
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// These are filled with ranges (rangeFrom[i] up to but not including
// rangeTo[i]) of code points that count as extending characters.
let $08c4544bca527ef0$var$rangeFrom = [], $08c4544bca527ef0$var$rangeTo = [];
(()=>{
    // Compressed representation of the Grapheme_Cluster_Break=Extend
    // information from
    // http://www.unicode.org/Public/16.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
    // Each pair of elements represents a range, as an offet from the
    // previous range and a length. Numbers are in base-36, with the empty
    // string being a shorthand for 1.
    let numbers = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
    for(let i = 0, n = 0; i < numbers.length; i++)(i % 2 ? $08c4544bca527ef0$var$rangeTo : $08c4544bca527ef0$var$rangeFrom).push(n = n + numbers[i]);
})();
function $08c4544bca527ef0$export$5ff7ae0b7231f50b(code) {
    if (code < 768) return false;
    for(let from = 0, to = $08c4544bca527ef0$var$rangeFrom.length;;){
        let mid = from + to >> 1;
        if (code < $08c4544bca527ef0$var$rangeFrom[mid]) to = mid;
        else if (code >= $08c4544bca527ef0$var$rangeTo[mid]) from = mid + 1;
        else return true;
        if (from == to) return false;
    }
}
function $08c4544bca527ef0$var$isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
function $08c4544bca527ef0$var$check(code) {
    for(let i = 0; i < $08c4544bca527ef0$var$rangeFrom.length; i++){
        if ($08c4544bca527ef0$var$rangeTo[i] > code) return $08c4544bca527ef0$var$rangeFrom[i] <= code;
    }
    return false;
}
const $08c4544bca527ef0$var$ZWJ = 0x200d;
function $08c4544bca527ef0$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (forward ? $08c4544bca527ef0$var$nextClusterBreak : $08c4544bca527ef0$var$prevClusterBreak)(str, pos, includeExtending);
}
function $08c4544bca527ef0$var$nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && $08c4544bca527ef0$var$surrogateLow(str.charCodeAt(pos)) && $08c4544bca527ef0$var$surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    let prev = $08c4544bca527ef0$var$codePointAt(str, pos);
    pos += $08c4544bca527ef0$var$codePointSize(prev);
    while(pos < str.length){
        let next = $08c4544bca527ef0$var$codePointAt(str, pos);
        if (prev == $08c4544bca527ef0$var$ZWJ || next == $08c4544bca527ef0$var$ZWJ || includeExtending && $08c4544bca527ef0$export$5ff7ae0b7231f50b(next)) {
            pos += $08c4544bca527ef0$var$codePointSize(next);
            prev = next;
        } else if ($08c4544bca527ef0$var$isRegionalIndicator(next)) {
            let countBefore = 0, i = pos - 2;
            while(i >= 0 && $08c4544bca527ef0$var$isRegionalIndicator($08c4544bca527ef0$var$codePointAt(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function $08c4544bca527ef0$var$prevClusterBreak(str, pos, includeExtending) {
    while(pos > 0){
        let found = $08c4544bca527ef0$var$nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function $08c4544bca527ef0$var$codePointAt(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$08c4544bca527ef0$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$08c4544bca527ef0$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
function $08c4544bca527ef0$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $08c4544bca527ef0$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
function $08c4544bca527ef0$var$codePointSize(code) {
    return code < 0x10000 ? 1 : 2;
}


/**
The data structure for documents. @nonabstract
*/ class $6295c6875f57e3ee$export$5f1af8db9871e1d6 {
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let parts = [];
        this.decompose(0, from, parts, 2 /* Open.To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* Open.To */ );
        this.decompose(to, this.length, parts, 1 /* Open.From */ );
        return $6295c6875f57e3ee$var$TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from, to = this.length) {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let parts = [];
        this.decompose(from, to, parts, 0);
        return $6295c6875f57e3ee$var$TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        let a = new $6295c6875f57e3ee$var$RawTextCursor(this), b = new $6295c6875f57e3ee$var$RawTextCursor(other);
        for(let skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter(dir = 1) {
        return new $6295c6875f57e3ee$var$RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from, to = this.length) {
        return new $6295c6875f57e3ee$var$PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        let inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            let start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new $6295c6875f57e3ee$var$LineCursor(inner);
    }
    /**
    Return the document as a string, using newline characters to
    separate lines.
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        let lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    @internal
    */ constructor(){}
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty;
        return text.length <= 32 /* Tree.Branch */  ? new $6295c6875f57e3ee$var$TextLeaf(text) : $6295c6875f57e3ee$var$TextNode.from($6295c6875f57e3ee$var$TextLeaf.split(text, []));
    }
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class $6295c6875f57e3ee$var$TextLeaf extends $6295c6875f57e3ee$export$5f1af8db9871e1d6 {
    constructor(text, length = $6295c6875f57e3ee$var$textLength(text)){
        super();
        this.text = text;
        this.length = length;
    }
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new $6295c6875f57e3ee$export$17d680238e50603e(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        let text = from <= 0 && to >= this.length ? this : new $6295c6875f57e3ee$var$TextLeaf($6295c6875f57e3ee$var$sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* Open.From */ ) {
            let prev = target.pop();
            let joined = $6295c6875f57e3ee$var$appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Tree.Branch */ ) target.push(new $6295c6875f57e3ee$var$TextLeaf(joined, prev.length + text.length));
            else {
                let mid = joined.length >> 1;
                target.push(new $6295c6875f57e3ee$var$TextLeaf(joined.slice(0, mid)), new $6295c6875f57e3ee$var$TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof $6295c6875f57e3ee$var$TextLeaf)) return super.replace(from, to, text);
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let lines = $6295c6875f57e3ee$var$appendText(this.text, $6295c6875f57e3ee$var$appendText(text.text, $6295c6875f57e3ee$var$sliceText(this.text, 0, from)), to);
        let newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Tree.Branch */ ) return new $6295c6875f57e3ee$var$TextLeaf(lines, newLen);
        return $6295c6875f57e3ee$var$TextNode.from($6295c6875f57e3ee$var$TextLeaf.split(lines, []), newLen);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let result = "";
        for(let pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            let line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let line of this.text)target.push(line);
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        let part = [], len = -1;
        for (let line of text){
            part.push(line);
            len += line.length + 1;
            if (part.length == 32 /* Tree.Branch */ ) {
                target.push(new $6295c6875f57e3ee$var$TextLeaf(part, len));
                part = [];
                len = -1;
            }
        }
        if (len > -1) target.push(new $6295c6875f57e3ee$var$TextLeaf(part, len));
        return target;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class $6295c6875f57e3ee$var$TextNode extends $6295c6875f57e3ee$export$5f1af8db9871e1d6 {
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        for (let child of children)this.lines += child.lines;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(let i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                let childOpen = open & ((pos <= from ? 1 /* Open.From */  : 0) | (end >= to ? 2 /* Open.To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        if (text.lines < this.lines) for(let i = 0, pos = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                let updated = child.replace(from - pos, to - pos, text);
                let totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    let copy = this.children.slice();
                    copy[i] = updated;
                    return new $6295c6875f57e3ee$var$TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let result = "";
        for(let i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let child of this.children)child.flatten(target);
    }
    scanIdentical(other, dir) {
        if (!(other instanceof $6295c6875f57e3ee$var$TextNode)) return 0;
        let length = 0;
        let [iA, iB, eA, eB] = dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            let chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children, length = children.reduce((l, ch)=>l + ch.length + 1, -1)) {
        let lines = 0;
        for (let ch of children)lines += ch.lines;
        if (lines < 32 /* Tree.Branch */ ) {
            let flat = [];
            for (let ch of children)ch.flatten(flat);
            return new $6295c6875f57e3ee$var$TextLeaf(flat, length);
        }
        let chunk = Math.max(32 /* Tree.Branch */ , lines >> 5 /* Tree.BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            let last;
            if (child.lines > maxChunk && child instanceof $6295c6875f57e3ee$var$TextNode) for (let node of child.children)add(node);
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof $6295c6875f57e3ee$var$TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof $6295c6875f57e3ee$var$TextLeaf && child.lines + last.lines <= 32 /* Tree.Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new $6295c6875f57e3ee$var$TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : $6295c6875f57e3ee$var$TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        for (let child of children)add(child);
        flush();
        return chunked.length == 1 ? chunked[0] : new $6295c6875f57e3ee$var$TextNode(chunked, length);
    }
}
$6295c6875f57e3ee$export$5f1af8db9871e1d6.empty = /*@__PURE__*/ new $6295c6875f57e3ee$var$TextLeaf([
    ""
], 0);
function $6295c6875f57e3ee$var$textLength(text) {
    let length = -1;
    for (let line of text)length += line.length + 1;
    return length;
}
function $6295c6875f57e3ee$var$appendText(text, target, from = 0, to = 1e9) {
    for(let pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        let line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function $6295c6875f57e3ee$var$sliceText(text, from, to) {
    return $6295c6875f57e3ee$var$appendText(text, [
        ""
    ], from, to);
}
class $6295c6875f57e3ee$var$RawTextCursor {
    constructor(text, dir = 1){
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof $6295c6875f57e3ee$var$TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            let last = this.nodes.length - 1;
            let top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            let size = top instanceof $6295c6875f57e3ee$var$TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof $6295c6875f57e3ee$var$TextLeaf) {
                // Move to the next string
                let next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                let next = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next.length) {
                    skip -= next.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next);
                    this.offsets.push(dir > 0 ? 1 : (next instanceof $6295c6875f57e3ee$var$TextLeaf ? next.text.length : next.children.length) << 1);
                }
            }
        }
    }
    next(skip = 0) {
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
}
class $6295c6875f57e3ee$var$PartialTextCursor {
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new $6295c6875f57e3ee$var$RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        let { value: value } = this.cursor.next(skip);
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next(skip = 0) {
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
}
class $6295c6875f57e3ee$var$LineCursor {
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
    next(skip = 0) {
        let { done: done, lineBreak: lineBreak, value: value } = this.inner.next(skip);
        if (done && this.afterBreak) {
            this.value = "";
            this.afterBreak = false;
        } else if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
}
if (typeof Symbol != "undefined") {
    $6295c6875f57e3ee$export$5f1af8db9871e1d6.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    $6295c6875f57e3ee$var$RawTextCursor.prototype[Symbol.iterator] = $6295c6875f57e3ee$var$PartialTextCursor.prototype[Symbol.iterator] = $6295c6875f57e3ee$var$LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class $6295c6875f57e3ee$export$17d680238e50603e {
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
}
function $6295c6875f57e3ee$var$clip(text, from, to) {
    from = Math.max(0, Math.min(text.length, from));
    return [
        from,
        Math.max(from, Math.min(text.length, to))
    ];
}
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function $6295c6875f57e3ee$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (0, $08c4544bca527ef0$export$a0fa439fd515e1ed)(str, pos, forward, includeExtending);
}
function $6295c6875f57e3ee$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $6295c6875f57e3ee$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function $6295c6875f57e3ee$export$42977f40461e1360(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$6295c6875f57e3ee$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$6295c6875f57e3ee$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function $6295c6875f57e3ee$export$73bfc63873071f74(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The amount of positions a character takes up in a JavaScript string.
*/ function $6295c6875f57e3ee$export$a870abf234f6353c(code) {
    return code < 0x10000 ? 1 : 2;
}
const $6295c6875f57e3ee$var$DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var $6295c6875f57e3ee$export$39cf3280165f92aa = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}($6295c6875f57e3ee$export$39cf3280165f92aa || ($6295c6875f57e3ee$export$39cf3280165f92aa = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class $6295c6875f57e3ee$export$34b6a936f2bb06a2 {
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    /**
    @internal
    */ constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
    /**
    The length of the document before the change.
    */ get length() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2){
            let ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(let i = 0, posA = 0, posB = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f, individual = false) {
        $6295c6875f57e3ee$var$iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        let sections = [];
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new $6295c6875f57e3ee$export$34b6a936f2bb06a2(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : $6295c6875f57e3ee$var$composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `this` happened before the ones in `other`.
    */ mapDesc(other, before = false) {
        return other.empty ? this : $6295c6875f57e3ee$var$mapSet(this, other, before);
    }
    mapPos(pos, assoc = -1, mode = $6295c6875f57e3ee$export$39cf3280165f92aa.Simple) {
        let posA = 0, posB = 0;
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != $6295c6875f57e3ee$export$39cf3280165f92aa.Simple && endA >= pos && (mode == $6295c6875f57e3ee$export$39cf3280165f92aa.TrackDel && posA < pos && endA > pos || mode == $6295c6875f57e3ee$export$39cf3280165f92aa.TrackBefore && posA < pos || mode == $6295c6875f57e3ee$export$39cf3280165f92aa.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from, to = from) {
        for(let i = 0, pos = 0; i < this.sections.length && pos <= to;){
            let len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        let result = "";
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new $6295c6875f57e3ee$export$34b6a936f2bb06a2(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new $6295c6875f57e3ee$export$34b6a936f2bb06a2(sections);
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class $6295c6875f57e3ee$export$29d7fbdcb1f8b71c extends $6295c6875f57e3ee$export$34b6a936f2bb06a2 {
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        $6295c6875f57e3ee$var$iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other, before = false) {
        return $6295c6875f57e3ee$var$mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        let sections = this.sections.slice(), inserted = [];
        for(let i = 0, pos = 0; i < sections.length; i += 2){
            let len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                let index = i >> 1;
                while(inserted.length < index)inserted.push($6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
            }
            pos += len;
        }
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : $6295c6875f57e3ee$var$composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other, before = false) {
        return other.empty ? this : $6295c6875f57e3ee$var$mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f, individual = false) {
        $6295c6875f57e3ee$var$iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        let resultSections = [], resultInserted = [], filteredSections = [];
        let iter = new $6295c6875f57e3ee$var$SectionIter(this);
        done: for(let i = 0, pos = 0;;){
            let next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                let len = Math.min(iter.len, next - pos);
                $6295c6875f57e3ee$var$addSection(filteredSections, len, -1);
                let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                $6295c6875f57e3ee$var$addSection(resultSections, len, ins);
                if (ins > 0) $6295c6875f57e3ee$var$addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            let end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                let len = Math.min(iter.len, end - pos);
                $6295c6875f57e3ee$var$addSection(resultSections, len, -1);
                $6295c6875f57e3ee$var$addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len);
                pos += len;
            }
        }
        return {
            changes: new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(resultSections, resultInserted),
            filtered: $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        let parts = [];
        for(let i = 0; i < this.sections.length; i += 2){
            let len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        let sections = [], inserted = [], pos = 0;
        let total = null;
        function flush(force = false) {
            if (!force && !sections.length) return;
            if (pos < length) $6295c6875f57e3ee$var$addSection(sections, length - pos, -1);
            let set = new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            if (Array.isArray(spec)) for (let sub of spec)process(sub);
            else if (spec instanceof $6295c6875f57e3ee$export$29d7fbdcb1f8b71c) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                let { from: from, to: to = from, insert: insert } = spec;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                let insText = !insert ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty : typeof insert == "string" ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.of(insert.split(lineSep || $6295c6875f57e3ee$var$DefaultSplit)) : insert;
                let insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) $6295c6875f57e3ee$var$addSection(sections, from - pos, -1);
                $6295c6875f57e3ee$var$addSection(sections, to - from, insLen);
                $6295c6875f57e3ee$var$addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        let sections = [], inserted = [];
        for(let i = 0; i < json.length; i++){
            let part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push($6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
                inserted[i] = $6295c6875f57e3ee$export$5f1af8db9871e1d6.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        }
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
    }
}
function $6295c6875f57e3ee$var$addSection(sections, len, ins, forceJoin = false) {
    if (len == 0 && ins <= 0) return;
    let last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (last >= 0 && len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function $6295c6875f57e3ee$var$addInsert(values, sections, value) {
    if (value.length == 0) return;
    let index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push($6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
        values.push(value);
    }
}
function $6295c6875f57e3ee$var$iterChanges(desc, f, individual) {
    let inserted = desc.inserted;
    for(let posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        let len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            let endA = posA, endB = posB, text = $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function $6295c6875f57e3ee$var$mapSet(setA, setB, before, mkSet = false) {
    // Produce a copy of setA that applies to the document after setB
    // has been applied (assuming both start at the same document).
    let sections = [], insert = mkSet ? [] : null;
    let a = new $6295c6875f57e3ee$var$SectionIter(setA), b = new $6295c6875f57e3ee$var$SectionIter(setB);
    // Iterate over both sets in parallel. inserted tracks, for changes
    // in A that have to be processed piece-by-piece, whether their
    // content has been inserted already, and refers to the section
    // index.
    for(let inserted = -1;;){
        if (a.done && b.len || b.done && a.len) throw new Error("Mismatched change set lengths");
        else if (a.ins == -1 && b.ins == -1) {
            // Move across ranges skipped by both sets.
            let len = Math.min(a.len, b.len);
            $6295c6875f57e3ee$var$addSection(sections, len, -1);
            a.forward(len);
            b.forward(len);
        } else if (b.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b.len < a.len || b.len == a.len && !before))) {
            // If there's a change in B that comes before the next change in
            // A (ordered by start pos, then len, then before flag), skip
            // that (and process any changes in A it covers).
            let len = b.len;
            $6295c6875f57e3ee$var$addSection(sections, b.ins, -1);
            while(len){
                let piece = Math.min(a.len, len);
                if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
                    $6295c6875f57e3ee$var$addSection(sections, 0, a.ins);
                    if (insert) $6295c6875f57e3ee$var$addInsert(insert, sections, a.text);
                    inserted = a.i;
                }
                a.forward(piece);
                len -= piece;
            }
            b.next();
        } else if (a.ins >= 0) {
            // Process the part of a change in A up to the start of the next
            // non-deletion change in B (if overlapping).
            let len = 0, left = a.len;
            while(left){
                if (b.ins == -1) {
                    let piece = Math.min(left, b.len);
                    len += piece;
                    left -= piece;
                    b.forward(piece);
                } else if (b.ins == 0 && b.len < left) {
                    left -= b.len;
                    b.next();
                } else break;
            }
            $6295c6875f57e3ee$var$addSection(sections, len, inserted < a.i ? a.ins : 0);
            if (insert && inserted < a.i) $6295c6875f57e3ee$var$addInsert(insert, sections, a.text);
            inserted = a.i;
            a.forward(a.len - left);
        } else if (a.done && b.done) return insert ? $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function $6295c6875f57e3ee$var$composeSets(setA, setB, mkSet = false) {
    let sections = [];
    let insert = mkSet ? [] : null;
    let a = new $6295c6875f57e3ee$var$SectionIter(setA), b = new $6295c6875f57e3ee$var$SectionIter(setB);
    for(let open = false;;){
        if (a.done && b.done) return insert ? $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(sections);
        else if (a.ins == 0) {
            $6295c6875f57e3ee$var$addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            $6295c6875f57e3ee$var$addSection(sections, 0, b.ins, open);
            if (insert) $6295c6875f57e3ee$var$addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            let len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                let insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                $6295c6875f57e3ee$var$addSection(sections, len, insB, open);
                if (insert && insB) $6295c6875f57e3ee$var$addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                $6295c6875f57e3ee$var$addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) $6295c6875f57e3ee$var$addInsert(insert, sections, a.textBit(len));
            } else {
                $6295c6875f57e3ee$var$addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) $6295c6875f57e3ee$var$addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class $6295c6875f57e3ee$var$SectionIter {
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
    next() {
        let { sections: sections } = this.set;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty : inserted[index];
    }
    textBit(len) {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class $6295c6875f57e3ee$export$7bd1839c3c5d5bd4 {
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags){
        this.from = from;
        this.to = to;
        this.flags = flags;
    }
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 8 /* RangeFlag.AssocBefore */  ? -1 : this.flags & 16 /* RangeFlag.AssocAfter */  ? 1 : 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        let level = this.flags & 7 /* RangeFlag.BidiLevelMask */ ;
        return level == 7 ? null : level;
    }
    /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ get goalColumn() {
        let value = this.flags >> 6 /* RangeFlag.GoalColumnOffset */ ;
        return value == 16777215 /* RangeFlag.NoGoalColumn */  ? undefined : value;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change, assoc = -1) {
        let from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new $6295c6875f57e3ee$export$7bd1839c3c5d5bd4(from, to, this.flags);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from, to = from) {
        if (from <= this.anchor && to >= this.anchor) return $6295c6875f57e3ee$export$3bb1bd44aee62999.range(from, to);
        let head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.range(this.anchor, head);
    }
    /**
    Compare this range to another range.
    */ eq(other, includeAssoc = false) {
        return this.anchor == other.anchor && this.head == other.head && (!includeAssoc || !this.empty || this.assoc == other.assoc);
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags) {
        return new $6295c6875f57e3ee$export$7bd1839c3c5d5bd4(from, to, flags);
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class $6295c6875f57e3ee$export$3bb1bd44aee62999 {
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change, assoc = -1) {
        if (change.empty) return this;
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection. By default, ranges
    are compared only by position. When `includeAssoc` is true,
    cursor ranges must also have the same
    [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
    */ eq(other, includeAssoc = false) {
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(let i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i], includeAssoc)) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new $6295c6875f57e3ee$export$3bb1bd44aee62999([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range, main = true) {
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range, which = this.mainIndex) {
        let ranges = this.ranges.slice();
        ranges[which] = range;
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999(json.ranges.map((r)=>$6295c6875f57e3ee$export$7bd1839c3c5d5bd4.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor, head = anchor) {
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999([
            $6295c6875f57e3ee$export$3bb1bd44aee62999.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges, mainIndex = 0) {
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(let pos = 0, i = 0; i < ranges.length; i++){
            let range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return $6295c6875f57e3ee$export$3bb1bd44aee62999.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
        return $6295c6875f57e3ee$export$7bd1839c3c5d5bd4.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 8 /* RangeFlag.AssocBefore */  : 16 /* RangeFlag.AssocAfter */ ) | (bidiLevel == null ? 7 : Math.min(6, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */ );
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn, bidiLevel) {
        let flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */  | (bidiLevel == null ? 7 : Math.min(6, bidiLevel));
        return head < anchor ? $6295c6875f57e3ee$export$7bd1839c3c5d5bd4.create(head, anchor, 48 /* RangeFlag.AssocAfter */  | flags) : $6295c6875f57e3ee$export$7bd1839c3c5d5bd4.create(anchor, head, (head > anchor ? 8 /* RangeFlag.AssocBefore */  : 0) | flags);
    }
    /**
    @internal
    */ static normalized(ranges, mainIndex = 0) {
        let main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(let i = 1; i < ranges.length; i++){
            let range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                let from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? $6295c6875f57e3ee$export$3bb1bd44aee62999.range(to, from) : $6295c6875f57e3ee$export$3bb1bd44aee62999.range(from, to));
            }
        }
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999(ranges, mainIndex);
    }
}
function $6295c6875f57e3ee$var$checkSelection(selection, docLength) {
    for (let range of selection.ranges)if (range.to > docLength) throw new RangeError("Selection points outside of document");
}
let $6295c6875f57e3ee$var$nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).

Note that `Facet` instances can be used anywhere where
[`FacetReader`](https://codemirror.net/6/docs/ref/#state.FacetReader) is expected.
*/ class $6295c6875f57e3ee$export$ef7d5e9b79fa1504 {
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, enables){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        /**
        @internal
        */ this.id = $6295c6875f57e3ee$var$nextID++;
        this.default = combine([]);
        this.extensions = typeof enables == "function" ? enables(this) : enables;
    }
    /**
    Returns a facet reader for this facet, which can be used to
    [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
    */ get reader() {
        return this;
    }
    /**
    Define a new facet.
    */ static define(config = {}) {
        return new $6295c6875f57e3ee$export$ef7d5e9b79fa1504(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? $6295c6875f57e3ee$var$sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new $6295c6875f57e3ee$var$FacetProvider([], this, 0 /* Provider.Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $6295c6875f57e3ee$var$FacetProvider(deps, this, 1 /* Provider.Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $6295c6875f57e3ee$var$FacetProvider(deps, this, 2 /* Provider.Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
}
function $6295c6875f57e3ee$var$sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class $6295c6875f57e3ee$var$FacetProvider {
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = $6295c6875f57e3ee$var$nextID++;
    }
    dynamicSlot(addresses) {
        var _a;
        let getter = this.value;
        let compare = this.facet.compareInput;
        let id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Provider.Multi */ ;
        let depDoc = false, depSel = false, depAddrs = [];
        for (let dep of this.dependencies){
            if (dep == "doc") depDoc = true;
            else if (dep == "selection") depSel = true;
            else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || $6295c6875f57e3ee$var$ensureAll(state, depAddrs)) {
                    let newVal = getter(state);
                    if (multi ? !$6295c6875f57e3ee$var$compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* SlotStatus.Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                let newVal, oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    let oldVal = $6295c6875f57e3ee$var$getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof $6295c6875f57e3ee$export$ef7d5e9b79fa1504 ? oldState.facet(dep) === state.facet(dep) : dep instanceof $6295c6875f57e3ee$export$34381b1ce2130245 ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? $6295c6875f57e3ee$var$compareArray(newVal = getter(state), oldVal, compare) : compare(newVal = getter(state), oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                } else newVal = getter(state);
                state.values[idx] = newVal;
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
}
function $6295c6875f57e3ee$var$compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function $6295c6875f57e3ee$var$ensureAll(state, addrs) {
    let changed = false;
    for (let addr of addrs)if ($6295c6875f57e3ee$var$ensureAddr(state, addr) & 1 /* SlotStatus.Changed */ ) changed = true;
    return changed;
}
function $6295c6875f57e3ee$var$dynamicFacetSlot(addresses, facet, providers) {
    let providerAddrs = providers.map((p)=>addresses[p.id]);
    let providerTypes = providers.map((p)=>p.type);
    let dynamic = providerAddrs.filter((p)=>!(p & 1));
    let idx = addresses[facet.id] >> 1;
    function get(state) {
        let values = [];
        for(let i = 0; i < providerAddrs.length; i++){
            let value = $6295c6875f57e3ee$var$getAddr(state, providerAddrs[i]);
            if (providerTypes[i] == 2 /* Provider.Multi */ ) for (let val of value)values.push(val);
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            for (let addr of providerAddrs)$6295c6875f57e3ee$var$ensureAddr(state, addr);
            state.values[idx] = get(state);
            return 1 /* SlotStatus.Changed */ ;
        },
        update (state, tr) {
            if (!$6295c6875f57e3ee$var$ensureAll(state, dynamic)) return 0;
            let value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        },
        reconfigure (state, oldState) {
            let depChanged = $6295c6875f57e3ee$var$ensureAll(state, providerAddrs);
            let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && $6295c6875f57e3ee$var$sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            let value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        }
    };
}
const $6295c6875f57e3ee$var$initField = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class $6295c6875f57e3ee$export$34381b1ce2130245 {
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
    /**
    Define a state field.
    */ static define(config) {
        let field = new $6295c6875f57e3ee$export$34381b1ce2130245($6295c6875f57e3ee$var$nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        let init = state.facet($6295c6875f57e3ee$var$initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        let idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update: (state, tr)=>{
                let oldVal = state.values[idx];
                let value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* SlotStatus.Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                let init = state.facet($6295c6875f57e3ee$var$initField), oldInit = oldState.facet($6295c6875f57e3ee$var$initField), reInit;
                if ((reInit = init.find((i)=>i.field == this)) && reInit != oldInit.find((i)=>i.field == this)) {
                    state.values[idx] = reInit.create(state);
                    return 1 /* SlotStatus.Changed */ ;
                }
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            $6295c6875f57e3ee$var$initField.of({
                field: this,
                create: create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
}
const $6295c6875f57e3ee$var$Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function $6295c6875f57e3ee$var$prec(value) {
    return (ext)=>new $6295c6875f57e3ee$var$PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ const $6295c6875f57e3ee$export$b92464a736444411 = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.lowest)
};
class $6295c6875f57e3ee$var$PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class $6295c6875f57e3ee$export$d51c0172eb2c2431 {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new $6295c6875f57e3ee$var$CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return $6295c6875f57e3ee$export$d51c0172eb2c2431.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class $6295c6875f57e3ee$var$CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
}
class $6295c6875f57e3ee$var$Configuration {
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* SlotStatus.Unresolved */ );
    }
    staticFacet(facet) {
        let addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        let fields = [];
        let facets = Object.create(null);
        let newCompartments = new Map();
        for (let ext of $6295c6875f57e3ee$var$flatten(base, compartments, newCompartments))if (ext instanceof $6295c6875f57e3ee$export$34381b1ce2130245) fields.push(ext);
        else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
        let address = Object.create(null);
        let staticValues = [];
        let dynamicSlots = [];
        for (let field of fields){
            address[field.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a)=>field.slot(a));
        }
        let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(let id in facets){
            let providers = facets[id], facet = providers[0].facet;
            let oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Provider.Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if ($6295c6875f57e3ee$var$sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    let value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                for (let p of providers)if (p.type == 0 /* Provider.Static */ ) {
                    address[p.id] = staticValues.length << 1 | 1;
                    staticValues.push(p.value);
                } else {
                    address[p.id] = dynamicSlots.length << 1;
                    dynamicSlots.push((a)=>p.dynamicSlot(a));
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>$6295c6875f57e3ee$var$dynamicFacetSlot(a, facet, providers));
            }
        }
        let dynamic = dynamicSlots.map((f)=>f(address));
        return new $6295c6875f57e3ee$var$Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
}
function $6295c6875f57e3ee$var$flatten(extension, compartments, newCompartments) {
    let result = [
        [],
        [],
        [],
        [],
        []
    ];
    let seen = new Map();
    function inner(ext, prec) {
        let known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            let found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof $6295c6875f57e3ee$var$CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        if (Array.isArray(ext)) for (let e of ext)inner(e, prec);
        else if (ext instanceof $6295c6875f57e3ee$var$CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            let content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof $6295c6875f57e3ee$var$PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof $6295c6875f57e3ee$export$34381b1ce2130245) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof $6295c6875f57e3ee$var$FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, $6295c6875f57e3ee$var$Prec_.default);
        } else {
            let content = ext.extension;
            if (!content) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content, prec);
        }
    }
    inner(extension, $6295c6875f57e3ee$var$Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function $6295c6875f57e3ee$var$ensureAddr(state, addr) {
    if (addr & 1) return 2 /* SlotStatus.Computed */ ;
    let idx = addr >> 1;
    let status = state.status[idx];
    if (status == 4 /* SlotStatus.Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* SlotStatus.Computed */ ) return status;
    state.status[idx] = 4 /* SlotStatus.Computing */ ;
    let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* SlotStatus.Computed */  | changed;
}
function $6295c6875f57e3ee$var$getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const $6295c6875f57e3ee$var$languageData = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$allowMultipleSelections = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
const $6295c6875f57e3ee$var$lineSeparator = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
const $6295c6875f57e3ee$var$changeFilter = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$transactionFilter = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$transactionExtender = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$readOnly = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class $6295c6875f57e3ee$export$9279461326b8700a {
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Define a new type of annotation.
    */ static define() {
        return new $6295c6875f57e3ee$export$f50c3066a53a6f2c();
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class $6295c6875f57e3ee$export$f50c3066a53a6f2c {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new $6295c6875f57e3ee$export$9279461326b8700a(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class $6295c6875f57e3ee$export$e41ff6bd17cc4417 {
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new $6295c6875f57e3ee$export$95000d4efaa4321f(this, value);
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class $6295c6875f57e3ee$export$95000d4efaa4321f {
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        let mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new $6295c6875f57e3ee$export$95000d4efaa4321f(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds. It should be a type that
    doesn't include `undefined`, since that is used in
    [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
    removed.
    */ static define(spec = {}) {
        return new $6295c6875f57e3ee$export$e41ff6bd17cc4417(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        let result = [];
        for (let effect of effects){
            let mapped = effect.map(mapping);
            if (mapped) result.push(mapped);
        }
        return result;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ $6295c6875f57e3ee$export$95000d4efaa4321f.reconfigure = /*@__PURE__*/ $6295c6875f57e3ee$export$95000d4efaa4321f.define();
/**
Append extensions to the top-level configuration of the editor.
*/ $6295c6875f57e3ee$export$95000d4efaa4321f.appendConfig = /*@__PURE__*/ $6295c6875f57e3ee$export$95000d4efaa4321f.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class $6295c6875f57e3ee$export$febc5573c75cefb0 {
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) $6295c6875f57e3ee$var$checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == $6295c6875f57e3ee$export$febc5573c75cefb0.time)) this.annotations = annotations.concat($6295c6875f57e3ee$export$febc5573c75cefb0.time.of(Date.now()));
    }
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new $6295c6875f57e3ee$export$febc5573c75cefb0(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        for (let ann of this.annotations)if (ann.type == type) return ann.value;
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        let e = this.annotation($6295c6875f57e3ee$export$febc5573c75cefb0.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.time = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.userEvent = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.addToHistory = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.remote = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
function $6295c6875f57e3ee$var$joinRanges(a, b) {
    let result = [];
    for(let iA = 0, iB = 0;;){
        let from, to;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function $6295c6875f57e3ee$var$mergeTransaction(a, b, sequential) {
    var _a;
    let mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes: changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: $6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(a.effects, mapForA).concat($6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function $6295c6875f57e3ee$var$resolveTransactionInner(state, spec, docSize) {
    let sel = spec.selection, annotations = $6295c6875f57e3ee$var$asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat($6295c6875f57e3ee$export$febc5573c75cefb0.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof $6295c6875f57e3ee$export$29d7fbdcb1f8b71c ? spec.changes : $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.of(spec.changes || [], docSize, state.facet($6295c6875f57e3ee$var$lineSeparator)),
        selection: sel && (sel instanceof $6295c6875f57e3ee$export$3bb1bd44aee62999 ? sel : $6295c6875f57e3ee$export$3bb1bd44aee62999.single(sel.anchor, sel.head)),
        effects: $6295c6875f57e3ee$var$asArray(spec.effects),
        annotations: annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function $6295c6875f57e3ee$var$resolveTransaction(state, specs, filter) {
    let s = $6295c6875f57e3ee$var$resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(let i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        let seq = !!specs[i].sequential;
        s = $6295c6875f57e3ee$var$mergeTransaction(s, $6295c6875f57e3ee$var$resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    let tr = $6295c6875f57e3ee$export$febc5573c75cefb0.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return $6295c6875f57e3ee$var$extendTransaction(filter ? $6295c6875f57e3ee$var$filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function $6295c6875f57e3ee$var$filterTransaction(tr) {
    let state = tr.startState;
    // Change filters
    let result = true;
    for (let filter of state.facet($6295c6875f57e3ee$var$changeFilter)){
        let value = filter(tr);
        if (value === false) {
            result = false;
            break;
        }
        if (Array.isArray(value)) result = result === true ? value : $6295c6875f57e3ee$var$joinRanges(result, value);
    }
    if (result !== true) {
        let changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.empty(state.doc.length);
        } else {
            let filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
        }
        tr = $6295c6875f57e3ee$export$febc5573c75cefb0.create(state, changes, tr.selection && tr.selection.map(back), $6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    let filters = state.facet($6295c6875f57e3ee$var$transactionFilter);
    for(let i = filters.length - 1; i >= 0; i--){
        let filtered = filters[i](tr);
        if (filtered instanceof $6295c6875f57e3ee$export$febc5573c75cefb0) tr = filtered;
        else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof $6295c6875f57e3ee$export$febc5573c75cefb0) tr = filtered[0];
        else tr = $6295c6875f57e3ee$var$resolveTransaction(state, $6295c6875f57e3ee$var$asArray(filtered), false);
    }
    return tr;
}
function $6295c6875f57e3ee$var$extendTransaction(tr) {
    let state = tr.startState, extenders = state.facet($6295c6875f57e3ee$var$transactionExtender), spec = tr;
    for(let i = extenders.length - 1; i >= 0; i--){
        let extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = $6295c6875f57e3ee$var$mergeTransaction(spec, $6295c6875f57e3ee$var$resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : $6295c6875f57e3ee$export$febc5573c75cefb0.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const $6295c6875f57e3ee$var$none = [];
function $6295c6875f57e3ee$var$asArray(value) {
    return value == null ? $6295c6875f57e3ee$var$none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var $6295c6875f57e3ee$export$239a3d59567c1401 = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}($6295c6875f57e3ee$export$239a3d59567c1401 || ($6295c6875f57e3ee$export$239a3d59567c1401 = {}));
const $6295c6875f57e3ee$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let $6295c6875f57e3ee$var$wordChar;
try {
    $6295c6875f57e3ee$var$wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function $6295c6875f57e3ee$var$hasWordChar(str) {
    if ($6295c6875f57e3ee$var$wordChar) return $6295c6875f57e3ee$var$wordChar.test(str);
    for(let i = 0; i < str.length; i++){
        let ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || $6295c6875f57e3ee$var$nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function $6295c6875f57e3ee$var$makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return $6295c6875f57e3ee$export$239a3d59567c1401.Space;
        if ($6295c6875f57e3ee$var$hasWordChar(char)) return $6295c6875f57e3ee$export$239a3d59567c1401.Word;
        for(let i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return $6295c6875f57e3ee$export$239a3d59567c1401.Word;
        return $6295c6875f57e3ee$export$239a3d59567c1401.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class $6295c6875f57e3ee$export$afa855cbfaff27f2 {
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(let i = 0; i < this.config.dynamicSlots.length; i++)$6295c6875f57e3ee$var$ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
    field(field, require = true) {
        let addr = this.config.address[field.id];
        if (addr == null) {
            if (require) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        $6295c6875f57e3ee$var$ensureAddr(this, addr);
        return $6295c6875f57e3ee$var$getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update(...specs) {
        return $6295c6875f57e3ee$var$resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        let conf = this.config, { base: base, compartments: compartments } = conf;
        for (let effect of tr.effects){
            if (effect.is($6295c6875f57e3ee$export$d51c0172eb2c2431.reconfigure)) {
                if (conf) {
                    compartments = new Map;
                    conf.compartments.forEach((val, key)=>compartments.set(key, val));
                    conf = null;
                }
                compartments.set(effect.value.compartment, effect.value.extension);
            } else if (effect.is($6295c6875f57e3ee$export$95000d4efaa4321f.reconfigure)) {
                conf = null;
                base = effect.value;
            } else if (effect.is($6295c6875f57e3ee$export$95000d4efaa4321f.appendConfig)) {
                conf = null;
                base = $6295c6875f57e3ee$var$asArray(base).concat(effect.value);
            }
        }
        let startValues;
        if (!conf) {
            conf = $6295c6875f57e3ee$var$Configuration.resolve(base, compartments, this);
            let intermediateState = new $6295c6875f57e3ee$export$afa855cbfaff27f2(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        let selection = tr.startState.facet($6295c6875f57e3ee$var$allowMultipleSelections) ? tr.newSelection : tr.newSelection.asSingle();
        new $6295c6875f57e3ee$export$afa855cbfaff27f2(conf, tr.newDoc, selection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: $6295c6875f57e3ee$export$3bb1bd44aee62999.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        let sel = this.selection;
        let result1 = f(sel.ranges[0]);
        let changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        let effects = $6295c6875f57e3ee$var$asArray(result1.effects);
        for(let i = 1; i < sel.ranges.length; i++){
            let result = f(sel.ranges[i]);
            let newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(let j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            let mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = $6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(effects, newMapped).concat($6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects($6295c6875f57e3ee$var$asArray(result.effects), mapBy));
        }
        return {
            changes: changes,
            selection: $6295c6875f57e3ee$export$3bb1bd44aee62999.create(ranges, sel.mainIndex),
            effects: effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes(spec = []) {
        if (spec instanceof $6295c6875f57e3ee$export$29d7fbdcb1f8b71c) return spec;
        return $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.of(spec, this.doc.length, this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return $6295c6875f57e3ee$export$5f1af8db9871e1d6.of(string.split(this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator) || $6295c6875f57e3ee$var$DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc(from = 0, to = this.doc.length) {
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        let addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        $6295c6875f57e3ee$var$ensureAddr(this, addr);
        return $6295c6875f57e3ee$var$getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        let result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(let prop in fields){
            let value = fields[prop];
            if (value instanceof $6295c6875f57e3ee$export$34381b1ce2130245 && this.config.address[value.id] != null) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json, config = {}, fields) {
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        let fieldInit = [];
        if (fields) {
            for(let prop in fields)if (Object.prototype.hasOwnProperty.call(json, prop)) {
                let field = fields[prop], value = json[prop];
                fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
            }
        }
        return $6295c6875f57e3ee$export$afa855cbfaff27f2.create({
            doc: json.doc,
            selection: $6295c6875f57e3ee$export$3bb1bd44aee62999.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create(config = {}) {
        let configuration = $6295c6875f57e3ee$var$Configuration.resolve(config.extensions || [], new Map);
        let doc = config.doc instanceof $6295c6875f57e3ee$export$5f1af8db9871e1d6 ? config.doc : $6295c6875f57e3ee$export$5f1af8db9871e1d6.of((config.doc || "").split(configuration.staticFacet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator) || $6295c6875f57e3ee$var$DefaultSplit));
        let selection = !config.selection ? $6295c6875f57e3ee$export$3bb1bd44aee62999.single(0) : config.selection instanceof $6295c6875f57e3ee$export$3bb1bd44aee62999 ? config.selection : $6295c6875f57e3ee$export$3bb1bd44aee62999.single(config.selection.anchor, config.selection.head);
        $6295c6875f57e3ee$var$checkSelection(selection, doc.length);
        if (!configuration.staticFacet($6295c6875f57e3ee$var$allowMultipleSelections)) selection = selection.asSingle();
        return new $6295c6875f57e3ee$export$afa855cbfaff27f2(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet($6295c6875f57e3ee$var$readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase, ...insert) {
        for (let map of this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.phrases))if (Object.prototype.hasOwnProperty.call(map, phrase)) {
            phrase = map[phrase];
            break;
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            let n = +(i || 1);
            return !n || n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    
    Examples of language data fields are...
    
    - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
      comment syntax.
    - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
      for providing language-specific completion sources.
    - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
      characters that should be considered part of words in this
      language.
    - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
      bracket closing behavior.
    */ languageDataAt(name, pos, side = -1) {
        let values = [];
        for (let provider of this.facet($6295c6875f57e3ee$var$languageData)){
            for (let result of provider(this, pos, side))if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        return $6295c6875f57e3ee$var$makeCategorizer(this.languageDataAt("wordChars", at).join(""));
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        let { text: text, from: from, length: length } = this.doc.lineAt(pos);
        let cat = this.charCategorizer(pos);
        let start = pos - from, end = pos - from;
        while(start > 0){
            let prev = $6295c6875f57e3ee$export$a0fa439fd515e1ed(text, start, false);
            if (cat(text.slice(prev, start)) != $6295c6875f57e3ee$export$239a3d59567c1401.Word) break;
            start = prev;
        }
        while(end < length){
            let next = $6295c6875f57e3ee$export$a0fa439fd515e1ed(text, end);
            if (cat(text.slice(end, next)) != $6295c6875f57e3ee$export$239a3d59567c1401.Word) break;
            end = next;
        }
        return start == end ? null : $6295c6875f57e3ee$export$3bb1bd44aee62999.range(start + from, end + from);
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.allowMultipleSelections = $6295c6875f57e3ee$var$allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.tabSize = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator = $6295c6875f57e3ee$var$lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.readOnly = $6295c6875f57e3ee$var$readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.phrases = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    compare (a, b) {
        let kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.languageData = $6295c6875f57e3ee$var$languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.changeFilter = $6295c6875f57e3ee$var$changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.transactionFilter = $6295c6875f57e3ee$var$transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.transactionExtender = $6295c6875f57e3ee$var$transactionExtender;
$6295c6875f57e3ee$export$d51c0172eb2c2431.reconfigure = /*@__PURE__*/ $6295c6875f57e3ee$export$95000d4efaa4321f.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function $6295c6875f57e3ee$export$4e19c0b693794a7e(configs, defaults, combine = {}) {
    let result = {};
    for (let config of configs)for (let key of Object.keys(config)){
        let value = config[key], current = result[key];
        if (current === undefined) result[key] = value;
        else if (current === value || value === undefined) ; // No conflict
        else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
        else throw new Error("Config merge conflict for field " + key);
    }
    for(let key in defaults)if (result[key] === undefined) result[key] = defaults[key];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class $6295c6875f57e3ee$export$d60f08ed93a48611 {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from, to = from) {
        return $6295c6875f57e3ee$export$9a58ef0d7ad3278c.create(from, to, this);
    }
}
$6295c6875f57e3ee$export$d60f08ed93a48611.prototype.startSide = $6295c6875f57e3ee$export$d60f08ed93a48611.prototype.endSide = 0;
$6295c6875f57e3ee$export$d60f08ed93a48611.prototype.point = false;
$6295c6875f57e3ee$export$d60f08ed93a48611.prototype.mapMode = $6295c6875f57e3ee$export$39cf3280165f92aa.TrackDel;
/**
A range associates a value with a range of positions.
*/ class $6295c6875f57e3ee$export$9a58ef0d7ad3278c {
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
    /**
    @internal
    */ static create(from, to, value) {
        return new $6295c6875f57e3ee$export$9a58ef0d7ad3278c(from, to, value);
    }
}
function $6295c6875f57e3ee$var$cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class $6295c6875f57e3ee$var$Chunk {
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end, startAt = 0) {
        let arr = end ? this.to : this.from;
        for(let lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            let mid = lo + hi >> 1;
            let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(let i = this.findIndex(from, -1000000000 /* C.Far */ , true), e = this.findIndex(to, 1000000000 /* C.Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        let value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(let i = 0; i < this.value.length; i++){
            let val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom, newTo;
            if (curFrom == curTo) {
                let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new $6295c6875f57e3ee$var$Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class $6295c6875f57e3ee$export$34cb5241245008dd {
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new $6295c6875f57e3ee$export$34cb5241245008dd(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        let last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        let size = this.nextLayer.size;
        for (let chunk of this.chunk)size += chunk.value.length;
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        let { add: add = [], sort: sort = false, filterFrom: filterFrom = 0, filterTo: filterTo = this.length } = updateSpec;
        let filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort($6295c6875f57e3ee$var$cmpRange);
        if (this.isEmpty) return add.length ? $6295c6875f57e3ee$export$34cb5241245008dd.of(add) : this;
        let cur = new $6295c6875f57e3ee$var$LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        let builder = new $6295c6875f57e3ee$export$89e09ce03c7e8594();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                let range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push($6295c6875f57e3ee$export$9a58ef0d7ad3278c.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? $6295c6875f57e3ee$export$34cb5241245008dd.empty : this.nextLayer.update({
            add: spill,
            filter: filter,
            filterFrom: filterFrom,
            filterTo: filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        let chunks = [], chunkPos = [], maxPoint = -1;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            let touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                let { mapped: mapped, pos: pos } = chunk.map(start, changes);
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        let next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new $6295c6875f57e3ee$export$34cb5241245008dd(chunkPos, chunks, next || $6295c6875f57e3ee$export$34cb5241245008dd.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter(from = 0) {
        return $6295c6875f57e3ee$var$HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets, from = 0) {
        return $6295c6875f57e3ee$var$HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration.
    */ textDiff, comparator, /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = -1) {
        let a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let sharedChunks = $6295c6875f57e3ee$var$findSharedChunks(a, b, textDiff);
        let sideA = new $6295c6875f57e3ee$var$SpanCursor(a, sharedChunks, minPointSize);
        let sideB = new $6295c6875f57e3ee$var$SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>$6295c6875f57e3ee$var$compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) $6295c6875f57e3ee$var$compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets, from = 0, to) {
        if (to == null) to = 999999999;
        let a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        let b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        let sharedChunks = $6295c6875f57e3ee$var$findSharedChunks(a, b);
        let sideA = new $6295c6875f57e3ee$var$SpanCursor(a, sharedChunks, 0).goto(from), sideB = new $6295c6875f57e3ee$var$SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !$6295c6875f57e3ee$var$sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator, /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = -1) {
        let cursor = new $6295c6875f57e3ee$var$SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        let openRanges = cursor.openStart;
        for(;;){
            let curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                let active = cursor.activeForPoint(cursor.to);
                let openCount = cursor.pointFrom < from ? active.length + 1 : cursor.point.startSide < 0 ? active.length : Math.min(active.length, openRanges);
                iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
                openRanges = Math.min(cursor.openEnd(curTo), active.length);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, openRanges);
                openRanges = cursor.openEnd(curTo);
            }
            if (cursor.to > to) return openRanges + (cursor.point && cursor.to > to ? 1 : 0);
            pos = cursor.to;
            cursor.next();
        }
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges, sort = false) {
        let build = new $6295c6875f57e3ee$export$89e09ce03c7e8594();
        for (let range of ranges instanceof $6295c6875f57e3ee$export$9a58ef0d7ad3278c ? [
            ranges
        ] : sort ? $6295c6875f57e3ee$var$lazySort(ranges) : ranges)build.add(range.from, range.to, range.value);
        return build.finish();
    }
    /**
    Join an array of range sets into a single set.
    */ static join(sets) {
        if (!sets.length) return $6295c6875f57e3ee$export$34cb5241245008dd.empty;
        let result = sets[sets.length - 1];
        for(let i = sets.length - 2; i >= 0; i--)for(let layer = sets[i]; layer != $6295c6875f57e3ee$export$34cb5241245008dd.empty; layer = layer.nextLayer)result = new $6295c6875f57e3ee$export$34cb5241245008dd(layer.chunkPos, layer.chunk, result, Math.max(layer.maxPoint, result.maxPoint));
        return result;
    }
}
/**
The empty set of ranges.
*/ $6295c6875f57e3ee$export$34cb5241245008dd.empty = /*@__PURE__*/ new $6295c6875f57e3ee$export$34cb5241245008dd([], [], null, -1);
function $6295c6875f57e3ee$var$lazySort(ranges) {
    if (ranges.length > 1) for(let prev = ranges[0], i = 1; i < ranges.length; i++){
        let cur = ranges[i];
        if ($6295c6875f57e3ee$var$cmpRange(prev, cur) > 0) return ranges.slice().sort($6295c6875f57e3ee$var$cmpRange);
        prev = cur;
    }
    return ranges;
}
$6295c6875f57e3ee$export$34cb5241245008dd.empty.nextLayer = $6295c6875f57e3ee$export$34cb5241245008dd.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class $6295c6875f57e3ee$export$89e09ce03c7e8594 {
    finishChunk(newArrays) {
        this.chunks.push(new $6295c6875f57e3ee$var$Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* C.Far */ ;
        this.lastTo = -1000000000 /* C.Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new $6295c6875f57e3ee$export$89e09ce03c7e8594)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        let diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* C.ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        let last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner($6295c6875f57e3ee$export$34cb5241245008dd.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        let result = $6295c6875f57e3ee$export$34cb5241245008dd.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
}
function $6295c6875f57e3ee$var$findSharedChunks(a, b, textDiff) {
    let inA = new Map();
    for (let set of a)for(let i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
    let shared = new Set();
    for (let set of b)for(let i = 0; i < set.chunk.length; i++){
        let known = inA.get(set.chunk[i]);
        if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set.chunkPos[i] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set.chunk[i].length))) shared.add(set.chunk[i]);
    }
    return shared;
}
class $6295c6875f57e3ee$var$LayerCursor {
    constructor(layer, skip, minPoint, rank = 0){
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            let next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            break;
        } else {
            let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            let from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
}
class $6295c6875f57e3ee$var$HeapCursor {
    constructor(heap){
        this.heap = heap;
    }
    static from(sets, skip = null, minPoint = -1) {
        let heap = [];
        for(let i = 0; i < sets.length; i++){
            for(let cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new $6295c6875f57e3ee$var$LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new $6295c6875f57e3ee$var$HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        for (let cur of this.heap)cur.goto(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$6295c6875f57e3ee$var$heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        for (let cur of this.heap)cur.forward(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$6295c6875f57e3ee$var$heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            let top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            $6295c6875f57e3ee$var$heapBubble(this.heap, 0);
        }
    }
}
function $6295c6875f57e3ee$var$heapBubble(heap, index) {
    for(let cur = heap[index];;){
        let childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        let child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class $6295c6875f57e3ee$var$SpanCursor {
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* C.Far */ ;
        this.endSide = 0;
        // The amount of open active ranges at the start of the iterator.
        // Not including points.
        this.openStart = -1;
        this.cursor = $6295c6875f57e3ee$var$HeapCursor.from(sets, skip, minPoint);
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        $6295c6875f57e3ee$var$remove(this.active, index);
        $6295c6875f57e3ee$var$remove(this.activeTo, index);
        $6295c6875f57e3ee$var$remove(this.activeRank, index);
        this.minActive = $6295c6875f57e3ee$var$findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        let i = 0, { value: value, to: to, rank: rank } = this.cursor;
        // Organize active marks by rank first, then by size
        while(i < this.activeRank.length && (rank - this.activeRank[i] || to - this.activeTo[i]) > 0)i++;
        $6295c6875f57e3ee$var$insert(this.active, i, value);
        $6295c6875f57e3ee$var$insert(this.activeTo, i, to);
        $6295c6875f57e3ee$var$insert(this.activeRank, i, rank);
        if (trackOpen) $6295c6875f57e3ee$var$insert(trackOpen, i, this.cursor.from);
        this.minActive = $6295c6875f57e3ee$var$findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        let from = this.to, wasPoint = this.point;
        this.point = null;
        let trackOpen = this.openStart < 0 ? [] : null;
        for(;;){
            let a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) $6295c6875f57e3ee$var$remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* C.Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                let nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            this.openStart = 0;
            for(let i = trackOpen.length - 1; i >= 0 && trackOpen[i] < from; i--)this.openStart++;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        let active = [];
        for(let i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        let open = 0;
        for(let i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
}
function $6295c6875f57e3ee$var$compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    let endB = startB + length;
    let pos = startB, dPos = startB - startA;
    for(;;){
        let dEnd = a.to + dPos - b.to, diff = dEnd || a.endSide - b.endSide;
        let end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        if (a.point || b.point) {
            if (!(a.point && b.point && (a.point == b.point || a.point.eq(b.point)) && $6295c6875f57e3ee$var$sameValues(a.activeForPoint(a.to), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
        } else if (clipEnd > pos && !$6295c6875f57e3ee$var$sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
        if (end > endB) break;
        if ((dEnd || a.openEnd != b.openEnd) && comparator.boundChange) comparator.boundChange(end);
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function $6295c6875f57e3ee$var$sameValues(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] != b[i] && !a[i].eq(b[i])) return false;
    return true;
}
function $6295c6875f57e3ee$var$remove(array, index) {
    for(let i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function $6295c6875f57e3ee$var$insert(array, index, value) {
    for(let i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function $6295c6875f57e3ee$var$findMinIndex(value, array) {
    let found = -1, foundPos = 1000000000 /* C.Far */ ;
    for(let i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function $6295c6875f57e3ee$export$20b4ab289374d0ac(string, tabSize, to = string.length) {
    let n = 0;
    for(let i = 0; i < to && i < string.length;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = $6295c6875f57e3ee$export$a0fa439fd515e1ed(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function $6295c6875f57e3ee$export$718b3d71c384ca05(string, col, tabSize, strict) {
    for(let i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = $6295c6875f57e3ee$export$a0fa439fd515e1ed(string, i);
    }
    return strict === true ? -1 : string.length;
}



const $afd7c6da9f842a17$var$C = "\u037c";
const $afd7c6da9f842a17$var$COUNT = typeof Symbol == "undefined" ? "__" + $afd7c6da9f842a17$var$C : Symbol.for($afd7c6da9f842a17$var$C);
const $afd7c6da9f842a17$var$SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const $afd7c6da9f842a17$var$top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class $afd7c6da9f842a17$export$b920c662d2efee20 {
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        let { finish: finish } = options || {};
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(let prop in spec){
                let value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(let prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        let id = $afd7c6da9f842a17$var$top[$afd7c6da9f842a17$var$COUNT] || 1;
        $afd7c6da9f842a17$var$top[$afd7c6da9f842a17$var$COUNT] = id + 1;
        return $afd7c6da9f842a17$var$C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    //
    // If a Content Security Policy nonce is provided, it is added to
    // the `<style>` tag generated by the library.
    static mount(root, modules, options) {
        let set = root[$afd7c6da9f842a17$var$SET], nonce = options && options.nonce;
        if (!set) set = new $afd7c6da9f842a17$var$StyleSet(root, nonce);
        else if (nonce) set.setNonce(nonce);
        set.mount(Array.isArray(modules) ? modules : [
            modules
        ], root);
    }
}
let $afd7c6da9f842a17$var$adoptedSet = new Map //<Document, StyleSet>
;
class $afd7c6da9f842a17$var$StyleSet {
    constructor(root, nonce){
        let doc = root.ownerDocument || root, win = doc.defaultView;
        if (!root.head && root.adoptedStyleSheets && win.CSSStyleSheet) {
            let adopted = $afd7c6da9f842a17$var$adoptedSet.get(doc);
            if (adopted) return root[$afd7c6da9f842a17$var$SET] = adopted;
            this.sheet = new win.CSSStyleSheet;
            $afd7c6da9f842a17$var$adoptedSet.set(doc, this);
        } else {
            this.styleTag = doc.createElement("style");
            if (nonce) this.styleTag.setAttribute("nonce", nonce);
        }
        this.modules = [];
        root[$afd7c6da9f842a17$var$SET] = this;
    }
    mount(modules, root) {
        let sheet = this.sheet;
        let pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(let i = 0; i < modules.length; i++){
            let mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(let k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (sheet) {
            if (root.adoptedStyleSheets.indexOf(this.sheet) < 0) root.adoptedStyleSheets = [
                this.sheet,
                ...root.adoptedStyleSheets
            ];
        } else {
            let text = "";
            for(let i = 0; i < this.modules.length; i++)text += this.modules[i].getRules() + "\n";
            this.styleTag.textContent = text;
            let target = root.head || root;
            if (this.styleTag.parentNode != target) target.insertBefore(this.styleTag, target.firstChild);
        }
    }
    setNonce(nonce) {
        if (this.styleTag && this.styleTag.getAttribute("nonce") != nonce) this.styleTag.setAttribute("nonce", nonce);
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.


var $68b9e7c405929963$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $68b9e7c405929963$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $68b9e7c405929963$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $68b9e7c405929963$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $68b9e7c405929963$var$i = 0; $68b9e7c405929963$var$i < 10; $68b9e7c405929963$var$i++)$68b9e7c405929963$export$e2253033e6e1df16[48 + $68b9e7c405929963$var$i] = $68b9e7c405929963$export$e2253033e6e1df16[96 + $68b9e7c405929963$var$i] = String($68b9e7c405929963$var$i);
// The function keys
for(var $68b9e7c405929963$var$i = 1; $68b9e7c405929963$var$i <= 24; $68b9e7c405929963$var$i++)$68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$i + 111] = "F" + $68b9e7c405929963$var$i;
// And the alphabetic keys
for(var $68b9e7c405929963$var$i = 65; $68b9e7c405929963$var$i <= 90; $68b9e7c405929963$var$i++){
    $68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$i] = String.fromCharCode($68b9e7c405929963$var$i + 32);
    $68b9e7c405929963$export$fba63a578e423eb[$68b9e7c405929963$var$i] = String.fromCharCode($68b9e7c405929963$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $68b9e7c405929963$var$code in $68b9e7c405929963$export$e2253033e6e1df16)if (!$68b9e7c405929963$export$fba63a578e423eb.hasOwnProperty($68b9e7c405929963$var$code)) $68b9e7c405929963$export$fba63a578e423eb[$68b9e7c405929963$var$code] = $68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$code];
function $68b9e7c405929963$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $68b9e7c405929963$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $68b9e7c405929963$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $68b9e7c405929963$export$fba63a578e423eb : $68b9e7c405929963$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}


function $2d3e4571bc0b9f5f$export$2e2bcd8739ae039() {
    var elt = arguments[0];
    if (typeof elt == "string") elt = document.createElement(elt);
    var i = 1, next = arguments[1];
    if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
        for(var name in next)if (Object.prototype.hasOwnProperty.call(next, name)) {
            var value = next[name];
            if (typeof value == "string") elt.setAttribute(name, value);
            else if (value != null) elt[name] = value;
        }
        i++;
    }
    for(; i < arguments.length; i++)$2d3e4571bc0b9f5f$var$add(elt, arguments[i]);
    return elt;
}
function $2d3e4571bc0b9f5f$var$add(elt, child) {
    if (typeof child == "string") elt.appendChild(document.createTextNode(child));
    else if (child == null) ;
    else if (child.nodeType != null) elt.appendChild(child);
    else if (Array.isArray(child)) for(var i = 0; i < child.length; i++)$2d3e4571bc0b9f5f$var$add(elt, child[i]);
    else throw new RangeError("Unsupported child node: " + child);
}


let $7beee9608540d2c3$var$nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
let $7beee9608540d2c3$var$doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
const $7beee9608540d2c3$var$ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$ie_upto10 = /*@__PURE__*/ /MSIE \d/.test($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$ie = !!($7beee9608540d2c3$var$ie_upto10 || $7beee9608540d2c3$var$ie_11up || $7beee9608540d2c3$var$ie_edge);
const $7beee9608540d2c3$var$gecko = !$7beee9608540d2c3$var$ie && /*@__PURE__*/ /gecko\/(\d+)/i.test($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$chrome = !$7beee9608540d2c3$var$ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$webkit = "webkitFontSmoothing" in $7beee9608540d2c3$var$doc.documentElement.style;
const $7beee9608540d2c3$var$safari = !$7beee9608540d2c3$var$ie && /*@__PURE__*/ /Apple Computer/.test($7beee9608540d2c3$var$nav.vendor);
const $7beee9608540d2c3$var$ios = $7beee9608540d2c3$var$safari && /*@__PURE__*/ (/Mobile\/\w+/.test($7beee9608540d2c3$var$nav.userAgent) || $7beee9608540d2c3$var$nav.maxTouchPoints > 2);
var $7beee9608540d2c3$var$browser = {
    mac: $7beee9608540d2c3$var$ios || /*@__PURE__*/ /Mac/.test($7beee9608540d2c3$var$nav.platform),
    windows: /*@__PURE__*/ /Win/.test($7beee9608540d2c3$var$nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test($7beee9608540d2c3$var$nav.platform),
    ie: $7beee9608540d2c3$var$ie,
    ie_version: $7beee9608540d2c3$var$ie_upto10 ? $7beee9608540d2c3$var$doc.documentMode || 6 : $7beee9608540d2c3$var$ie_11up ? +$7beee9608540d2c3$var$ie_11up[1] : $7beee9608540d2c3$var$ie_edge ? +$7beee9608540d2c3$var$ie_edge[1] : 0,
    gecko: $7beee9608540d2c3$var$gecko,
    gecko_version: $7beee9608540d2c3$var$gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!$7beee9608540d2c3$var$chrome,
    chrome_version: $7beee9608540d2c3$var$chrome ? +$7beee9608540d2c3$var$chrome[1] : 0,
    ios: $7beee9608540d2c3$var$ios,
    android: /*@__PURE__*/ /Android\b/.test($7beee9608540d2c3$var$nav.userAgent),
    webkit: $7beee9608540d2c3$var$webkit,
    webkit_version: $7beee9608540d2c3$var$webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    safari: $7beee9608540d2c3$var$safari,
    safari_version: $7beee9608540d2c3$var$safari ? +/*@__PURE__*/ (/\bVersion\/(\d+(\.\d+)?)/.exec($7beee9608540d2c3$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: $7beee9608540d2c3$var$doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
function $7beee9608540d2c3$var$combineAttrs(source, target) {
    for(let name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
const $7beee9608540d2c3$var$noAttrs = /*@__PURE__*/ Object.create(null);
function $7beee9608540d2c3$var$attrsEq(a, b, ignore) {
    if (a == b) return true;
    if (!a) a = $7beee9608540d2c3$var$noAttrs;
    if (!b) b = $7beee9608540d2c3$var$noAttrs;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0)) return false;
    for (let key of keysA){
        if (key != ignore && (keysB.indexOf(key) == -1 || a[key] !== b[key])) return false;
    }
    return true;
}
function $7beee9608540d2c3$var$setAttrs(dom, attrs) {
    for(let i = dom.attributes.length - 1; i >= 0; i--){
        let name = dom.attributes[i].name;
        if (attrs[name] == null) dom.removeAttribute(name);
    }
    for(let name in attrs){
        let value = attrs[name];
        if (name == "style") dom.style.cssText = value;
        else if (dom.getAttribute(name) != value) dom.setAttribute(name, value);
    }
}
function $7beee9608540d2c3$var$updateAttrs(dom, prev, attrs) {
    let changed = false;
    if (prev) {
        for(let name in prev)if (!(attrs && name in attrs)) {
            changed = true;
            if (name == "style") dom.style.cssText = "";
            else dom.removeAttribute(name);
        }
    }
    if (attrs) {
        for(let name in attrs)if (!(prev && prev[name] == attrs[name])) {
            changed = true;
            if (name == "style") dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    return changed;
}
function $7beee9608540d2c3$var$getAttrs(dom) {
    let attrs = Object.create(null);
    for(let i = 0; i < dom.attributes.length; i++){
        let attr = dom.attributes[i];
        attrs[attr.name] = attr.value;
    }
    return attrs;
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class $7beee9608540d2c3$export$95cdd842edb044c5 {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom, view) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    For inline widgets that are displayed inline (as opposed to
    `inline-block`) and introduce line breaks (through `<br>` tags
    or textual newlines), this must indicate the amount of line
    breaks they introduce. Defaults to 0.
    */ get lineBreaks() {
        return 0;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    Override the way screen coordinates for positions at/in the
    widget are found. `pos` will be the offset into the widget, and
    `side` the side of the position that is being queried—less than
    zero for before, greater than zero for after, and zero for
    directly at that position.
    */ coordsAt(dom, pos, side) {
        return null;
    }
    /**
    @internal
    */ get isHidden() {
        return false;
    }
    /**
    @internal
    */ get editable() {
        return false;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var $7beee9608540d2c3$export$48808c686fe495c4 = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}($7beee9608540d2c3$export$48808c686fe495c4 || ($7beee9608540d2c3$export$48808c686fe495c4 = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class $7beee9608540d2c3$export$10e30b733df217ea extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new $7beee9608540d2c3$var$MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        let side = Math.max(-10000, Math.min(10000, spec.side || 0)), block = !!spec.block;
        side += block && !spec.inlineOrder ? side > 0 ? 300000000 /* Side.BlockAfter */  : -400000000 /* Side.BlockBefore */  : side > 0 ? 100000000 /* Side.InlineAfter */  : -100000000 /* Side.InlineBefore */ ;
        return new $7beee9608540d2c3$var$PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        let block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* Side.GapStart */ ;
            endSide = 400000000 /* Side.GapEnd */ ;
        } else {
            let { start: start, end: end } = $7beee9608540d2c3$var$getInclusive(spec, block);
            startSide = (start ? block ? -300000000 /* Side.BlockIncStart */  : -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* Side.BlockIncEnd */  : 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ ) + 1;
        }
        return new $7beee9608540d2c3$var$PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new $7beee9608540d2c3$var$LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of, sort = false) {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
}
/**
The empty set of decorations.
*/ $7beee9608540d2c3$export$10e30b733df217ea.none = (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
class $7beee9608540d2c3$var$MarkDecoration extends $7beee9608540d2c3$export$10e30b733df217ea {
    constructor(spec){
        let { start: start, end: end } = $7beee9608540d2c3$var$getInclusive(spec);
        super(start ? -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ , end ? 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.attrs = spec.class && spec.attributes ? $7beee9608540d2c3$var$combineAttrs(spec.attributes, {
            class: spec.class
        }) : spec.class ? {
            class: spec.class
        } : spec.attributes || $7beee9608540d2c3$var$noAttrs;
    }
    eq(other) {
        return this == other || other instanceof $7beee9608540d2c3$var$MarkDecoration && this.tagName == other.tagName && $7beee9608540d2c3$var$attrsEq(this.attrs, other.attrs);
    }
    range(from, to = from) {
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
}
$7beee9608540d2c3$var$MarkDecoration.prototype.point = false;
class $7beee9608540d2c3$var$LineDecoration extends $7beee9608540d2c3$export$10e30b733df217ea {
    constructor(spec){
        super(-200000000 /* Side.Line */ , -200000000 /* Side.Line */ , null, spec);
    }
    eq(other) {
        return other instanceof $7beee9608540d2c3$var$LineDecoration && this.spec.class == other.spec.class && $7beee9608540d2c3$var$attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from, to = from) {
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
}
$7beee9608540d2c3$var$LineDecoration.prototype.mapMode = (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackBefore;
$7beee9608540d2c3$var$LineDecoration.prototype.point = true;
class $7beee9608540d2c3$var$PointDecoration extends $7beee9608540d2c3$export$10e30b733df217ea {
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel : startSide <= 0 ? (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackBefore : (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackAfter;
    }
    // Only relevant when this.block == true
    get type() {
        return this.startSide != this.endSide ? $7beee9608540d2c3$export$48808c686fe495c4.WidgetRange : this.startSide <= 0 ? $7beee9608540d2c3$export$48808c686fe495c4.WidgetBefore : $7beee9608540d2c3$export$48808c686fe495c4.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
    }
    eq(other) {
        return other instanceof $7beee9608540d2c3$var$PointDecoration && $7beee9608540d2c3$var$widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from, to = from) {
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
}
$7beee9608540d2c3$var$PointDecoration.prototype.point = true;
function $7beee9608540d2c3$var$getInclusive(spec, block = false) {
    let { inclusiveStart: start, inclusiveEnd: end } = spec;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function $7beee9608540d2c3$var$widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function $7beee9608540d2c3$var$addRange(from, to, ranges, margin = 0) {
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
/**
A block wrapper defines a DOM node that wraps lines or other block
wrappers at the top of the document. It affects any line or block
widget that starts inside its range, including blocks starting
directly at `from` but not including `to`.
*/ class $7beee9608540d2c3$export$b9b108b497733374 extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
    constructor(tagName, attributes){
        super();
        this.tagName = tagName;
        this.attributes = attributes;
    }
    eq(other) {
        return other == this || other instanceof $7beee9608540d2c3$export$b9b108b497733374 && this.tagName == other.tagName && $7beee9608540d2c3$var$attrsEq(this.attributes, other.attributes);
    }
    /**
    Create a block wrapper object with the given tag name and
    attributes.
    */ static create(spec) {
        return new $7beee9608540d2c3$export$b9b108b497733374(spec.tagName, spec.attributes || $7beee9608540d2c3$var$noAttrs);
    }
    /**
    Create a range set from the given block wrapper ranges.
    */ static set(of, sort = false) {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(of, sort);
    }
}
$7beee9608540d2c3$export$b9b108b497733374.prototype.startSide = $7beee9608540d2c3$export$b9b108b497733374.prototype.endSide = -1;
function $7beee9608540d2c3$var$getSelection(root) {
    let target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function $7beee9608540d2c3$var$contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function $7beee9608540d2c3$var$hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return $7beee9608540d2c3$var$contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function $7beee9608540d2c3$var$clientRectsFor(dom) {
    if (dom.nodeType == 3) return $7beee9608540d2c3$var$textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function $7beee9608540d2c3$var$isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? $7beee9608540d2c3$var$scanFor(node, off, targetNode, targetOff, -1) || $7beee9608540d2c3$var$scanFor(node, off, targetNode, targetOff, 1) : false;
}
function $7beee9608540d2c3$var$domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function $7beee9608540d2c3$var$isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
function $7beee9608540d2c3$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $7beee9608540d2c3$var$maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = $7beee9608540d2c3$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? $7beee9608540d2c3$var$maxOffset(node) : 0;
        } else return false;
    }
}
function $7beee9608540d2c3$var$maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $7beee9608540d2c3$var$flattenRect(rect, left) {
    let x = left ? rect.left : rect.right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function $7beee9608540d2c3$var$windowRect(win) {
    let vp = win.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function $7beee9608540d2c3$var$getScale(elt, rect) {
    let scaleX = rect.width / elt.offsetWidth;
    let scaleY = rect.height / elt.offsetHeight;
    if (scaleX > 0.995 && scaleX < 1.005 || !isFinite(scaleX) || Math.abs(rect.width - elt.offsetWidth) < 1) scaleX = 1;
    if (scaleY > 0.995 && scaleY < 1.005 || !isFinite(scaleY) || Math.abs(rect.height - elt.offsetHeight) < 1) scaleY = 1;
    return {
        scaleX: scaleX,
        scaleY: scaleY
    };
}
function $7beee9608540d2c3$var$scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    for(let cur = dom, stop = false; cur && !stop;){
        if (cur.nodeType == 1) {
            let bounding, top = cur == doc.body;
            let scaleX = 1, scaleY = 1;
            if (top) bounding = $7beee9608540d2c3$var$windowRect(win);
            else {
                if (/^(fixed|sticky)$/.test(getComputedStyle(cur).position)) stop = true;
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.assignedSlot || cur.parentNode;
                    continue;
                }
                let rect = cur.getBoundingClientRect();
                ({ scaleX: scaleX, scaleY: scaleY } = $7beee9608540d2c3$var$getScale(cur, rect));
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: rect.left,
                    right: rect.left + cur.clientWidth * scaleX,
                    top: rect.top,
                    bottom: rect.top + cur.clientHeight * scaleY
                };
            }
            let moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top) {
                    moveY = rect.top - (bounding.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + yMargin;
                } else if (rect.bottom > bounding.bottom) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = rect.top - (bounding.top + yMargin);
                }
            } else {
                let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left) {
                    moveX = rect.left - (bounding.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + xMargin;
                } else if (rect.right > bounding.right) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = rect.left - (bounding.left + xMargin);
                }
            } else {
                let targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    let movedX = 0, movedY = 0;
                    if (moveY) {
                        let start = cur.scrollTop;
                        cur.scrollTop += moveY / scaleY;
                        movedY = (cur.scrollTop - start) * scaleY;
                    }
                    if (moveX) {
                        let start = cur.scrollLeft;
                        cur.scrollLeft += moveX / scaleX;
                        movedX = (cur.scrollLeft - start) * scaleX;
                    }
                    rect = {
                        left: rect.left - movedX,
                        top: rect.top - movedY,
                        right: rect.right - movedX,
                        bottom: rect.bottom - movedY
                    };
                    if (movedX && Math.abs(movedX - moveX) < 1) x = "nearest";
                    if (movedY && Math.abs(movedY - moveY) < 1) y = "nearest";
                }
            }
            if (top) break;
            if (rect.top < bounding.top || rect.bottom > bounding.bottom || rect.left < bounding.left || rect.right > bounding.right) rect = {
                left: Math.max(rect.left, bounding.left),
                right: Math.min(rect.right, bounding.right),
                top: Math.max(rect.top, bounding.top),
                bottom: Math.min(rect.bottom, bounding.bottom)
            };
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
function $7beee9608540d2c3$var$scrollableParents(dom) {
    let doc = dom.ownerDocument, x, y;
    for(let cur = dom.parentNode; cur;){
        if (cur == doc.body || x && y) break;
        else if (cur.nodeType == 1) {
            if (!y && cur.scrollHeight > cur.clientHeight) y = cur;
            if (!x && cur.scrollWidth > cur.clientWidth) x = cur;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
    return {
        x: x,
        y: y
    };
}
class $7beee9608540d2c3$var$DOMSelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        let { anchorNode: anchorNode, focusNode: focusNode } = range;
        // Clip offsets to node size to avoid crashes when Safari reports bogus offsets (#1152)
        this.set(anchorNode, Math.min(range.anchorOffset, anchorNode ? $7beee9608540d2c3$var$maxOffset(anchorNode) : 0), focusNode, Math.min(range.focusOffset, focusNode ? $7beee9608540d2c3$var$maxOffset(focusNode) : 0));
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
}
let $7beee9608540d2c3$var$preventScrollSupported = null;
// Safari 26 breaks preventScroll support
if ($7beee9608540d2c3$var$browser.safari && $7beee9608540d2c3$var$browser.safari_version >= 26) $7beee9608540d2c3$var$preventScrollSupported = false;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $7beee9608540d2c3$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($7beee9608540d2c3$var$preventScrollSupported) return dom.focus($7beee9608540d2c3$var$preventScrollSupported);
    let stack = [];
    for(let cur = dom; cur; cur = cur.parentNode){
        stack.push(cur, cur.scrollTop, cur.scrollLeft);
        if (cur == cur.ownerDocument) break;
    }
    dom.focus($7beee9608540d2c3$var$preventScrollSupported == null ? {
        get preventScroll () {
            $7beee9608540d2c3$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$7beee9608540d2c3$var$preventScrollSupported) {
        $7beee9608540d2c3$var$preventScrollSupported = false;
        for(let i = 0; i < stack.length;){
            let elt = stack[i++], top = stack[i++], left = stack[i++];
            if (elt.scrollTop != top) elt.scrollTop = top;
            if (elt.scrollLeft != left) elt.scrollLeft = left;
        }
    }
}
let $7beee9608540d2c3$var$scratchRange;
function $7beee9608540d2c3$var$textRange(node, from, to = from) {
    let range = $7beee9608540d2c3$var$scratchRange || ($7beee9608540d2c3$var$scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function $7beee9608540d2c3$var$dispatchKey(elt, name, code, mods) {
    let options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    if (mods) ({ altKey: options.altKey, ctrlKey: options.ctrlKey, shiftKey: options.shiftKey, metaKey: options.metaKey } = mods);
    let down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    let up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function $7beee9608540d2c3$var$getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function $7beee9608540d2c3$var$atElementStart(doc, selection) {
    let node = selection.focusNode, offset = selection.focusOffset;
    if (!node || selection.anchorNode != node || selection.anchorOffset != offset) return false;
    // Safari can report bogus offsets (#1152)
    offset = Math.min(offset, $7beee9608540d2c3$var$maxOffset(node));
    for(;;){
        if (offset) {
            if (node.nodeType != 1) return false;
            let prev = node.childNodes[offset - 1];
            if (prev.contentEditable == "false") offset--;
            else {
                node = prev;
                offset = $7beee9608540d2c3$var$maxOffset(node);
            }
        } else if (node == doc) return true;
        else {
            offset = $7beee9608540d2c3$var$domIndex(node);
            node = node.parentNode;
        }
    }
}
function $7beee9608540d2c3$var$isScrolledToBottom(elt) {
    return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
function $7beee9608540d2c3$var$textNodeBefore(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset > 0) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $7beee9608540d2c3$var$maxOffset(node);
        } else if (node.parentNode && !$7beee9608540d2c3$var$isBlockElement(node)) {
            offset = $7beee9608540d2c3$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $7beee9608540d2c3$var$textNodeAfter(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$7beee9608540d2c3$var$isBlockElement(node)) {
            offset = $7beee9608540d2c3$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
class $7beee9608540d2c3$var$DOMPos {
    constructor(node, offset, precise = true){
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
    static before(dom, precise) {
        return new $7beee9608540d2c3$var$DOMPos(dom.parentNode, $7beee9608540d2c3$var$domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new $7beee9608540d2c3$var$DOMPos(dom.parentNode, $7beee9608540d2c3$var$domIndex(dom) + 1, precise);
    }
}
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var $7beee9608540d2c3$export$cacd6541cfeeb6c1 = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}($7beee9608540d2c3$export$cacd6541cfeeb6c1 || ($7beee9608540d2c3$export$cacd6541cfeeb6c1 = {}));
const $7beee9608540d2c3$var$LTR = $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR, $7beee9608540d2c3$var$RTL = $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL;
// Decode a string with each type encoded as log2(type)
function $7beee9608540d2c3$var$dec(str) {
    let result = [];
    for(let i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
const $7beee9608540d2c3$var$LowTypes = /*@__PURE__*/ $7beee9608540d2c3$var$dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
const $7beee9608540d2c3$var$ArabicTypes = /*@__PURE__*/ $7beee9608540d2c3$var$dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const $7beee9608540d2c3$var$Brackets = /*@__PURE__*/ Object.create(null), $7beee9608540d2c3$var$BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for (let p of [
    "()",
    "[]",
    "{}"
]){
    let l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    $7beee9608540d2c3$var$Brackets[l] = r;
    $7beee9608540d2c3$var$Brackets[r] = -l;
}
function $7beee9608540d2c3$var$charType(ch) {
    return ch <= 0xf7 ? $7beee9608540d2c3$var$LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* T.R */  : 0x600 <= ch && ch <= 0x6f9 ? $7beee9608540d2c3$var$ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* T.AL */  : 0x2000 <= ch && ch <= 0x200c ? 256 /* T.NI */  : 0xfb50 <= ch && ch <= 0xfdff ? 4 /* T.AL */  : 1 /* T.L */ ;
}
const $7beee9608540d2c3$var$BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class $7beee9608540d2c3$export$e1ed96b746bb516a {
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? $7beee9608540d2c3$var$RTL : $7beee9608540d2c3$var$LTR;
    }
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ forward(forward, dir) {
        return forward == (this.dir == dir);
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        let maybe = -1;
        for(let i = 0; i < order.length; i++){
            let span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
}
function $7beee9608540d2c3$var$isolatesEq(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++){
        let iA = a[i], iB = b[i];
        if (iA.from != iB.from || iA.to != iB.to || iA.direction != iB.direction || !$7beee9608540d2c3$var$isolatesEq(iA.inner, iB.inner)) return false;
    }
    return true;
}
// Reused array of character types
const $7beee9608540d2c3$var$types = [];
// Fill in the character types (in `types`) from `from` to `to` and
// apply W normalization rules.
function $7beee9608540d2c3$var$computeCharTypes(line, rFrom, rTo, isolates, outerType) {
    for(let iI = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        let prevType = iI ? 256 /* T.NI */  : outerType;
        // W1. Examine each non-spacing mark (NSM) in the level run, and
        // change the type of the NSM to the type of the previous
        // character. If the NSM is at the start of the level run, it will
        // get the type of sor.
        // W2. Search backwards from each instance of a European number
        // until the first strong type (R, L, AL, or sor) is found. If an
        // AL is found, change the type of the European number to Arabic
        // number.
        // W3. Change all ALs to R.
        // (Left after this: L, R, EN, AN, ET, CS, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $7beee9608540d2c3$var$charType(line.charCodeAt(i));
            if (type == 512 /* T.NSM */ ) type = prev;
            else if (type == 8 /* T.EN */  && prevStrong == 4 /* T.AL */ ) type = 16 /* T.AN */ ;
            $7beee9608540d2c3$var$types[i] = type == 4 /* T.AL */  ? 2 /* T.R */  : type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
            prev = type;
        }
        // W5. A sequence of European terminators adjacent to European
        // numbers changes to all European numbers.
        // W6. Otherwise, separators and terminators change to Other
        // Neutral.
        // W7. Search backwards from each instance of a European number
        // until the first strong type (R, L, or sor) is found. If an L is
        // found, then change the type of the European number to L.
        // (Left after this: L, R, EN+AN, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $7beee9608540d2c3$var$types[i];
            if (type == 128 /* T.CS */ ) {
                if (i < to - 1 && prev == $7beee9608540d2c3$var$types[i + 1] && prev & 24 /* T.Num */ ) type = $7beee9608540d2c3$var$types[i] = prev;
                else $7beee9608540d2c3$var$types[i] = 256 /* T.NI */ ;
            } else if (type == 64 /* T.ET */ ) {
                let end = i + 1;
                while(end < to && $7beee9608540d2c3$var$types[end] == 64 /* T.ET */ )end++;
                let replace = i && prev == 8 /* T.EN */  || end < rTo && $7beee9608540d2c3$var$types[end] == 8 /* T.EN */  ? prevStrong == 1 /* T.L */  ? 1 /* T.L */  : 8 /* T.EN */  : 256 /* T.NI */ ;
                for(let j = i; j < end; j++)$7beee9608540d2c3$var$types[j] = replace;
                i = end - 1;
            } else if (type == 8 /* T.EN */  && prevStrong == 1 /* T.L */ ) $7beee9608540d2c3$var$types[i] = 1 /* T.L */ ;
            prev = type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
        }
    }
}
// Process brackets throughout a run sequence.
function $7beee9608540d2c3$var$processBracketPairs(line, rFrom, rTo, isolates, outerType) {
    let oppositeType = outerType == 1 /* T.L */  ? 2 /* T.R */  : 1 /* T.L */ ;
    for(let iI = 0, sI = 0, context = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N0. Process bracket pairs in an isolating run sequence
        // sequentially in the logical order of the text positions of the
        // opening paired brackets using the logic given below. Within this
        // scope, bidirectional types EN and AN are treated as R.
        for(let i = from, ch, br, type; i < to; i++){
            // Keeps [startIndex, type, strongSeen] triples for each open
            // bracket on BracketStack.
            if (br = $7beee9608540d2c3$var$Brackets[ch = line.charCodeAt(i)]) {
                if (br < 0) {
                    for(let sJ = sI - 3; sJ >= 0; sJ -= 3)if ($7beee9608540d2c3$var$BracketStack[sJ + 1] == -br) {
                        let flags = $7beee9608540d2c3$var$BracketStack[sJ + 2];
                        let type = flags & 2 /* Bracketed.EmbedInside */  ? outerType : !(flags & 4 /* Bracketed.OppositeInside */ ) ? 0 : flags & 1 /* Bracketed.OppositeBefore */  ? oppositeType : outerType;
                        if (type) $7beee9608540d2c3$var$types[i] = $7beee9608540d2c3$var$types[$7beee9608540d2c3$var$BracketStack[sJ]] = type;
                        sI = sJ;
                        break;
                    }
                } else if ($7beee9608540d2c3$var$BracketStack.length == 189 /* Bracketed.MaxDepth */ ) break;
                else {
                    $7beee9608540d2c3$var$BracketStack[sI++] = i;
                    $7beee9608540d2c3$var$BracketStack[sI++] = ch;
                    $7beee9608540d2c3$var$BracketStack[sI++] = context;
                }
            } else if ((type = $7beee9608540d2c3$var$types[i]) == 2 /* T.R */  || type == 1 /* T.L */ ) {
                let embed = type == outerType;
                context = embed ? 0 : 1 /* Bracketed.OppositeBefore */ ;
                for(let sJ = sI - 3; sJ >= 0; sJ -= 3){
                    let cur = $7beee9608540d2c3$var$BracketStack[sJ + 2];
                    if (cur & 2 /* Bracketed.EmbedInside */ ) break;
                    if (embed) $7beee9608540d2c3$var$BracketStack[sJ + 2] |= 2 /* Bracketed.EmbedInside */ ;
                    else {
                        if (cur & 4 /* Bracketed.OppositeInside */ ) break;
                        $7beee9608540d2c3$var$BracketStack[sJ + 2] |= 4 /* Bracketed.OppositeInside */ ;
                    }
                }
            }
        }
    }
}
function $7beee9608540d2c3$var$processNeutrals(rFrom, rTo, isolates, outerType) {
    for(let iI = 0, prev = outerType; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N1. A sequence of neutrals takes the direction of the
        // surrounding strong text if the text on both sides has the same
        // direction. European and Arabic numbers act as if they were R in
        // terms of their influence on neutrals. Start-of-level-run (sor)
        // and end-of-level-run (eor) are used at level run boundaries.
        // N2. Any remaining neutrals take the embedding direction.
        // (Left after this: L, R, EN+AN)
        for(let i = from; i < to;){
            let type = $7beee9608540d2c3$var$types[i];
            if (type == 256 /* T.NI */ ) {
                let end = i + 1;
                for(;;){
                    if (end == to) {
                        if (iI == isolates.length) break;
                        end = isolates[iI++].to;
                        to = iI < isolates.length ? isolates[iI].from : rTo;
                    } else if ($7beee9608540d2c3$var$types[end] == 256 /* T.NI */ ) end++;
                    else break;
                }
                let beforeL = prev == 1 /* T.L */ ;
                let afterL = (end < rTo ? $7beee9608540d2c3$var$types[end] : outerType) == 1 /* T.L */ ;
                let replace = beforeL == afterL ? beforeL ? 1 /* T.L */  : 2 /* T.R */  : outerType;
                for(let j = end, jI = iI, fromJ = jI ? isolates[jI - 1].to : rFrom; j > i;){
                    if (j == fromJ) {
                        j = isolates[--jI].from;
                        fromJ = jI ? isolates[jI - 1].to : rFrom;
                    }
                    $7beee9608540d2c3$var$types[--j] = replace;
                }
                i = end;
            } else {
                prev = type;
                i++;
            }
        }
    }
}
// Find the contiguous ranges of character types in a given range, and
// emit spans for them. Flip the order of the spans as appropriate
// based on the level, and call through to compute the spans for
// isolates at the proper point.
function $7beee9608540d2c3$var$emitSpans(line, from, to, level, baseLevel, isolates, order) {
    let ourType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    if (level % 2 == baseLevel % 2) for(let iCh = from, iI = 0; iCh < to;){
        // Scan a section of characters in direction ourType, unless
        // there's another type of char right after iCh, in which case
        // we scan a section of other characters (which, if ourType ==
        // T.L, may contain both T.R and T.AN chars).
        let sameDir = true, isNum = false;
        if (iI == isolates.length || iCh < isolates[iI].from) {
            let next = $7beee9608540d2c3$var$types[iCh];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        // Holds an array of isolates to pass to a recursive call if we
        // must recurse (to distinguish T.AN inside an RTL section in
        // LTR text), null if we can emit directly
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI < isolates.length && iScan == isolates[iI].from) {
                if (isNum) break run;
                let iso = isolates[iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.to, jI = iI + 1;;){
                    if (upto == to) break run;
                    if (jI < isolates.length && isolates[jI].from == upto) upto = isolates[jI++].to;
                    else if ($7beee9608540d2c3$var$types[upto] == ourType) break run;
                    else break;
                }
                iI++;
                if (recurse) recurse.push(iso);
                else {
                    if (iso.from > iCh) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iCh, iso.from, localLevel));
                    let dirSwap = iso.direction == $7beee9608540d2c3$var$LTR != !(localLevel % 2);
                    $7beee9608540d2c3$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.to;
                }
                iScan = iso.to;
            } else if (iScan == to || (sameDir ? $7beee9608540d2c3$var$types[iScan] != ourType : $7beee9608540d2c3$var$types[iScan] == ourType)) break;
            else iScan++;
        }
        if (recurse) $7beee9608540d2c3$var$emitSpans(line, iCh, iScan, level + 1, baseLevel, recurse, order);
        else if (iCh < iScan) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iCh, iScan, localLevel));
        iCh = iScan;
    }
    else // Iterate in reverse to flip the span order. Same code again, but
    // going from the back of the section to the front
    for(let iCh = to, iI = isolates.length; iCh > from;){
        let sameDir = true, isNum = false;
        if (!iI || iCh > isolates[iI - 1].to) {
            let next = $7beee9608540d2c3$var$types[iCh - 1];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI && iScan == isolates[iI - 1].to) {
                if (isNum) break run;
                let iso = isolates[--iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.from, jI = iI;;){
                    if (upto == from) break run;
                    if (jI && isolates[jI - 1].to == upto) upto = isolates[--jI].from;
                    else if ($7beee9608540d2c3$var$types[upto - 1] == ourType) break run;
                    else break;
                }
                if (recurse) recurse.push(iso);
                else {
                    if (iso.to < iCh) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iso.to, iCh, localLevel));
                    let dirSwap = iso.direction == $7beee9608540d2c3$var$LTR != !(localLevel % 2);
                    $7beee9608540d2c3$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.from;
                }
                iScan = iso.from;
            } else if (iScan == from || (sameDir ? $7beee9608540d2c3$var$types[iScan - 1] != ourType : $7beee9608540d2c3$var$types[iScan - 1] == ourType)) break;
            else iScan--;
        }
        if (recurse) $7beee9608540d2c3$var$emitSpans(line, iScan, iCh, level + 1, baseLevel, recurse, order);
        else if (iScan < iCh) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iScan, iCh, localLevel));
        iCh = iScan;
    }
}
function $7beee9608540d2c3$var$computeSectionOrder(line, level, baseLevel, isolates, from, to, order) {
    let outerType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    $7beee9608540d2c3$var$computeCharTypes(line, from, to, isolates, outerType);
    $7beee9608540d2c3$var$processBracketPairs(line, from, to, isolates, outerType);
    $7beee9608540d2c3$var$processNeutrals(from, to, isolates, outerType);
    $7beee9608540d2c3$var$emitSpans(line, from, to, level, baseLevel, isolates, order);
}
function $7beee9608540d2c3$var$computeOrder(line, direction, isolates) {
    if (!line) return [
        new $7beee9608540d2c3$export$e1ed96b746bb516a(0, 0, direction == $7beee9608540d2c3$var$RTL ? 1 : 0)
    ];
    if (direction == $7beee9608540d2c3$var$LTR && !isolates.length && !$7beee9608540d2c3$var$BidiRE.test(line)) return $7beee9608540d2c3$var$trivialOrder(line.length);
    if (isolates.length) while(line.length > $7beee9608540d2c3$var$types.length)$7beee9608540d2c3$var$types[$7beee9608540d2c3$var$types.length] = 256 /* T.NI */ ; // Make sure types array has no gaps
    let order = [], level = direction == $7beee9608540d2c3$var$LTR ? 0 : 1;
    $7beee9608540d2c3$var$computeSectionOrder(line, level, level, isolates, 0, line.length, order);
    return order;
}
function $7beee9608540d2c3$var$trivialOrder(length) {
    return [
        new $7beee9608540d2c3$export$e1ed96b746bb516a(0, length, 0)
    ];
}
let $7beee9608540d2c3$var$movedOver = "";
// This implementation moves strictly visually, without concern for a
// traversal visiting every logical position in the string. It will
// still do so for simple input, but situations like multiple isolates
// with the same level next to each other, or text going against the
// main dir at the end of the line, will make some positions
// unreachable with this motion. Each visible cursor position will
// correspond to the lower-level bidi span that touches it.
//
// The alternative would be to solve an order globally for a given
// line, making sure that it includes every position, but that would
// require associating non-canonical (higher bidi span level)
// positions with a given visual position, which is likely to confuse
// people. (And would generally be a lot more complicated.)
function $7beee9608540d2c3$var$moveVisually(line, order, dir, start, forward) {
    var _a;
    let startIndex = start.head - line.from;
    let spanI = $7beee9608540d2c3$export$e1ed96b746bb516a.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    let span = order[spanI], spanEnd = span.side(forward, dir);
    // End of span
    if (startIndex == spanEnd) {
        let nextI = spanI += forward ? 1 : -1;
        if (nextI < 0 || nextI >= order.length) return null;
        span = order[spanI = nextI];
        startIndex = span.side(!forward, dir);
        spanEnd = span.side(forward, dir);
    }
    let nextIndex = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, startIndex, span.forward(forward, dir));
    if (nextIndex < span.from || nextIndex > span.to) nextIndex = spanEnd;
    $7beee9608540d2c3$var$movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (nextSpan && nextIndex == spanEnd && nextSpan.level + (forward ? 0 : 1) < span.level) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(nextSpan.side(!forward, dir) + line.from, nextSpan.forward(forward, dir) ? 1 : -1, nextSpan.level);
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(nextIndex + line.from, span.forward(forward, dir) ? -1 : 1, span.level);
}
function $7beee9608540d2c3$var$autoDirection(text, from, to) {
    for(let i = from; i < to; i++){
        let type = $7beee9608540d2c3$var$charType(text.charCodeAt(i));
        if (type == 1 /* T.L */ ) return $7beee9608540d2c3$var$LTR;
        if (type == 2 /* T.R */  || type == 4 /* T.AL */ ) return $7beee9608540d2c3$var$RTL;
    }
    return $7beee9608540d2c3$var$LTR;
}
const $7beee9608540d2c3$var$clickAddsSelectionRange = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$dragMovesSelection$1 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$mouseSelectionStyle = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$exceptionSink = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$updateListener = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$inputHandler = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$focusChangeEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$clipboardInputFilter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$clipboardOutputFilter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$perLineTextDirection = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $7beee9608540d2c3$var$nativeSelectionHidden = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $7beee9608540d2c3$var$scrollHandler = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
class $7beee9608540d2c3$var$ScrollTarget {
    constructor(range, y = "nearest", x = "nearest", yMargin = 5, xMargin = 5, // This data structure is abused to also store precise scroll
    // snapshots, instead of a `scrollIntoView` request. When this
    // flag is `true`, `range` points at a position in the reference
    // line, `yMargin` holds the difference between the top of that
    // line and the top of the editor, and `xMargin` holds the
    // editor's `scrollLeft`.
    isSnapshot = false){
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
        this.isSnapshot = isSnapshot;
    }
    map(changes) {
        return changes.empty ? this : new $7beee9608540d2c3$var$ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
    clip(state) {
        return this.range.to <= state.doc.length ? this : new $7beee9608540d2c3$var$ScrollTarget((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(state.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
}
const $7beee9608540d2c3$var$scrollIntoView = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map: (t, ch)=>t.map(ch)
});
const $7beee9608540d2c3$var$setEditContextFormatting = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function $7beee9608540d2c3$export$f86b2a1a2ce291b3(state, exception, context) {
    let handler = state.facet($7beee9608540d2c3$var$exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror && window.onerror(String(exception), context, undefined, undefined, exception)) ;
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
const $7beee9608540d2c3$var$editable = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : true
});
let $7beee9608540d2c3$var$nextPluginID = 0;
const $7beee9608540d2c3$var$viewPlugin = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (plugins) {
        return plugins.filter((p, i)=>{
            for(let j = 0; j < i; j++)if (plugins[j].plugin == p.plugin) return false;
            return true;
        });
    }
});
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view. They optionally take an argument, in
which case you need to call [`of`](https://codemirror.net/6/docs/ref/#view.ViewPlugin.of) to create
an extension for the plugin. When the argument type is undefined,
you can use the plugin instance as an extension directly.
*/ class $7beee9608540d2c3$export$44d5eccfd62adda7 {
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, /**
    @internal
    */ domEventObservers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.domEventObservers = domEventObservers;
        this.baseExtensions = buildExtensions(this);
        this.extension = this.baseExtensions.concat($7beee9608540d2c3$var$viewPlugin.of({
            plugin: this,
            arg: undefined
        }));
    }
    /**
    Create an extension for this plugin with the given argument.
    */ of(arg) {
        return this.baseExtensions.concat($7beee9608540d2c3$var$viewPlugin.of({
            plugin: this,
            arg: arg
        }));
    }
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        const { eventHandlers: eventHandlers, eventObservers: eventObservers, provide: provide, decorations: deco } = spec || {};
        return new $7beee9608540d2c3$export$44d5eccfd62adda7($7beee9608540d2c3$var$nextPluginID++, create, eventHandlers, eventObservers, (plugin)=>{
            let ext = [];
            if (deco) ext.push($7beee9608540d2c3$var$decorations.of((view)=>{
                let pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : $7beee9608540d2c3$export$10e30b733df217ea.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return $7beee9608540d2c3$export$44d5eccfd62adda7.define((view, arg)=>new cls(view, arg), spec);
    }
}
class $7beee9608540d2c3$var$PluginInstance {
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `null`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
    get plugin() {
        return this.spec && this.spec.plugin;
    }
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.plugin.create(view, this.spec.arg);
            } catch (e) {
                $7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            let update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                $7beee9608540d2c3$export$f86b2a1a2ce291b3(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
}
const $7beee9608540d2c3$var$editorAttributes = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$contentAttributes = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
// Provide decorations
const $7beee9608540d2c3$var$decorations = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$blockWrappers = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$outerDecorations = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$atomicRanges = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$bidiIsolatedRanges = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
function $7beee9608540d2c3$var$getIsolatedRanges(view, line) {
    let isolates = view.state.facet($7beee9608540d2c3$var$bidiIsolatedRanges);
    if (!isolates.length) return isolates;
    let sets = isolates.map((i)=>i instanceof Function ? i(view) : i);
    let result = [];
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(sets, line.from, line.to, {
        point () {},
        span (fromDoc, toDoc, active, open) {
            let from = fromDoc - line.from, to = toDoc - line.from;
            let level = result;
            for(let i = active.length - 1; i >= 0; i--, open--){
                let direction = active[i].spec.bidiIsolate, update;
                if (direction == null) direction = $7beee9608540d2c3$var$autoDirection(line.text, from, to);
                if (open > 0 && level.length && (update = level[level.length - 1]).to == from && update.direction == direction) {
                    update.to = to;
                    level = update.inner;
                } else {
                    let add = {
                        from: from,
                        to: to,
                        direction: direction,
                        inner: []
                    };
                    level.push(add);
                    level = add.inner;
                }
            }
        }
    });
    return result;
}
const $7beee9608540d2c3$var$scrollMargins = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
function $7beee9608540d2c3$var$getScrollMargins(view) {
    let left = 0, right = 0, top = 0, bottom = 0;
    for (let source of view.state.facet($7beee9608540d2c3$var$scrollMargins)){
        let m = source(view);
        if (m) {
            if (m.left != null) left = Math.max(left, m.left);
            if (m.right != null) right = Math.max(right, m.right);
            if (m.top != null) top = Math.max(top, m.top);
            if (m.bottom != null) bottom = Math.max(bottom, m.bottom);
        }
    }
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
    };
}
const $7beee9608540d2c3$var$styleModule = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
class $7beee9608540d2c3$var$ChangedRange {
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
    join(other) {
        return new $7beee9608540d2c3$var$ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        let i = set.length, me = this;
        for(; i > 0; i--){
            let range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    // Extend a set to cover all the content in `ranges`, which is a
    // flat array with each pair of numbers representing fromB/toB
    // positions. These pairs are generated in unchanged ranges, so the
    // offset between doc A and doc B is the same for their start and
    // end points.
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        let result = [];
        for(let dI = 0, rI = 0, off = 0;;){
            let nextD = dI < diff.length ? diff[dI].fromB : 1e9;
            let nextR = rI < ranges.length ? ranges[rI] : 1e9;
            let fromB = Math.min(nextD, nextR);
            if (fromB == 1e9) break;
            let fromA = fromB + off, toB = fromB, toA = fromA;
            for(;;){
                if (rI < ranges.length && ranges[rI] <= toB) {
                    let end = ranges[rI + 1];
                    rI += 2;
                    toB = Math.max(toB, end);
                    for(let i = dI; i < diff.length && diff[i].fromB <= toB; i++)off = diff[i].toA - diff[i].toB;
                    toA = Math.max(toA, end + off);
                } else if (dI < diff.length && diff[dI].fromB <= toB) {
                    let next = diff[dI++];
                    toB = Math.max(toB, next.toB);
                    toA = Math.max(toA, next.toA);
                    off = next.toA - next.toB;
                } else break;
            }
            result.push(new $7beee9608540d2c3$var$ChangedRange(fromA, toA, fromB, toB));
        }
        return result;
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class $7beee9608540d2c3$export$b5b084f95c87edf7 {
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, $6295c6875f57e3ee$export$29d7fbdcb1f8b71c).empty(this.startState.doc.length);
        for (let tr of transactions)this.changes = this.changes.compose(tr.changes);
        let changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new $7beee9608540d2c3$var$ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
    }
    /**
    @internal
    */ static create(view, state, transactions) {
        return new $7beee9608540d2c3$export$b5b084f95c87edf7(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* UpdateFlag.Viewport */ ) > 0;
    }
    /**
    Returns true when
    [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
    and the viewport change is not just the result of mapping it in
    response to document changes.
    */ get viewportMoved() {
        return (this.flags & 8 /* UpdateFlag.ViewportMoved */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 18 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* UpdateFlag.Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
}
const $7beee9608540d2c3$var$noChildren = [];
class $7beee9608540d2c3$var$Tile {
    constructor(dom, length, flags = 0){
        this.dom = dom;
        this.length = length;
        this.flags = flags;
        this.parent = null;
        dom.cmTile = this;
    }
    get breakAfter() {
        return this.flags & 1 /* TileFlag.BreakAfter */ ;
    }
    get children() {
        return $7beee9608540d2c3$var$noChildren;
    }
    isWidget() {
        return false;
    }
    get isHidden() {
        return false;
    }
    isComposite() {
        return false;
    }
    isLine() {
        return false;
    }
    isText() {
        return false;
    }
    isBlock() {
        return false;
    }
    get domAttrs() {
        return null;
    }
    sync(track) {
        this.flags |= 2 /* TileFlag.Synced */ ;
        if (this.flags & 4 /* TileFlag.AttrsDirty */ ) {
            this.flags &= -5 /* TileFlag.AttrsDirty */ ;
            let attrs = this.domAttrs;
            if (attrs) $7beee9608540d2c3$var$setAttrs(this.dom, attrs);
        }
    }
    toString() {
        return this.constructor.name + (this.children.length ? `(${this.children})` : "") + (this.breakAfter ? "#" : "");
    }
    destroy() {
        this.parent = null;
    }
    setDOM(dom) {
        this.dom = dom;
        dom.cmTile = this;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(tile, start = this.posAtStart) {
        let pos = start;
        for (let child of this.children){
            if (child == tile) return pos;
            pos += child.length + child.breakAfter;
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(tile) {
        return this.posBefore(tile) + tile.length;
    }
    covers(side) {
        return true;
    }
    coordsIn(pos, side) {
        return null;
    }
    domPosFor(off, side) {
        let index = $7beee9608540d2c3$var$domIndex(this.dom);
        let after = this.length ? off > 0 : side > 0;
        return new $7beee9608540d2c3$var$DOMPos(this.parent.dom, index + (after ? 1 : 0), off == 0 || off == this.length);
    }
    markDirty(attrs) {
        this.flags &= -3 /* TileFlag.Synced */ ;
        if (attrs) this.flags |= 4 /* TileFlag.AttrsDirty */ ;
        if (this.parent && this.parent.flags & 2 /* TileFlag.Synced */ ) this.parent.markDirty(false);
    }
    get overrideDOMText() {
        return null;
    }
    get root() {
        for(let t = this; t; t = t.parent)if (t instanceof $7beee9608540d2c3$var$DocTile) return t;
        return null;
    }
    static get(dom) {
        return dom.cmTile;
    }
}
class $7beee9608540d2c3$var$CompositeTile extends $7beee9608540d2c3$var$Tile {
    constructor(dom){
        super(dom, 0);
        this._children = [];
    }
    isComposite() {
        return true;
    }
    get children() {
        return this._children;
    }
    get lastChild() {
        return this.children.length ? this.children[this.children.length - 1] : null;
    }
    append(child) {
        this.children.push(child);
        child.parent = this;
    }
    sync(track) {
        if (this.flags & 2 /* TileFlag.Synced */ ) return;
        super.sync(track);
        let parent = this.dom, prev = null, next;
        let tracking = (track === null || track === void 0 ? void 0 : track.node) == parent ? track : null;
        let length = 0;
        for (let child of this.children){
            child.sync(track);
            length += child.length + child.breakAfter;
            next = prev ? prev.nextSibling : parent.firstChild;
            if (tracking && next != child.dom) tracking.written = true;
            if (child.dom.parentNode == parent) while(next && next != child.dom)next = $7beee9608540d2c3$var$rm$1(next);
            else parent.insertBefore(child.dom, next);
            prev = child.dom;
        }
        next = prev ? prev.nextSibling : parent.firstChild;
        if (tracking && next) tracking.written = true;
        while(next)next = $7beee9608540d2c3$var$rm$1(next);
        this.length = length;
    }
}
// Remove a DOM node and return its next sibling.
function $7beee9608540d2c3$var$rm$1(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// The top-level tile. Its dom property equals view.contentDOM.
class $7beee9608540d2c3$var$DocTile extends $7beee9608540d2c3$var$CompositeTile {
    constructor(view, dom){
        super(dom);
        this.view = view;
    }
    owns(tile) {
        for(; tile; tile = tile.parent)if (tile == this) return true;
        return false;
    }
    isBlock() {
        return true;
    }
    nearest(dom) {
        for(;;){
            if (!dom) return null;
            let tile = $7beee9608540d2c3$var$Tile.get(dom);
            if (tile && this.owns(tile)) return tile;
            dom = dom.parentNode;
        }
    }
    blockTiles(f) {
        for(let stack = [], cur = this, i = 0, pos = 0;;)if (i == cur.children.length) {
            if (!stack.length) return;
            cur = cur.parent;
            if (cur.breakAfter) pos++;
            i = stack.pop();
        } else {
            let next = cur.children[i++];
            if (next instanceof $7beee9608540d2c3$var$BlockWrapperTile) {
                stack.push(i);
                cur = next;
                i = 0;
            } else {
                let end = pos + next.length;
                let result = f(next, pos);
                if (result !== undefined) return result;
                pos = end + next.breakAfter;
            }
        }
    }
    // Find the block at the given position. If side < -1, make sure to
    // stay before block widgets at that position, if side > 1, after
    // such widgets (used for selection drawing, which needs to be able
    // to get coordinates for positions that aren't valid cursor positions).
    resolveBlock(pos, side) {
        let before, beforeOff = -1, after, afterOff = -1;
        this.blockTiles((tile, off)=>{
            let end = off + tile.length;
            if (pos >= off && pos <= end) {
                if (tile.isWidget() && side >= -1 && side <= 1) {
                    if (tile.flags & 32 /* TileFlag.After */ ) return true;
                    if (tile.flags & 16 /* TileFlag.Before */ ) before = undefined;
                }
                if ((off < pos || pos == end && (side < -1 ? tile.length : tile.covers(1))) && (!before || !tile.isWidget() && before.isWidget())) {
                    before = tile;
                    beforeOff = pos - off;
                }
                if ((end > pos || pos == off && (side > 1 ? tile.length : tile.covers(-1))) && (!after || !tile.isWidget() && after.isWidget())) {
                    after = tile;
                    afterOff = pos - off;
                }
            }
        });
        if (!before && !after) throw new Error("No tile at position " + pos);
        return before && side < 0 || !after ? {
            tile: before,
            offset: beforeOff
        } : {
            tile: after,
            offset: afterOff
        };
    }
}
class $7beee9608540d2c3$var$BlockWrapperTile extends $7beee9608540d2c3$var$CompositeTile {
    constructor(dom, wrapper){
        super(dom);
        this.wrapper = wrapper;
    }
    isBlock() {
        return true;
    }
    covers(side) {
        if (!this.children.length) return false;
        return side < 0 ? this.children[0].covers(-1) : this.lastChild.covers(1);
    }
    get domAttrs() {
        return this.wrapper.attributes;
    }
    static of(wrapper, dom) {
        let tile = new $7beee9608540d2c3$var$BlockWrapperTile(dom || document.createElement(wrapper.tagName), wrapper);
        if (!dom) tile.flags |= 4 /* TileFlag.AttrsDirty */ ;
        return tile;
    }
}
class $7beee9608540d2c3$var$LineTile extends $7beee9608540d2c3$var$CompositeTile {
    constructor(dom, attrs){
        super(dom);
        this.attrs = attrs;
    }
    isLine() {
        return true;
    }
    static start(attrs, dom, keepAttrs) {
        let line = new $7beee9608540d2c3$var$LineTile(dom || document.createElement("div"), attrs);
        if (!dom || !keepAttrs) line.flags |= 4 /* TileFlag.AttrsDirty */ ;
        return line;
    }
    get domAttrs() {
        return this.attrs;
    }
    // Find the tile associated with a given position in this line.
    resolveInline(pos, side, forCoords) {
        let before = null, beforeOff = -1, after = null, afterOff = -1;
        function scan(tile, pos) {
            for(let i = 0, off = 0; i < tile.children.length && off <= pos; i++){
                let child = tile.children[i], end = off + child.length;
                if (end >= pos) {
                    if (child.isComposite()) scan(child, pos - off);
                    else if ((!after || after.isHidden && (side > 0 || forCoords && $7beee9608540d2c3$var$onSameLine(after, child))) && (end > pos || child.flags & 32 /* TileFlag.After */ )) {
                        after = child;
                        afterOff = pos - off;
                    } else if (off < pos || child.flags & 16 /* TileFlag.Before */  && !child.isHidden) {
                        before = child;
                        beforeOff = pos - off;
                    }
                }
                off = end;
            }
        }
        scan(this, pos);
        let target = (side < 0 ? before : after) || before || after;
        return target ? {
            tile: target,
            offset: target == before ? beforeOff : afterOff
        } : null;
    }
    coordsIn(pos, side) {
        let found = this.resolveInline(pos, side, true);
        if (!found) return $7beee9608540d2c3$var$fallbackRect(this);
        return found.tile.coordsIn(Math.max(0, found.offset), side);
    }
    domIn(pos, side) {
        let found = this.resolveInline(pos, side);
        if (found) {
            let { tile: tile, offset: offset } = found;
            if (this.dom.contains(tile.dom)) {
                if (tile.isText()) return new $7beee9608540d2c3$var$DOMPos(tile.dom, Math.min(tile.dom.nodeValue.length, offset));
                return tile.domPosFor(offset, side);
            }
            let parent = found.tile.parent, saw = false;
            for (let ch of parent.children){
                if (saw) return new $7beee9608540d2c3$var$DOMPos(ch.dom, 0);
                if (ch == found.tile) saw = true;
            }
        }
        return new $7beee9608540d2c3$var$DOMPos(this.dom, 0);
    }
}
function $7beee9608540d2c3$var$fallbackRect(tile) {
    let last = tile.dom.lastChild;
    if (!last) return tile.dom.getBoundingClientRect();
    let rects = $7beee9608540d2c3$var$clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function $7beee9608540d2c3$var$onSameLine(a, b) {
    let posA = a.coordsIn(0, 1), posB = b.coordsIn(0, 1);
    return posA && posB && posB.top < posA.bottom;
}
class $7beee9608540d2c3$var$MarkTile extends $7beee9608540d2c3$var$CompositeTile {
    constructor(dom, mark){
        super(dom);
        this.mark = mark;
    }
    get domAttrs() {
        return this.mark.attrs;
    }
    static of(mark, dom) {
        let tile = new $7beee9608540d2c3$var$MarkTile(dom || document.createElement(mark.tagName), mark);
        if (!dom) tile.flags |= 4 /* TileFlag.AttrsDirty */ ;
        return tile;
    }
}
class $7beee9608540d2c3$var$TextTile extends $7beee9608540d2c3$var$Tile {
    constructor(dom, text){
        super(dom, text.length);
        this.text = text;
    }
    sync(track) {
        if (this.flags & 2 /* TileFlag.Synced */ ) return;
        super.sync(track);
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    isText() {
        return true;
    }
    toString() {
        return JSON.stringify(this.text);
    }
    coordsIn(pos, side) {
        let length = this.dom.nodeValue.length;
        if (pos > length) pos = length;
        let from = pos, to = pos, flatten = 0;
        if (pos == 0 && side < 0 || pos == length && side >= 0) {
            if (!($7beee9608540d2c3$var$browser.chrome || $7beee9608540d2c3$var$browser.gecko)) {
                if (pos) {
                    from--;
                    flatten = 1;
                } else if (to < length) {
                    to++;
                    flatten = -1;
                }
            }
        } else {
            if (side < 0) from--;
            else if (to < length) to++;
        }
        let rects = $7beee9608540d2c3$var$textRange(this.dom, from, to).getClientRects();
        if (!rects.length) return null;
        let rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
        if ($7beee9608540d2c3$var$browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
        return flatten ? $7beee9608540d2c3$var$flattenRect(rect, flatten < 0) : rect || null;
    }
    static of(text, dom) {
        let tile = new $7beee9608540d2c3$var$TextTile(dom || document.createTextNode(text), text);
        if (!dom) tile.flags |= 2 /* TileFlag.Synced */ ;
        return tile;
    }
}
class $7beee9608540d2c3$var$WidgetTile extends $7beee9608540d2c3$var$Tile {
    constructor(dom, length, widget, flags){
        super(dom, length, flags);
        this.widget = widget;
    }
    isWidget() {
        return true;
    }
    get isHidden() {
        return this.widget.isHidden;
    }
    covers(side) {
        if (this.flags & 48 /* TileFlag.PointWidget */ ) return false;
        return (this.flags & (side < 0 ? 64 /* TileFlag.IncStart */  : 128 /* TileFlag.IncEnd */ )) > 0;
    }
    coordsIn(pos, side) {
        return this.coordsInWidget(pos, side, false);
    }
    coordsInWidget(pos, side, block) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        if (block) return $7beee9608540d2c3$var$flattenRect(this.dom.getBoundingClientRect(), this.length ? pos == 0 : side <= 0);
        else {
            let rects = this.dom.getClientRects(), rect = null;
            if (!rects.length) return null;
            let fromBack = this.flags & 16 /* TileFlag.Before */  ? true : this.flags & 32 /* TileFlag.After */  ? false : pos > 0;
            for(let i = fromBack ? rects.length - 1 : 0;; i += fromBack ? -1 : 1){
                rect = rects[i];
                if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
            }
            return $7beee9608540d2c3$var$flattenRect(rect, !fromBack);
        }
    }
    get overrideDOMText() {
        if (!this.length) return (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
        let { root: root } = this;
        if (!root) return (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
        let start = this.posAtStart;
        return root.view.state.doc.slice(start, start + this.length);
    }
    destroy() {
        super.destroy();
        this.widget.destroy(this.dom);
    }
    static of(widget, view, length, flags, dom) {
        if (!dom) {
            dom = widget.toDOM(view);
            if (!widget.editable) dom.contentEditable = "false";
        }
        return new $7beee9608540d2c3$var$WidgetTile(dom, length, widget, flags);
    }
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class $7beee9608540d2c3$var$WidgetBufferTile extends $7beee9608540d2c3$var$Tile {
    constructor(flags){
        let img = document.createElement("img");
        img.className = "cm-widgetBuffer";
        img.setAttribute("aria-hidden", "true");
        super(img, 0, flags);
    }
    get isHidden() {
        return false;
    }
    get overrideDOMText() {
        return (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
    }
    coordsIn(pos) {
        return this.dom.getBoundingClientRect();
    }
}
// Represents a position in the tile tree.
class $7beee9608540d2c3$var$TilePointer {
    constructor(top){
        this.index = 0;
        this.beforeBreak = false;
        this.parents = [];
        this.tile = top;
    }
    // Advance by the given distance. If side is -1, stop leaving or
    // entering tiles, or skipping zero-length tiles, once the distance
    // has been traversed. When side is 1, leave, enter, or skip
    // everything at the end position.
    advance(dist, side, walker) {
        let { tile: tile, index: index, beforeBreak: beforeBreak, parents: parents } = this;
        while(dist || side > 0){
            if (!tile.isComposite()) {
                if (index == tile.length) {
                    beforeBreak = !!tile.breakAfter;
                    ({ tile: tile, index: index } = parents.pop());
                    index++;
                } else if (!dist) break;
                else {
                    let take = Math.min(dist, tile.length - index);
                    if (walker) walker.skip(tile, index, index + take);
                    dist -= take;
                    index += take;
                }
            } else if (beforeBreak) {
                if (!dist) break;
                if (walker) walker.break();
                dist--;
                beforeBreak = false;
            } else if (index == tile.children.length) {
                if (!dist && !parents.length) break;
                if (walker) walker.leave(tile);
                beforeBreak = !!tile.breakAfter;
                ({ tile: tile, index: index } = parents.pop());
                index++;
            } else {
                let next = tile.children[index], brk = next.breakAfter;
                if ((side > 0 ? next.length <= dist : next.length < dist) && (!walker || walker.skip(next, 0, next.length) !== false || !next.isComposite)) {
                    beforeBreak = !!brk;
                    index++;
                    dist -= next.length;
                } else {
                    parents.push({
                        tile: tile,
                        index: index
                    });
                    tile = next;
                    index = 0;
                    if (walker && next.isComposite()) walker.enter(next);
                }
            }
        }
        this.tile = tile;
        this.index = index;
        this.beforeBreak = beforeBreak;
        return this;
    }
    get root() {
        return this.parents.length ? this.parents[0].tile : this.tile;
    }
}
// Used to track open block wrappers
class $7beee9608540d2c3$var$OpenWrapper {
    constructor(from, to, wrapper, rank){
        this.from = from;
        this.to = to;
        this.wrapper = wrapper;
        this.rank = rank;
    }
}
// This class builds up a new document tile using input from either
// iteration over the old tree or iteration over the document +
// decorations. The add* methods emit elements into the tile
// structure. To avoid awkward synchronization issues, marks and block
// wrappers are treated as belonging to to their content, rather than
// opened/closed independently.
//
// All composite tiles that are touched by changes are rebuilt,
// reusing as much of the old tree (either whole nodes or just DOM
// elements) as possible. The new tree is built without the Synced
// flag, and then synced (during which DOM parent/child relations are
// fixed up, text nodes filled in, and attributes added) in a second
// phase.
class $7beee9608540d2c3$var$TileBuilder {
    constructor(cache, root, blockWrappers){
        this.cache = cache;
        this.root = root;
        this.blockWrappers = blockWrappers;
        this.curLine = null;
        this.lastBlock = null;
        this.afterWidget = null;
        this.pos = 0;
        this.wrappers = [];
        this.wrapperPos = 0;
    }
    addText(text, marks, openStart, tile) {
        var _a;
        this.flushBuffer();
        let parent = this.ensureMarks(marks, openStart);
        let prev = parent.lastChild;
        if (prev && prev.isText() && !(prev.flags & 8 /* TileFlag.Composition */ )) {
            this.cache.reused.set(prev, 2 /* Reused.DOM */ );
            let tile = parent.children[parent.children.length - 1] = new $7beee9608540d2c3$var$TextTile(prev.dom, prev.text + text);
            tile.parent = parent;
        } else parent.append(tile || $7beee9608540d2c3$var$TextTile.of(text, (_a = this.cache.find($7beee9608540d2c3$var$TextTile)) === null || _a === void 0 ? void 0 : _a.dom));
        this.pos += text.length;
        this.afterWidget = null;
    }
    addComposition(composition, context) {
        let line = this.curLine;
        if (line.dom != context.line.dom) {
            line.setDOM(this.cache.reused.has(context.line) ? $7beee9608540d2c3$var$freeNode(context.line.dom) : context.line.dom);
            this.cache.reused.set(context.line, 2 /* Reused.DOM */ );
        }
        let head = line;
        for(let i = context.marks.length - 1; i >= 0; i--){
            let mark = context.marks[i];
            let last = head.lastChild;
            if (last instanceof $7beee9608540d2c3$var$MarkTile && last.mark.eq(mark.mark)) {
                if (last.dom != mark.dom) last.setDOM($7beee9608540d2c3$var$freeNode(mark.dom));
                head = last;
            } else {
                if (this.cache.reused.get(mark)) {
                    let tile = $7beee9608540d2c3$var$Tile.get(mark.dom);
                    if (tile) tile.setDOM($7beee9608540d2c3$var$freeNode(mark.dom));
                }
                let nw = $7beee9608540d2c3$var$MarkTile.of(mark.mark, mark.dom);
                head.append(nw);
                head = nw;
            }
            this.cache.reused.set(mark, 2 /* Reused.DOM */ );
        }
        let text = new $7beee9608540d2c3$var$TextTile(composition.text, composition.text.nodeValue);
        text.flags |= 8 /* TileFlag.Composition */ ;
        head.append(text);
    }
    addInlineWidget(widget, marks, openStart) {
        // Adjacent same-side-facing non-replacing widgets don't need buffers between them
        let noSpace = this.afterWidget && widget.flags & 48 /* TileFlag.PointWidget */  && (this.afterWidget.flags & 48 /* TileFlag.PointWidget */ ) == (widget.flags & 48 /* TileFlag.PointWidget */ );
        if (!noSpace) this.flushBuffer();
        let parent = this.ensureMarks(marks, openStart);
        if (!noSpace && !(widget.flags & 16 /* TileFlag.Before */ )) parent.append(this.getBuffer(1));
        parent.append(widget);
        this.pos += widget.length;
        this.afterWidget = widget;
    }
    addMark(tile, marks, openStart) {
        this.flushBuffer();
        let parent = this.ensureMarks(marks, openStart);
        parent.append(tile);
        this.pos += tile.length;
        this.afterWidget = null;
    }
    addBlockWidget(widget) {
        this.getBlockPos().append(widget);
        this.pos += widget.length;
        this.lastBlock = widget;
        this.endLine();
    }
    continueWidget(length) {
        let widget = this.afterWidget || this.lastBlock;
        widget.length += length;
        this.pos += length;
    }
    addLineStart(attrs, dom) {
        var _a;
        if (!attrs) attrs = $7beee9608540d2c3$var$lineBaseAttrs;
        let tile = $7beee9608540d2c3$var$LineTile.start(attrs, dom || ((_a = this.cache.find($7beee9608540d2c3$var$LineTile)) === null || _a === void 0 ? void 0 : _a.dom), !!dom);
        this.getBlockPos().append(this.lastBlock = this.curLine = tile);
    }
    addLine(tile) {
        this.getBlockPos().append(tile);
        this.pos += tile.length;
        this.lastBlock = tile;
        this.endLine();
    }
    addBreak() {
        this.lastBlock.flags |= 1 /* TileFlag.BreakAfter */ ;
        this.endLine();
        this.pos++;
    }
    addLineStartIfNotCovered(attrs) {
        if (!this.blockPosCovered()) this.addLineStart(attrs);
    }
    ensureLine(attrs) {
        if (!this.curLine) this.addLineStart(attrs);
    }
    ensureMarks(marks, openStart) {
        var _a;
        let parent = this.curLine;
        for(let i = marks.length - 1; i >= 0; i--){
            let mark = marks[i], last;
            if (openStart > 0 && (last = parent.lastChild) && last instanceof $7beee9608540d2c3$var$MarkTile && last.mark.eq(mark)) {
                parent = last;
                openStart--;
            } else {
                let tile = $7beee9608540d2c3$var$MarkTile.of(mark, (_a = this.cache.find($7beee9608540d2c3$var$MarkTile, (m)=>m.mark.eq(mark))) === null || _a === void 0 ? void 0 : _a.dom);
                parent.append(tile);
                parent = tile;
                openStart = 0;
            }
        }
        return parent;
    }
    endLine() {
        if (this.curLine) {
            this.flushBuffer();
            let last = this.curLine.lastChild;
            if (!last || !$7beee9608540d2c3$var$hasContent(this.curLine, false) || last.dom.nodeName != "BR" && last.isWidget() && !($7beee9608540d2c3$var$browser.ios && $7beee9608540d2c3$var$hasContent(this.curLine, true))) this.curLine.append(this.cache.findWidget($7beee9608540d2c3$var$BreakWidget, 0, 32 /* TileFlag.After */ ) || new $7beee9608540d2c3$var$WidgetTile($7beee9608540d2c3$var$BreakWidget.toDOM(), 0, $7beee9608540d2c3$var$BreakWidget, 32 /* TileFlag.After */ ));
            this.curLine = this.afterWidget = null;
        }
    }
    updateBlockWrappers() {
        if (this.wrapperPos > this.pos + 10000 /* C.WrapperReset */ ) {
            this.blockWrappers.goto(this.pos);
            this.wrappers.length = 0;
        }
        for(let i = this.wrappers.length - 1; i >= 0; i--)if (this.wrappers[i].to < this.pos) this.wrappers.splice(i, 1);
        for(let cur = this.blockWrappers; cur.value && cur.from <= this.pos; cur.next())if (cur.to >= this.pos) {
            let wrap = new $7beee9608540d2c3$var$OpenWrapper(cur.from, cur.to, cur.value, cur.rank), i = this.wrappers.length;
            while(i > 0 && (this.wrappers[i - 1].rank - wrap.rank || this.wrappers[i - 1].to - wrap.to) < 0)i--;
            this.wrappers.splice(i, 0, wrap);
        }
        this.wrapperPos = this.pos;
    }
    getBlockPos() {
        var _a;
        this.updateBlockWrappers();
        let parent = this.root;
        for (let wrap of this.wrappers){
            let last = parent.lastChild;
            if (wrap.from < this.pos && last instanceof $7beee9608540d2c3$var$BlockWrapperTile && last.wrapper.eq(wrap.wrapper)) parent = last;
            else {
                let tile = $7beee9608540d2c3$var$BlockWrapperTile.of(wrap.wrapper, (_a = this.cache.find($7beee9608540d2c3$var$BlockWrapperTile, (t)=>t.wrapper.eq(wrap.wrapper))) === null || _a === void 0 ? void 0 : _a.dom);
                parent.append(tile);
                parent = tile;
            }
        }
        return parent;
    }
    blockPosCovered() {
        let last = this.lastBlock;
        return last != null && !last.breakAfter && (!last.isWidget() || (last.flags & 160 /* TileFlag.IncEnd */ ) > 0);
    }
    getBuffer(side) {
        let flags = 2 /* TileFlag.Synced */  | (side < 0 ? 16 /* TileFlag.Before */  : 32 /* TileFlag.After */ );
        let found = this.cache.find($7beee9608540d2c3$var$WidgetBufferTile, undefined, 1 /* Reused.Full */ );
        if (found) found.flags = flags;
        return found || new $7beee9608540d2c3$var$WidgetBufferTile(flags);
    }
    flushBuffer() {
        if (this.afterWidget && !(this.afterWidget.flags & 32 /* TileFlag.After */ )) {
            this.afterWidget.parent.append(this.getBuffer(-1));
            this.afterWidget = null;
        }
    }
}
// Helps getting efficient access to the document text.
class $7beee9608540d2c3$var$TextStream {
    constructor(doc){
        this.skipCount = 0;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
    }
    skip(len) {
        // Advance the iterator past the replaced content
        if (this.textOff + len <= this.text.length) this.textOff += len;
        else {
            this.skipCount += len - (this.text.length - this.textOff);
            this.text = "";
            this.textOff = 0;
        }
    }
    next(maxLen) {
        if (this.textOff == this.text.length) {
            let { value: value, lineBreak: lineBreak, done: done } = this.cursor.next(this.skipCount);
            this.skipCount = 0;
            if (done) throw new Error("Ran out of text content when drawing inline views");
            this.text = value;
            let len = this.textOff = Math.min(maxLen, value.length);
            return lineBreak ? null : value.slice(0, len);
        }
        let end = Math.min(this.text.length, this.textOff + maxLen);
        let chars = this.text.slice(this.textOff, end);
        this.textOff = end;
        return chars;
    }
}
// Assign the tile classes bucket numbers for caching.
const $7beee9608540d2c3$var$buckets = [
    $7beee9608540d2c3$var$WidgetTile,
    $7beee9608540d2c3$var$LineTile,
    $7beee9608540d2c3$var$TextTile,
    $7beee9608540d2c3$var$MarkTile,
    $7beee9608540d2c3$var$WidgetBufferTile,
    $7beee9608540d2c3$var$BlockWrapperTile,
    $7beee9608540d2c3$var$DocTile
];
for(let i = 0; i < $7beee9608540d2c3$var$buckets.length; i++)$7beee9608540d2c3$var$buckets[i].bucket = i;
// Leaf tiles and line tiles may be reused in their entirety. All
// others will get new tiles allocated, using the old DOM when
// possible.
class $7beee9608540d2c3$var$TileCache {
    constructor(view){
        this.view = view;
        // Buckets are circular buffers, using `index` as the current
        // position.
        this.buckets = $7beee9608540d2c3$var$buckets.map(()=>[]);
        this.index = $7beee9608540d2c3$var$buckets.map(()=>0);
        this.reused = new Map;
    }
    // Put a tile in the cache.
    add(tile) {
        let i = tile.constructor.bucket, bucket = this.buckets[i];
        if (bucket.length < 6 /* C.Bucket */ ) bucket.push(tile);
        else bucket[this.index[i] = (this.index[i] + 1) % 6 /* C.Bucket */ ] = tile;
    }
    find(cls, test, type = 2 /* Reused.DOM */ ) {
        let i = cls.bucket;
        let bucket = this.buckets[i], off = this.index[i];
        for(let j = bucket.length - 1; j >= 0; j--){
            // Look at the most recently added items first (last-in, first-out)
            let index = (j + off) % bucket.length, tile = bucket[index];
            if ((!test || test(tile)) && !this.reused.has(tile)) {
                bucket.splice(index, 1);
                if (index < off) this.index[i]--;
                this.reused.set(tile, type);
                return tile;
            }
        }
        return null;
    }
    findWidget(widget, length, flags) {
        let widgets = this.buckets[0];
        if (widgets.length) for(let i = 0, pass = 0;; i++){
            if (i == widgets.length) {
                if (pass) return null;
                pass = 1;
                i = 0;
            }
            let tile = widgets[i];
            if (!this.reused.has(tile) && (pass == 0 ? tile.widget.compare(widget) : tile.widget.constructor == widget.constructor && widget.updateDOM(tile.dom, this.view))) {
                widgets.splice(i, 1);
                if (i < this.index[0]) this.index[0]--;
                this.reused.set(tile, 1 /* Reused.Full */ );
                tile.length = length;
                tile.flags = tile.flags & -498 | flags;
                return tile;
            }
        }
    }
    reuse(tile) {
        this.reused.set(tile, 1 /* Reused.Full */ );
        return tile;
    }
    maybeReuse(tile, type = 2 /* Reused.DOM */ ) {
        if (this.reused.has(tile)) return undefined;
        this.reused.set(tile, type);
        return tile.dom;
    }
}
// This class organizes a pass over the document, guided by the array
// of replaced ranges. For ranges that haven't changed, it iterates
// the old tree and copies its content into the new document. For
// changed ranges, it runs a decoration iterator to guide generation
// of content.
class $7beee9608540d2c3$var$TileUpdate {
    constructor(view, old, blockWrappers, decorations, disallowBlockEffectsFor){
        this.view = view;
        this.decorations = decorations;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.openWidget = false;
        this.openMarks = 0;
        this.cache = new $7beee9608540d2c3$var$TileCache(view);
        this.text = new $7beee9608540d2c3$var$TextStream(view.state.doc);
        this.builder = new $7beee9608540d2c3$var$TileBuilder(this.cache, new $7beee9608540d2c3$var$DocTile(view, view.contentDOM), (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter(blockWrappers));
        this.cache.reused.set(old, 2 /* Reused.DOM */ );
        this.old = new $7beee9608540d2c3$var$TilePointer(old);
    }
    run(changes, composition) {
        let compositionContext = composition && this.getCompositionContext(composition.text);
        for(let posA = 0, posB = 0, i = 0;;){
            let next = i < changes.length ? changes[i++] : null;
            let skipA = next ? next.fromA : this.old.root.length;
            if (skipA > posA) {
                let len = skipA - posA;
                this.preserve(len, !i, !next);
                posA = skipA;
                posB += len;
            }
            if (!next) break;
            this.forward(next.fromA, next.toA);
            // Compositions need to be handled specially, forcing the
            // focused text node and its parent nodes to remain stable at
            // that point in the document.
            if (composition && next.fromA <= composition.range.fromA && next.toA >= composition.range.toA) {
                this.emit(posB, composition.range.fromB);
                this.builder.addComposition(composition, compositionContext);
                this.emit(composition.range.toB, next.toB);
            } else this.emit(posB, next.toB);
            posB = next.toB;
            posA = next.toA;
        }
        if (this.builder.curLine) this.builder.endLine();
        return this.builder.root;
    }
    preserve(length, incStart, incEnd) {
        let activeMarks = $7beee9608540d2c3$var$getMarks(this.old), openMarks = this.openMarks;
        this.old.advance(length, incEnd ? 1 : -1, {
            skip: (tile, from, to)=>{
                if (tile.isWidget()) {
                    if (this.openWidget) this.builder.continueWidget(to - from);
                    else {
                        let widget = to > 0 || from < tile.length ? $7beee9608540d2c3$var$WidgetTile.of(tile.widget, this.view, to - from, tile.flags & 496 /* TileFlag.Widget */ , this.cache.maybeReuse(tile)) : this.cache.reuse(tile);
                        if (widget.flags & 256 /* TileFlag.Block */ ) {
                            widget.flags &= -2 /* TileFlag.BreakAfter */ ;
                            this.builder.addBlockWidget(widget);
                        } else {
                            this.builder.addInlineWidget(widget, activeMarks, openMarks);
                            openMarks = activeMarks.length;
                        }
                    }
                } else if (tile.isText()) {
                    if (!from && to == tile.length) this.builder.addText(tile.text, activeMarks, openMarks, this.cache.reuse(tile));
                    else {
                        this.cache.add(tile);
                        this.builder.addText(tile.text.slice(from, to), activeMarks, openMarks);
                    }
                    openMarks = activeMarks.length;
                } else if (tile.isLine()) {
                    tile.flags &= -2 /* TileFlag.BreakAfter */ ;
                    this.cache.reused.set(tile, 1 /* Reused.Full */ );
                    this.builder.addLine(tile);
                } else if (tile instanceof $7beee9608540d2c3$var$WidgetBufferTile) this.cache.add(tile);
                else if (tile instanceof $7beee9608540d2c3$var$MarkTile) {
                    this.builder.addMark(tile, activeMarks, openMarks);
                    this.cache.reused.set(tile, 1 /* Reused.Full */ );
                } else return false;
                this.openWidget = false;
            },
            enter: (tile)=>{
                if (tile.isLine()) this.builder.addLineStart(tile.attrs, this.cache.maybeReuse(tile));
                else {
                    this.cache.add(tile);
                    if (tile instanceof $7beee9608540d2c3$var$MarkTile) {
                        activeMarks.unshift(tile.mark);
                        openMarks++;
                    }
                }
                this.openWidget = false;
            },
            leave: (tile)=>{
                if (tile.isLine()) {
                    if (activeMarks.length) activeMarks.length = openMarks = 0;
                } else if (tile instanceof $7beee9608540d2c3$var$MarkTile) {
                    activeMarks.shift();
                    openMarks = Math.min(openMarks, activeMarks.length);
                }
            },
            break: ()=>{
                this.builder.addBreak();
                this.openWidget = false;
            }
        });
        this.text.skip(length);
    }
    emit(from, to) {
        let pendingLineAttrs = null;
        let b = this.builder, markCount = 0;
        let openEnd = (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(this.decorations, from, to, {
            point: (from, to, deco, active, openStart, index)=>{
                if (deco instanceof $7beee9608540d2c3$var$PointDecoration) {
                    if (this.disallowBlockEffectsFor[index]) {
                        if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
                        if (to > this.view.state.doc.lineAt(from).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
                    }
                    markCount = active.length;
                    if (openStart > active.length) b.continueWidget(to - from);
                    else {
                        let widget = deco.widget || (deco.block ? $7beee9608540d2c3$var$NullWidget.block : $7beee9608540d2c3$var$NullWidget.inline);
                        let flags = $7beee9608540d2c3$var$widgetFlags(deco);
                        let tile = this.cache.findWidget(widget, to - from, flags) || $7beee9608540d2c3$var$WidgetTile.of(widget, this.view, to - from, flags);
                        if (deco.block) {
                            if (deco.startSide > 0) b.addLineStartIfNotCovered(pendingLineAttrs);
                            b.addBlockWidget(tile);
                        } else {
                            b.ensureLine(pendingLineAttrs);
                            b.addInlineWidget(tile, active, openStart);
                        }
                    }
                    pendingLineAttrs = null;
                } else pendingLineAttrs = $7beee9608540d2c3$var$addLineDeco(pendingLineAttrs, deco);
                if (to > from) this.text.skip(to - from);
            },
            span: (from, to, active, openStart)=>{
                for(let pos = from; pos < to;){
                    let chars = this.text.next(Math.min(512 /* C.Chunk */ , to - pos));
                    if (chars == null) {
                        b.addLineStartIfNotCovered(pendingLineAttrs);
                        b.addBreak();
                        pos++;
                    } else {
                        b.ensureLine(pendingLineAttrs);
                        b.addText(chars, active, openStart);
                        pos += chars.length;
                    }
                    pendingLineAttrs = null;
                }
            }
        });
        b.addLineStartIfNotCovered(pendingLineAttrs);
        this.openWidget = openEnd > markCount;
        this.openMarks = openEnd;
    }
    forward(from, to) {
        this.old.advance(to - from, 1, {
            skip: (tile, from, to)=>{
                if (tile.isText() || to == tile.length) this.cache.add(tile);
            },
            enter: (tile)=>this.cache.add(tile),
            leave: ()=>{},
            break: ()=>{}
        });
    }
    getCompositionContext(text) {
        let marks = [], line = null;
        for(let parent = text.parentNode;; parent = parent.parentNode){
            let tile = $7beee9608540d2c3$var$Tile.get(parent);
            if (parent == this.view.contentDOM) break;
            if (tile instanceof $7beee9608540d2c3$var$MarkTile) marks.push(tile);
            else if (tile === null || tile === void 0 ? void 0 : tile.isLine()) line = tile;
            else if (parent.nodeName == "DIV" && !line && parent != this.view.contentDOM) line = new $7beee9608540d2c3$var$LineTile(parent, $7beee9608540d2c3$var$lineBaseAttrs);
            else marks.push($7beee9608540d2c3$var$MarkTile.of(new $7beee9608540d2c3$var$MarkDecoration({
                tagName: parent.nodeName.toLowerCase(),
                attributes: $7beee9608540d2c3$var$getAttrs(parent)
            }), parent));
        }
        return {
            line: line,
            marks: marks
        };
    }
}
function $7beee9608540d2c3$var$hasContent(tile, requireText) {
    let scan = (tile)=>{
        for (let ch of tile.children)if ((requireText ? ch.isText() : ch.length) || scan(ch)) return true;
        return false;
    };
    return scan(tile);
}
function $7beee9608540d2c3$var$widgetFlags(deco) {
    let flags = deco.isReplace ? (deco.startSide < 0 ? 64 /* TileFlag.IncStart */  : 0) | (deco.endSide > 0 ? 128 /* TileFlag.IncEnd */  : 0) : deco.startSide > 0 ? 32 /* TileFlag.After */  : 16 /* TileFlag.Before */ ;
    if (deco.block) flags |= 256 /* TileFlag.Block */ ;
    return flags;
}
const $7beee9608540d2c3$var$lineBaseAttrs = {
    class: "cm-line"
};
function $7beee9608540d2c3$var$addLineDeco(value, deco) {
    let attrs = deco.spec.attributes, cls = deco.spec.class;
    if (!attrs && !cls) return value;
    if (!value) value = {
        class: "cm-line"
    };
    if (attrs) $7beee9608540d2c3$var$combineAttrs(attrs, value);
    if (cls) value.class += " " + cls;
    return value;
}
function $7beee9608540d2c3$var$getMarks(ptr) {
    let found = [];
    for(let i = ptr.parents.length; i > 1; i--){
        let tile = i == ptr.parents.length ? ptr.tile : ptr.parents[i].tile;
        if (tile instanceof $7beee9608540d2c3$var$MarkTile) found.push(tile.mark);
    }
    return found;
}
function $7beee9608540d2c3$var$freeNode(node) {
    let tile = $7beee9608540d2c3$var$Tile.get(node);
    if (tile) tile.setDOM(node.cloneNode());
    return node;
}
class $7beee9608540d2c3$var$NullWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(tag){
        super();
        this.tag = tag;
    }
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
        return true;
    }
}
$7beee9608540d2c3$var$NullWidget.inline = /*@__PURE__*/ new $7beee9608540d2c3$var$NullWidget("span");
$7beee9608540d2c3$var$NullWidget.block = /*@__PURE__*/ new $7beee9608540d2c3$var$NullWidget("div");
const $7beee9608540d2c3$var$BreakWidget = /*@__PURE__*/ new class extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    toDOM() {
        return document.createElement("br");
    }
    get isHidden() {
        return true;
    }
    get editable() {
        return true;
    }
};
class $7beee9608540d2c3$var$DocView {
    constructor(view){
        this.view = view;
        this.decorations = [];
        this.blockWrappers = [];
        this.dynamicDecorationMap = [
            false
        ];
        this.domChanged = null;
        this.hasComposition = null;
        this.editContextFormatting = $7beee9608540d2c3$export$10e30b733df217ea.none;
        this.lastCompositionAfterCursor = false;
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.updateDeco();
        this.tile = new $7beee9608540d2c3$var$DocTile(view, view.contentDOM);
        this.updateInner([
            new $7beee9608540d2c3$var$ChangedRange(0, 0, 0, view.state.doc.length)
        ], null);
    }
    // Update the document view to a given state.
    update(update) {
        var _a;
        let changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every(({ fromA: fromA, toA: toA })=>toA < this.minWidthFrom || fromA > this.minWidthTo)) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        this.updateEditContextFormatting(update);
        let readCompositionAt = -1;
        if (this.view.inputState.composing >= 0 && !this.view.observer.editContext) {
            if ((_a = this.domChanged) === null || _a === void 0 ? void 0 : _a.newSel) readCompositionAt = this.domChanged.newSel.head;
            else if (!$7beee9608540d2c3$var$touchesComposition(update.changes, this.hasComposition) && !update.selectionSet) readCompositionAt = update.state.selection.main.head;
        }
        let composition = readCompositionAt > -1 ? $7beee9608540d2c3$var$findCompositionRange(this.view, update.changes, readCompositionAt) : null;
        this.domChanged = null;
        if (this.hasComposition) {
            let { from: from, to: to } = this.hasComposition;
            changedRanges = new $7beee9608540d2c3$var$ChangedRange(from, to, update.changes.mapPos(from, -1), update.changes.mapPos(to, 1)).addToSet(changedRanges.slice());
        }
        this.hasComposition = composition ? {
            from: composition.range.fromB,
            to: composition.range.toB
        } : null;
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if (($7beee9608540d2c3$var$browser.ie || $7beee9608540d2c3$var$browser.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        let prevDeco = this.decorations, prevWrappers = this.blockWrappers;
        this.updateDeco();
        let decoDiff = $7beee9608540d2c3$var$findChangedDeco(prevDeco, this.decorations, update.changes);
        if (decoDiff.length) changedRanges = $7beee9608540d2c3$var$ChangedRange.extendWithRanges(changedRanges, decoDiff);
        let blockDiff = $7beee9608540d2c3$var$findChangedWrappers(prevWrappers, this.blockWrappers, update.changes);
        if (blockDiff.length) changedRanges = $7beee9608540d2c3$var$ChangedRange.extendWithRanges(changedRanges, blockDiff);
        if (composition && !changedRanges.some((r)=>r.fromA <= composition.range.fromA && r.toA >= composition.range.toA)) changedRanges = composition.range.addToSet(changedRanges.slice());
        if (this.tile.flags & 2 /* TileFlag.Synced */  && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, composition);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, composition) {
        this.view.viewState.mustMeasureContent = true;
        let { observer: observer } = this.view;
        observer.ignore(()=>{
            if (composition || changes.length) {
                let oldTile = this.tile;
                let builder = new $7beee9608540d2c3$var$TileUpdate(this.view, oldTile, this.blockWrappers, this.decorations, this.dynamicDecorationMap);
                this.tile = builder.run(changes, composition);
                $7beee9608540d2c3$var$destroyDropped(oldTile, builder.cache.reused);
            }
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.tile.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px";
            this.tile.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            let track = $7beee9608540d2c3$var$browser.chrome || $7beee9608540d2c3$var$browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.tile.sync(track);
            if (track && (track.written || observer.selectionRange.focusNode != track.node || !this.tile.dom.contains(track.node))) this.forceSelection = true;
            this.tile.dom.style.height = "";
        });
        let gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            for (let child of this.tile.children)if (child.isWidget() && child.widget instanceof $7beee9608540d2c3$var$BlockGapWidget) gaps.push(child.dom);
        }
        observer.updateGaps(gaps);
    }
    updateEditContextFormatting(update) {
        this.editContextFormatting = this.editContextFormatting.map(update.changes);
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($7beee9608540d2c3$var$setEditContextFormatting)) this.editContextFormatting = effect.value;
    }
    // Sync the DOM selection to this.state.selection
    updateSelection(mustRead = false, fromPointer = false) {
        if (mustRead || !this.view.observer.selectionRange.focusNode) this.view.observer.readSelectionRange();
        let { dom: dom } = this.tile;
        let activeElt = this.view.root.activeElement, focused = activeElt == dom;
        let selectionNotFocus = !focused && !(this.view.state.facet($7beee9608540d2c3$var$editable) || dom.tabIndex > -1) && $7beee9608540d2c3$var$hasSelection(dom, this.view.observer.selectionRange) && !(activeElt && dom.contains(activeElt));
        if (!(focused || fromPointer || selectionNotFocus)) return;
        let force = this.forceSelection;
        this.forceSelection = false;
        let main = this.view.state.selection.main, anchor, head;
        if (main.empty) head = anchor = this.inlineDOMNearPos(main.anchor, main.assoc || 1);
        else {
            head = this.inlineDOMNearPos(main.head, main.head == main.from ? 1 : -1);
            anchor = this.inlineDOMNearPos(main.anchor, main.anchor == main.from ? 1 : -1);
        }
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if ($7beee9608540d2c3$var$browser.gecko && main.empty && !this.hasComposition && $7beee9608540d2c3$var$betweenUneditable(anchor)) {
            let dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new $7beee9608540d2c3$var$DOMPos(dummy, 0);
            force = true;
        }
        let domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || (!$7beee9608540d2c3$var$isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !$7beee9608540d2c3$var$isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) && !this.suppressWidgetCursorChange(domSel, main)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if ($7beee9608540d2c3$var$browser.android && $7beee9608540d2c3$var$browser.chrome && dom.contains(domSel.focusNode) && $7beee9608540d2c3$var$inUneditable(domSel.focusNode, dom)) {
                    dom.blur();
                    dom.focus({
                        preventScroll: true
                    });
                }
                let rawSel = $7beee9608540d2c3$var$getSelection(this.view.root);
                if (!rawSel) ;
                else if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if ($7beee9608540d2c3$var$browser.gecko) {
                        let nextTo = $7beee9608540d2c3$var$nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* NextTo.After */ ) {
                            let text = (nextTo == 1 /* NextTo.Before */  ? $7beee9608540d2c3$var$textNodeBefore : $7beee9608540d2c3$var$textNodeAfter)(anchor.node, anchor.offset);
                            if (text) anchor = new $7beee9608540d2c3$var$DOMPos(text.node, text.offset);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && rawSel.caretBidiLevel !== undefined) rawSel.caretBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    // Safari will ignore the call above when the editor is
                    // hidden, and then raise an error on the call to extend
                    // (#940).
                    try {
                        rawSel.extend(head.node, head.offset);
                    } catch (_) {}
                } else {
                    // Primitive (IE) way
                    let range = document.createRange();
                    if (main.anchor > main.head) [anchor, head] = [
                        head,
                        anchor
                    ];
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
                if (selectionNotFocus && this.view.root.activeElement == dom) {
                    dom.blur();
                    if (activeElt) activeElt.focus();
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new $7beee9608540d2c3$var$DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new $7beee9608540d2c3$var$DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    // If a zero-length widget is inserted next to the cursor during
    // composition, avoid moving it across it and disrupting the
    // composition.
    suppressWidgetCursorChange(sel, cursor) {
        return this.hasComposition && cursor.empty && $7beee9608540d2c3$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset) && this.posFromDOM(sel.focusNode, sel.focusOffset) == cursor.head;
    }
    enforceCursorAssoc() {
        if (this.hasComposition) return;
        let { view: view } = this, cursor = view.state.selection.main;
        let sel = $7beee9608540d2c3$var$getSelection(view.root);
        let { anchorNode: anchorNode, anchorOffset: anchorOffset } = view.observer.selectionRange;
        if (!sel || !cursor.empty || !cursor.assoc || !sel.modify) return;
        let line = this.lineAt(cursor.head);
        if (!line) return;
        let lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        let dom = this.domAtPos(cursor.head + cursor.assoc, cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
        // This can go wrong in corner cases like single-character lines,
        // so check and reset if necessary.
        view.observer.readSelectionRange();
        let newRange = view.observer.selectionRange;
        if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from) sel.collapse(anchorNode, anchorOffset);
    }
    posFromDOM(node, offset) {
        let tile = this.tile.nearest(node);
        if (!tile) return this.tile.dom.compareDocumentPosition(node) & 2 /* PRECEDING */  ? 0 : this.view.state.doc.length;
        let start = tile.posAtStart;
        if (tile.isComposite()) {
            let after;
            if (node == tile.dom) after = tile.dom.childNodes[offset];
            else {
                let bias = $7beee9608540d2c3$var$maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
                for(;;){
                    let parent = node.parentNode;
                    if (parent == tile.dom) break;
                    if (bias == 0 && parent.firstChild != parent.lastChild) {
                        if (node == parent.firstChild) bias = -1;
                        else bias = 1;
                    }
                    node = parent;
                }
                if (bias < 0) after = node;
                else after = node.nextSibling;
            }
            if (after == tile.dom.firstChild) return start;
            while(after && !$7beee9608540d2c3$var$Tile.get(after))after = after.nextSibling;
            if (!after) return start + tile.length;
            for(let i = 0, pos = start;; i++){
                let child = tile.children[i];
                if (child.dom == after) return pos;
                pos += child.length + child.breakAfter;
            }
        } else if (tile.isText()) return node == tile.dom ? start + offset : start + (offset ? tile.length : 0);
        else return start;
    }
    domAtPos(pos, side) {
        let { tile: tile, offset: offset } = this.tile.resolveBlock(pos, side);
        if (tile.isWidget()) return tile.domPosFor(pos, side);
        return tile.domIn(offset, side);
    }
    inlineDOMNearPos(pos, side) {
        let before, beforeOff = -1, beforeBad = false;
        let after, afterOff = -1, afterBad = false;
        this.tile.blockTiles((tile, off)=>{
            if (tile.isWidget()) {
                if (tile.flags & 32 /* TileFlag.After */  && before) return true;
                if (tile.flags & 16 /* TileFlag.Before */ ) beforeBad = true;
            } else {
                let end = off + tile.length;
                if (off <= pos) {
                    before = tile;
                    beforeOff = pos - off;
                    beforeBad = end < pos;
                }
                if (end >= pos && !after) {
                    after = tile;
                    afterOff = pos - off;
                    afterBad = off > pos;
                }
                if (off > pos && after) return true;
            }
        });
        if (!before && !after) return this.domAtPos(pos, side);
        if (beforeBad && after) before = null;
        else if (afterBad && before) after = null;
        return before && side < 0 || !after ? before.domIn(beforeOff, side) : after.domIn(afterOff, side);
    }
    coordsAt(pos, side) {
        let { tile: tile, offset: offset } = this.tile.resolveBlock(pos, side);
        if (tile.isWidget()) {
            if (tile.widget instanceof $7beee9608540d2c3$var$BlockGapWidget) return null;
            return tile.coordsInWidget(offset, side, true);
        }
        return tile.coordsIn(offset, side);
    }
    lineAt(pos) {
        let { tile: tile } = this.tile.resolveBlock(pos, 1);
        return tile.isLine() ? tile : null;
    }
    coordsForChar(pos) {
        let { tile: tile, offset: offset } = this.tile.resolveBlock(pos, 1);
        if (!tile.isLine()) return null;
        function scan(tile, offset) {
            if (tile.isComposite()) for (let ch of tile.children){
                if (ch.length >= offset) {
                    let found = scan(ch, offset);
                    if (found) return found;
                }
                offset -= ch.length;
                if (offset < 0) break;
            }
            else if (tile.isText() && offset < tile.length) {
                let end = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(tile.text, offset);
                if (end == offset) return null;
                let rects = $7beee9608540d2c3$var$textRange(tile.dom, offset, end).getClientRects();
                for(let i = 0; i < rects.length; i++){
                    let rect = rects[i];
                    if (i == rects.length - 1 || rect.top < rect.bottom && rect.left < rect.right) return rect;
                }
            }
            return null;
        }
        return scan(tile, offset);
    }
    measureVisibleLineHeights(viewport) {
        let result = [], { from: from, to: to } = viewport;
        let contentWidth = this.view.contentDOM.clientWidth;
        let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        let widest = -1, ltr = this.view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        let spaceAbove = 0;
        let scan = (tile, pos, measureBounds)=>{
            for(let i = 0; i < tile.children.length; i++){
                if (pos > to) break;
                let child = tile.children[i], end = pos + child.length;
                let childRect = child.dom.getBoundingClientRect(), { height: height } = childRect;
                if (measureBounds && !i) spaceAbove += childRect.top - measureBounds.top;
                if (child instanceof $7beee9608540d2c3$var$BlockWrapperTile) {
                    if (end > from) scan(child, pos, childRect);
                } else if (pos >= from) {
                    if (spaceAbove > 0) result.push(-spaceAbove);
                    result.push(height + spaceAbove);
                    spaceAbove = 0;
                    if (isWider) {
                        let last = child.dom.lastChild;
                        let rects = last ? $7beee9608540d2c3$var$clientRectsFor(last) : [];
                        if (rects.length) {
                            let rect = rects[rects.length - 1];
                            let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                            if (width > widest) {
                                widest = width;
                                this.minWidth = contentWidth;
                                this.minWidthFrom = pos;
                                this.minWidthTo = end;
                            }
                        }
                    }
                }
                if (measureBounds && i == tile.children.length - 1) spaceAbove += measureBounds.bottom - childRect.bottom;
                pos = end + child.breakAfter;
            }
        };
        scan(this.tile, 0, null);
        return result;
    }
    textDirectionAt(pos) {
        let { tile: tile } = this.tile.resolveBlock(pos, 1);
        return getComputedStyle(tile.dom).direction == "rtl" ? $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL : $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
    }
    measureTextSize() {
        let lineMeasure = this.tile.blockTiles((tile)=>{
            if (tile.isLine() && tile.children.length && tile.length <= 20) {
                let totalWidth = 0, textHeight;
                for (let child of tile.children){
                    if (!child.isText() || /[^ -~]/.test(child.text)) return undefined;
                    let rects = $7beee9608540d2c3$var$clientRectsFor(child.dom);
                    if (rects.length != 1) return undefined;
                    totalWidth += rects[0].width;
                    textHeight = rects[0].height;
                }
                if (totalWidth) return {
                    lineHeight: tile.dom.getBoundingClientRect().height,
                    charWidth: totalWidth / tile.length,
                    textHeight: textHeight
                };
            }
        });
        if (lineMeasure) return lineMeasure;
        // If no workable line exists, force a layout of a measurable element
        let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
        dummy.className = "cm-line";
        dummy.style.width = "99999px";
        dummy.style.position = "absolute";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.tile.dom.appendChild(dummy);
            let rect = $7beee9608540d2c3$var$clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect && rect.width ? rect.width / 27 : 7;
            textHeight = rect && rect.height ? rect.height : lineHeight;
            dummy.remove();
        });
        return {
            lineHeight: lineHeight,
            charWidth: charWidth,
            textHeight: textHeight
        };
    }
    computeBlockGapDeco() {
        let deco = [], vs = this.view.viewState;
        for(let pos = 0, i = 0;; i++){
            let next = i == vs.viewports.length ? null : vs.viewports[i];
            let end = next ? next.from - 1 : this.view.state.doc.length;
            if (end > pos) {
                let height = (vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top) / this.view.scaleY;
                deco.push($7beee9608540d2c3$export$10e30b733df217ea.replace({
                    widget: new $7beee9608540d2c3$var$BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return $7beee9608540d2c3$export$10e30b733df217ea.set(deco);
    }
    updateDeco() {
        let i = 1;
        let allDeco = this.view.state.facet($7beee9608540d2c3$var$decorations).map((d)=>{
            let dynamic = this.dynamicDecorationMap[i++] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        let dynamicOuter = false, outerDeco = this.view.state.facet($7beee9608540d2c3$var$outerDecorations).map((d, i)=>{
            let dynamic = typeof d == "function";
            if (dynamic) dynamicOuter = true;
            return dynamic ? d(this.view) : d;
        });
        if (outerDeco.length) {
            this.dynamicDecorationMap[i++] = dynamicOuter;
            allDeco.push((0, $6295c6875f57e3ee$export$34cb5241245008dd).join(outerDeco));
        }
        this.decorations = [
            this.editContextFormatting,
            ...allDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
        while(i < this.decorations.length)this.dynamicDecorationMap[i++] = false;
        this.blockWrappers = this.view.state.facet($7beee9608540d2c3$var$blockWrappers).map((v)=>typeof v == "function" ? v(this.view) : v);
    }
    scrollIntoView(target) {
        if (target.isSnapshot) {
            let ref = this.view.viewState.lineBlockAt(target.range.head);
            this.view.scrollDOM.scrollTop = ref.top - target.yMargin;
            this.view.scrollDOM.scrollLeft = target.xMargin;
            return;
        }
        for (let handler of this.view.state.facet($7beee9608540d2c3$var$scrollHandler))try {
            if (handler(this.view, target.range, target)) return true;
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.view.state, e, "scroll handler");
        }
        let { range: range } = target;
        let rect = this.coordsAt(range.head, range.empty ? range.assoc : range.head > range.anchor ? -1 : 1), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        let margins = $7beee9608540d2c3$var$getScrollMargins(this.view);
        let targetRect = {
            left: rect.left - margins.left,
            top: rect.top - margins.top,
            right: rect.right + margins.right,
            bottom: rect.bottom + margins.bottom
        };
        let { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = this.view.scrollDOM;
        $7beee9608540d2c3$var$scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, Math.max(Math.min(target.xMargin, offsetWidth), -offsetWidth), Math.max(Math.min(target.yMargin, offsetHeight), -offsetHeight), this.view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR);
    }
    lineHasWidget(pos) {
        let scan = (child)=>child.isWidget() || child.children.some(scan);
        return scan(this.tile.resolveBlock(pos, 1).tile);
    }
    destroy() {
        $7beee9608540d2c3$var$destroyDropped(this.tile);
    }
}
function $7beee9608540d2c3$var$destroyDropped(tile, reused) {
    let r = reused === null || reused === void 0 ? void 0 : reused.get(tile);
    if (r != 1 /* Reused.Full */ ) {
        if (r == null) tile.destroy();
        for (let ch of tile.children)$7beee9608540d2c3$var$destroyDropped(ch, reused);
    }
}
function $7beee9608540d2c3$var$betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
function $7beee9608540d2c3$var$findCompositionNode(view, headPos) {
    let sel = view.observer.selectionRange;
    if (!sel.focusNode) return null;
    let textBefore = $7beee9608540d2c3$var$textNodeBefore(sel.focusNode, sel.focusOffset);
    let textAfter = $7beee9608540d2c3$var$textNodeAfter(sel.focusNode, sel.focusOffset);
    let textNode = textBefore || textAfter;
    if (textAfter && textBefore && textAfter.node != textBefore.node) {
        let tileAfter = $7beee9608540d2c3$var$Tile.get(textAfter.node);
        if (!tileAfter || tileAfter.isText() && tileAfter.text != textAfter.node.nodeValue) textNode = textAfter;
        else if (view.docView.lastCompositionAfterCursor) {
            let tileBefore = $7beee9608540d2c3$var$Tile.get(textBefore.node);
            if (!(!tileBefore || tileBefore.isText() && tileBefore.text != textBefore.node.nodeValue)) textNode = textAfter;
        }
    }
    view.docView.lastCompositionAfterCursor = textNode != textBefore;
    if (!textNode) return null;
    let from = headPos - textNode.offset;
    return {
        from: from,
        to: from + textNode.node.nodeValue.length,
        node: textNode.node
    };
}
function $7beee9608540d2c3$var$findCompositionRange(view, changes, headPos) {
    let found = $7beee9608540d2c3$var$findCompositionNode(view, headPos);
    if (!found) return null;
    let { node: textNode, from: from, to: to } = found, text = textNode.nodeValue;
    // Don't try to preserve multi-line compositions
    if (/[\n\r]/.test(text)) return null;
    if (view.state.doc.sliceString(found.from, found.to) != text) return null;
    let inv = changes.invertedDesc;
    return {
        range: new $7beee9608540d2c3$var$ChangedRange(inv.mapPos(from), inv.mapPos(to), from, to),
        text: textNode
    };
}
function $7beee9608540d2c3$var$nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* NextTo.Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* NextTo.After */  : 0);
}
let $7beee9608540d2c3$var$DecorationComparator$1 = class DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $7beee9608540d2c3$var$addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        $7beee9608540d2c3$var$addRange(from, to, this.changes);
    }
    boundChange(pos) {
        $7beee9608540d2c3$var$addRange(pos, pos, this.changes);
    }
};
function $7beee9608540d2c3$var$findChangedDeco(a, b, diff) {
    let comp = new $7beee9608540d2c3$var$DecorationComparator$1;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).compare(a, b, diff, comp);
    return comp.changes;
}
class $7beee9608540d2c3$var$WrapperComparator {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $7beee9608540d2c3$var$addRange(from, to, this.changes);
    }
    comparePoint() {}
    boundChange(pos) {
        $7beee9608540d2c3$var$addRange(pos, pos, this.changes);
    }
}
function $7beee9608540d2c3$var$findChangedWrappers(a, b, diff) {
    let comp = new $7beee9608540d2c3$var$WrapperComparator;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).compare(a, b, diff, comp);
    return comp.changes;
}
function $7beee9608540d2c3$var$inUneditable(node, inside) {
    for(let cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == 'false') return true;
    }
    return false;
}
function $7beee9608540d2c3$var$touchesComposition(changes, composition) {
    let touched = false;
    if (composition) changes.iterChangedRanges((from, to)=>{
        if (from < composition.to && to > composition.from) touched = true;
    });
    return touched;
}
class $7beee9608540d2c3$var$BlockGapWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(height){
        super();
        this.height = height;
    }
    toDOM() {
        let elt = document.createElement("div");
        elt.className = "cm-gap";
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get editable() {
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
    ignoreEvent() {
        return false;
    }
}
function $7beee9608540d2c3$var$groupAt(state, pos, bias = 1) {
    let categorize = state.charCategorizer(pos);
    let line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    let from = linePos, to = linePos;
    if (bias < 0) from = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, linePos, false);
    else to = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, linePos);
    let cat = categorize(line.text.slice(from, to));
    while(from > 0){
        let prev = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        let next = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from + line.from, to + line.from);
}
function $7beee9608540d2c3$var$posAtCoordsImprecise(view, contentRect, block, x, y) {
    let into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        let textHeight = view.viewState.heightOracle.textHeight;
        let line = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    let content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, $6295c6875f57e3ee$export$718b3d71c384ca05)(content, into, view.state.tabSize);
}
function $7beee9608540d2c3$var$blockAt(view, pos, side) {
    let line = view.lineBlockAt(pos);
    if (Array.isArray(line.type)) {
        let best;
        for (let l of line.type){
            if (l.from > pos) break;
            if (l.to < pos) continue;
            if (l.from < pos && l.to > pos) return l;
            if (!best || l.type == $7beee9608540d2c3$export$48808c686fe495c4.Text && (best.type != l.type || (side < 0 ? l.from < pos : l.to > pos))) best = l;
        }
        return best || line;
    }
    return line;
}
function $7beee9608540d2c3$var$moveToLineBoundary(view, start, forward, includeWrap) {
    let line = $7beee9608540d2c3$var$blockAt(view, start.head, start.assoc || -1);
    let coords = !includeWrap || line.type != $7beee9608540d2c3$export$48808c686fe495c4.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        let editorRect = view.dom.getBoundingClientRect();
        let direction = view.textDirectionAt(line.from);
        let pos = view.posAtCoords({
            x: forward == (direction == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
    }
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function $7beee9608540d2c3$var$moveByChar(view, start, forward, by) {
    let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    let direction = view.textDirectionAt(line.from);
    for(let cur = start, check = null;;){
        let next = $7beee9608540d2c3$var$moveVisually(line, spans, direction, cur, forward), char = $7beee9608540d2c3$var$movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = view.visualLineSide(line, !forward);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function $7beee9608540d2c3$var$byGroup(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start);
    return (next)=>{
        let nextCat = categorize(next);
        if (cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function $7beee9608540d2c3$var$moveVertically(view, start, forward, distance) {
    let startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(startPos, start.assoc);
    let goal = start.goalColumn, startY;
    let rect = view.contentDOM.getBoundingClientRect();
    let startCoords = view.coordsAtPos(startPos, start.assoc || -1), docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        let line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    let resolvedGoal = rect.left + goal;
    let dist = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
    for(let extra = 0;; extra += 10){
        let curY = startY + (dist + extra) * dir;
        let pos = $7beee9608540d2c3$var$posAtCoords(view, {
            x: resolvedGoal,
            y: curY
        }, false, dir);
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos.pos, pos.assoc, undefined, goal);
    }
}
function $7beee9608540d2c3$var$skipAtomicRanges(atoms, pos, bias) {
    for(;;){
        let moved = 0;
        for (let set of atoms)set.between(pos - 1, pos + 1, (from, to, value)=>{
            if (pos > from && pos < to) {
                let side = moved || bias || (pos - from < to - pos ? -1 : 1);
                pos = side < 0 ? from : to;
                moved = side;
            }
        });
        if (!moved) return pos;
    }
}
function $7beee9608540d2c3$var$skipAtomsForSelection(atoms, sel) {
    let ranges = null;
    for(let i = 0; i < sel.ranges.length; i++){
        let range = sel.ranges[i], updated = null;
        if (range.empty) {
            let pos = $7beee9608540d2c3$var$skipAtomicRanges(atoms, range.from, 0);
            if (pos != range.from) updated = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, -1);
        } else {
            let from = $7beee9608540d2c3$var$skipAtomicRanges(atoms, range.from, -1);
            let to = $7beee9608540d2c3$var$skipAtomicRanges(atoms, range.to, 1);
            if (from != range.from || to != range.to) updated = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.from == range.anchor ? from : to, range.from == range.head ? from : to);
        }
        if (updated) {
            if (!ranges) ranges = sel.ranges.slice();
            ranges[i] = updated;
        }
    }
    return ranges ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, sel.mainIndex) : sel;
}
function $7beee9608540d2c3$var$skipAtoms(view, oldPos, pos) {
    let newPos = $7beee9608540d2c3$var$skipAtomicRanges(view.state.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
    return newPos == pos.from ? pos : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(newPos, newPos < pos.from ? 1 : -1);
}
class $7beee9608540d2c3$var$PosAssoc {
    constructor(pos, assoc){
        this.pos = pos;
        this.assoc = assoc;
    }
}
function $7beee9608540d2c3$var$posAtCoords(view, coords, precise, scanY) {
    let content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    let { x: x, y: y } = coords, yOffset = y - docTop, block;
    // First find the block at the given Y position, if any. If scanY is
    // given (used for vertical cursor motion), try to skip widgets and
    // line padding.
    for(;;){
        if (yOffset < 0) return new $7beee9608540d2c3$var$PosAssoc(0, 1);
        if (yOffset > view.viewState.docHeight) return new $7beee9608540d2c3$var$PosAssoc(view.state.doc.length, -1);
        block = view.elementAtHeight(yOffset);
        if (scanY == null) break;
        if (block.type == $7beee9608540d2c3$export$48808c686fe495c4.Text) {
            // Check whether we aren't landing the top/bottom padding of the line
            let rect = view.docView.coordsAt(scanY < 0 ? block.from : block.to, scanY);
            if (rect && (scanY < 0 ? rect.top <= yOffset + docTop : rect.bottom >= yOffset + docTop)) break;
        }
        let halfLine = view.viewState.heightOracle.textHeight / 2;
        yOffset = scanY > 0 ? block.bottom + halfLine : block.top - halfLine;
    }
    // If outside the viewport, return null if precise==true, an
    // estimate otherwise.
    if (view.viewport.from >= block.to || view.viewport.to <= block.from) {
        if (precise) return null;
        if (block.type == $7beee9608540d2c3$export$48808c686fe495c4.Text) {
            let pos = $7beee9608540d2c3$var$posAtCoordsImprecise(view, content, block, x, y);
            return new $7beee9608540d2c3$var$PosAssoc(pos, pos == block.from ? 1 : -1);
        }
    }
    if (block.type != $7beee9608540d2c3$export$48808c686fe495c4.Text) return yOffset < (block.top + block.bottom) / 2 ? new $7beee9608540d2c3$var$PosAssoc(block.from, 1) : new $7beee9608540d2c3$var$PosAssoc(block.to, -1);
    // Here we know we're in a line, so run the logic for inline layout
    return $7beee9608540d2c3$var$posAtCoordsInline(view, view.docView.lineAt(block.from), block.from, x, y);
}
// Scan through the rectangles for the content of a tile, finding the
// one closest to the given coordinates, prefering closeness in Y over
// closeness in X.
//
// If this is a text tile, go character-by-character. For line or mark
// tiles, check each non-point-widget child, and descend text or mark
// tiles with a recursive call.
//
// For non-wrapped, purely left-to-right text, this could use a binary
// search. But because this seems to be fast enough, for how often it
// is called, there's not currently a specialized implementation for
// that.
function $7beee9608540d2c3$var$posAtCoordsInline(view, tile, offset, x, y) {
    let closest = -1, closestRect = null;
    let dxClosest = 1e9, dyClosest = 1e9;
    let rowTop = y, rowBot = y;
    let checkRects = (rects, index)=>{
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top == rect.bottom) continue;
            let dx = rect.left > x ? rect.left - x : rect.right < x ? x - rect.right : 0;
            let dy = rect.top > y ? rect.top - y : rect.bottom < y ? y - rect.bottom : 0;
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                // Rectangle is in the current row
                rowTop = Math.min(rect.top, rowTop);
                rowBot = Math.max(rect.bottom, rowBot);
                dy = 0;
            }
            if (closest < 0 || (dy - dyClosest || dx - dxClosest) < 0) {
                if (closest >= 0 && dyClosest && dxClosest < dx && closestRect.top <= rowBot - 2 && closestRect.bottom >= rowTop + 2) // Retroactively set dy to 0 if the current match is in this row.
                dyClosest = 0;
                else {
                    closest = index;
                    dxClosest = dx;
                    dyClosest = dy;
                    closestRect = rect;
                }
            }
        }
    };
    if (tile.isText()) {
        for(let i = 0; i < tile.length;){
            let next = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(tile.text, i);
            checkRects($7beee9608540d2c3$var$textRange(tile.dom, i, next).getClientRects(), i);
            if (!dxClosest && !dyClosest) break;
            i = next;
        }
        let after = x > (closestRect.left + closestRect.right) / 2 == ($7beee9608540d2c3$var$dirAt(view, closest + offset) == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR);
        return after ? new $7beee9608540d2c3$var$PosAssoc(offset + (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(tile.text, closest), -1) : new $7beee9608540d2c3$var$PosAssoc(offset + closest, 1);
    } else {
        if (!tile.length) return new $7beee9608540d2c3$var$PosAssoc(offset, 1);
        for(let i = 0; i < tile.children.length; i++){
            let child = tile.children[i];
            if (child.flags & 48 /* TileFlag.PointWidget */ ) continue;
            let rects = (child.dom.nodeType == 1 ? child.dom : $7beee9608540d2c3$var$textRange(child.dom, 0, child.length)).getClientRects();
            checkRects(rects, i);
            if (!dxClosest && !dyClosest) break;
        }
        let inner = tile.children[closest], innerOff = tile.posBefore(inner, offset);
        if (inner.isComposite() || inner.isText()) return $7beee9608540d2c3$var$posAtCoordsInline(view, inner, innerOff, Math.max(closestRect.left, Math.min(closestRect.right, x)), y);
        let after = x > (closestRect.left + closestRect.right) / 2 == ($7beee9608540d2c3$var$dirAt(view, closest + offset) == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR);
        return after ? new $7beee9608540d2c3$var$PosAssoc(innerOff + inner.length, -1) : new $7beee9608540d2c3$var$PosAssoc(innerOff, 1);
    }
}
function $7beee9608540d2c3$var$dirAt(view, pos) {
    let line = view.state.doc.lineAt(pos), spans = view.bidiSpans(line);
    return spans[$7beee9608540d2c3$export$e1ed96b746bb516a.find(view.bidiSpans(line), pos - line.from, -1, 1)].dir;
}
const $7beee9608540d2c3$var$LineBreakPlaceholder = "\uffff";
class $7beee9608540d2c3$var$DOMReader {
    constructor(points, state){
        this.points = points;
        this.text = "";
        this.lineSeparator = state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).lineSeparator);
    }
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += $7beee9608540d2c3$var$LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        let parent = start.parentNode;
        for(let cur = start;;){
            this.findPointBefore(parent, cur);
            let oldLen = this.text.length;
            this.readNode(cur);
            let tile = $7beee9608540d2c3$var$Tile.get(cur), next = cur.nextSibling;
            if (next == end) {
                if ((tile === null || tile === void 0 ? void 0 : tile.breakAfter) && !next) this.lineBreak();
                break;
            }
            let nextTile = $7beee9608540d2c3$var$Tile.get(next);
            if ((tile && nextTile ? tile.breakAfter : (tile ? tile.breakAfter : $7beee9608540d2c3$var$isBlockElement(cur)) || $7beee9608540d2c3$var$isBlockElement(next) && (cur.nodeName != "BR" || (tile === null || tile === void 0 ? void 0 : tile.isWidget())) && this.text.length > oldLen) && !$7beee9608540d2c3$var$isEmptyToEnd(next, end)) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        let text = node.nodeValue;
        for (let point of this.points)if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
        for(let off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            let nextBreak = -1, breakSize = 1, m;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                for (let point of this.points)if (point.node == node && point.pos > this.text.length) point.pos -= breakSize - 1;
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        let tile = $7beee9608540d2c3$var$Tile.get(node);
        let fromView = tile && tile.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(let i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        for (let point of this.points)if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
    }
    findPointInside(node, length) {
        for (let point of this.points)if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + ($7beee9608540d2c3$var$isAtEnd(node, point.node, point.offset) ? length : 0);
    }
}
function $7beee9608540d2c3$var$isAtEnd(parent, node, offset) {
    for(;;){
        if (!node || offset < $7beee9608540d2c3$var$maxOffset(node)) return false;
        if (node == parent) return true;
        offset = $7beee9608540d2c3$var$domIndex(node) + 1;
        node = node.parentNode;
    }
}
function $7beee9608540d2c3$var$isEmptyToEnd(node, end) {
    let widgets;
    for(;; node = node.nextSibling){
        if (node == end || !node) break;
        let view = $7beee9608540d2c3$var$Tile.get(node);
        if (!(view === null || view === void 0 ? void 0 : view.isWidget())) return false;
        if (view) (widgets || (widgets = [])).push(view);
    }
    if (widgets) for (let w of widgets){
        let override = w.overrideDOMText;
        if (override === null || override === void 0 ? void 0 : override.length) return false;
    }
    return true;
}
class $7beee9608540d2c3$var$DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
class $7beee9608540d2c3$var$DOMChange {
    constructor(view, start, end, typeOver){
        this.typeOver = typeOver;
        this.bounds = null;
        this.text = "";
        this.domChanged = start > -1;
        let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
        if (view.state.readOnly && start > -1) // Ignore changes when the editor is read-only
        this.newSel = null;
        else if (start > -1 && (this.bounds = $7beee9608540d2c3$var$domBoundsAround(view.docView.tile, start, end, 0))) {
            let selPoints = iHead || iAnchor ? [] : $7beee9608540d2c3$var$selectionPoints(view);
            let reader = new $7beee9608540d2c3$var$DOMReader(selPoints, view.state);
            reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
            this.text = reader.text;
            this.newSel = $7beee9608540d2c3$var$selectionFromPoints(selPoints, this.bounds.from);
        } else {
            let domSel = view.observer.selectionRange;
            let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !$7beee9608540d2c3$var$contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
            let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !$7beee9608540d2c3$var$contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
            // iOS will refuse to select the block gaps when doing
            // select-all.
            // Chrome will put the selection *inside* them, confusing
            // posFromDOM
            let vp = view.viewport;
            if (($7beee9608540d2c3$var$browser.ios || $7beee9608540d2c3$var$browser.chrome) && view.state.selection.main.empty && head != anchor && (vp.from > 0 || vp.to < view.state.doc.length)) {
                let from = Math.min(head, anchor), to = Math.max(head, anchor);
                let offFrom = vp.from - from, offTo = vp.to - to;
                if ((offFrom == 0 || offFrom == 1 || from == 0) && (offTo == 0 || offTo == -1 || to == view.state.doc.length)) {
                    head = 0;
                    anchor = view.state.doc.length;
                }
            }
            if (view.inputState.composing > -1 && view.state.selection.ranges.length > 1) this.newSel = view.state.selection.replaceRange((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(anchor, head));
            else this.newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(anchor, head);
        }
    }
}
function $7beee9608540d2c3$var$domBoundsAround(tile, from, to, offset) {
    if (tile.isComposite()) {
        let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(let i = 0, pos = offset, prevEnd = offset; i < tile.children.length; i++){
            let child = tile.children[i], end = pos + child.length;
            if (pos < from && end > to) return $7beee9608540d2c3$var$domBoundsAround(child, from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == tile.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + tile.length : toEnd,
            startDOM: (fromI ? tile.children[fromI - 1].dom.nextSibling : null) || tile.dom.firstChild,
            endDOM: toI < tile.children.length && toI >= 0 ? tile.children[toI].dom : null
        };
    } else if (tile.isText()) return {
        from: offset,
        to: offset + tile.length,
        startDOM: tile.dom,
        endDOM: tile.dom.nextSibling
    };
    else return null;
}
function $7beee9608540d2c3$var$applyDOMChange(view, domChange) {
    let change;
    let { newSel: newSel } = domChange, sel = view.state.selection.main;
    let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
    if (domChange.bounds) {
        let { from: from, to: to } = domChange.bounds;
        let preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (lastKey === 8 || $7beee9608540d2c3$var$browser.android && domChange.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        let diff = $7beee9608540d2c3$var$findDiff(view.state.doc.sliceString(from, to, $7beee9608540d2c3$var$LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
        if (diff) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. DomChange drops one of those.
            if ($7beee9608540d2c3$var$browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == $7beee9608540d2c3$var$LineBreakPlaceholder + $7beee9608540d2c3$var$LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(domChange.text.slice(diff.from, diff.toB).split($7beee9608540d2c3$var$LineBreakPlaceholder))
            };
        }
    } else if (newSel && (!view.hasFocus && view.state.facet($7beee9608540d2c3$var$editable) || newSel.main.eq(sel))) newSel = null;
    if (!change && !newSel) return false;
    if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) // Heuristic to notice typing over a selected character
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, sel.to)
    };
    else if (($7beee9608540d2c3$var$browser.mac || $7beee9608540d2c3$var$browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
        // Detect insert-period-on-double-space Mac and Android behavior,
        // and transform it into a regular space insert.
        if (newSel && change.insert.length == 2) newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: change.from,
            to: change.to,
            insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                change.insert.toString().replace(".", " ")
            ])
        };
    } else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) // If the change is inside the selection and covers most of it,
    // assume it is a selection replace (with identical characters at
    // the start/end not included in the diff)
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
    else if (view.state.doc.lineAt(sel.from).to < sel.to && view.docView.lineHasWidget(sel.to) && view.inputState.insertingTextAt > Date.now() - 50) // For a cross-line insertion, Chrome and Safari will crudely take
    // the text of the line after the selection, flattening any
    // widgets, and move it into the joined line. This tries to detect
    // such a situation, and replaces the change with a selection
    // replace of the text provided by the beforeinput event.
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.toText(view.inputState.insertingText)
    };
    else if ($7beee9608540d2c3$var$browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
        // In Chrome, if you insert a space at the start of a wrapped
        // line, it will actually insert a newline and a space, causing a
        // bogus new line to be created in CodeMirror (#968)
        if (newSel) newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                " "
            ])
        };
    }
    if (change) return $7beee9608540d2c3$var$applyDOMChangeInner(view, change, newSel, lastKey);
    else if (newSel && !newSel.main.eq(sel)) {
        let scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
            if (userEvent == "select.pointer") newSel = $7beee9608540d2c3$var$skipAtomsForSelection(view.state.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view)), newSel);
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView: scrollIntoView,
            userEvent: userEvent
        });
        return true;
    } else return false;
}
function $7beee9608540d2c3$var$applyDOMChangeInner(view, change, newSel, lastKey = -1) {
    if ($7beee9608540d2c3$var$browser.ios && view.inputState.flushIOSKey(change)) return true;
    let sel = view.state.selection.main;
    // Android browsers don't fire reasonable key events for enter,
    // backspace, or delete. So this detects changes that look like
    // they're caused by those keys, and reinterprets them as key
    // events. (Some of these keys are also handled by beforeinput
    // events and the pendingAndroidKey mechanism, but that's not
    // reliable in all situations.)
    if ($7beee9608540d2c3$var$browser.android && (change.to == sel.to && // GBoard will sometimes remove a space it just inserted
    // after a completion when you press enter
    (change.from == sel.from || change.from == sel.from - 1 && view.state.sliceDoc(change.from, sel.from) == " ") && change.insert.length == 1 && change.insert.lines == 2 && $7beee9608540d2c3$var$dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from && change.to > sel.head) && $7beee9608540d2c3$var$dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && $7beee9608540d2c3$var$dispatchKey(view.contentDOM, "Delete", 46))) return true;
    let text = change.insert.toString();
    if (view.inputState.composing >= 0) view.inputState.composing++;
    let defaultTr;
    let defaultInsert = ()=>defaultTr || (defaultTr = $7beee9608540d2c3$var$applyDefaultInsert(view, change, newSel));
    if (!view.state.facet($7beee9608540d2c3$var$inputHandler).some((h)=>h(view, change.from, change.to, text, defaultInsert))) view.dispatch(defaultInsert());
    return true;
}
function $7beee9608540d2c3$var$applyDefaultInsert(view, change, newSel) {
    let tr, startState = view.state, sel = startState.selection.main, inAtomic = -1;
    if (change.from == change.to && change.from < sel.from || change.from > sel.to) {
        let side = change.from < sel.from ? -1 : 1, pos = side < 0 ? sel.from : sel.to;
        let moved = $7beee9608540d2c3$var$skipAtomicRanges(startState.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view)), pos, side);
        if (change.from == moved) inAtomic = moved;
    }
    if (inAtomic > -1) tr = {
        changes: change,
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(change.from + change.insert.length, -1)
    };
    else if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
        let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
        let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
        tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
    } else {
        let changes = startState.changes(change);
        let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : undefined;
        // Try to apply a composition change to all cursors
        if (startState.selection.ranges.length > 1 && (view.inputState.composing >= 0 || view.inputState.compositionPendingChange) && change.to <= sel.to + 10 && change.to >= sel.to - 10) {
            let replaced = view.state.sliceDoc(change.from, change.to);
            let compositionRange, composition = newSel && $7beee9608540d2c3$var$findCompositionNode(view, newSel.main.head);
            if (composition) {
                let dLen = change.insert.length - (change.to - change.from);
                compositionRange = {
                    from: composition.from,
                    to: composition.to - dLen
                };
            } else compositionRange = view.state.doc.lineAt(sel.head);
            let offset = sel.to - change.to;
            tr = startState.changeByRange((range)=>{
                if (range.from == sel.from && range.to == sel.to) return {
                    changes: changes,
                    range: mainSel || range.map(changes)
                };
                let to = range.to - offset, from = to - replaced.length;
                if (view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                // changes in the same node work without aborting
                // composition, so cursors in the composition range are
                // ignored.
                to >= compositionRange.from && from <= compositionRange.to) return {
                    range: range
                };
                let rangeChanges = startState.changes({
                    from: from,
                    to: to,
                    insert: change.insert
                }), selOff = range.to - sel.to;
                return {
                    changes: rangeChanges,
                    range: !mainSel ? range.map(rangeChanges) : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                };
            });
        } else tr = {
            changes: changes,
            selection: mainSel && startState.selection.replaceRange(mainSel)
        };
    }
    let userEvent = "input.type";
    if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
        view.inputState.compositionPendingChange = false;
        userEvent += ".compose";
        if (view.inputState.compositionFirstChange) {
            userEvent += ".start";
            view.inputState.compositionFirstChange = false;
        }
    }
    return startState.update(tr, {
        userEvent: userEvent,
        scrollIntoView: true
    });
}
function $7beee9608540d2c3$var$findDiff(a, b, preferredPos, preferredSide) {
    let minLen = Math.min(a.length, b.length);
    let from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    let toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        let adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from: from,
        toA: toA,
        toB: toB
    };
}
function $7beee9608540d2c3$var$selectionPoints(view) {
    let result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    let { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = view.observer.selectionRange;
    if (anchorNode) {
        result.push(new $7beee9608540d2c3$var$DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new $7beee9608540d2c3$var$DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function $7beee9608540d2c3$var$selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(anchor + base, head + base) : null;
}
class $7beee9608540d2c3$var$InputState {
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    constructor(view){
        this.view = view;
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.lastTouchTime = 0;
        this.lastFocusTime = 0;
        this.lastScrollTop = 0;
        this.lastScrollLeft = 0;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        /**
        When enabled (>-1), tab presses are not given to key handlers,
        leaving the browser's default behavior. If >0, the mode expires
        at that timestamp, and any other keypress clears it.
        Esc enables temporary tab focus mode for two seconds when not
        otherwise handled.
        */ this.tabFocusMode = -1;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.handlers = Object.create(null);
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        // End time of the previous composition
        this.compositionEndedAt = 0;
        // Used in a kludge to detect when an Enter keypress should be
        // considered part of the composition on Safari, which fires events
        // in the wrong order
        this.compositionPendingKey = false;
        // Used to categorize changes as part of a composition, even when
        // the mutation events fire shortly after the compositionend event
        this.compositionPendingChange = false;
        // Set by beforeinput, used in DOM change reader
        this.insertingText = "";
        this.insertingTextAt = 0;
        this.mouseSelection = null;
        // When a drag from the editor is active, this points at the range
        // being dragged.
        this.draggedContent = null;
        this.handleEvent = this.handleEvent.bind(this);
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if ($7beee9608540d2c3$var$browser.safari) view.contentDOM.addEventListener("input", ()=>null);
        if ($7beee9608540d2c3$var$browser.gecko) $7beee9608540d2c3$var$firefoxCopyCutHack(view.contentDOM.ownerDocument);
    }
    handleEvent(event) {
        if (!$7beee9608540d2c3$var$eventBelongsToEditor(this.view, event) || this.ignoreDuringComposition(event)) return;
        if (event.type == "keydown" && this.keydown(event)) return;
        if (this.view.updateState != 0 /* UpdateState.Idle */ ) Promise.resolve().then(()=>this.runHandlers(event.type, event));
        else this.runHandlers(event.type, event);
    }
    runHandlers(type, event) {
        let handlers = this.handlers[type];
        if (handlers) {
            for (let observer of handlers.observers)observer(this.view, event);
            for (let handler of handlers.handlers){
                if (event.defaultPrevented) break;
                if (handler(this.view, event)) {
                    event.preventDefault();
                    break;
                }
            }
        }
    }
    ensureHandlers(plugins) {
        let handlers = $7beee9608540d2c3$var$computeHandlers(plugins), prev = this.handlers, dom = this.view.contentDOM;
        for(let type in handlers)if (type != "scroll") {
            let passive = !handlers[type].handlers.length;
            let exists = prev[type];
            if (exists && passive != !exists.handlers.length) {
                dom.removeEventListener(type, this.handleEvent);
                exists = null;
            }
            if (!exists) dom.addEventListener(type, this.handleEvent, {
                passive: passive
            });
        }
        for(let type in prev)if (type != "scroll" && !handlers[type]) dom.removeEventListener(type, this.handleEvent);
        this.handlers = handlers;
    }
    keydown(event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode)) return true;
        if (this.tabFocusMode > 0 && event.keyCode != 27 && $7beee9608540d2c3$var$modifierCodes.indexOf(event.keyCode) < 0) this.tabFocusMode = -1;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if ($7beee9608540d2c3$var$browser.android && $7beee9608540d2c3$var$browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            this.view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Preventing the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        let pending;
        if ($7beee9608540d2c3$var$browser.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = $7beee9608540d2c3$var$PendingKeys.find((key)=>key.keyCode == event.keyCode)) && !event.ctrlKey || $7beee9608540d2c3$var$EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
            this.pendingIOSKey = pending || event;
            setTimeout(()=>this.flushIOSKey(), 250);
            return true;
        }
        if (event.keyCode != 229) this.view.observer.forceFlush();
        return false;
    }
    flushIOSKey(change) {
        let key = this.pendingIOSKey;
        if (!key) return false;
        // This looks like an autocorrection before Enter
        if (key.key == "Enter" && change && change.from < change.to && /^\S+$/.test(change.insert.toString())) return false;
        this.pendingIOSKey = undefined;
        return $7beee9608540d2c3$var$dispatchKey(this.view.contentDOM, key.key, key.keyCode, key instanceof KeyboardEvent ? key : undefined);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type) || event.synthetic) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if ($7beee9608540d2c3$var$browser.safari && !$7beee9608540d2c3$var$browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
            this.compositionPendingKey = false;
            return true;
        }
        return false;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        this.view.observer.update(update);
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (this.draggedContent && update.docChanged) this.draggedContent = this.draggedContent.map(update.changes);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
}
function $7beee9608540d2c3$var$bindHandler(plugin, handler) {
    return (view, event)=>{
        try {
            return handler.call(plugin, event, view);
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e);
        }
    };
}
function $7beee9608540d2c3$var$computeHandlers(plugins) {
    let result = Object.create(null);
    function record(type) {
        return result[type] || (result[type] = {
            observers: [],
            handlers: []
        });
    }
    for (let plugin of plugins){
        let spec = plugin.spec, handlers = spec && spec.plugin.domEventHandlers, observers = spec && spec.plugin.domEventObservers;
        if (handlers) for(let type in handlers){
            let f = handlers[type];
            if (f) record(type).handlers.push($7beee9608540d2c3$var$bindHandler(plugin.value, f));
        }
        if (observers) for(let type in observers){
            let f = observers[type];
            if (f) record(type).observers.push($7beee9608540d2c3$var$bindHandler(plugin.value, f));
        }
    }
    for(let type in $7beee9608540d2c3$var$handlers)record(type).handlers.push($7beee9608540d2c3$var$handlers[type]);
    for(let type in $7beee9608540d2c3$var$observers)record(type).observers.push($7beee9608540d2c3$var$observers[type]);
    return result;
}
const $7beee9608540d2c3$var$PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertLineBreak"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
const $7beee9608540d2c3$var$EmacsyPendingKeys = "dthko";
// Key codes for modifier keys
const $7beee9608540d2c3$var$modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
const $7beee9608540d2c3$var$dragScrollMargin = 6;
function $7beee9608540d2c3$var$dragScrollSpeed(dist) {
    return Math.max(0, dist) * 0.7 + 8;
}
function $7beee9608540d2c3$var$dist(a, b) {
    return Math.max(Math.abs(a.clientX - b.clientX), Math.abs(a.clientY - b.clientY));
}
class $7beee9608540d2c3$var$MouseSelection {
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.startEvent = startEvent;
        this.style = style;
        this.mustSelect = mustSelect;
        this.scrollSpeed = {
            x: 0,
            y: 0
        };
        this.scrolling = -1;
        this.lastEvent = startEvent;
        this.scrollParents = $7beee9608540d2c3$var$scrollableParents(view.contentDOM);
        this.atoms = view.state.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view));
        let doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).allowMultipleSelections) && $7beee9608540d2c3$var$addsSelectionRange(view, startEvent);
        this.dragging = $7beee9608540d2c3$var$isInPrimarySelection(view, startEvent) && $7beee9608540d2c3$var$getClickType(startEvent) == 1 ? null : false;
    }
    start(event) {
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) this.select(event);
    }
    move(event) {
        if (event.buttons == 0) return this.destroy();
        if (this.dragging || this.dragging == null && $7beee9608540d2c3$var$dist(this.startEvent, event) < 10) return;
        this.select(this.lastEvent = event);
        let sx = 0, sy = 0;
        let left = 0, top = 0, right = this.view.win.innerWidth, bottom = this.view.win.innerHeight;
        if (this.scrollParents.x) ({ left: left, right: right } = this.scrollParents.x.getBoundingClientRect());
        if (this.scrollParents.y) ({ top: top, bottom: bottom } = this.scrollParents.y.getBoundingClientRect());
        let margins = $7beee9608540d2c3$var$getScrollMargins(this.view);
        if (event.clientX - margins.left <= left + $7beee9608540d2c3$var$dragScrollMargin) sx = -$7beee9608540d2c3$var$dragScrollSpeed(left - event.clientX);
        else if (event.clientX + margins.right >= right - $7beee9608540d2c3$var$dragScrollMargin) sx = $7beee9608540d2c3$var$dragScrollSpeed(event.clientX - right);
        if (event.clientY - margins.top <= top + $7beee9608540d2c3$var$dragScrollMargin) sy = -$7beee9608540d2c3$var$dragScrollSpeed(top - event.clientY);
        else if (event.clientY + margins.bottom >= bottom - $7beee9608540d2c3$var$dragScrollMargin) sy = $7beee9608540d2c3$var$dragScrollSpeed(event.clientY - bottom);
        this.setScrollSpeed(sx, sy);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        this.setScrollSpeed(0, 0);
        let doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
    }
    setScrollSpeed(sx, sy) {
        this.scrollSpeed = {
            x: sx,
            y: sy
        };
        if (sx || sy) {
            if (this.scrolling < 0) this.scrolling = setInterval(()=>this.scroll(), 50);
        } else if (this.scrolling > -1) {
            clearInterval(this.scrolling);
            this.scrolling = -1;
        }
    }
    scroll() {
        let { x: x, y: y } = this.scrollSpeed;
        if (x && this.scrollParents.x) {
            this.scrollParents.x.scrollLeft += x;
            x = 0;
        }
        if (y && this.scrollParents.y) {
            this.scrollParents.y.scrollTop += y;
            y = 0;
        }
        if (x || y) this.view.win.scrollBy(x, y);
        if (this.dragging === false) this.select(this.lastEvent);
    }
    select(event) {
        let { view: view } = this, selection = $7beee9608540d2c3$var$skipAtomsForSelection(this.atoms, this.style.get(event, this.extend, this.multiple));
        if (this.mustSelect || !selection.eq(view.state.selection, this.dragging === false)) this.view.dispatch({
            selection: selection,
            userEvent: "select.pointer"
        });
        this.mustSelect = false;
    }
    update(update) {
        if (update.transactions.some((tr)=>tr.isUserEvent("input.type"))) this.destroy();
        else if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
}
function $7beee9608540d2c3$var$addsSelectionRange(view, event) {
    let facet = view.state.facet($7beee9608540d2c3$var$clickAddsSelectionRange);
    return facet.length ? facet[0](event) : $7beee9608540d2c3$var$browser.mac ? event.metaKey : event.ctrlKey;
}
function $7beee9608540d2c3$var$dragMovesSelection(view, event) {
    let facet = view.state.facet($7beee9608540d2c3$var$dragMovesSelection$1);
    return facet.length ? facet[0](event) : $7beee9608540d2c3$var$browser.mac ? !event.altKey : !event.ctrlKey;
}
function $7beee9608540d2c3$var$isInPrimarySelection(view, event) {
    let { main: main } = view.state.selection;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    let sel = $7beee9608540d2c3$var$getSelection(view.root);
    if (!sel || sel.rangeCount == 0) return true;
    let rects = sel.getRangeAt(0).getClientRects();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function $7beee9608540d2c3$var$eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target, tile; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (tile = $7beee9608540d2c3$var$Tile.get(node)) && tile.isWidget() && tile.widget.ignoreEvent(event)) return false;
    return true;
}
const $7beee9608540d2c3$var$handlers = /*@__PURE__*/ Object.create(null);
const $7beee9608540d2c3$var$observers = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $7beee9608540d2c3$var$brokenClipboardAPI = $7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version < 15 || $7beee9608540d2c3$var$browser.ios && $7beee9608540d2c3$var$browser.webkit_version < 604;
function $7beee9608540d2c3$var$capturePaste(view) {
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        $7beee9608540d2c3$var$doPaste(view, target.value);
    }, 50);
}
function $7beee9608540d2c3$var$textFilter(state, facet, text) {
    for (let filter of state.facet(facet))text = filter(text, state);
    return text;
}
function $7beee9608540d2c3$var$doPaste(view, input) {
    input = $7beee9608540d2c3$var$textFilter(view.state, $7beee9608540d2c3$var$clipboardInputFilter, input);
    let { state: state } = view, changes, i = 1, text = state.toText(input);
    let byLine = text.lines == state.selection.ranges.length;
    let linewise = $7beee9608540d2c3$var$lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && $7beee9608540d2c3$var$lastLinewiseCopy == text.toString();
    if (linewise) {
        let lastLine = -1;
        changes = state.changeByRange((range)=>{
            let line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range: range
            };
            lastLine = line.from;
            let insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert: insert
                },
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        let line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
$7beee9608540d2c3$var$observers.scroll = (view)=>{
    view.inputState.lastScrollTop = view.scrollDOM.scrollTop;
    view.inputState.lastScrollLeft = view.scrollDOM.scrollLeft;
};
$7beee9608540d2c3$var$handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27 && view.inputState.tabFocusMode != 0) view.inputState.tabFocusMode = Date.now() + 2000;
    return false;
};
$7beee9608540d2c3$var$observers.touchstart = (view, e)=>{
    view.inputState.lastTouchTime = Date.now();
    view.inputState.setSelectionOrigin("select.pointer");
};
$7beee9608540d2c3$var$observers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
$7beee9608540d2c3$var$handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if (view.inputState.lastTouchTime > Date.now() - 2000) return false; // Ignore touch interaction
    let style = null;
    for (let makeStyle of view.state.facet($7beee9608540d2c3$var$mouseSelectionStyle)){
        style = makeStyle(view, event);
        if (style) break;
    }
    if (!style && event.button == 0) style = $7beee9608540d2c3$var$basicMouseSelection(view, event);
    if (style) {
        let mustFocus = !view.hasFocus;
        view.inputState.startMouseSelection(new $7beee9608540d2c3$var$MouseSelection(view, event, style, mustFocus));
        if (mustFocus) view.observer.ignore(()=>{
            $7beee9608540d2c3$var$focusPreventScroll(view.contentDOM);
            let active = view.root.activeElement;
            if (active && !active.contains(view.contentDOM)) active.blur();
        });
        let mouseSel = view.inputState.mouseSelection;
        if (mouseSel) {
            mouseSel.start(event);
            return mouseSel.dragging === false;
        }
    } else view.inputState.setSelectionOrigin("select.pointer");
    return false;
};
function $7beee9608540d2c3$var$rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, bias);
    else if (type == 2) return $7beee9608540d2c3$var$groupAt(view.state, pos, bias);
    else {
        let visual = view.docView.lineAt(pos), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        let from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, to);
    }
}
let $7beee9608540d2c3$var$inside = (x, y, rect)=>y >= rect.top && y <= rect.bottom && x >= rect.left && x <= rect.right;
// Try to determine, for the given coordinates, associated with the
// given position, whether they are related to the element before or
// the element after the position.
function $7beee9608540d2c3$var$findPositionSide(view, pos, x, y) {
    let line = view.docView.lineAt(pos);
    if (!line) return 1;
    let off = pos - line.posAtStart;
    // Line boundaries point into the line
    if (off == 0) return 1;
    if (off == line.length) return -1;
    // Positions on top of an element point at that element
    let before = line.coordsIn(off, -1);
    if (before && $7beee9608540d2c3$var$inside(x, y, before)) return -1;
    let after = line.coordsIn(off, 1);
    if (after && $7beee9608540d2c3$var$inside(x, y, after)) return 1;
    // This is probably a line wrap point. Pick before if the point is
    // above its bottom.
    return before && before.bottom >= y ? -1 : 1;
}
function $7beee9608540d2c3$var$queryPos(view, event) {
    let pos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    return {
        pos: pos,
        bias: $7beee9608540d2c3$var$findPositionSide(view, pos, event.clientX, event.clientY)
    };
}
const $7beee9608540d2c3$var$BadMouseDetail = $7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11;
let $7beee9608540d2c3$var$lastMouseDown = null, $7beee9608540d2c3$var$lastMouseDownCount = 0, $7beee9608540d2c3$var$lastMouseDownTime = 0;
function $7beee9608540d2c3$var$getClickType(event) {
    if (!$7beee9608540d2c3$var$BadMouseDetail) return event.detail;
    let last = $7beee9608540d2c3$var$lastMouseDown, lastTime = $7beee9608540d2c3$var$lastMouseDownTime;
    $7beee9608540d2c3$var$lastMouseDown = event;
    $7beee9608540d2c3$var$lastMouseDownTime = Date.now();
    return $7beee9608540d2c3$var$lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? ($7beee9608540d2c3$var$lastMouseDownCount + 1) % 3 : 1;
}
function $7beee9608540d2c3$var$basicMouseSelection(view, event) {
    let start = $7beee9608540d2c3$var$queryPos(view, event), type = $7beee9608540d2c3$var$getClickType(event);
    let startSel = view.state.selection;
    return {
        update (update) {
            if (update.docChanged) {
                start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
            }
        },
        get (event, extend, multiple) {
            let cur = $7beee9608540d2c3$var$queryPos(view, event), removed;
            let range = $7beee9608540d2c3$var$rangeForClick(view, cur.pos, cur.bias, type);
            if (start.pos != cur.pos && !extend) {
                let startRange = $7beee9608540d2c3$var$rangeForClick(view, start.pos, start.bias, type);
                let from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, to) : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(to, from);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to));
            else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = $7beee9608540d2c3$var$removeRangeAround(startSel, cur.pos))) return removed;
            else if (multiple) return startSel.addRange(range);
            else return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
                range
            ]);
        }
    };
}
function $7beee9608540d2c3$var$removeRangeAround(sel, pos) {
    for(let i = 0; i < sel.ranges.length; i++){
        let { from: from, to: to } = sel.ranges[i];
        if (from <= pos && to >= pos) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(sel.ranges.slice(0, i).concat(sel.ranges.slice(i + 1)), sel.mainIndex == i ? 0 : sel.mainIndex - (sel.mainIndex > i ? 1 : 0));
    }
    return null;
}
$7beee9608540d2c3$var$handlers.dragstart = (view, event)=>{
    let { selection: { main: range } } = view.state;
    if (event.target.draggable) {
        let tile = view.docView.tile.nearest(event.target);
        if (tile && tile.isWidget()) {
            let from = tile.posAtStart, to = from + tile.length;
            if (from >= range.to || to <= range.from) range = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, to);
        }
    }
    let { inputState: inputState } = view;
    if (inputState.mouseSelection) inputState.mouseSelection.dragging = true;
    inputState.draggedContent = range;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", $7beee9608540d2c3$var$textFilter(view.state, $7beee9608540d2c3$var$clipboardOutputFilter, view.state.sliceDoc(range.from, range.to)));
        event.dataTransfer.effectAllowed = "copyMove";
    }
    return false;
};
$7beee9608540d2c3$var$handlers.dragend = (view)=>{
    view.inputState.draggedContent = null;
    return false;
};
function $7beee9608540d2c3$var$dropText(view, event, text, direct) {
    text = $7beee9608540d2c3$var$textFilter(view.state, $7beee9608540d2c3$var$clipboardInputFilter, text);
    if (!text) return;
    let dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let { draggedContent: draggedContent } = view.inputState;
    let del = direct && draggedContent && $7beee9608540d2c3$var$dragMovesSelection(view, event) ? {
        from: draggedContent.from,
        to: draggedContent.to
    } : null;
    let ins = {
        from: dropPos,
        insert: text
    };
    let changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes: changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
    view.inputState.draggedContent = null;
}
$7beee9608540d2c3$var$handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return false;
    if (view.state.readOnly) return true;
    let files = event.dataTransfer.files;
    if (files && files.length) {
        let text = Array(files.length), read = 0;
        let finishFile = ()=>{
            if (++read == files.length) $7beee9608540d2c3$var$dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(let i = 0; i < files.length; i++){
            let reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        }
        return true;
    } else {
        let text = event.dataTransfer.getData("Text");
        if (text) {
            $7beee9608540d2c3$var$dropText(view, event, text, true);
            return true;
        }
    }
    return false;
};
$7beee9608540d2c3$var$handlers.paste = (view, event)=>{
    if (view.state.readOnly) return true;
    view.observer.flush();
    let data = $7beee9608540d2c3$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        $7beee9608540d2c3$var$doPaste(view, data.getData("text/plain") || data.getData("text/uri-list"));
        return true;
    } else {
        $7beee9608540d2c3$var$capturePaste(view);
        return false;
    }
};
function $7beee9608540d2c3$var$captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function $7beee9608540d2c3$var$copiedRange(state) {
    let content = [], ranges = [], linewise = false;
    for (let range of state.selection.ranges)if (!range.empty) {
        content.push(state.sliceDoc(range.from, range.to));
        ranges.push(range);
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        let upto = -1;
        for (let { from: from } of state.selection.ranges){
            let line = state.doc.lineAt(from);
            if (line.number > upto) {
                content.push(line.text);
                ranges.push({
                    from: line.from,
                    to: Math.min(state.doc.length, line.to + 1)
                });
            }
            upto = line.number;
        }
        linewise = true;
    }
    return {
        text: $7beee9608540d2c3$var$textFilter(state, $7beee9608540d2c3$var$clipboardOutputFilter, content.join(state.lineBreak)),
        ranges: ranges,
        linewise: linewise
    };
}
let $7beee9608540d2c3$var$lastLinewiseCopy = null;
$7beee9608540d2c3$var$handlers.copy = $7beee9608540d2c3$var$handlers.cut = (view, event)=>{
    let { text: text, ranges: ranges, linewise: linewise } = $7beee9608540d2c3$var$copiedRange(view.state);
    if (!text && !linewise) return false;
    $7beee9608540d2c3$var$lastLinewiseCopy = linewise ? text : null;
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
    let data = $7beee9608540d2c3$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        data.clearData();
        data.setData("text/plain", text);
        return true;
    } else {
        $7beee9608540d2c3$var$captureCopy(view, text);
        return false;
    }
};
const $7beee9608540d2c3$var$isFocusChange = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
function $7beee9608540d2c3$var$focusChangeTransaction(state, focus) {
    let effects = [];
    for (let getEffect of state.facet($7beee9608540d2c3$var$focusChangeEffect)){
        let effect = getEffect(state, focus);
        if (effect) effects.push(effect);
    }
    return effects.length ? state.update({
        effects: effects,
        annotations: $7beee9608540d2c3$var$isFocusChange.of(true)
    }) : null;
}
function $7beee9608540d2c3$var$updateForFocusChange(view) {
    setTimeout(()=>{
        let focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            let tr = $7beee9608540d2c3$var$focusChangeTransaction(view.state, focus);
            if (tr) view.dispatch(tr);
            else view.update([]);
        }
    }, 10);
}
$7beee9608540d2c3$var$observers.focus = (view)=>{
    view.inputState.lastFocusTime = Date.now();
    // When focusing reset the scroll position, move it back to where it was
    if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
        view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
        view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
    }
    $7beee9608540d2c3$var$updateForFocusChange(view);
};
$7beee9608540d2c3$var$observers.blur = (view)=>{
    view.observer.clearSelectionRange();
    $7beee9608540d2c3$var$updateForFocusChange(view);
};
$7beee9608540d2c3$var$observers.compositionstart = $7beee9608540d2c3$var$observers.compositionupdate = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) // FIXME possibly set a timeout to clear it again on Android
    view.inputState.composing = 0;
};
$7beee9608540d2c3$var$observers.compositionend = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionPendingKey = true;
    view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
    view.inputState.compositionFirstChange = null;
    if ($7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$browser.android) // Delay flushing for a bit on Android because it'll often fire a
    // bunch of contradictory changes in a row at end of compositon
    view.observer.flushSoon();
    else if (view.inputState.compositionPendingChange) // If we found pending records, schedule a flush.
    Promise.resolve().then(()=>view.observer.flush());
    else // Otherwise, make sure that, if no changes come in soon, the
    // composition view is cleared.
    setTimeout(()=>{
        if (view.inputState.composing < 0 && view.docView.hasComposition) view.update([]);
    }, 50);
};
$7beee9608540d2c3$var$observers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
$7beee9608540d2c3$var$handlers.beforeinput = (view, event)=>{
    var _a, _b;
    if (event.inputType == "insertText" || event.inputType == "insertCompositionText") {
        view.inputState.insertingText = event.data;
        view.inputState.insertingTextAt = Date.now();
    }
    // In EditContext mode, we must handle insertReplacementText events
    // directly, to make spell checking corrections work
    if (event.inputType == "insertReplacementText" && view.observer.editContext) {
        let text = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("text/plain"), ranges = event.getTargetRanges();
        if (text && ranges.length) {
            let r = ranges[0];
            let from = view.posAtDOM(r.startContainer, r.startOffset), to = view.posAtDOM(r.endContainer, r.endOffset);
            $7beee9608540d2c3$var$applyDOMChangeInner(view, {
                from: from,
                to: to,
                insert: view.state.toText(text)
            }, null);
            return true;
        }
    }
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    let pending;
    if ($7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$browser.android && (pending = $7beee9608540d2c3$var$PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            let startViewHeight = ((_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
    if ($7beee9608540d2c3$var$browser.ios && event.inputType == "deleteContentForward") // For some reason, DOM changes (and beforeinput) happen _before_
    // the key event for ctrl-d on iOS when using an external
    // keyboard.
    view.observer.flushSoon();
    // Safari will occasionally forget to fire compositionend at the end of a dead-key composition
    if ($7beee9608540d2c3$var$browser.safari && event.inputType == "insertText" && view.inputState.composing >= 0) setTimeout(()=>$7beee9608540d2c3$var$observers.compositionend(view, event), 20);
    return false;
};
const $7beee9608540d2c3$var$appliedFirefoxHack = /*@__PURE__*/ new Set;
// In Firefox, when cut/copy handlers are added to the document, that
// somehow avoids a bug where those events aren't fired when the
// selection is empty. See https://github.com/codemirror/dev/issues/1082
// and https://bugzilla.mozilla.org/show_bug.cgi?id=995961
function $7beee9608540d2c3$var$firefoxCopyCutHack(doc) {
    if (!$7beee9608540d2c3$var$appliedFirefoxHack.has(doc)) {
        $7beee9608540d2c3$var$appliedFirefoxHack.add(doc);
        doc.addEventListener("copy", ()=>{});
        doc.addEventListener("cut", ()=>{});
    }
}
const $7beee9608540d2c3$var$wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
// Used to track, during updateHeight, if any actual heights changed
let $7beee9608540d2c3$var$heightChangeFlag = false;
function $7beee9608540d2c3$var$clearHeightChangeFlag() {
    $7beee9608540d2c3$var$heightChangeFlag = false;
}
class $7beee9608540d2c3$var$HeightOracle {
    constructor(lineWrapping){
        this.lineWrapping = lineWrapping;
        this.doc = (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
        this.heightSamples = {};
        this.lineHeight = 14; // The height of an entire line (line-height)
        this.charWidth = 7;
        this.textHeight = 14; // The height of the actual font (font-size)
        this.lineLength = 30;
    }
    heightForGap(from, to) {
        let lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.max(0, Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength));
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / Math.max(1, this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return $7beee9608540d2c3$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        let newHeight = false;
        for(let i = 0; i < lineHeights.length; i++){
            let h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
        let lineWrapping = $7beee9608540d2c3$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        let changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.textHeight = textHeight;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(let i = 0; i < knownHeights.length; i++){
                let h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nodes. The `heights` array is a sequence of
// block heights, starting from position `from`.
class $7beee9608540d2c3$var$MeasuredHeights {
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
    get more() {
        return this.index < this.heights.length;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class $7beee9608540d2c3$export$ddfdc4ccfe9512bd {
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    @internal Weird packed field that holds an array of children
    for composite blocks, a decoration for block widgets, and a
    number indicating the amount of widget-created line breaks for
    text blocks.
    */ _content){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this._content = _content;
    }
    /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ get type() {
        return typeof this._content == "number" ? $7beee9608540d2c3$export$48808c686fe495c4.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    If this is a widget block, this will return the widget
    associated with it.
    */ get widget() {
        return this._content instanceof $7beee9608540d2c3$var$PointDecoration ? this._content.widget : null;
    }
    /**
    If this is a textblock, this holds the number of line breaks
    that appear in widgets inside the block.
    */ get widgetLineBreaks() {
        return typeof this._content == "number" ? this._content : 0;
    }
    /**
    @internal
    */ join(other) {
        let content = (Array.isArray(this._content) ? this._content : [
            this
        ]).concat(Array.isArray(other._content) ? other._content : [
            other
        ]);
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(this.from, this.length + other.length, this.top, this.height + other.height, content);
    }
}
var $7beee9608540d2c3$var$QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}($7beee9608540d2c3$var$QueryType || ($7beee9608540d2c3$var$QueryType = {}));
const $7beee9608540d2c3$var$Epsilon = 1e-3;
class $7beee9608540d2c3$var$HeightMap {
    constructor(length, height, flags = 2 /* Flag.Outdated */ ){
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
    get outdated() {
        return (this.flags & 2 /* Flag.Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Flag.Outdated */  : 0) | this.flags & -3 /* Flag.Outdated */ ;
    }
    setHeight(height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > $7beee9608540d2c3$var$Epsilon) $7beee9608540d2c3$var$heightChangeFlag = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return $7beee9608540d2c3$var$HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        let me = this, doc = oracle.doc;
        for(let i = changes.length - 1; i >= 0; i--){
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = changes[i];
            let start = me.lineAt(fromA, $7beee9608540d2c3$var$QueryType.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
            let end = start.to >= toA ? start : me.lineAt(toA, $7beee9608540d2c3$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, $7beee9608540d2c3$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            let nodes = $7beee9608540d2c3$var$NodeBuilder.build(oracle.setDoc(doc), decorations, fromB, toB);
            me = $7beee9608540d2c3$var$replace(me, me.replace(fromA, toA, nodes));
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new $7beee9608540d2c3$var$HeightMapText(0, 0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        let i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    let split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    let split = nodes[j];
                    if (split.break) nodes.splice(j, 1, split.left, null, split.right);
                    else nodes.splice(j, 1, split.left, split.right);
                    j += 2 + split.break;
                    after -= split.size;
                } else break;
            } else if (before < after) {
                let next = nodes[i++];
                if (next) before += next.size;
            } else {
                let next = nodes[--j];
                if (next) after += next.size;
            }
        }
        let brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new $7beee9608540d2c3$var$HeightMapBranch($7beee9608540d2c3$var$HeightMap.of(nodes.slice(0, i)), brk, $7beee9608540d2c3$var$HeightMap.of(nodes.slice(j)));
    }
}
function $7beee9608540d2c3$var$replace(old, val) {
    if (old == val) return old;
    if (old.constructor != val.constructor) $7beee9608540d2c3$var$heightChangeFlag = true;
    return val;
}
$7beee9608540d2c3$var$HeightMap.prototype.size = 1;
const $7beee9608540d2c3$var$SpaceDeco = /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.replace({});
class $7beee9608540d2c3$var$HeightMapBlock extends $7beee9608540d2c3$var$HeightMap {
    constructor(length, height, deco){
        super(length, height);
        this.deco = deco;
        this.spaceAbove = 0;
    }
    mainBlock(top, offset) {
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(offset, this.length, top + this.spaceAbove, this.height - this.spaceAbove, this.deco || 0);
    }
    blockAt(height, _oracle, top, offset) {
        return this.spaceAbove && height < top + this.spaceAbove ? new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(offset, 0, top, this.spaceAbove, $7beee9608540d2c3$var$SpaceDeco) : this.mainBlock(top, offset);
    }
    lineAt(_value, _type, oracle, top, offset) {
        let main = this.mainBlock(top, offset);
        return this.spaceAbove ? this.blockAt(0, oracle, top, offset).join(main) : main;
    }
    forEachLine(from, to, oracle, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.lineAt(0, $7beee9608540d2c3$var$QueryType.ByPos, oracle, top, offset));
    }
    setMeasuredHeight(measured) {
        let next = measured.heights[measured.index++];
        if (next < 0) {
            this.spaceAbove = -next;
            next = measured.heights[measured.index++];
        } else this.spaceAbove = 0;
        this.setHeight(next);
    }
    updateHeight(oracle, offset = 0, _force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setMeasuredHeight(measured);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
}
class $7beee9608540d2c3$var$HeightMapText extends $7beee9608540d2c3$var$HeightMapBlock {
    constructor(length, height, above){
        super(length, height, null);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
        this.breaks = 0; // Number of widget-introduced line breaks on the line
        this.spaceAbove = above;
    }
    mainBlock(top, offset) {
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(offset, this.length, top + this.spaceAbove, this.height - this.spaceAbove, this.breaks);
    }
    replace(_from, _to, nodes) {
        let node = nodes[0];
        if (nodes.length == 1 && (node instanceof $7beee9608540d2c3$var$HeightMapText || node instanceof $7beee9608540d2c3$var$HeightMapGap && node.flags & 4 /* Flag.SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof $7beee9608540d2c3$var$HeightMapGap) node = new $7beee9608540d2c3$var$HeightMapText(node.length, this.height, this.spaceAbove);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return $7beee9608540d2c3$var$HeightMap.of(nodes);
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setMeasuredHeight(measured);
        else if (force || this.outdated) {
            this.spaceAbove = 0;
            this.setHeight(Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
        }
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
}
class $7beee9608540d2c3$var$HeightMapGap extends $7beee9608540d2c3$var$HeightMap {
    constructor(length){
        super(length, 0);
    }
    heightMetrics(oracle, offset) {
        let firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
        let lines = lastLine - firstLine + 1;
        let perLine, perChar = 0;
        if (oracle.lineWrapping) {
            let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
            perLine = totalPerLine / lines;
            if (this.length > lines + 1) perChar = (this.height - totalPerLine) / (this.length - lines - 1);
        } else perLine = this.height / lines;
        return {
            firstLine: firstLine,
            lastLine: lastLine,
            perLine: perLine,
            perChar: perChar
        };
    }
    blockAt(height, oracle, top, offset) {
        let { firstLine: firstLine, lastLine: lastLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        if (oracle.lineWrapping) {
            let guess = offset + (height < oracle.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (height - top) / this.height)) * this.length));
            let line = oracle.doc.lineAt(guess), lineHeight = perLine + line.length * perChar;
            let lineTop = Math.max(top, height - lineHeight / 2);
            return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0);
        } else {
            let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / perLine)));
            let { from: from, length: length } = oracle.doc.line(firstLine + line);
            return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(from, length, top + perLine * line, perLine, 0);
        }
    }
    lineAt(value, type, oracle, top, offset) {
        if (type == $7beee9608540d2c3$var$QueryType.ByHeight) return this.blockAt(value, oracle, top, offset);
        if (type == $7beee9608540d2c3$var$QueryType.ByPosNoHeight) {
            let { from: from, to: to } = oracle.doc.lineAt(value);
            return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(from, to - from, 0, 0, 0);
        }
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        let line = oracle.doc.lineAt(value), lineHeight = perLine + line.length * perChar;
        let linesAbove = line.number - firstLine;
        let lineTop = top + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(line.from, line.length, Math.max(top, Math.min(lineTop, top + this.height - lineHeight)), lineHeight, 0);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        from = Math.max(from, offset);
        to = Math.min(to, offset + this.length);
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        for(let pos = from, lineTop = top; pos <= to;){
            let line = oracle.doc.lineAt(pos);
            if (pos == from) {
                let linesAbove = line.number - firstLine;
                lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
            }
            let lineHeight = perLine + perChar * line.length;
            f(new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0));
            lineTop += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        let after = this.length - to;
        if (after > 0) {
            let last = nodes[nodes.length - 1];
            if (last instanceof $7beee9608540d2c3$var$HeightMapGap) nodes[nodes.length - 1] = new $7beee9608540d2c3$var$HeightMapGap(last.length + after);
            else nodes.push(null, new $7beee9608540d2c3$var$HeightMapGap(after - 1));
        }
        if (from > 0) {
            let first = nodes[0];
            if (first instanceof $7beee9608540d2c3$var$HeightMapGap) nodes[0] = new $7beee9608540d2c3$var$HeightMapGap(from + first.length);
            else nodes.unshift(new $7beee9608540d2c3$var$HeightMapGap(from - 1), null);
        }
        return $7beee9608540d2c3$var$HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new $7beee9608540d2c3$var$HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new $7beee9608540d2c3$var$HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            if (measured.from > offset) nodes.push(new $7beee9608540d2c3$var$HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                let len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                let height = measured.heights[measured.index++], above = 0;
                if (height < 0) {
                    above = -height;
                    height = measured.heights[measured.index++];
                }
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= $7beee9608540d2c3$var$Epsilon) singleHeight = -2;
                let line = new $7beee9608540d2c3$var$HeightMapText(len, height, above);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new $7beee9608540d2c3$var$HeightMapGap(end - pos).updateHeight(oracle, pos));
            let result = $7beee9608540d2c3$var$HeightMap.of(nodes);
            if (singleHeight < 0 || Math.abs(result.height - this.height) >= $7beee9608540d2c3$var$Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= $7beee9608540d2c3$var$Epsilon) $7beee9608540d2c3$var$heightChangeFlag = true;
            return $7beee9608540d2c3$var$replace(this, result);
        } else if (force || this.outdated) {
            this.setHeight(oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
}
class $7beee9608540d2c3$var$HeightMapBranch extends $7beee9608540d2c3$var$HeightMap {
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Flag.Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
    get break() {
        return this.flags & 1 /* Flag.Break */ ;
    }
    blockAt(height, oracle, top, offset) {
        let mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, oracle, top, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, oracle, top, offset) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        let left = type == $7beee9608540d2c3$var$QueryType.ByHeight ? value < rightTop : value < rightOffset;
        let base = left ? this.left.lineAt(value, type, oracle, top, offset) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        let subQuery = type == $7beee9608540d2c3$var$QueryType.ByPosNoHeight ? $7beee9608540d2c3$var$QueryType.ByPosNoHeight : $7beee9608540d2c3$var$QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, oracle, top, offset).join(base);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, oracle, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, oracle, rightTop, rightOffset, f);
        } else {
            let mid = this.lineAt(rightOffset, $7beee9608540d2c3$var$QueryType.ByPos, oracle, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, oracle, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, oracle, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        let rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        let result = [];
        if (from > 0) this.decomposeLeft(from, result);
        let left = result.length;
        for (let node of nodes)result.push(node);
        if (from > 0) $7beee9608540d2c3$var$mergeGaps(result, left - 1);
        if (to < this.length) {
            let right = result.length;
            this.decomposeRight(to, result);
            $7beee9608540d2c3$var$mergeGaps(result, right);
        }
        return $7beee9608540d2c3$var$HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        let left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        let left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return $7beee9608540d2c3$var$HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = $7beee9608540d2c3$var$replace(this.left, left);
        this.right = $7beee9608540d2c3$var$replace(this.right, right);
        this.setHeight(left.height + right.height);
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let { left: left, right: right } = this, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
}
function $7beee9608540d2c3$var$mergeGaps(nodes, around) {
    let before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof $7beee9608540d2c3$var$HeightMapGap && (after = nodes[around + 1]) instanceof $7beee9608540d2c3$var$HeightMapGap) nodes.splice(around - 1, 3, new $7beee9608540d2c3$var$HeightMapGap(before.length + 1 + after.length));
}
const $7beee9608540d2c3$var$relevantWidgetHeight = 5;
class $7beee9608540d2c3$var$NodeBuilder {
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            let end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof $7beee9608540d2c3$var$HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new $7beee9608540d2c3$var$HeightMapText(end - this.pos, -1, 0));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            let height = deco.widget ? deco.widget.estimatedHeight : 0;
            let breaks = deco.widget ? deco.widget.lineBreaks : 0;
            if (height < 0) height = this.oracle.lineHeight;
            let len = to - from;
            if (deco.block) this.addBlock(new $7beee9608540d2c3$var$HeightMapBlock(len, height, deco));
            else if (len || breaks || height >= $7beee9608540d2c3$var$relevantWidgetHeight) this.addLineDeco(height, breaks, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        let { from: from, to: to } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new $7beee9608540d2c3$var$HeightMapText(this.pos - from, -1, 0));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        let gap = new $7beee9608540d2c3$var$HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* Flag.SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof $7beee9608540d2c3$var$HeightMapText) return last;
        let line = new $7beee9608540d2c3$var$HeightMapText(0, -1, 0);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        this.enterLine();
        let deco = block.deco;
        if (deco && deco.startSide > 0 && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (deco && deco.endSide > 0) this.covering = block;
    }
    addLineDeco(height, breaks, length) {
        let line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        line.breaks += breaks;
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof $7beee9608540d2c3$var$HeightMapText) && !this.isCovered) this.nodes.push(new $7beee9608540d2c3$var$HeightMapText(0, -1, 0));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        let pos = from;
        for (let node of this.nodes){
            if (node instanceof $7beee9608540d2c3$var$HeightMapText) node.updateHeight(this.oracle, pos);
            pos += node ? node.length : 1;
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        let builder = new $7beee9608540d2c3$var$NodeBuilder(from, oracle);
        (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
}
function $7beee9608540d2c3$var$heightRelevantDecoChanges(a, b, diff) {
    let comp = new $7beee9608540d2c3$var$DecorationComparator;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class $7beee9608540d2c3$var$DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) $7beee9608540d2c3$var$addRange(from, to, this.changes, 5);
    }
}
function $7beee9608540d2c3$var$visiblePixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
    let top = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
    for(let parent = dom.parentNode; parent && parent != doc.body;){
        if (parent.nodeType == 1) {
            let elt = parent;
            let style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                let parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = Math.min(parent == dom.parentNode ? win.innerHeight : bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function $7beee9608540d2c3$var$inWindow(elt) {
    let rect = elt.getBoundingClientRect(), win = elt.ownerDocument.defaultView || window;
    return rect.left < win.innerWidth && rect.right > 0 && rect.top < win.innerHeight && rect.bottom > 0;
}
function $7beee9608540d2c3$var$fullPixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class $7beee9608540d2c3$var$LineGap {
    constructor(from, to, size, displaySize){
        this.from = from;
        this.to = to;
        this.size = size;
        this.displaySize = displaySize;
    }
    static same(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++){
            let gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(viewState, wrapping) {
        return $7beee9608540d2c3$export$10e30b733df217ea.replace({
            widget: new $7beee9608540d2c3$var$LineGapWidget(this.displaySize * (wrapping ? viewState.scaleY : viewState.scaleX), wrapping)
        }).range(this.from, this.to);
    }
}
class $7beee9608540d2c3$var$LineGapWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        let elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
}
class $7beee9608540d2c3$var$ViewState {
    constructor(state){
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0; // Padding above the document, scaled
        this.paddingBottom = 0; // Padding below the document, scaled
        this.contentDOMWidth = 0; // contentDOM.getBoundingClientRect().width
        this.contentDOMHeight = 0; // contentDOM.getBoundingClientRect().height
        this.editorHeight = 0; // scrollDOM.clientHeight, unscaled
        this.editorWidth = 0; // scrollDOM.clientWidth, unscaled
        this.scrollTop = 0; // Last seen scrollDOM.scrollTop, scaled
        this.scrolledToBottom = false;
        // The CSS-transformation scale of the editor (transformed size /
        // concrete size)
        this.scaleX = 1;
        this.scaleY = 1;
        // The vertical position (document-relative) to which to anchor the
        // scroll position. -1 means anchor to the end of the document.
        this.scrollAnchorPos = 0;
        // The height at the anchor position. Set by the DOM update phase.
        // -1 means no height available.
        this.scrollAnchorHeight = -1;
        // See VP.MaxDOMHeight
        this.scaler = $7beee9608540d2c3$var$IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        let guessWrapping = state.facet($7beee9608540d2c3$var$contentAttributes).some((v)=>typeof v != "function" && v.class == "cm-lineWrapping");
        this.heightOracle = new $7beee9608540d2c3$var$HeightOracle(guessWrapping);
        this.stateDeco = state.facet($7beee9608540d2c3$var$decorations).filter((d)=>typeof d != "function");
        this.heightMap = $7beee9608540d2c3$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty, this.heightOracle.setDoc(state.doc), [
            new $7beee9608540d2c3$var$ChangedRange(0, 0, 0, state.doc.length)
        ]);
        for(let i = 0; i < 2; i++){
            this.viewport = this.getViewport(0, null);
            if (!this.updateForViewport()) break;
        }
        this.updateViewportLines();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = $7beee9608540d2c3$export$10e30b733df217ea.set(this.lineGaps.map((gap)=>gap.draw(this, false)));
        this.computeVisibleRanges();
    }
    updateForViewport() {
        let viewports = [
            this.viewport
        ], { main: main } = this.state.selection;
        for(let i = 0; i <= 1; i++){
            let pos = i ? main.head : main.anchor;
            if (!viewports.some(({ from: from, to: to })=>pos >= from && pos <= to)) {
                let { from: from, to: to } = this.lineBlockAt(pos);
                viewports.push(new $7beee9608540d2c3$var$Viewport(from, to));
            }
        }
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        return this.updateScaler();
    }
    updateScaler() {
        let scaler = this.scaler;
        this.scaler = this.heightMap.height <= 7000000 /* VP.MaxDOMHeight */  ? $7beee9608540d2c3$var$IdScaler : new $7beee9608540d2c3$var$BigScaler(this.heightOracle, this.heightMap, this.viewports);
        return scaler.eq(this.scaler) ? 0 : 2 /* UpdateFlag.Height */ ;
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block)=>{
            this.viewportLines.push($7beee9608540d2c3$var$scaleBlock(block, this.scaler));
        });
    }
    update(update, scrollTarget = null) {
        this.state = update.state;
        let prevDeco = this.stateDeco;
        this.stateDeco = this.state.facet($7beee9608540d2c3$var$decorations).filter((d)=>typeof d != "function");
        let contentChanges = update.changedRanges;
        let heightChanges = $7beee9608540d2c3$var$ChangedRange.extendWithRanges(contentChanges, $7beee9608540d2c3$var$heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, $6295c6875f57e3ee$export$29d7fbdcb1f8b71c).empty(this.state.doc.length)));
        let prevHeight = this.heightMap.height;
        let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
        $7beee9608540d2c3$var$clearHeightChangeFlag();
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight || $7beee9608540d2c3$var$heightChangeFlag) update.flags |= 2 /* UpdateFlag.Height */ ;
        if (scrollAnchor) {
            this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
            this.scrollAnchorHeight = scrollAnchor.top;
        } else {
            this.scrollAnchorPos = -1;
            this.scrollAnchorHeight = prevHeight;
        }
        let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        let viewportChange = viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        update.flags |= this.updateForViewport();
        if (viewportChange || !update.changes.empty || update.flags & 2 /* UpdateFlag.Height */ ) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges(update.changes);
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet($7beee9608540d2c3$var$nativeSelectionHidden)) this.mustEnforceCursorAssoc = true;
    }
    measure(view) {
        let dom = view.contentDOM, style = window.getComputedStyle(dom);
        let oracle = this.heightOracle;
        let whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL : $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
        let domRect = dom.getBoundingClientRect();
        let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
        this.contentDOMHeight = domRect.height;
        this.mustMeasureContent = false;
        let result = 0, bias = 0;
        if (domRect.width && domRect.height) {
            let { scaleX: scaleX, scaleY: scaleY } = $7beee9608540d2c3$var$getScale(dom, domRect);
            if (scaleX > .005 && Math.abs(this.scaleX - scaleX) > .005 || scaleY > .005 && Math.abs(this.scaleY - scaleY) > .005) {
                this.scaleX = scaleX;
                this.scaleY = scaleY;
                result |= 16 /* UpdateFlag.Geometry */ ;
                refresh = measureContent = true;
            }
        }
        // Vertical padding
        let paddingTop = (parseInt(style.paddingTop) || 0) * this.scaleY;
        let paddingBottom = (parseInt(style.paddingBottom) || 0) * this.scaleY;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 18 /* UpdateFlag.Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        let scrollTop = view.scrollDOM.scrollTop * this.scaleY;
        if (this.scrollTop != scrollTop) {
            this.scrollAnchorHeight = -1;
            this.scrollTop = scrollTop;
        }
        this.scrolledToBottom = $7beee9608540d2c3$var$isScrolledToBottom(view.scrollDOM);
        // Pixel viewport
        let pixelViewport = (this.printing ? $7beee9608540d2c3$var$fullPixelRange : $7beee9608540d2c3$var$visiblePixelRange)(dom, this.paddingTop);
        let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView && !this.scrollTarget && !$7beee9608540d2c3$var$inWindow(view.dom)) return 0;
        let contentWidth = domRect.width;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = domRect.width;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        if (measureContent) {
            let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                let { lineHeight: lineHeight, charWidth: charWidth, textHeight: textHeight } = view.docView.measureTextSize();
                refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, Math.max(5, contentWidth / charWidth), lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 16 /* UpdateFlag.Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            $7beee9608540d2c3$var$clearHeightChangeFlag();
            for (let vp of this.viewports){
                let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                this.heightMap = (refresh ? $7beee9608540d2c3$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty, this.heightOracle, [
                    new $7beee9608540d2c3$var$ChangedRange(0, 0, 0, view.state.doc.length)
                ]) : this.heightMap).updateHeight(oracle, 0, refresh, new $7beee9608540d2c3$var$MeasuredHeights(vp.from, heights));
            }
            if ($7beee9608540d2c3$var$heightChangeFlag) result |= 2 /* UpdateFlag.Height */ ;
        }
        let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) {
            if (result & 2 /* UpdateFlag.Height */ ) result |= this.updateScaler();
            this.viewport = this.getViewport(bias, this.scrollTarget);
            result |= this.updateForViewport();
        }
        if (result & 2 /* UpdateFlag.Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* VP.Margin */  / 2));
        let map = this.heightMap, oracle = this.heightOracle;
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        let viewport = new $7beee9608540d2c3$var$Viewport(map.lineAt(visibleTop - marginTop * 1000 /* VP.Margin */ , $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* VP.Margin */ , $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            let { head: head } = scrollTarget.range;
            if (head < viewport.from || head > viewport.to) {
                let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                let block = map.lineAt(head, $7beee9608540d2c3$var$QueryType.ByPos, oracle, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new $7beee9608540d2c3$var$Viewport(map.lineAt(topPos - 500, $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(topPos + viewHeight + 500, $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        let from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new $7beee9608540d2c3$var$Viewport(this.heightMap.lineAt(from, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate({ from: from, to: to }, bias = 0) {
        if (!this.inView) return true;
        let { top: top } = this.heightMap.lineAt(from, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { bottom: bottom } = this.heightMap.lineAt(to, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        return (from == 0 || top <= visibleTop - Math.max(10 /* VP.MinCoverMargin */ , Math.min(-bias, 250 /* VP.MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* VP.MinCoverMargin */ , Math.min(bias, 250 /* VP.MaxCoverMargin */ ))) && top > visibleTop - 2000 /* VP.Margin */  && bottom < visibleBottom + 2000 /* VP.Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        let mapped = [];
        for (let gap of gaps)if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new $7beee9608540d2c3$var$LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size, gap.displaySize));
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current, mayMeasure) {
        let wrapping = this.heightOracle.lineWrapping;
        let margin = wrapping ? 10000 /* LG.MarginWrap */  : 2000 /* LG.Margin */ , halfMargin = margin >> 1, doubleMargin = margin << 1;
        // The non-wrapping logic won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR && !wrapping) return [];
        let gaps = [];
        let addGap = (from, to, line, structure)=>{
            if (to - from < halfMargin) return;
            let sel = this.state.selection.main, avoid = [
                sel.from
            ];
            if (!sel.empty) avoid.push(sel.to);
            for (let pos of avoid)if (pos > from && pos < to) {
                addGap(from, pos - 10 /* LG.SelectionMargin */ , line, structure);
                addGap(pos + 10 /* LG.SelectionMargin */ , to, line, structure);
                return;
            }
            let gap = $7beee9608540d2c3$var$find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < halfMargin && Math.abs(gap.to - to) < halfMargin && !avoid.some((pos)=>gap.from < pos && gap.to > pos));
            if (!gap) {
                // When scrolling down, snap gap ends to line starts to avoid shifts in wrapping
                if (to < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r)=>r.from <= to && r.to >= to)) {
                    let lineStart = mayMeasure.moveToLineBoundary((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(to), false, true).head;
                    if (lineStart > from) to = lineStart;
                }
                let size = this.gapSize(line, from, to, structure);
                let displaySize = wrapping || size < 2000000 /* VP.MaxHorizGap */  ? size : 2000000 /* VP.MaxHorizGap */ ;
                gap = new $7beee9608540d2c3$var$LineGap(from, to, size, displaySize);
            }
            gaps.push(gap);
        };
        let checkLine = (line)=>{
            if (line.length < doubleMargin || line.type != $7beee9608540d2c3$export$48808c686fe495c4.Text) return;
            let structure = $7beee9608540d2c3$var$lineStructure(line.from, line.to, this.stateDeco);
            if (structure.total < doubleMargin) return;
            let target = this.scrollTarget ? this.scrollTarget.range.head : null;
            let viewFrom, viewTo;
            if (wrapping) {
                let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                let top, bot;
                if (target != null) {
                    let targetFrac = $7beee9608540d2c3$var$findFraction(structure, target);
                    let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
                    top = targetFrac - spaceFrac;
                    bot = targetFrac + spaceFrac;
                } else {
                    top = (this.visibleTop - line.top - marginHeight) / line.height;
                    bot = (this.visibleBottom - line.top + marginHeight) / line.height;
                }
                viewFrom = $7beee9608540d2c3$var$findPosition(structure, top);
                viewTo = $7beee9608540d2c3$var$findPosition(structure, bot);
            } else {
                let totalWidth = structure.total * this.heightOracle.charWidth;
                let marginWidth = margin * this.heightOracle.charWidth;
                let horizOffset = 0;
                if (totalWidth > 2000000 /* VP.MaxHorizGap */ ) {
                    for (let old of current)if (old.from >= line.from && old.from < line.to && old.size != old.displaySize && old.from * this.heightOracle.charWidth + horizOffset < this.pixelViewport.left) horizOffset = old.size - old.displaySize;
                }
                let pxLeft = this.pixelViewport.left + horizOffset, pxRight = this.pixelViewport.right + horizOffset;
                let left, right;
                if (target != null) {
                    let targetFrac = $7beee9608540d2c3$var$findFraction(structure, target);
                    let spaceFrac = ((pxRight - pxLeft) / 2 + marginWidth) / totalWidth;
                    left = targetFrac - spaceFrac;
                    right = targetFrac + spaceFrac;
                } else {
                    left = (pxLeft - marginWidth) / totalWidth;
                    right = (pxRight + marginWidth) / totalWidth;
                }
                viewFrom = $7beee9608540d2c3$var$findPosition(structure, left);
                viewTo = $7beee9608540d2c3$var$findPosition(structure, right);
            }
            if (viewFrom > line.from) addGap(line.from, viewFrom, line, structure);
            if (viewTo < line.to) addGap(viewTo, line.to, line, structure);
        };
        for (let line of this.viewportLines)if (Array.isArray(line.type)) line.type.forEach(checkLine);
        else checkLine(line);
        return gaps;
    }
    gapSize(line, from, to, structure) {
        let fraction = $7beee9608540d2c3$var$findFraction(structure, to) - $7beee9608540d2c3$var$findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!$7beee9608540d2c3$var$LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = $7beee9608540d2c3$export$10e30b733df217ea.set(gaps.map((gap)=>gap.draw(this, this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges(changes) {
        let deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        let ranges = [];
        (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from: from,
                    to: to
                });
            },
            point () {}
        }, 20);
        let changed = 0;
        if (ranges.length != this.visibleRanges.length) changed = 12 /* UpdateFlag.Viewport */ ;
        else for(let i = 0; i < ranges.length && !(changed & 8 /* UpdateFlag.ViewportMoved */ ); i++){
            let old = this.visibleRanges[i], nw = ranges[i];
            if (old.from != nw.from || old.to != nw.to) {
                changed |= 4 /* UpdateFlag.Viewport */ ;
                if (!(changes && changes.mapPos(old.from, -1) == nw.from && changes.mapPos(old.to, 1) == nw.to)) changed |= 8 /* UpdateFlag.ViewportMoved */ ;
            }
        }
        this.visibleRanges = ranges;
        return changed;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || $7beee9608540d2c3$var$scaleBlock(this.heightMap.lineAt(pos, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return height >= this.viewportLines[0].top && height <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((l)=>l.top <= height && l.bottom >= height) || $7beee9608540d2c3$var$scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), $7beee9608540d2c3$var$QueryType.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    scrollAnchorAt(scrollTop) {
        let block = this.lineBlockAtHeight(scrollTop + 8);
        return block.from >= this.viewport.from || this.viewportLines[0].top - scrollTop > 200 ? block : this.viewportLines[0];
    }
    elementAtHeight(height) {
        return $7beee9608540d2c3$var$scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
}
class $7beee9608540d2c3$var$Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function $7beee9608540d2c3$var$lineStructure(from, to, stateDeco) {
    let ranges = [], pos = from, total = 0;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to: to
        });
        total += to - pos;
    }
    return {
        total: total,
        ranges: ranges
    };
}
function $7beee9608540d2c3$var$findPosition({ total: total, ranges: ranges }, ratio) {
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    let dist = Math.floor(total * ratio);
    for(let i = 0;; i++){
        let { from: from, to: to } = ranges[i], size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function $7beee9608540d2c3$var$findFraction(structure, pos) {
    let counted = 0;
    for (let { from: from, to: to } of structure.ranges){
        if (pos <= to) {
            counted += pos - from;
            break;
        }
        counted += to - from;
    }
    return counted / structure.total;
}
function $7beee9608540d2c3$var$find(array, f) {
    for (let val of array)if (f(val)) return val;
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
const $7beee9608540d2c3$var$IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1,
    eq (other) {
        return other == this;
    }
};
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class $7beee9608540d2c3$var$BigScaler {
    constructor(oracle, heightMap, viewports){
        let vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map(({ from: from, to: to })=>{
            let top = heightMap.lineAt(from, $7beee9608540d2c3$var$QueryType.ByPos, oracle, 0, 0).top;
            let bottom = heightMap.lineAt(to, $7beee9608540d2c3$var$QueryType.ByPos, oracle, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from: from,
                to: to,
                top: top,
                bottom: bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* VP.MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        for (let obj of this.viewports){
            obj.domTop = domBase + (obj.top - base) * this.scale;
            domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
            base = obj.bottom;
        }
    }
    toDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    eq(other) {
        if (!(other instanceof $7beee9608540d2c3$var$BigScaler)) return false;
        return this.scale == other.scale && this.viewports.length == other.viewports.length && this.viewports.every((vp, i)=>vp.from == other.viewports[i].from && vp.to == other.viewports[i].to);
    }
}
function $7beee9608540d2c3$var$scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b)=>$7beee9608540d2c3$var$scaleBlock(b, scaler)) : block._content);
}
const $7beee9608540d2c3$var$theme = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (strs)=>strs.join(" ")
});
const $7beee9608540d2c3$var$darkTheme = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.indexOf(true) > -1
});
const $7beee9608540d2c3$var$baseThemeID = /*@__PURE__*/ (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName(), $7beee9608540d2c3$var$baseLightID = /*@__PURE__*/ (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName(), $7beee9608540d2c3$var$baseDarkID = /*@__PURE__*/ (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName();
const $7beee9608540d2c3$var$lightDarkIDs = {
    "&light": "." + $7beee9608540d2c3$var$baseLightID,
    "&dark": "." + $7beee9608540d2c3$var$baseDarkID
};
function $7beee9608540d2c3$var$buildTheme(main, spec, scopes) {
    return new (0, $afd7c6da9f842a17$export$b920c662d2efee20)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
const $7beee9608540d2c3$var$baseTheme$1 = /*@__PURE__*/ $7beee9608540d2c3$var$buildTheme("." + $7beee9608540d2c3$var$baseThemeID, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0,
        overflowAnchor: "none"
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        minHeight: "100%",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#ddd"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    ".cm-iso": {
        unicodeBidi: "isolate"
    },
    ".cm-announced": {
        position: "fixed",
        top: "-10000px"
    },
    "@media print": {
        ".cm-announced": {
            display: "none"
        }
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        zIndex: 200
    },
    ".cm-gutters-before": {
        insetInlineStart: 0
    },
    ".cm-gutters-after": {
        insetInlineEnd: 0
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        border: "0px solid #ddd",
        "&.cm-gutters-before": {
            borderRightWidth: "1px"
        },
        "&.cm-gutters-after": {
            borderLeftWidth: "1px"
        }
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0,
        zIndex: 300
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-dialog": {
        padding: "2px 19px 4px 6px",
        position: "relative",
        "& label": {
            fontSize: "80%"
        }
    },
    ".cm-dialog-close": {
        position: "absolute",
        top: "3px",
        right: "4px",
        backgroundColor: "inherit",
        border: "none",
        font: "inherit",
        fontSize: "14px",
        padding: "0"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top",
        userSelect: "none"
    },
    ".cm-highlightSpace": {
        backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
        backgroundPosition: "center"
    },
    ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, $7beee9608540d2c3$var$lightDarkIDs);
const $7beee9608540d2c3$var$observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
const $7beee9608540d2c3$var$useCharData = $7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11;
class $7beee9608540d2c3$var$DOMObserver {
    constructor(view){
        this.view = view;
        this.active = false;
        this.editContext = null;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new $7beee9608540d2c3$var$DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
        this.lastChange = 0;
        this.scrollTargets = [];
        this.intersection = null;
        this.resizeScroll = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        this.printQuery = null;
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            for (let mut of mutations)this.queue.push(mut);
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if (($7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11 || $7beee9608540d2c3$var$browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if (window.EditContext && $7beee9608540d2c3$var$browser.android && view.constructor.EDIT_CONTEXT !== false && // Chrome <126 doesn't support inverted selections in edit context (#1392)
        !($7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$browser.chrome_version < 126)) {
            this.editContext = new $7beee9608540d2c3$var$EditContextManager(view);
            if (view.state.facet($7beee9608540d2c3$var$editable)) view.contentDOM.editContext = this.editContext.editContext;
        }
        if ($7beee9608540d2c3$var$useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onScroll = this.onScroll.bind(this);
        if (window.matchMedia) this.printQuery = window.matchMedia("print");
        if (typeof ResizeObserver == "function") {
            this.resizeScroll = new ResizeObserver(()=>{
                var _a;
                if (((_a = this.view.docView) === null || _a === void 0 ? void 0 : _a.lastUpdate) < Date.now() - 75) this.onResize();
            });
            this.resizeScroll.observe(view.scrollDOM);
        }
        this.addWindowListeners(this.win = view.win);
        this.start();
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {
                threshold: [
                    0,
                    .001
                ]
            });
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
    }
    onScrollChanged(e) {
        this.view.inputState.runHandlers("scroll", e);
        if (this.intersecting) this.view.measure();
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        if (this.editContext) this.view.requestMeasure(this.editContext.measureReq);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint(event) {
        if ((event.type == "change" || !event.type) && !event.matches) return;
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            for (let gap of gaps)this.gapIntersection.observe(gap);
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        let wasChanged = this.selectionChanged;
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        let { view: view } = this, sel = this.selectionRange;
        if (view.state.facet($7beee9608540d2c3$var$editable) ? view.root.activeElement != this.dom : !$7beee9608540d2c3$var$hasSelection(this.dom, sel)) return;
        let context = sel.anchorNode && view.docView.tile.nearest(sel.anchorNode);
        if (context && context.isWidget() && context.widget.ignoreEvent(event)) {
            if (!wasChanged) this.selectionChanged = false;
            return;
        }
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if (($7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11 || $7beee9608540d2c3$var$browser.android && $7beee9608540d2c3$var$browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && $7beee9608540d2c3$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        let { view: view } = this;
        // The Selection object is broken in shadow roots in Safari. See
        // https://github.com/codemirror/dev/issues/414
        let selection = $7beee9608540d2c3$var$getSelection(view.root);
        if (!selection) return false;
        let range = $7beee9608540d2c3$var$browser.safari && view.root.nodeType == 11 && view.root.activeElement == this.dom && $7beee9608540d2c3$var$safariSelectionRangeHack(this.view, selection) || selection;
        if (!range || this.selectionRange.eq(range)) return false;
        let local = $7beee9608540d2c3$var$hasSelection(this.dom, range);
        // Detect the situation where the browser has, on focus, moved the
        // selection to the start of the content element. Reset it to the
        // position from the editor state.
        if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && $7beee9608540d2c3$var$atElementStart(this.dom, range)) {
            this.view.inputState.lastFocusTime = 0;
            view.docView.updateSelection();
            return false;
        }
        this.selectionRange.setRange(range);
        if (local) this.selectionChanged = true;
        return true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        let i = 0, changed = null;
        for(let dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
            for (let dom of this.scrollTargets = changed)dom.addEventListener("scroll", this.onScroll);
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, $7beee9608540d2c3$var$observeOptions);
        if ($7beee9608540d2c3$var$useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if ($7beee9608540d2c3$var$useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        var _a;
        if (!this.delayedAndroidKey) {
            let flush = ()=>{
                let key = this.delayedAndroidKey;
                if (key) {
                    this.clearDelayedAndroidKey();
                    this.view.inputState.lastKeyCode = key.keyCode;
                    this.view.inputState.lastKeyTime = Date.now();
                    let flushed = this.flush();
                    if (!flushed && key.force) $7beee9608540d2c3$var$dispatchKey(this.dom, key.key, key.keyCode);
                }
            };
            this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
        }
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key: key,
            keyCode: keyCode,
            // Only run the key handler when no changes are detected if
            // this isn't coming right after another change, in which case
            // it is probably part of a weird chain of updates, and should
            // be ignored if it returns the DOM to its previous state.
            force: this.lastChange < Date.now() - 50 || !!((_a = this.delayedAndroidKey) === null || _a === void 0 ? void 0 : _a.force)
        };
    }
    clearDelayedAndroidKey() {
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = this.view.win.requestAnimationFrame(()=>{
            this.delayedFlush = -1;
            this.flush();
        });
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            this.view.win.cancelAnimationFrame(this.delayedFlush);
            this.delayedFlush = -1;
        }
        this.flush();
    }
    pendingRecords() {
        for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    processRecords() {
        let records = this.pendingRecords();
        if (records.length) this.queue = [];
        let from = -1, to = -1, typeOver = false;
        for (let record of records){
            let range = this.readMutation(record);
            if (!range) continue;
            if (range.typeOver) typeOver = true;
            if (from == -1) ({ from: from, to: to } = range);
            else {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        }
        return {
            from: from,
            to: to,
            typeOver: typeOver
        };
    }
    readChange() {
        let { from: from, to: to, typeOver: typeOver } = this.processRecords();
        let newSel = this.selectionChanged && $7beee9608540d2c3$var$hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return null;
        if (from > -1) this.lastChange = Date.now();
        this.view.inputState.lastFocusTime = 0;
        this.selectionChanged = false;
        let change = new $7beee9608540d2c3$var$DOMChange(this.view, from, to, typeOver);
        this.view.docView.domChanged = {
            newSel: change.newSel ? change.newSel.main : null
        };
        return change;
    }
    // Apply pending changes, if any
    flush(readSelection = true) {
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return false;
        if (readSelection) this.readSelectionRange();
        let domChange = this.readChange();
        if (!domChange) {
            this.view.requestMeasure();
            return false;
        }
        let startState = this.view.state;
        let handled = $7beee9608540d2c3$var$applyDOMChange(this.view, domChange);
        // The view wasn't updated but DOM/selection changes were seen. Reset the view.
        if (this.view.state == startState && (domChange.domChanged || domChange.newSel && !domChange.newSel.main.eq(this.view.state.selection.main))) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        let tile = this.view.docView.tile.nearest(rec.target);
        if (!tile || tile.isWidget()) return null;
        tile.markDirty(rec.type == "attributes");
        if (rec.type == "childList") {
            let childBefore = $7beee9608540d2c3$var$findChild(tile, rec.previousSibling || rec.target.previousSibling, -1);
            let childAfter = $7beee9608540d2c3$var$findChild(tile, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? tile.posAfter(childBefore) : tile.posAtStart,
                to: childAfter ? tile.posBefore(childAfter) : tile.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: tile.posAtStart,
            to: tile.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    setWindow(win) {
        if (win != this.win) {
            this.removeWindowListeners(this.win);
            this.win = win;
            this.addWindowListeners(this.win);
        }
    }
    addWindowListeners(win) {
        win.addEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.addEventListener) this.printQuery.addEventListener("change", this.onPrint);
            else this.printQuery.addListener(this.onPrint);
        } else win.addEventListener("beforeprint", this.onPrint);
        win.addEventListener("scroll", this.onScroll);
        win.document.addEventListener("selectionchange", this.onSelectionChange);
    }
    removeWindowListeners(win) {
        win.removeEventListener("scroll", this.onScroll);
        win.removeEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.removeEventListener) this.printQuery.removeEventListener("change", this.onPrint);
            else this.printQuery.removeListener(this.onPrint);
        } else win.removeEventListener("beforeprint", this.onPrint);
        win.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    update(update) {
        if (this.editContext) {
            this.editContext.update(update);
            if (update.startState.facet($7beee9608540d2c3$var$editable) != update.state.facet($7beee9608540d2c3$var$editable)) update.view.contentDOM.editContext = update.state.facet($7beee9608540d2c3$var$editable) ? this.editContext.editContext : null;
        }
    }
    destroy() {
        var _a, _b, _c;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resizeScroll) === null || _c === void 0 || _c.disconnect();
        for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
        this.removeWindowListeners(this.win);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
        this.win.cancelAnimationFrame(this.delayedFlush);
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        if (this.editContext) {
            this.view.contentDOM.editContext = null;
            this.editContext.destroy();
        }
    }
}
function $7beee9608540d2c3$var$findChild(tile, dom, dir) {
    while(dom){
        let curTile = $7beee9608540d2c3$var$Tile.get(dom);
        if (curTile && curTile.parent == tile) return curTile;
        let parent = dom.parentNode;
        dom = parent != tile.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
function $7beee9608540d2c3$var$buildSelectionRangeFromRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor, 1);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($7beee9608540d2c3$var$isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function $7beee9608540d2c3$var$safariSelectionRangeHack(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $7beee9608540d2c3$var$buildSelectionRangeFromRange(view, range);
    }
    let found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    view.dom.ownerDocument.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    return found ? $7beee9608540d2c3$var$buildSelectionRangeFromRange(view, found) : null;
}
class $7beee9608540d2c3$var$EditContextManager {
    constructor(view){
        // The document window for which the text in the context is
        // maintained. For large documents, this may be smaller than the
        // editor document. This window always includes the selection head.
        this.from = 0;
        this.to = 0;
        // When applying a transaction, this is used to compare the change
        // made to the context content to the change in the transaction in
        // order to make the minimal changes to the context (since touching
        // that sometimes breaks series of multiple edits made for a single
        // user action on some Android keyboards)
        this.pendingContextChange = null;
        this.handlers = Object.create(null);
        // Kludge to work around the fact that EditContext does not respond
        // well to having its content updated during a composition (see #1472)
        this.composing = null;
        this.resetRange(view.state);
        let context = this.editContext = new window.EditContext({
            text: view.state.doc.sliceString(this.from, this.to),
            selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, view.state.selection.main.anchor))),
            selectionEnd: this.toContextPos(view.state.selection.main.head)
        });
        this.handlers.textupdate = (e)=>{
            let main = view.state.selection.main, { anchor: anchor, head: head } = main;
            let from = this.toEditorPos(e.updateRangeStart), to = this.toEditorPos(e.updateRangeEnd);
            if (view.inputState.composing >= 0 && !this.composing) this.composing = {
                contextBase: e.updateRangeStart,
                editorBase: from,
                drifted: false
            };
            let deletes = to - from > e.text.length;
            // If the window doesn't include the anchor, assume changes
            // adjacent to a side go up to the anchor.
            if (from == this.from && anchor < this.from) from = anchor;
            else if (to == this.to && anchor > this.to) to = anchor;
            let diff = $7beee9608540d2c3$var$findDiff(view.state.sliceDoc(from, to), e.text, (deletes ? main.from : main.to) - from, deletes ? "end" : null);
            // Edit contexts sometimes fire empty changes
            if (!diff) {
                let newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart), this.toEditorPos(e.selectionEnd));
                if (!newSel.main.eq(main)) view.dispatch({
                    selection: newSel,
                    userEvent: "select"
                });
                return;
            }
            let change = {
                from: diff.from + from,
                to: diff.toA + from,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(e.text.slice(diff.from, diff.toB).split("\n"))
            };
            if (($7beee9608540d2c3$var$browser.mac || $7beee9608540d2c3$var$browser.android) && change.from == head - 1 && /^\. ?$/.test(e.text) && view.contentDOM.getAttribute("autocorrect") == "off") change = {
                from: from,
                to: to,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                    e.text.replace(".", " ")
                ])
            };
            this.pendingContextChange = change;
            if (!view.state.readOnly) {
                let newLen = this.to - this.from + (change.to - change.from + change.insert.length);
                $7beee9608540d2c3$var$applyDOMChangeInner(view, change, (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart, newLen), this.toEditorPos(e.selectionEnd, newLen)));
            }
            // If the transaction didn't flush our change, revert it so
            // that the context is in sync with the editor state again.
            if (this.pendingContextChange) {
                this.revertPending(view.state);
                this.setSelection(view.state);
            }
            // Work around missed compositionend events. See https://discuss.codemirror.net/t/a/9514
            if (change.from < change.to && !change.insert.length && view.inputState.composing >= 0 && !/[\\p{Alphabetic}\\p{Number}_]/.test(context.text.slice(Math.max(0, e.updateRangeStart - 1), Math.min(context.text.length, e.updateRangeStart + 1)))) this.handlers.compositionend(e);
        };
        this.handlers.characterboundsupdate = (e)=>{
            let rects = [], prev = null;
            for(let i = this.toEditorPos(e.rangeStart), end = this.toEditorPos(e.rangeEnd); i < end; i++){
                let rect = view.coordsForChar(i);
                prev = rect && new DOMRect(rect.left, rect.top, rect.right - rect.left, rect.bottom - rect.top) || prev || new DOMRect;
                rects.push(prev);
            }
            context.updateCharacterBounds(e.rangeStart, rects);
        };
        this.handlers.textformatupdate = (e)=>{
            let deco = [];
            for (let format of e.getTextFormats()){
                let lineStyle = format.underlineStyle, thickness = format.underlineThickness;
                if (!/none/i.test(lineStyle) && !/none/i.test(thickness)) {
                    let from = this.toEditorPos(format.rangeStart), to = this.toEditorPos(format.rangeEnd);
                    if (from < to) {
                        // These values changed from capitalized custom strings to lower-case CSS keywords in 2025
                        let style = `text-decoration: underline ${/^[a-z]/.test(lineStyle) ? lineStyle + " " : lineStyle == "Dashed" ? "dashed " : lineStyle == "Squiggle" ? "wavy " : ""}${/thin/i.test(thickness) ? 1 : 2}px`;
                        deco.push($7beee9608540d2c3$export$10e30b733df217ea.mark({
                            attributes: {
                                style: style
                            }
                        }).range(from, to));
                    }
                }
            }
            view.dispatch({
                effects: $7beee9608540d2c3$var$setEditContextFormatting.of($7beee9608540d2c3$export$10e30b733df217ea.set(deco))
            });
        };
        this.handlers.compositionstart = ()=>{
            if (view.inputState.composing < 0) {
                view.inputState.composing = 0;
                view.inputState.compositionFirstChange = true;
            }
        };
        this.handlers.compositionend = ()=>{
            view.inputState.composing = -1;
            view.inputState.compositionFirstChange = null;
            if (this.composing) {
                let { drifted: drifted } = this.composing;
                this.composing = null;
                if (drifted) this.reset(view.state);
            }
        };
        for(let event in this.handlers)context.addEventListener(event, this.handlers[event]);
        this.measureReq = {
            read: (view)=>{
                this.editContext.updateControlBounds(view.contentDOM.getBoundingClientRect());
                let sel = $7beee9608540d2c3$var$getSelection(view.root);
                if (sel && sel.rangeCount) this.editContext.updateSelectionBounds(sel.getRangeAt(0).getBoundingClientRect());
            }
        };
    }
    applyEdits(update) {
        let off = 0, abort = false, pending = this.pendingContextChange;
        update.changes.iterChanges((fromA, toA, _fromB, _toB, insert)=>{
            if (abort) return;
            let dLen = insert.length - (toA - fromA);
            if (pending && toA >= pending.to) {
                if (pending.from == fromA && pending.to == toA && pending.insert.eq(insert)) {
                    pending = this.pendingContextChange = null; // Match
                    off += dLen;
                    this.to += dLen;
                    return;
                } else {
                    pending = null;
                    this.revertPending(update.state);
                }
            }
            fromA += off;
            toA += off;
            if (toA <= this.from) {
                this.from += dLen;
                this.to += dLen;
            } else if (fromA < this.to) {
                if (fromA < this.from || toA > this.to || this.to - this.from + insert.length > 30000 /* CxVp.MaxSize */ ) {
                    abort = true;
                    return;
                }
                this.editContext.updateText(this.toContextPos(fromA), this.toContextPos(toA), insert.toString());
                this.to += dLen;
            }
            off += dLen;
        });
        if (pending && !abort) this.revertPending(update.state);
        return !abort;
    }
    update(update) {
        let reverted = this.pendingContextChange, startSel = update.startState.selection.main;
        if (this.composing && (this.composing.drifted || !update.changes.touchesRange(startSel.from, startSel.to) && update.transactions.some((tr)=>!tr.isUserEvent("input.type") && tr.changes.touchesRange(this.from, this.to)))) {
            this.composing.drifted = true;
            this.composing.editorBase = update.changes.mapPos(this.composing.editorBase);
        } else if (!this.applyEdits(update) || !this.rangeIsValid(update.state)) {
            this.pendingContextChange = null;
            this.reset(update.state);
        } else if (update.docChanged || update.selectionSet || reverted) this.setSelection(update.state);
        if (update.geometryChanged || update.docChanged || update.selectionSet) update.view.requestMeasure(this.measureReq);
    }
    resetRange(state) {
        let { head: head } = state.selection.main;
        this.from = Math.max(0, head - 10000 /* CxVp.Margin */ );
        this.to = Math.min(state.doc.length, head + 10000 /* CxVp.Margin */ );
    }
    reset(state) {
        this.resetRange(state);
        this.editContext.updateText(0, this.editContext.text.length, state.doc.sliceString(this.from, this.to));
        this.setSelection(state);
    }
    revertPending(state) {
        let pending = this.pendingContextChange;
        this.pendingContextChange = null;
        this.editContext.updateText(this.toContextPos(pending.from), this.toContextPos(pending.from + pending.insert.length), state.doc.sliceString(pending.from, pending.to));
    }
    setSelection(state) {
        let { main: main } = state.selection;
        let start = this.toContextPos(Math.max(this.from, Math.min(this.to, main.anchor)));
        let end = this.toContextPos(main.head);
        if (this.editContext.selectionStart != start || this.editContext.selectionEnd != end) this.editContext.updateSelection(start, end);
    }
    rangeIsValid(state) {
        let { head: head } = state.selection.main;
        return !(this.from > 0 && head - this.from < 500 /* CxVp.MinMargin */  || this.to < state.doc.length && this.to - head < 500 /* CxVp.MinMargin */  || this.to - this.from > 30000);
    }
    toEditorPos(contextPos, clipLen = this.to - this.from) {
        contextPos = Math.min(contextPos, clipLen);
        let c = this.composing;
        return c && c.drifted ? c.editorBase + (contextPos - c.contextBase) : contextPos + this.from;
    }
    toContextPos(editorPos) {
        let c = this.composing;
        return c && c.drifted ? c.contextBase + (editorPos - c.editorBase) : editorPos - this.from;
    }
    destroy() {
        for(let event in this.handlers)this.editContext.removeEventListener(event, this.handlers[event]);
    }
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class $7beee9608540d2c3$export$eece2fccabbb77c5 {
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return !!this.inputState && this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return !!this.inputState && this.inputState.composing >= 0;
    }
    /**
    The document or shadow root that the view lives in.
    */ get root() {
        return this._root;
    }
    /**
    @internal
    */ get win() {
        return this.dom.ownerDocument.defaultView || window;
    }
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(config = {}){
        var _a;
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* UpdateState.Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.className = "cm-announced";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        if (config.parent) config.parent.appendChild(this.dom);
        let { dispatch: dispatch } = config;
        this.dispatchTransactions = config.dispatchTransactions || dispatch && ((trs)=>trs.forEach((tr)=>dispatch(tr, this))) || ((trs)=>this.update(trs));
        this.dispatch = this.dispatch.bind(this);
        this._root = config.root || $7beee9608540d2c3$var$getRoot(config.parent) || document;
        this.viewState = new $7beee9608540d2c3$var$ViewState(config.state || (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).create(config));
        if (config.scrollTo && config.scrollTo.is($7beee9608540d2c3$var$scrollIntoView)) this.viewState.scrollTarget = config.scrollTo.value.clip(this.viewState.state);
        this.plugins = this.state.facet($7beee9608540d2c3$var$viewPlugin).map((spec)=>new $7beee9608540d2c3$var$PluginInstance(spec));
        for (let plugin of this.plugins)plugin.update(this);
        this.observer = new $7beee9608540d2c3$var$DOMObserver(this);
        this.inputState = new $7beee9608540d2c3$var$InputState(this);
        this.inputState.ensureHandlers(this.plugins);
        this.docView = new $7beee9608540d2c3$var$DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* UpdateState.Idle */ ;
        this.requestMeasure();
        if ((_a = document.fonts) === null || _a === void 0 ? void 0 : _a.ready) document.fonts.ready.then(()=>this.requestMeasure());
    }
    dispatch(...input) {
        let trs = input.length == 1 && input[0] instanceof (0, $6295c6875f57e3ee$export$febc5573c75cefb0) ? input : input.length == 1 && Array.isArray(input[0]) ? input[0] : [
            this.state.update(...input)
        ];
        this.dispatchTransactions(trs, this);
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        let redrawn = false, attrsChanged = false, update;
        let state = this.state;
        for (let tr of transactions){
            if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
            state = tr.state;
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
        if (transactions.some((tr)=>tr.annotation($7beee9608540d2c3$var$isFocusChange))) {
            this.inputState.notifiedFocused = focus;
            // If a focus-change transaction is being dispatched, set this update flag.
            focusFlag = 1 /* UpdateFlag.Focus */ ;
        } else if (focus != this.inputState.notifiedFocused) {
            this.inputState.notifiedFocused = focus;
            // Schedule a separate focus transaction if necessary, otherwise
            // add a flag to this update
            dispatchFocus = $7beee9608540d2c3$var$focusChangeTransaction(state, focus);
            if (!dispatchFocus) focusFlag = 1 /* UpdateFlag.Focus */ ;
        }
        // If there was a pending DOM change, eagerly read it and try to
        // apply it after the given transactions.
        let pendingKey = this.observer.delayedAndroidKey, domChange = null;
        if (pendingKey) {
            this.observer.clearDelayedAndroidKey();
            domChange = this.observer.readChange();
            // Only try to apply DOM changes if the transactions didn't
            // change the doc or selection.
            if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection)) domChange = null;
        } else this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).phrases) != this.state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).phrases)) return this.setState(state);
        update = $7beee9608540d2c3$export$b5b084f95c87edf7.create(this, state, transactions);
        update.flags |= focusFlag;
        let scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* UpdateState.Updating */ ;
            for (let tr of transactions){
                if (scrollTarget) scrollTarget = scrollTarget.map(tr.changes);
                if (tr.scrollIntoView) {
                    let { main: main } = tr.state.selection;
                    scrollTarget = new $7beee9608540d2c3$var$ScrollTarget(main.empty ? main : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(main.head, main.head > main.anchor ? -1 : 1));
                }
                for (let e of tr.effects)if (e.is($7beee9608540d2c3$var$scrollIntoView)) scrollTarget = e.value.clip(this.state);
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = $7beee9608540d2c3$var$CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet($7beee9608540d2c3$var$styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (update.startState.facet($7beee9608540d2c3$var$theme) != update.state.facet($7beee9608540d2c3$var$theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (redrawn) this.docViewUpdate();
        if (!update.empty) for (let listener of this.state.facet($7beee9608540d2c3$var$updateListener))try {
            listener(update);
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e, "update listener");
        }
        if (dispatchFocus || domChange) Promise.resolve().then(()=>{
            if (dispatchFocus && this.state == dispatchFocus.startState) this.dispatch(dispatchFocus);
            if (domChange) {
                if (!$7beee9608540d2c3$var$applyDOMChange(this, domChange) && pendingKey.force) $7beee9608540d2c3$var$dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
            }
        });
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* UpdateState.Updating */ ;
        let hadFocus = this.hasFocus;
        try {
            for (let plugin of this.plugins)plugin.destroy(this);
            this.viewState = new $7beee9608540d2c3$var$ViewState(newState);
            this.plugins = newState.facet($7beee9608540d2c3$var$viewPlugin).map((spec)=>new $7beee9608540d2c3$var$PluginInstance(spec));
            this.pluginMap.clear();
            for (let plugin of this.plugins)plugin.update(this);
            this.docView.destroy();
            this.docView = new $7beee9608540d2c3$var$DocView(this);
            this.inputState.ensureHandlers(this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        let prevSpecs = update.startState.facet($7beee9608540d2c3$var$viewPlugin), specs = update.state.facet($7beee9608540d2c3$var$viewPlugin);
        if (prevSpecs != specs) {
            let newPlugins = [];
            for (let spec of specs){
                let found = prevSpecs.indexOf(spec);
                if (found < 0) newPlugins.push(new $7beee9608540d2c3$var$PluginInstance(spec));
                else {
                    let plugin = this.plugins[found];
                    plugin.mustUpdate = update;
                    newPlugins.push(plugin);
                }
            }
            for (let plugin of this.plugins)if (plugin.mustUpdate != update) plugin.destroy(this);
            this.plugins = newPlugins;
            this.pluginMap.clear();
        } else for (let p of this.plugins)p.mustUpdate = update;
        for(let i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
        if (prevSpecs != specs) this.inputState.ensureHandlers(this.plugins);
    }
    docViewUpdate() {
        for (let plugin of this.plugins){
            let val = plugin.value;
            if (val && val.docViewUpdate) try {
                val.docViewUpdate(this);
            } catch (e) {
                $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e, "doc view update listener");
            }
        }
    }
    /**
    @internal
    */ measure(flush = true) {
        if (this.destroyed) return;
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        if (this.observer.delayedAndroidKey) {
            this.measureScheduled = -1;
            this.requestMeasure();
            return;
        }
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.forceFlush();
        let updated = null;
        let sDOM = this.scrollDOM, scrollTop = sDOM.scrollTop * this.scaleY;
        let { scrollAnchorPos: scrollAnchorPos, scrollAnchorHeight: scrollAnchorHeight } = this.viewState;
        if (Math.abs(scrollTop - this.viewState.scrollTop) > 1) scrollAnchorHeight = -1;
        this.viewState.scrollAnchorHeight = -1;
        try {
            for(let i = 0;; i++){
                if (scrollAnchorHeight < 0) {
                    if ($7beee9608540d2c3$var$isScrolledToBottom(sDOM)) {
                        scrollAnchorPos = -1;
                        scrollAnchorHeight = this.viewState.heightMap.height;
                    } else {
                        let block = this.viewState.scrollAnchorAt(scrollTop);
                        scrollAnchorPos = block.from;
                        scrollAnchorHeight = block.top;
                    }
                }
                this.updateState = 1 /* UpdateState.Measuring */ ;
                let changed = this.viewState.measure(this);
                if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
                if (i > 5) {
                    console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    break;
                }
                let measuring = [];
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* UpdateFlag.Viewport */ )) [this.measureRequests, measuring] = [
                    measuring,
                    this.measureRequests
                ];
                let measured = measuring.map((m)=>{
                    try {
                        return m.read(this);
                    } catch (e) {
                        $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e);
                        return $7beee9608540d2c3$var$BadMeasure;
                    }
                });
                let update = $7beee9608540d2c3$export$b5b084f95c87edf7.create(this, this.state, []), redrawn = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                this.updateState = 2 /* UpdateState.Updating */ ;
                if (!update.empty) {
                    this.updatePlugins(update);
                    this.inputState.update(update);
                    this.updateAttrs();
                    redrawn = this.docView.update(update);
                    if (redrawn) this.docViewUpdate();
                }
                for(let i = 0; i < measuring.length; i++)if (measured[i] != $7beee9608540d2c3$var$BadMeasure) try {
                    let m = measuring[i];
                    if (m.write) m.write(measured[i], this);
                } catch (e) {
                    $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e);
                }
                if (redrawn) this.docView.updateSelection(true);
                if (!update.viewportChanged && this.measureRequests.length == 0) {
                    if (this.viewState.editorHeight) {
                        if (this.viewState.scrollTarget) {
                            this.docView.scrollIntoView(this.viewState.scrollTarget);
                            this.viewState.scrollTarget = null;
                            scrollAnchorHeight = -1;
                            continue;
                        } else {
                            let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
                            let diff = newAnchorHeight - scrollAnchorHeight;
                            if (diff > 1 || diff < -1) {
                                scrollTop = scrollTop + diff;
                                sDOM.scrollTop = scrollTop / this.scaleY;
                                scrollAnchorHeight = -1;
                                continue;
                            }
                        }
                    }
                    break;
                }
            }
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
            this.measureScheduled = -1;
        }
        if (updated && !updated.empty) for (let listener of this.state.facet($7beee9608540d2c3$var$updateListener))listener(updated);
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return $7beee9608540d2c3$var$baseThemeID + " " + (this.state.facet($7beee9608540d2c3$var$darkTheme) ? $7beee9608540d2c3$var$baseDarkID : $7beee9608540d2c3$var$baseLightID) + " " + this.state.facet($7beee9608540d2c3$var$theme);
    }
    updateAttrs() {
        let editorAttrs = $7beee9608540d2c3$var$attrsFromFacet(this, $7beee9608540d2c3$var$editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        let contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            writingsuggestions: "false",
            translate: "no",
            contenteditable: !this.state.facet($7beee9608540d2c3$var$editable) ? "false" : "true",
            class: "cm-content",
            style: `${$7beee9608540d2c3$var$browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        $7beee9608540d2c3$var$attrsFromFacet(this, $7beee9608540d2c3$var$contentAttributes, contentAttrs);
        let changed = this.observer.ignore(()=>{
            let changedContent = $7beee9608540d2c3$var$updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            let changedEditor = $7beee9608540d2c3$var$updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        let first = true;
        for (let tr of trs)for (let effect of tr.effects)if (effect.is($7beee9608540d2c3$export$eece2fccabbb77c5.announce)) {
            if (first) this.announceDOM.textContent = "";
            first = false;
            let div = this.announceDOM.appendChild(document.createElement("div"));
            div.textContent = effect.value;
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet($7beee9608540d2c3$var$styleModule);
        let nonce = this.state.facet($7beee9608540d2c3$export$eece2fccabbb77c5.cspNonce);
        (0, $afd7c6da9f842a17$export$b920c662d2efee20).mount(this.root, this.styleModules.concat($7beee9608540d2c3$var$baseTheme$1).reverse(), nonce ? {
            nonce: nonce
        } : undefined);
    }
    readMeasured() {
        if (this.updateState == 2 /* UpdateState.Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* UpdateState.Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = this.win.requestAnimationFrame(()=>this.measure());
        if (request) {
            if (this.measureRequests.indexOf(request) > -1) return;
            if (request.key != null) {
                for(let i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        let known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.plugin != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.plugin == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    If the editor is transformed with CSS, this provides the scale
    along the X axis. Otherwise, it will just be 1. Note that
    transforms other than translation and scaling are not supported.
    */ get scaleX() {
        return this.viewState.scaleX;
    }
    /**
    Provide the CSS transformed scale along the Y axis.
    */ get scaleY() {
        return this.viewState.scaleY;
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt)) at the given
    height, again interpreted relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return $7beee9608540d2c3$var$skipAtoms(this, start, $7beee9608540d2c3$var$moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return $7beee9608540d2c3$var$skipAtoms(this, start, $7beee9608540d2c3$var$moveByChar(this, start, forward, (initial)=>$7beee9608540d2c3$var$byGroup(this, start.head, initial)));
    }
    /**
    Get the cursor position visually at the start or end of a line.
    Note that this may differ from the _logical_ position at its
    start or end (which is simply at `line.from`/`line.to`) if text
    at the start or end goes against the line's base text direction.
    */ visualLineSide(line, end) {
        let order = this.bidiSpans(line), dir = this.textDirectionAt(line.from);
        let span = order[end ? order.length - 1 : 0];
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(span.side(end, dir) + line.from, span.forward(!end, dir) ? 1 : -1);
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward, includeWrap = true) {
        return $7beee9608540d2c3$var$moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return $7beee9608540d2c3$var$skipAtoms(this, start, $7beee9608540d2c3$var$moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos, side = 1) {
        return this.docView.domAtPos(pos, side);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node, offset = 0) {
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords, precise = true) {
        this.readMeasured();
        let found = $7beee9608540d2c3$var$posAtCoords(this, coords, precise);
        return found && found.pos;
    }
    posAndSideAtCoords(coords, precise = true) {
        this.readMeasured();
        return $7beee9608540d2c3$var$posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos, side = 1) {
        this.readMeasured();
        let rect = this.docView.coordsAt(pos, side);
        if (!rect || rect.left == rect.right) return rect;
        let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        let span = order[$7beee9608540d2c3$export$e1ed96b746bb516a.find(order, pos - line.from, -1, side)];
        return $7beee9608540d2c3$var$flattenRect(rect, span.dir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR == side > 0);
    }
    /**
    Return the rectangle around a given character. If `pos` does not
    point in front of a character that is in the viewport and
    rendered (i.e. not replaced, not a line break), this will return
    null. For space characters that are a line wrap point, this will
    return the position before the line break.
    */ coordsForChar(pos) {
        this.readMeasured();
        return this.docView.coordsForChar(pos);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        let perLine = this.state.facet($7beee9608540d2c3$var$perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > $7beee9608540d2c3$var$MaxBidiLine) return $7beee9608540d2c3$var$trivialOrder(line.length);
        let dir = this.textDirectionAt(line.from), isolates;
        for (let entry of this.bidiCache){
            if (entry.from == line.from && entry.dir == dir && (entry.fresh || $7beee9608540d2c3$var$isolatesEq(entry.isolates, isolates = $7beee9608540d2c3$var$getIsolatedRanges(this, line)))) return entry.order;
        }
        if (!isolates) isolates = $7beee9608540d2c3$var$getIsolatedRanges(this, line);
        let order = $7beee9608540d2c3$var$computeOrder(line.text, dir, isolates);
        this.bidiCache.push(new $7beee9608540d2c3$var$CachedOrder(line.from, line.to, dir, isolates, true, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (this.dom.ownerDocument.hasFocus() || $7beee9608540d2c3$var$browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            $7beee9608540d2c3$var$focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
    necessary when moving the editor's existing DOM to a new window or shadow root.
    */ setRoot(root) {
        if (this._root != root) {
            this._root = root;
            this.observer.setWindow((root.nodeType == 9 ? root : root.ownerDocument).defaultView || window);
            this.mountStyles();
        }
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        if (this.root.activeElement == this.contentDOM) this.contentDOM.blur();
        for (let plugin of this.plugins)plugin.destroy(this);
        this.plugins = [];
        this.inputState.destroy();
        this.docView.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos, options = {}) {
        return $7beee9608540d2c3$var$scrollIntoView.of(new $7beee9608540d2c3$var$ScrollTarget(typeof pos == "number" ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos) : pos, options.y, options.x, options.yMargin, options.xMargin));
    }
    /**
    Return an effect that resets the editor to its current (at the
    time this method was called) scroll position. Note that this
    only affects the editor's own scrollable element, not parents.
    See also
    [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
    
    The effect should be used with a document identical to the one
    it was created for. Failing to do so is not an error, but may
    not scroll to the expected position. You can
    [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
    */ scrollSnapshot() {
        let { scrollTop: scrollTop, scrollLeft: scrollLeft } = this.scrollDOM;
        let ref = this.viewState.scrollAnchorAt(scrollTop);
        return $7beee9608540d2c3$var$scrollIntoView.of(new $7beee9608540d2c3$var$ScrollTarget((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(ref.from), "start", "start", ref.top - scrollTop, scrollLeft, true));
    }
    /**
    Enable or disable tab-focus mode, which disables key bindings
    for Tab and Shift-Tab, letting the browser's default
    focus-changing behavior go through instead. This is useful to
    prevent trapping keyboard users in your editor.
    
    Without argument, this toggles the mode. With a boolean, it
    enables (true) or disables it (false). Given a number, it
    temporarily enables the mode until that number of milliseconds
    have passed or another non-Tab key is pressed.
    */ setTabFocusMode(to) {
        if (to == null) this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1;
        else if (typeof to == "boolean") this.inputState.tabFocusMode = to ? 0 : -1;
        else if (this.inputState.tabFocusMode != 0) this.inputState.tabFocusMode = Date.now() + to;
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return $7beee9608540d2c3$export$44d5eccfd62adda7.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create an extension that registers DOM event observers. Contrary
    to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
    observers can't be prevented from running by a higher-precedence
    handler returning true. They also don't prevent other handlers
    and observers from running when they return true, and should not
    call `preventDefault`.
    */ static domEventObservers(observers) {
        return $7beee9608540d2c3$export$44d5eccfd62adda7.define(()=>({}), {
            eventObservers: observers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        let prefix = (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName();
        let result = [
            $7beee9608540d2c3$var$theme.of(prefix),
            $7beee9608540d2c3$var$styleModule.of($7beee9608540d2c3$var$buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push($7beee9608540d2c3$var$darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, $6295c6875f57e3ee$export$b92464a736444411).lowest($7beee9608540d2c3$var$styleModule.of($7beee9608540d2c3$var$buildTheme("." + $7beee9608540d2c3$var$baseThemeID, spec, $7beee9608540d2c3$var$lightDarkIDs)));
    }
    /**
    Retrieve an editor view instance from the view's DOM
    representation.
    */ static findFromDOM(dom) {
        var _a;
        let content = dom.querySelector(".cm-content");
        let tile = content && $7beee9608540d2c3$var$Tile.get(content) || $7beee9608540d2c3$var$Tile.get(dom);
        return ((_a = tile === null || tile === void 0 ? void 0 : tile.root) === null || _a === void 0 ? void 0 : _a.view) || null;
    }
}
/**
Facet to add a [style
module](https://github.com/marijnh/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.styleModule = $7beee9608540d2c3$var$styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.

The `insert` argument can be used to get the default transaction
that would be applied for this input. This can be useful when
dispatching the custom behavior as a separate transaction.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.inputHandler = $7beee9608540d2c3$var$inputHandler;
/**
Functions provided in this facet will be used to transform text
pasted or dropped into the editor.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.clipboardInputFilter = $7beee9608540d2c3$var$clipboardInputFilter;
/**
Transform text copied or dragged from the editor.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.clipboardOutputFilter = $7beee9608540d2c3$var$clipboardOutputFilter;
/**
Scroll handlers can override how things are scrolled into view.
If they return `true`, no further handling happens for the
scrolling. If they return false, the default scroll behavior is
applied. Scroll handlers should never initiate editor updates.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.scrollHandler = $7beee9608540d2c3$var$scrollHandler;
/**
This facet can be used to provide functions that create effects
to be dispatched when the editor's focus state changes.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.focusChangeEffect = $7beee9608540d2c3$var$focusChangeEffect;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.perLineTextDirection = $7beee9608540d2c3$var$perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.exceptionSink = $7beee9608540d2c3$var$exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.updateListener = $7beee9608540d2c3$var$updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.editable = $7beee9608540d2c3$var$editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.mouseSelectionStyle = $7beee9608540d2c3$var$mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.dragMovesSelection = $7beee9608540d2c3$var$dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.clickAddsSelectionRange = $7beee9608540d2c3$var$clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.

If you want decorated ranges to behave like atomic units for
cursor motion and deletion purposes, also provide the range set
containing the decorations to
[`EditorView.atomicRanges`](https://codemirror.net/6/docs/ref/#view.EditorView^atomicRanges).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.decorations = $7beee9608540d2c3$var$decorations;
/**
[Block wrappers](https://codemirror.net/6/docs/ref/#view.BlockWrapper) provide a way to add DOM
structure around editor lines and block widgets. Sets of
wrappers are provided in a similar way to decorations, and are
nested in a similar way when they overlap. A wrapper affects all
lines and block widgets that start inside its range.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.blockWrappers = $7beee9608540d2c3$var$blockWrappers;
/**
Facet that works much like
[`decorations`](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), but puts its
inputs at the very bottom of the precedence stack, meaning mark
decorations provided here will only be split by other, partially
overlapping `outerDecorations` ranges, and wrap around all
regular decorations. Use this for mark elements that should, as
much as possible, remain in one piece.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.outerDecorations = $7beee9608540d2c3$var$outerDecorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.atomicRanges = $7beee9608540d2c3$var$atomicRanges;
/**
When range decorations add a `unicode-bidi: isolate` style, they
should also include a
[`bidiIsolate`](https://codemirror.net/6/docs/ref/#view.MarkDecorationSpec.bidiIsolate) property
in their decoration spec, and be exposed through this facet, so
that the editor can compute the proper text order. (Other values
for `unicode-bidi`, except of course `normal`, are not
supported.)
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.bidiIsolatedRanges = $7beee9608540d2c3$var$bidiIsolatedRanges;
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.scrollMargins = $7beee9608540d2c3$var$scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.darkTheme = $7beee9608540d2c3$var$darkTheme;
/**
Provides a Content Security Policy nonce to use when creating
the style sheets for the editor. Holds the empty string when no
nonce has been provided.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.cspNonce = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : ""
});
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes = $7beee9608540d2c3$var$contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.editorAttributes = $7beee9608540d2c3$var$editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.lineWrapping = /*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.announce = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
// Maximum line length for which we compute accurate bidi info
const $7beee9608540d2c3$var$MaxBidiLine = 4096;
const $7beee9608540d2c3$var$BadMeasure = {};
class $7beee9608540d2c3$var$CachedOrder {
    constructor(from, to, dir, isolates, fresh, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.isolates = isolates;
        this.fresh = fresh;
        this.order = order;
    }
    static update(cache, changes) {
        if (changes.empty && !cache.some((c)=>c.fresh)) return cache;
        let result = [], lastDir = cache.length ? cache[cache.length - 1].dir : $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        for(let i = Math.max(0, cache.length - 10); i < cache.length; i++){
            let entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new $7beee9608540d2c3$var$CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.isolates, false, entry.order));
        }
        return result;
    }
}
function $7beee9608540d2c3$var$attrsFromFacet(view, facet, base) {
    for(let sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        let source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) $7beee9608540d2c3$var$combineAttrs(value, base);
    }
    return base;
}
const $7beee9608540d2c3$var$currentPlatform = $7beee9608540d2c3$var$browser.mac ? "mac" : $7beee9608540d2c3$var$browser.windows ? "win" : $7beee9608540d2c3$var$browser.linux ? "linux" : "key";
function $7beee9608540d2c3$var$normalizeKeyName(name, platform) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; ++i){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $7beee9608540d2c3$var$modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
const $7beee9608540d2c3$var$handleKeyEvents = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).default(/*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.domEventHandlers({
    keydown (event, view) {
        return $7beee9608540d2c3$var$runHandlers($7beee9608540d2c3$var$getKeymap(view.state), event, view, "editor");
    }
}));
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ const $7beee9608540d2c3$export$5043418e2ef368d5 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    enables: $7beee9608540d2c3$var$handleKeyEvents
});
const $7beee9608540d2c3$var$Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function $7beee9608540d2c3$var$getKeymap(state) {
    let bindings = state.facet($7beee9608540d2c3$export$5043418e2ef368d5);
    let map = $7beee9608540d2c3$var$Keymaps.get(bindings);
    if (!map) $7beee9608540d2c3$var$Keymaps.set(bindings, map = $7beee9608540d2c3$var$buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function $7beee9608540d2c3$export$bce154f45536286e(view, event, scope) {
    return $7beee9608540d2c3$var$runHandlers($7beee9608540d2c3$var$getKeymap(view.state), event, view, scope);
}
let $7beee9608540d2c3$var$storedPrefix = null;
const $7beee9608540d2c3$var$PrefixTimeout = 4000;
function $7beee9608540d2c3$var$buildKeymap(bindings, platform = $7beee9608540d2c3$var$currentPlatform) {
    let bound = Object.create(null);
    let isPrefix = Object.create(null);
    let checkPrefix = (name, is)=>{
        let current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    let add = (scope, key, command, preventDefault, stopPropagation)=>{
        var _a, _b;
        let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        let parts = key.split(/ (?!$)/).map((k)=>$7beee9608540d2c3$var$normalizeKeyName(k, platform));
        for(let i = 1; i < parts.length; i++){
            let prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                stopPropagation: false,
                run: [
                    (view)=>{
                        let ourObj = $7beee9608540d2c3$var$storedPrefix = {
                            view: view,
                            prefix: prefix,
                            scope: scope
                        };
                        setTimeout(()=>{
                            if ($7beee9608540d2c3$var$storedPrefix == ourObj) $7beee9608540d2c3$var$storedPrefix = null;
                        }, $7beee9608540d2c3$var$PrefixTimeout);
                        return true;
                    }
                ]
            };
        }
        let full = parts.join(" ");
        checkPrefix(full, false);
        let binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            stopPropagation: false,
            run: ((_b = (_a = scopeObj._any) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
        });
        if (command) binding.run.push(command);
        if (preventDefault) binding.preventDefault = true;
        if (stopPropagation) binding.stopPropagation = true;
    };
    for (let b of bindings){
        let scopes = b.scope ? b.scope.split(" ") : [
            "editor"
        ];
        if (b.any) for (let scope of scopes){
            let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
            if (!scopeObj._any) scopeObj._any = {
                preventDefault: false,
                stopPropagation: false,
                run: []
            };
            let { any: any } = b;
            for(let key in scopeObj)scopeObj[key].run.push((view)=>any(view, $7beee9608540d2c3$var$currentKeyEvent));
        }
        let name = b[platform] || b.key;
        if (!name) continue;
        for (let scope of scopes){
            add(scope, name, b.run, b.preventDefault, b.stopPropagation);
            if (b.shift) add(scope, "Shift-" + name, b.shift, b.preventDefault, b.stopPropagation);
        }
    }
    return bound;
}
let $7beee9608540d2c3$var$currentKeyEvent = null;
function $7beee9608540d2c3$var$runHandlers(map, event, view, scope) {
    $7beee9608540d2c3$var$currentKeyEvent = event;
    let name = (0, $68b9e7c405929963$export$fb33aafd75404f4c)(event);
    let charCode = (0, $6295c6875f57e3ee$export$42977f40461e1360)(name, 0), isChar = (0, $6295c6875f57e3ee$export$a870abf234f6353c)(charCode) == name.length && name != " ";
    let prefix = "", handled = false, prevented = false, stopPropagation = false;
    if ($7beee9608540d2c3$var$storedPrefix && $7beee9608540d2c3$var$storedPrefix.view == view && $7beee9608540d2c3$var$storedPrefix.scope == scope) {
        prefix = $7beee9608540d2c3$var$storedPrefix.prefix + " ";
        if ($7beee9608540d2c3$var$modifierCodes.indexOf(event.keyCode) < 0) {
            prevented = true;
            $7beee9608540d2c3$var$storedPrefix = null;
        }
    }
    let ran = new Set;
    let runFor = (binding)=>{
        if (binding) {
            for (let cmd of binding.run)if (!ran.has(cmd)) {
                ran.add(cmd);
                if (cmd(view)) {
                    if (binding.stopPropagation) stopPropagation = true;
                    return true;
                }
            }
            if (binding.preventDefault) {
                if (binding.stopPropagation) stopPropagation = true;
                prevented = true;
            }
        }
        return false;
    };
    let scopeObj = map[scope], baseName, shiftName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(name, event, !isChar)])) handled = true;
        else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
        !($7beee9608540d2c3$var$browser.windows && event.ctrlKey && event.altKey) && // Alt-combinations on macOS tend to be typed characters
        !($7beee9608540d2c3$var$browser.mac && event.altKey && !(event.ctrlKey || event.metaKey)) && (baseName = (0, $68b9e7c405929963$export$e2253033e6e1df16)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(baseName, event, true)])) handled = true;
            else if (event.shiftKey && (shiftName = (0, $68b9e7c405929963$export$fba63a578e423eb)[event.keyCode]) != name && shiftName != baseName && runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(shiftName, event, false)])) handled = true;
        } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(name, event, true)])) handled = true;
        if (!handled && runFor(scopeObj._any)) handled = true;
    }
    if (prevented) handled = true;
    if (handled && stopPropagation) event.stopPropagation();
    $7beee9608540d2c3$var$currentKeyEvent = null;
    return handled;
}
/**
Implementation of [`LayerMarker`](https://codemirror.net/6/docs/ref/#view.LayerMarker) that creates
a rectangle at a given set of coordinates.
*/ class $7beee9608540d2c3$export$9ddce7bd14f42a78 {
    /**
    Create a marker with the given class and dimensions. If `width`
    is null, the DOM element will get no width style.
    */ constructor(className, /**
    The left position of the marker (in pixels, document-relative).
    */ left, /**
    The top position of the marker.
    */ top, /**
    The width of the marker, or null if it shouldn't get a width assigned.
    */ width, /**
    The height of the marker.
    */ height){
        this.className = className;
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    draw() {
        let elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    update(elt, prev) {
        if (prev.className != this.className) return false;
        this.adjust(elt);
        return true;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width != null) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
    /**
    Create a set of rectangles for the given selection range,
    assigning them theclass`className`. Will create a single
    rectangle for empty ranges, and a set of selection-style
    rectangles covering the range's content (in a bidi-aware
    way) for non-empty ones.
    */ static forRange(view, className, range) {
        if (range.empty) {
            let pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (!pos) return [];
            let base = $7beee9608540d2c3$var$getBase(view);
            return [
                new $7beee9608540d2c3$export$9ddce7bd14f42a78(className, pos.left - base.left, pos.top - base.top, null, pos.bottom - pos.top)
            ];
        } else return $7beee9608540d2c3$var$rectanglesForRange(view, className, range);
    }
}
function $7beee9608540d2c3$var$getBase(view) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let left = view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth * view.scaleX;
    return {
        left: left - view.scrollDOM.scrollLeft * view.scaleX,
        top: rect.top - view.scrollDOM.scrollTop * view.scaleY
    };
}
function $7beee9608540d2c3$var$wrappedLine(view, pos, side, inside) {
    let coords = view.coordsAtPos(pos, side * 2);
    if (!coords) return inside;
    let editorRect = view.dom.getBoundingClientRect();
    let y = (coords.top + coords.bottom) / 2;
    let left = view.posAtCoords({
        x: editorRect.left + 1,
        y: y
    });
    let right = view.posAtCoords({
        x: editorRect.right - 1,
        y: y
    });
    if (left == null || right == null) return inside;
    return {
        from: Math.max(inside.from, Math.min(left, right)),
        to: Math.min(inside.to, Math.max(left, right))
    };
}
function $7beee9608540d2c3$var$rectanglesForRange(view, className, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    let from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    let ltr = view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
    let content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = $7beee9608540d2c3$var$getBase(view);
    let lineElt = content.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
    let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
    let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
    let startBlock = $7beee9608540d2c3$var$blockAt(view, from, 1), endBlock = $7beee9608540d2c3$var$blockAt(view, to, -1);
    let visualStart = startBlock.type == $7beee9608540d2c3$export$48808c686fe495c4.Text ? startBlock : null;
    let visualEnd = endBlock.type == $7beee9608540d2c3$export$48808c686fe495c4.Text ? endBlock : null;
    if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks)) visualStart = $7beee9608540d2c3$var$wrappedLine(view, from, 1, visualStart);
    if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks)) visualEnd = $7beee9608540d2c3$var$wrappedLine(view, to, -1, visualEnd);
    if (visualStart && visualEnd && visualStart.from == visualEnd.from && visualStart.to == visualEnd.to) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        let top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        let bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        let between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top.bottom + view.defaultLineHeight / 2 < bottom.top) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == $7beee9608540d2c3$export$48808c686fe495c4.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new $7beee9608540d2c3$export$9ddce7bd14f42a78(className, left - base.left, top - base.top, right - left, bottom - top);
    }
    function pieces({ top: top, bottom: bottom, horizontal: horizontal }) {
        let pieces = [];
        for(let i = 0; i < horizontal.length; i += 2)pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        let top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            let fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            let toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            if (!fromCoords || !toCoords) return;
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        let start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        // Split the range by visible range and document line
        for (let r of view.visibleRanges)if (r.to > start && r.from < end) for(let pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
            let docLine = view.state.doc.lineAt(pos);
            for (let span of view.bidiSpans(docLine)){
                let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                if (spanFrom >= endPos) break;
                if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
            }
            pos = docLine.to + 1;
            if (pos >= endPos) break;
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top: top,
            bottom: bottom,
            horizontal: horizontal
        };
    }
    function drawForWidget(block, top) {
        let y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function $7beee9608540d2c3$var$sameMarker(a, b) {
    return a.constructor == b.constructor && a.eq(b);
}
class $7beee9608540d2c3$var$LayerView {
    constructor(view, layer){
        this.view = view;
        this.layer = layer;
        this.drawn = [];
        this.scaleX = 1;
        this.scaleY = 1;
        this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        };
        this.dom = view.scrollDOM.appendChild(document.createElement("div"));
        this.dom.classList.add("cm-layer");
        if (layer.above) this.dom.classList.add("cm-layer-above");
        if (layer.class) this.dom.classList.add(layer.class);
        this.scale();
        this.dom.setAttribute("aria-hidden", "true");
        this.setOrder(view.state);
        view.requestMeasure(this.measureReq);
        if (layer.mount) layer.mount(this.dom, view);
    }
    update(update) {
        if (update.startState.facet($7beee9608540d2c3$var$layerOrder) != update.state.facet($7beee9608540d2c3$var$layerOrder)) this.setOrder(update.state);
        if (this.layer.update(update, this.dom) || update.geometryChanged) {
            this.scale();
            update.view.requestMeasure(this.measureReq);
        }
    }
    docViewUpdate(view) {
        if (this.layer.updateOnDocViewUpdate !== false) view.requestMeasure(this.measureReq);
    }
    setOrder(state) {
        let pos = 0, order = state.facet($7beee9608540d2c3$var$layerOrder);
        while(pos < order.length && order[pos] != this.layer)pos++;
        this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
    }
    measure() {
        return this.layer.markers(this.view);
    }
    scale() {
        let { scaleX: scaleX, scaleY: scaleY } = this.view;
        if (scaleX != this.scaleX || scaleY != this.scaleY) {
            this.scaleX = scaleX;
            this.scaleY = scaleY;
            this.dom.style.transform = `scale(${1 / scaleX}, ${1 / scaleY})`;
        }
    }
    draw(markers) {
        if (markers.length != this.drawn.length || markers.some((p, i)=>!$7beee9608540d2c3$var$sameMarker(p, this.drawn[i]))) {
            let old = this.dom.firstChild, oldI = 0;
            for (let marker of markers)if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
                old = old.nextSibling;
                oldI++;
            } else this.dom.insertBefore(marker.draw(), old);
            while(old){
                let next = old.nextSibling;
                old.remove();
                old = next;
            }
            this.drawn = markers;
            if ($7beee9608540d2c3$var$browser.safari && $7beee9608540d2c3$var$browser.safari_version >= 26) this.dom.style.display = this.dom.firstChild ? "" : "none";
        }
    }
    destroy() {
        if (this.layer.destroy) this.layer.destroy(this.dom, this.view);
        this.dom.remove();
    }
}
const $7beee9608540d2c3$var$layerOrder = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Define a layer.
*/ function $7beee9608540d2c3$export$50a222d9023da98b(config) {
    return [
        $7beee9608540d2c3$export$44d5eccfd62adda7.define((v)=>new $7beee9608540d2c3$var$LayerView(v, config)),
        $7beee9608540d2c3$var$layerOrder.of(config)
    ];
}
const $7beee9608540d2c3$var$selectionConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function $7beee9608540d2c3$export$17a3d0ab3687347d(config = {}) {
    return [
        $7beee9608540d2c3$var$selectionConfig.of(config),
        $7beee9608540d2c3$var$cursorLayer,
        $7beee9608540d2c3$var$selectionLayer,
        $7beee9608540d2c3$var$hideNativeSelection,
        $7beee9608540d2c3$var$nativeSelectionHidden.of(true)
    ];
}
/**
Retrieve the [`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) configuration
for this state. (Note that this will return a set of defaults even
if `drawSelection` isn't enabled.)
*/ function $7beee9608540d2c3$export$74e411a7b5f41f23(state) {
    return state.facet($7beee9608540d2c3$var$selectionConfig);
}
function $7beee9608540d2c3$var$configChanged(update) {
    return update.startState.facet($7beee9608540d2c3$var$selectionConfig) != update.state.facet($7beee9608540d2c3$var$selectionConfig);
}
const $7beee9608540d2c3$var$cursorLayer = /*@__PURE__*/ $7beee9608540d2c3$export$50a222d9023da98b({
    above: true,
    markers (view) {
        let { state: state } = view, conf = state.facet($7beee9608540d2c3$var$selectionConfig);
        let cursors = [];
        for (let r of state.selection.ranges){
            let prim = r == state.selection.main;
            if (r.empty || conf.drawRangeCursor) {
                let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
                let cursor = r.empty ? r : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(r.head, r.head > r.anchor ? -1 : 1);
                for (let piece of $7beee9608540d2c3$export$9ddce7bd14f42a78.forRange(view, className, cursor))cursors.push(piece);
            }
        }
        return cursors;
    },
    update (update, dom) {
        if (update.transactions.some((tr)=>tr.selection)) dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        let confChange = $7beee9608540d2c3$var$configChanged(update);
        if (confChange) $7beee9608540d2c3$var$setBlinkRate(update.state, dom);
        return update.docChanged || update.selectionSet || confChange;
    },
    mount (dom, view) {
        $7beee9608540d2c3$var$setBlinkRate(view.state, dom);
    },
    class: "cm-cursorLayer"
});
function $7beee9608540d2c3$var$setBlinkRate(state, dom) {
    dom.style.animationDuration = state.facet($7beee9608540d2c3$var$selectionConfig).cursorBlinkRate + "ms";
}
const $7beee9608540d2c3$var$selectionLayer = /*@__PURE__*/ $7beee9608540d2c3$export$50a222d9023da98b({
    above: false,
    markers (view) {
        return view.state.selection.ranges.map((r)=>r.empty ? [] : $7beee9608540d2c3$export$9ddce7bd14f42a78.forRange(view, "cm-selectionBackground", r)).reduce((a, b)=>a.concat(b));
    },
    update (update, dom) {
        return update.docChanged || update.selectionSet || update.viewportChanged || $7beee9608540d2c3$var$configChanged(update);
    },
    class: "cm-selectionLayer"
});
const $7beee9608540d2c3$var$hideNativeSelection = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.theme({
    ".cm-line": {
        "& ::selection, &::selection": {
            backgroundColor: "transparent !important"
        },
        caretColor: "transparent !important"
    },
    ".cm-content": {
        caretColor: "transparent !important",
        "& :focus": {
            caretColor: "initial !important",
            "&::selection, & ::selection": {
                backgroundColor: "Highlight !important"
            }
        }
    }
}));
const $7beee9608540d2c3$var$setDropCursorPos = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
const $7beee9608540d2c3$var$dropCursorPos = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is($7beee9608540d2c3$var$setDropCursorPos) ? e.value : pos, pos);
    }
});
const $7beee9608540d2c3$var$drawDropCursor = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    update(update) {
        var _a;
        let cursorPos = update.state.field($7beee9608540d2c3$var$dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field($7beee9608540d2c3$var$dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        let { view: view } = this;
        let pos = view.state.field($7beee9608540d2c3$var$dropCursorPos);
        let rect = pos != null && view.coordsAtPos(pos);
        if (!rect) return null;
        let outer = view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + view.scrollDOM.scrollLeft * view.scaleX,
            top: rect.top - outer.top + view.scrollDOM.scrollTop * view.scaleY,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            let { scaleX: scaleX, scaleY: scaleY } = this.view;
            if (pos) {
                this.cursor.style.left = pos.left / scaleX + "px";
                this.cursor.style.top = pos.top / scaleY + "px";
                this.cursor.style.height = pos.height / scaleY + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field($7beee9608540d2c3$var$dropCursorPos) != pos) this.view.dispatch({
            effects: $7beee9608540d2c3$var$setDropCursorPos.of(pos)
        });
    }
}, {
    eventObservers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function $7beee9608540d2c3$export$b8e3092a3bfa2062() {
    return [
        $7beee9608540d2c3$var$dropCursorPos,
        $7beee9608540d2c3$var$drawDropCursor
    ];
}
function $7beee9608540d2c3$var$iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(let cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, m);
    }
}
function $7beee9608540d2c3$var$matchRanges(view, maxLength) {
    let visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    let result = [];
    for (let { from: from, to: to } of visible){
        from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
        to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
        if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
        else result.push({
            from: from,
            to: to
        });
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class $7beee9608540d2c3$export$9b928b0ca20b25cb {
    /**
    Create a decorator.
    */ constructor(config){
        const { regexp: regexp, decoration: decoration, decorate: decorate, boundary: boundary, maxLength: maxLength = 1000 } = config;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        if (decorate) this.addMatch = (match, view, from, add)=>decorate(add, from, from + match[0].length, match, view);
        else if (typeof decoration == "function") this.addMatch = (match, view, from, add)=>{
            let deco = decoration(match, view, from);
            if (deco) add(from, from + match[0].length, deco);
        };
        else if (decoration) this.addMatch = (match, _view, from, add)=>add(from, from + match[0].length, decoration);
        else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        let build = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)(), add = build.add.bind(build);
        for (let { from: from, to: to } of $7beee9608540d2c3$var$matchRanges(view, this.maxLength))$7beee9608540d2c3$var$iterMatches(view.state.doc, this.regexp, from, to, (from, m)=>this.addMatch(m, view, from, add));
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        let changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to >= update.view.viewport.from && from <= update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportMoved || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        for (let r of view.visibleRanges){
            let from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
            if (to >= from) {
                let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                if (this.boundary) {
                    for(; from > fromLine.from; from--)if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                        start = from;
                        break;
                    }
                    for(; to < toLine.to; to++)if (this.boundary.test(toLine.text[to - toLine.from])) {
                        end = to;
                        break;
                    }
                }
                let ranges = [], m;
                let add = (from, to, deco)=>ranges.push(deco.range(from, to));
                if (fromLine == toLine) {
                    this.regexp.lastIndex = start - fromLine.from;
                    while((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)this.addMatch(m, view, m.index + fromLine.from, add);
                } else $7beee9608540d2c3$var$iterMatches(view.state.doc, this.regexp, start, end, (from, m)=>this.addMatch(m, view, from, add));
                deco = deco.update({
                    filterFrom: start,
                    filterTo: end,
                    filter: (from, to)=>from < start || to > end,
                    add: ranges
                });
            }
        }
        return deco;
    }
}
const $7beee9608540d2c3$var$UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const $7beee9608540d2c3$var$Specials = /*@__PURE__*/ new RegExp("[\u0000-\u0008\u000a-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]", $7beee9608540d2c3$var$UnicodeRegexpSupport);
const $7beee9608540d2c3$var$Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
let $7beee9608540d2c3$var$_supportsTabSize = null;
function $7beee9608540d2c3$var$supportsTabSize() {
    var _a;
    if ($7beee9608540d2c3$var$_supportsTabSize == null && typeof document != "undefined" && document.body) {
        let styles = document.body.style;
        $7beee9608540d2c3$var$_supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return $7beee9608540d2c3$var$_supportsTabSize || false;
}
const $7beee9608540d2c3$var$specialCharConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let config = (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            render: null,
            specialChars: $7beee9608540d2c3$var$Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !$7beee9608540d2c3$var$supportsTabSize()) config.specialChars = new RegExp("\t|" + config.specialChars.source, $7beee9608540d2c3$var$UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, $7beee9608540d2c3$var$UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function $7beee9608540d2c3$export$76dc0899547f659c(/**
Configuration options.
*/ config = {}) {
    return [
        $7beee9608540d2c3$var$specialCharConfig.of(config),
        $7beee9608540d2c3$var$specialCharPlugin()
    ];
}
let $7beee9608540d2c3$var$_plugin = null;
function $7beee9608540d2c3$var$specialCharPlugin() {
    return $7beee9608540d2c3$var$_plugin || ($7beee9608540d2c3$var$_plugin = $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.decorations = $7beee9608540d2c3$export$10e30b733df217ea.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet($7beee9608540d2c3$var$specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
        makeDecorator(conf) {
            return new $7beee9608540d2c3$export$9b928b0ca20b25cb({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    let { doc: doc } = view.state;
                    let code = (0, $6295c6875f57e3ee$export$42977f40461e1360)(m[0], 0);
                    if (code == 9) {
                        let line = doc.lineAt(pos);
                        let size = view.state.tabSize, col = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(line.text, size, pos - line.from);
                        return $7beee9608540d2c3$export$10e30b733df217ea.replace({
                            widget: new $7beee9608540d2c3$var$TabWidget((size - col % size) * this.view.defaultCharacterWidth / this.view.scaleX)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = $7beee9608540d2c3$export$10e30b733df217ea.replace({
                        widget: new $7beee9608540d2c3$var$SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            let conf = update.state.facet($7beee9608540d2c3$var$specialCharConfig);
            if (update.startState.facet($7beee9608540d2c3$var$specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
const $7beee9608540d2c3$var$DefaultPlaceholder = "\u2022";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function $7beee9608540d2c3$var$placeholder$1(code) {
    if (code >= 32) return $7beee9608540d2c3$var$DefaultPlaceholder;
    if (code == 10) return "\u2424";
    return String.fromCharCode(9216 + code);
}
class $7beee9608540d2c3$var$SpecialCharWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        let ph = $7beee9608540d2c3$var$placeholder$1(this.code);
        let desc = view.state.phrase("Control character") + " " + ($7beee9608540d2c3$var$Names[this.code] || "0x" + this.code.toString(16));
        let custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        let span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
class $7beee9608540d2c3$var$TabWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(width){
        super();
        this.width = width;
    }
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        let span = document.createElement("span");
        span.textContent = "\t";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
const $7beee9608540d2c3$var$plugin = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
    update(update) {
        let { view: view } = update;
        let height = view.viewState.editorHeight - view.defaultLineHeight - view.documentPadding.top - 0.5;
        if (height >= 0 && height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function $7beee9608540d2c3$export$1f905ef5d6deb4f() {
    return [
        $7beee9608540d2c3$var$plugin,
        $7beee9608540d2c3$var$contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin($7beee9608540d2c3$var$plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function $7beee9608540d2c3$export$1a7e096bee9035c() {
    return $7beee9608540d2c3$var$activeLineHighlighter;
}
const $7beee9608540d2c3$var$lineDeco = /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.line({
    class: "cm-activeLine"
});
const $7beee9608540d2c3$var$activeLineHighlighter = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let lastLineStart = -1, deco = [];
        for (let r of view.state.selection.ranges){
            let line = view.lineBlockAt(r.head);
            if (line.from > lastLineStart) {
                deco.push($7beee9608540d2c3$var$lineDeco.range(line.from));
                lastLineStart = line.from;
            }
        }
        return $7beee9608540d2c3$export$10e30b733df217ea.set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
class $7beee9608540d2c3$var$Placeholder extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(content){
        super();
        this.content = content;
    }
    toDOM(view) {
        let wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(view) : this.content.cloneNode(true));
        wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    coordsAt(dom) {
        let rects = dom.firstChild ? $7beee9608540d2c3$var$clientRectsFor(dom.firstChild) : [];
        if (!rects.length) return null;
        let style = window.getComputedStyle(dom.parentNode);
        let rect = $7beee9608540d2c3$var$flattenRect(rects[0], style.direction != "rtl");
        let lineHeight = parseInt(style.lineHeight);
        if (rect.bottom - rect.top > lineHeight * 1.5) return {
            left: rect.left,
            right: rect.right,
            top: rect.top,
            bottom: rect.top + lineHeight
        };
        return rect;
    }
    ignoreEvent() {
        return false;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function $7beee9608540d2c3$export$c7187bbd1a7a9244(content) {
    let plugin = $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.placeholder = content ? $7beee9608540d2c3$export$10e30b733df217ea.set([
                $7beee9608540d2c3$export$10e30b733df217ea.widget({
                    widget: new $7beee9608540d2c3$var$Placeholder(content),
                    side: 1
                }).range(0)
            ]) : $7beee9608540d2c3$export$10e30b733df217ea.none;
        }
        get decorations() {
            return this.view.state.doc.length ? $7beee9608540d2c3$export$10e30b733df217ea.none : this.placeholder;
        }
    }, {
        decorations: (v)=>v.decorations
    });
    return typeof content == "string" ? [
        plugin,
        $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes.of({
            "aria-placeholder": content
        })
    ] : plugin;
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
const $7beee9608540d2c3$var$MaxOff = 2000;
function $7beee9608540d2c3$var$rectangleFor(state, a, b) {
    let startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    let ranges = [];
    if (a.off > $7beee9608540d2c3$var$MaxOff || b.off > $7beee9608540d2c3$var$MaxOff || a.col < 0 || b.col < 0) {
        let startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(line.from + startOff, line.to + endOff));
        }
    } else {
        let startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            let start = (0, $6295c6875f57e3ee$export$718b3d71c384ca05)(line.text, startCol, state.tabSize, true);
            if (start < 0) ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(line.to));
            else {
                let end = (0, $6295c6875f57e3ee$export$718b3d71c384ca05)(line.text, endCol, state.tabSize);
                ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(line.from + start, line.from + end));
            }
        }
    }
    return ranges;
}
function $7beee9608540d2c3$var$absoluteColumn(view, x) {
    let ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function $7beee9608540d2c3$var$getPos(view, event) {
    let offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let line = view.state.doc.lineAt(offset), off = offset - line.from;
    let col = off > $7beee9608540d2c3$var$MaxOff ? -1 : off == line.length ? $7beee9608540d2c3$var$absoluteColumn(view, event.clientX) : (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col: col,
        off: off
    };
}
function $7beee9608540d2c3$var$rectangleSelectionStyle(view, event) {
    let start = $7beee9608540d2c3$var$getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                let newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            let cur = $7beee9608540d2c3$var$getPos(view, event);
            if (!cur) return startSel;
            let ranges = $7beee9608540d2c3$var$rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges.concat(startSel.ranges));
            else return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function $7beee9608540d2c3$export$dd482925db1aabd3(options) {
    let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return $7beee9608540d2c3$export$eece2fccabbb77c5.mouseSelectionStyle.of((view, event)=>filter(event) ? $7beee9608540d2c3$var$rectangleSelectionStyle(view, event) : null);
}
const $7beee9608540d2c3$var$keys = {
    Alt: [
        18,
        (e)=>!!e.altKey
    ],
    Control: [
        17,
        (e)=>!!e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>!!e.shiftKey
    ],
    Meta: [
        91,
        (e)=>!!e.metaKey
    ]
};
const $7beee9608540d2c3$var$showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function $7beee9608540d2c3$export$9b6525222ac3b7fb(options = {}) {
    let [code, getter] = $7beee9608540d2c3$var$keys[options.key || "Alt"];
    let plugin = $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
    }, {
        eventObservers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            },
            mousemove (e) {
                this.set(getter(e));
            }
        }
    });
    return [
        plugin,
        $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? $7beee9608540d2c3$var$showCrosshair : null;
        })
    ];
}
const $7beee9608540d2c3$var$Outside = "-10000px";
class $7beee9608540d2c3$var$TooltipViewManager {
    constructor(view, facet, createTooltipView, removeTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.removeTooltipView = removeTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        let prev = null;
        this.tooltipViews = this.tooltips.map((t)=>prev = createTooltipView(t, prev));
    }
    update(update, above) {
        var _a;
        let input = update.state.facet(this.facet);
        let tooltips = input.filter((x)=>x);
        if (input === this.input) {
            for (let t of this.tooltipViews)if (t.update) t.update(update);
            return false;
        }
        let tooltipViews = [], newAbove = above ? [] : null;
        for(let i = 0; i < tooltips.length; i++){
            let tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(let i = 0; i < this.tooltips.length; i++){
                let other = this.tooltips[i];
                if (other && other.create == tip.create) known = i;
            }
            if (known < 0) {
                tooltipViews[i] = this.createTooltipView(tip, i ? tooltipViews[i - 1] : null);
                if (newAbove) newAbove[i] = !!tip.above;
            } else {
                let tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (newAbove) newAbove[i] = above[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        for (let t of this.tooltipViews)if (tooltipViews.indexOf(t) < 0) {
            this.removeTooltipView(t);
            (_a = t.destroy) === null || _a === void 0 || _a.call(t);
        }
        if (above) {
            newAbove.forEach((val, i)=>above[i] = val);
            above.length = newAbove.length;
        }
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function $7beee9608540d2c3$export$1fc29293196e3bc(config = {}) {
    return $7beee9608540d2c3$var$tooltipConfig.of(config);
}
function $7beee9608540d2c3$var$windowSpace(view) {
    let docElt = view.dom.ownerDocument.documentElement;
    return {
        top: 0,
        left: 0,
        bottom: docElt.clientHeight,
        right: docElt.clientWidth
    };
}
const $7beee9608540d2c3$var$tooltipConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: $7beee9608540d2c3$var$browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || $7beee9608540d2c3$var$windowSpace
        };
    }
});
const $7beee9608540d2c3$var$knownHeight = /*@__PURE__*/ new WeakMap();
const $7beee9608540d2c3$var$tooltipPlugin = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.above = [];
        this.inView = true;
        this.madeAbsolute = false;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        let config = view.state.facet($7beee9608540d2c3$var$tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(()=>this.measureSoon()) : null;
        this.manager = new $7beee9608540d2c3$var$TooltipViewManager(view, $7beee9608540d2c3$export$dba11b50e1aa3c12, (t, p)=>this.createTooltip(t, p), (t)=>{
            if (this.resizeObserver) this.resizeObserver.unobserve(t.dom);
            t.dom.remove();
        });
        this.above = this.manager.tooltips.map((t)=>!!t.above);
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            for (let tooltip of this.manager.tooltipViews)this.intersectionObserver.observe(tooltip.dom);
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        let updated = this.manager.update(update, this.above);
        if (updated) this.observeIntersection();
        let shouldMeasure = updated || update.geometryChanged;
        let newConfig = update.state.facet($7beee9608540d2c3$var$tooltipConfig);
        if (newConfig.position != this.position && !this.madeAbsolute) {
            this.position = newConfig.position;
            for (let t of this.manager.tooltipViews)t.dom.style.position = this.position;
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            for (let t of this.manager.tooltipViews)this.container.appendChild(t.dom);
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip, prev) {
        let tooltipView = tooltip.create(this.view);
        let before = prev ? prev.dom : null;
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            let arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.appendChild(arrow);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = $7beee9608540d2c3$var$Outside;
        tooltipView.dom.style.left = "0px";
        this.container.insertBefore(tooltipView.dom, before);
        if (tooltipView.mount) tooltipView.mount(this.view);
        if (this.resizeObserver) this.resizeObserver.observe(tooltipView.dom);
        return tooltipView;
    }
    destroy() {
        var _a, _b, _c;
        this.view.win.removeEventListener("resize", this.measureSoon);
        for (let tooltipView of this.manager.tooltipViews){
            tooltipView.dom.remove();
            (_a = tooltipView.destroy) === null || _a === void 0 || _a.call(tooltipView);
        }
        if (this.parent) this.container.remove();
        (_b = this.resizeObserver) === null || _b === void 0 || _b.disconnect();
        (_c = this.intersectionObserver) === null || _c === void 0 || _c.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        let scaleX = 1, scaleY = 1, makeAbsolute = false;
        if (this.position == "fixed" && this.manager.tooltipViews.length) {
            let { dom: dom } = this.manager.tooltipViews[0];
            if ($7beee9608540d2c3$var$browser.safari) {
                // Safari always sets offsetParent to null, even if a fixed
                // element is positioned relative to a transformed parent. So
                // we use this kludge to try and detect this.
                let rect = dom.getBoundingClientRect();
                makeAbsolute = Math.abs(rect.top + 10000) > 1 || Math.abs(rect.left) > 1;
            } else // More conforming browsers will set offsetParent to the
            // transformed element.
            makeAbsolute = !!dom.offsetParent && dom.offsetParent != this.container.ownerDocument.body;
        }
        if (makeAbsolute || this.position == "absolute") {
            if (this.parent) {
                let rect = this.parent.getBoundingClientRect();
                if (rect.width && rect.height) {
                    scaleX = rect.width / this.parent.offsetWidth;
                    scaleY = rect.height / this.parent.offsetHeight;
                }
            } else ({ scaleX: scaleX, scaleY: scaleY } = this.view.viewState);
        }
        let visible = this.view.scrollDOM.getBoundingClientRect(), margins = $7beee9608540d2c3$var$getScrollMargins(this.view);
        return {
            visible: {
                left: visible.left + margins.left,
                top: visible.top + margins.top,
                right: visible.right - margins.right,
                bottom: visible.bottom - margins.bottom
            },
            parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
            pos: this.manager.tooltips.map((t, i)=>{
                let tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map(({ dom: dom })=>dom.getBoundingClientRect()),
            space: this.view.state.facet($7beee9608540d2c3$var$tooltipConfig).tooltipSpace(this.view),
            scaleX: scaleX,
            scaleY: scaleY,
            makeAbsolute: makeAbsolute
        };
    }
    writeMeasure(measured) {
        var _a;
        if (measured.makeAbsolute) {
            this.madeAbsolute = true;
            this.position = "absolute";
            for (let t of this.manager.tooltipViews)t.dom.style.position = "absolute";
        }
        let { visible: visible, space: space, scaleX: scaleX, scaleY: scaleY } = measured;
        let others = [];
        for(let i = 0; i < this.manager.tooltips.length; i++){
            let tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], { dom: dom } = tView;
            let pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || tooltip.clip !== false && (pos.bottom <= Math.max(visible.top, space.top) || pos.top >= Math.min(visible.bottom, space.bottom) || pos.right < Math.max(visible.left, space.left) - .1 || pos.left > Math.min(visible.right, space.right) + .1)) {
                dom.style.top = $7beee9608540d2c3$var$Outside;
                continue;
            }
            let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            let arrowHeight = arrow ? 7 /* Arrow.Size */  : 0;
            let width = size.right - size.left, height = (_a = $7beee9608540d2c3$var$knownHeight.get(tView)) !== null && _a !== void 0 ? _a : size.bottom - size.top;
            let offset = tView.offset || $7beee9608540d2c3$var$noOffset, ltr = this.view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
            let left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.max(space.left, Math.min(pos.left - (arrow ? 14 /* Arrow.Offset */  : 0) + offset.x, space.right - width)) : Math.min(Math.max(space.left, pos.left - width + (arrow ? 14 /* Arrow.Offset */  : 0) - offset.x), space.right - width);
            let above = this.above[i];
            if (!tooltip.strictSide && (above ? pos.top - height - arrowHeight - offset.y < space.top : pos.bottom + height + arrowHeight + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = this.above[i] = !above;
            let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
            if (spaceVert < height && tView.resize !== false) {
                if (spaceVert < this.view.defaultLineHeight) {
                    dom.style.top = $7beee9608540d2c3$var$Outside;
                    continue;
                }
                $7beee9608540d2c3$var$knownHeight.set(tView, height);
                dom.style.height = (height = spaceVert) / scaleY + "px";
            } else if (dom.style.height) dom.style.height = "";
            let top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            let right = left + width;
            if (tView.overlap !== true) {
                for (let r of others)if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
            }
            if (this.position == "absolute") {
                dom.style.top = (top - measured.parent.top) / scaleY + "px";
                $7beee9608540d2c3$var$setLeftStyle(dom, (left - measured.parent.left) / scaleX);
            } else {
                dom.style.top = top / scaleY + "px";
                $7beee9608540d2c3$var$setLeftStyle(dom, left / scaleX);
            }
            if (arrow) {
                let arrowLeft = pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Arrow.Offset */  - 7 /* Arrow.Size */ );
                arrow.style.left = arrowLeft / scaleX + "px";
            }
            if (tView.overlap !== true) others.push({
                left: left,
                top: top,
                right: right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned(measured.space);
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                if (!this.inView) for (let tv of this.manager.tooltipViews)tv.dom.style.top = $7beee9608540d2c3$var$Outside;
            }
        }
    }
}, {
    eventObservers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
function $7beee9608540d2c3$var$setLeftStyle(elt, value) {
    let current = parseInt(elt.style.left, 10);
    if (isNaN(current) || Math.abs(value - current) > 1) elt.style.left = value + "px";
}
const $7beee9608540d2c3$var$baseTheme = /*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.baseTheme({
    ".cm-tooltip": {
        zIndex: 500,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Arrow.Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Arrow.Size */ }px solid transparent`,
            borderRight: `${7 /* Arrow.Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
const $7beee9608540d2c3$var$noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ const $7beee9608540d2c3$export$dba11b50e1aa3c12 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    enables: [
        $7beee9608540d2c3$var$tooltipPlugin,
        $7beee9608540d2c3$var$baseTheme
    ]
});
const $7beee9608540d2c3$var$showHoverTooltip = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (inputs)=>inputs.reduce((a, i)=>a.concat(i), [])
});
class $7beee9608540d2c3$var$HoverTooltipHost {
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new $7beee9608540d2c3$var$HoverTooltipHost(view);
    }
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new $7beee9608540d2c3$var$TooltipViewManager(view, $7beee9608540d2c3$var$showHoverTooltip, (t, p)=>this.createHostedView(t, p), (t)=>t.dom.remove());
    }
    createHostedView(tooltip, prev) {
        let hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.insertBefore(hostedView.dom, prev ? prev.dom.nextSibling : this.dom.firstChild);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.mount) hostedView.mount(view);
        this.mounted = true;
    }
    positioned(space) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.positioned) hostedView.positioned(space);
    }
    update(update) {
        this.manager.update(update);
    }
    destroy() {
        var _a;
        for (let t of this.manager.tooltipViews)(_a = t.destroy) === null || _a === void 0 || _a.call(t);
    }
    passProp(name) {
        let value = undefined;
        for (let view of this.manager.tooltipViews){
            let given = view[name];
            if (given !== undefined) {
                if (value === undefined) value = given;
                else if (value !== given) return undefined;
            }
        }
        return value;
    }
    get offset() {
        return this.passProp("offset");
    }
    get getCoords() {
        return this.passProp("getCoords");
    }
    get overlap() {
        return this.passProp("overlap");
    }
    get resize() {
        return this.passProp("resize");
    }
}
const $7beee9608540d2c3$var$showHoverTooltipHost = /*@__PURE__*/ $7beee9608540d2c3$export$dba11b50e1aa3c12.compute([
    $7beee9608540d2c3$var$showHoverTooltip
], (state)=>{
    let tooltips = state.facet($7beee9608540d2c3$var$showHoverTooltip);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.map((t)=>{
            var _a;
            return (_a = t.end) !== null && _a !== void 0 ? _a : t.pos;
        })),
        create: $7beee9608540d2c3$var$HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
class $7beee9608540d2c3$var$HoverPlugin {
    constructor(view, source, field, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update() {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active.length) return;
        let hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        let { view: view, lastMove: lastMove } = this;
        let tile = view.docView.tile.nearest(lastMove.target);
        if (!tile) return;
        let pos, side = 1;
        if (tile.isWidget()) pos = tile.posAtStart;
        else {
            pos = view.posAtCoords(lastMove);
            if (pos == null) return;
            let posCoords = view.coordsAtPos(pos);
            if (!posCoords || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - view.defaultCharacterWidth || lastMove.x > posCoords.right + view.defaultCharacterWidth) return;
            let bidi = view.bidiSpans(view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
            let rtl = bidi && bidi.dir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL ? -1 : 1;
            side = lastMove.x < posCoords.left ? -rtl : rtl;
        }
        let open = this.source(view, pos, side);
        if (open === null || open === void 0 ? void 0 : open.then) {
            let pending = this.pending = {
                pos: pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    if (result && !(Array.isArray(result) && !result.length)) view.dispatch({
                        effects: this.setHover.of(Array.isArray(result) ? result : [
                            result
                        ])
                    });
                }
            }, (e)=>$7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e, "hover tooltip"));
        } else if (open && !(Array.isArray(open) && !open.length)) view.dispatch({
            effects: this.setHover.of(Array.isArray(open) ? open : [
                open
            ])
        });
    }
    get tooltip() {
        let plugin = this.view.plugin($7beee9608540d2c3$var$tooltipPlugin);
        let index = plugin ? plugin.manager.tooltips.findIndex((t)=>t.create == $7beee9608540d2c3$var$HoverTooltipHost.create) : -1;
        return index > -1 ? plugin.manager.tooltipViews[index] : null;
    }
    mousemove(event) {
        var _a, _b;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        let { active: active, tooltip: tooltip } = this;
        if (active.length && tooltip && !$7beee9608540d2c3$var$isInTooltip(tooltip.dom, event) || this.pending) {
            let { pos: pos } = active[0] || this.pending, end = (_b = (_a = active[0]) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !$7beee9608540d2c3$var$isOverRange(this.view, pos, end, event.clientX, event.clientY)) {
                this.view.dispatch({
                    effects: this.setHover.of([])
                });
                this.pending = null;
            }
        }
    }
    mouseleave(event) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        let { active: active } = this;
        if (active.length) {
            let { tooltip: tooltip } = this;
            let inTooltip = tooltip && tooltip.dom.contains(event.relatedTarget);
            if (!inTooltip) this.view.dispatch({
                effects: this.setHover.of([])
            });
            else this.watchTooltipLeave(tooltip.dom);
        }
    }
    watchTooltipLeave(tooltip) {
        let watch = (event)=>{
            tooltip.removeEventListener("mouseleave", watch);
            if (this.active.length && !this.view.dom.contains(event.relatedTarget)) this.view.dispatch({
                effects: this.setHover.of([])
            });
        };
        tooltip.addEventListener("mouseleave", watch);
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
}
const $7beee9608540d2c3$var$tooltipMargin = 4;
function $7beee9608540d2c3$var$isInTooltip(tooltip, event) {
    let { left: left, right: right, top: top, bottom: bottom } = tooltip.getBoundingClientRect(), arrow;
    if (arrow = tooltip.querySelector(".cm-tooltip-arrow")) {
        let arrowRect = arrow.getBoundingClientRect();
        top = Math.min(arrowRect.top, top);
        bottom = Math.max(arrowRect.bottom, bottom);
    }
    return event.clientX >= left - $7beee9608540d2c3$var$tooltipMargin && event.clientX <= right + $7beee9608540d2c3$var$tooltipMargin && event.clientY >= top - $7beee9608540d2c3$var$tooltipMargin && event.clientY <= bottom + $7beee9608540d2c3$var$tooltipMargin;
}
function $7beee9608540d2c3$var$isOverRange(view, from, to, x, y, margin) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let docBottom = view.documentTop + view.documentPadding.top + view.contentHeight;
    if (rect.left > x || rect.right < x || rect.top > y || Math.min(rect.bottom, docBottom) < y) return false;
    let pos = view.posAtCoords({
        x: x,
        y: y
    }, false);
    return pos >= from && pos <= to;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.

The return value is a valid [editor extension](https://codemirror.net/6/docs/ref/#state.Extension)
but also provides an `active` property holding a state field that
can be used to read the currently active tooltips produced by this
extension.
*/ function $7beee9608540d2c3$export$69f8d9e63c4aa884(source, options = {}) {
    let setHover = (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
    let hoverState = (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
        create () {
            return [];
        },
        update (value, tr) {
            if (value.length) {
                if (options.hideOnChange && (tr.docChanged || tr.selection)) value = [];
                else if (options.hideOn) value = value.filter((v)=>!options.hideOn(tr, v));
                if (tr.docChanged) {
                    let mapped = [];
                    for (let tooltip of value){
                        let newPos = tr.changes.mapPos(tooltip.pos, -1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel);
                        if (newPos != null) {
                            let copy = Object.assign(Object.create(null), tooltip);
                            copy.pos = newPos;
                            if (copy.end != null) copy.end = tr.changes.mapPos(copy.end);
                            mapped.push(copy);
                        }
                    }
                    value = mapped;
                }
            }
            for (let effect of tr.effects){
                if (effect.is(setHover)) value = effect.value;
                if (effect.is($7beee9608540d2c3$var$closeHoverTooltipEffect)) value = [];
            }
            return value;
        },
        provide: (f)=>$7beee9608540d2c3$var$showHoverTooltip.from(f)
    });
    return {
        active: hoverState,
        extension: [
            hoverState,
            $7beee9608540d2c3$export$44d5eccfd62adda7.define((view)=>new $7beee9608540d2c3$var$HoverPlugin(view, source, hoverState, setHover, options.hoverTime || 300 /* Hover.Time */ )),
            $7beee9608540d2c3$var$showHoverTooltipHost
        ]
    };
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function $7beee9608540d2c3$export$46455b4476d4b8e1(view, tooltip) {
    let plugin = view.plugin($7beee9608540d2c3$var$tooltipPlugin);
    if (!plugin) return null;
    let found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function $7beee9608540d2c3$export$7864d875805bc1b0(state) {
    return state.facet($7beee9608540d2c3$var$showHoverTooltip).some((x)=>x);
}
const $7beee9608540d2c3$var$closeHoverTooltipEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
/**
Transaction effect that closes all hover tooltips.
*/ const $7beee9608540d2c3$export$f6974094db6525a = /*@__PURE__*/ $7beee9608540d2c3$var$closeHoverTooltipEffect.of(null);
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function $7beee9608540d2c3$export$912859096d593b90(view) {
    let plugin = view.plugin($7beee9608540d2c3$var$tooltipPlugin);
    if (plugin) plugin.maybeMeasure();
}
const $7beee9608540d2c3$var$panelConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let topContainer, bottomContainer;
        for (let c of configs){
            topContainer = topContainer || c.topContainer;
            bottomContainer = bottomContainer || c.bottomContainer;
        }
        return {
            topContainer: topContainer,
            bottomContainer: bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function $7beee9608540d2c3$export$8128819a2322681a(config) {
    return config ? [
        $7beee9608540d2c3$var$panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function $7beee9608540d2c3$export$7361ed18ff57179e(view, panel) {
    let plugin = view.plugin($7beee9608540d2c3$var$panelPlugin);
    let index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
const $7beee9608540d2c3$var$panelPlugin = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.input = view.state.facet($7beee9608540d2c3$export$e89c3c9af31c1e3b);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        let conf = view.state.facet($7beee9608540d2c3$var$panelConfig);
        this.top = new $7beee9608540d2c3$var$PanelGroup(view, true, conf.topContainer);
        this.bottom = new $7beee9608540d2c3$var$PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        for (let p of this.panels){
            p.dom.classList.add("cm-panel");
            if (p.mount) p.mount();
        }
    }
    update(update) {
        let conf = update.state.facet($7beee9608540d2c3$var$panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new $7beee9608540d2c3$var$PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new $7beee9608540d2c3$var$PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        let input = update.state.facet($7beee9608540d2c3$export$e89c3c9af31c1e3b);
        if (input != this.input) {
            let specs = input.filter((x)=>x);
            let panels = [], top = [], bottom = [], mount = [];
            for (let spec of specs){
                let known = this.specs.indexOf(spec), panel;
                if (known < 0) {
                    panel = spec(update.view);
                    mount.push(panel);
                } else {
                    panel = this.panels[known];
                    if (panel.update) panel.update(update);
                }
                panels.push(panel);
                (panel.top ? top : bottom).push(panel);
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            for (let p of mount){
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } else {
            for (let p of this.panels)if (p.update) p.update(update);
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
}, {
    provide: (plugin)=>$7beee9608540d2c3$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class $7beee9608540d2c3$var$PanelGroup {
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
    sync(panels) {
        for (let p of this.panels)if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            this.dom.style[this.top ? "top" : "bottom"] = "0";
            let parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        let curDOM = this.dom.firstChild;
        for (let panel of this.panels)if (panel.dom.parentNode == this.dom) {
            while(curDOM != panel.dom)curDOM = $7beee9608540d2c3$var$rm(curDOM);
            curDOM = curDOM.nextSibling;
        } else this.dom.insertBefore(panel.dom, curDOM);
        while(curDOM)curDOM = $7beee9608540d2c3$var$rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        for (let cls of this.classes.split(" "))if (cls) this.container.classList.remove(cls);
        for (let cls of (this.classes = this.view.themeClasses).split(" "))if (cls) this.container.classList.add(cls);
    }
}
function $7beee9608540d2c3$var$rm(node) {
    let next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ const $7beee9608540d2c3$export$e89c3c9af31c1e3b = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    enables: $7beee9608540d2c3$var$panelPlugin
});
/**
Show a panel above or below the editor to show the user a message
or prompt them for input. Returns an effect that can be dispatched
to close the dialog, and a promise that resolves when the dialog
is closed or a form inside of it is submitted.

You are encouraged, if your handling of the result of the promise
dispatches a transaction, to include the `close` effect in it. If
you don't, this function will automatically dispatch a separate
transaction right after.
*/ function $7beee9608540d2c3$export$61e0a65f251cfdb3(view, config) {
    let resolve;
    let promise = new Promise((r)=>resolve = r);
    let panelCtor = (view)=>$7beee9608540d2c3$var$createDialog(view, config, resolve);
    if (view.state.field($7beee9608540d2c3$var$dialogField, false)) view.dispatch({
        effects: $7beee9608540d2c3$var$openDialogEffect.of(panelCtor)
    });
    else view.dispatch({
        effects: (0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($7beee9608540d2c3$var$dialogField.init(()=>[
                panelCtor
            ]))
    });
    let close = $7beee9608540d2c3$var$closeDialogEffect.of(panelCtor);
    return {
        close: close,
        result: promise.then((form)=>{
            let queue = view.win.queueMicrotask || ((f)=>view.win.setTimeout(f, 10));
            queue(()=>{
                if (view.state.field($7beee9608540d2c3$var$dialogField).indexOf(panelCtor) > -1) view.dispatch({
                    effects: close
                });
            });
            return form;
        })
    };
}
/**
Find the [`Panel`](https://codemirror.net/6/docs/ref/#view.Panel) for an open dialog, using a class
name as identifier.
*/ function $7beee9608540d2c3$export$add6d5f54f9ab5a8(view, className) {
    let dialogs = view.state.field($7beee9608540d2c3$var$dialogField, false) || [];
    for (let open of dialogs){
        let panel = $7beee9608540d2c3$export$7361ed18ff57179e(view, open);
        if (panel && panel.dom.classList.contains(className)) return panel;
    }
    return null;
}
const $7beee9608540d2c3$var$dialogField = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return [];
    },
    update (dialogs, tr) {
        for (let e of tr.effects){
            if (e.is($7beee9608540d2c3$var$openDialogEffect)) dialogs = [
                e.value
            ].concat(dialogs);
            else if (e.is($7beee9608540d2c3$var$closeDialogEffect)) dialogs = dialogs.filter((d)=>d != e.value);
        }
        return dialogs;
    },
    provide: (f)=>$7beee9608540d2c3$export$e89c3c9af31c1e3b.computeN([
            f
        ], (state)=>state.field(f))
});
const $7beee9608540d2c3$var$openDialogEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7beee9608540d2c3$var$closeDialogEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
function $7beee9608540d2c3$var$createDialog(view, config, result) {
    let content = config.content ? config.content(view, ()=>done(null)) : null;
    if (!content) {
        content = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("form");
        if (config.input) {
            let input = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", config.input);
            if (/^(text|password|number|email|tel|url)$/.test(input.type)) input.classList.add("cm-textfield");
            if (!input.name) input.name = "input";
            content.appendChild((0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", (config.label || "") + ": ", input));
        } else content.appendChild(document.createTextNode(config.label || ""));
        content.appendChild(document.createTextNode(" "));
        content.appendChild((0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
            class: "cm-button",
            type: "submit"
        }, config.submitLabel || "OK"));
    }
    let forms = content.nodeName == "FORM" ? [
        content
    ] : content.querySelectorAll("form");
    for(let i = 0; i < forms.length; i++){
        let form = forms[i];
        form.addEventListener("keydown", (event)=>{
            if (event.keyCode == 27) {
                event.preventDefault();
                done(null);
            } else if (event.keyCode == 13) {
                event.preventDefault();
                done(form);
            }
        });
        form.addEventListener("submit", (event)=>{
            event.preventDefault();
            done(form);
        });
    }
    let panel = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", content, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
        onclick: ()=>done(null),
        "aria-label": view.state.phrase("close"),
        class: "cm-dialog-close",
        type: "button"
    }, [
        "\xd7"
    ]));
    if (config.class) panel.className = config.class;
    panel.classList.add("cm-dialog");
    function done(form) {
        if (panel.contains(panel.ownerDocument.activeElement)) view.focus();
        result(form);
    }
    return {
        dom: panel,
        top: config.top,
        mount: ()=>{
            if (config.focus) {
                let focus;
                if (typeof config.focus == "string") focus = content.querySelector(config.focus);
                else focus = content.querySelector("input") || content.querySelector("button");
                if (focus && "select" in focus) focus.select();
                else if (focus && "focus" in focus) focus.focus();
            }
        }
    };
}
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class $7beee9608540d2c3$export$591ab4c909549043 extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
$7beee9608540d2c3$export$591ab4c909549043.prototype.elementClass = "";
$7beee9608540d2c3$export$591ab4c909549043.prototype.toDOM = undefined;
$7beee9608540d2c3$export$591ab4c909549043.prototype.mapMode = (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackBefore;
$7beee9608540d2c3$export$591ab4c909549043.prototype.startSide = $7beee9608540d2c3$export$591ab4c909549043.prototype.endSide = -1;
$7beee9608540d2c3$export$591ab4c909549043.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ const $7beee9608540d2c3$export$113bd64f27ac1172 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Facet used to add a class to all gutter elements next to a widget.
Should not provide widgets with a `toDOM` method.
*/ const $7beee9608540d2c3$export$6dd229d2c0925f7a = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, $6295c6875f57e3ee$export$34cb5241245008dd).empty,
    lineMarker: ()=>null,
    widgetMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {},
    side: "before"
};
const $7beee9608540d2c3$var$activeGutters = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function $7beee9608540d2c3$export$f2b922cb4a245974(config) {
    return [
        $7beee9608540d2c3$export$ec15ef01b8fbae61(),
        $7beee9608540d2c3$var$activeGutters.of({
            ...$7beee9608540d2c3$var$defaults,
            ...config
        })
    ];
}
const $7beee9608540d2c3$var$unfixGutters = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function $7beee9608540d2c3$export$ec15ef01b8fbae61(config) {
    let result = [
        $7beee9608540d2c3$var$gutterView
    ];
    if (config && config.fixed === false) result.push($7beee9608540d2c3$var$unfixGutters.of(true));
    return result;
}
const $7beee9608540d2c3$var$gutterView = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.domAfter = null;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters cm-gutters-before";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        this.gutters = view.state.facet($7beee9608540d2c3$var$activeGutters).map((conf)=>new $7beee9608540d2c3$var$SingleGutterView(view, conf));
        this.fixed = !view.state.facet($7beee9608540d2c3$var$unfixGutters);
        for (let gutter of this.gutters)if (gutter.config.side == "after") this.getDOMAfter().appendChild(gutter.dom);
        else this.dom.appendChild(gutter.dom);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
    getDOMAfter() {
        if (!this.domAfter) {
            this.domAfter = document.createElement("div");
            this.domAfter.className = "cm-gutters cm-gutters-after";
            this.domAfter.setAttribute("aria-hidden", "true");
            this.domAfter.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
            this.domAfter.style.position = this.fixed ? "sticky" : "";
            this.view.scrollDOM.appendChild(this.domAfter);
        }
        return this.domAfter;
    }
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            let vpA = this.prevViewport, vpB = update.view.viewport;
            let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) {
            let min = this.view.contentHeight / this.view.scaleY + "px";
            this.dom.style.minHeight = min;
            if (this.domAfter) this.domAfter.style.minHeight = min;
        }
        if (this.view.state.facet($7beee9608540d2c3$var$unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
            if (this.domAfter) this.domAfter.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        let after = this.dom.nextSibling;
        if (detach) {
            this.dom.remove();
            if (this.domAfter) this.domAfter.remove();
        }
        let lineClasses = (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter(this.view.state.facet($7beee9608540d2c3$export$113bd64f27ac1172), this.view.viewport.from);
        let classSet = [];
        let contexts = this.gutters.map((gutter)=>new $7beee9608540d2c3$var$UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        for (let line of this.view.viewportLineBlocks){
            if (classSet.length) classSet = [];
            if (Array.isArray(line.type)) {
                let first = true;
                for (let b of line.type){
                    if (b.type == $7beee9608540d2c3$export$48808c686fe495c4.Text && first) {
                        $7beee9608540d2c3$var$advanceCursor(lineClasses, classSet, b.from);
                        for (let cx of contexts)cx.line(this.view, b, classSet);
                        first = false;
                    } else if (b.widget) for (let cx of contexts)cx.widget(this.view, b);
                }
            } else if (line.type == $7beee9608540d2c3$export$48808c686fe495c4.Text) {
                $7beee9608540d2c3$var$advanceCursor(lineClasses, classSet, line.from);
                for (let cx of contexts)cx.line(this.view, line, classSet);
            } else if (line.widget) for (let cx of contexts)cx.widget(this.view, line);
        }
        for (let cx of contexts)cx.finish();
        if (detach) {
            this.view.scrollDOM.insertBefore(this.dom, after);
            if (this.domAfter) this.view.scrollDOM.appendChild(this.domAfter);
        }
    }
    updateGutters(update) {
        let prev = update.startState.facet($7beee9608540d2c3$var$activeGutters), cur = update.state.facet($7beee9608540d2c3$var$activeGutters);
        let change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, $6295c6875f57e3ee$export$34cb5241245008dd).eq(update.startState.facet($7beee9608540d2c3$export$113bd64f27ac1172), update.state.facet($7beee9608540d2c3$export$113bd64f27ac1172), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            for (let gutter of this.gutters)if (gutter.update(update)) change = true;
        } else {
            change = true;
            let gutters = [];
            for (let conf of cur){
                let known = prev.indexOf(conf);
                if (known < 0) gutters.push(new $7beee9608540d2c3$var$SingleGutterView(this.view, conf));
                else {
                    this.gutters[known].update(update);
                    gutters.push(this.gutters[known]);
                }
            }
            for (let g of this.gutters){
                g.dom.remove();
                if (gutters.indexOf(g) < 0) g.destroy();
            }
            for (let g of gutters)if (g.config.side == "after") this.getDOMAfter().appendChild(g.dom);
            else this.dom.appendChild(g.dom);
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        for (let view of this.gutters)view.destroy();
        this.dom.remove();
        if (this.domAfter) this.domAfter.remove();
    }
}, {
    provide: (plugin)=>$7beee9608540d2c3$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            let before = value.dom.offsetWidth * view.scaleX, after = value.domAfter ? value.domAfter.offsetWidth * view.scaleX : 0;
            return view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR ? {
                left: before,
                right: after
            } : {
                right: before,
                left: after
            };
        })
});
function $7beee9608540d2c3$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $7beee9608540d2c3$var$advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class $7beee9608540d2c3$var$UpdateContext {
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.i = 0;
        this.cursor = (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter(gutter.markers, viewport.from);
    }
    addElement(view, block, markers) {
        let { gutter: gutter } = this, above = (block.top - this.height) / view.scaleY, height = block.height / view.scaleY;
        if (this.i == gutter.elements.length) {
            let newElt = new $7beee9608540d2c3$var$GutterElement(view, height, above, markers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, height, above, markers);
        this.height = block.bottom;
        this.i++;
    }
    line(view, line, extraMarkers) {
        let localMarkers = [];
        $7beee9608540d2c3$var$advanceCursor(this.cursor, localMarkers, line.from);
        if (extraMarkers.length) localMarkers = localMarkers.concat(extraMarkers);
        let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        let gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        this.addElement(view, line, localMarkers);
    }
    widget(view, block) {
        let marker = this.gutter.config.widgetMarker(view, block.widget, block), markers = marker ? [
            marker
        ] : null;
        for (let cls of view.state.facet($7beee9608540d2c3$export$6dd229d2c0925f7a)){
            let marker = cls(view, block.widget, block);
            if (marker) (markers || (markers = [])).push(marker);
        }
        if (markers) this.addElement(view, block, markers);
    }
    finish() {
        let gutter = this.gutter;
        while(gutter.elements.length > this.i){
            let last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
}
class $7beee9608540d2c3$var$SingleGutterView {
    constructor(view, config){
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(let prop in config.domEventHandlers)this.dom.addEventListener(prop, (event)=>{
            let target = event.target, y;
            if (target != this.dom && this.dom.contains(target)) {
                while(target.parentNode != this.dom)target = target.parentNode;
                let rect = target.getBoundingClientRect();
                y = (rect.top + rect.bottom) / 2;
            } else y = event.clientY;
            let line = view.lineBlockAtHeight(y - view.documentTop);
            if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
        });
        this.markers = $7beee9608540d2c3$var$asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new $7beee9608540d2c3$var$GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
    update(update) {
        let prevMarkers = this.markers;
        this.markers = $7beee9608540d2c3$var$asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            let updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        let vp = update.view.viewport;
        return !(0, $6295c6875f57e3ee$export$34cb5241245008dd).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        for (let elt of this.elements)elt.destroy();
    }
}
class $7beee9608540d2c3$var$GutterElement {
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
    update(view, height, above, markers) {
        if (this.height != height) {
            this.height = height;
            this.dom.style.height = height + "px";
        }
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!$7beee9608540d2c3$var$sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        let cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(let iNew = 0, iOld = 0;;){
            let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                let c = marker.elementClass;
                if (c) cls += " " + c;
                for(let i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                let next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    let after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
}
function $7beee9608540d2c3$var$sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ const $7beee9608540d2c3$export$dd0c91e0a7121f5f = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Facet used to create markers in the line number gutter next to widgets.
*/ const $7beee9608540d2c3$export$510194e22d36ff6c = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$lineNumberConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                let result = Object.assign({}, a);
                for(let event in b){
                    let exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                }
                return result;
            }
        });
    }
});
class $7beee9608540d2c3$var$NumberMarker extends $7beee9608540d2c3$export$591ab4c909549043 {
    constructor(number){
        super();
        this.number = number;
    }
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
}
function $7beee9608540d2c3$var$formatNumber(view, number) {
    return view.state.facet($7beee9608540d2c3$var$lineNumberConfig).formatNumber(number, view.state);
}
const $7beee9608540d2c3$var$lineNumberGutter = /*@__PURE__*/ $7beee9608540d2c3$var$activeGutters.compute([
    $7beee9608540d2c3$var$lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet($7beee9608540d2c3$export$dd0c91e0a7121f5f);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new $7beee9608540d2c3$var$NumberMarker($7beee9608540d2c3$var$formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        widgetMarker: (view, widget, block)=>{
            for (let m of view.state.facet($7beee9608540d2c3$export$510194e22d36ff6c)){
                let result = m(view, widget, block);
                if (result) return result;
            }
            return null;
        },
        lineMarkerChange: (update)=>update.startState.facet($7beee9608540d2c3$var$lineNumberConfig) != update.state.facet($7beee9608540d2c3$var$lineNumberConfig),
        initialSpacer (view) {
            return new $7beee9608540d2c3$var$NumberMarker($7beee9608540d2c3$var$formatNumber(view, $7beee9608540d2c3$var$maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            let max = $7beee9608540d2c3$var$formatNumber(update.view, $7beee9608540d2c3$var$maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new $7beee9608540d2c3$var$NumberMarker(max);
        },
        domEventHandlers: state.facet($7beee9608540d2c3$var$lineNumberConfig).domEventHandlers,
        side: "before"
    }));
/**
Create a line number gutter extension.
*/ function $7beee9608540d2c3$export$1a8cf111682eaa7d(config = {}) {
    return [
        $7beee9608540d2c3$var$lineNumberConfig.of(config),
        $7beee9608540d2c3$export$ec15ef01b8fbae61(),
        $7beee9608540d2c3$var$lineNumberGutter
    ];
}
function $7beee9608540d2c3$var$maxLineNumber(lines) {
    let last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
const $7beee9608540d2c3$var$activeLineGutterMarker = /*@__PURE__*/ new class extends $7beee9608540d2c3$export$591ab4c909549043 {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
const $7beee9608540d2c3$var$activeLineGutterHighlighter = /*@__PURE__*/ $7beee9608540d2c3$export$113bd64f27ac1172.compute([
    "selection"
], (state)=>{
    let marks = [], last = -1;
    for (let range of state.selection.ranges){
        let linePos = state.doc.lineAt(range.head).from;
        if (linePos > last) {
            last = linePos;
            marks.push($7beee9608540d2c3$var$activeLineGutterMarker.range(linePos));
        }
    }
    return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function $7beee9608540d2c3$export$93b52f08bb2c759c() {
    return $7beee9608540d2c3$var$activeLineGutterHighlighter;
}
function $7beee9608540d2c3$var$matcher(decorator) {
    return $7beee9608540d2c3$export$44d5eccfd62adda7.define((view)=>({
            decorations: decorator.createDeco(view),
            update (u) {
                this.decorations = decorator.updateDeco(u, this.decorations);
            }
        }), {
        decorations: (v)=>v.decorations
    });
}
const $7beee9608540d2c3$var$tabDeco = /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.mark({
    class: "cm-highlightTab"
});
const $7beee9608540d2c3$var$spaceDeco = /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.mark({
    class: "cm-highlightSpace"
});
const $7beee9608540d2c3$var$whitespaceHighlighter = /*@__PURE__*/ $7beee9608540d2c3$var$matcher(/*@__PURE__*/ new $7beee9608540d2c3$export$9b928b0ca20b25cb({
    regexp: /\t| /g,
    decoration: (match)=>match[0] == "\t" ? $7beee9608540d2c3$var$tabDeco : $7beee9608540d2c3$var$spaceDeco,
    boundary: /\S/
}));
/**
Returns an extension that highlights whitespace, adding a
`cm-highlightSpace` class to stretches of spaces, and a
`cm-highlightTab` class to individual tab characters. By default,
the former are shown as faint dots, and the latter as arrows.
*/ function $7beee9608540d2c3$export$beeff585f23bdb79() {
    return $7beee9608540d2c3$var$whitespaceHighlighter;
}
const $7beee9608540d2c3$var$trailingHighlighter = /*@__PURE__*/ $7beee9608540d2c3$var$matcher(/*@__PURE__*/ new $7beee9608540d2c3$export$9b928b0ca20b25cb({
    regexp: /\s+$/g,
    decoration: /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.mark({
        class: "cm-trailingSpace"
    })
}));
/**
Returns an extension that adds a `cm-trailingSpace` class to all
trailing whitespace.
*/ function $7beee9608540d2c3$export$6e66b0e142f44c26() {
    return $7beee9608540d2c3$var$trailingHighlighter;
}
/**
@internal
*/ const $7beee9608540d2c3$export$91afc2cf83e15b44 = {
    HeightMap: $7beee9608540d2c3$var$HeightMap,
    HeightOracle: $7beee9608540d2c3$var$HeightOracle,
    MeasuredHeights: $7beee9608540d2c3$var$MeasuredHeights,
    QueryType: $7beee9608540d2c3$var$QueryType,
    ChangedRange: $7beee9608540d2c3$var$ChangedRange,
    computeOrder: $7beee9608540d2c3$var$computeOrder,
    moveVisually: $7beee9608540d2c3$var$moveVisually,
    clearHeightChangeFlag: $7beee9608540d2c3$var$clearHeightChangeFlag,
    getHeightChangeFlag: ()=>$7beee9608540d2c3$var$heightChangeFlag
};


/**
The default maximum length of a `TreeBuffer` node.
*/ const $ed739beecf769914$export$de305a849879ffa = 1024;
let $ed739beecf769914$var$nextPropID = 0;
class $ed739beecf769914$var$Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/**
Each [node type](#common.NodeType) or [individual tree](#common.Tree)
can have metadata associated with it in props. Instances of this
class represent prop names.
*/ class $ed739beecf769914$export$b8034b9bc18acd90 {
    /**
    Create a new node prop type.
    */ constructor(config = {}){
        this.id = $ed739beecf769914$var$nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
        this.combine = config.combine || null;
    }
    /**
    This is meant to be used with
    [`NodeSet.extend`](#common.NodeSet.extend) or
    [`LRParser.configure`](#lr.ParserConfig.props) to compute
    prop values for each node type in the set. Takes a [match
    object](#common.NodeType^match) or function that returns undefined
    if the node type doesn't get this prop, and the prop's value if
    it does.
    */ add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = $ed739beecf769914$export$f06e977173f1857c.match(match);
        return (type)=>{
            let result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
}
/**
Prop that is used to describe matching delimiters. For opening
delimiters, this holds an array of node names (written as a
space-separated string when declaring this prop in a grammar)
for the node types of closing delimiters that match it.
*/ $ed739beecf769914$export$b8034b9bc18acd90.closedBy = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
attached to closing delimiters, holding an array of node names
of types of matching opening delimiters.
*/ $ed739beecf769914$export$b8034b9bc18acd90.openedBy = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Used to assign node types to groups (for example, all node
types that represent an expression could be tagged with an
`"Expression"` group).
*/ $ed739beecf769914$export$b8034b9bc18acd90.group = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Attached to nodes to indicate these should be
[displayed](https://codemirror.net/docs/ref/#language.syntaxTree)
in a bidirectional text isolate, so that direction-neutral
characters on their sides don't incorrectly get associated with
surrounding text. You'll generally want to set this for nodes
that contain arbitrary text, like strings and comments, and for
nodes that appear _inside_ arbitrary text, like HTML tags. When
not given a value, in a grammar declaration, defaults to
`"auto"`.
*/ $ed739beecf769914$export$b8034b9bc18acd90.isolate = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (value)=>{
        if (value && value != "rtl" && value != "ltr" && value != "auto") throw new RangeError("Invalid value for isolate: " + value);
        return value || "auto";
    }
});
/**
The hash of the [context](#lr.ContextTracker.constructor)
that the node was parsed in, if any. Used to limit reuse of
contextual nodes.
*/ $ed739beecf769914$export$b8034b9bc18acd90.contextHash = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
/**
The distance beyond the end of the node that the tokenizer
looked ahead for any of the tokens inside the node. (The LR
parser only stores this when it is larger than 25, for
efficiency reasons.)
*/ $ed739beecf769914$export$b8034b9bc18acd90.lookAhead = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
/**
This per-node prop is used to replace a given node, or part of a
node, with another tree. This is useful to include trees from
different languages in mixed-language parsers.
*/ $ed739beecf769914$export$b8034b9bc18acd90.mounted = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
/**
A mounted tree, which can be [stored](#common.NodeProp^mounted) on
a tree node to indicate that parts of its content are
represented by another tree.
*/ class $ed739beecf769914$export$358cdd8bd77577cc {
    constructor(/**
    The inner tree.
    */ tree, /**
    If this is null, this tree replaces the entire node (it will
    be included in the regular iteration instead of its host
    node). If not, only the given ranges are considered to be
    covered by this tree. This is used for trees that are mixed in
    a way that isn't strictly hierarchical. Such mounted trees are
    only entered by [`resolveInner`](#common.Tree.resolveInner)
    and [`enter`](#common.SyntaxNode.enter).
    */ overlay, /**
    The parser used to create this subtree.
    */ parser){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
    }
    /**
    @internal
    */ static get(tree) {
        return tree && tree.props && tree.props[$ed739beecf769914$export$b8034b9bc18acd90.mounted.id];
    }
}
const $ed739beecf769914$var$noProps = Object.create(null);
/**
Each node in a syntax tree has a node type associated with it.
*/ class $ed739beecf769914$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name of the node type. Not necessarily unique, but if the
    grammar was written properly, different node types with the
    same name within a node set should play the same semantic
    role.
    */ name, /**
    @internal
    */ props, /**
    The id of this node in its set. Corresponds to the term ids
    used in the parser.
    */ id, /**
    @internal
    */ flags = 0){
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
    /**
    Define a node type.
    */ static define(spec) {
        let props = spec.props && spec.props.length ? Object.create(null) : $ed739beecf769914$var$noProps;
        let flags = (spec.top ? 1 /* NodeFlag.Top */  : 0) | (spec.skipped ? 2 /* NodeFlag.Skipped */  : 0) | (spec.error ? 4 /* NodeFlag.Error */  : 0) | (spec.name == null ? 8 /* NodeFlag.Anonymous */  : 0);
        let type = new $ed739beecf769914$export$f06e977173f1857c(spec.name || "", props, spec.id, flags);
        if (spec.props) for (let src of spec.props){
            if (!Array.isArray(src)) src = src(type);
            if (src) {
                if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                props[src[0].id] = src[1];
            }
        }
        return type;
    }
    /**
    Retrieves a node prop for this type. Will return `undefined` if
    the prop isn't present on this node.
    */ prop(prop) {
        return this.props[prop.id];
    }
    /**
    True when this is the top node of a grammar.
    */ get isTop() {
        return (this.flags & 1 /* NodeFlag.Top */ ) > 0;
    }
    /**
    True when this node is produced by a skip rule.
    */ get isSkipped() {
        return (this.flags & 2 /* NodeFlag.Skipped */ ) > 0;
    }
    /**
    Indicates whether this is an error node.
    */ get isError() {
        return (this.flags & 4 /* NodeFlag.Error */ ) > 0;
    }
    /**
    When true, this node type doesn't correspond to a user-declared
    named node, for example because it is used to cache repetition.
    */ get isAnonymous() {
        return (this.flags & 8 /* NodeFlag.Anonymous */ ) > 0;
    }
    /**
    Returns true when this node's name or one of its
    [groups](#common.NodeProp^group) matches the given string.
    */ is(name) {
        if (typeof name == 'string') {
            if (this.name == name) return true;
            let group = this.prop($ed739beecf769914$export$b8034b9bc18acd90.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /**
    Create a function from node types to arbitrary values by
    specifying an object whose property names are node or
    [group](#common.NodeProp^group) names. Often useful with
    [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    names, separated by spaces, in a single property name to map
    multiple node names to a single value.
    */ static match(map) {
        let direct = Object.create(null);
        for(let prop in map)for (let name of prop.split(" "))direct[name] = map[prop];
        return (node)=>{
            for(let groups = node.prop($ed739beecf769914$export$b8034b9bc18acd90.group), i = -1; i < (groups ? groups.length : 0); i++){
                let found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
}
/**
An empty dummy node type to use when no actual type is available.
*/ $ed739beecf769914$export$f06e977173f1857c.none = new $ed739beecf769914$export$f06e977173f1857c("", Object.create(null), 0, 8 /* NodeFlag.Anonymous */ );
/**
A node set holds a collection of node types. It is used to
compactly represent trees by storing their type ids, rather than a
full pointer to the type object, in a numeric array. Each parser
[has](#lr.LRParser.nodeSet) a node set, and [tree
buffers](#common.TreeBuffer) can only store collections of nodes
from the same set. A set can have a maximum of 2**16 (65536) node
types in it, so that the ids fit into 16-bit typed array slots.
*/ class $ed739beecf769914$export$7fad5fb00d8de02c {
    /**
    Create a set with the given types. The `id` property of each
    type should correspond to its position within the array.
    */ constructor(/**
    The node types in this set, by id.
    */ types){
        this.types = types;
        for(let i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    /**
    Create a copy of this set with some node properties added. The
    arguments to this method can be created with
    [`NodeProp.add`](#common.NodeProp.add).
    */ extend(...props) {
        let newTypes = [];
        for (let type of this.types){
            let newProps = null;
            for (let source of props){
                let add = source(type);
                if (add) {
                    if (!newProps) newProps = Object.assign({}, type.props);
                    let value = add[1], prop = add[0];
                    if (prop.combine && prop.id in newProps) value = prop.combine(newProps[prop.id], value);
                    newProps[prop.id] = value;
                }
            }
            newTypes.push(newProps ? new $ed739beecf769914$export$f06e977173f1857c(type.name, newProps, type.id, type.flags) : type);
        }
        return new $ed739beecf769914$export$7fad5fb00d8de02c(newTypes);
    }
}
const $ed739beecf769914$var$CachedNode = new WeakMap(), $ed739beecf769914$var$CachedInnerNode = new WeakMap();
/**
Options that control iteration. Can be combined with the `|`
operator to enable multiple ones.
*/ var $ed739beecf769914$export$b0e28367f55837aa;
(function(IterMode) {
    /**
    When enabled, iteration will only visit [`Tree`](#common.Tree)
    objects, not nodes packed into
    [`TreeBuffer`](#common.TreeBuffer)s.
    */ IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /**
    Enable this to make iteration include anonymous nodes (such as
    the nodes that wrap repeated grammar constructs into a balanced
    tree).
    */ IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /**
    By default, regular [mounted](#common.NodeProp^mounted) nodes
    replace their base node in iteration. Enable this to ignore them
    instead.
    */ IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /**
    This option only applies in
    [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    library to not enter mounted overlays if one covers the given
    position.
    */ IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})($ed739beecf769914$export$b0e28367f55837aa || ($ed739beecf769914$export$b0e28367f55837aa = {}));
/**
A piece of syntax tree. There are two ways to approach these
trees: the way they are actually stored in memory, and the
convenient way.

Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
objects. By packing detail information into `TreeBuffer` leaf
nodes, the representation is made a lot more memory-efficient.

However, when you want to actually work with tree nodes, this
representation is very awkward, so most client code will want to
use the [`TreeCursor`](#common.TreeCursor) or
[`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
a view on some part of this data structure, and can be used to
move around to adjacent nodes.
*/ class $ed739beecf769914$export$7fbedc92909ed28e {
    /**
    Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    */ constructor(/**
    The type of the top node.
    */ type, /**
    This node's child nodes.
    */ children, /**
    The positions (offsets relative to the start of this tree) of
    the children.
    */ positions, /**
    The total length of this tree
    */ length, /**
    Per-node [node props](#common.NodeProp) to associate with this node.
    */ props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /**
        @internal
        */ this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            for (let [prop, value] of props)this.props[typeof prop == "number" ? prop : prop.id] = value;
        }
    }
    /**
    @internal
    */ toString() {
        let mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(this);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        let children = "";
        for (let ch of this.children){
            let str = ch.toString();
            if (str) {
                if (children) children += ",";
                children += str;
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /**
    Get a [tree cursor](#common.TreeCursor) positioned at the top of
    the tree. Mode can be used to [control](#common.IterMode) which
    nodes the cursor visits.
    */ cursor(mode = 0) {
        return new $ed739beecf769914$export$3ae4554f36e54a34(this.topNode, mode);
    }
    /**
    Get a [tree cursor](#common.TreeCursor) pointing into this tree
    at the given position and side (see
    [`moveTo`](#common.TreeCursor.moveTo).
    */ cursorAt(pos, side = 0, mode = 0) {
        let scope = $ed739beecf769914$var$CachedNode.get(this) || this.topNode;
        let cursor = new $ed739beecf769914$export$3ae4554f36e54a34(scope);
        cursor.moveTo(pos, side);
        $ed739beecf769914$var$CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) object for the top of the
    tree.
    */ get topNode() {
        return new $ed739beecf769914$var$TreeNode(this, 0, 0, null);
    }
    /**
    Get the [syntax node](#common.SyntaxNode) at the given position.
    If `side` is -1, this will move into nodes that end at the
    position. If 1, it'll move into nodes that start at the
    position. With 0, it'll only enter nodes that cover the position
    from both sides.
    
    Note that this will not enter
    [overlays](#common.MountedTree.overlay), and you often want
    [`resolveInner`](#common.Tree.resolveInner) instead.
    */ resolve(pos, side = 0) {
        let node = $ed739beecf769914$var$resolveNode($ed739beecf769914$var$CachedNode.get(this) || this.topNode, pos, side, false);
        $ed739beecf769914$var$CachedNode.set(this, node);
        return node;
    }
    /**
    Like [`resolve`](#common.Tree.resolve), but will enter
    [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    pointing into the innermost overlaid tree at the given position
    (with parent links going through all parent structure, including
    the host trees).
    */ resolveInner(pos, side = 0) {
        let node = $ed739beecf769914$var$resolveNode($ed739beecf769914$var$CachedInnerNode.get(this) || this.topNode, pos, side, true);
        $ed739beecf769914$var$CachedInnerNode.set(this, node);
        return node;
    }
    /**
    In some situations, it can be useful to iterate through all
    nodes around a position, including those in overlays that don't
    directly cover the position. This method gives you an iterator
    that will produce all nodes, from small to big, around the given
    position.
    */ resolveStack(pos, side = 0) {
        return $ed739beecf769914$var$stackIterator(this, pos, side);
    }
    /**
    Iterate over the tree and its children, calling `enter` for any
    node that touches the `from`/`to` region (if given) before
    running over such a node's children, and `leave` (if given) when
    leaving the node. When `enter` returns `false`, that node will
    not have its children iterated over (or `leave` called).
    */ iterate(spec) {
        let { enter: enter, leave: leave, from: from = 0, to: to = this.length } = spec;
        let mode = spec.mode || 0, anon = (mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous) > 0;
        for(let c = this.cursor(mode | $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous);;){
            let entered = false;
            if (c.from <= to && c.to >= from && (!anon && c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && (anon || !c.type.isAnonymous)) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /**
    Get the value of the given [node prop](#common.NodeProp) for this
    node. Works with both per-node and per-type props.
    */ prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /**
    Returns the node's [per-node props](#common.NodeProp.perNode) in a
    format that can be passed to the [`Tree`](#common.Tree)
    constructor.
    */ get propValues() {
        let result = [];
        if (this.props) for(let id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /**
    Balance the direct children of this tree, producing a copy of
    which may have children grouped into subtrees with type
    [`NodeType.none`](#common.NodeType^none).
    */ balance(config = {}) {
        return this.children.length <= 8 /* Balance.BranchFactor */  ? this : $ed739beecf769914$var$balanceRange($ed739beecf769914$export$f06e977173f1857c.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new $ed739beecf769914$export$7fbedc92909ed28e(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new $ed739beecf769914$export$7fbedc92909ed28e($ed739beecf769914$export$f06e977173f1857c.none, children, positions, length)));
    }
    /**
    Build a tree from a postfix-ordered buffer of node information,
    or a cursor over such a buffer.
    */ static build(data) {
        return $ed739beecf769914$var$buildTree(data);
    }
}
/**
The empty tree
*/ $ed739beecf769914$export$7fbedc92909ed28e.empty = new $ed739beecf769914$export$7fbedc92909ed28e($ed739beecf769914$export$f06e977173f1857c.none, [], [], 0);
class $ed739beecf769914$var$FlatBufferCursor {
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new $ed739beecf769914$var$FlatBufferCursor(this.buffer, this.index);
    }
}
/**
Tree buffers contain (type, start, end, endIndex) quads for each
node. In such a buffer, nodes are stored in prefix order (parents
before children, with the endIndex of the parent indicating which
children belong to it).
*/ class $ed739beecf769914$export$33300581b70be371 {
    /**
    Create a tree buffer.
    */ constructor(/**
    The buffer's content.
    */ buffer, /**
    The total length of the group of nodes in the buffer.
    */ length, /**
    The node set used in this buffer.
    */ set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
    /**
    @internal
    */ get type() {
        return $ed739beecf769914$export$f06e977173f1857c.none;
    }
    /**
    @internal
    */ toString() {
        let result = [];
        for(let index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /**
    @internal
    */ childString(index) {
        let id = this.buffer[index], endIndex = this.buffer[index + 3];
        let type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        let children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /**
    @internal
    */ findChild(startIndex, endIndex, dir, pos, side) {
        let { buffer: buffer } = this, pick = -1;
        for(let i = startIndex; i != endIndex; i = buffer[i + 3])if ($ed739beecf769914$var$checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /**
    @internal
    */ slice(startI, endI, from) {
        let b = this.buffer;
        let copy = new Uint16Array(endI - startI), len = 0;
        for(let i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            let to = copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
            len = Math.max(len, to);
        }
        return new $ed739beecf769914$export$33300581b70be371(copy, len, this.set);
    }
}
function $ed739beecf769914$var$checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Side.Before */ :
            return from < pos;
        case -1 /* Side.AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Side.Around */ :
            return from < pos && to > pos;
        case 1 /* Side.AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* Side.After */ :
            return to > pos;
        case 4 /* Side.DontCare */ :
            return true;
    }
}
function $ed739beecf769914$var$resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        let parent = !overlays && node instanceof $ed739beecf769914$var$TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    let mode = overlays ? 0 : $ed739beecf769914$export$b0e28367f55837aa.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent)if (scan instanceof $ed739beecf769914$var$TreeNode && scan.index < 0 && ((_a = parent.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent;
    }
    for(;;){
        let inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class $ed739beecf769914$var$BaseNode {
    cursor(mode = 0) {
        return new $ed739beecf769914$export$3ae4554f36e54a34(this, mode);
    }
    getChild(type, before = null, after = null) {
        let r = $ed739beecf769914$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $ed739beecf769914$var$getChildren(this, type, before, after);
    }
    resolve(pos, side = 0) {
        return $ed739beecf769914$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $ed739beecf769914$var$resolveNode(this, pos, side, true);
    }
    matchContext(context) {
        return $ed739beecf769914$var$matchNodeContext(this.parent, context);
    }
    enterUnfinishedNodesBefore(pos) {
        let scan = this.childBefore(pos), node = this;
        while(scan){
            let last = scan.lastChild;
            if (!last || last.to != scan.to) break;
            if (last.type.isError && last.from == last.to) {
                node = scan;
                scan = last.prevSibling;
            } else scan = last;
        }
        return node;
    }
    get node() {
        return this;
    }
    get next() {
        return this.parent;
    }
}
class $ed739beecf769914$var$TreeNode extends $ed739beecf769914$var$BaseNode {
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        super();
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side, mode = 0) {
        for(let parent = this;;){
            for(let { children: children, positions: positions } = parent._tree, e = dir > 0 ? children.length : -1; i != e; i += dir){
                let next = children[i], start = positions[i] + parent.from;
                if (!$ed739beecf769914$var$checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof $ed739beecf769914$export$33300581b70be371) {
                    if (mode & $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers) continue;
                    let index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new $ed739beecf769914$var$BufferNode(new $ed739beecf769914$var$BufferContext(parent, next, i, start), null, index);
                } else if (mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || !next.type.isAnonymous || $ed739beecf769914$var$hasChild(next)) {
                    let mounted;
                    if (!(mode & $ed739beecf769914$export$b0e28367f55837aa.IgnoreMounts) && (mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(next)) && !mounted.overlay) return new $ed739beecf769914$var$TreeNode(mounted.tree, start, i, parent);
                    let inner = new $ed739beecf769914$var$TreeNode(next, start, i, parent);
                    return mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
                }
            }
            if (mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Side.Before */ );
    }
    prop(prop) {
        return this._tree.prop(prop);
    }
    enter(pos, side, mode = 0) {
        let mounted;
        if (!(mode & $ed739beecf769914$export$b0e28367f55837aa.IgnoreOverlays) && (mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(this._tree)) && mounted.overlay) {
            let rPos = pos - this.from;
            for (let { from: from, to: to } of mounted.overlay){
                if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to >= rPos : to > rPos)) return new $ed739beecf769914$var$TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        let val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    /**
    @internal
    */ toString() {
        return this._tree.toString();
    }
}
function $ed739beecf769914$var$getChildren(node, type, before, after) {
    let cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) for(let found = false; !found;){
        found = cur.type.is(before);
        if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function $ed739beecf769914$var$matchNodeContext(node, context, i = context.length - 1) {
    for(let p = node; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class $ed739beecf769914$var$BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class $ed739beecf769914$var$BufferNode extends $ed739beecf769914$var$BaseNode {
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(context, _parent, index){
        super();
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
    child(dir, pos, side) {
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new $ed739beecf769914$var$BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Side.Before */ );
    }
    prop(prop) {
        return this.type.prop(prop);
    }
    enter(pos, side, mode = 0) {
        if (mode & $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers) return null;
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new $ed739beecf769914$var$BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* Side.DontCare */ );
    }
    get nextSibling() {
        let { buffer: buffer } = this.context;
        let after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new $ed739beecf769914$var$BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        let { buffer: buffer } = this.context;
        let parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new $ed739beecf769914$var$BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
    }
    get tree() {
        return null;
    }
    toTree() {
        let children = [], positions = [];
        let { buffer: buffer } = this.context;
        let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            let from = buffer.buffer[this.index + 1];
            children.push(buffer.slice(startI, endI, from));
            positions.push(0);
        }
        return new $ed739beecf769914$export$7fbedc92909ed28e(this.type, children, positions, this.to - this.from);
    }
    /**
    @internal
    */ toString() {
        return this.context.buffer.childString(this.index);
    }
}
function $ed739beecf769914$var$iterStack(heads) {
    if (!heads.length) return null;
    let pick = 0, picked = heads[0];
    for(let i = 1; i < heads.length; i++){
        let node = heads[i];
        if (node.from > picked.from || node.to < picked.to) {
            picked = node;
            pick = i;
        }
    }
    let next = picked instanceof $ed739beecf769914$var$TreeNode && picked.index < 0 ? null : picked.parent;
    let newHeads = heads.slice();
    if (next) newHeads[pick] = next;
    else newHeads.splice(pick, 1);
    return new $ed739beecf769914$var$StackIterator(newHeads, picked);
}
class $ed739beecf769914$var$StackIterator {
    constructor(heads, node){
        this.heads = heads;
        this.node = node;
    }
    get next() {
        return $ed739beecf769914$var$iterStack(this.heads);
    }
}
function $ed739beecf769914$var$stackIterator(tree, pos, side) {
    let inner = tree.resolveInner(pos, side), layers = null;
    for(let scan = inner instanceof $ed739beecf769914$var$TreeNode ? inner : inner.context.parent; scan; scan = scan.parent)if (scan.index < 0) {
        let parent = scan.parent;
        (layers || (layers = [
            inner
        ])).push(parent.resolve(pos, side));
        scan = parent;
    } else {
        let mount = $ed739beecf769914$export$358cdd8bd77577cc.get(scan.tree);
        // Relevant overlay branching off
        if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
            let root = new $ed739beecf769914$var$TreeNode(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
            (layers || (layers = [
                inner
            ])).push($ed739beecf769914$var$resolveNode(root, pos, side, false));
        }
    }
    return layers ? $ed739beecf769914$var$iterStack(layers) : inner;
}
/**
A tree cursor object focuses on a given node in a syntax tree, and
allows you to move to adjacent nodes.
*/ class $ed739beecf769914$export$3ae4554f36e54a34 {
    /**
    Shorthand for `.type.name`.
    */ get name() {
        return this.type.name;
    }
    /**
    @internal
    */ constructor(node, /**
    @internal
    */ mode = 0){
        this.mode = mode;
        /**
        @internal
        */ this.buffer = null;
        this.stack = [];
        /**
        @internal
        */ this.index = 0;
        this.bufferNode = null;
        if (node instanceof $ed739beecf769914$var$TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(let n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        let { start: start, buffer: buffer } = this.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    /**
    @internal
    */ yield(node) {
        if (!node) return false;
        if (node instanceof $ed739beecf769914$var$TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /**
    @internal
    */ toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /**
    @internal
    */ enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        let { buffer: buffer } = this.buffer;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /**
    Move the cursor to this node's first child. When this returns
    false, the node has no child, and the cursor has not been moved.
    */ firstChild() {
        return this.enterChild(1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to this node's last child.
    */ lastChild() {
        return this.enterChild(-1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to the first child that ends after `pos`.
    */ childAfter(pos) {
        return this.enterChild(1, pos, 2 /* Side.After */ );
    }
    /**
    Move to the last child that starts before `pos`.
    */ childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Side.Before */ );
    }
    /**
    Move the cursor to the child around `pos`. If side is -1 the
    child may end at that position, when 1 it may start there. This
    will also enter [overlaid](#common.MountedTree.overlay)
    [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    set to false.
    */ enter(pos, side, mode = this.mode) {
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /**
    Move to the node's parent node, if this isn't the top node.
    */ parent() {
        if (!this.buffer) return this.yieldNode(this.mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        let parent = this.mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /**
    @internal
    */ sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode));
        let { buffer: buffer } = this.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            let parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
        } else {
            let after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode)) : false;
    }
    /**
    Move to this node's next sibling, if any.
    */ nextSibling() {
        return this.sibling(1);
    }
    /**
    Move to this node's previous sibling, if any.
    */ prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        let index, parent, { buffer: buffer } = this;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(let i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            ({ index: index, parent: parent } = buffer);
        } else ({ index: index, _parent: parent } = this._tree);
        for(; parent; { index: index, _parent: parent } = parent){
            if (index > -1) for(let i = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i != e; i += dir){
                let child = parent._tree.children[i];
                if (this.mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || child instanceof $ed739beecf769914$export$33300581b70be371 || !child.type.isAnonymous || $ed739beecf769914$var$hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* Side.DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /**
    Move to the next node in a
    [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
    traversal, going from a node to its first child or, if the
    current node is empty or `enter` is false, its next sibling or
    the next sibling of the first parent node that has one.
    */ next(enter = true) {
        return this.move(1, enter);
    }
    /**
    Move to the next node in a last-to-first pre-order traversal. A
    node is followed by its last child or, if it has none, its
    previous sibling or the previous sibling of the first parent
    node that has one.
    */ prev(enter = true) {
        return this.move(-1, enter);
    }
    /**
    Move the cursor to the innermost node that covers `pos`. If
    `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    it will enter nodes that start at `pos`.
    */ moveTo(pos, side = 0) {
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) at the cursor's current
    position.
    */ get node() {
        if (!this.buffer) return this._tree;
        let cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(let index = this.index, d = this.stack.length; d >= 0;){
            for(let c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(let i = depth; i < this.stack.length; i++)result = new $ed739beecf769914$var$BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new $ed739beecf769914$var$BufferNode(this.buffer, result, this.index);
    }
    /**
    Get the [tree](#common.Tree) that represents the current node, if
    any. Will return null when the node is in a [tree
    buffer](#common.TreeBuffer).
    */ get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /**
    Iterate over the current node and all its descendants, calling
    `enter` when entering a node and `leave`, if given, when leaving
    one. When `enter` returns `false`, any children of that node are
    skipped, and `leave` isn't called for it.
    */ iterate(enter, leave) {
        for(let depth = 0;;){
            let mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (!depth) return;
                if (this.nextSibling()) break;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /**
    Test whether the current node matches a given context—a sequence
    of direct parent node names. Empty strings in the context array
    are treated as wildcards.
    */ matchContext(context) {
        if (!this.buffer) return $ed739beecf769914$var$matchNodeContext(this.node.parent, context);
        let { buffer: buffer } = this.buffer, { types: types } = buffer.set;
        for(let i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return $ed739beecf769914$var$matchNodeContext(this._tree, context, i);
            let type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
}
function $ed739beecf769914$var$hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof $ed739beecf769914$export$33300581b70be371 || !ch.type.isAnonymous || $ed739beecf769914$var$hasChild(ch));
}
function $ed739beecf769914$var$buildTree(data) {
    var _a;
    let { buffer: buffer, nodeSet: nodeSet, maxBufferLength: maxBufferLength = $ed739beecf769914$export$de305a849879ffa, reused: reused = [], minRepeatType: minRepeatType = nodeSet.types.length } = data;
    let cursor = Array.isArray(buffer) ? new $ed739beecf769914$var$FlatBufferCursor(buffer, buffer.length) : buffer;
    let types = nodeSet.types;
    let contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat, depth) {
        let { id: id, start: start, end: end, size: size } = cursor;
        let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
        if (size < 0) {
            cursor.next();
            if (size == -1 /* SpecialRecord.Reuse */ ) {
                let node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* SpecialRecord.ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* SpecialRecord.LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        let type = types[id], node, buffer;
        let startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            let data = new Uint16Array(buffer.size - buffer.skip);
            let endPos = cursor.pos - buffer.size, index = data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, data, index);
            node = new $ed739beecf769914$export$33300581b70be371(data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            let endPos = cursor.pos - size;
            cursor.next();
            let localChildren = [], localPositions = [];
            let localInRepeat = id >= minRepeatType ? id : -1;
            let lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos){
                if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                    if (cursor.end <= lastEnd - maxBufferLength) {
                        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
                        lastGroup = localChildren.length;
                        lastEnd = cursor.end;
                    }
                    cursor.next();
                } else if (depth > 2500 /* CutOff.Depth */ ) takeFlatNode(start, endPos, localChildren, localPositions);
                else takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
            }
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                let make = makeBalanced(type, contextAtStart);
                node = $ed739beecf769914$var$balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
        }
        children.push(node);
        positions.push(startPos);
    }
    function takeFlatNode(parentStart, minPos, children, positions) {
        let nodes = []; // Temporary, inverted array of leaf nodes found, with absolute positions
        let nodeCount = 0, stopAt = -1;
        while(cursor.pos > minPos){
            let { id: id, start: start, end: end, size: size } = cursor;
            if (size > 4) cursor.next();
            else if (stopAt > -1 && start < stopAt) break;
            else {
                if (stopAt < 0) stopAt = end - maxBufferLength;
                nodes.push(id, start, end);
                nodeCount++;
                cursor.next();
            }
        }
        if (nodeCount) {
            let buffer = new Uint16Array(nodeCount * 4);
            let start = nodes[nodes.length - 2];
            for(let i = nodes.length - 3, j = 0; i >= 0; i -= 3){
                buffer[j++] = nodes[i];
                buffer[j++] = nodes[i + 1] - start;
                buffer[j++] = nodes[i + 2] - start;
                buffer[j++] = j;
            }
            children.push(new $ed739beecf769914$export$33300581b70be371(buffer, nodes[2] - start, nodeSet));
            positions.push(start - parentStart);
        }
    }
    function makeBalanced(type, contextHash) {
        return (children, positions, length)=>{
            let lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof $ed739beecf769914$export$7fbedc92909ed28e) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop($ed739beecf769914$export$b8034b9bc18acd90.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead, contextHash);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead, contextHash) {
        let localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to, contextHash));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length, lookAhead, contextHash, props) {
        if (contextHash) {
            let pair = [
                $ed739beecf769914$export$b8034b9bc18acd90.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            let pair = [
                $ed739beecf769914$export$b8034b9bc18acd90.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        return new $ed739beecf769914$export$7fbedc92909ed28e(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        let fork = cursor.fork();
        let size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        let result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(let minPos = fork.pos - maxSize; fork.pos > minPos;){
            let nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            let startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            let localSkipped = fork.id >= minRepeatType ? 4 : 0;
            let nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* SpecialRecord.ContextChange */  || fork.size == -4 /* SpecialRecord.LookAhead */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        let { id: id, start: start, end: end, size: size } = cursor;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            let startIndex = index;
            if (size > 4) {
                let endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* SpecialRecord.ContextChange */ ) contextHash = id;
        else if (size == -4 /* SpecialRecord.LookAhead */ ) lookAhead = id;
        return index;
    }
    let children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
    let length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new $ed739beecf769914$export$7fbedc92909ed28e(types[data.topID], children.reverse(), positions.reverse(), length);
}
const $ed739beecf769914$var$nodeSizeCache = new WeakMap;
function $ed739beecf769914$var$nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof $ed739beecf769914$export$33300581b70be371 || node.type != balanceType) return 1;
    let size = $ed739beecf769914$var$nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        for (let child of node.children){
            if (child.type != balanceType || !(child instanceof $ed739beecf769914$export$7fbedc92909ed28e)) {
                size = 1;
                break;
            }
            size += $ed739beecf769914$var$nodeSize(balanceType, child);
        }
        $ed739beecf769914$var$nodeSizeCache.set(node, size);
    }
    return size;
}
function $ed739beecf769914$var$balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    let total = 0;
    for(let i = from; i < to; i++)total += $ed739beecf769914$var$nodeSize(balanceType, children[i]);
    let maxChild = Math.ceil(total * 1.5 / 8 /* Balance.BranchFactor */ );
    let localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(let i = from; i < to;){
            let groupFrom = i, groupStart = positions[i], groupSize = $ed739beecf769914$var$nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                let nextSize = $ed739beecf769914$var$nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    let only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                let length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push($ed739beecf769914$var$balanceRange(balanceType, children, positions, groupFrom, i, groupStart, length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/**
Provides a way to associate values with pieces of trees. As long
as that part of the tree is reused, the associated values can be
retrieved from an updated tree.
*/ class $ed739beecf769914$export$7f13b5dc44c541ae {
    constructor(){
        this.map = new WeakMap();
    }
    setBuffer(buffer, index, value) {
        let inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        let inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /**
    Set the value for this syntax node.
    */ set(node, value) {
        if (node instanceof $ed739beecf769914$var$BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof $ed739beecf769914$var$TreeNode) this.map.set(node.tree, value);
    }
    /**
    Retrieve value for this syntax node, if it exists in the map.
    */ get(node) {
        return node instanceof $ed739beecf769914$var$BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof $ed739beecf769914$var$TreeNode ? this.map.get(node.tree) : undefined;
    }
    /**
    Set the value for the node that a cursor currently points to.
    */ cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /**
    Retrieve the value for the node that a cursor currently points
    to.
    */ cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
}
/**
Tree fragments are used during [incremental
parsing](#common.Parser.startParse) to track parts of old trees
that can be reused in a new parse. An array of fragments is used
to track regions of an old tree whose nodes might be reused in new
parses. Use the static
[`applyChanges`](#common.TreeFragment^applyChanges) method to
update fragments for document changes.
*/ class $ed739beecf769914$export$3ae2ede6dca97077 {
    /**
    Construct a tree fragment. You'll usually want to use
    [`addTree`](#common.TreeFragment^addTree) and
    [`applyChanges`](#common.TreeFragment^applyChanges) instead of
    calling this directly.
    */ constructor(/**
    The start of the unchanged range pointed to by this fragment.
    This refers to an offset in the _updated_ document (as opposed
    to the original tree).
    */ from, /**
    The end of the unchanged range.
    */ to, /**
    The tree that this fragment is based on.
    */ tree, /**
    The offset between the fragment's tree and the document that
    this fragment can be used against. Add this when going from
    document to tree positions, subtract it to go from tree to
    document positions.
    */ offset, openStart = false, openEnd = false){
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Open.Start */  : 0) | (openEnd ? 2 /* Open.End */  : 0);
    }
    /**
    Whether the start of the fragment represents the start of a
    parse, or the end of a change. (In the second case, it may not
    be safe to reuse some nodes at the start, depending on the
    parsing algorithm.)
    */ get openStart() {
        return (this.open & 1 /* Open.Start */ ) > 0;
    }
    /**
    Whether the end of the fragment represents the end of a
    full-document parse, or the start of a change.
    */ get openEnd() {
        return (this.open & 2 /* Open.End */ ) > 0;
    }
    /**
    Create a set of fragments from a freshly parsed tree, or update
    an existing set of fragments by replacing the ones that overlap
    with a tree with content from the new tree. When `partial` is
    true, the parse is treated as incomplete, and the resulting
    fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    true.
    */ static addTree(tree, fragments = [], partial = false) {
        let result = [
            new $ed739beecf769914$export$3ae2ede6dca97077(0, tree.length, tree, 0, false, partial)
        ];
        for (let f of fragments)if (f.to > tree.length) result.push(f);
        return result;
    }
    /**
    Apply a set of edits to an array of fragments, removing or
    splitting fragments as necessary to remove edited ranges, and
    adjusting offsets for fragments that moved.
    */ static applyChanges(fragments, changes, minGap = 128) {
        if (!changes.length) return fragments;
        let result = [];
        let fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(let cI = 0, pos = 0, off = 0;; cI++){
            let nextC = cI < changes.length ? changes[cI] : null;
            let nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                let cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new $ed739beecf769914$export$3ae2ede6dca97077(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
}
/**
A superclass that parsers should extend.
*/ class $ed739beecf769914$export$7acfa6ed01010e37 {
    /**
    Start a parse, returning a [partial parse](#common.PartialParse)
    object. [`fragments`](#common.TreeFragment) can be passed in to
    make the parse incremental.
    
    By default, the entire input is parsed. You can pass `ranges`,
    which should be a sorted array of non-empty, non-overlapping
    ranges, to parse only those ranges. The tree returned in that
    case will start at `ranges[0].from`.
    */ startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new $ed739beecf769914$var$StringInput(input);
        ranges = !ranges ? [
            new $ed739beecf769914$var$Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new $ed739beecf769914$var$Range(r.from, r.to)) : [
            new $ed739beecf769914$var$Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /**
    Run a full parse, returning the resulting tree.
    */ parse(input, fragments, ranges) {
        let parse = this.startParse(input, fragments, ranges);
        for(;;){
            let done = parse.advance();
            if (done) return done;
        }
    }
}
class $ed739beecf769914$var$StringInput {
    constructor(string){
        this.string = string;
    }
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
}
/**
Create a parse wrapper that, after the inner parse completes,
scans its tree for mixed language regions with the `nest`
function, runs the resulting [inner parses](#common.NestedParse),
and then [mounts](#common.NodeProp^mounted) their results onto the
tree.
*/ function $ed739beecf769914$export$5dcc455959c76221(nest) {
    return (parse, input, fragments, ranges)=>new $ed739beecf769914$var$MixedParse(parse, nest, input, fragments, ranges);
}
class $ed739beecf769914$var$InnerParse {
    constructor(parser, parse, overlay, target, from){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.target = target;
        this.from = from;
    }
}
function $ed739beecf769914$var$checkRanges(ranges) {
    if (!ranges.length || ranges.some((r)=>r.from >= r.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
}
class $ed739beecf769914$var$ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
const $ed739beecf769914$var$stoppedInner = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
class $ed739beecf769914$var$MixedParse {
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
    advance() {
        if (this.baseParse) {
            let done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            if (this.stoppedAt != null) for (let inner of this.inner)inner.parse.stopAt(this.stoppedAt);
        }
        if (this.innerDone == this.inner.length) {
            let result = this.baseTree;
            if (this.stoppedAt != null) result = new $ed739beecf769914$export$7fbedc92909ed28e(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    $ed739beecf769914$var$stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        let inner = this.inner[this.innerDone], done = inner.parse.advance();
        if (done) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            let props = Object.assign(Object.create(null), inner.target.props);
            props[$ed739beecf769914$export$b8034b9bc18acd90.mounted.id] = new $ed739beecf769914$export$358cdd8bd77577cc(done, inner.overlay, inner.parser);
            inner.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        let pos = this.input.length;
        for(let i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(let i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        let fragmentCursor = new $ed739beecf769914$var$FragmentCursor(this.fragments);
        let overlay = null;
        let covered = null;
        let cursor = new $ed739beecf769914$export$3ae4554f36e54a34(new $ed739beecf769914$var$TreeNode(this.baseTree, this.ranges[0].from, 0, null), $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous | $ed739beecf769914$export$b0e28367f55837aa.IgnoreMounts);
        scan: for(let nest, isCovered;;){
            let enter = true, range;
            if (this.stoppedAt != null && cursor.from >= this.stoppedAt) enter = false;
            else if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    let match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    if (match) for (let r of match.mount.overlay){
                        let from = r.from + match.pos, to = r.to + match.pos;
                        if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                            from: from,
                            to: to
                        });
                    }
                }
                enter = false;
            } else if (covered && (isCovered = $ed739beecf769914$var$checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered != 2 /* Cover.Full */ ;
            else if (!cursor.type.isAnonymous && (nest = this.nest(cursor, this.input)) && (cursor.from < cursor.to || !nest.overlay)) {
                if (!cursor.tree) {
                    $ed739beecf769914$var$materialize(cursor);
                    // materialize create one more level of nesting
                    // we need to add depth to active overlay for going backwards
                    if (overlay) overlay.depth++;
                    if (covered) covered.depth++;
                }
                let oldMounts = fragmentCursor.findMounts(cursor.from, nest.parser);
                if (typeof nest.overlay == "function") overlay = new $ed739beecf769914$var$ActiveOverlay(nest.parser, nest.overlay, oldMounts, this.inner.length, cursor.from, cursor.tree, overlay);
                else {
                    let ranges = $ed739beecf769914$var$punchRanges(this.ranges, nest.overlay || (cursor.from < cursor.to ? [
                        new $ed739beecf769914$var$Range(cursor.from, cursor.to)
                    ] : []));
                    if (ranges.length) $ed739beecf769914$var$checkRanges(ranges);
                    if (ranges.length || !nest.overlay) this.inner.push(new $ed739beecf769914$var$InnerParse(nest.parser, ranges.length ? nest.parser.startParse(this.input, $ed739beecf769914$var$enterFragments(oldMounts, ranges), ranges) : nest.parser.startParse(""), nest.overlay ? nest.overlay.map((r)=>new $ed739beecf769914$var$Range(r.from - cursor.from, r.to - cursor.from)) : null, cursor.tree, ranges.length ? ranges[0].from : cursor.from));
                    if (!nest.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges: ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new $ed739beecf769914$var$Range(cursor.from, cursor.to);
                if (range.from < range.to) {
                    let last = overlay.ranges.length - 1;
                    if (last >= 0 && overlay.ranges[last].to == range.from) overlay.ranges[last] = {
                        from: overlay.ranges[last].from,
                        to: range.to
                    };
                    else overlay.ranges.push(range);
                }
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) break scan;
                if (overlay && !--overlay.depth) {
                    let ranges = $ed739beecf769914$var$punchRanges(this.ranges, overlay.ranges);
                    if (ranges.length) {
                        $ed739beecf769914$var$checkRanges(ranges);
                        this.inner.splice(overlay.index, 0, new $ed739beecf769914$var$InnerParse(overlay.parser, overlay.parser.startParse(this.input, $ed739beecf769914$var$enterFragments(overlay.mounts, ranges), ranges), overlay.ranges.map((r)=>new $ed739beecf769914$var$Range(r.from - overlay.start, r.to - overlay.start)), overlay.target, ranges[0].from));
                    }
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
        }
    }
}
function $ed739beecf769914$var$checkCover(covered, from, to) {
    for (let range of covered){
        if (range.from >= to) break;
        if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Cover.Full */  : 1 /* Cover.Partial */ ;
    }
    return 0 /* Cover.None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function $ed739beecf769914$var$sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        let from = buf.buffer[startI + 1];
        nodes.push(buf.slice(startI, endI, from));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function $ed739beecf769914$var$materialize(cursor) {
    let { node: node } = cursor, stack = [];
    let buffer = node.context.buffer;
    // Scan up to the nearest tree
    do {
        stack.push(cursor.index);
        cursor.parent();
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    let base = cursor.tree, i = base.children.indexOf(buffer);
    let buf = base.children[i], b = buf.buffer, newStack = [
        i
    ];
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length, stackPos) {
        let targetI = stack[stackPos];
        let children = [], positions = [];
        $ed739beecf769914$var$sliceBuf(buf, startI, targetI, children, positions, innerOffset);
        let from = b[targetI + 1], to = b[targetI + 2];
        newStack.push(children.length);
        let child = stackPos ? split(targetI + 4, b[targetI + 3], buf.set.types[b[targetI]], from, to - from, stackPos - 1) : node.toTree();
        children.push(child);
        positions.push(from - innerOffset);
        $ed739beecf769914$var$sliceBuf(buf, b[targetI + 3], endI, children, positions, innerOffset);
        return new $ed739beecf769914$export$7fbedc92909ed28e(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, $ed739beecf769914$export$f06e977173f1857c.none, 0, buf.length, stack.length - 1);
    // Move the cursor back to the target node
    for (let index of newStack){
        let tree = cursor.tree.children[index], pos = cursor.tree.positions[index];
        cursor.yield(new $ed739beecf769914$var$TreeNode(tree, pos + cursor.from, index, cursor._tree));
    }
}
class $ed739beecf769914$var$StructureCursor {
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor($ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous | $ed739beecf769914$export$b0e28367f55837aa.IgnoreMounts);
    }
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        let { cursor: cursor } = this, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, $ed739beecf769914$export$b0e28367f55837aa.IgnoreOverlays | $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers)) ;
            else if (!cursor.next(false)) this.done = true;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(let tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof $ed739beecf769914$export$7fbedc92909ed28e) tree = tree.children[0];
            else break;
        }
        return false;
    }
}
class $ed739beecf769914$var$FragmentCursor {
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            let first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop($ed739beecf769914$var$stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new $ed739beecf769914$var$StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            let frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop($ed739beecf769914$var$stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new $ed739beecf769914$var$StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        let result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(let pos = this.inner.cursor.node; pos; pos = pos.parent){
                let mount = (_a = pos.tree) === null || _a === void 0 ? void 0 : _a.prop($ed739beecf769914$export$b8034b9bc18acd90.mounted);
                if (mount && mount.parser == parser) for(let i = this.fragI; i < this.fragments.length; i++){
                    let frag = this.fragments[i];
                    if (frag.from >= pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag: frag,
                        pos: pos.from - frag.offset,
                        mount: mount
                    });
                }
            }
        }
        return result;
    }
}
function $ed739beecf769914$var$punchRanges(outer, ranges) {
    let copy = null, current = ranges;
    for(let i = 1, j = 0; i < outer.length; i++){
        let gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            let r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new $ed739beecf769914$var$Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new $ed739beecf769914$var$Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new $ed739beecf769914$var$Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function $ed739beecf769914$var$findCoverChanges(a, b, from, to) {
    let iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    let result = [];
    for(;;){
        let nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        let nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            let start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new $ed739beecf769914$var$Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function $ed739beecf769914$var$enterFragments(mounts, ranges) {
    let result = [];
    for (let { pos: pos, mount: mount, frag: frag } of mounts){
        let startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
        let from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
        if (mount.overlay) {
            let overlay = mount.overlay.map((r)=>new $ed739beecf769914$var$Range(r.from + pos, r.to + pos));
            let changes = $ed739beecf769914$var$findCoverChanges(ranges, overlay, from, to);
            for(let i = 0, pos = from;; i++){
                let last = i == changes.length, end = last ? to : changes[i].from;
                if (end > pos) result.push(new $ed739beecf769914$export$3ae2ede6dca97077(pos, end, mount.tree, -startPos, frag.from >= pos || frag.openStart, frag.to <= end || frag.openEnd));
                if (last) break;
                pos = changes[i].to;
            }
        } else result.push(new $ed739beecf769914$export$3ae2ede6dca97077(from, to, mount.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
    }
    return result;
}





let $a1ec9d683d365521$var$nextTagID = 0;
/**
Highlighting tags are markers that denote a highlighting category.
They are [associated](#highlight.styleTags) with parts of a syntax
tree by a language mode, and then mapped to an actual CSS style by
a [highlighter](#highlight.Highlighter).

Because syntax tree node types and highlight styles have to be
able to talk the same language, CodeMirror uses a mostly _closed_
[vocabulary](#highlight.tags) of syntax tags (as opposed to
traditional open string-based systems, which make it hard for
highlighting themes to cover all the tokens produced by the
various languages).

It _is_ possible to [define](#highlight.Tag^define) your own
highlighting tags for system-internal use (where you control both
the language package and the highlighter), but such tags will not
be picked up by regular highlighters (though you can derive them
from standard tags to allow highlighters to fall back to those).
*/ class $a1ec9d683d365521$export$3288d34c523a1192 {
    /**
    @internal
    */ constructor(/**
    The optional name of the base tag @internal
    */ name, /**
    The set of this tag and all its parent tags, starting with
    this one itself and sorted in order of decreasing specificity.
    */ set, /**
    The base unmodified tag that this one is based on, if it's
    modified @internal
    */ base, /**
    The modifiers applied to this.base @internal
    */ modified){
        this.name = name;
        this.set = set;
        this.base = base;
        this.modified = modified;
        /**
        @internal
        */ this.id = $a1ec9d683d365521$var$nextTagID++;
    }
    toString() {
        let { name: name } = this;
        for (let mod of this.modified)if (mod.name) name = `${mod.name}(${name})`;
        return name;
    }
    static define(nameOrParent, parent) {
        let name = typeof nameOrParent == "string" ? nameOrParent : "?";
        if (nameOrParent instanceof $a1ec9d683d365521$export$3288d34c523a1192) parent = nameOrParent;
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        let tag = new $a1ec9d683d365521$export$3288d34c523a1192(name, [], null, []);
        tag.set.push(tag);
        if (parent) for (let t of parent.set)tag.set.push(t);
        return tag;
    }
    /**
    Define a tag _modifier_, which is a function that, given a tag,
    will return a tag that is a subtag of the original. Applying the
    same modifier to a twice tag will return the same value (`m1(t1)
    == m1(t1)`) and applying multiple modifiers will, regardless or
    order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    
    When multiple modifiers are applied to a given base tag, each
    smaller set of modifiers is registered as a parent, so that for
    example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    `m1(m3(t1)`, and so on.
    */ static defineModifier(name) {
        let mod = new $a1ec9d683d365521$var$Modifier(name);
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return $a1ec9d683d365521$var$Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
}
let $a1ec9d683d365521$var$nextModifierID = 0;
class $a1ec9d683d365521$var$Modifier {
    constructor(name){
        this.name = name;
        this.instances = [];
        this.id = $a1ec9d683d365521$var$nextModifierID++;
    }
    static get(base, mods) {
        if (!mods.length) return base;
        let exists = mods[0].instances.find((t)=>t.base == base && $a1ec9d683d365521$var$sameArray(mods, t.modified));
        if (exists) return exists;
        let set = [], tag = new $a1ec9d683d365521$export$3288d34c523a1192(base.name, set, base, mods);
        for (let m of mods)m.instances.push(tag);
        let configs = $a1ec9d683d365521$var$powerSet(mods);
        for (let parent of base.set)if (!parent.modified.length) for (let config of configs)set.push($a1ec9d683d365521$var$Modifier.get(parent, config));
        return tag;
    }
}
function $a1ec9d683d365521$var$sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function $a1ec9d683d365521$var$powerSet(array) {
    let sets = [
        []
    ];
    for(let i = 0; i < array.length; i++)for(let j = 0, e = sets.length; j < e; j++)sets.push(sets[j].concat(array[i]));
    return sets.sort((a, b)=>b.length - a.length);
}
/**
This function is used to add a set of tags to a language syntax
via [`NodeSet.extend`](#common.NodeSet.extend) or
[`LRParser.configure`](#lr.LRParser.configure).

The argument object maps node selectors to [highlighting
tags](#highlight.Tag) or arrays of tags.

Node selectors may hold one or more (space-separated) node paths.
Such a path can be a [node name](#common.NodeType.name), or
multiple node names (or `*` wildcards) separated by slash
characters, as in `"Block/Declaration/VariableName"`. Such a path
matches the final node but only if its direct parent nodes are the
other nodes mentioned. A `*` in such a path matches any parent,
but only a single level—wildcards that match multiple parents
aren't supported, both for efficiency reasons and because Lezer
trees make it rather hard to reason about what they would match.)

A path can be ended with `/...` to indicate that the tag assigned
to the node should also apply to all child nodes, even if they
match their own style (by default, only the innermost style is
used).

When a path ends in `!`, as in `Attribute!`, no further matching
happens for the node's child nodes, and the entire node gets the
given style.

In this notation, node names that contain `/`, `!`, `*`, or `...`
must be quoted as JSON strings.

For example:

```javascript
parser.configure({props: [
  styleTags({
    // Style Number and BigNumber nodes
    "Number BigNumber": tags.number,
    // Style Escape nodes whose parent is String
    "String/Escape": tags.escape,
    // Style anything inside Attributes nodes
    "Attributes!": tags.meta,
    // Add a style to all content inside Italic nodes
    "Italic/...": tags.emphasis,
    // Style InvalidString nodes as both `string` and `invalid`
    "InvalidString": [tags.string, tags.invalid],
    // Style the node named "/" as punctuation
    '"/"': tags.punctuation
  })
]})
```
*/ function $a1ec9d683d365521$export$c537e79bb7b94295(spec) {
    let byName = Object.create(null);
    for(let prop in spec){
        let tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        for (let part of prop.split(" "))if (part) {
            let pieces = [], mode = 2 /* Mode.Normal */ , rest = part;
            for(let pos = 0;;){
                if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                    mode = 1 /* Mode.Inherit */ ;
                    break;
                }
                let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                if (!m) throw new RangeError("Invalid path: " + part);
                pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                pos += m[0].length;
                if (pos == part.length) break;
                let next = part[pos++];
                if (pos == part.length && next == "!") {
                    mode = 0 /* Mode.Opaque */ ;
                    break;
                }
                if (next != "/") throw new RangeError("Invalid path: " + part);
                rest = part.slice(pos);
            }
            let last = pieces.length - 1, inner = pieces[last];
            if (!inner) throw new RangeError("Invalid path: " + part);
            let rule = new $a1ec9d683d365521$var$Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
            byName[inner] = rule.sort(byName[inner]);
        }
    }
    return $a1ec9d683d365521$var$ruleNodeProp.add(byName);
}
const $a1ec9d683d365521$var$ruleNodeProp = new (0, $ed739beecf769914$export$b8034b9bc18acd90)({
    combine (a, b) {
        let cur, root, take;
        while(a || b){
            if (!a || b && a.depth >= b.depth) {
                take = b;
                b = b.next;
            } else {
                take = a;
                a = a.next;
            }
            if (cur && cur.mode == take.mode && !take.context && !cur.context) continue;
            let copy = new $a1ec9d683d365521$var$Rule(take.tags, take.mode, take.context);
            if (cur) cur.next = copy;
            else root = copy;
            cur = copy;
        }
        return root;
    }
});
class $a1ec9d683d365521$var$Rule {
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
    get opaque() {
        return this.mode == 0 /* Mode.Opaque */ ;
    }
    get inherit() {
        return this.mode == 1 /* Mode.Inherit */ ;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
}
$a1ec9d683d365521$var$Rule.empty = new $a1ec9d683d365521$var$Rule([], 2 /* Mode.Normal */ , null);
/**
Define a [highlighter](#highlight.Highlighter) from an array of
tag/class pairs. Classes associated with more specific tags will
take precedence.
*/ function $a1ec9d683d365521$export$b7f6332ce20f80fb(tags, options) {
    let map = Object.create(null);
    for (let style of tags){
        if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
        else for (let tag of style.tag)map[tag.id] = style.class;
    }
    let { scope: scope, all: all = null } = options || {};
    return {
        style: (tags)=>{
            let cls = all;
            for (let tag of tags)for (let sub of tag.set){
                let tagClass = map[sub.id];
                if (tagClass) {
                    cls = cls ? cls + " " + tagClass : tagClass;
                    break;
                }
            }
            return cls;
        },
        scope: scope
    };
}
function $a1ec9d683d365521$var$highlightTags(highlighters, tags) {
    let result = null;
    for (let highlighter of highlighters){
        let value = highlighter.style(tags);
        if (value) result = result ? result + " " + value : value;
    }
    return result;
}
/**
Highlight the given [tree](#common.Tree) with the given
[highlighter](#highlight.Highlighter). Often, the higher-level
[`highlightCode`](#highlight.highlightCode) function is easier to
use.
*/ function $a1ec9d683d365521$export$af82b3d076119fad(tree, highlighter, /**
Assign styling to a region of the text. Will be called, in order
of position, for any ranges where more than zero classes apply.
`classes` is a space separated string of CSS classes.
*/ putStyle, /**
The start of the range to highlight.
*/ from = 0, /**
The end of the range.
*/ to = tree.length) {
    let builder = new $a1ec9d683d365521$var$HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
/**
Highlight the given tree with the given highlighter, calling
`putText` for every piece of text, either with a set of classes or
with the empty string when unstyled, and `putBreak` for every line
break.
*/ function $a1ec9d683d365521$export$e443a046766e80e8(code, tree, highlighter, putText, putBreak, from = 0, to = code.length) {
    let pos = from;
    function writeTo(p, classes) {
        if (p <= pos) return;
        for(let text = code.slice(pos, p), i = 0;;){
            let nextBreak = text.indexOf("\n", i);
            let upto = nextBreak < 0 ? text.length : nextBreak;
            if (upto > i) putText(text.slice(i, upto), classes);
            if (nextBreak < 0) break;
            putBreak();
            i = nextBreak + 1;
        }
        pos = p;
    }
    $a1ec9d683d365521$export$af82b3d076119fad(tree, highlighter, (from, to, classes)=>{
        writeTo(from, "");
        writeTo(to, classes);
    }, from, to);
    writeTo(to, "");
}
class $a1ec9d683d365521$var$HighlightBuilder {
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        let { type: type, from: start, to: end } = cursor;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        let cls = inheritedClass;
        let rule = $a1ec9d683d365521$export$1519d79cc79711ec(cursor) || $a1ec9d683d365521$var$Rule.empty;
        let tagCls = $a1ec9d683d365521$var$highlightTags(highlighters, rule.tags);
        if (tagCls) {
            if (cls) cls += " ";
            cls += tagCls;
            if (rule.mode == 1 /* Mode.Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
        }
        this.startSpan(Math.max(from, start), cls);
        if (rule.opaque) return;
        let mounted = cursor.tree && cursor.tree.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).mounted);
        if (mounted && mounted.overlay) {
            let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            let innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            let hasChild = cursor.firstChild();
            for(let i = 0, pos = start;; i++){
                let next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                let nextPos = next ? next.from + start : end;
                let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(rangeTo, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), "", innerHighlighters);
                    this.startSpan(Math.min(to, pos), cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            if (mounted) inheritedClass = "";
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
}
/**
Match a syntax node's [highlight rules](#highlight.styleTags). If
there's a match, return its set of tags, and whether it is
opaque (uses a `!`) or applies to all child nodes (`/...`).
*/ function $a1ec9d683d365521$export$1519d79cc79711ec(node) {
    let rule = node.type.prop($a1ec9d683d365521$var$ruleNodeProp);
    while(rule && rule.context && !node.matchContext(rule.context))rule = rule.next;
    return rule || null;
}
const $a1ec9d683d365521$var$t = $a1ec9d683d365521$export$3288d34c523a1192.define;
const $a1ec9d683d365521$var$comment = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$name = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$typeName = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name), $a1ec9d683d365521$var$propertyName = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name), $a1ec9d683d365521$var$literal = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$string = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal), $a1ec9d683d365521$var$number = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal), $a1ec9d683d365521$var$content = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$heading = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content), $a1ec9d683d365521$var$keyword = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$operator = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$punctuation = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$bracket = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$punctuation), $a1ec9d683d365521$var$meta = $a1ec9d683d365521$var$t();
/**
The default set of highlighting [tags](#highlight.Tag).

This collection is heavily biased towards programming languages,
and necessarily incomplete. A full ontology of syntactic
constructs would fill a stack of books, and be impractical to
write themes for. So try to make do with this set. If all else
fails, [open an
issue](https://github.com/codemirror/codemirror.next) to propose a
new tag, or [define](#highlight.Tag^define) a local custom tag for
your use case.

Note that it is not obligatory to always attach the most specific
tag possible to an element—if your grammar can't easily
distinguish a certain type of element (such as a local variable),
it is okay to style it as its more general variant (a variable).

For tags that extend some parent tag, the documentation links to
the parent.
*/ const $a1ec9d683d365521$export$8b7a896ae75accbf = {
    comment: /**
    A comment.
    */ $a1ec9d683d365521$var$comment,
    /**
    A line [comment](#highlight.tags.comment).
    */ lineComment: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$comment),
    /**
    A block [comment](#highlight.tags.comment).
    */ blockComment: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$comment),
    /**
    A documentation [comment](#highlight.tags.comment).
    */ docComment: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$comment),
    name: /**
    Any kind of identifier.
    */ $a1ec9d683d365521$var$name,
    /**
    The [name](#highlight.tags.name) of a variable.
    */ variableName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    A type [name](#highlight.tags.name).
    */ typeName: $a1ec9d683d365521$var$typeName,
    /**
    A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    */ tagName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$typeName),
    /**
    A property or field [name](#highlight.tags.name).
    */ propertyName: $a1ec9d683d365521$var$propertyName,
    /**
    An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    */ attributeName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$propertyName),
    /**
    The [name](#highlight.tags.name) of a class.
    */ className: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    A label [name](#highlight.tags.name).
    */ labelName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    A namespace [name](#highlight.tags.name).
    */ namespace: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    The [name](#highlight.tags.name) of a macro.
    */ macroName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    literal: /**
    A literal value.
    */ $a1ec9d683d365521$var$literal,
    string: /**
    A string [literal](#highlight.tags.literal).
    */ $a1ec9d683d365521$var$string,
    /**
    A documentation [string](#highlight.tags.string).
    */ docString: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$string),
    /**
    A character literal (subtag of [string](#highlight.tags.string)).
    */ character: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$string),
    /**
    An attribute value (subtag of [string](#highlight.tags.string)).
    */ attributeValue: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$string),
    number: /**
    A number [literal](#highlight.tags.literal).
    */ $a1ec9d683d365521$var$number,
    /**
    An integer [number](#highlight.tags.number) literal.
    */ integer: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$number),
    /**
    A floating-point [number](#highlight.tags.number) literal.
    */ float: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$number),
    /**
    A boolean [literal](#highlight.tags.literal).
    */ bool: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    Regular expression [literal](#highlight.tags.literal).
    */ regexp: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    An escape [literal](#highlight.tags.literal), for example a
    backslash escape in a string.
    */ escape: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    A color [literal](#highlight.tags.literal).
    */ color: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    A URL [literal](#highlight.tags.literal).
    */ url: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    keyword: /**
    A language keyword.
    */ $a1ec9d683d365521$var$keyword,
    /**
    The [keyword](#highlight.tags.keyword) for the self or this
    object.
    */ self: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    The [keyword](#highlight.tags.keyword) for null.
    */ null: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) denoting some atomic value.
    */ atom: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that represents a unit.
    */ unit: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A modifier [keyword](#highlight.tags.keyword).
    */ modifier: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that acts as an operator.
    */ operatorKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A control-flow related [keyword](#highlight.tags.keyword).
    */ controlKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that defines something.
    */ definitionKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) related to defining or
    interfacing with modules.
    */ moduleKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    operator: /**
    An operator.
    */ $a1ec9d683d365521$var$operator,
    /**
    An [operator](#highlight.tags.operator) that dereferences something.
    */ derefOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Arithmetic-related [operator](#highlight.tags.operator).
    */ arithmeticOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Logical [operator](#highlight.tags.operator).
    */ logicOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Bit [operator](#highlight.tags.operator).
    */ bitwiseOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Comparison [operator](#highlight.tags.operator).
    */ compareOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    [Operator](#highlight.tags.operator) that updates its operand.
    */ updateOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    [Operator](#highlight.tags.operator) that defines something.
    */ definitionOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Type-related [operator](#highlight.tags.operator).
    */ typeOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Control-flow [operator](#highlight.tags.operator).
    */ controlOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    punctuation: /**
    Program or markup punctuation.
    */ $a1ec9d683d365521$var$punctuation,
    /**
    [Punctuation](#highlight.tags.punctuation) that separates
    things.
    */ separator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$punctuation),
    bracket: /**
    Bracket-style [punctuation](#highlight.tags.punctuation).
    */ $a1ec9d683d365521$var$bracket,
    /**
    Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    tokens).
    */ angleBracket: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    /**
    Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    tokens).
    */ squareBracket: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    /**
    Parentheses (usually `(` and `)` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ paren: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    /**
    Braces (usually `{` and `}` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ brace: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    content: /**
    Content, for example plain text in XML or markup documents.
    */ $a1ec9d683d365521$var$content,
    heading: /**
    [Content](#highlight.tags.content) that represents a heading.
    */ $a1ec9d683d365521$var$heading,
    /**
    A level 1 [heading](#highlight.tags.heading).
    */ heading1: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 2 [heading](#highlight.tags.heading).
    */ heading2: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 3 [heading](#highlight.tags.heading).
    */ heading3: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 4 [heading](#highlight.tags.heading).
    */ heading4: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 5 [heading](#highlight.tags.heading).
    */ heading5: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 6 [heading](#highlight.tags.heading).
    */ heading6: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
    */ contentSeparator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that represents a list.
    */ list: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that represents a quote.
    */ quote: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is emphasized.
    */ emphasis: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is styled strong.
    */ strong: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is part of a link.
    */ link: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is styled as code or
    monospace.
    */ monospace: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that has a strike-through
    style.
    */ strikethrough: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    Inserted text in a change-tracking format.
    */ inserted: $a1ec9d683d365521$var$t(),
    /**
    Deleted text.
    */ deleted: $a1ec9d683d365521$var$t(),
    /**
    Changed text.
    */ changed: $a1ec9d683d365521$var$t(),
    /**
    An invalid or unsyntactic element.
    */ invalid: $a1ec9d683d365521$var$t(),
    meta: /**
    Metadata or meta-instruction.
    */ $a1ec9d683d365521$var$meta,
    /**
    [Metadata](#highlight.tags.meta) that applies to the entire
    document.
    */ documentMeta: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$meta),
    /**
    [Metadata](#highlight.tags.meta) that annotates or adds
    attributes to a given syntactic element.
    */ annotation: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$meta),
    /**
    Processing instruction or preprocessor directive. Subtag of
    [meta](#highlight.tags.meta).
    */ processingInstruction: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$meta),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that a
    given element is being defined. Expected to be used with the
    various [name](#highlight.tags.name) tags.
    */ definition: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("definition"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that
    something is constant. Mostly expected to be used with
    [variable names](#highlight.tags.variableName).
    */ constant: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("constant"),
    /**
    [Modifier](#highlight.Tag^defineModifier) used to indicate that
    a [variable](#highlight.tags.variableName) or [property
    name](#highlight.tags.propertyName) is being called or defined
    as a function.
    */ function: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("function"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that can be applied to
    [names](#highlight.tags.name) to indicate that they belong to
    the language's standard environment.
    */ standard: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("standard"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates a given
    [names](#highlight.tags.name) is local to some scope.
    */ local: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("local"),
    /**
    A generic variant [modifier](#highlight.Tag^defineModifier) that
    can be used to tag language-specific alternative variants of
    some common tag. It is recommended for themes to define special
    forms of at least the [string](#highlight.tags.string) and
    [variable name](#highlight.tags.variableName) tags, since those
    come up a lot.
    */ special: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier("special")
};
for(let name in $a1ec9d683d365521$export$8b7a896ae75accbf){
    let val = $a1ec9d683d365521$export$8b7a896ae75accbf[name];
    if (val instanceof $a1ec9d683d365521$export$3288d34c523a1192) val.name = name;
}
/**
This is a highlighter that adds stable, predictable classes to
tokens, for styling with external CSS.

The following tags are mapped to their name prefixed with `"tok-"`
(for example `"tok-comment"`):

* [`link`](#highlight.tags.link)
* [`heading`](#highlight.tags.heading)
* [`emphasis`](#highlight.tags.emphasis)
* [`strong`](#highlight.tags.strong)
* [`keyword`](#highlight.tags.keyword)
* [`atom`](#highlight.tags.atom)
* [`bool`](#highlight.tags.bool)
* [`url`](#highlight.tags.url)
* [`labelName`](#highlight.tags.labelName)
* [`inserted`](#highlight.tags.inserted)
* [`deleted`](#highlight.tags.deleted)
* [`literal`](#highlight.tags.literal)
* [`string`](#highlight.tags.string)
* [`number`](#highlight.tags.number)
* [`variableName`](#highlight.tags.variableName)
* [`typeName`](#highlight.tags.typeName)
* [`namespace`](#highlight.tags.namespace)
* [`className`](#highlight.tags.className)
* [`macroName`](#highlight.tags.macroName)
* [`propertyName`](#highlight.tags.propertyName)
* [`operator`](#highlight.tags.operator)
* [`comment`](#highlight.tags.comment)
* [`meta`](#highlight.tags.meta)
* [`punctuation`](#highlight.tags.punctuation)
* [`invalid`](#highlight.tags.invalid)

In addition, these mappings are provided:

* [`regexp`](#highlight.tags.regexp),
  [`escape`](#highlight.tags.escape), and
  [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
  are mapped to `"tok-string2"`
* [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName2"`
* [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-local"`
* [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-definition"`
* [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
  to `"tok-propertyName tok-definition"`
*/ const $a1ec9d683d365521$export$bf3ffb24fb17216c = $a1ec9d683d365521$export$b7f6332ce20f80fb([
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.link,
        class: "tok-link"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.heading,
        class: "tok-heading"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.strong,
        class: "tok-strong"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.keyword,
        class: "tok-keyword"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.atom,
        class: "tok-atom"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.bool,
        class: "tok-bool"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.url,
        class: "tok-url"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.labelName,
        class: "tok-labelName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.inserted,
        class: "tok-inserted"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.deleted,
        class: "tok-deleted"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.literal,
        class: "tok-literal"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.string,
        class: "tok-string"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.number,
        class: "tok-number"
    },
    {
        tag: [
            $a1ec9d683d365521$export$8b7a896ae75accbf.regexp,
            $a1ec9d683d365521$export$8b7a896ae75accbf.escape,
            $a1ec9d683d365521$export$8b7a896ae75accbf.special($a1ec9d683d365521$export$8b7a896ae75accbf.string)
        ],
        class: "tok-string2"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.variableName,
        class: "tok-variableName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.local($a1ec9d683d365521$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.definition($a1ec9d683d365521$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.special($a1ec9d683d365521$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName2"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.definition($a1ec9d683d365521$export$8b7a896ae75accbf.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.typeName,
        class: "tok-typeName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.namespace,
        class: "tok-namespace"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.className,
        class: "tok-className"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.macroName,
        class: "tok-macroName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.operator,
        class: "tok-operator"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.comment,
        class: "tok-comment"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.meta,
        class: "tok-meta"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.invalid,
        class: "tok-invalid"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.punctuation,
        class: "tok-punctuation"
    }
]);



var $a97ccac5cf5f4f5d$var$_a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ const $a97ccac5cf5f4f5d$export$27a2e78097f753f7 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function $a97ccac5cf5f4f5d$export$b57f683f43553b99(baseData) {
    return (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
Syntax node prop used to register sublanguages. Should be added to
the top level node type for the language.
*/ const $a97ccac5cf5f4f5d$export$4afc6f37514bbb67 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a {
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, extraExtensions = [], /**
    A language name.
    */ name = ""){
        this.data = data;
        this.name = name;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, $6295c6875f57e3ee$export$afa855cbfaff27f2).prototype.hasOwnProperty("tree")) Object.defineProperty((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).prototype, "tree", {
            get () {
                return $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(this);
            }
        });
        this.parser = parser;
        this.extension = [
            $a97ccac5cf5f4f5d$export$789c912f57fe164c.of(this),
            (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).languageData.of((state, pos, side)=>{
                let top = $a97ccac5cf5f4f5d$var$topNodeAt(state, pos, side), data = top.type.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7);
                if (!data) return [];
                let base = state.facet(data), sub = top.type.prop($a97ccac5cf5f4f5d$export$4afc6f37514bbb67);
                if (sub) {
                    let innerNode = top.resolve(pos - top.from, side);
                    for (let sublang of sub)if (sublang.test(innerNode, state)) {
                        let data = state.facet(sublang.facet);
                        return sublang.type == "replace" ? data : data.concat(base);
                    }
                }
                return base;
            })
        ].concat(extraExtensions);
    }
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos, side = -1) {
        return $a97ccac5cf5f4f5d$var$topNodeAt(state, pos, side).type.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        let lang = state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        let result = [];
        let explore = (tree, from)=>{
            if (tree.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == this.data) {
                result.push({
                    from: from,
                    to: from + tree.length
                });
                return;
            }
            let mount = tree.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).mounted);
            if (mount) {
                if (mount.tree.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == this.data) {
                    if (mount.overlay) for (let r of mount.overlay)result.push({
                        from: r.from + from,
                        to: r.to + from
                    });
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    let size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(let i = 0; i < tree.children.length; i++){
                let ch = tree.children[i];
                if (ch instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) explore(ch, tree.positions[i] + from);
            }
        };
        explore($a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
}
/**
@internal
*/ $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.setState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
function $a97ccac5cf5f4f5d$var$topNodeAt(state, pos, side) {
    let topLang = state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c), tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state).topNode;
    if (!topLang || topLang.allowsNesting) {
        for(let node = tree; node; node = node.enter(pos, side, (0, $ed739beecf769914$export$b0e28367f55837aa).ExcludeBuffers))if (node.type.isTop) tree = node;
    }
    return tree;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser)
parsers.
*/ class $a97ccac5cf5f4f5d$export$b243968d9fb6db03 extends $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a {
    constructor(data, parser, name){
        super(data, parser, [], name);
        this.parser = parser;
    }
    /**
    Define a language from a parser.
    */ static define(spec) {
        let data = $a97ccac5cf5f4f5d$export$b57f683f43553b99(spec.languageData);
        return new $a97ccac5cf5f4f5d$export$b243968d9fb6db03(data, spec.parser.configure({
            props: [
                $a97ccac5cf5f4f5d$export$27a2e78097f753f7.add((type)=>type.isTop ? data : undefined)
            ]
        }), spec.name);
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser and optionally a new name.
    */ configure(options, name) {
        return new $a97ccac5cf5f4f5d$export$b243968d9fb6db03(this.data, this.parser.configure(options), name || this.name);
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state) {
    let field = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state, false);
    return field ? field.tree : (0, $ed739beecf769914$export$7fbedc92909ed28e).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function $a97ccac5cf5f4f5d$export$8694796f3a52e973(state, upto, timeout = 50) {
    var _a;
    let parse = (_a = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    if (!parse) return null;
    let oldVieport = parse.viewport;
    parse.updateViewport({
        from: 0,
        to: upto
    });
    let result = parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
    parse.updateViewport(oldVieport);
    return result;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function $a97ccac5cf5f4f5d$export$2c95b013b0941e86(state, upto = state.doc.length) {
    var _a;
    return ((_a = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function $a97ccac5cf5f4f5d$export$b3bcb61c35026d72(view, upto = view.viewport.to, timeout = 100) {
    let success = $a97ccac5cf5f4f5d$export$8694796f3a52e973(view.state, upto, timeout);
    if (success != $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function $a97ccac5cf5f4f5d$export$23c0ee92d6189d3f(view) {
    var _a;
    return ((_a = view.plugin($a97ccac5cf5f4f5d$var$parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
/**
Lezer-style
[`Input`](https://lezer.codemirror.net/docs/ref#common.Input)
object for a [`Text`](https://codemirror.net/6/docs/ref/#state.Text) object.
*/ class $a97ccac5cf5f4f5d$export$78c262ab5af874ad {
    /**
    Create an input object for the given document.
    */ constructor(doc){
        this.doc = doc;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
    get length() {
        return this.doc.length;
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        let stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
}
let $a97ccac5cf5f4f5d$var$currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa {
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ fragments = [], /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa(parser, state, [], (0, $ed739beecf769914$export$7fbedc92909ed28e).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new $a97ccac5cf5f4f5d$export$78c262ab5af874ad(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, $ed739beecf769914$export$7fbedc92909ed28e).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                let endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                let done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, $ed739beecf769914$export$3ae2ede6dca97077).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        let pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, $ed739beecf769914$export$3ae2ede6dca97077).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        let prev = $a97ccac5cf5f4f5d$var$currentContext;
        $a97ccac5cf5f4f5d$var$currentContext = this;
        try {
            return f();
        } finally{
            $a97ccac5cf5f4f5d$var$currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(let r; r = this.tempSkipped.pop();)fragments = $a97ccac5cf5f4f5d$var$cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        let { fragments: fragments, tree: tree, treeLen: treeLen, viewport: viewport, skipped: skipped } = this;
        this.takeTree();
        if (!changes.empty) {
            let ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                }));
            fragments = (0, $ed739beecf769914$export$3ae2ede6dca97077).applyChanges(fragments, ranges);
            tree = (0, $ed739beecf769914$export$7fbedc92909ed28e).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                for (let r of this.skipped){
                    let from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                    if (from < to) skipped.push({
                        from: from,
                        to: to
                    });
                }
            }
        }
        return new $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        let startLen = this.skipped.length;
        for(let i = 0; i < this.skipped.length; i++){
            let { from: from, to: to } = this.skipped[i];
            if (from < viewport.to && to > viewport.from) {
                this.fragments = $a97ccac5cf5f4f5d$var$cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from: from,
            to: to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, $ed739beecf769914$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                let from = ranges[0].from, to = ranges[ranges.length - 1].to;
                let parser = {
                    parsedPos: from,
                    advance () {
                        let cx = $a97ccac5cf5f4f5d$var$currentContext;
                        if (cx) {
                            for (let r of ranges)cx.tempSkipped.push(r);
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, $ed739beecf769914$export$7fbedc92909ed28e)((0, $ed739beecf769914$export$f06e977173f1857c).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        let frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return $a97ccac5cf5f4f5d$var$currentContext;
    }
}
function $a97ccac5cf5f4f5d$var$cutFragments(fragments, from, to) {
    return (0, $ed739beecf769914$export$3ae2ede6dca97077).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class $a97ccac5cf5f4f5d$var$LanguageState {
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        let newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        let upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Work.Apply */ , upto)) newCx.takeTree();
        return new $a97ccac5cf5f4f5d$var$LanguageState(newCx);
    }
    static init(state) {
        let vpTo = Math.min(3000 /* Work.InitViewport */ , state.doc.length);
        let parseState = $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa.create(state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Work.Apply */ , vpTo)) parseState.takeTree();
        return new $a97ccac5cf5f4f5d$var$LanguageState(parseState);
    }
}
$a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create: $a97ccac5cf5f4f5d$var$LanguageState.init,
    update (value, tr) {
        for (let e of tr.effects)if (e.is($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.setState)) return e.value;
        if (tr.startState.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c) != tr.state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c)) return $a97ccac5cf5f4f5d$var$LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
let $a97ccac5cf5f4f5d$var$requestIdle = (callback)=>{
    let timeout = setTimeout(()=>callback(), 500 /* Work.MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") $a97ccac5cf5f4f5d$var$requestIdle = (callback)=>{
    let idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* Work.MinPause */ 
        });
    }, 100 /* Work.MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
const $a97ccac5cf5f4f5d$var$isInputPending = typeof navigator != "undefined" && (($a97ccac5cf5f4f5d$var$_a = navigator.scheduling) === null || $a97ccac5cf5f4f5d$var$_a === void 0 ? void 0 : $a97ccac5cf5f4f5d$var$_a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
const $a97ccac5cf5f4f5d$var$parseWorker = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class ParseWorker {
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
    update(update) {
        let cx = this.view.state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged || update.selectionSet) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* Work.ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        let { state: state } = this.view, field = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = $a97ccac5cf5f4f5d$var$requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        let now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* Work.ChunkTime */ ;
            this.chunkBudget = 3000 /* Work.ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        let { state: state, viewport: { to: vpTo } } = this.view, field = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* Work.MaxParseAhead */ )) return;
        let endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Work.Slice */ , deadline && !$a97ccac5cf5f4f5d$var$isInputPending ? Math.max(25 /* Work.MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        let done = field.context.work(()=>{
            return $a97ccac5cf5f4f5d$var$isInputPending && $a97ccac5cf5f4f5d$var$isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* Work.MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.setState.of(new $a97ccac5cf5f4f5d$var$LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state. Used
by `Language` object's `extension` property (so you don't need to
manually wrap your languages in this). Can be used to access the
current language on a state.
*/ const $a97ccac5cf5f4f5d$export$789c912f57fe164c = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: (language)=>[
            $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state,
            $a97ccac5cf5f4f5d$var$parseWorker,
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).contentAttributes.compute([
                language
            ], (state)=>{
                let lang = state.facet(language);
                return lang && lang.name ? {
                    "data-language": lang.name
                } : {};
            })
        ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ support = []){
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class $a97ccac5cf5f4f5d$export$50ab82debf88f71 {
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        let { load: load, support: support } = spec;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new $a97ccac5cf5f4f5d$export$50ab82debf88f71(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        for (let d of descs)if (d.filename && d.filename.test(filename)) return d;
        let ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            for (let d of descs)if (d.extensions.indexOf(ext[1]) > -1) return d;
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name, fuzzy = true) {
        name = name.toLowerCase();
        for (let d of descs)if (d.alias.some((a)=>a == name)) return d;
        if (fuzzy) for (let d of descs)for (let a of d.alias){
            let found = name.indexOf(a);
            if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d;
        }
        return null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth, as a column number (see
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)), at the start of a given
line. A return value of `null` indicates no indentation can be
determined, and the line should inherit the indentation of the one
above it. A return value of `undefined` defers to the next indent
service.
*/ const $a97ccac5cf5f4f5d$export$5952625dce50d1f3 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Facet for overriding the unit by which indentation happens. Should
be a string consisting entirely of the same whitespace character.
When not set, this defaults to 2 spaces.
*/ const $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        let unit = values[0];
        if (!unit || /\S/.test(unit) || Array.from(unit).some((e)=>e != unit[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return unit;
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function $a97ccac5cf5f4f5d$export$ad3205d09311a797(state) {
    let unit = state.facet($a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function $a97ccac5cf5f4f5d$export$db5a40e207b40576(state, cols) {
    let result = "", ts = state.tabSize, ch = state.facet($a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5)[0];
    if (ch == "\t") {
        while(cols >= ts){
            result += "\t";
            cols -= ts;
        }
        ch = " ";
    }
    for(let i = 0; i < cols; i++)result += ch;
    return result;
}
/**
Get the indentation, as a column number, at the given position.
Will first consult any [indent services](https://codemirror.net/6/docs/ref/#language.indentService)
that are registered, and if none of those return an indentation,
this will check the syntax tree for the [indent node
prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp) and use that if found. Returns a
number when an indentation could be determined, and null
otherwise.
*/ function $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211(context, pos) {
    if (context instanceof (0, $6295c6875f57e3ee$export$afa855cbfaff27f2)) context = new $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8(context);
    for (let service of context.state.facet($a97ccac5cf5f4f5d$export$5952625dce50d1f3)){
        let result = service(context, pos);
        if (result !== undefined) return result;
    }
    let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(context.state);
    return tree.length >= pos ? $a97ccac5cf5f4f5d$var$syntaxIndentation(context, tree, pos) : null;
}
/**
Create a change set that auto-indents all lines touched by the
given document range.
*/ function $a97ccac5cf5f4f5d$export$2fc72a4ad8b85e40(state, from, to) {
    let updated = Object.create(null);
    let context = new $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8(state, {
        overrideIndentation: (start)=>{
            var _a;
            return (_a = updated[start]) !== null && _a !== void 0 ? _a : -1;
        }
    });
    let changes = [];
    for(let pos = from; pos <= to;){
        let line = state.doc.lineAt(pos);
        pos = line.to + 1;
        let indent = $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211(context, line.from);
        if (indent == null) continue;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = $a97ccac5cf5f4f5d$export$db5a40e207b40576(state, indent);
        if (cur != norm) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    }
    return state.changes(changes);
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8 {
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ options = {}){
        this.state = state;
        this.options = options;
        this.unit = $a97ccac5cf5f4f5d$export$ad3205d09311a797(state);
    }
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos, bias = 1) {
        let line = this.state.doc.lineAt(pos);
        let { simulateBreak: simulateBreak, simulateDoubleBreak: simulateDoubleBreak } = this.options;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos, bias = 1) {
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        let { text: text, from: from } = this.lineAt(pos, bias);
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let result = this.countColumn(text, pos - from);
        let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line, pos = line.length) {
        return (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let override = this.options.overrideIndentation;
        if (override) {
            let overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number (see also
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)) or null, where null
indicates that no definitive indentation can be determined.
*/ const $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
// Compute the indentation for a given position from the syntax tree.
function $a97ccac5cf5f4f5d$var$syntaxIndentation(cx, ast, pos) {
    let stack = ast.resolveStack(pos);
    let inner = ast.resolveInner(pos, -1).resolve(pos, 0).enterUnfinishedNodesBefore(pos);
    if (inner != stack.node) {
        let add = [];
        for(let cur = inner; cur && !(cur.from < stack.node.from || cur.to > stack.node.to || cur.from == stack.node.from && cur.type == stack.node.type); cur = cur.parent)add.push(cur);
        for(let i = add.length - 1; i >= 0; i--)stack = {
            node: add[i],
            next: stack
        };
    }
    return $a97ccac5cf5f4f5d$var$indentFor(stack, cx, pos);
}
function $a97ccac5cf5f4f5d$var$indentFor(stack, cx, pos) {
    for(let cur = stack; cur; cur = cur.next){
        let strategy = $a97ccac5cf5f4f5d$var$indentStrategy(cur.node);
        if (strategy) return strategy($a97ccac5cf5f4f5d$export$8aaeb0848a33f7c3.create(cx, pos, cur));
    }
    return 0;
}
function $a97ccac5cf5f4f5d$var$ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function $a97ccac5cf5f4f5d$var$indentStrategy(tree) {
    let strategy = tree.type.prop($a97ccac5cf5f4f5d$export$72c7d4c52b3c6460);
    if (strategy) return strategy;
    let first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy))) {
        let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>$a97ccac5cf5f4f5d$var$delimitedStrategy(cx, true, 1, undefined, closed && !$a97ccac5cf5f4f5d$var$ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? $a97ccac5cf5f4f5d$var$topIndent : null;
}
function $a97ccac5cf5f4f5d$var$topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class $a97ccac5cf5f4f5d$export$8aaeb0848a33f7c3 extends $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8 {
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    @internal
    */ context){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.context = context;
    }
    /**
    The syntax tree node to which the indentation strategy
    applies.
    */ get node() {
        return this.context.node;
    }
    /**
    @internal
    */ static create(base, pos, context) {
        return new $a97ccac5cf5f4f5d$export$8aaeb0848a33f7c3(base, pos, context);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        return this.baseIndentFor(this.node);
    }
    /**
    Get the indentation for the reference line of the given node
    (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
    */ baseIndentFor(node) {
        let line = this.state.doc.lineAt(node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            let atBreak = node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if ($a97ccac5cf5f4f5d$var$isParent(atBreak, node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        return $a97ccac5cf5f4f5d$var$indentFor(this.context.next, this.base, this.pos);
    }
}
function $a97ccac5cf5f4f5d$var$isParent(parent, of) {
    for(let cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function $a97ccac5cf5f4f5d$var$bracketedAligned(context) {
    let tree = context.node;
    let openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    let sim = context.options.simulateBreak;
    let openLine = context.state.doc.lineAt(openToken.from);
    let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(let pos = openToken.to;;){
        let next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) {
            if (next.from >= lineEnd) return null;
            let space = /^ */.exec(openLine.text.slice(openToken.to - openLine.from))[0].length;
            return {
                from: openToken.from,
                to: openToken.to + space
            };
        }
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function $a97ccac5cf5f4f5d$export$60e82ea306899488({ closing: closing, align: align = true, units: units = 1 }) {
    return (context)=>$a97ccac5cf5f4f5d$var$delimitedStrategy(context, align, units, closing);
}
function $a97ccac5cf5f4f5d$var$delimitedStrategy(context, align, units, closing, closedAt) {
    let after = context.textAfter, space = after.match(/^\s*/)[0].length;
    let closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    let aligned = align ? $a97ccac5cf5f4f5d$var$bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ const $a97ccac5cf5f4f5d$export$4764c629086182f2 = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c({ except: except, units: units = 1 } = {}) {
    return (context)=>{
        let matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
const $a97ccac5cf5f4f5d$var$DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function $a97ccac5cf5f4f5d$export$9bcaf6e2125ee117() {
    return (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        let rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        let doc = tr.newDoc, { head: head } = tr.newSelection.main, line = doc.lineAt(head);
        if (head > line.from + $a97ccac5cf5f4f5d$var$DontIndentBeyond) return tr;
        let lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        let { state: state } = tr, last = -1, changes = [];
        for (let { head: head } of state.selection.ranges){
            let line = state.doc.lineAt(head);
            if (line.from == last) continue;
            last = line.from;
            let indent = $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211(state, line.from);
            if (indent == null) continue;
            let cur = /^\s*/.exec(line.text)[0];
            let norm = $a97ccac5cf5f4f5d$export$db5a40e207b40576(state, indent);
            if (cur != norm) changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
        return changes.length ? [
            tr,
            {
                changes: changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ const $a97ccac5cf5f4f5d$export$40014037e3ef64a = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ const $a97ccac5cf5f4f5d$export$9b075a85eb4377d8 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function $a97ccac5cf5f4f5d$export$48672beae16a681b(node) {
    let first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function $a97ccac5cf5f4f5d$var$syntaxFolding(state, start, end) {
    let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state);
    if (tree.length < end) return null;
    let stack = tree.resolveStack(end, 1);
    let found = null;
    for(let iter = stack; iter; iter = iter.next){
        let cur = iter.node;
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        let prop = cur.type.prop($a97ccac5cf5f4f5d$export$9b075a85eb4377d8);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !$a97ccac5cf5f4f5d$var$isUnfinished(cur))) {
            let value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function $a97ccac5cf5f4f5d$var$isUnfinished(node) {
    let ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(state, lineStart, lineEnd) {
    for (let service of state.facet($a97ccac5cf5f4f5d$export$40014037e3ef64a)){
        let result = service(state, lineStart, lineEnd);
        if (result) return result;
    }
    return $a97ccac5cf5f4f5d$var$syntaxFolding(state, lineStart, lineEnd);
}
function $a97ccac5cf5f4f5d$var$mapRange(range, mapping) {
    let from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from: from,
        to: to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ const $a97ccac5cf5f4f5d$export$a123efe007ad265 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map: $a97ccac5cf5f4f5d$var$mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ const $a97ccac5cf5f4f5d$export$bf2507dc398fc1ab = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map: $a97ccac5cf5f4f5d$var$mapRange
});
function $a97ccac5cf5f4f5d$var$selectedLines(view) {
    let lines = [];
    for (let { head: head } of view.state.selection.ranges){
        if (lines.some((l)=>l.from <= head && l.to >= head)) continue;
        lines.push(view.lineBlockAt(head));
    }
    return lines;
}
/**
The state field that stores the folded ranges (as a [decoration
set](https://codemirror.net/6/docs/ref/#view.DecorationSet)). Can be passed to
[`EditorState.toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) and
[`fromJSON`](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) to serialize the fold
state.
*/ const $a97ccac5cf5f4f5d$export$6955fe1f7c578abb = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
    },
    update (folded, tr) {
        if (tr.isUserEvent("delete")) tr.changes.iterChangedRanges((fromA, toA)=>folded = $a97ccac5cf5f4f5d$var$clearTouchedFolds(folded, fromA, toA));
        folded = folded.map(tr.changes);
        for (let e of tr.effects){
            if (e.is($a97ccac5cf5f4f5d$export$a123efe007ad265) && !$a97ccac5cf5f4f5d$var$foldExists(folded, e.value.from, e.value.to)) {
                let { preparePlaceholder: preparePlaceholder } = tr.state.facet($a97ccac5cf5f4f5d$var$foldConfig);
                let widget = !preparePlaceholder ? $a97ccac5cf5f4f5d$var$foldWidget : (0, $7beee9608540d2c3$export$10e30b733df217ea).replace({
                    widget: new $a97ccac5cf5f4f5d$var$PreparedFoldWidget(preparePlaceholder(tr.state, e.value))
                });
                folded = folded.update({
                    add: [
                        widget.range(e.value.from, e.value.to)
                    ]
                });
            } else if (e.is($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab)) folded = folded.update({
                filter: (from, to)=>e.value.from != from || e.value.to != to,
                filterFrom: e.value.from,
                filterTo: e.value.to
            });
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) folded = $a97ccac5cf5f4f5d$var$clearTouchedFolds(folded, tr.selection.main.head);
        return folded;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f),
    toJSON (folded, state) {
        let ranges = [];
        folded.between(0, state.doc.length, (from, to)=>{
            ranges.push(from, to);
        });
        return ranges;
    },
    fromJSON (value) {
        if (!Array.isArray(value) || value.length % 2) throw new RangeError("Invalid JSON for fold state");
        let ranges = [];
        for(let i = 0; i < value.length;){
            let from = value[i++], to = value[i++];
            if (typeof from != "number" || typeof to != "number") throw new RangeError("Invalid JSON for fold state");
            ranges.push($a97ccac5cf5f4f5d$var$foldWidget.range(from, to));
        }
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).set(ranges, true);
    }
});
function $a97ccac5cf5f4f5d$var$clearTouchedFolds(folded, from, to = from) {
    let touched = false;
    folded.between(from, to, (a, b)=>{
        if (a < to && b > from) touched = true;
    });
    return !touched ? folded : folded.update({
        filterFrom: from,
        filterTo: to,
        filter: (a, b)=>a >= to || b <= from
    });
}
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function $a97ccac5cf5f4f5d$export$2b3c199812391e05(state) {
    return state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) || (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
}
function $a97ccac5cf5f4f5d$var$findFold(state, from, to) {
    var _a;
    let found = null;
    (_a = state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from: from,
            to: to
        };
    });
    return found;
}
function $a97ccac5cf5f4f5d$var$foldExists(folded, from, to) {
    let found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function $a97ccac5cf5f4f5d$var$maybeEnable(state, other) {
    return state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) ? other : other.concat((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($a97ccac5cf5f4f5d$export$2c875b83a85d0f31()));
}
/**
Fold the lines that are selected, if possible.
*/ const $a97ccac5cf5f4f5d$export$52e96be2adbea02a = (view)=>{
    for (let line of $a97ccac5cf5f4f5d$var$selectedLines(view)){
        let range = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (range) {
            view.dispatch({
                effects: $a97ccac5cf5f4f5d$var$maybeEnable(view.state, [
                    $a97ccac5cf5f4f5d$export$a123efe007ad265.of(range),
                    $a97ccac5cf5f4f5d$var$announceFold(view, range)
                ])
            });
            return true;
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ const $a97ccac5cf5f4f5d$export$f4cd5e9f2c073861 = (view)=>{
    if (!view.state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false)) return false;
    let effects = [];
    for (let line of $a97ccac5cf5f4f5d$var$selectedLines(view)){
        let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded), $a97ccac5cf5f4f5d$var$announceFold(view, folded, false));
    }
    if (effects.length) view.dispatch({
        effects: effects
    });
    return effects.length > 0;
};
function $a97ccac5cf5f4f5d$var$announceFold(view, range, fold = true) {
    let lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ const $a97ccac5cf5f4f5d$export$5396d9eaf1c0ba76 = (view)=>{
    let { state: state } = view, effects = [];
    for(let pos = 0; pos < state.doc.length;){
        let line = view.lineBlockAt(pos), range = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(state, line.from, line.to);
        if (range) effects.push($a97ccac5cf5f4f5d$export$a123efe007ad265.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: $a97ccac5cf5f4f5d$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ const $a97ccac5cf5f4f5d$export$5671b24df569b27d = (view)=>{
    let field = view.state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false);
    if (!field || !field.size) return false;
    let effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of({
            from: from,
            to: to
        }));
    });
    view.dispatch({
        effects: effects
    });
    return true;
};
// Find the foldable region containing the given line, if one exists
function $a97ccac5cf5f4f5d$var$foldableContainer(view, lineBlock) {
    // Look backwards through line blocks until we find a foldable region that
    // intersects with the line
    for(let line = lineBlock;;){
        let foldableRegion = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (foldableRegion && foldableRegion.to > lineBlock.from) return foldableRegion;
        if (!line.from) return null;
        line = view.lineBlockAt(line.from - 1);
    }
}
/**
Toggle folding at cursors. Unfolds if there is an existing fold
starting in that line, tries to find a foldable range around it
otherwise.
*/ const $a97ccac5cf5f4f5d$export$b23e83f59d68c8f1 = (view)=>{
    let effects = [];
    for (let line of $a97ccac5cf5f4f5d$var$selectedLines(view)){
        let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded), $a97ccac5cf5f4f5d$var$announceFold(view, folded, false));
        else {
            let foldRange = $a97ccac5cf5f4f5d$var$foldableContainer(view, line);
            if (foldRange) effects.push($a97ccac5cf5f4f5d$export$a123efe007ad265.of(foldRange), $a97ccac5cf5f4f5d$var$announceFold(view, foldRange));
        }
    }
    if (effects.length > 0) view.dispatch({
        effects: $a97ccac5cf5f4f5d$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ const $a97ccac5cf5f4f5d$export$39c52376a8936d67 = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: $a97ccac5cf5f4f5d$export$52e96be2adbea02a
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: $a97ccac5cf5f4f5d$export$f4cd5e9f2c073861
    },
    {
        key: "Ctrl-Alt-[",
        run: $a97ccac5cf5f4f5d$export$5396d9eaf1c0ba76
    },
    {
        key: "Ctrl-Alt-]",
        run: $a97ccac5cf5f4f5d$export$5671b24df569b27d
    }
];
const $a97ccac5cf5f4f5d$var$defaultConfig = {
    placeholderDOM: null,
    preparePlaceholder: null,
    placeholderText: "\u2026"
};
const $a97ccac5cf5f4f5d$var$foldConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(values, $a97ccac5cf5f4f5d$var$defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function $a97ccac5cf5f4f5d$export$2c875b83a85d0f31(config) {
    let result = [
        $a97ccac5cf5f4f5d$export$6955fe1f7c578abb,
        $a97ccac5cf5f4f5d$var$baseTheme$1
    ];
    if (config) result.push($a97ccac5cf5f4f5d$var$foldConfig.of(config));
    return result;
}
function $a97ccac5cf5f4f5d$var$widgetToDOM(view, prepared) {
    let { state: state } = view, conf = state.facet($a97ccac5cf5f4f5d$var$foldConfig);
    let onclick = (event)=>{
        let line = view.lineBlockAt(view.posAtDOM(event.target));
        let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
        if (folded) view.dispatch({
            effects: $a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded)
        });
        event.preventDefault();
    };
    if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick, prepared);
    let element = document.createElement("span");
    element.textContent = conf.placeholderText;
    element.setAttribute("aria-label", state.phrase("folded code"));
    element.title = state.phrase("unfold");
    element.className = "cm-foldPlaceholder";
    element.onclick = onclick;
    return element;
}
const $a97ccac5cf5f4f5d$var$foldWidget = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).replace({
    widget: /*@__PURE__*/ new class extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
        toDOM(view) {
            return $a97ccac5cf5f4f5d$var$widgetToDOM(view, null);
        }
    }
});
class $a97ccac5cf5f4f5d$var$PreparedFoldWidget extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
    constructor(value){
        super();
        this.value = value;
    }
    eq(other) {
        return this.value == other.value;
    }
    toDOM(view) {
        return $a97ccac5cf5f4f5d$var$widgetToDOM(view, this.value);
    }
}
const $a97ccac5cf5f4f5d$var$foldGutterDefaults = {
    openText: "\u2304",
    closedText: "\u203A",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: ()=>false
};
class $a97ccac5cf5f4f5d$var$FoldMarker extends (0, $7beee9608540d2c3$export$591ab4c909549043) {
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        let span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function $a97ccac5cf5f4f5d$export$c4dcf64f741b6228(config = {}) {
    let fullConfig = {
        ...$a97ccac5cf5f4f5d$var$foldGutterDefaults,
        ...config
    };
    let canFold = new $a97ccac5cf5f4f5d$var$FoldMarker(fullConfig, true), canUnfold = new $a97ccac5cf5f4f5d$var$FoldMarker(fullConfig, false);
    let markers = (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c) != update.state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c) || update.startState.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) != update.state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) || $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.startState) != $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.state) || fullConfig.foldingChanged(update)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            let builder = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
            for (let line of view.viewportLineBlocks){
                let mark = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to) ? canUnfold : $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to) ? canFold : null;
                if (mark) builder.add(line.from, line.from, mark);
            }
            return builder.finish();
        }
    });
    let { domEventHandlers: domEventHandlers } = fullConfig;
    return [
        markers,
        (0, $7beee9608540d2c3$export$f2b922cb4a245974)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
            },
            initialSpacer () {
                return new $a97ccac5cf5f4f5d$var$FoldMarker(fullConfig, false);
            },
            domEventHandlers: {
                ...domEventHandlers,
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: $a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded)
                        });
                        return true;
                    }
                    let range = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: $a97ccac5cf5f4f5d$export$a123efe007ad265.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            }
        }),
        $a97ccac5cf5f4f5d$export$2c875b83a85d0f31()
    ];
}
const $a97ccac5cf5f4f5d$var$baseTheme$1 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with higlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class $a97ccac5cf5f4f5d$export$4819f093bdd5b4a {
    constructor(/**
    The tag styles used to create this highlight style.
    */ specs, options){
        this.specs = specs;
        let modSpec;
        function def(spec) {
            let cls = (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        const scopeOpt = options.scope;
        this.scope = scopeOpt instanceof $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a ? (type)=>type.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, $a1ec9d683d365521$export$b7f6332ce20f80fb)(specs.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all: all
        }).style;
        this.module = modSpec ? new (0, $afd7c6da9f842a17$export$b920c662d2efee20)(modSpec) : null;
        this.themeType = options.themeType;
    }
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new $a97ccac5cf5f4f5d$export$4819f093bdd5b4a(specs, options || {});
    }
}
const $a97ccac5cf5f4f5d$var$highlighterFacet = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $a97ccac5cf5f4f5d$var$fallbackHighlighter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function $a97ccac5cf5f4f5d$var$getHighlighters(state) {
    let main = state.facet($a97ccac5cf5f4f5d$var$highlighterFacet);
    return main.length ? main : state.facet($a97ccac5cf5f4f5d$var$fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function $a97ccac5cf5f4f5d$export$ec1b956ff3a16361(highlighter, options) {
    let ext = [
        $a97ccac5cf5f4f5d$var$treeHighlighter
    ], themeType;
    if (highlighter instanceof $a97ccac5cf5f4f5d$export$4819f093bdd5b4a) {
        if (highlighter.module) ext.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push($a97ccac5cf5f4f5d$var$fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push($a97ccac5cf5f4f5d$var$highlighterFacet.computeN([
        (0, $7beee9608540d2c3$export$eece2fccabbb77c5).darkTheme
    ], (state)=>{
        return state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push($a97ccac5cf5f4f5d$var$highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function $a97ccac5cf5f4f5d$export$8ca2b052028e8782(state, tags, scope) {
    let highlighters = $a97ccac5cf5f4f5d$var$getHighlighters(state);
    let result = null;
    if (highlighters) {
        for (let highlighter of highlighters)if (!highlighter.scope || scope && highlighter.scope(scope)) {
            let cls = highlighter.style(tags);
            if (cls) result = result ? result + " " + cls : cls;
        }
    }
    return result;
}
class $a97ccac5cf5f4f5d$var$TreeHighlighter {
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.buildDeco(view, $a97ccac5cf5f4f5d$var$getHighlighters(view.state));
        this.decoratedTo = view.viewport.to;
    }
    update(update) {
        let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.state), highlighters = $a97ccac5cf5f4f5d$var$getHighlighters(update.state);
        let styleChange = highlighters != $a97ccac5cf5f4f5d$var$getHighlighters(update.startState);
        let { viewport: viewport } = update.view, decoratedToMapped = update.changes.mapPos(this.decoratedTo, 1);
        if (tree.length < viewport.to && !styleChange && tree.type == this.tree.type && decoratedToMapped >= viewport.to) {
            this.decorations = this.decorations.map(update.changes);
            this.decoratedTo = decoratedToMapped;
        } else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
            this.decoratedTo = viewport.to;
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        let builder = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
        for (let { from: from, to: to } of view.visibleRanges)(0, $a1ec9d683d365521$export$af82b3d076119fad)(this.tree, highlighters, (from, to, style)=>{
            builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
                class: style
            })));
        }, from, to);
        return builder.finish();
    }
}
const $a97ccac5cf5f4f5d$var$treeHighlighter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).high(/*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass($a97ccac5cf5f4f5d$var$TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ const $a97ccac5cf5f4f5d$export$bb02a6818dd48320 = /*@__PURE__*/ $a97ccac5cf5f4f5d$export$4819f093bdd5b4a.define([
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta,
        color: "#404740"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).link,
        textDecoration: "underline"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).url,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).contentSeparator,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).literal,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).regexp,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).local((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
        color: "#00c"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).comment,
        color: "#940"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).invalid,
        color: "#f00"
    }
]);
const $a97ccac5cf5f4f5d$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
const $a97ccac5cf5f4f5d$var$DefaultScanDist = 10000, $a97ccac5cf5f4f5d$var$DefaultBrackets = "()[]{}";
const $a97ccac5cf5f4f5d$var$bracketMatchingConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            afterCursor: true,
            brackets: $a97ccac5cf5f4f5d$var$DefaultBrackets,
            maxScanDistance: $a97ccac5cf5f4f5d$var$DefaultScanDist,
            renderMatch: $a97ccac5cf5f4f5d$var$defaultRenderMatch
        });
    }
});
const $a97ccac5cf5f4f5d$var$matchingMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-matchingBracket"
}), $a97ccac5cf5f4f5d$var$nonmatchingMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-nonmatchingBracket"
});
function $a97ccac5cf5f4f5d$var$defaultRenderMatch(match) {
    let decorations = [];
    let mark = match.matched ? $a97ccac5cf5f4f5d$var$matchingMark : $a97ccac5cf5f4f5d$var$nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
const $a97ccac5cf5f4f5d$var$bracketMatchingState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
    },
    update (deco, tr) {
        if (!tr.docChanged && !tr.selection) return deco;
        let decorations = [];
        let config = tr.state.facet($a97ccac5cf5f4f5d$var$bracketMatchingConfig);
        for (let range of tr.state.selection.ranges){
            if (!range.empty) continue;
            let match = $a97ccac5cf5f4f5d$export$3391942603e90cda(tr.state, range.head, -1, config) || range.head > 0 && $a97ccac5cf5f4f5d$export$3391942603e90cda(tr.state, range.head - 1, 1, config) || config.afterCursor && ($a97ccac5cf5f4f5d$export$3391942603e90cda(tr.state, range.head, 1, config) || range.head < tr.state.doc.length && $a97ccac5cf5f4f5d$export$3391942603e90cda(tr.state, range.head + 1, -1, config));
            if (match) decorations = decorations.concat(config.renderMatch(match, tr.state));
        }
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).set(decorations, true);
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f)
});
const $a97ccac5cf5f4f5d$var$bracketMatchingUnique = [
    $a97ccac5cf5f4f5d$var$bracketMatchingState,
    $a97ccac5cf5f4f5d$var$baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function $a97ccac5cf5f4f5d$export$cef7edfd214be605(config = {}) {
    return [
        $a97ccac5cf5f4f5d$var$bracketMatchingConfig.of(config),
        $a97ccac5cf5f4f5d$var$bracketMatchingUnique
    ];
}
/**
When larger syntax nodes, such as HTML tags, are marked as
opening/closing, it can be a bit messy to treat the whole node as
a matchable bracket. This node prop allows you to define, for such
a node, a ‘handle’—the part of the node that is highlighted, and
that the cursor must be on to activate highlighting in the first
place.
*/ const $a97ccac5cf5f4f5d$export$ca7d74cd5b9f1011 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
function $a97ccac5cf5f4f5d$var$matchingNodes(node, dir, brackets) {
    let byProp = node.prop(dir < 0 ? (0, $ed739beecf769914$export$b8034b9bc18acd90).openedBy : (0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        let index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
function $a97ccac5cf5f4f5d$var$findHandle(node) {
    let hasHandle = node.type.prop($a97ccac5cf5f4f5d$export$ca7d74cd5b9f1011);
    return hasHandle ? hasHandle(node.node) : node;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function $a97ccac5cf5f4f5d$export$3391942603e90cda(state, pos, dir, config = {}) {
    let maxScanDistance = config.maxScanDistance || $a97ccac5cf5f4f5d$var$DefaultScanDist, brackets = config.brackets || $a97ccac5cf5f4f5d$var$DefaultBrackets;
    let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state), node = tree.resolveInner(pos, dir);
    for(let cur = node; cur; cur = cur.parent){
        let matches = $a97ccac5cf5f4f5d$var$matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) {
            let handle = $a97ccac5cf5f4f5d$var$findHandle(cur);
            if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to)) return $a97ccac5cf5f4f5d$var$matchMarkedBrackets(state, pos, dir, cur, handle, matches, brackets);
        }
    }
    return $a97ccac5cf5f4f5d$var$matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function $a97ccac5cf5f4f5d$var$matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
    let parent = token.parent, firstToken = {
        from: handle.from,
        to: handle.to
    };
    let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
            let endHandle = $a97ccac5cf5f4f5d$var$findHandle(cursor);
            return {
                start: firstToken,
                end: endHandle ? {
                    from: endHandle.from,
                    to: endHandle.to
                } : undefined,
                matched: true
            };
        } else if ($a97ccac5cf5f4f5d$var$matchingNodes(cursor.type, dir, brackets)) depth++;
        else if ($a97ccac5cf5f4f5d$var$matchingNodes(cursor.type, -dir, brackets)) {
            if (depth == 0) {
                let endHandle = $a97ccac5cf5f4f5d$var$findHandle(cursor);
                return {
                    start: firstToken,
                    end: endHandle && endHandle.from < endHandle.to ? {
                        from: endHandle.from,
                        to: endHandle.to
                    } : undefined,
                    matched: false
                };
            }
            depth--;
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function $a97ccac5cf5f4f5d$var$matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    let bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    let startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(let distance = 0; !iter.next().done && distance <= maxScanDistance;){
        let text = iter.value;
        if (dir < 0) distance += text.length;
        let basePos = pos + distance * dir;
        for(let pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos != end; pos += dir){
            let found = brackets.indexOf(text[pos]);
            if (found < 0 || tree.resolveInner(basePos + pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + pos,
                    to: basePos + pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function $a97ccac5cf5f4f5d$var$countCol(string, end, tabSize, startIndex = 0, startValue = 0) {
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    let n = startValue;
    for(let i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class $a97ccac5cf5f4f5d$export$72a09304cc8c1940 {
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit, overrideIndent){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        this.overrideIndent = overrideIndent;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        let ch = this.string.charAt(this.pos);
        let ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        let start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        let start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        let found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = $a97ccac5cf5f4f5d$var$countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        var _a;
        return (_a = this.overrideIndent) !== null && _a !== void 0 ? _a : $a97ccac5cf5f4f5d$var$countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            let cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            let substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            let match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
}
function $a97ccac5cf5f4f5d$var$fullParser(spec) {
    return {
        name: spec.name || "",
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || $a97ccac5cf5f4f5d$var$defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || $a97ccac5cf5f4f5d$var$noTokens,
        mergeTokens: spec.mergeTokens !== false
    };
}
function $a97ccac5cf5f4f5d$var$defaultCopyState(state) {
    if (typeof state != "object") return state;
    let newState = {};
    for(let prop in state){
        let val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
const $a97ccac5cf5f4f5d$var$IndentedFrom = /*@__PURE__*/ new WeakMap();
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class $a97ccac5cf5f4f5d$export$5ee3cc23916207d8 extends $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a {
    constructor(parser){
        let data = $a97ccac5cf5f4f5d$export$b57f683f43553b99(parser.languageData);
        let p = $a97ccac5cf5f4f5d$var$fullParser(parser), self;
        let impl = new class extends (0, $ed739beecf769914$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                return new $a97ccac5cf5f4f5d$var$Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [], parser.name);
        this.topNode = $a97ccac5cf5f4f5d$var$docID(data, this);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, $ed739beecf769914$export$b8034b9bc18acd90)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new $a97ccac5cf5f4f5d$var$TokenTable(p.tokenTable) : $a97ccac5cf5f4f5d$var$defaultTokenTable;
    }
    /**
    Define a stream language.
    */ static define(spec) {
        return new $a97ccac5cf5f4f5d$export$5ee3cc23916207d8(spec);
    }
    /**
    @internal
    */ getIndent(cx) {
        let from = undefined;
        let { overrideIndentation: overrideIndentation } = cx.options;
        if (overrideIndentation) {
            from = $a97ccac5cf5f4f5d$var$IndentedFrom.get(cx.state);
            if (from != null && from < cx.pos - 1e4) from = undefined;
        }
        let start = $a97ccac5cf5f4f5d$var$findState(this, cx.node.tree, cx.node.from, cx.node.from, from !== null && from !== void 0 ? from : cx.pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = cx.node.from;
        }
        if (cx.pos - statePos > 10000 /* C.MaxIndentScanDist */ ) return null;
        while(statePos < cx.pos){
            let line = cx.state.doc.lineAt(statePos), end = Math.min(cx.pos, line.to);
            if (line.length) {
                let indentation = overrideIndentation ? overrideIndentation(line.from) : -1;
                let stream = new $a97ccac5cf5f4f5d$export$72a09304cc8c1940(line.text, cx.state.tabSize, cx.unit, indentation < 0 ? undefined : indentation);
                while(stream.pos < end - line.from)$a97ccac5cf5f4f5d$var$readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == cx.pos) break;
            statePos = line.to + 1;
        }
        let line = cx.lineAt(cx.pos);
        if (overrideIndentation && from == null) $a97ccac5cf5f4f5d$var$IndentedFrom.set(cx.state, line.from);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(line.text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
}
function $a97ccac5cf5f4f5d$var$findState(lang, tree, off, startPos, before) {
    let state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(let i = tree.children.length - 1; i >= 0; i--){
        let child = tree.children[i], pos = off + tree.positions[i];
        let found = child instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e) && pos < before && $a97ccac5cf5f4f5d$var$findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function $a97ccac5cf5f4f5d$var$cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && from == 0 && tree.type == lang.topNode) inside = true;
    for(let i = tree.children.length - 1; i >= 0; i--){
        let pos = tree.positions[i], child = tree.children[i], inner;
        if (pos < to && child instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) {
            if (!(inner = $a97ccac5cf5f4f5d$var$cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, $ed739beecf769914$export$7fbedc92909ed28e)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function $a97ccac5cf5f4f5d$var$findStartInFragments(lang, fragments, startPos, endPos, editorState) {
    for (let f of fragments){
        let from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
        let found = from <= startPos && to > startPos && $a97ccac5cf5f4f5d$var$findState(lang, f.tree, 0 - f.offset, startPos, to), tree;
        if (found && found.pos <= endPos && (tree = $a97ccac5cf5f4f5d$var$cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
            state: found.state,
            tree: tree
        };
    }
    return {
        state: lang.streamParser.startState(editorState ? $a97ccac5cf5f4f5d$export$ad3205d09311a797(editorState) : 4),
        tree: (0, $ed739beecf769914$export$7fbedc92909ed28e).empty
    };
}
class $a97ccac5cf5f4f5d$var$Parse {
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        let context = $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa.get(), from = ranges[0].from;
        let { state: state, tree: tree } = $a97ccac5cf5f4f5d$var$findStartInFragments(lang, fragments, from, this.to, context === null || context === void 0 ? void 0 : context.state);
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(let i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* C.MaxDistanceBeforeViewport */  && ranges.some((r)=>r.from <= context.viewport.from && r.to >= context.viewport.from)) {
            this.state = this.lang.streamParser.startState($a97ccac5cf5f4f5d$export$ad3205d09311a797(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
    advance() {
        let context = $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa.get();
        let parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        let end = Math.min(parseEnd, this.chunkStart + 512 /* C.ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        let chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            let eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        let from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(let index = this.rangeIndex;;){
            let rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            let rangeStart = this.ranges[index].from;
            let after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line: line,
            end: end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            let end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            let start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, offset) {
        let size = 4;
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            let len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        let last = this.chunk.length - 4;
        if (this.lang.streamParser.mergeTokens && size == 4 && last >= 0 && this.chunk[last] == id && this.chunk[last + 2] == from) this.chunk[last + 2] = to;
        else this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        let { line: line, end: end } = this.nextLine(), offset = 0, { streamParser: streamParser } = this.lang;
        let stream = new $a97ccac5cf5f4f5d$export$72a09304cc8c1940(line, context ? context.state.tabSize : 4, context ? $a97ccac5cf5f4f5d$export$ad3205d09311a797(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            let token = $a97ccac5cf5f4f5d$var$readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, offset);
            if (stream.start > 10000 /* C.MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        let tree = (0, $ed739beecf769914$export$7fbedc92909ed28e).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet: $a97ccac5cf5f4f5d$var$nodeSet,
            topID: 0,
            maxBufferLength: 512 /* C.ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, $ed739beecf769914$export$7fbedc92909ed28e)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, $ed739beecf769914$export$7fbedc92909ed28e)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
}
function $a97ccac5cf5f4f5d$var$readToken(token, stream, state) {
    stream.start = stream.pos;
    for(let i = 0; i < 10; i++){
        let result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
const $a97ccac5cf5f4f5d$var$noTokens = /*@__PURE__*/ Object.create(null);
const $a97ccac5cf5f4f5d$var$typeArray = [
    (0, $ed739beecf769914$export$f06e977173f1857c).none
];
const $a97ccac5cf5f4f5d$var$nodeSet = /*@__PURE__*/ new (0, $ed739beecf769914$export$7fad5fb00d8de02c)($a97ccac5cf5f4f5d$var$typeArray);
const $a97ccac5cf5f4f5d$var$warned = [];
// Cache of node types by name and tags
const $a97ccac5cf5f4f5d$var$byTag = /*@__PURE__*/ Object.create(null);
const $a97ccac5cf5f4f5d$var$defaultTable = /*@__PURE__*/ Object.create(null);
for (let [legacyName, name] of [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
])$a97ccac5cf5f4f5d$var$defaultTable[legacyName] = /*@__PURE__*/ $a97ccac5cf5f4f5d$var$createTokenType($a97ccac5cf5f4f5d$var$noTokens, name);
class $a97ccac5cf5f4f5d$var$TokenTable {
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), $a97ccac5cf5f4f5d$var$defaultTable);
    }
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = $a97ccac5cf5f4f5d$var$createTokenType(this.extra, tag));
    }
}
const $a97ccac5cf5f4f5d$var$defaultTokenTable = /*@__PURE__*/ new $a97ccac5cf5f4f5d$var$TokenTable($a97ccac5cf5f4f5d$var$noTokens);
function $a97ccac5cf5f4f5d$var$warnForPart(part, msg) {
    if ($a97ccac5cf5f4f5d$var$warned.indexOf(part) > -1) return;
    $a97ccac5cf5f4f5d$var$warned.push(part);
    console.warn(msg);
}
function $a97ccac5cf5f4f5d$var$createTokenType(extra, tagStr) {
    let tags$1 = [];
    for (let name of tagStr.split(" ")){
        let found = [];
        for (let part of name.split(".")){
            let value = extra[part] || (0, $a1ec9d683d365521$export$8b7a896ae75accbf)[part];
            if (!value) $a97ccac5cf5f4f5d$var$warnForPart(part, `Unknown highlighting tag ${part}`);
            else if (typeof value == "function") {
                if (!found.length) $a97ccac5cf5f4f5d$var$warnForPart(part, `Modifier ${part} used at start of tag`);
                else found = found.map(value);
            } else if (found.length) $a97ccac5cf5f4f5d$var$warnForPart(part, `Tag ${part} used as modifier`);
            else found = Array.isArray(value) ? value : [
                value
            ];
        }
        for (let tag of found)tags$1.push(tag);
    }
    if (!tags$1.length) return 0;
    let name = tagStr.replace(/ /g, "_"), key = name + " " + tags$1.map((t)=>t.id);
    let known = $a97ccac5cf5f4f5d$var$byTag[key];
    if (known) return known.id;
    let type = $a97ccac5cf5f4f5d$var$byTag[key] = (0, $ed739beecf769914$export$f06e977173f1857c).define({
        id: $a97ccac5cf5f4f5d$var$typeArray.length,
        name: name,
        props: [
            (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
                [name]: tags$1
            })
        ]
    });
    $a97ccac5cf5f4f5d$var$typeArray.push(type);
    return type.id;
}
function $a97ccac5cf5f4f5d$var$docID(data, lang) {
    let type = (0, $ed739beecf769914$export$f06e977173f1857c).define({
        id: $a97ccac5cf5f4f5d$var$typeArray.length,
        name: "Document",
        props: [
            $a97ccac5cf5f4f5d$export$27a2e78097f753f7.add(()=>data),
            $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460.add(()=>(cx)=>lang.getIndent(cx))
        ],
        top: true
    });
    $a97ccac5cf5f4f5d$var$typeArray.push(type);
    return type;
}
function $a97ccac5cf5f4f5d$var$buildForLine(line) {
    return line.length <= 4096 && /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/.test(line);
}
function $a97ccac5cf5f4f5d$var$textHasRTL(text) {
    for(let i = text.iter(); !i.next().done;)if ($a97ccac5cf5f4f5d$var$buildForLine(i.value)) return true;
    return false;
}
function $a97ccac5cf5f4f5d$var$changeAddsRTL(change) {
    let added = false;
    change.iterChanges((fA, tA, fB, tB, ins)=>{
        if (!added && $a97ccac5cf5f4f5d$var$textHasRTL(ins)) added = true;
    });
    return added;
}
const $a97ccac5cf5f4f5d$var$alwaysIsolate = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
Make sure nodes
[marked](https://lezer.codemirror.net/docs/ref/#common.NodeProp^isolate)
as isolating for bidirectional text are rendered in a way that
isolates them from the surrounding text.
*/ function $a97ccac5cf5f4f5d$export$9c455d2bd760f210(options = {}) {
    let extensions = [
        $a97ccac5cf5f4f5d$var$isolateMarks
    ];
    if (options.alwaysIsolate) extensions.push($a97ccac5cf5f4f5d$var$alwaysIsolate.of(true));
    return extensions;
}
const $a97ccac5cf5f4f5d$var$isolateMarks = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.always = view.state.facet($a97ccac5cf5f4f5d$var$alwaysIsolate) || view.textDirection != (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR || view.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).perLineTextDirection);
        this.hasRTL = !this.always && $a97ccac5cf5f4f5d$var$textHasRTL(view.state.doc);
        this.tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.always || this.hasRTL ? $a97ccac5cf5f4f5d$var$buildDeco(view, this.tree, this.always) : (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
    }
    update(update) {
        let always = update.state.facet($a97ccac5cf5f4f5d$var$alwaysIsolate) || update.view.textDirection != (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR || update.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).perLineTextDirection);
        if (!always && !this.hasRTL && $a97ccac5cf5f4f5d$var$changeAddsRTL(update.changes)) this.hasRTL = true;
        if (!always && !this.hasRTL) return;
        let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.state);
        if (always != this.always || tree != this.tree || update.docChanged || update.viewportChanged) {
            this.tree = tree;
            this.always = always;
            this.decorations = $a97ccac5cf5f4f5d$var$buildDeco(update.view, tree, always);
        }
    }
}, {
    provide: (plugin)=>{
        function access(view) {
            var _a, _b;
            return (_b = (_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.decorations) !== null && _b !== void 0 ? _b : (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        }
        return [
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).outerDecorations.of(access),
            (0, $6295c6875f57e3ee$export$b92464a736444411).lowest((0, $7beee9608540d2c3$export$eece2fccabbb77c5).bidiIsolatedRanges.of(access))
        ];
    }
});
function $a97ccac5cf5f4f5d$var$buildDeco(view, tree, always) {
    let deco = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
    let ranges = view.visibleRanges;
    if (!always) ranges = $a97ccac5cf5f4f5d$var$clipRTLLines(ranges, view.state.doc);
    for (let { from: from, to: to } of ranges)tree.iterate({
        enter: (node)=>{
            let iso = node.type.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).isolate);
            if (iso) deco.add(node.from, node.to, $a97ccac5cf5f4f5d$var$marks[iso]);
        },
        from: from,
        to: to
    });
    return deco.finish();
}
function $a97ccac5cf5f4f5d$var$clipRTLLines(ranges, doc) {
    let cur = doc.iter(), pos = 0, result = [], last = null;
    for (let { from: from, to: to } of ranges){
        if (last && last.to > from) {
            from = last.to;
            if (from >= to) continue;
        }
        if (pos + cur.value.length < from) {
            cur.next(from - (pos + cur.value.length));
            pos = from;
        }
        for(;;){
            let start = pos, end = pos + cur.value.length;
            if (!cur.lineBreak && $a97ccac5cf5f4f5d$var$buildForLine(cur.value)) {
                if (last && last.to > start - 10) last.to = Math.min(to, end);
                else result.push(last = {
                    from: start,
                    to: Math.min(to, end)
                });
            }
            if (end >= to) break;
            pos = end;
            cur.next();
        }
    }
    return result;
}
const $a97ccac5cf5f4f5d$var$marks = {
    rtl: /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "rtl"
        },
        bidiIsolate: (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).RTL
    }),
    ltr: /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "ltr"
        },
        bidiIsolate: (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR
    }),
    auto: /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "auto"
        },
        bidiIsolate: null
    })
};


/**
An instance of this is passed to completion source functions.
*/ class $7570a9a1a9679713$export$7b73e80391102dce {
    /**
    Create a new completion context. (Mostly useful for testing
    completion sources—in the editor, the extension will create
    these for you.)
    */ constructor(/**
    The editor state that the completion happens in.
    */ state, /**
    The position at which the completion is happening.
    */ pos, /**
    Indicates whether completion was activated explicitly, or
    implicitly by typing. The usual way to respond to this is to
    only return completions when either there is part of a
    completable entity before the cursor, or `explicit` is true.
    */ explicit, /**
    The editor view. May be undefined if the context was created
    in a situation where there is no such view available, such as
    in synchronous updates via
    [`CompletionResult.update`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.update)
    or when called by test code.
    */ view){
        this.state = state;
        this.pos = pos;
        this.explicit = explicit;
        this.view = view;
        /**
        @internal
        */ this.abortListeners = [];
        /**
        @internal
        */ this.abortOnDocChange = false;
    }
    /**
    Get the extent, content, and (if there is a token) type of the
    token before `this.pos`.
    */ tokenBefore(types) {
        let token = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(this.state).resolveInner(this.pos, -1);
        while(token && types.indexOf(token.name) < 0)token = token.parent;
        return token ? {
            from: token.from,
            to: this.pos,
            text: this.state.sliceDoc(token.from, this.pos),
            type: token.type
        } : null;
    }
    /**
    Get the match of the given expression directly before the
    cursor.
    */ matchBefore(expr) {
        let line = this.state.doc.lineAt(this.pos);
        let start = Math.max(line.from, this.pos - 250);
        let str = line.text.slice(start - line.from, this.pos - line.from);
        let found = str.search($7570a9a1a9679713$var$ensureAnchor(expr, false));
        return found < 0 ? null : {
            from: start + found,
            to: this.pos,
            text: str.slice(found)
        };
    }
    /**
    Yields true when the query has been aborted. Can be useful in
    asynchronous queries to avoid doing work that will be ignored.
    */ get aborted() {
        return this.abortListeners == null;
    }
    /**
    Allows you to register abort handlers, which will be called when
    the query is
    [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
    
    By default, running queries will not be aborted for regular
    typing or backspacing, on the assumption that they are likely to
    return a result with a
    [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
    allows the result to be used after all. Passing `onDocChange:
    true` will cause this query to be aborted for any document
    change.
    */ addEventListener(type, listener, options) {
        if (type == "abort" && this.abortListeners) {
            this.abortListeners.push(listener);
            if (options && options.onDocChange) this.abortOnDocChange = true;
        }
    }
}
function $7570a9a1a9679713$var$toSet(chars) {
    let flat = Object.keys(chars).join("");
    let words = /\w/.test(flat);
    if (words) flat = flat.replace(/\w/g, "");
    return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function $7570a9a1a9679713$var$prefixMatch(options) {
    let first = Object.create(null), rest = Object.create(null);
    for (let { label: label } of options){
        first[label[0]] = true;
        for(let i = 1; i < label.length; i++)rest[label[i]] = true;
    }
    let source = $7570a9a1a9679713$var$toSet(first) + $7570a9a1a9679713$var$toSet(rest) + "*$";
    return [
        new RegExp("^" + source),
        new RegExp(source)
    ];
}
/**
Given a a fixed array of options, return an autocompleter that
completes them.
*/ function $7570a9a1a9679713$export$db0ee7d2648a0c4b(list) {
    let options = list.map((o)=>typeof o == "string" ? {
            label: o
        } : o);
    let [validFor, match] = options.every((o)=>/^\w+$/.test(o.label)) ? [
        /\w*$/,
        /\w+$/
    ] : $7570a9a1a9679713$var$prefixMatch(options);
    return (context)=>{
        let token = context.matchBefore(match);
        return token || context.explicit ? {
            from: token ? token.from : context.pos,
            options: options,
            validFor: validFor
        } : null;
    };
}
/**
Wrap the given completion source so that it will only fire when the
cursor is in a syntax node with one of the given names.
*/ function $7570a9a1a9679713$export$498fe7f50ed891b8(nodes, source) {
    return (context)=>{
        for(let pos = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return source(context);
            if (pos.type.isTop) break;
        }
        return null;
    };
}
/**
Wrap the given completion source so that it will not fire when the
cursor is in a syntax node with one of the given names.
*/ function $7570a9a1a9679713$export$1dfdaeb1e91714c0(nodes, source) {
    return (context)=>{
        for(let pos = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return null;
            if (pos.type.isTop) break;
        }
        return source(context);
    };
}
class $7570a9a1a9679713$var$Option {
    constructor(completion, source, match, score){
        this.completion = completion;
        this.source = source;
        this.match = match;
        this.score = score;
    }
}
function $7570a9a1a9679713$var$cur(state) {
    return state.selection.main.from;
}
// Make sure the given regexp has a $ at its end and, if `start` is
// true, a ^ at its start.
function $7570a9a1a9679713$var$ensureAnchor(expr, start) {
    var _a;
    let { source: source } = expr;
    let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
    if (!addStart && !addEnd) return expr;
    return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a = expr.flags) !== null && _a !== void 0 ? _a : expr.ignoreCase ? "i" : "");
}
/**
This annotation is added to transactions that are produced by
picking a completion.
*/ const $7570a9a1a9679713$export$6c84d44c1ceeb831 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
/**
Helper function that returns a transaction spec which inserts a
completion's text in the main selection range, and any other
selection range that has the same text in front of it.
*/ function $7570a9a1a9679713$export$496ff43229d73eba(state, text, from, to) {
    let { main: main } = state.selection, fromOff = from - main.from, toOff = to - main.from;
    return {
        ...state.changeByRange((range)=>{
            if (range != main && from != to && state.sliceDoc(range.from + fromOff, range.from + toOff) != state.sliceDoc(from, to)) return {
                range: range
            };
            let lines = state.toText(text);
            return {
                changes: {
                    from: range.from + fromOff,
                    to: to == main.from ? range.to : range.from + toOff,
                    insert: lines
                },
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + fromOff + lines.length)
            };
        }),
        scrollIntoView: true,
        userEvent: "input.complete"
    };
}
const $7570a9a1a9679713$var$SourceCache = /*@__PURE__*/ new WeakMap();
function $7570a9a1a9679713$var$asSource(source) {
    if (!Array.isArray(source)) return source;
    let known = $7570a9a1a9679713$var$SourceCache.get(source);
    if (!known) $7570a9a1a9679713$var$SourceCache.set(source, known = $7570a9a1a9679713$export$db0ee7d2648a0c4b(source));
    return known;
}
const $7570a9a1a9679713$var$startCompletionEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7570a9a1a9679713$var$closeCompletionEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
// A pattern matcher for fuzzy completion matching. Create an instance
// once for a pattern, and then use that to match any number of
// completions.
class $7570a9a1a9679713$var$FuzzyMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.chars = [];
        this.folded = [];
        // Buffers reused by calls to `match` to track matched character
        // positions.
        this.any = [];
        this.precise = [];
        this.byWord = [];
        this.score = 0;
        this.matched = [];
        for(let p = 0; p < pattern.length;){
            let char = (0, $6295c6875f57e3ee$export$42977f40461e1360)(pattern, p), size = (0, $6295c6875f57e3ee$export$a870abf234f6353c)(char);
            this.chars.push(char);
            let part = pattern.slice(p, p + size), upper = part.toUpperCase();
            this.folded.push((0, $6295c6875f57e3ee$export$42977f40461e1360)(upper == part ? part.toLowerCase() : upper, 0));
            p += size;
        }
        this.astral = pattern.length != this.chars.length;
    }
    ret(score, matched) {
        this.score = score;
        this.matched = matched;
        return this;
    }
    // Matches a given word (completion) against the pattern (input).
    // Will return a boolean indicating whether there was a match and,
    // on success, set `this.score` to the score, `this.matched` to an
    // array of `from, to` pairs indicating the matched parts of `word`.
    //
    // The score is a number that is more negative the worse the match
    // is. See `Penalty` above.
    match(word) {
        if (this.pattern.length == 0) return this.ret(-100 /* Penalty.NotFull */ , []);
        if (word.length < this.pattern.length) return null;
        let { chars: chars, folded: folded, any: any, precise: precise, byWord: byWord } = this;
        // For single-character queries, only match when they occur right
        // at the start
        if (chars.length == 1) {
            let first = (0, $6295c6875f57e3ee$export$42977f40461e1360)(word, 0), firstSize = (0, $6295c6875f57e3ee$export$a870abf234f6353c)(first);
            let score = firstSize == word.length ? 0 : -100 /* Penalty.NotFull */ ;
            if (first == chars[0]) ;
            else if (first == folded[0]) score += -200 /* Penalty.CaseFold */ ;
            else return null;
            return this.ret(score, [
                0,
                firstSize
            ]);
        }
        let direct = word.indexOf(this.pattern);
        if (direct == 0) return this.ret(word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ , [
            0,
            this.pattern.length
        ]);
        let len = chars.length, anyTo = 0;
        if (direct < 0) {
            for(let i = 0, e = Math.min(word.length, 200); i < e && anyTo < len;){
                let next = (0, $6295c6875f57e3ee$export$42977f40461e1360)(word, i);
                if (next == chars[anyTo] || next == folded[anyTo]) any[anyTo++] = i;
                i += (0, $6295c6875f57e3ee$export$a870abf234f6353c)(next);
            }
            // No match, exit immediately
            if (anyTo < len) return null;
        }
        // This tracks the extent of the precise (non-folded, not
        // necessarily adjacent) match
        let preciseTo = 0;
        // Tracks whether there is a match that hits only characters that
        // appear to be starting words. `byWordFolded` is set to true when
        // a case folded character is encountered in such a match
        let byWordTo = 0, byWordFolded = false;
        // If we've found a partial adjacent match, these track its state
        let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
        let hasLower = /[a-z]/.test(word), wordAdjacent = true;
        // Go over the option's text, scanning for the various kinds of matches
        for(let i = 0, e = Math.min(word.length, 200), prevType = 0 /* Tp.NonWord */ ; i < e && byWordTo < len;){
            let next = (0, $6295c6875f57e3ee$export$42977f40461e1360)(word, i);
            if (direct < 0) {
                if (preciseTo < len && next == chars[preciseTo]) precise[preciseTo++] = i;
                if (adjacentTo < len) {
                    if (next == chars[adjacentTo] || next == folded[adjacentTo]) {
                        if (adjacentTo == 0) adjacentStart = i;
                        adjacentEnd = i + 1;
                        adjacentTo++;
                    } else adjacentTo = 0;
                }
            }
            let ch, type = next < 0xff ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 /* Tp.Lower */  : next >= 65 && next <= 90 ? 1 /* Tp.Upper */  : 0 /* Tp.NonWord */  : (ch = (0, $6295c6875f57e3ee$export$73bfc63873071f74)(next)) != ch.toLowerCase() ? 1 /* Tp.Upper */  : ch != ch.toUpperCase() ? 2 /* Tp.Lower */  : 0 /* Tp.NonWord */ ;
            if (!i || type == 1 /* Tp.Upper */  && hasLower || prevType == 0 /* Tp.NonWord */  && type != 0 /* Tp.NonWord */ ) {
                if (chars[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true)) byWord[byWordTo++] = i;
                else if (byWord.length) wordAdjacent = false;
            }
            prevType = type;
            i += (0, $6295c6875f57e3ee$export$a870abf234f6353c)(next);
        }
        if (byWordTo == len && byWord[0] == 0 && wordAdjacent) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0), byWord, word);
        if (adjacentTo == len && adjacentStart == 0) return this.ret(-200 /* Penalty.CaseFold */  - word.length + (adjacentEnd == word.length ? 0 : -100 /* Penalty.NotFull */ ), [
            0,
            adjacentEnd
        ]);
        if (direct > -1) return this.ret(-700 /* Penalty.NotStart */  - word.length, [
            direct,
            direct + this.pattern.length
        ]);
        if (adjacentTo == len) return this.ret(-900 /* Penalty.NotStart */  - word.length, [
            adjacentStart,
            adjacentEnd
        ]);
        if (byWordTo == len) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0) + -700 /* Penalty.NotStart */  + (wordAdjacent ? 0 : -1100 /* Penalty.Gap */ ), byWord, word);
        return chars.length == 2 ? null : this.result((any[0] ? -700 /* Penalty.NotStart */  : 0) + -200 /* Penalty.CaseFold */  + -1100 /* Penalty.Gap */ , any, word);
    }
    result(score, positions, word) {
        let result = [], i = 0;
        for (let pos of positions){
            let to = pos + (this.astral ? (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(word, pos)) : 1);
            if (i && result[i - 1] == pos) result[i - 1] = to;
            else {
                result[i++] = pos;
                result[i++] = to;
            }
        }
        return this.ret(score - word.length, result);
    }
}
class $7570a9a1a9679713$var$StrictMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.matched = [];
        this.score = 0;
        this.folded = pattern.toLowerCase();
    }
    match(word) {
        if (word.length < this.pattern.length) return null;
        let start = word.slice(0, this.pattern.length);
        let match = start == this.pattern ? 0 : start.toLowerCase() == this.folded ? -200 /* Penalty.CaseFold */  : null;
        if (match == null) return null;
        this.matched = [
            0,
            start.length
        ];
        this.score = match + (word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ );
        return this;
    }
}
const $7570a9a1a9679713$var$completionConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            activateOnTyping: true,
            activateOnCompletion: ()=>false,
            activateOnTypingDelay: 100,
            selectOnOpen: true,
            override: null,
            closeOnBlur: true,
            maxRenderedOptions: 100,
            defaultKeymap: true,
            tooltipClass: ()=>"",
            optionClass: ()=>"",
            aboveCursor: false,
            icons: true,
            addToOptions: [],
            positionInfo: $7570a9a1a9679713$var$defaultPositionInfo,
            filterStrict: false,
            compareCompletions: (a, b)=>(a.sortText || a.label).localeCompare(b.sortText || b.label),
            interactionDelay: 75,
            updateSyncTime: 100
        }, {
            defaultKeymap: (a, b)=>a && b,
            closeOnBlur: (a, b)=>a && b,
            icons: (a, b)=>a && b,
            tooltipClass: (a, b)=>(c)=>$7570a9a1a9679713$var$joinClass(a(c), b(c)),
            optionClass: (a, b)=>(c)=>$7570a9a1a9679713$var$joinClass(a(c), b(c)),
            addToOptions: (a, b)=>a.concat(b),
            filterStrict: (a, b)=>a || b
        });
    }
});
function $7570a9a1a9679713$var$joinClass(a, b) {
    return a ? b ? a + " " + b : a : b;
}
function $7570a9a1a9679713$var$defaultPositionInfo(view, list, option, info, space, tooltip) {
    let rtl = view.textDirection == (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).RTL, left = rtl, narrow = false;
    let side = "top", offset, maxWidth;
    let spaceLeft = list.left - space.left, spaceRight = space.right - list.right;
    let infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
    if (left && spaceLeft < Math.min(infoWidth, spaceRight)) left = false;
    else if (!left && spaceRight < Math.min(infoWidth, spaceLeft)) left = true;
    if (infoWidth <= (left ? spaceLeft : spaceRight)) {
        offset = Math.max(space.top, Math.min(option.top, space.bottom - infoHeight)) - list.top;
        maxWidth = Math.min(400 /* Info.Width */ , left ? spaceLeft : spaceRight);
    } else {
        narrow = true;
        maxWidth = Math.min(400 /* Info.Width */ , (rtl ? list.right : space.right - list.left) - 30 /* Info.Margin */ );
        let spaceBelow = space.bottom - list.bottom;
        if (spaceBelow >= infoHeight || spaceBelow > list.top) offset = option.bottom - list.top;
        else {
            side = "bottom";
            offset = list.bottom - option.top;
        }
    }
    let scaleY = (list.bottom - list.top) / tooltip.offsetHeight;
    let scaleX = (list.right - list.left) / tooltip.offsetWidth;
    return {
        style: `${side}: ${offset / scaleY}px; max-width: ${maxWidth / scaleX}px`,
        class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
    };
}
function $7570a9a1a9679713$var$optionContent(config) {
    let content = config.addToOptions.slice();
    if (config.icons) content.push({
        render (completion) {
            let icon = document.createElement("div");
            icon.classList.add("cm-completionIcon");
            if (completion.type) icon.classList.add(...completion.type.split(/\s+/g).map((cls)=>"cm-completionIcon-" + cls));
            icon.setAttribute("aria-hidden", "true");
            return icon;
        },
        position: 20
    });
    content.push({
        render (completion, _s, _v, match) {
            let labelElt = document.createElement("span");
            labelElt.className = "cm-completionLabel";
            let label = completion.displayLabel || completion.label, off = 0;
            for(let j = 0; j < match.length;){
                let from = match[j++], to = match[j++];
                if (from > off) labelElt.appendChild(document.createTextNode(label.slice(off, from)));
                let span = labelElt.appendChild(document.createElement("span"));
                span.appendChild(document.createTextNode(label.slice(from, to)));
                span.className = "cm-completionMatchedText";
                off = to;
            }
            if (off < label.length) labelElt.appendChild(document.createTextNode(label.slice(off)));
            return labelElt;
        },
        position: 50
    }, {
        render (completion) {
            if (!completion.detail) return null;
            let detailElt = document.createElement("span");
            detailElt.className = "cm-completionDetail";
            detailElt.textContent = completion.detail;
            return detailElt;
        },
        position: 80
    });
    return content.sort((a, b)=>a.position - b.position).map((a)=>a.render);
}
function $7570a9a1a9679713$var$rangeAroundSelected(total, selected, max) {
    if (total <= max) return {
        from: 0,
        to: total
    };
    if (selected < 0) selected = 0;
    if (selected <= total >> 1) {
        let off = Math.floor(selected / max);
        return {
            from: off * max,
            to: (off + 1) * max
        };
    }
    let off = Math.floor((total - selected) / max);
    return {
        from: total - (off + 1) * max,
        to: total - off * max
    };
}
class $7570a9a1a9679713$var$CompletionTooltip {
    constructor(view, stateField, applyCompletion){
        this.view = view;
        this.stateField = stateField;
        this.applyCompletion = applyCompletion;
        this.info = null;
        this.infoDestroy = null;
        this.placeInfoReq = {
            read: ()=>this.measureInfo(),
            write: (pos)=>this.placeInfo(pos),
            key: this
        };
        this.space = null;
        this.currentClass = "";
        let cState = view.state.field(stateField);
        let { options: options, selected: selected } = cState.open;
        let config = view.state.facet($7570a9a1a9679713$var$completionConfig);
        this.optionContent = $7570a9a1a9679713$var$optionContent(config);
        this.optionClass = config.optionClass;
        this.tooltipClass = config.tooltipClass;
        this.range = $7570a9a1a9679713$var$rangeAroundSelected(options.length, selected, config.maxRenderedOptions);
        this.dom = document.createElement("div");
        this.dom.className = "cm-tooltip-autocomplete";
        this.updateTooltipClass(view.state);
        this.dom.addEventListener("mousedown", (e)=>{
            let { options: options } = view.state.field(stateField).open;
            for(let dom = e.target, match; dom && dom != this.dom; dom = dom.parentNode)if (dom.nodeName == "LI" && (match = /-(\d+)$/.exec(dom.id)) && +match[1] < options.length) {
                this.applyCompletion(view, options[+match[1]]);
                e.preventDefault();
                return;
            }
        });
        this.dom.addEventListener("focusout", (e)=>{
            let state = view.state.field(this.stateField, false);
            if (state && state.tooltip && view.state.facet($7570a9a1a9679713$var$completionConfig).closeOnBlur && e.relatedTarget != view.contentDOM) view.dispatch({
                effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
            });
        });
        this.showOptions(options, cState.id);
    }
    mount() {
        this.updateSel();
    }
    showOptions(options, id) {
        if (this.list) this.list.remove();
        this.list = this.dom.appendChild(this.createListBox(options, id, this.range));
        this.list.addEventListener("scroll", ()=>{
            if (this.info) this.view.requestMeasure(this.placeInfoReq);
        });
    }
    update(update) {
        var _a;
        let cState = update.state.field(this.stateField);
        let prevState = update.startState.field(this.stateField);
        this.updateTooltipClass(update.state);
        if (cState != prevState) {
            let { options: options, selected: selected, disabled: disabled } = cState.open;
            if (!prevState.open || prevState.open.options != options) {
                this.range = $7570a9a1a9679713$var$rangeAroundSelected(options.length, selected, update.state.facet($7570a9a1a9679713$var$completionConfig).maxRenderedOptions);
                this.showOptions(options, cState.id);
            }
            this.updateSel();
            if (disabled != ((_a = prevState.open) === null || _a === void 0 ? void 0 : _a.disabled)) this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!disabled);
        }
    }
    updateTooltipClass(state) {
        let cls = this.tooltipClass(state);
        if (cls != this.currentClass) {
            for (let c of this.currentClass.split(" "))if (c) this.dom.classList.remove(c);
            for (let c of cls.split(" "))if (c) this.dom.classList.add(c);
            this.currentClass = cls;
        }
    }
    positioned(space) {
        this.space = space;
        if (this.info) this.view.requestMeasure(this.placeInfoReq);
    }
    updateSel() {
        let cState = this.view.state.field(this.stateField), open = cState.open;
        if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
            this.range = $7570a9a1a9679713$var$rangeAroundSelected(open.options.length, open.selected, this.view.state.facet($7570a9a1a9679713$var$completionConfig).maxRenderedOptions);
            this.showOptions(open.options, cState.id);
        }
        let newSel = this.updateSelectedOption(open.selected);
        if (newSel) {
            this.destroyInfo();
            let { completion: completion } = open.options[open.selected];
            let { info: info } = completion;
            if (!info) return;
            let infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
            if (!infoResult) return;
            if ("then" in infoResult) infoResult.then((obj)=>{
                if (obj && this.view.state.field(this.stateField, false) == cState) this.addInfoPane(obj, completion);
            }).catch((e)=>(0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, e, "completion info"));
            else {
                this.addInfoPane(infoResult, completion);
                newSel.setAttribute("aria-describedby", this.info.id);
            }
        }
    }
    addInfoPane(content, completion) {
        this.destroyInfo();
        let wrap = this.info = document.createElement("div");
        wrap.className = "cm-tooltip cm-completionInfo";
        wrap.id = "cm-completionInfo-" + Math.floor(Math.random() * 0xffff).toString(16);
        if (content.nodeType != null) {
            wrap.appendChild(content);
            this.infoDestroy = null;
        } else {
            let { dom: dom, destroy: destroy } = content;
            wrap.appendChild(dom);
            this.infoDestroy = destroy || null;
        }
        this.dom.appendChild(wrap);
        this.view.requestMeasure(this.placeInfoReq);
    }
    updateSelectedOption(selected) {
        let set = null;
        for(let opt = this.list.firstChild, i = this.range.from; opt; opt = opt.nextSibling, i++){
            if (opt.nodeName != "LI" || !opt.id) i--; // A section header
            else if (i == selected) {
                if (!opt.hasAttribute("aria-selected")) {
                    opt.setAttribute("aria-selected", "true");
                    set = opt;
                }
            } else if (opt.hasAttribute("aria-selected")) {
                opt.removeAttribute("aria-selected");
                opt.removeAttribute("aria-describedby");
            }
        }
        if (set) $7570a9a1a9679713$var$scrollIntoView(this.list, set);
        return set;
    }
    measureInfo() {
        let sel = this.dom.querySelector("[aria-selected]");
        if (!sel || !this.info) return null;
        let listRect = this.dom.getBoundingClientRect();
        let infoRect = this.info.getBoundingClientRect();
        let selRect = sel.getBoundingClientRect();
        let space = this.space;
        if (!space) {
            let docElt = this.dom.ownerDocument.documentElement;
            space = {
                left: 0,
                top: 0,
                right: docElt.clientWidth,
                bottom: docElt.clientHeight
            };
        }
        if (selRect.top > Math.min(space.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space.top, listRect.top) + 10) return null;
        return this.view.state.facet($7570a9a1a9679713$var$completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space, this.dom);
    }
    placeInfo(pos) {
        if (this.info) {
            if (pos) {
                if (pos.style) this.info.style.cssText = pos.style;
                this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
            } else this.info.style.cssText = "top: -1e6px";
        }
    }
    createListBox(options, id, range) {
        const ul = document.createElement("ul");
        ul.id = id;
        ul.setAttribute("role", "listbox");
        ul.setAttribute("aria-expanded", "true");
        ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
        ul.addEventListener("mousedown", (e)=>{
            // Prevent focus change when clicking the scrollbar
            if (e.target == ul) e.preventDefault();
        });
        let curSection = null;
        for(let i = range.from; i < range.to; i++){
            let { completion: completion, match: match } = options[i], { section: section } = completion;
            if (section) {
                let name = typeof section == "string" ? section : section.name;
                if (name != curSection && (i > range.from || range.from == 0)) {
                    curSection = name;
                    if (typeof section != "string" && section.header) ul.appendChild(section.header(section));
                    else {
                        let header = ul.appendChild(document.createElement("completion-section"));
                        header.textContent = name;
                    }
                }
            }
            const li = ul.appendChild(document.createElement("li"));
            li.id = id + "-" + i;
            li.setAttribute("role", "option");
            let cls = this.optionClass(completion);
            if (cls) li.className = cls;
            for (let source of this.optionContent){
                let node = source(completion, this.view.state, this.view, match);
                if (node) li.appendChild(node);
            }
        }
        if (range.from) ul.classList.add("cm-completionListIncompleteTop");
        if (range.to < options.length) ul.classList.add("cm-completionListIncompleteBottom");
        return ul;
    }
    destroyInfo() {
        if (this.info) {
            if (this.infoDestroy) this.infoDestroy();
            this.info.remove();
            this.info = null;
        }
    }
    destroy() {
        this.destroyInfo();
    }
}
function $7570a9a1a9679713$var$completionTooltip(stateField, applyCompletion) {
    return (view)=>new $7570a9a1a9679713$var$CompletionTooltip(view, stateField, applyCompletion);
}
function $7570a9a1a9679713$var$scrollIntoView(container, element) {
    let parent = container.getBoundingClientRect();
    let self = element.getBoundingClientRect();
    let scaleY = parent.height / container.offsetHeight;
    if (self.top < parent.top) container.scrollTop -= (parent.top - self.top) / scaleY;
    else if (self.bottom > parent.bottom) container.scrollTop += (self.bottom - parent.bottom) / scaleY;
}
// Used to pick a preferred option when two options with the same
// label occur in the result.
function $7570a9a1a9679713$var$score(option) {
    return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function $7570a9a1a9679713$var$sortOptions(active, state) {
    let options = [];
    let sections = null, dynamicSectionScore = null;
    let addOption = (option)=>{
        options.push(option);
        let { section: section } = option.completion;
        if (section) {
            if (!sections) sections = [];
            let name = typeof section == "string" ? section : section.name;
            if (!sections.some((s)=>s.name == name)) sections.push(typeof section == "string" ? {
                name: name
            } : section);
        }
    };
    let conf = state.facet($7570a9a1a9679713$var$completionConfig);
    for (let a of active)if (a.hasResult()) {
        let getMatch = a.result.getMatch;
        if (a.result.filter === false) for (let option of a.result.options)addOption(new $7570a9a1a9679713$var$Option(option, a.source, getMatch ? getMatch(option) : [], 1e9 - options.length));
        else {
            let pattern = state.sliceDoc(a.from, a.to), match;
            let matcher = conf.filterStrict ? new $7570a9a1a9679713$var$StrictMatcher(pattern) : new $7570a9a1a9679713$var$FuzzyMatcher(pattern);
            for (let option of a.result.options)if (match = matcher.match(option.label)) {
                let matched = !option.displayLabel ? match.matched : getMatch ? getMatch(option, match.matched) : [];
                let score = match.score + (option.boost || 0);
                addOption(new $7570a9a1a9679713$var$Option(option, a.source, matched, score));
                if (typeof option.section == "object" && option.section.rank === "dynamic") {
                    let { name: name } = option.section;
                    if (!dynamicSectionScore) dynamicSectionScore = Object.create(null);
                    dynamicSectionScore[name] = Math.max(score, dynamicSectionScore[name] || -1000000000);
                }
            }
        }
    }
    if (sections) {
        let sectionOrder = Object.create(null), pos = 0;
        let cmp = (a, b)=>{
            return (a.rank === "dynamic" && b.rank === "dynamic" ? dynamicSectionScore[b.name] - dynamicSectionScore[a.name] : 0) || (typeof a.rank == "number" ? a.rank : 1e9) - (typeof b.rank == "number" ? b.rank : 1e9) || (a.name < b.name ? -1 : 1);
        };
        for (let s of sections.sort(cmp)){
            pos -= 1e5;
            sectionOrder[s.name] = pos;
        }
        for (let option of options){
            let { section: section } = option.completion;
            if (section) option.score += sectionOrder[typeof section == "string" ? section : section.name];
        }
    }
    let result = [], prev = null;
    let compare = conf.compareCompletions;
    for (let opt of options.sort((a, b)=>b.score - a.score || compare(a.completion, b.completion))){
        let cur = opt.completion;
        if (!prev || prev.label != cur.label || prev.detail != cur.detail || prev.type != null && cur.type != null && prev.type != cur.type || prev.apply != cur.apply || prev.boost != cur.boost) result.push(opt);
        else if ($7570a9a1a9679713$var$score(opt.completion) > $7570a9a1a9679713$var$score(prev)) result[result.length - 1] = opt;
        prev = opt.completion;
    }
    return result;
}
class $7570a9a1a9679713$var$CompletionDialog {
    constructor(options, attrs, tooltip, timestamp, selected, disabled){
        this.options = options;
        this.attrs = attrs;
        this.tooltip = tooltip;
        this.timestamp = timestamp;
        this.selected = selected;
        this.disabled = disabled;
    }
    setSelected(selected, id) {
        return selected == this.selected || selected >= this.options.length ? this : new $7570a9a1a9679713$var$CompletionDialog(this.options, $7570a9a1a9679713$var$makeAttrs(id, selected), this.tooltip, this.timestamp, selected, this.disabled);
    }
    static build(active, state, id, prev, conf, didSetActive) {
        if (prev && !didSetActive && active.some((s)=>s.isPending)) return prev.setDisabled();
        let options = $7570a9a1a9679713$var$sortOptions(active, state);
        if (!options.length) return prev && active.some((a)=>a.isPending) ? prev.setDisabled() : null;
        let selected = state.facet($7570a9a1a9679713$var$completionConfig).selectOnOpen ? 0 : -1;
        if (prev && prev.selected != selected && prev.selected != -1) {
            let selectedValue = prev.options[prev.selected].completion;
            for(let i = 0; i < options.length; i++)if (options[i].completion == selectedValue) {
                selected = i;
                break;
            }
        }
        return new $7570a9a1a9679713$var$CompletionDialog(options, $7570a9a1a9679713$var$makeAttrs(id, selected), {
            pos: active.reduce((a, b)=>b.hasResult() ? Math.min(a, b.from) : a, 1e8),
            create: $7570a9a1a9679713$var$createTooltip,
            above: conf.aboveCursor
        }, prev ? prev.timestamp : Date.now(), selected, false);
    }
    map(changes) {
        return new $7570a9a1a9679713$var$CompletionDialog(this.options, this.attrs, {
            ...this.tooltip,
            pos: changes.mapPos(this.tooltip.pos)
        }, this.timestamp, this.selected, this.disabled);
    }
    setDisabled() {
        return new $7570a9a1a9679713$var$CompletionDialog(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, true);
    }
}
class $7570a9a1a9679713$var$CompletionState {
    constructor(active, id, open){
        this.active = active;
        this.id = id;
        this.open = open;
    }
    static start() {
        return new $7570a9a1a9679713$var$CompletionState($7570a9a1a9679713$var$none, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
    }
    update(tr) {
        let { state: state } = tr, conf = state.facet($7570a9a1a9679713$var$completionConfig);
        let sources = conf.override || state.languageDataAt("autocomplete", $7570a9a1a9679713$var$cur(state)).map($7570a9a1a9679713$var$asSource);
        let active = sources.map((source)=>{
            let value = this.active.find((s)=>s.source == source) || new $7570a9a1a9679713$var$ActiveSource(source, this.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
            return value.update(tr, conf);
        });
        if (active.length == this.active.length && active.every((a, i)=>a == this.active[i])) active = this.active;
        let open = this.open, didSet = tr.effects.some((e)=>e.is($7570a9a1a9679713$var$setActiveEffect));
        if (open && tr.docChanged) open = open.map(tr.changes);
        if (tr.selection || active.some((a)=>a.hasResult() && tr.changes.touchesRange(a.from, a.to)) || !$7570a9a1a9679713$var$sameResults(active, this.active) || didSet) open = $7570a9a1a9679713$var$CompletionDialog.build(active, state, this.id, open, conf, didSet);
        else if (open && open.disabled && !active.some((a)=>a.isPending)) open = null;
        if (!open && active.every((a)=>!a.isPending) && active.some((a)=>a.hasResult())) active = active.map((a)=>a.hasResult() ? new $7570a9a1a9679713$var$ActiveSource(a.source, 0 /* State.Inactive */ ) : a);
        for (let effect of tr.effects)if (effect.is($7570a9a1a9679713$var$setSelectedEffect)) open = open && open.setSelected(effect.value, this.id);
        return active == this.active && open == this.open ? this : new $7570a9a1a9679713$var$CompletionState(active, this.id, open);
    }
    get tooltip() {
        return this.open ? this.open.tooltip : null;
    }
    get attrs() {
        return this.open ? this.open.attrs : this.active.length ? $7570a9a1a9679713$var$baseAttrs : $7570a9a1a9679713$var$noAttrs;
    }
}
function $7570a9a1a9679713$var$sameResults(a, b) {
    if (a == b) return true;
    for(let iA = 0, iB = 0;;){
        while(iA < a.length && !a[iA].hasResult())iA++;
        while(iB < b.length && !b[iB].hasResult())iB++;
        let endA = iA == a.length, endB = iB == b.length;
        if (endA || endB) return endA == endB;
        if (a[iA++].result != b[iB++].result) return false;
    }
}
const $7570a9a1a9679713$var$baseAttrs = {
    "aria-autocomplete": "list"
};
const $7570a9a1a9679713$var$noAttrs = {};
function $7570a9a1a9679713$var$makeAttrs(id, selected) {
    let result = {
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-controls": id
    };
    if (selected > -1) result["aria-activedescendant"] = id + "-" + selected;
    return result;
}
const $7570a9a1a9679713$var$none = [];
function $7570a9a1a9679713$var$getUpdateType(tr, conf) {
    if (tr.isUserEvent("input.complete")) {
        let completion = tr.annotation($7570a9a1a9679713$export$6c84d44c1ceeb831);
        if (completion && conf.activateOnCompletion(completion)) return 12 /* UpdateType.Reset */ ;
    }
    let typing = tr.isUserEvent("input.type");
    return typing && conf.activateOnTyping ? 5 /* UpdateType.Typing */  : typing ? 1 /* UpdateType.Typing */  : tr.isUserEvent("delete.backward") ? 2 /* UpdateType.Backspacing */  : tr.selection ? 8 /* UpdateType.Reset */  : tr.docChanged ? 16 /* UpdateType.ResetIfTouching */  : 0 /* UpdateType.None */ ;
}
class $7570a9a1a9679713$var$ActiveSource {
    constructor(source, state, explicit = false){
        this.source = source;
        this.state = state;
        this.explicit = explicit;
    }
    hasResult() {
        return false;
    }
    get isPending() {
        return this.state == 1 /* State.Pending */ ;
    }
    update(tr, conf) {
        let type = $7570a9a1a9679713$var$getUpdateType(tr, conf), value = this;
        if (type & 8 /* UpdateType.Reset */  || type & 16 /* UpdateType.ResetIfTouching */  && this.touches(tr)) value = new $7570a9a1a9679713$var$ActiveSource(value.source, 0 /* State.Inactive */ );
        if (type & 4 /* UpdateType.Activate */  && value.state == 0 /* State.Inactive */ ) value = new $7570a9a1a9679713$var$ActiveSource(this.source, 1 /* State.Pending */ );
        value = value.updateFor(tr, type);
        for (let effect of tr.effects){
            if (effect.is($7570a9a1a9679713$var$startCompletionEffect)) value = new $7570a9a1a9679713$var$ActiveSource(value.source, 1 /* State.Pending */ , effect.value);
            else if (effect.is($7570a9a1a9679713$var$closeCompletionEffect)) value = new $7570a9a1a9679713$var$ActiveSource(value.source, 0 /* State.Inactive */ );
            else if (effect.is($7570a9a1a9679713$var$setActiveEffect)) {
                for (let active of effect.value)if (active.source == value.source) value = active;
            }
        }
        return value;
    }
    updateFor(tr, type) {
        return this.map(tr.changes);
    }
    map(changes) {
        return this;
    }
    touches(tr) {
        return tr.changes.touchesRange($7570a9a1a9679713$var$cur(tr.state));
    }
}
class $7570a9a1a9679713$var$ActiveResult extends $7570a9a1a9679713$var$ActiveSource {
    constructor(source, explicit, limit, result, from, to){
        super(source, 3 /* State.Result */ , explicit);
        this.limit = limit;
        this.result = result;
        this.from = from;
        this.to = to;
    }
    hasResult() {
        return true;
    }
    updateFor(tr, type) {
        var _a;
        if (!(type & 3 /* UpdateType.SimpleInteraction */ )) return this.map(tr.changes);
        let result = this.result;
        if (result.map && !tr.changes.empty) result = result.map(result, tr.changes);
        let from = tr.changes.mapPos(this.from), to = tr.changes.mapPos(this.to, 1);
        let pos = $7570a9a1a9679713$var$cur(tr.state);
        if (pos > to || !result || type & 2 /* UpdateType.Backspacing */  && ($7570a9a1a9679713$var$cur(tr.startState) == this.from || pos < this.limit)) return new $7570a9a1a9679713$var$ActiveSource(this.source, type & 4 /* UpdateType.Activate */  ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
        let limit = tr.changes.mapPos(this.limit);
        if ($7570a9a1a9679713$var$checkValid(result.validFor, tr.state, from, to)) return new $7570a9a1a9679713$var$ActiveResult(this.source, this.explicit, limit, result, from, to);
        if (result.update && (result = result.update(result, from, to, new $7570a9a1a9679713$export$7b73e80391102dce(tr.state, pos, false)))) return new $7570a9a1a9679713$var$ActiveResult(this.source, this.explicit, limit, result, result.from, (_a = result.to) !== null && _a !== void 0 ? _a : $7570a9a1a9679713$var$cur(tr.state));
        return new $7570a9a1a9679713$var$ActiveSource(this.source, 1 /* State.Pending */ , this.explicit);
    }
    map(mapping) {
        if (mapping.empty) return this;
        let result = this.result.map ? this.result.map(this.result, mapping) : this.result;
        if (!result) return new $7570a9a1a9679713$var$ActiveSource(this.source, 0 /* State.Inactive */ );
        return new $7570a9a1a9679713$var$ActiveResult(this.source, this.explicit, mapping.mapPos(this.limit), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
    }
    touches(tr) {
        return tr.changes.touchesRange(this.from, this.to);
    }
}
function $7570a9a1a9679713$var$checkValid(validFor, state, from, to) {
    if (!validFor) return false;
    let text = state.sliceDoc(from, to);
    return typeof validFor == "function" ? validFor(text, from, to, state) : $7570a9a1a9679713$var$ensureAnchor(validFor, true).test(text);
}
const $7570a9a1a9679713$var$setActiveEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (sources, mapping) {
        return sources.map((s)=>s.map(mapping));
    }
});
const $7570a9a1a9679713$var$setSelectedEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7570a9a1a9679713$var$completionState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return $7570a9a1a9679713$var$CompletionState.start();
    },
    update (value, tr) {
        return value.update(tr);
    },
    provide: (f)=>[
            (0, $7beee9608540d2c3$export$dba11b50e1aa3c12).from(f, (val)=>val.tooltip),
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).contentAttributes.from(f, (state)=>state.attrs)
        ]
});
function $7570a9a1a9679713$var$applyCompletion(view, option) {
    const apply = option.completion.apply || option.completion.label;
    let result = view.state.field($7570a9a1a9679713$var$completionState).active.find((a)=>a.source == option.source);
    if (!(result instanceof $7570a9a1a9679713$var$ActiveResult)) return false;
    if (typeof apply == "string") view.dispatch({
        ...$7570a9a1a9679713$export$496ff43229d73eba(view.state, apply, result.from, result.to),
        annotations: $7570a9a1a9679713$export$6c84d44c1ceeb831.of(option.completion)
    });
    else apply(view, option.completion, result.from, result.to);
    return true;
}
const $7570a9a1a9679713$var$createTooltip = /*@__PURE__*/ $7570a9a1a9679713$var$completionTooltip($7570a9a1a9679713$var$completionState, $7570a9a1a9679713$var$applyCompletion);
/**
Returns a command that moves the completion selection forward or
backward by the given amount.
*/ function $7570a9a1a9679713$export$26f3a479ac65d653(forward, by = "option") {
    return (view)=>{
        let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
        if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($7570a9a1a9679713$var$completionConfig).interactionDelay) return false;
        let step = 1, tooltip;
        if (by == "page" && (tooltip = (0, $7beee9608540d2c3$export$46455b4476d4b8e1)(view, cState.open.tooltip))) step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
        let { length: length } = cState.open.options;
        let selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length - 1;
        if (selected < 0) selected = by == "page" ? 0 : length - 1;
        else if (selected >= length) selected = by == "page" ? length - 1 : 0;
        view.dispatch({
            effects: $7570a9a1a9679713$var$setSelectedEffect.of(selected)
        });
        return true;
    };
}
/**
Accept the current completion.
*/ const $7570a9a1a9679713$export$537623a3380ccdae = (view)=>{
    let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
    if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($7570a9a1a9679713$var$completionConfig).interactionDelay) return false;
    return $7570a9a1a9679713$var$applyCompletion(view, cState.open.options[cState.open.selected]);
};
/**
Explicitly start autocompletion.
*/ const $7570a9a1a9679713$export$8a36416d28f82fd5 = (view)=>{
    let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
    if (!cState) return false;
    view.dispatch({
        effects: $7570a9a1a9679713$var$startCompletionEffect.of(true)
    });
    return true;
};
/**
Close the currently active completion.
*/ const $7570a9a1a9679713$export$bdc62126738c63ab = (view)=>{
    let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
    if (!cState || !cState.active.some((a)=>a.state != 0 /* State.Inactive */ )) return false;
    view.dispatch({
        effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
    });
    return true;
};
class $7570a9a1a9679713$var$RunningQuery {
    constructor(active, context){
        this.active = active;
        this.context = context;
        this.time = Date.now();
        this.updates = [];
        // Note that 'undefined' means 'not done yet', whereas 'null' means
        // 'query returned null'.
        this.done = undefined;
    }
}
const $7570a9a1a9679713$var$MaxUpdateCount = 50, $7570a9a1a9679713$var$MinAbortTime = 1000;
const $7570a9a1a9679713$var$completionPlugin = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.debounceUpdate = -1;
        this.running = [];
        this.debounceAccept = -1;
        this.pendingStart = false;
        this.composing = 0 /* CompositionState.None */ ;
        for (let active of view.state.field($7570a9a1a9679713$var$completionState).active)if (active.isPending) this.startQuery(active);
    }
    update(update) {
        let cState = update.state.field($7570a9a1a9679713$var$completionState);
        let conf = update.state.facet($7570a9a1a9679713$var$completionConfig);
        if (!update.selectionSet && !update.docChanged && update.startState.field($7570a9a1a9679713$var$completionState) == cState) return;
        let doesReset = update.transactions.some((tr)=>{
            let type = $7570a9a1a9679713$var$getUpdateType(tr, conf);
            return type & 8 /* UpdateType.Reset */  || (tr.selection || tr.docChanged) && !(type & 3 /* UpdateType.SimpleInteraction */ );
        });
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (doesReset || query.context.abortOnDocChange && update.docChanged || query.updates.length + update.transactions.length > $7570a9a1a9679713$var$MaxUpdateCount && Date.now() - query.time > $7570a9a1a9679713$var$MinAbortTime) {
                for (let handler of query.context.abortListeners)try {
                    handler();
                } catch (e) {
                    (0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, e);
                }
                query.context.abortListeners = null;
                this.running.splice(i--, 1);
            } else query.updates.push(...update.transactions);
        }
        if (this.debounceUpdate > -1) clearTimeout(this.debounceUpdate);
        if (update.transactions.some((tr)=>tr.effects.some((e)=>e.is($7570a9a1a9679713$var$startCompletionEffect)))) this.pendingStart = true;
        let delay = this.pendingStart ? 50 : conf.activateOnTypingDelay;
        this.debounceUpdate = cState.active.some((a)=>a.isPending && !this.running.some((q)=>q.active.source == a.source)) ? setTimeout(()=>this.startUpdate(), delay) : -1;
        if (this.composing != 0 /* CompositionState.None */ ) for (let tr of update.transactions){
            if (tr.isUserEvent("input.type")) this.composing = 2 /* CompositionState.Changed */ ;
            else if (this.composing == 2 /* CompositionState.Changed */  && tr.selection) this.composing = 3 /* CompositionState.ChangedAndMoved */ ;
        }
    }
    startUpdate() {
        this.debounceUpdate = -1;
        this.pendingStart = false;
        let { state: state } = this.view, cState = state.field($7570a9a1a9679713$var$completionState);
        for (let active of cState.active)if (active.isPending && !this.running.some((r)=>r.active.source == active.source)) this.startQuery(active);
        if (this.running.length && cState.open && cState.open.disabled) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($7570a9a1a9679713$var$completionConfig).updateSyncTime);
    }
    startQuery(active) {
        let { state: state } = this.view, pos = $7570a9a1a9679713$var$cur(state);
        let context = new $7570a9a1a9679713$export$7b73e80391102dce(state, pos, active.explicit, this.view);
        let pending = new $7570a9a1a9679713$var$RunningQuery(active, context);
        this.running.push(pending);
        Promise.resolve(active.source(context)).then((result)=>{
            if (!pending.context.aborted) {
                pending.done = result || null;
                this.scheduleAccept();
            }
        }, (err)=>{
            this.view.dispatch({
                effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
            });
            (0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, err);
        });
    }
    scheduleAccept() {
        if (this.running.every((q)=>q.done !== undefined)) this.accept();
        else if (this.debounceAccept < 0) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($7570a9a1a9679713$var$completionConfig).updateSyncTime);
    }
    // For each finished query in this.running, try to create a result
    // or, if appropriate, restart the query.
    accept() {
        var _a;
        if (this.debounceAccept > -1) clearTimeout(this.debounceAccept);
        this.debounceAccept = -1;
        let updated = [];
        let conf = this.view.state.facet($7570a9a1a9679713$var$completionConfig), cState = this.view.state.field($7570a9a1a9679713$var$completionState);
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (query.done === undefined) continue;
            this.running.splice(i--, 1);
            if (query.done) {
                let pos = $7570a9a1a9679713$var$cur(query.updates.length ? query.updates[0].startState : this.view.state);
                let limit = Math.min(pos, query.done.from + (query.active.explicit ? 0 : 1));
                let active = new $7570a9a1a9679713$var$ActiveResult(query.active.source, query.active.explicit, limit, query.done, query.done.from, (_a = query.done.to) !== null && _a !== void 0 ? _a : pos);
                // Replay the transactions that happened since the start of
                // the request and see if that preserves the result
                for (let tr of query.updates)active = active.update(tr, conf);
                if (active.hasResult()) {
                    updated.push(active);
                    continue;
                }
            }
            let current = cState.active.find((a)=>a.source == query.active.source);
            if (current && current.isPending) {
                if (query.done == null) {
                    // Explicitly failed. Should clear the pending status if it
                    // hasn't been re-set in the meantime.
                    let active = new $7570a9a1a9679713$var$ActiveSource(query.active.source, 0 /* State.Inactive */ );
                    for (let tr of query.updates)active = active.update(tr, conf);
                    if (!active.isPending) updated.push(active);
                } else // Cleared by subsequent transactions. Restart.
                this.startQuery(current);
            }
        }
        if (updated.length || cState.open && cState.open.disabled) this.view.dispatch({
            effects: $7570a9a1a9679713$var$setActiveEffect.of(updated)
        });
    }
}, {
    eventHandlers: {
        blur (event) {
            let state = this.view.state.field($7570a9a1a9679713$var$completionState, false);
            if (state && state.tooltip && this.view.state.facet($7570a9a1a9679713$var$completionConfig).closeOnBlur) {
                let dialog = state.open && (0, $7beee9608540d2c3$export$46455b4476d4b8e1)(this.view, state.open.tooltip);
                if (!dialog || !dialog.dom.contains(event.relatedTarget)) setTimeout(()=>this.view.dispatch({
                        effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
                    }), 10);
            }
        },
        compositionstart () {
            this.composing = 1 /* CompositionState.Started */ ;
        },
        compositionend () {
            if (this.composing == 3 /* CompositionState.ChangedAndMoved */ ) // Safari fires compositionend events synchronously, possibly
            // from inside an update, so dispatch asynchronously to avoid reentrancy
            setTimeout(()=>this.view.dispatch({
                    effects: $7570a9a1a9679713$var$startCompletionEffect.of(false)
                }), 20);
            this.composing = 0 /* CompositionState.None */ ;
        }
    }
});
const $7570a9a1a9679713$var$windows = typeof navigator == "object" && /*@__PURE__*/ /Win/.test(navigator.platform);
const $7570a9a1a9679713$var$commitCharacters = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).domEventHandlers({
    keydown (event, view) {
        let field = view.state.field($7570a9a1a9679713$var$completionState, false);
        if (!field || !field.open || field.open.disabled || field.open.selected < 0 || event.key.length > 1 || event.ctrlKey && !($7570a9a1a9679713$var$windows && event.altKey) || event.metaKey) return false;
        let option = field.open.options[field.open.selected];
        let result = field.active.find((a)=>a.source == option.source);
        let commitChars = option.completion.commitCharacters || result.result.commitCharacters;
        if (commitChars && commitChars.indexOf(event.key) > -1) $7570a9a1a9679713$var$applyCompletion(view, option);
        return false;
    }
}));
const $7570a9a1a9679713$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
        "& > ul": {
            fontFamily: "monospace",
            whiteSpace: "nowrap",
            overflow: "hidden auto",
            maxWidth_fallback: "700px",
            maxWidth: "min(700px, 95vw)",
            minWidth: "250px",
            maxHeight: "10em",
            height: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& > li, & > completion-section": {
                padding: "1px 3px",
                lineHeight: 1.2
            },
            "& > li": {
                overflowX: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer"
            },
            "& > completion-section": {
                display: "list-item",
                borderBottom: "1px solid silver",
                paddingLeft: "0.5em",
                opacity: 0.7
            }
        }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#17c",
        color: "white"
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#777"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#347",
        color: "white"
    },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#444"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
        content: '"\xb7\xb7\xb7"',
        opacity: 0.5,
        display: "block",
        textAlign: "center"
    },
    ".cm-tooltip.cm-completionInfo": {
        position: "absolute",
        padding: "3px 9px",
        width: "max-content",
        maxWidth: `${400 /* Info.Width */ }px`,
        boxSizing: "border-box",
        whiteSpace: "pre-line"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
        right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
        left: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-left-narrow": {
        right: `${30 /* Info.Margin */ }px`
    },
    ".cm-completionInfo.cm-completionInfo-right-narrow": {
        left: `${30 /* Info.Margin */ }px`
    },
    "&light .cm-snippetField": {
        backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
        backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
        verticalAlign: "text-top",
        width: 0,
        height: "1.15em",
        display: "inline-block",
        margin: "0 -0.7px -.7em",
        borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
        textDecoration: "underline"
    },
    ".cm-completionDetail": {
        marginLeft: "0.5em",
        fontStyle: "italic"
    },
    ".cm-completionIcon": {
        fontSize: "90%",
        width: ".8em",
        display: "inline-block",
        textAlign: "center",
        paddingRight: ".6em",
        opacity: "0.6",
        boxSizing: "content-box"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
        "&:after": {
            content: "'\u0192'"
        }
    },
    ".cm-completionIcon-class": {
        "&:after": {
            content: "'\u25CB'"
        }
    },
    ".cm-completionIcon-interface": {
        "&:after": {
            content: "'\u25CC'"
        }
    },
    ".cm-completionIcon-variable": {
        "&:after": {
            content: "'\uD835\uDC65'"
        }
    },
    ".cm-completionIcon-constant": {
        "&:after": {
            content: "'\uD835\uDC36'"
        }
    },
    ".cm-completionIcon-type": {
        "&:after": {
            content: "'\uD835\uDC61'"
        }
    },
    ".cm-completionIcon-enum": {
        "&:after": {
            content: "'\u222A'"
        }
    },
    ".cm-completionIcon-property": {
        "&:after": {
            content: "'\u25A1'"
        }
    },
    ".cm-completionIcon-keyword": {
        "&:after": {
            content: "'\uD83D\uDD11\uFE0E'"
        } // Disable emoji rendering
    },
    ".cm-completionIcon-namespace": {
        "&:after": {
            content: "'\u25A2'"
        }
    },
    ".cm-completionIcon-text": {
        "&:after": {
            content: "'abc'",
            fontSize: "50%",
            verticalAlign: "middle"
        }
    }
});
class $7570a9a1a9679713$var$FieldPos {
    constructor(field, line, from, to){
        this.field = field;
        this.line = line;
        this.from = from;
        this.to = to;
    }
}
class $7570a9a1a9679713$var$FieldRange {
    constructor(field, from, to){
        this.field = field;
        this.from = from;
        this.to = to;
    }
    map(changes) {
        let from = changes.mapPos(this.from, -1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel);
        let to = changes.mapPos(this.to, 1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel);
        return from == null || to == null ? null : new $7570a9a1a9679713$var$FieldRange(this.field, from, to);
    }
}
class $7570a9a1a9679713$var$Snippet {
    constructor(lines, fieldPositions){
        this.lines = lines;
        this.fieldPositions = fieldPositions;
    }
    instantiate(state, pos) {
        let text = [], lineStart = [
            pos
        ];
        let lineObj = state.doc.lineAt(pos), baseIndent = /^\s*/.exec(lineObj.text)[0];
        for (let line of this.lines){
            if (text.length) {
                let indent = baseIndent, tabs = /^\t*/.exec(line)[0].length;
                for(let i = 0; i < tabs; i++)indent += state.facet((0, $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5));
                lineStart.push(pos + indent.length - tabs);
                line = indent + line.slice(tabs);
            }
            text.push(line);
            pos += line.length + 1;
        }
        let ranges = this.fieldPositions.map((pos)=>new $7570a9a1a9679713$var$FieldRange(pos.field, lineStart[pos.line] + pos.from, lineStart[pos.line] + pos.to));
        return {
            text: text,
            ranges: ranges
        };
    }
    static parse(template) {
        let fields = [];
        let lines = [], positions = [], m;
        for (let line of template.split(/\r\n?|\n/)){
            while(m = /[#$]\{(?:(\d+)(?::([^{}]*))?|((?:\\[{}]|[^{}])*))\}/.exec(line)){
                let seq = m[1] ? +m[1] : null, rawName = m[2] || m[3] || "", found = -1;
                let name = rawName.replace(/\\[{}]/g, (m)=>m[1]);
                for(let i = 0; i < fields.length; i++)if (seq != null ? fields[i].seq == seq : name ? fields[i].name == name : false) found = i;
                if (found < 0) {
                    let i = 0;
                    while(i < fields.length && (seq == null || fields[i].seq != null && fields[i].seq < seq))i++;
                    fields.splice(i, 0, {
                        seq: seq,
                        name: name
                    });
                    found = i;
                    for (let pos of positions)if (pos.field >= found) pos.field++;
                }
                for (let pos of positions)if (pos.line == lines.length && pos.from > m.index) {
                    let snip = m[2] ? 3 + (m[1] || "").length : 2;
                    pos.from -= snip;
                    pos.to -= snip;
                }
                positions.push(new $7570a9a1a9679713$var$FieldPos(found, lines.length, m.index, m.index + name.length));
                line = line.slice(0, m.index) + rawName + line.slice(m.index + m[0].length);
            }
            line = line.replace(/\\([{}])/g, (_, brace, index)=>{
                for (let pos of positions)if (pos.line == lines.length && pos.from > index) {
                    pos.from--;
                    pos.to--;
                }
                return brace;
            });
            lines.push(line);
        }
        return new $7570a9a1a9679713$var$Snippet(lines, positions);
    }
}
let $7570a9a1a9679713$var$fieldMarker = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).widget({
    widget: /*@__PURE__*/ new class extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
        toDOM() {
            let span = document.createElement("span");
            span.className = "cm-snippetFieldPosition";
            return span;
        }
        ignoreEvent() {
            return false;
        }
    }
});
let $7570a9a1a9679713$var$fieldRange = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-snippetField"
});
class $7570a9a1a9679713$var$ActiveSnippet {
    constructor(ranges, active){
        this.ranges = ranges;
        this.active = active;
        this.deco = (0, $7beee9608540d2c3$export$10e30b733df217ea).set(ranges.map((r)=>(r.from == r.to ? $7570a9a1a9679713$var$fieldMarker : $7570a9a1a9679713$var$fieldRange).range(r.from, r.to)), true);
    }
    map(changes) {
        let ranges = [];
        for (let r of this.ranges){
            let mapped = r.map(changes);
            if (!mapped) return null;
            ranges.push(mapped);
        }
        return new $7570a9a1a9679713$var$ActiveSnippet(ranges, this.active);
    }
    selectionInsideField(sel) {
        return sel.ranges.every((range)=>this.ranges.some((r)=>r.field == this.active && r.from <= range.from && r.to >= range.to));
    }
}
const $7570a9a1a9679713$var$setActive = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (value, changes) {
        return value && value.map(changes);
    }
});
const $7570a9a1a9679713$var$moveToField = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7570a9a1a9679713$var$snippetState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($7570a9a1a9679713$var$setActive)) return effect.value;
            if (effect.is($7570a9a1a9679713$var$moveToField) && value) return new $7570a9a1a9679713$var$ActiveSnippet(value.ranges, effect.value);
        }
        if (value && tr.docChanged) value = value.map(tr.changes);
        if (value && tr.selection && !value.selectionInsideField(tr.selection)) value = null;
        return value;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f, (val)=>val ? val.deco : (0, $7beee9608540d2c3$export$10e30b733df217ea).none)
});
function $7570a9a1a9679713$var$fieldSelection(ranges, field) {
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges.filter((r)=>r.field == field).map((r)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(r.from, r.to)));
}
/**
Convert a snippet template to a function that can
[apply](https://codemirror.net/6/docs/ref/#autocomplete.Completion.apply) it. Snippets are written
using syntax like this:

    "for (let ${index} = 0; ${index} < ${end}; ${index}++) {\n\t${}\n}"

Each `${}` placeholder (you may also use `#{}`) indicates a field
that the user can fill in. Its name, if any, will be the default
content for the field.

When the snippet is activated by calling the returned function,
the code is inserted at the given position. Newlines in the
template are indented by the indentation of the start line, plus
one [indent unit](https://codemirror.net/6/docs/ref/#language.indentUnit) per tab character after
the newline.

On activation, (all instances of) the first field are selected.
The user can move between fields with Tab and Shift-Tab as long as
the fields are active. Moving to the last field or moving the
cursor out of the current field deactivates the fields.

The order of fields defaults to textual order, but you can add
numbers to placeholders (`${1}` or `${1:defaultText}`) to provide
a custom order.

To include a literal `{` or `}` in your template, put a backslash
in front of it. This will be removed and the brace will not be
interpreted as indicating a placeholder.
*/ function $7570a9a1a9679713$export$f77f1ac5bf251232(template) {
    let snippet = $7570a9a1a9679713$var$Snippet.parse(template);
    return (editor, completion, from, to)=>{
        let { text: text, ranges: ranges } = snippet.instantiate(editor.state, from);
        let { main: main } = editor.state.selection;
        let spec = {
            changes: {
                from: from,
                to: to == main.from ? main.to : to,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(text)
            },
            scrollIntoView: true,
            annotations: completion ? [
                $7570a9a1a9679713$export$6c84d44c1ceeb831.of(completion),
                (0, $6295c6875f57e3ee$export$febc5573c75cefb0).userEvent.of("input.complete")
            ] : undefined
        };
        if (ranges.length) spec.selection = $7570a9a1a9679713$var$fieldSelection(ranges, 0);
        if (ranges.some((r)=>r.field > 0)) {
            let active = new $7570a9a1a9679713$var$ActiveSnippet(ranges, 0);
            let effects = spec.effects = [
                $7570a9a1a9679713$var$setActive.of(active)
            ];
            if (editor.state.field($7570a9a1a9679713$var$snippetState, false) === undefined) effects.push((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of([
                $7570a9a1a9679713$var$snippetState,
                $7570a9a1a9679713$var$addSnippetKeymap,
                $7570a9a1a9679713$var$snippetPointerHandler,
                $7570a9a1a9679713$var$baseTheme
            ]));
        }
        editor.dispatch(editor.state.update(spec));
    };
}
function $7570a9a1a9679713$var$moveField(dir) {
    return ({ state: state, dispatch: dispatch })=>{
        let active = state.field($7570a9a1a9679713$var$snippetState, false);
        if (!active || dir < 0 && active.active == 0) return false;
        let next = active.active + dir, last = dir > 0 && !active.ranges.some((r)=>r.field == next + dir);
        dispatch(state.update({
            selection: $7570a9a1a9679713$var$fieldSelection(active.ranges, next),
            effects: $7570a9a1a9679713$var$setActive.of(last ? null : new $7570a9a1a9679713$var$ActiveSnippet(active.ranges, next)),
            scrollIntoView: true
        }));
        return true;
    };
}
/**
A command that clears the active snippet, if any.
*/ const $7570a9a1a9679713$export$4d00dce2599b1df3 = ({ state: state, dispatch: dispatch })=>{
    let active = state.field($7570a9a1a9679713$var$snippetState, false);
    if (!active) return false;
    dispatch(state.update({
        effects: $7570a9a1a9679713$var$setActive.of(null)
    }));
    return true;
};
/**
Move to the next snippet field, if available.
*/ const $7570a9a1a9679713$export$d8da8fdad886df2f = /*@__PURE__*/ $7570a9a1a9679713$var$moveField(1);
/**
Move to the previous snippet field, if available.
*/ const $7570a9a1a9679713$export$8d02b23b64ec425c = /*@__PURE__*/ $7570a9a1a9679713$var$moveField(-1);
/**
Check if there is an active snippet with a next field for
`nextSnippetField` to move to.
*/ function $7570a9a1a9679713$export$9c250e449e4af222(state) {
    let active = state.field($7570a9a1a9679713$var$snippetState, false);
    return !!(active && active.ranges.some((r)=>r.field == active.active + 1));
}
/**
Returns true if there is an active snippet and a previous field
for `prevSnippetField` to move to.
*/ function $7570a9a1a9679713$export$ace2e22fa9996777(state) {
    let active = state.field($7570a9a1a9679713$var$snippetState, false);
    return !!(active && active.active > 0);
}
const $7570a9a1a9679713$var$defaultSnippetKeymap = [
    {
        key: "Tab",
        run: $7570a9a1a9679713$export$d8da8fdad886df2f,
        shift: $7570a9a1a9679713$export$8d02b23b64ec425c
    },
    {
        key: "Escape",
        run: $7570a9a1a9679713$export$4d00dce2599b1df3
    }
];
/**
A facet that can be used to configure the key bindings used by
snippets. The default binds Tab to
[`nextSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.nextSnippetField), Shift-Tab to
[`prevSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.prevSnippetField), and Escape
to [`clearSnippet`](https://codemirror.net/6/docs/ref/#autocomplete.clearSnippet).
*/ const $7570a9a1a9679713$export$1808c2f24fc99b36 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (maps) {
        return maps.length ? maps[0] : $7570a9a1a9679713$var$defaultSnippetKeymap;
    }
});
const $7570a9a1a9679713$var$addSnippetKeymap = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ (0, $7beee9608540d2c3$export$5043418e2ef368d5).compute([
    $7570a9a1a9679713$export$1808c2f24fc99b36
], (state)=>state.facet($7570a9a1a9679713$export$1808c2f24fc99b36)));
/**
Create a completion from a snippet. Returns an object with the
properties from `completion`, plus an `apply` function that
applies the snippet.
*/ function $7570a9a1a9679713$export$975ef56e648d23ad(template, completion) {
    return {
        ...completion,
        apply: $7570a9a1a9679713$export$f77f1ac5bf251232(template)
    };
}
const $7570a9a1a9679713$var$snippetPointerHandler = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).domEventHandlers({
    mousedown (event, view) {
        let active = view.state.field($7570a9a1a9679713$var$snippetState, false), pos;
        if (!active || (pos = view.posAtCoords({
            x: event.clientX,
            y: event.clientY
        })) == null) return false;
        let match = active.ranges.find((r)=>r.from <= pos && r.to >= pos);
        if (!match || match.field == active.active) return false;
        view.dispatch({
            selection: $7570a9a1a9679713$var$fieldSelection(active.ranges, match.field),
            effects: $7570a9a1a9679713$var$setActive.of(active.ranges.some((r)=>r.field > match.field) ? new $7570a9a1a9679713$var$ActiveSnippet(active.ranges, match.field) : null),
            scrollIntoView: true
        });
        return true;
    }
});
function $7570a9a1a9679713$var$wordRE(wordChars) {
    let escaped = wordChars.replace(/[\]\-\\]/g, "\\$&");
    try {
        return new RegExp(`[\\p{Alphabetic}\\p{Number}_${escaped}]+`, "ug");
    } catch (_a) {
        return new RegExp(`[\w${escaped}]`, "g");
    }
}
function $7570a9a1a9679713$var$mapRE(re, f) {
    return new RegExp(f(re.source), re.unicode ? "u" : "");
}
const $7570a9a1a9679713$var$wordCaches = /*@__PURE__*/ Object.create(null);
function $7570a9a1a9679713$var$wordCache(wordChars) {
    return $7570a9a1a9679713$var$wordCaches[wordChars] || ($7570a9a1a9679713$var$wordCaches[wordChars] = new WeakMap);
}
function $7570a9a1a9679713$var$storeWords(doc, wordRE, result, seen, ignoreAt) {
    for(let lines = doc.iterLines(), pos = 0; !lines.next().done;){
        let { value: value } = lines, m;
        wordRE.lastIndex = 0;
        while(m = wordRE.exec(value))if (!seen[m[0]] && pos + m.index != ignoreAt) {
            result.push({
                type: "text",
                label: m[0]
            });
            seen[m[0]] = true;
            if (result.length >= 2000 /* C.MaxList */ ) return;
        }
        pos += value.length + 1;
    }
}
function $7570a9a1a9679713$var$collectWords(doc, cache, wordRE, to, ignoreAt) {
    let big = doc.length >= 1000 /* C.MinCacheLen */ ;
    let cached = big && cache.get(doc);
    if (cached) return cached;
    let result = [], seen = Object.create(null);
    if (doc.children) {
        let pos = 0;
        for (let ch of doc.children){
            if (ch.length >= 1000 /* C.MinCacheLen */ ) {
                for (let c of $7570a9a1a9679713$var$collectWords(ch, cache, wordRE, to - pos, ignoreAt - pos))if (!seen[c.label]) {
                    seen[c.label] = true;
                    result.push(c);
                }
            } else $7570a9a1a9679713$var$storeWords(ch, wordRE, result, seen, ignoreAt - pos);
            pos += ch.length + 1;
        }
    } else $7570a9a1a9679713$var$storeWords(doc, wordRE, result, seen, ignoreAt);
    if (big && result.length < 2000 /* C.MaxList */ ) cache.set(doc, result);
    return result;
}
/**
A completion source that will scan the document for words (using a
[character categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer)), and
return those as completions.
*/ const $7570a9a1a9679713$export$a018df98be431a1 = (context)=>{
    let wordChars = context.state.languageDataAt("wordChars", context.pos).join("");
    let re = $7570a9a1a9679713$var$wordRE(wordChars);
    let token = context.matchBefore($7570a9a1a9679713$var$mapRE(re, (s)=>s + "$"));
    if (!token && !context.explicit) return null;
    let from = token ? token.from : context.pos;
    let options = $7570a9a1a9679713$var$collectWords(context.state.doc, $7570a9a1a9679713$var$wordCache(wordChars), re, 50000 /* C.Range */ , from);
    return {
        from: from,
        options: options,
        validFor: $7570a9a1a9679713$var$mapRE(re, (s)=>"^" + s)
    };
};
const $7570a9a1a9679713$var$defaults = {
    brackets: [
        "(",
        "[",
        "{",
        "'",
        '"'
    ],
    before: ")]}:;>",
    stringPrefixes: []
};
const $7570a9a1a9679713$var$closeBracketEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (value, mapping) {
        let mapped = mapping.mapPos(value, -1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackAfter);
        return mapped == null ? undefined : mapped;
    }
});
const $7570a9a1a9679713$var$closedBracket = /*@__PURE__*/ new class extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
};
$7570a9a1a9679713$var$closedBracket.startSide = 1;
$7570a9a1a9679713$var$closedBracket.endSide = -1;
const $7570a9a1a9679713$var$bracketState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
    },
    update (value, tr) {
        value = value.map(tr.changes);
        if (tr.selection) {
            let line = tr.state.doc.lineAt(tr.selection.main.head);
            value = value.update({
                filter: (from)=>from >= line.from && from <= line.to
            });
        }
        for (let effect of tr.effects)if (effect.is($7570a9a1a9679713$var$closeBracketEffect)) value = value.update({
            add: [
                $7570a9a1a9679713$var$closedBracket.range(effect.value, effect.value + 1)
            ]
        });
        return value;
    }
});
/**
Extension to enable bracket-closing behavior. When a closeable
bracket is typed, its closing bracket is immediately inserted
after the cursor. When closing a bracket directly in front of a
closing bracket inserted by the extension, the cursor moves over
that bracket.
*/ function $7570a9a1a9679713$export$69e4e9d3300ff824() {
    return [
        $7570a9a1a9679713$var$inputHandler,
        $7570a9a1a9679713$var$bracketState
    ];
}
const $7570a9a1a9679713$var$definedClosing = "()[]{}<>\xab\xbb\xbb\xab\uFF3B\uFF3D\uFF5B\uFF5D";
function $7570a9a1a9679713$var$closing(ch) {
    for(let i = 0; i < $7570a9a1a9679713$var$definedClosing.length; i += 2)if ($7570a9a1a9679713$var$definedClosing.charCodeAt(i) == ch) return $7570a9a1a9679713$var$definedClosing.charAt(i + 1);
    return (0, $6295c6875f57e3ee$export$73bfc63873071f74)(ch < 128 ? ch : ch + 1);
}
function $7570a9a1a9679713$var$config(state, pos) {
    return state.languageDataAt("closeBrackets", pos)[0] || $7570a9a1a9679713$var$defaults;
}
const $7570a9a1a9679713$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
const $7570a9a1a9679713$var$inputHandler = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).inputHandler.of((view, from, to, insert)=>{
    if (($7570a9a1a9679713$var$android ? view.composing : view.compositionStarted) || view.state.readOnly) return false;
    let sel = view.state.selection.main;
    if (insert.length > 2 || insert.length == 2 && (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(insert, 0)) == 1 || from != sel.from || to != sel.to) return false;
    let tr = $7570a9a1a9679713$export$7ce1ae5219095222(view.state, insert);
    if (!tr) return false;
    view.dispatch(tr);
    return true;
});
/**
Command that implements deleting a pair of matching brackets when
the cursor is between them.
*/ const $7570a9a1a9679713$export$5339d701ea89967c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let conf = $7570a9a1a9679713$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $7570a9a1a9679713$var$defaults.brackets;
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty) {
            let before = $7570a9a1a9679713$var$prevChar(state.doc, range.head);
            for (let token of tokens){
                if (token == before && $7570a9a1a9679713$var$nextChar(state.doc, range.head) == $7570a9a1a9679713$var$closing((0, $6295c6875f57e3ee$export$42977f40461e1360)(token, 0))) return {
                    changes: {
                        from: range.head - token.length,
                        to: range.head + token.length
                    },
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head - token.length)
                };
            }
        }
        return {
            range: dont = range
        };
    });
    if (!dont) dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "delete.backward"
    }));
    return !dont;
};
/**
Close-brackets related key bindings. Binds Backspace to
[`deleteBracketPair`](https://codemirror.net/6/docs/ref/#autocomplete.deleteBracketPair).
*/ const $7570a9a1a9679713$export$9477e95792b48f4a = [
    {
        key: "Backspace",
        run: $7570a9a1a9679713$export$5339d701ea89967c
    }
];
/**
Implements the extension's behavior on text insertion. If the
given string counts as a bracket in the language around the
selection, and replacing the selection with it requires custom
behavior (inserting a closing version or skipping past a
previously-closed bracket), this function returns a transaction
representing that custom behavior. (You only need this if you want
to programmatically insert brackets—the
[`closeBrackets`](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets) extension will
take care of running this for user input.)
*/ function $7570a9a1a9679713$export$7ce1ae5219095222(state, bracket) {
    let conf = $7570a9a1a9679713$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $7570a9a1a9679713$var$defaults.brackets;
    for (let tok of tokens){
        let closed = $7570a9a1a9679713$var$closing((0, $6295c6875f57e3ee$export$42977f40461e1360)(tok, 0));
        if (bracket == tok) return closed == tok ? $7570a9a1a9679713$var$handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : $7570a9a1a9679713$var$handleOpen(state, tok, closed, conf.before || $7570a9a1a9679713$var$defaults.before);
        if (bracket == closed && $7570a9a1a9679713$var$closedBracketAt(state, state.selection.main.from)) return $7570a9a1a9679713$var$handleClose(state, tok, closed);
    }
    return null;
}
function $7570a9a1a9679713$var$closedBracketAt(state, pos) {
    let found = false;
    state.field($7570a9a1a9679713$var$bracketState).between(0, state.doc.length, (from)=>{
        if (from == pos) found = true;
    });
    return found;
}
function $7570a9a1a9679713$var$nextChar(doc, pos) {
    let next = doc.sliceString(pos, pos + 2);
    return next.slice(0, (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(next, 0)));
}
function $7570a9a1a9679713$var$prevChar(doc, pos) {
    let prev = doc.sliceString(pos - 2, pos);
    return (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function $7570a9a1a9679713$var$handleOpen(state, open, close, closeBefore) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: open,
                    from: range.from
                },
                {
                    insert: close,
                    from: range.to
                }
            ],
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(range.to + open.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor + open.length, range.head + open.length)
        };
        let next = $7570a9a1a9679713$var$nextChar(state.doc, range.head);
        if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1) return {
            changes: {
                insert: open + close,
                from: range.head
            },
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(range.head + open.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head + open.length)
        };
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $7570a9a1a9679713$var$handleClose(state, _open, close) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty && $7570a9a1a9679713$var$nextChar(state.doc, range.head) == close) return {
            changes: {
                from: range.head,
                to: range.head + close.length,
                insert: close
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head + close.length)
        };
        return dont = {
            range: range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
// Handles cases where the open and close token are the same, and
// possibly triple quotes (as in `"""abc"""`-style quoting).
function $7570a9a1a9679713$var$handleSame(state, token, allowTriple, config) {
    let stringPrefixes = config.stringPrefixes || $7570a9a1a9679713$var$defaults.stringPrefixes;
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: token,
                    from: range.from
                },
                {
                    insert: token,
                    from: range.to
                }
            ],
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(range.to + token.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor + token.length, range.head + token.length)
        };
        let pos = range.head, next = $7570a9a1a9679713$var$nextChar(state.doc, pos), start;
        if (next == token) {
            if ($7570a9a1a9679713$var$nodeStart(state, pos)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $7570a9a1a9679713$var$closeBracketEffect.of(pos + token.length),
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
            else if ($7570a9a1a9679713$var$closedBracketAt(state, pos)) {
                let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
                let content = isTriple ? token + token + token : token;
                return {
                    changes: {
                        from: pos,
                        to: pos + content.length,
                        insert: content
                    },
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + content.length)
                };
            }
        } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = $7570a9a1a9679713$var$canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && $7570a9a1a9679713$var$nodeStart(state, start)) return {
            changes: {
                insert: token + token + token + token,
                from: pos
            },
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(pos + token.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + token.length)
        };
        else if (state.charCategorizer(pos)(next) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) {
            if ($7570a9a1a9679713$var$canStartStringAt(state, pos, stringPrefixes) > -1 && !$7570a9a1a9679713$var$probablyInString(state, pos, token, stringPrefixes)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $7570a9a1a9679713$var$closeBracketEffect.of(pos + token.length),
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
        }
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $7570a9a1a9679713$var$nodeStart(state, pos) {
    let tree = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos + 1);
    return tree.parent && tree.from == pos;
}
function $7570a9a1a9679713$var$probablyInString(state, pos, quoteToken, prefixes) {
    let node = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1);
    let maxPrefix = prefixes.reduce((m, p)=>Math.max(m, p.length), 0);
    for(let i = 0; i < 5; i++){
        let start = state.sliceDoc(node.from, Math.min(node.to, node.from + quoteToken.length + maxPrefix));
        let quotePos = start.indexOf(quoteToken);
        if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
            let first = node.firstChild;
            while(first && first.from == node.from && first.to - first.from > quoteToken.length + quotePos){
                if (state.sliceDoc(first.to - quoteToken.length, first.to) == quoteToken) return false;
                first = first.firstChild;
            }
            return true;
        }
        let parent = node.to == pos && node.parent;
        if (!parent) break;
        node = parent;
    }
    return false;
}
function $7570a9a1a9679713$var$canStartStringAt(state, pos, prefixes) {
    let charCat = state.charCategorizer(pos);
    if (charCat(state.sliceDoc(pos - 1, pos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) return pos;
    for (let prefix of prefixes){
        let start = pos - prefix.length;
        if (state.sliceDoc(start, pos) == prefix && charCat(state.sliceDoc(start - 1, start)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) return start;
    }
    return -1;
}
/**
Returns an extension that enables autocompletion.
*/ function $7570a9a1a9679713$export$f95786d390465556(config = {}) {
    return [
        $7570a9a1a9679713$var$commitCharacters,
        $7570a9a1a9679713$var$completionState,
        $7570a9a1a9679713$var$completionConfig.of(config),
        $7570a9a1a9679713$var$completionPlugin,
        $7570a9a1a9679713$var$completionKeymapExt,
        $7570a9a1a9679713$var$baseTheme
    ];
}
/**
Basic keybindings for autocompletion.

 - Ctrl-Space (and Alt-\` or Alt-i on macOS): [`startCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.startCompletion)
 - Escape: [`closeCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.closeCompletion)
 - ArrowDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true)`
 - ArrowUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false)`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - PageUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false, "page")`
 - Enter: [`acceptCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.acceptCompletion)
*/ const $7570a9a1a9679713$export$2a3d759d156afab4 = [
    {
        key: "Ctrl-Space",
        run: $7570a9a1a9679713$export$8a36416d28f82fd5
    },
    {
        mac: "Alt-`",
        run: $7570a9a1a9679713$export$8a36416d28f82fd5
    },
    {
        mac: "Alt-i",
        run: $7570a9a1a9679713$export$8a36416d28f82fd5
    },
    {
        key: "Escape",
        run: $7570a9a1a9679713$export$bdc62126738c63ab
    },
    {
        key: "ArrowDown",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(true)
    },
    {
        key: "ArrowUp",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(false)
    },
    {
        key: "PageDown",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(true, "page")
    },
    {
        key: "PageUp",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(false, "page")
    },
    {
        key: "Enter",
        run: $7570a9a1a9679713$export$537623a3380ccdae
    }
];
const $7570a9a1a9679713$var$completionKeymapExt = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ (0, $7beee9608540d2c3$export$5043418e2ef368d5).computeN([
    $7570a9a1a9679713$var$completionConfig
], (state)=>state.facet($7570a9a1a9679713$var$completionConfig).defaultKeymap ? [
        $7570a9a1a9679713$export$2a3d759d156afab4
    ] : []));
/**
Get the current completion status. When completions are available,
this will return `"active"`. When completions are pending (in the
process of being queried), this returns `"pending"`. Otherwise, it
returns `null`.
*/ function $7570a9a1a9679713$export$9eb35bf27959eae5(state) {
    let cState = state.field($7570a9a1a9679713$var$completionState, false);
    return cState && cState.active.some((a)=>a.isPending) ? "pending" : cState && cState.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? "active" : null;
}
const $7570a9a1a9679713$var$completionArrayCache = /*@__PURE__*/ new WeakMap;
/**
Returns the available completions as an array.
*/ function $7570a9a1a9679713$export$dc0f5d77fb0cbbf5(state) {
    var _a;
    let open = (_a = state.field($7570a9a1a9679713$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    if (!open || open.disabled) return [];
    let completions = $7570a9a1a9679713$var$completionArrayCache.get(open.options);
    if (!completions) $7570a9a1a9679713$var$completionArrayCache.set(open.options, completions = open.options.map((o)=>o.completion));
    return completions;
}
/**
Return the currently selected completion, if any.
*/ function $7570a9a1a9679713$export$8c322db2cd50d0f1(state) {
    var _a;
    let open = (_a = state.field($7570a9a1a9679713$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.options[open.selected].completion : null;
}
/**
Returns the currently selected position in the active completion
list, or null if no completions are active.
*/ function $7570a9a1a9679713$export$93d3d3265e08d270(state) {
    var _a;
    let open = (_a = state.field($7570a9a1a9679713$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.selected : null;
}
/**
Create an effect that can be attached to a transaction to change
the currently selected completion.
*/ function $7570a9a1a9679713$export$64a726c2de6175b8(index) {
    return $7570a9a1a9679713$var$setSelectedEffect.of(index);
}






/**
Comment or uncomment the current selection. Will use line comments
if available, otherwise falling back to block comments.
*/ const $032754016b6293d7$export$afbcdd0bff36c567 = (target)=>{
    let { state: state } = target, line = state.doc.lineAt(state.selection.main.from), config = $032754016b6293d7$var$getConfig(target.state, line.from);
    return config.line ? $032754016b6293d7$export$63a9abf96aaa3c5d(target) : config.block ? $032754016b6293d7$export$e88d9eff7cafcc34(target) : false;
};
function $032754016b6293d7$var$command(f, option) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let tr = f(option, state);
        if (!tr) return false;
        dispatch(state.update(tr));
        return true;
    };
}
/**
Comment or uncomment the current selection using line comments.
The line comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $032754016b6293d7$export$63a9abf96aaa3c5d = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeLineComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using line comments.
*/ const $032754016b6293d7$export$5d080f5a78d4f5b3 = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeLineComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using line comments.
*/ const $032754016b6293d7$export$5a43b8c36509b6fd = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeLineComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the current selection using block comments.
The block comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $032754016b6293d7$export$19d6fa84ce3a55ab = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeBlockComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using block comments.
*/ const $032754016b6293d7$export$f2ae215066c4835a = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeBlockComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using block comments.
*/ const $032754016b6293d7$export$fddcfb23c3a05835 = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeBlockComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the lines around the current selection using
block comments.
*/ const $032754016b6293d7$export$e88d9eff7cafcc34 = /*@__PURE__*/ $032754016b6293d7$var$command((o, s)=>$032754016b6293d7$var$changeBlockComment(o, s, $032754016b6293d7$var$selectedLineRanges(s)), 0 /* CommentOption.Toggle */ );
function $032754016b6293d7$var$getConfig(state, pos) {
    let data = state.languageDataAt("commentTokens", pos, 1);
    return data.length ? data[0] : {};
}
const $032754016b6293d7$var$SearchMargin = 50;
/**
Determines if the given range is block-commented in the given
state.
*/ function $032754016b6293d7$var$findBlockComment(state, { open: open, close: close }, from, to) {
    let textBefore = state.sliceDoc(from - $032754016b6293d7$var$SearchMargin, from);
    let textAfter = state.sliceDoc(to, to + $032754016b6293d7$var$SearchMargin);
    let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
    let beforeOff = textBefore.length - spaceBefore;
    if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) return {
        open: {
            pos: from - spaceBefore,
            margin: spaceBefore && 1
        },
        close: {
            pos: to + spaceAfter,
            margin: spaceAfter && 1
        }
    };
    let startText, endText;
    if (to - from <= 2 * $032754016b6293d7$var$SearchMargin) startText = endText = state.sliceDoc(from, to);
    else {
        startText = state.sliceDoc(from, from + $032754016b6293d7$var$SearchMargin);
        endText = state.sliceDoc(to - $032754016b6293d7$var$SearchMargin, to);
    }
    let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
    let endOff = endText.length - endSpace - close.length;
    if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) return {
        open: {
            pos: from + startSpace + open.length,
            margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
        },
        close: {
            pos: to - endSpace - close.length,
            margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
        }
    };
    return null;
}
function $032754016b6293d7$var$selectedLineRanges(state) {
    let ranges = [];
    for (let r of state.selection.ranges){
        let fromLine = state.doc.lineAt(r.from);
        let toLine = r.to <= fromLine.to ? fromLine : state.doc.lineAt(r.to);
        if (toLine.from > fromLine.from && toLine.from == r.to) toLine = r.to == fromLine.to + 1 ? fromLine : state.doc.lineAt(r.to - 1);
        let last = ranges.length - 1;
        if (last >= 0 && ranges[last].to > fromLine.from) ranges[last].to = toLine.to;
        else ranges.push({
            from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length,
            to: toLine.to
        });
    }
    return ranges;
}
// Performs toggle, comment and uncomment of block comments in
// languages that support them.
function $032754016b6293d7$var$changeBlockComment(option, state, ranges = state.selection.ranges) {
    let tokens = ranges.map((r)=>$032754016b6293d7$var$getConfig(state, r.from).block);
    if (!tokens.every((c)=>c)) return null;
    let comments = ranges.map((r, i)=>$032754016b6293d7$var$findBlockComment(state, tokens[i], r.from, r.to));
    if (option != 2 /* CommentOption.Uncomment */  && !comments.every((c)=>c)) return {
        changes: state.changes(ranges.map((range, i)=>{
            if (comments[i]) return [];
            return [
                {
                    from: range.from,
                    insert: tokens[i].open + " "
                },
                {
                    from: range.to,
                    insert: " " + tokens[i].close
                }
            ];
        }))
    };
    else if (option != 1 /* CommentOption.Comment */  && comments.some((c)=>c)) {
        let changes = [];
        for(let i = 0, comment; i < comments.length; i++)if (comment = comments[i]) {
            let token = tokens[i], { open: open, close: close } = comment;
            changes.push({
                from: open.pos - token.open.length,
                to: open.pos + open.margin
            }, {
                from: close.pos - close.margin,
                to: close.pos + token.close.length
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
// Performs toggle, comment and uncomment of line comments.
function $032754016b6293d7$var$changeLineComment(option, state, ranges = state.selection.ranges) {
    let lines = [];
    let prevLine = -1;
    for (let { from: from, to: to } of ranges){
        let startI = lines.length, minIndent = 1e9;
        let token = $032754016b6293d7$var$getConfig(state, from).line;
        if (!token) continue;
        for(let pos = from; pos <= to;){
            let line = state.doc.lineAt(pos);
            if (line.from > prevLine && (from == to || to > line.from)) {
                prevLine = line.from;
                let indent = /^\s*/.exec(line.text)[0].length;
                let empty = indent == line.length;
                let comment = line.text.slice(indent, indent + token.length) == token ? indent : -1;
                if (indent < line.text.length && indent < minIndent) minIndent = indent;
                lines.push({
                    line: line,
                    comment: comment,
                    token: token,
                    indent: indent,
                    empty: empty,
                    single: false
                });
            }
            pos = line.to + 1;
        }
        if (minIndent < 1e9) {
            for(let i = startI; i < lines.length; i++)if (lines[i].indent < lines[i].line.text.length) lines[i].indent = minIndent;
        }
        if (lines.length == startI + 1) lines[startI].single = true;
    }
    if (option != 2 /* CommentOption.Uncomment */  && lines.some((l)=>l.comment < 0 && (!l.empty || l.single))) {
        let changes = [];
        for (let { line: line, token: token, indent: indent, empty: empty, single: single } of lines)if (single || !empty) changes.push({
            from: line.from + indent,
            insert: token + " "
        });
        let changeSet = state.changes(changes);
        return {
            changes: changeSet,
            selection: state.selection.map(changeSet, 1)
        };
    } else if (option != 1 /* CommentOption.Comment */  && lines.some((l)=>l.comment >= 0)) {
        let changes = [];
        for (let { line: line, comment: comment, token: token } of lines)if (comment >= 0) {
            let from = line.from + comment, to = from + token.length;
            if (line.text[to - line.from] == " ") to++;
            changes.push({
                from: from,
                to: to
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
const $032754016b6293d7$var$fromHistory = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
/**
Transaction annotation that will prevent that transaction from
being combined with other transactions in the undo history. Given
`"before"`, it'll prevent merging with previous transactions. With
`"after"`, subsequent transactions won't be combined with this
one. With `"full"`, the transaction is isolated on both sides.
*/ const $032754016b6293d7$export$33e0bb25992f9954 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
/**
This facet provides a way to register functions that, given a
transaction, provide a set of effects that the history should
store when inverting the transaction. This can be used to
integrate some kinds of effects in the history, so that they can
be undone (and redone again).
*/ const $032754016b6293d7$export$edb12867fb9b2023 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $032754016b6293d7$var$historyConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            minDepth: 100,
            newGroupDelay: 500,
            joinToEvent: (_t, isAdjacent)=>isAdjacent
        }, {
            minDepth: Math.max,
            newGroupDelay: Math.min,
            joinToEvent: (a, b)=>(tr, adj)=>a(tr, adj) || b(tr, adj)
        });
    }
});
const $032754016b6293d7$var$historyField_ = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return $032754016b6293d7$var$HistoryState.empty;
    },
    update (state, tr) {
        let config = tr.state.facet($032754016b6293d7$var$historyConfig);
        let fromHist = tr.annotation($032754016b6293d7$var$fromHistory);
        if (fromHist) {
            let item = $032754016b6293d7$var$HistEvent.fromTransaction(tr, fromHist.selection), from = fromHist.side;
            let other = from == 0 /* BranchName.Done */  ? state.undone : state.done;
            if (item) other = $032754016b6293d7$var$updateBranch(other, other.length, config.minDepth, item);
            else other = $032754016b6293d7$var$addSelection(other, tr.startState.selection);
            return new $032754016b6293d7$var$HistoryState(from == 0 /* BranchName.Done */  ? fromHist.rest : other, from == 0 /* BranchName.Done */  ? other : fromHist.rest);
        }
        let isolate = tr.annotation($032754016b6293d7$export$33e0bb25992f9954);
        if (isolate == "full" || isolate == "before") state = state.isolate();
        if (tr.annotation((0, $6295c6875f57e3ee$export$febc5573c75cefb0).addToHistory) === false) return !tr.changes.empty ? state.addMapping(tr.changes.desc) : state;
        let event = $032754016b6293d7$var$HistEvent.fromTransaction(tr);
        let time = tr.annotation((0, $6295c6875f57e3ee$export$febc5573c75cefb0).time), userEvent = tr.annotation((0, $6295c6875f57e3ee$export$febc5573c75cefb0).userEvent);
        if (event) state = state.addChanges(event, time, userEvent, config, tr);
        else if (tr.selection) state = state.addSelection(tr.startState.selection, time, userEvent, config.newGroupDelay);
        if (isolate == "full" || isolate == "after") state = state.isolate();
        return state;
    },
    toJSON (value) {
        return {
            done: value.done.map((e)=>e.toJSON()),
            undone: value.undone.map((e)=>e.toJSON())
        };
    },
    fromJSON (json) {
        return new $032754016b6293d7$var$HistoryState(json.done.map($032754016b6293d7$var$HistEvent.fromJSON), json.undone.map($032754016b6293d7$var$HistEvent.fromJSON));
    }
});
/**
Create a history extension with the given configuration.
*/ function $032754016b6293d7$export$55abd4691b317664(config = {}) {
    return [
        $032754016b6293d7$var$historyField_,
        $032754016b6293d7$var$historyConfig.of(config),
        (0, $7beee9608540d2c3$export$eece2fccabbb77c5).domEventHandlers({
            beforeinput (e, view) {
                let command = e.inputType == "historyUndo" ? $032754016b6293d7$export$21f930c44940fd98 : e.inputType == "historyRedo" ? $032754016b6293d7$export$1688e416fee0a49e : null;
                if (!command) return false;
                e.preventDefault();
                return command(view);
            }
        })
    ];
}
/**
The state field used to store the history data. Should probably
only be used when you want to
[serialize](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) or
[deserialize](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) state objects in a way
that preserves history.
*/ const $032754016b6293d7$export$c00598b6ceeb3e9 = $032754016b6293d7$var$historyField_;
function $032754016b6293d7$var$cmd(side, selection) {
    return function({ state: state, dispatch: dispatch }) {
        if (!selection && state.readOnly) return false;
        let historyState = state.field($032754016b6293d7$var$historyField_, false);
        if (!historyState) return false;
        let tr = historyState.pop(side, state, selection);
        if (!tr) return false;
        dispatch(tr);
        return true;
    };
}
/**
Undo a single group of history events. Returns false if no group
was available.
*/ const $032754016b6293d7$export$21f930c44940fd98 = /*@__PURE__*/ $032754016b6293d7$var$cmd(0 /* BranchName.Done */ , false);
/**
Redo a group of history events. Returns false if no group was
available.
*/ const $032754016b6293d7$export$1688e416fee0a49e = /*@__PURE__*/ $032754016b6293d7$var$cmd(1 /* BranchName.Undone */ , false);
/**
Undo a change or selection change.
*/ const $032754016b6293d7$export$43103d47530fe49f = /*@__PURE__*/ $032754016b6293d7$var$cmd(0 /* BranchName.Done */ , true);
/**
Redo a change or selection change.
*/ const $032754016b6293d7$export$2d87af80f1777f20 = /*@__PURE__*/ $032754016b6293d7$var$cmd(1 /* BranchName.Undone */ , true);
function $032754016b6293d7$var$depth(side) {
    return function(state) {
        let histState = state.field($032754016b6293d7$var$historyField_, false);
        if (!histState) return 0;
        let branch = side == 0 /* BranchName.Done */  ? histState.done : histState.undone;
        return branch.length - (branch.length && !branch[0].changes ? 1 : 0);
    };
}
/**
The amount of undoable change events available in a given state.
*/ const $032754016b6293d7$export$f8a176c2b9a10bdb = /*@__PURE__*/ $032754016b6293d7$var$depth(0 /* BranchName.Done */ );
/**
The amount of redoable change events available in a given state.
*/ const $032754016b6293d7$export$3ffe6b288e7d941b = /*@__PURE__*/ $032754016b6293d7$var$depth(1 /* BranchName.Undone */ );
// History events store groups of changes or effects that need to be
// undone/redone together.
class $032754016b6293d7$var$HistEvent {
    constructor(// The changes in this event. Normal events hold at least one
    // change or effect. But it may be necessary to store selection
    // events before the first change, in which case a special type of
    // instance is created which doesn't hold any changes, with
    // changes == startSelection == undefined
    changes, // The effects associated with this event
    effects, // Accumulated mapping (from addToHistory==false) that should be
    // applied to events below this one.
    mapped, // The selection before this event
    startSelection, // Stores selection changes after this event, to be used for
    // selection undo/redo.
    selectionsAfter){
        this.changes = changes;
        this.effects = effects;
        this.mapped = mapped;
        this.startSelection = startSelection;
        this.selectionsAfter = selectionsAfter;
    }
    setSelAfter(after) {
        return new $032754016b6293d7$var$HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after);
    }
    toJSON() {
        var _a, _b, _c;
        return {
            changes: (_a = this.changes) === null || _a === void 0 ? void 0 : _a.toJSON(),
            mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
            startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
            selectionsAfter: this.selectionsAfter.map((s)=>s.toJSON())
        };
    }
    static fromJSON(json) {
        return new $032754016b6293d7$var$HistEvent(json.changes && (0, $6295c6875f57e3ee$export$29d7fbdcb1f8b71c).fromJSON(json.changes), [], json.mapped && (0, $6295c6875f57e3ee$export$34b6a936f2bb06a2).fromJSON(json.mapped), json.startSelection && (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).fromJSON(json.startSelection), json.selectionsAfter.map((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).fromJSON));
    }
    // This does not check `addToHistory` and such, it assumes the
    // transaction needs to be converted to an item. Returns null when
    // there are no changes or effects in the transaction.
    static fromTransaction(tr, selection) {
        let effects = $032754016b6293d7$var$none;
        for (let invert of tr.startState.facet($032754016b6293d7$export$edb12867fb9b2023)){
            let result = invert(tr);
            if (result.length) effects = effects.concat(result);
        }
        if (!effects.length && tr.changes.empty) return null;
        return new $032754016b6293d7$var$HistEvent(tr.changes.invert(tr.startState.doc), effects, undefined, selection || tr.startState.selection, $032754016b6293d7$var$none);
    }
    static selection(selections) {
        return new $032754016b6293d7$var$HistEvent(undefined, $032754016b6293d7$var$none, undefined, undefined, selections);
    }
}
function $032754016b6293d7$var$updateBranch(branch, to, maxLen, newEvent) {
    let start = to + 1 > maxLen + 20 ? to - maxLen - 1 : 0;
    let newBranch = branch.slice(start, to);
    newBranch.push(newEvent);
    return newBranch;
}
function $032754016b6293d7$var$isAdjacent(a, b) {
    let ranges = [], isAdjacent = false;
    a.iterChangedRanges((f, t)=>ranges.push(f, t));
    b.iterChangedRanges((_f, _t, f, t)=>{
        for(let i = 0; i < ranges.length;){
            let from = ranges[i++], to = ranges[i++];
            if (t >= from && f <= to) isAdjacent = true;
        }
    });
    return isAdjacent;
}
function $032754016b6293d7$var$eqSelectionShape(a, b) {
    return a.ranges.length == b.ranges.length && a.ranges.filter((r, i)=>r.empty != b.ranges[i].empty).length === 0;
}
function $032754016b6293d7$var$conc(a, b) {
    return !a.length ? b : !b.length ? a : a.concat(b);
}
const $032754016b6293d7$var$none = [];
const $032754016b6293d7$var$MaxSelectionsPerEvent = 200;
function $032754016b6293d7$var$addSelection(branch, selection) {
    if (!branch.length) return [
        $032754016b6293d7$var$HistEvent.selection([
            selection
        ])
    ];
    else {
        let lastEvent = branch[branch.length - 1];
        let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - $032754016b6293d7$var$MaxSelectionsPerEvent));
        if (sels.length && sels[sels.length - 1].eq(selection)) return branch;
        sels.push(selection);
        return $032754016b6293d7$var$updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
    }
}
// Assumes the top item has one or more selectionAfter values
function $032754016b6293d7$var$popSelection(branch) {
    let last = branch[branch.length - 1];
    let newBranch = branch.slice();
    newBranch[branch.length - 1] = last.setSelAfter(last.selectionsAfter.slice(0, last.selectionsAfter.length - 1));
    return newBranch;
}
// Add a mapping to the top event in the given branch. If this maps
// away all the changes and effects in that item, drop it and
// propagate the mapping to the next item.
function $032754016b6293d7$var$addMappingToBranch(branch, mapping) {
    if (!branch.length) return branch;
    let length = branch.length, selections = $032754016b6293d7$var$none;
    while(length){
        let event = $032754016b6293d7$var$mapEvent(branch[length - 1], mapping, selections);
        if (event.changes && !event.changes.empty || event.effects.length) {
            let result = branch.slice(0, length);
            result[length - 1] = event;
            return result;
        } else {
            mapping = event.mapped;
            length--;
            selections = event.selectionsAfter;
        }
    }
    return selections.length ? [
        $032754016b6293d7$var$HistEvent.selection(selections)
    ] : $032754016b6293d7$var$none;
}
function $032754016b6293d7$var$mapEvent(event, mapping, extraSelections) {
    let selections = $032754016b6293d7$var$conc(event.selectionsAfter.length ? event.selectionsAfter.map((s)=>s.map(mapping)) : $032754016b6293d7$var$none, extraSelections);
    // Change-less events don't store mappings (they are always the last event in a branch)
    if (!event.changes) return $032754016b6293d7$var$HistEvent.selection(selections);
    let mappedChanges = event.changes.map(mapping), before = mapping.mapDesc(event.changes, true);
    let fullMapping = event.mapped ? event.mapped.composeDesc(before) : before;
    return new $032754016b6293d7$var$HistEvent(mappedChanges, (0, $6295c6875f57e3ee$export$95000d4efaa4321f).mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before), selections);
}
const $032754016b6293d7$var$joinableUserEvent = /^(input\.type|delete)($|\.)/;
class $032754016b6293d7$var$HistoryState {
    constructor(done, undone, prevTime = 0, prevUserEvent){
        this.done = done;
        this.undone = undone;
        this.prevTime = prevTime;
        this.prevUserEvent = prevUserEvent;
    }
    isolate() {
        return this.prevTime ? new $032754016b6293d7$var$HistoryState(this.done, this.undone) : this;
    }
    addChanges(event, time, userEvent, config, tr) {
        let done = this.done, lastEvent = done[done.length - 1];
        if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || $032754016b6293d7$var$joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < config.newGroupDelay && config.joinToEvent(tr, $032754016b6293d7$var$isAdjacent(lastEvent.changes, event.changes)) || // For compose (but not compose.start) events, always join with previous event
        userEvent == "input.type.compose")) done = $032754016b6293d7$var$updateBranch(done, done.length - 1, config.minDepth, new $032754016b6293d7$var$HistEvent(event.changes.compose(lastEvent.changes), $032754016b6293d7$var$conc((0, $6295c6875f57e3ee$export$95000d4efaa4321f).mapEffects(event.effects, lastEvent.changes), lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, $032754016b6293d7$var$none));
        else done = $032754016b6293d7$var$updateBranch(done, done.length, config.minDepth, event);
        return new $032754016b6293d7$var$HistoryState(done, $032754016b6293d7$var$none, time, userEvent);
    }
    addSelection(selection, time, userEvent, newGroupDelay) {
        let last = this.done.length ? this.done[this.done.length - 1].selectionsAfter : $032754016b6293d7$var$none;
        if (last.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && $032754016b6293d7$var$eqSelectionShape(last[last.length - 1], selection)) return this;
        return new $032754016b6293d7$var$HistoryState($032754016b6293d7$var$addSelection(this.done, selection), this.undone, time, userEvent);
    }
    addMapping(mapping) {
        return new $032754016b6293d7$var$HistoryState($032754016b6293d7$var$addMappingToBranch(this.done, mapping), $032754016b6293d7$var$addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
    }
    pop(side, state, onlySelection) {
        let branch = side == 0 /* BranchName.Done */  ? this.done : this.undone;
        if (branch.length == 0) return null;
        let event = branch[branch.length - 1], selection = event.selectionsAfter[0] || state.selection;
        if (onlySelection && event.selectionsAfter.length) return state.update({
            selection: event.selectionsAfter[event.selectionsAfter.length - 1],
            annotations: $032754016b6293d7$var$fromHistory.of({
                side: side,
                rest: $032754016b6293d7$var$popSelection(branch),
                selection: selection
            }),
            userEvent: side == 0 /* BranchName.Done */  ? "select.undo" : "select.redo",
            scrollIntoView: true
        });
        else if (!event.changes) return null;
        else {
            let rest = branch.length == 1 ? $032754016b6293d7$var$none : branch.slice(0, branch.length - 1);
            if (event.mapped) rest = $032754016b6293d7$var$addMappingToBranch(rest, event.mapped);
            return state.update({
                changes: event.changes,
                selection: event.startSelection,
                effects: event.effects,
                annotations: $032754016b6293d7$var$fromHistory.of({
                    side: side,
                    rest: rest,
                    selection: selection
                }),
                filter: false,
                userEvent: side == 0 /* BranchName.Done */  ? "undo" : "redo",
                scrollIntoView: true
            });
        }
    }
}
$032754016b6293d7$var$HistoryState.empty = /*@__PURE__*/ new $032754016b6293d7$var$HistoryState($032754016b6293d7$var$none, $032754016b6293d7$var$none);
/**
Default key bindings for the undo history.

- Mod-z: [`undo`](https://codemirror.net/6/docs/ref/#commands.undo).
- Mod-y (Mod-Shift-z on macOS) + Ctrl-Shift-z on Linux: [`redo`](https://codemirror.net/6/docs/ref/#commands.redo).
- Mod-u: [`undoSelection`](https://codemirror.net/6/docs/ref/#commands.undoSelection).
- Alt-u (Mod-Shift-u on macOS): [`redoSelection`](https://codemirror.net/6/docs/ref/#commands.redoSelection).
*/ const $032754016b6293d7$export$ab4a28cb63e8a670 = [
    {
        key: "Mod-z",
        run: $032754016b6293d7$export$21f930c44940fd98,
        preventDefault: true
    },
    {
        key: "Mod-y",
        mac: "Mod-Shift-z",
        run: $032754016b6293d7$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        linux: "Ctrl-Shift-z",
        run: $032754016b6293d7$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        key: "Mod-u",
        run: $032754016b6293d7$export$43103d47530fe49f,
        preventDefault: true
    },
    {
        key: "Alt-u",
        mac: "Mod-Shift-u",
        run: $032754016b6293d7$export$2d87af80f1777f20,
        preventDefault: true
    }
];
function $032754016b6293d7$var$updateSel(sel, by) {
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(sel.ranges.map(by), sel.mainIndex);
}
function $032754016b6293d7$var$setSel(state, selection) {
    return state.update({
        selection: selection,
        scrollIntoView: true,
        userEvent: "select"
    });
}
function $032754016b6293d7$var$moveSel({ state: state, dispatch: dispatch }, how) {
    let selection = $032754016b6293d7$var$updateSel(state.selection, how);
    if (selection.eq(state.selection, true)) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
}
function $032754016b6293d7$var$rangeEnd(range, forward) {
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(forward ? range.to : range.from);
}
function $032754016b6293d7$var$cursorByChar(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
function $032754016b6293d7$var$ltrAtCursor(view) {
    return view.textDirectionAt(view.state.selection.main.head) == (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR;
}
/**
Move the selection one character to the left (which is backward in
left-to-right text, forward in right-to-left text).
*/ const $032754016b6293d7$export$3447f2b737925430 = (view)=>$032754016b6293d7$var$cursorByChar(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one character to the right.
*/ const $032754016b6293d7$export$e45941411d098b = (view)=>$032754016b6293d7$var$cursorByChar(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one character forward.
*/ const $032754016b6293d7$export$25b7809021291927 = (view)=>$032754016b6293d7$var$cursorByChar(view, true);
/**
Move the selection one character backward.
*/ const $032754016b6293d7$export$6ddc33d0aa7a1b65 = (view)=>$032754016b6293d7$var$cursorByChar(view, false);
function $032754016b6293d7$var$byCharLogical(state, range, forward) {
    let pos = range.head, line = state.doc.lineAt(pos);
    if (pos == (forward ? line.to : line.from)) pos = forward ? Math.min(state.doc.length, line.to + 1) : Math.max(0, line.from - 1);
    else pos = line.from + (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward);
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
}
function $032754016b6293d7$var$moveByCharLogical(target, forward) {
    return $032754016b6293d7$var$moveSel(target, (range)=>range.empty ? $032754016b6293d7$var$byCharLogical(target.state, range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
/**
Move the selection one character forward, in logical
(non-text-direction-aware) string index order.
*/ const $032754016b6293d7$export$7ce32ef700b0ef27 = (target)=>$032754016b6293d7$var$moveByCharLogical(target, true);
/**
Move the selection one character backward, in logical string index
order.
*/ const $032754016b6293d7$export$a4c56edc7f7903df = (target)=>$032754016b6293d7$var$moveByCharLogical(target, false);
function $032754016b6293d7$var$cursorByGroup(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? view.moveByGroup(range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
/**
Move the selection to the left across one group of word or
non-word (but also non-space) characters.
*/ const $032754016b6293d7$export$137fb1611fb38377 = (view)=>$032754016b6293d7$var$cursorByGroup(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one group to the right.
*/ const $032754016b6293d7$export$8fb2c619d55341b4 = (view)=>$032754016b6293d7$var$cursorByGroup(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one group forward.
*/ const $032754016b6293d7$export$ce8d94762dbdebb8 = (view)=>$032754016b6293d7$var$cursorByGroup(view, true);
/**
Move the selection one group backward.
*/ const $032754016b6293d7$export$dd83d1d646f184d8 = (view)=>$032754016b6293d7$var$cursorByGroup(view, false);
function $032754016b6293d7$var$toGroupStart(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start), initial = cat != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space;
    return (next)=>{
        let nextCat = categorize(next);
        if (nextCat != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space) return initial && nextCat == cat;
        initial = false;
        return true;
    };
}
/**
Move the cursor one group forward in the default Windows style,
where it moves to the start of the next group.
*/ const $032754016b6293d7$export$c0e6054be0198e65 = (view)=>{
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, true, (start)=>$032754016b6293d7$var$toGroupStart(view, range.head, start)) : $032754016b6293d7$var$rangeEnd(range, true));
};
const $032754016b6293d7$var$segmenter = typeof Intl != "undefined" && Intl.Segmenter ? /*@__PURE__*/ new Intl.Segmenter(undefined, {
    granularity: "word"
}) : null;
function $032754016b6293d7$var$moveBySubword(view, range, forward) {
    let categorize = view.state.charCategorizer(range.from);
    let cat = (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space, pos = range.from, steps = 0;
    let done = false, sawUpper = false, sawLower = false;
    let step = (next)=>{
        if (done) return false;
        pos += forward ? next.length : -next.length;
        let nextCat = categorize(next), ahead;
        if (nextCat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && next.charCodeAt(0) < 128 && /[\W_]/.test(next)) nextCat = -1; // Treat word punctuation specially
        if (cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space) cat = nextCat;
        if (cat != nextCat) return false;
        if (cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) {
            if (next.toLowerCase() == next) {
                if (!forward && sawUpper) return false;
                sawLower = true;
            } else if (sawLower) {
                if (forward) return false;
                done = true;
            } else {
                if (sawUpper && forward && categorize(ahead = view.state.sliceDoc(pos, pos + 1)) == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && ahead.toLowerCase() == ahead) return false;
                sawUpper = true;
            }
        }
        steps++;
        return true;
    };
    let end = view.moveByChar(range, forward, (start)=>{
        step(start);
        return step;
    });
    if ($032754016b6293d7$var$segmenter && cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && end.from == range.from + steps * (forward ? 1 : -1)) {
        let from = Math.min(range.head, end.head), to = Math.max(range.head, end.head);
        let skipped = view.state.sliceDoc(from, to);
        if (skipped.length > 1 && /[\u4E00-\uffff]/.test(skipped)) {
            let segments = Array.from($032754016b6293d7$var$segmenter.segment(skipped));
            if (segments.length > 1) {
                if (forward) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head + segments[1].index, -1);
                return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(end.head + segments[segments.length - 1].index, 1);
            }
        }
    }
    return end;
}
function $032754016b6293d7$var$cursorBySubword(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? $032754016b6293d7$var$moveBySubword(view, range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
/**
Move the selection one group or camel-case subword forward.
*/ const $032754016b6293d7$export$d969a5b0dca9c3e2 = (view)=>$032754016b6293d7$var$cursorBySubword(view, true);
/**
Move the selection one group or camel-case subword backward.
*/ const $032754016b6293d7$export$ade35f5607ad3d82 = (view)=>$032754016b6293d7$var$cursorBySubword(view, false);
function $032754016b6293d7$var$interestingNode(state, node, bracketProp) {
    if (node.type.prop(bracketProp)) return true;
    let len = node.to - node.from;
    return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function $032754016b6293d7$var$moveBySyntax(state, start, forward) {
    let pos = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(start.head);
    let bracketProp = forward ? (0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy : (0, $ed739beecf769914$export$b8034b9bc18acd90).openedBy;
    // Scan forward through child nodes to see if there's an interesting
    // node ahead.
    for(let at = start.head;;){
        let next = forward ? pos.childAfter(at) : pos.childBefore(at);
        if (!next) break;
        if ($032754016b6293d7$var$interestingNode(state, next, bracketProp)) pos = next;
        else at = forward ? next.to : next.from;
    }
    let bracket = pos.type.prop(bracketProp), match, newPos;
    if (bracket && (match = forward ? (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, pos.from, 1) : (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, pos.to, -1)) && match.matched) newPos = forward ? match.end.to : match.end.from;
    else newPos = forward ? pos.to : pos.from;
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(newPos, forward ? -1 : 1);
}
/**
Move the cursor over the next syntactic element to the left.
*/ const $032754016b6293d7$export$1e53c014543c10bb = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the cursor over the next syntactic element to the right.
*/ const $032754016b6293d7$export$62c6dc33f5d01e39 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, $032754016b6293d7$var$ltrAtCursor(view)));
function $032754016b6293d7$var$cursorByLine(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>{
        if (!range.empty) return $032754016b6293d7$var$rangeEnd(range, forward);
        let moved = view.moveVertically(range, forward);
        return moved.head != range.head ? moved : view.moveToLineBoundary(range, forward);
    });
}
/**
Move the selection one line up.
*/ const $032754016b6293d7$export$fe179dad0485d99d = (view)=>$032754016b6293d7$var$cursorByLine(view, false);
/**
Move the selection one line down.
*/ const $032754016b6293d7$export$75f9b75ffb1a9dc5 = (view)=>$032754016b6293d7$var$cursorByLine(view, true);
function $032754016b6293d7$var$pageInfo(view) {
    let selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
    let marginTop = 0, marginBottom = 0, height;
    if (selfScroll) {
        for (let source of view.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollMargins)){
            let margins = source(view);
            if (margins === null || margins === void 0 ? void 0 : margins.top) marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
            if (margins === null || margins === void 0 ? void 0 : margins.bottom) marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
        }
        height = view.scrollDOM.clientHeight - marginTop - marginBottom;
    } else height = (view.dom.ownerDocument.defaultView || window).innerHeight;
    return {
        marginTop: marginTop,
        marginBottom: marginBottom,
        selfScroll: selfScroll,
        height: Math.max(view.defaultLineHeight, height - 5)
    };
}
function $032754016b6293d7$var$cursorByPage(view, forward) {
    let page = $032754016b6293d7$var$pageInfo(view);
    let { state: state } = view, selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        return range.empty ? view.moveVertically(range, forward, page.height) : $032754016b6293d7$var$rangeEnd(range, forward);
    });
    if (selection.eq(state.selection)) return false;
    let effect;
    if (page.selfScroll) {
        let startPos = view.coordsAtPos(state.selection.main.head);
        let scrollRect = view.scrollDOM.getBoundingClientRect();
        let scrollTop = scrollRect.top + page.marginTop, scrollBottom = scrollRect.bottom - page.marginBottom;
        if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom) effect = (0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(selection.main.head, {
            y: "start",
            yMargin: startPos.top - scrollTop
        });
    }
    view.dispatch($032754016b6293d7$var$setSel(state, selection), {
        effects: effect
    });
    return true;
}
/**
Move the selection one page up.
*/ const $032754016b6293d7$export$546ec71a9f854193 = (view)=>$032754016b6293d7$var$cursorByPage(view, false);
/**
Move the selection one page down.
*/ const $032754016b6293d7$export$6e407c2072d437f4 = (view)=>$032754016b6293d7$var$cursorByPage(view, true);
function $032754016b6293d7$var$moveByLineBoundary(view, start, forward) {
    let line = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
    if (moved.head == start.head && moved.head != (forward ? line.to : line.from)) moved = view.moveToLineBoundary(start, forward, false);
    if (!forward && moved.head == line.from && line.length) {
        let space = /^\s*/.exec(view.state.sliceDoc(line.from, Math.min(line.from + 100, line.to)))[0].length;
        if (space && start.head != line.from + space) moved = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(line.from + space);
    }
    return moved;
}
/**
Move the selection to the next line wrap point, or to the end of
the line if there isn't one left on this line.
*/ const $032754016b6293d7$export$b59ae3b25af6ea13 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, true));
/**
Move the selection to previous line wrap point, or failing that to
the start of the line. If the line is indented, and the cursor
isn't already at the end of the indentation, this will move to the
end of the indentation instead of the start of the line.
*/ const $032754016b6293d7$export$64939ebc49b03818 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, false));
/**
Move the selection one line wrap point to the left.
*/ const $032754016b6293d7$export$515c8c77cfbd2e73 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection one line wrap point to the right.
*/ const $032754016b6293d7$export$912e453a1e062a62 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, $032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection to the start of the line.
*/ const $032754016b6293d7$export$9c7dea99650bd512 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from, 1));
/**
Move the selection to the end of the line.
*/ const $032754016b6293d7$export$2a3cdaf3ab2dcbf2 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to, -1));
function $032754016b6293d7$var$toMatchingBracket(state, dispatch, extend) {
    let found = false, selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        let matching = (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head, -1) || (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head, 1) || range.head > 0 && (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head - 1, 1) || range.head < state.doc.length && (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head + 1, -1);
        if (!matching || !matching.end) return range;
        found = true;
        let head = matching.start.from == range.head ? matching.end.to : matching.end.from;
        return extend ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor, head) : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(head);
    });
    if (!found) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
}
/**
Move the selection to the bracket matching the one it is currently
on, if any.
*/ const $032754016b6293d7$export$e5a7e1f2d38b1f6a = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$toMatchingBracket(state, dispatch, false);
/**
Extend the selection to the bracket matching the one the selection
head is currently on, if any.
*/ const $032754016b6293d7$export$a56168b85007a381 = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$toMatchingBracket(state, dispatch, true);
function $032754016b6293d7$var$extendSel(target, how) {
    let selection = $032754016b6293d7$var$updateSel(target.state.selection, (range)=>{
        let head = how(range);
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor, head.head, head.goalColumn, head.bidiLevel || undefined);
    });
    if (selection.eq(target.state.selection)) return false;
    target.dispatch($032754016b6293d7$var$setSel(target.state, selection));
    return true;
}
function $032754016b6293d7$var$selectByChar(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveByChar(range, forward));
}
/**
Move the selection head one character to the left, while leaving
the anchor in place.
*/ const $032754016b6293d7$export$639be832433387f = (view)=>$032754016b6293d7$var$selectByChar(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one character to the right.
*/ const $032754016b6293d7$export$49e3d65796d89132 = (view)=>$032754016b6293d7$var$selectByChar(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one character forward.
*/ const $032754016b6293d7$export$6a18f0ec4e3aa4ba = (view)=>$032754016b6293d7$var$selectByChar(view, true);
/**
Move the selection head one character backward.
*/ const $032754016b6293d7$export$1132822fa6924c1d = (view)=>$032754016b6293d7$var$selectByChar(view, false);
/**
Move the selection head one character forward by logical
(non-direction aware) string index order.
*/ const $032754016b6293d7$export$74309692c7a8e2d9 = (target)=>$032754016b6293d7$var$extendSel(target, (range)=>$032754016b6293d7$var$byCharLogical(target.state, range, true));
/**
Move the selection head one character backward by logical string
index order.
*/ const $032754016b6293d7$export$2bfcd2df135aa168 = (target)=>$032754016b6293d7$var$extendSel(target, (range)=>$032754016b6293d7$var$byCharLogical(target.state, range, false));
function $032754016b6293d7$var$selectByGroup(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveByGroup(range, forward));
}
/**
Move the selection head one [group](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) to
the left.
*/ const $032754016b6293d7$export$ef839611b4c2ba40 = (view)=>$032754016b6293d7$var$selectByGroup(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one group to the right.
*/ const $032754016b6293d7$export$5ebbb4cf65fe8a74 = (view)=>$032754016b6293d7$var$selectByGroup(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one group forward.
*/ const $032754016b6293d7$export$53ddb317471acf76 = (view)=>$032754016b6293d7$var$selectByGroup(view, true);
/**
Move the selection head one group backward.
*/ const $032754016b6293d7$export$65a2ce60964fa778 = (view)=>$032754016b6293d7$var$selectByGroup(view, false);
/**
Move the selection head one group forward in the default Windows
style, skipping to the start of the next group.
*/ const $032754016b6293d7$export$5ea626eef31f242e = (view)=>{
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveByChar(range, true, (start)=>$032754016b6293d7$var$toGroupStart(view, range.head, start)));
};
function $032754016b6293d7$var$selectBySubword(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveBySubword(view, range, forward));
}
/**
Move the selection head one group or camel-case subword forward.
*/ const $032754016b6293d7$export$c4f4d945a8760145 = (view)=>$032754016b6293d7$var$selectBySubword(view, true);
/**
Move the selection head one group or subword backward.
*/ const $032754016b6293d7$export$3a6caa1f1abce2e2 = (view)=>$032754016b6293d7$var$selectBySubword(view, false);
/**
Move the selection head over the next syntactic element to the left.
*/ const $032754016b6293d7$export$67b15be4414061b5 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection head over the next syntactic element to the right.
*/ const $032754016b6293d7$export$74aa476df7791ce = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, $032754016b6293d7$var$ltrAtCursor(view)));
function $032754016b6293d7$var$selectByLine(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveVertically(range, forward));
}
/**
Move the selection head one line up.
*/ const $032754016b6293d7$export$92aa693a1ecd7061 = (view)=>$032754016b6293d7$var$selectByLine(view, false);
/**
Move the selection head one line down.
*/ const $032754016b6293d7$export$bf847527697a3040 = (view)=>$032754016b6293d7$var$selectByLine(view, true);
function $032754016b6293d7$var$selectByPage(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveVertically(range, forward, $032754016b6293d7$var$pageInfo(view).height));
}
/**
Move the selection head one page up.
*/ const $032754016b6293d7$export$61eab34d4ff5cbaf = (view)=>$032754016b6293d7$var$selectByPage(view, false);
/**
Move the selection head one page down.
*/ const $032754016b6293d7$export$a4c186a0dadaf91c = (view)=>$032754016b6293d7$var$selectByPage(view, true);
/**
Move the selection head to the next line boundary.
*/ const $032754016b6293d7$export$df223d0097d57a86 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, true));
/**
Move the selection head to the previous line boundary.
*/ const $032754016b6293d7$export$643176ee603b8e87 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, false));
/**
Move the selection head one line boundary to the left.
*/ const $032754016b6293d7$export$769cc61da74090c5 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection head one line boundary to the right.
*/ const $032754016b6293d7$export$de427496204690a6 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, $032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection head to the start of the line.
*/ const $032754016b6293d7$export$a0e1e86f753956a4 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from));
/**
Move the selection head to the end of the line.
*/ const $032754016b6293d7$export$bd34a38d148e23af = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to));
/**
Move the selection to the start of the document.
*/ const $032754016b6293d7$export$ff7ed6e6e1cb317f = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: 0
    }));
    return true;
};
/**
Move the selection to the end of the document.
*/ const $032754016b6293d7$export$b12ef1671b2836da = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: state.doc.length
    }));
    return true;
};
/**
Move the selection head to the start of the document.
*/ const $032754016b6293d7$export$aa525ee829cc26b = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: 0
    }));
    return true;
};
/**
Move the selection head to the end of the document.
*/ const $032754016b6293d7$export$fff0131cdd9694fe = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: state.doc.length
    }));
    return true;
};
/**
Select the entire document.
*/ const $032754016b6293d7$export$90aca4adda6ff0f5 = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update({
        selection: {
            anchor: 0,
            head: state.doc.length
        },
        userEvent: "select"
    }));
    return true;
};
/**
Expand the selection to cover entire lines.
*/ const $032754016b6293d7$export$e41c12847640c21 = ({ state: state, dispatch: dispatch })=>{
    let ranges = $032754016b6293d7$var$selectedLineBlocks(state).map(({ from: from, to: to })=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, Math.min(to + 1, state.doc.length)));
    dispatch(state.update({
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges),
        userEvent: "select"
    }));
    return true;
};
/**
Select the next syntactic construct that is larger than the
selection. Note that this will only work insofar as the language
[provider](https://codemirror.net/6/docs/ref/#language.language) you use builds up a full
syntax tree.
*/ const $032754016b6293d7$export$f38a48fa120d50ce = ({ state: state, dispatch: dispatch })=>{
    let selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        let tree = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state), stack = tree.resolveStack(range.from, 1);
        if (range.empty) {
            let stackBefore = tree.resolveStack(range.from, -1);
            if (stackBefore.node.from >= stack.node.from && stackBefore.node.to <= stack.node.to) stack = stackBefore;
        }
        for(let cur = stack; cur; cur = cur.next){
            let { node: node } = cur;
            if ((node.from < range.from && node.to >= range.to || node.to > range.to && node.from <= range.from) && cur.next) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(node.to, node.from);
        }
        return range;
    });
    if (selection.eq(state.selection)) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
};
function $032754016b6293d7$var$addCursorVertically(view, forward) {
    let { state: state } = view, sel = state.selection, ranges = state.selection.ranges.slice();
    for (let range of state.selection.ranges){
        let line = state.doc.lineAt(range.head);
        if (forward ? line.to < view.state.doc.length : line.from > 0) for(let cur = range;;){
            let next = view.moveVertically(cur, forward);
            if (next.head < line.from || next.head > line.to) {
                if (!ranges.some((r)=>r.head == next.head)) ranges.push(next);
                break;
            } else if (next.head == cur.head) break;
            else cur = next;
        }
    }
    if (ranges.length == sel.ranges.length) return false;
    view.dispatch($032754016b6293d7$var$setSel(state, (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, ranges.length - 1)));
    return true;
}
/**
Expand the selection by adding a cursor above the heads of
currently selected ranges.
*/ const $032754016b6293d7$export$3054522ff62988dd = (view)=>$032754016b6293d7$var$addCursorVertically(view, false);
/**
Expand the selection by adding a cursor below the heads of
currently selected ranges.
*/ const $032754016b6293d7$export$83ff5bba776179f3 = (view)=>$032754016b6293d7$var$addCursorVertically(view, true);
/**
Simplify the current selection. When multiple ranges are selected,
reduce it to its main range. Otherwise, if the selection is
non-empty, convert it to a cursor selection.
*/ const $032754016b6293d7$export$2f90cebc0d40abf = ({ state: state, dispatch: dispatch })=>{
    let cur = state.selection, selection = null;
    if (cur.ranges.length > 1) selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
        cur.main
    ]);
    else if (!cur.main.empty) selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
        (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(cur.main.head)
    ]);
    if (!selection) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
};
function $032754016b6293d7$var$deleteBy(target, by) {
    if (target.state.readOnly) return false;
    let event = "delete.selection", { state: state } = target;
    let changes = state.changeByRange((range)=>{
        let { from: from, to: to } = range;
        if (from == to) {
            let towards = by(range);
            if (towards < from) {
                event = "delete.backward";
                towards = $032754016b6293d7$var$skipAtomic(target, towards, false);
            } else if (towards > from) {
                event = "delete.forward";
                towards = $032754016b6293d7$var$skipAtomic(target, towards, true);
            }
            from = Math.min(from, towards);
            to = Math.max(to, towards);
        } else {
            from = $032754016b6293d7$var$skipAtomic(target, from, false);
            to = $032754016b6293d7$var$skipAtomic(target, to, true);
        }
        return from == to ? {
            range: range
        } : {
            changes: {
                from: from,
                to: to
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(from, from < range.head ? -1 : 1)
        };
    });
    if (changes.changes.empty) return false;
    target.dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: event,
        effects: event == "delete.selection" ? (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(state.phrase("Selection deleted")) : undefined
    }));
    return true;
}
function $032754016b6293d7$var$skipAtomic(target, pos, forward) {
    if (target instanceof (0, $7beee9608540d2c3$export$eece2fccabbb77c5)) for (let ranges of target.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).atomicRanges).map((f)=>f(target)))ranges.between(pos, pos, (from, to)=>{
        if (from < pos && to > pos) pos = forward ? to : from;
    });
    return pos;
}
const $032754016b6293d7$var$deleteByChar = (target, forward, byIndentUnit)=>$032754016b6293d7$var$deleteBy(target, (range)=>{
        let pos = range.from, { state: state } = target, line = state.doc.lineAt(pos), before, targetPos;
        if (byIndentUnit && !forward && pos > line.from && pos < line.from + 200 && !/[^ \t]/.test(before = line.text.slice(0, pos - line.from))) {
            if (before[before.length - 1] == "\t") return pos - 1;
            let col = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(before, state.tabSize), drop = col % (0, $a97ccac5cf5f4f5d$export$ad3205d09311a797)(state) || (0, $a97ccac5cf5f4f5d$export$ad3205d09311a797)(state);
            for(let i = 0; i < drop && before[before.length - 1 - i] == " "; i++)pos--;
            targetPos = pos;
        } else {
            targetPos = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward, forward) + line.from;
            if (targetPos == pos && line.number != (forward ? state.doc.lines : 1)) targetPos += forward ? 1 : -1;
            else if (!forward && /[\ufe00-\ufe0f]/.test(line.text.slice(targetPos - line.from, pos - line.from))) targetPos = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, targetPos - line.from, false, false) + line.from;
        }
        return targetPos;
    });
/**
Delete the selection, or, for cursor selections, the character or
indentation unit before the cursor.
*/ const $032754016b6293d7$export$1e8a14efe7ca9a33 = (view)=>$032754016b6293d7$var$deleteByChar(view, false, true);
/**
Delete the selection or the character before the cursor. Does not
implement any extended behavior like deleting whole indentation
units in one go.
*/ const $032754016b6293d7$export$3365c1d7b1abe7df = (view)=>$032754016b6293d7$var$deleteByChar(view, false, false);
/**
Delete the selection or the character after the cursor.
*/ const $032754016b6293d7$export$d41683a0f042cb80 = (view)=>$032754016b6293d7$var$deleteByChar(view, true, false);
const $032754016b6293d7$var$deleteByGroup = (target, forward)=>$032754016b6293d7$var$deleteBy(target, (range)=>{
        let pos = range.head, { state: state } = target, line = state.doc.lineAt(pos);
        let categorize = state.charCategorizer(pos);
        for(let cat = null;;){
            if (pos == (forward ? line.to : line.from)) {
                if (pos == range.head && line.number != (forward ? state.doc.lines : 1)) pos += forward ? 1 : -1;
                break;
            }
            let next = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward) + line.from;
            let nextChar = line.text.slice(Math.min(pos, next) - line.from, Math.max(pos, next) - line.from);
            let nextCat = categorize(nextChar);
            if (cat != null && nextCat != cat) break;
            if (nextChar != " " || pos != range.head) cat = nextCat;
            pos = next;
        }
        return pos;
    });
/**
Delete the selection or backward until the end of the next
[group](https://codemirror.net/6/docs/ref/#view.EditorView.moveByGroup), only skipping groups of
whitespace when they consist of a single space.
*/ const $032754016b6293d7$export$3072f591ab219e94 = (target)=>$032754016b6293d7$var$deleteByGroup(target, false);
/**
Delete the selection or forward until the end of the next group.
*/ const $032754016b6293d7$export$56a4e2ef21b58242 = (target)=>$032754016b6293d7$var$deleteByGroup(target, true);
/**
Variant of [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
that uses the Windows convention of also deleting the whitespace
after a word.
*/ const $032754016b6293d7$export$94136ce5bc6ca33e = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>view.moveByChar(range, true, (start)=>$032754016b6293d7$var$toGroupStart(view, range.head, start)).head);
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line. If the cursor is directly at the end of the
line, delete the line break after it.
*/ const $032754016b6293d7$export$ae3820c4ce0e9c92 = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineEnd = view.lineBlockAt(range.head).to;
        return range.head < lineEnd ? lineEnd : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line. If the cursor is directly at the start of the
line, delete the line break before it.
*/ const $032754016b6293d7$export$dc80e21fb31e84a5 = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineStart = view.lineBlockAt(range.head).from;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line or the next line wrap before the cursor.
*/ const $032754016b6293d7$export$d1072494cede984a = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, false).head;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line or the next line wrap after the cursor.
*/ const $032754016b6293d7$export$b87eb3a389c264a4 = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, true).head;
        return range.head < lineStart ? lineStart : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete all whitespace directly before a line end from the
document.
*/ const $032754016b6293d7$export$8acd3a9fe3872724 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = [];
    for(let pos = 0, prev = "", iter = state.doc.iter();;){
        iter.next();
        if (iter.lineBreak || iter.done) {
            let trailing = prev.search(/\s+$/);
            if (trailing > -1) changes.push({
                from: pos - (prev.length - trailing),
                to: pos
            });
            if (iter.done) break;
            prev = "";
        } else prev = iter.value;
        pos += iter.value.length;
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        userEvent: "delete"
    }));
    return true;
};
/**
Replace each selection range with a line break, leaving the cursor
on the line before the break.
*/ const $032754016b6293d7$export$a258d4581e1d5d3c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                    "",
                    ""
                ])
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from)
        };
    });
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Flip the characters before and after the cursor(s).
*/ const $032754016b6293d7$export$55467a37288e4063 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        if (!range.empty || range.from == 0 || range.from == state.doc.length) return {
            range: range
        };
        let pos = range.from, line = state.doc.lineAt(pos);
        let from = pos == line.from ? pos - 1 : (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, false) + line.from;
        let to = pos == line.to ? pos + 1 : (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, true) + line.from;
        return {
            changes: {
                from: from,
                to: to,
                insert: state.doc.slice(pos, to).append(state.doc.slice(from, pos))
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(to)
        };
    });
    if (changes.changes.empty) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "move.character"
    }));
    return true;
};
function $032754016b6293d7$var$selectedLineBlocks(state) {
    let blocks = [], upto = -1;
    for (let range of state.selection.ranges){
        let startLine = state.doc.lineAt(range.from), endLine = state.doc.lineAt(range.to);
        if (!range.empty && range.to == endLine.from) endLine = state.doc.lineAt(range.to - 1);
        if (upto >= startLine.number) {
            let prev = blocks[blocks.length - 1];
            prev.to = endLine.to;
            prev.ranges.push(range);
        } else blocks.push({
            from: startLine.from,
            to: endLine.to,
            ranges: [
                range
            ]
        });
        upto = endLine.number + 1;
    }
    return blocks;
}
function $032754016b6293d7$var$moveLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [], ranges = [];
    for (let block of $032754016b6293d7$var$selectedLineBlocks(state)){
        if (forward ? block.to == state.doc.length : block.from == 0) continue;
        let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
        let size = nextLine.length + 1;
        if (forward) {
            changes.push({
                from: block.to,
                to: nextLine.to
            }, {
                from: block.from,
                insert: nextLine.text + state.lineBreak
            });
            for (let r of block.ranges)ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(Math.min(state.doc.length, r.anchor + size), Math.min(state.doc.length, r.head + size)));
        } else {
            changes.push({
                from: nextLine.from,
                to: block.from
            }, {
                from: block.to,
                insert: state.lineBreak + nextLine.text
            });
            for (let r of block.ranges)ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(r.anchor - size, r.head - size));
        }
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, state.selection.mainIndex),
        userEvent: "move.line"
    }));
    return true;
}
/**
Move the selected lines up one line.
*/ const $032754016b6293d7$export$c4eebaf75cfae23e = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$moveLine(state, dispatch, false);
/**
Move the selected lines down one line.
*/ const $032754016b6293d7$export$ac19ae98a6fcd34c = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$moveLine(state, dispatch, true);
function $032754016b6293d7$var$copyLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [];
    for (let block of $032754016b6293d7$var$selectedLineBlocks(state))if (forward) changes.push({
        from: block.from,
        insert: state.doc.slice(block.from, block.to) + state.lineBreak
    });
    else changes.push({
        from: block.to,
        insert: state.lineBreak + state.doc.slice(block.from, block.to)
    });
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        userEvent: "input.copyline"
    }));
    return true;
}
/**
Create a copy of the selected lines. Keep the selection in the top copy.
*/ const $032754016b6293d7$export$c3798d29213e527c = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$copyLine(state, dispatch, false);
/**
Create a copy of the selected lines. Keep the selection in the bottom copy.
*/ const $032754016b6293d7$export$1ad385c375816d2f = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$copyLine(state, dispatch, true);
/**
Delete selected lines.
*/ const $032754016b6293d7$export$aba0d4cd8923f1ae = (view)=>{
    if (view.state.readOnly) return false;
    let { state: state } = view, changes = state.changes($032754016b6293d7$var$selectedLineBlocks(state).map(({ from: from, to: to })=>{
        if (from > 0) from--;
        else if (to < state.doc.length) to++;
        return {
            from: from,
            to: to
        };
    }));
    let selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        let dist = undefined;
        if (view.lineWrapping) {
            let block = view.lineBlockAt(range.head), pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (pos) dist = block.bottom + view.documentTop - pos.bottom + view.defaultLineHeight / 2;
        }
        return view.moveVertically(range, true, dist);
    }).map(changes);
    view.dispatch({
        changes: changes,
        selection: selection,
        scrollIntoView: true,
        userEvent: "delete.line"
    });
    return true;
};
/**
Replace the selection with a newline.
*/ const $032754016b6293d7$export$e7e1d174affeae8d = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.replaceSelection(state.lineBreak), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Replace the selection with a newline and the same amount of
indentation as the line above.
*/ const $032754016b6293d7$export$8dc33eb9291e07ef = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.changeByRange((range)=>{
        let indent = /^\s*/.exec(state.doc.lineAt(range.from).text)[0];
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: state.lineBreak + indent
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + indent.length + 1)
        };
    }), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
function $032754016b6293d7$var$isBetweenBrackets(state, pos) {
    if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1))) return {
        from: pos,
        to: pos
    };
    let context = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos);
    let before = context.childBefore(pos), after = context.childAfter(pos), closedBy;
    if (before && after && before.to <= pos && after.from >= pos && (closedBy = before.type.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy)) && closedBy.indexOf(after.name) > -1 && state.doc.lineAt(before.to).from == state.doc.lineAt(after.from).from && !/\S/.test(state.sliceDoc(before.to, after.from))) return {
        from: before.to,
        to: after.from
    };
    return null;
}
/**
Replace the selection with a newline and indent the newly created
line(s). If the current line consists only of whitespace, this
will also delete that whitespace. When the cursor is between
matching brackets, an additional newline will be inserted after
the cursor.
*/ const $032754016b6293d7$export$668310d2b1aa07d5 = /*@__PURE__*/ $032754016b6293d7$var$newlineAndIndent(false);
/**
Create a blank, indented line below the current line.
*/ const $032754016b6293d7$export$2ff1ccbcf65d0770 = /*@__PURE__*/ $032754016b6293d7$var$newlineAndIndent(true);
function $032754016b6293d7$var$newlineAndIndent(atEof) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let changes = state.changeByRange((range)=>{
            let { from: from, to: to } = range, line = state.doc.lineAt(from);
            let explode = !atEof && from == to && $032754016b6293d7$var$isBetweenBrackets(state, from);
            if (atEof) from = to = (to <= line.to ? line : state.doc.lineAt(to)).to;
            let cx = new (0, $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8)(state, {
                simulateBreak: from,
                simulateDoubleBreak: !!explode
            });
            let indent = (0, $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211)(cx, from);
            if (indent == null) indent = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(/^\s*/.exec(state.doc.lineAt(from).text)[0], state.tabSize);
            while(to < line.to && /\s/.test(line.text[to - line.from]))to++;
            if (explode) ({ from: from, to: to } = explode);
            else if (from > line.from && from < line.from + 100 && !/\S/.test(line.text.slice(0, from))) from = line.from;
            let insert = [
                "",
                (0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, indent)
            ];
            if (explode) insert.push((0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, cx.lineIndent(line.from, -1)));
            return {
                changes: {
                    from: from,
                    to: to,
                    insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(insert)
                },
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(from + 1 + insert[1].length)
            };
        });
        dispatch(state.update(changes, {
            scrollIntoView: true,
            userEvent: "input"
        }));
        return true;
    };
}
function $032754016b6293d7$var$changeBySelectedLine(state, f) {
    let atLine = -1;
    return state.changeByRange((range)=>{
        let changes = [];
        for(let pos = range.from; pos <= range.to;){
            let line = state.doc.lineAt(pos);
            if (line.number > atLine && (range.empty || range.to > line.from)) {
                f(line, changes, range);
                atLine = line.number;
            }
            pos = line.to + 1;
        }
        let changeSet = state.changes(changes);
        return {
            changes: changes,
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(changeSet.mapPos(range.anchor, 1), changeSet.mapPos(range.head, 1))
        };
    });
}
/**
Auto-indent the selected lines. This uses the [indentation service
facet](https://codemirror.net/6/docs/ref/#language.indentService) as source for auto-indent
information.
*/ const $032754016b6293d7$export$ffcf50534fec79c3 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let updated = Object.create(null);
    let context = new (0, $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8)(state, {
        overrideIndentation: (start)=>{
            let found = updated[start];
            return found == null ? -1 : found;
        }
    });
    let changes = $032754016b6293d7$var$changeBySelectedLine(state, (line, changes, range)=>{
        let indent = (0, $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211)(context, line.from);
        if (indent == null) return;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = (0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, indent);
        if (cur != norm || range.from < line.from + cur.length) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    });
    if (!changes.changes.empty) dispatch(state.update(changes, {
        userEvent: "indent"
    }));
    return true;
};
/**
Add a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation to all selected
lines.
*/ const $032754016b6293d7$export$a61bf6a946ffc826 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($032754016b6293d7$var$changeBySelectedLine(state, (line, changes)=>{
        changes.push({
            from: line.from,
            insert: state.facet((0, $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5))
        });
    }), {
        userEvent: "input.indent"
    }));
    return true;
};
/**
Remove a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation from all
selected lines.
*/ const $032754016b6293d7$export$e4b902122bfe67ae = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($032754016b6293d7$var$changeBySelectedLine(state, (line, changes)=>{
        let space = /^\s*/.exec(line.text)[0];
        if (!space) return;
        let col = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(space, state.tabSize), keep = 0;
        let insert = (0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, Math.max(0, col - (0, $a97ccac5cf5f4f5d$export$ad3205d09311a797)(state)));
        while(keep < space.length && keep < insert.length && space.charCodeAt(keep) == insert.charCodeAt(keep))keep++;
        changes.push({
            from: line.from + keep,
            to: line.from + space.length,
            insert: insert.slice(keep)
        });
    }), {
        userEvent: "delete.dedent"
    }));
    return true;
};
/**
Enables or disables
[tab-focus mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode). While on, this
prevents the editor's key bindings from capturing Tab or
Shift-Tab, making it possible for the user to move focus out of
the editor with the keyboard.
*/ const $032754016b6293d7$export$f118650570e71643 = (view)=>{
    view.setTabFocusMode();
    return true;
};
/**
Temporarily enables [tab-focus
mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode) for two seconds or until
another key is pressed.
*/ const $032754016b6293d7$export$1f0650d3f23682c8 = (view)=>{
    view.setTabFocusMode(2000);
    return true;
};
/**
Insert a tab character at the cursor or, if something is selected,
use [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) to indent the entire
selection.
*/ const $032754016b6293d7$export$89b2fa0b43bd10f8 = ({ state: state, dispatch: dispatch })=>{
    if (state.selection.ranges.some((r)=>!r.empty)) return $032754016b6293d7$export$a61bf6a946ffc826({
        state: state,
        dispatch: dispatch
    });
    dispatch(state.update(state.replaceSelection("\t"), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Array of key bindings containing the Emacs-style bindings that are
available on macOS by default.

 - Ctrl-b: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - Ctrl-f: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-p: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - Ctrl-n: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Ctrl-a: [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Ctrl-e: [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - Ctrl-d: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-h: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Ctrl-k: [`deleteToLineEnd`](https://codemirror.net/6/docs/ref/#commands.deleteToLineEnd)
 - Ctrl-Alt-h: [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-o: [`splitLine`](https://codemirror.net/6/docs/ref/#commands.splitLine)
 - Ctrl-t: [`transposeChars`](https://codemirror.net/6/docs/ref/#commands.transposeChars)
 - Ctrl-v: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown)
 - Alt-v: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp)
*/ const $032754016b6293d7$export$ef7c3246c722c48f = [
    {
        key: "Ctrl-b",
        run: $032754016b6293d7$export$3447f2b737925430,
        shift: $032754016b6293d7$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Ctrl-f",
        run: $032754016b6293d7$export$e45941411d098b,
        shift: $032754016b6293d7$export$49e3d65796d89132
    },
    {
        key: "Ctrl-p",
        run: $032754016b6293d7$export$fe179dad0485d99d,
        shift: $032754016b6293d7$export$92aa693a1ecd7061
    },
    {
        key: "Ctrl-n",
        run: $032754016b6293d7$export$75f9b75ffb1a9dc5,
        shift: $032754016b6293d7$export$bf847527697a3040
    },
    {
        key: "Ctrl-a",
        run: $032754016b6293d7$export$9c7dea99650bd512,
        shift: $032754016b6293d7$export$a0e1e86f753956a4
    },
    {
        key: "Ctrl-e",
        run: $032754016b6293d7$export$2a3cdaf3ab2dcbf2,
        shift: $032754016b6293d7$export$bd34a38d148e23af
    },
    {
        key: "Ctrl-d",
        run: $032754016b6293d7$export$d41683a0f042cb80
    },
    {
        key: "Ctrl-h",
        run: $032754016b6293d7$export$1e8a14efe7ca9a33
    },
    {
        key: "Ctrl-k",
        run: $032754016b6293d7$export$ae3820c4ce0e9c92
    },
    {
        key: "Ctrl-Alt-h",
        run: $032754016b6293d7$export$3072f591ab219e94
    },
    {
        key: "Ctrl-o",
        run: $032754016b6293d7$export$a258d4581e1d5d3c
    },
    {
        key: "Ctrl-t",
        run: $032754016b6293d7$export$55467a37288e4063
    },
    {
        key: "Ctrl-v",
        run: $032754016b6293d7$export$6e407c2072d437f4
    }
];
/**
An array of key bindings closely sticking to platform-standard or
widely used bindings. (This includes the bindings from
[`emacsStyleKeymap`](https://codemirror.net/6/docs/ref/#commands.emacsStyleKeymap), with their `key`
property changed to `mac`.)

 - ArrowLeft: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - ArrowRight: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-ArrowLeft (Alt-ArrowLeft on macOS): [`cursorGroupLeft`](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) ([`selectGroupLeft`](https://codemirror.net/6/docs/ref/#commands.selectGroupLeft) with Shift)
 - Ctrl-ArrowRight (Alt-ArrowRight on macOS): [`cursorGroupRight`](https://codemirror.net/6/docs/ref/#commands.cursorGroupRight) ([`selectGroupRight`](https://codemirror.net/6/docs/ref/#commands.selectGroupRight) with Shift)
 - Cmd-ArrowLeft (on macOS): [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Cmd-ArrowRight (on macOS): [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - ArrowUp: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - ArrowDown: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Cmd-ArrowUp (on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Cmd-ArrowDown (on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Ctrl-ArrowUp (on macOS): [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - Ctrl-ArrowDown (on macOS): [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - PageUp: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - PageDown: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - Home: [`cursorLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryBackward) ([`selectLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryBackward) with Shift)
 - End: [`cursorLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryForward) ([`selectLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryForward) with Shift)
 - Ctrl-Home (Cmd-Home on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Ctrl-End (Cmd-Home on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Enter and Shift-Enter: [`insertNewlineAndIndent`](https://codemirror.net/6/docs/ref/#commands.insertNewlineAndIndent)
 - Ctrl-a (Cmd-a on macOS): [`selectAll`](https://codemirror.net/6/docs/ref/#commands.selectAll)
 - Backspace: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Delete: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-Backspace (Alt-Backspace on macOS): [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-Delete (Alt-Delete on macOS): [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
 - Cmd-Backspace (macOS): [`deleteLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryBackward).
 - Cmd-Delete (macOS): [`deleteLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryForward).
*/ const $032754016b6293d7$export$ae5dfd95be821a1c = /*@__PURE__*/ [
    {
        key: "ArrowLeft",
        run: $032754016b6293d7$export$3447f2b737925430,
        shift: $032754016b6293d7$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Mod-ArrowLeft",
        mac: "Alt-ArrowLeft",
        run: $032754016b6293d7$export$137fb1611fb38377,
        shift: $032754016b6293d7$export$ef839611b4c2ba40,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowLeft",
        run: $032754016b6293d7$export$515c8c77cfbd2e73,
        shift: $032754016b6293d7$export$769cc61da74090c5,
        preventDefault: true
    },
    {
        key: "ArrowRight",
        run: $032754016b6293d7$export$e45941411d098b,
        shift: $032754016b6293d7$export$49e3d65796d89132,
        preventDefault: true
    },
    {
        key: "Mod-ArrowRight",
        mac: "Alt-ArrowRight",
        run: $032754016b6293d7$export$8fb2c619d55341b4,
        shift: $032754016b6293d7$export$5ebbb4cf65fe8a74,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowRight",
        run: $032754016b6293d7$export$912e453a1e062a62,
        shift: $032754016b6293d7$export$de427496204690a6,
        preventDefault: true
    },
    {
        key: "ArrowUp",
        run: $032754016b6293d7$export$fe179dad0485d99d,
        shift: $032754016b6293d7$export$92aa693a1ecd7061,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowUp",
        run: $032754016b6293d7$export$ff7ed6e6e1cb317f,
        shift: $032754016b6293d7$export$aa525ee829cc26b
    },
    {
        mac: "Ctrl-ArrowUp",
        run: $032754016b6293d7$export$546ec71a9f854193,
        shift: $032754016b6293d7$export$61eab34d4ff5cbaf
    },
    {
        key: "ArrowDown",
        run: $032754016b6293d7$export$75f9b75ffb1a9dc5,
        shift: $032754016b6293d7$export$bf847527697a3040,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowDown",
        run: $032754016b6293d7$export$b12ef1671b2836da,
        shift: $032754016b6293d7$export$fff0131cdd9694fe
    },
    {
        mac: "Ctrl-ArrowDown",
        run: $032754016b6293d7$export$6e407c2072d437f4,
        shift: $032754016b6293d7$export$a4c186a0dadaf91c
    },
    {
        key: "PageUp",
        run: $032754016b6293d7$export$546ec71a9f854193,
        shift: $032754016b6293d7$export$61eab34d4ff5cbaf
    },
    {
        key: "PageDown",
        run: $032754016b6293d7$export$6e407c2072d437f4,
        shift: $032754016b6293d7$export$a4c186a0dadaf91c
    },
    {
        key: "Home",
        run: $032754016b6293d7$export$64939ebc49b03818,
        shift: $032754016b6293d7$export$643176ee603b8e87,
        preventDefault: true
    },
    {
        key: "Mod-Home",
        run: $032754016b6293d7$export$ff7ed6e6e1cb317f,
        shift: $032754016b6293d7$export$aa525ee829cc26b
    },
    {
        key: "End",
        run: $032754016b6293d7$export$b59ae3b25af6ea13,
        shift: $032754016b6293d7$export$df223d0097d57a86,
        preventDefault: true
    },
    {
        key: "Mod-End",
        run: $032754016b6293d7$export$b12ef1671b2836da,
        shift: $032754016b6293d7$export$fff0131cdd9694fe
    },
    {
        key: "Enter",
        run: $032754016b6293d7$export$668310d2b1aa07d5,
        shift: $032754016b6293d7$export$668310d2b1aa07d5
    },
    {
        key: "Mod-a",
        run: $032754016b6293d7$export$90aca4adda6ff0f5
    },
    {
        key: "Backspace",
        run: $032754016b6293d7$export$1e8a14efe7ca9a33,
        shift: $032754016b6293d7$export$1e8a14efe7ca9a33,
        preventDefault: true
    },
    {
        key: "Delete",
        run: $032754016b6293d7$export$d41683a0f042cb80,
        preventDefault: true
    },
    {
        key: "Mod-Backspace",
        mac: "Alt-Backspace",
        run: $032754016b6293d7$export$3072f591ab219e94,
        preventDefault: true
    },
    {
        key: "Mod-Delete",
        mac: "Alt-Delete",
        run: $032754016b6293d7$export$56a4e2ef21b58242,
        preventDefault: true
    },
    {
        mac: "Mod-Backspace",
        run: $032754016b6293d7$export$d1072494cede984a,
        preventDefault: true
    },
    {
        mac: "Mod-Delete",
        run: $032754016b6293d7$export$b87eb3a389c264a4,
        preventDefault: true
    }
].concat(/*@__PURE__*/ $032754016b6293d7$export$ef7c3246c722c48f.map((b)=>({
        mac: b.key,
        run: b.run,
        shift: b.shift
    })));
/**
The default keymap. Includes all bindings from
[`standardKeymap`](https://codemirror.net/6/docs/ref/#commands.standardKeymap) plus the following:

- Alt-ArrowLeft (Ctrl-ArrowLeft on macOS): [`cursorSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxLeft) ([`selectSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxLeft) with Shift)
- Alt-ArrowRight (Ctrl-ArrowRight on macOS): [`cursorSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxRight) ([`selectSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxRight) with Shift)
- Alt-ArrowUp: [`moveLineUp`](https://codemirror.net/6/docs/ref/#commands.moveLineUp)
- Alt-ArrowDown: [`moveLineDown`](https://codemirror.net/6/docs/ref/#commands.moveLineDown)
- Shift-Alt-ArrowUp: [`copyLineUp`](https://codemirror.net/6/docs/ref/#commands.copyLineUp)
- Shift-Alt-ArrowDown: [`copyLineDown`](https://codemirror.net/6/docs/ref/#commands.copyLineDown)
- Ctrl-Alt-ArrowUp (Cmd-Alt-ArrowUp on macOS): [`addCursorAbove`](https://codemirror.net/6/docs/ref/#commands.addCursorAbove).
- Ctrl-Alt-ArrowDown (Cmd-Alt-ArrowDown on macOS): [`addCursorBelow`](https://codemirror.net/6/docs/ref/#commands.addCursorBelow).
- Escape: [`simplifySelection`](https://codemirror.net/6/docs/ref/#commands.simplifySelection)
- Ctrl-Enter (Cmd-Enter on macOS): [`insertBlankLine`](https://codemirror.net/6/docs/ref/#commands.insertBlankLine)
- Alt-l (Ctrl-l on macOS): [`selectLine`](https://codemirror.net/6/docs/ref/#commands.selectLine)
- Ctrl-i (Cmd-i on macOS): [`selectParentSyntax`](https://codemirror.net/6/docs/ref/#commands.selectParentSyntax)
- Ctrl-[ (Cmd-[ on macOS): [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess)
- Ctrl-] (Cmd-] on macOS): [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore)
- Ctrl-Alt-\\ (Cmd-Alt-\\ on macOS): [`indentSelection`](https://codemirror.net/6/docs/ref/#commands.indentSelection)
- Shift-Ctrl-k (Shift-Cmd-k on macOS): [`deleteLine`](https://codemirror.net/6/docs/ref/#commands.deleteLine)
- Shift-Ctrl-\\ (Shift-Cmd-\\ on macOS): [`cursorMatchingBracket`](https://codemirror.net/6/docs/ref/#commands.cursorMatchingBracket)
- Ctrl-/ (Cmd-/ on macOS): [`toggleComment`](https://codemirror.net/6/docs/ref/#commands.toggleComment).
- Shift-Alt-a: [`toggleBlockComment`](https://codemirror.net/6/docs/ref/#commands.toggleBlockComment).
- Ctrl-m (Alt-Shift-m on macOS): [`toggleTabFocusMode`](https://codemirror.net/6/docs/ref/#commands.toggleTabFocusMode).
*/ const $032754016b6293d7$export$ab2e8d0ac5d2b69e = /*@__PURE__*/ [
    {
        key: "Alt-ArrowLeft",
        mac: "Ctrl-ArrowLeft",
        run: $032754016b6293d7$export$1e53c014543c10bb,
        shift: $032754016b6293d7$export$67b15be4414061b5
    },
    {
        key: "Alt-ArrowRight",
        mac: "Ctrl-ArrowRight",
        run: $032754016b6293d7$export$62c6dc33f5d01e39,
        shift: $032754016b6293d7$export$74aa476df7791ce
    },
    {
        key: "Alt-ArrowUp",
        run: $032754016b6293d7$export$c4eebaf75cfae23e
    },
    {
        key: "Shift-Alt-ArrowUp",
        run: $032754016b6293d7$export$c3798d29213e527c
    },
    {
        key: "Alt-ArrowDown",
        run: $032754016b6293d7$export$ac19ae98a6fcd34c
    },
    {
        key: "Shift-Alt-ArrowDown",
        run: $032754016b6293d7$export$1ad385c375816d2f
    },
    {
        key: "Mod-Alt-ArrowUp",
        run: $032754016b6293d7$export$3054522ff62988dd
    },
    {
        key: "Mod-Alt-ArrowDown",
        run: $032754016b6293d7$export$83ff5bba776179f3
    },
    {
        key: "Escape",
        run: $032754016b6293d7$export$2f90cebc0d40abf
    },
    {
        key: "Mod-Enter",
        run: $032754016b6293d7$export$2ff1ccbcf65d0770
    },
    {
        key: "Alt-l",
        mac: "Ctrl-l",
        run: $032754016b6293d7$export$e41c12847640c21
    },
    {
        key: "Mod-i",
        run: $032754016b6293d7$export$f38a48fa120d50ce,
        preventDefault: true
    },
    {
        key: "Mod-[",
        run: $032754016b6293d7$export$e4b902122bfe67ae
    },
    {
        key: "Mod-]",
        run: $032754016b6293d7$export$a61bf6a946ffc826
    },
    {
        key: "Mod-Alt-\\",
        run: $032754016b6293d7$export$ffcf50534fec79c3
    },
    {
        key: "Shift-Mod-k",
        run: $032754016b6293d7$export$aba0d4cd8923f1ae
    },
    {
        key: "Shift-Mod-\\",
        run: $032754016b6293d7$export$e5a7e1f2d38b1f6a
    },
    {
        key: "Mod-/",
        run: $032754016b6293d7$export$afbcdd0bff36c567
    },
    {
        key: "Alt-A",
        run: $032754016b6293d7$export$19d6fa84ce3a55ab
    },
    {
        key: "Ctrl-m",
        mac: "Shift-Alt-m",
        run: $032754016b6293d7$export$f118650570e71643
    }
].concat($032754016b6293d7$export$ae5dfd95be821a1c);
/**
A binding that binds Tab to [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) and
Shift-Tab to [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess).
Please see the [Tab example](../../examples/tab/) before using
this.
*/ const $032754016b6293d7$export$893b77570f8af4da = {
    key: "Tab",
    run: $032754016b6293d7$export$a61bf6a946ffc826,
    shift: $032754016b6293d7$export$e4b902122bfe67ae
};



/**
A parse stack. These are used internally by the parser to track
parsing progress. They also provide some properties and methods
that external code such as a tokenizer can use to get information
about the parse state.
*/ class $96e8fc72168067c5$export$694e0d28c7ffc90c {
    /**
    @internal
    */ constructor(/**
    The parse that this stack is part of @internal
    */ p, /**
    Holds state, input pos, buffer index triplets for all but the
    top state @internal
    */ stack, /**
    The current parse state @internal
    */ state, // The position at which the next reduce should take place. This
    // can be less than `this.pos` when skipped expressions have been
    // added to the stack (which should be moved outside of the next
    // reduction)
    /**
    @internal
    */ reducePos, /**
    The input position up to which this stack has parsed.
    */ pos, /**
    The dynamic score of the stack, including dynamic precedence
    and error-recovery penalties
    @internal
    */ score, // The output buffer. Holds (type, start, end, size) quads
    // representing nodes created by the parser, where `size` is
    // amount of buffer array entries covered by this node.
    /**
    @internal
    */ buffer, // The base offset of the buffer. When stacks are split, the split
    // instance shared the buffer history with its parent up to
    // `bufferBase`, which is the absolute offset (including the
    // offset of previous splits) into the buffer at which this stack
    // starts writing.
    /**
    @internal
    */ bufferBase, /**
    @internal
    */ curContext, /**
    @internal
    */ lookAhead = 0, // A parent stack from which this was split off, if any. This is
    // set up so that it always points to a stack that has some
    // additional buffer content, never to a stack with an equal
    // `bufferBase`.
    /**
    @internal
    */ parent){
        this.p = p;
        this.stack = stack;
        this.state = state;
        this.reducePos = reducePos;
        this.pos = pos;
        this.score = score;
        this.buffer = buffer;
        this.bufferBase = bufferBase;
        this.curContext = curContext;
        this.lookAhead = lookAhead;
        this.parent = parent;
    }
    /**
    @internal
    */ toString() {
        return `[${this.stack.filter((_, i)=>i % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
    }
    // Start an empty stack
    /**
    @internal
    */ static start(p, state, pos = 0) {
        let cx = p.parser.context;
        return new $96e8fc72168067c5$export$694e0d28c7ffc90c(p, [], state, pos, pos, 0, [], 0, cx ? new $96e8fc72168067c5$var$StackContext(cx, cx.start) : null, 0, null);
    }
    /**
    The stack's current [context](#lr.ContextTracker) value, if
    any. Its type will depend on the context tracker's type
    parameter, or it will be `null` if there is no context
    tracker.
    */ get context() {
        return this.curContext ? this.curContext.context : null;
    }
    // Push a state onto the stack, tracking its start position as well
    // as the buffer base at that point.
    /**
    @internal
    */ pushState(state, start) {
        this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
        this.state = state;
    }
    // Apply a reduce action
    /**
    @internal
    */ reduce(action) {
        var _a;
        let depth = action >> 19 /* Action.ReduceDepthShift */ , type = action & 65535 /* Action.ValueMask */ ;
        let { parser: parser } = this.p;
        let lookaheadRecord = this.reducePos < this.pos - 25 /* Lookahead.Margin */  && this.setLookAhead(this.pos);
        let dPrec = parser.dynamicPrecedence(type);
        if (dPrec) this.score += dPrec;
        if (depth == 0) {
            this.pushState(parser.getGoto(this.state, type, true), this.reducePos);
            // Zero-depth reductions are a special case—they add stuff to
            // the stack without popping anything off.
            if (type < parser.minRepeatTerm) this.storeNode(type, this.reducePos, this.reducePos, lookaheadRecord ? 8 : 4, true);
            this.reduceContext(type, this.reducePos);
            return;
        }
        // Find the base index into `this.stack`, content after which will
        // be dropped. Note that with `StayFlag` reductions we need to
        // consume two extra frames (the dummy parent node for the skipped
        // expression and the state that we'll be staying in, which should
        // be moved to `this.state`).
        let base = this.stack.length - (depth - 1) * 3 - (action & 262144 /* Action.StayFlag */  ? 6 : 0);
        let start = base ? this.stack[base - 2] : this.p.ranges[0].from, size = this.reducePos - start;
        // This is a kludge to try and detect overly deep left-associative
        // trees, which will not increase the parse stack depth and thus
        // won't be caught by the regular stack-depth limit check.
        if (size >= 2000 /* Recover.MinBigReduction */  && !((_a = this.p.parser.nodeSet.types[type]) === null || _a === void 0 ? void 0 : _a.isAnonymous)) {
            if (start == this.p.lastBigReductionStart) {
                this.p.bigReductionCount++;
                this.p.lastBigReductionSize = size;
            } else if (this.p.lastBigReductionSize < size) {
                this.p.bigReductionCount = 1;
                this.p.lastBigReductionStart = start;
                this.p.lastBigReductionSize = size;
            }
        }
        let bufferBase = base ? this.stack[base - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
        // Store normal terms or `R -> R R` repeat reductions
        if (type < parser.minRepeatTerm || action & 131072 /* Action.RepeatFlag */ ) {
            let pos = parser.stateFlag(this.state, 1 /* StateFlag.Skipped */ ) ? this.pos : this.reducePos;
            this.storeNode(type, start, pos, count + 4, true);
        }
        if (action & 262144 /* Action.StayFlag */ ) this.state = this.stack[base];
        else {
            let baseStateID = this.stack[base - 3];
            this.state = parser.getGoto(baseStateID, type, true);
        }
        while(this.stack.length > base)this.stack.pop();
        this.reduceContext(type, start);
    }
    // Shift a value into the buffer
    /**
    @internal
    */ storeNode(term, start, end, size = 4, mustSink = false) {
        if (term == 0 /* Term.Err */  && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
            // Try to omit/merge adjacent error nodes
            let cur = this, top = this.buffer.length;
            if (top == 0 && cur.parent) {
                top = cur.bufferBase - cur.parent.bufferBase;
                cur = cur.parent;
            }
            if (top > 0 && cur.buffer[top - 4] == 0 /* Term.Err */  && cur.buffer[top - 1] > -1) {
                if (start == end) return;
                if (cur.buffer[top - 2] >= start) {
                    cur.buffer[top - 2] = end;
                    return;
                }
            }
        }
        if (!mustSink || this.pos == end) this.buffer.push(term, start, end, size);
        else {
            let index = this.buffer.length;
            if (index > 0 && (this.buffer[index - 4] != 0 /* Term.Err */  || this.buffer[index - 1] < 0)) {
                let mustMove = false;
                for(let scan = index; scan > 0 && this.buffer[scan - 2] > end; scan -= 4)if (this.buffer[scan - 1] >= 0) {
                    mustMove = true;
                    break;
                }
                if (mustMove) while(index > 0 && this.buffer[index - 2] > end){
                    // Move this record forward
                    this.buffer[index] = this.buffer[index - 4];
                    this.buffer[index + 1] = this.buffer[index - 3];
                    this.buffer[index + 2] = this.buffer[index - 2];
                    this.buffer[index + 3] = this.buffer[index - 1];
                    index -= 4;
                    if (size > 4) size -= 4;
                }
            }
            this.buffer[index] = term;
            this.buffer[index + 1] = start;
            this.buffer[index + 2] = end;
            this.buffer[index + 3] = size;
        }
    }
    // Apply a shift action
    /**
    @internal
    */ shift(action, type, start, end) {
        if (action & 131072 /* Action.GotoFlag */ ) this.pushState(action & 65535 /* Action.ValueMask */ , this.pos);
        else if ((action & 262144 /* Action.StayFlag */ ) == 0) {
            let nextState = action, { parser: parser } = this.p;
            if (end > this.pos || type <= parser.maxNode) {
                this.pos = end;
                if (!parser.stateFlag(nextState, 1 /* StateFlag.Skipped */ )) this.reducePos = end;
            }
            this.pushState(nextState, start);
            this.shiftContext(type, start);
            if (type <= parser.maxNode) this.buffer.push(type, start, end, 4);
        } else {
            this.pos = end;
            this.shiftContext(type, start);
            if (type <= this.p.parser.maxNode) this.buffer.push(type, start, end, 4);
        }
    }
    // Apply an action
    /**
    @internal
    */ apply(action, next, nextStart, nextEnd) {
        if (action & 65536 /* Action.ReduceFlag */ ) this.reduce(action);
        else this.shift(action, next, nextStart, nextEnd);
    }
    // Add a prebuilt (reused) node into the buffer.
    /**
    @internal
    */ useNode(value, next) {
        let index = this.p.reused.length - 1;
        if (index < 0 || this.p.reused[index] != value) {
            this.p.reused.push(value);
            index++;
        }
        let start = this.pos;
        this.reducePos = this.pos = start + value.length;
        this.pushState(next, start);
        this.buffer.push(index, start, this.reducePos, -1 /* size == -1 means this is a reused value */ );
        if (this.curContext) this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
    }
    // Split the stack. Due to the buffer sharing and the fact
    // that `this.stack` tends to stay quite shallow, this isn't very
    // expensive.
    /**
    @internal
    */ split() {
        let parent = this;
        let off = parent.buffer.length;
        // Because the top of the buffer (after this.pos) may be mutated
        // to reorder reductions and skipped tokens, and shared buffers
        // should be immutable, this copies any outstanding skipped tokens
        // to the new buffer, and puts the base pointer before them.
        while(off > 0 && parent.buffer[off - 2] > parent.reducePos)off -= 4;
        let buffer = parent.buffer.slice(off), base = parent.bufferBase + off;
        // Make sure parent points to an actual parent with content, if there is such a parent.
        while(parent && base == parent.bufferBase)parent = parent.parent;
        return new $96e8fc72168067c5$export$694e0d28c7ffc90c(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base, this.curContext, this.lookAhead, parent);
    }
    // Try to recover from an error by 'deleting' (ignoring) one token.
    /**
    @internal
    */ recoverByDelete(next, nextEnd) {
        let isNode = next <= this.p.parser.maxNode;
        if (isNode) this.storeNode(next, this.pos, nextEnd, 4);
        this.storeNode(0 /* Term.Err */ , this.pos, nextEnd, isNode ? 8 : 4);
        this.pos = this.reducePos = nextEnd;
        this.score -= 190 /* Recover.Delete */ ;
    }
    /**
    Check if the given term would be able to be shifted (optionally
    after some reductions) on this stack. This can be useful for
    external tokenizers that want to make sure they only provide a
    given token when it applies.
    */ canShift(term) {
        for(let sim = new $96e8fc72168067c5$var$SimulatedStack(this);;){
            let action = this.p.parser.stateSlot(sim.state, 4 /* ParseState.DefaultReduce */ ) || this.p.parser.hasAction(sim.state, term);
            if (action == 0) return false;
            if ((action & 65536 /* Action.ReduceFlag */ ) == 0) return true;
            sim.reduce(action);
        }
    }
    // Apply up to Recover.MaxNext recovery actions that conceptually
    // inserts some missing token or rule.
    /**
    @internal
    */ recoverByInsert(next) {
        if (this.stack.length >= 300 /* Recover.MaxInsertStackDepth */ ) return [];
        let nextStates = this.p.parser.nextStates(this.state);
        if (nextStates.length > 8 || this.stack.length >= 120 /* Recover.DampenInsertStackDepth */ ) {
            let best = [];
            for(let i = 0, s; i < nextStates.length; i += 2)if ((s = nextStates[i + 1]) != this.state && this.p.parser.hasAction(s, next)) best.push(nextStates[i], s);
            if (this.stack.length < 120 /* Recover.DampenInsertStackDepth */ ) for(let i = 0; best.length < 8 && i < nextStates.length; i += 2){
                let s = nextStates[i + 1];
                if (!best.some((v, i)=>i & 1 && v == s)) best.push(nextStates[i], s);
            }
            nextStates = best;
        }
        let result = [];
        for(let i = 0; i < nextStates.length && result.length < 4 /* Recover.MaxNext */ ; i += 2){
            let s = nextStates[i + 1];
            if (s == this.state) continue;
            let stack = this.split();
            stack.pushState(s, this.pos);
            stack.storeNode(0 /* Term.Err */ , stack.pos, stack.pos, 4, true);
            stack.shiftContext(nextStates[i], this.pos);
            stack.reducePos = this.pos;
            stack.score -= 200 /* Recover.Insert */ ;
            result.push(stack);
        }
        return result;
    }
    // Force a reduce, if possible. Return false if that can't
    // be done.
    /**
    @internal
    */ forceReduce() {
        let { parser: parser } = this.p;
        let reduce = parser.stateSlot(this.state, 5 /* ParseState.ForcedReduce */ );
        if ((reduce & 65536 /* Action.ReduceFlag */ ) == 0) return false;
        if (!parser.validAction(this.state, reduce)) {
            let depth = reduce >> 19 /* Action.ReduceDepthShift */ , term = reduce & 65535 /* Action.ValueMask */ ;
            let target = this.stack.length - depth * 3;
            if (target < 0 || parser.getGoto(this.stack[target], term, false) < 0) {
                let backup = this.findForcedReduction();
                if (backup == null) return false;
                reduce = backup;
            }
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            this.score -= 100 /* Recover.Reduce */ ;
        }
        this.reducePos = this.pos;
        this.reduce(reduce);
        return true;
    }
    /**
    Try to scan through the automaton to find some kind of reduction
    that can be applied. Used when the regular ForcedReduce field
    isn't a valid action. @internal
    */ findForcedReduction() {
        let { parser: parser } = this.p, seen = [];
        let explore = (state, depth)=>{
            if (seen.includes(state)) return;
            seen.push(state);
            return parser.allActions(state, (action)=>{
                if (action & 393216 /* Action.GotoFlag */ ) ;
                else if (action & 65536 /* Action.ReduceFlag */ ) {
                    let rDepth = (action >> 19 /* Action.ReduceDepthShift */ ) - depth;
                    if (rDepth > 1) {
                        let term = action & 65535 /* Action.ValueMask */ , target = this.stack.length - rDepth * 3;
                        if (target >= 0 && parser.getGoto(this.stack[target], term, false) >= 0) return rDepth << 19 /* Action.ReduceDepthShift */  | 65536 /* Action.ReduceFlag */  | term;
                    }
                } else {
                    let found = explore(action, depth + 1);
                    if (found != null) return found;
                }
            });
        };
        return explore(this.state, 0);
    }
    /**
    @internal
    */ forceAll() {
        while(!this.p.parser.stateFlag(this.state, 2 /* StateFlag.Accepting */ ))if (!this.forceReduce()) {
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            break;
        }
        return this;
    }
    /**
    Check whether this state has no further actions (assumed to be a direct descendant of the
    top state, since any other states must be able to continue
    somehow). @internal
    */ get deadEnd() {
        if (this.stack.length != 3) return false;
        let { parser: parser } = this.p;
        return parser.data[parser.stateSlot(this.state, 1 /* ParseState.Actions */ )] == 65535 /* Seq.End */  && !parser.stateSlot(this.state, 4 /* ParseState.DefaultReduce */ );
    }
    /**
    Restart the stack (put it back in its start state). Only safe
    when this.stack.length == 3 (state is directly below the top
    state). @internal
    */ restart() {
        this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
        this.state = this.stack[0];
        this.stack.length = 0;
    }
    /**
    @internal
    */ sameState(other) {
        if (this.state != other.state || this.stack.length != other.stack.length) return false;
        for(let i = 0; i < this.stack.length; i += 3)if (this.stack[i] != other.stack[i]) return false;
        return true;
    }
    /**
    Get the parser used by this stack.
    */ get parser() {
        return this.p.parser;
    }
    /**
    Test whether a given dialect (by numeric ID, as exported from
    the terms file) is enabled.
    */ dialectEnabled(dialectID) {
        return this.p.parser.dialect.flags[dialectID];
    }
    shiftContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    reduceContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    /**
    @internal
    */ emitContext() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -3) this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
    }
    /**
    @internal
    */ emitLookAhead() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -4) this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
    }
    updateContext(context) {
        if (context != this.curContext.context) {
            let newCx = new $96e8fc72168067c5$var$StackContext(this.curContext.tracker, context);
            if (newCx.hash != this.curContext.hash) this.emitContext();
            this.curContext = newCx;
        }
    }
    /**
    @internal
    */ setLookAhead(lookAhead) {
        if (lookAhead <= this.lookAhead) return false;
        this.emitLookAhead();
        this.lookAhead = lookAhead;
        return true;
    }
    /**
    @internal
    */ close() {
        if (this.curContext && this.curContext.tracker.strict) this.emitContext();
        if (this.lookAhead > 0) this.emitLookAhead();
    }
}
class $96e8fc72168067c5$var$StackContext {
    constructor(tracker, context){
        this.tracker = tracker;
        this.context = context;
        this.hash = tracker.strict ? tracker.hash(context) : 0;
    }
}
// Used to cheaply run some reductions to scan ahead without mutating
// an entire stack
class $96e8fc72168067c5$var$SimulatedStack {
    constructor(start){
        this.start = start;
        this.state = start.state;
        this.stack = start.stack;
        this.base = this.stack.length;
    }
    reduce(action) {
        let term = action & 65535 /* Action.ValueMask */ , depth = action >> 19 /* Action.ReduceDepthShift */ ;
        if (depth == 0) {
            if (this.stack == this.start.stack) this.stack = this.stack.slice();
            this.stack.push(this.state, 0, 0);
            this.base += 3;
        } else this.base -= (depth - 1) * 3;
        let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
        this.state = goto;
    }
}
// This is given to `Tree.build` to build a buffer, and encapsulates
// the parent-stack-walking necessary to read the nodes.
class $96e8fc72168067c5$var$StackBufferCursor {
    constructor(stack, pos, index){
        this.stack = stack;
        this.pos = pos;
        this.index = index;
        this.buffer = stack.buffer;
        if (this.index == 0) this.maybeNext();
    }
    static create(stack, pos = stack.bufferBase + stack.buffer.length) {
        return new $96e8fc72168067c5$var$StackBufferCursor(stack, pos, pos - stack.bufferBase);
    }
    maybeNext() {
        let next = this.stack.parent;
        if (next != null) {
            this.index = this.stack.bufferBase - next.bufferBase;
            this.stack = next;
            this.buffer = next.buffer;
        }
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    next() {
        this.index -= 4;
        this.pos -= 4;
        if (this.index == 0) this.maybeNext();
    }
    fork() {
        return new $96e8fc72168067c5$var$StackBufferCursor(this.stack, this.pos, this.index);
    }
}
// See lezer-generator/src/encode.ts for comments about the encoding
// used here
function $96e8fc72168067c5$var$decodeArray(input, Type = Uint16Array) {
    if (typeof input != "string") return input;
    let array = null;
    for(let pos = 0, out = 0; pos < input.length;){
        let value = 0;
        for(;;){
            let next = input.charCodeAt(pos++), stop = false;
            if (next == 126 /* Encode.BigValCode */ ) {
                value = 65535 /* Encode.BigVal */ ;
                break;
            }
            if (next >= 92 /* Encode.Gap2 */ ) next--;
            if (next >= 34 /* Encode.Gap1 */ ) next--;
            let digit = next - 32 /* Encode.Start */ ;
            if (digit >= 46 /* Encode.Base */ ) {
                digit -= 46 /* Encode.Base */ ;
                stop = true;
            }
            value += digit;
            if (stop) break;
            value *= 46 /* Encode.Base */ ;
        }
        if (array) array[out++] = value;
        else array = new Type(value);
    }
    return array;
}
class $96e8fc72168067c5$var$CachedToken {
    constructor(){
        this.start = -1;
        this.value = -1;
        this.end = -1;
        this.extended = -1;
        this.lookAhead = 0;
        this.mask = 0;
        this.context = 0;
    }
}
const $96e8fc72168067c5$var$nullToken = new $96e8fc72168067c5$var$CachedToken;
/**
[Tokenizers](#lr.ExternalTokenizer) interact with the input
through this interface. It presents the input as a stream of
characters, tracking lookahead and hiding the complexity of
[ranges](#common.Parser.parse^ranges) from tokenizer code.
*/ class $96e8fc72168067c5$export$f22294a9362415e4 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ input, /**
    @internal
    */ ranges){
        this.input = input;
        this.ranges = ranges;
        /**
        @internal
        */ this.chunk = "";
        /**
        @internal
        */ this.chunkOff = 0;
        /**
        Backup chunk
        */ this.chunk2 = "";
        this.chunk2Pos = 0;
        /**
        The character code of the next code unit in the input, or -1
        when the stream is at the end of the input.
        */ this.next = -1;
        /**
        @internal
        */ this.token = $96e8fc72168067c5$var$nullToken;
        this.rangeIndex = 0;
        this.pos = this.chunkPos = ranges[0].from;
        this.range = ranges[0];
        this.end = ranges[ranges.length - 1].to;
        this.readNext();
    }
    /**
    @internal
    */ resolveOffset(offset, assoc) {
        let range = this.range, index = this.rangeIndex;
        let pos = this.pos + offset;
        while(pos < range.from){
            if (!index) return null;
            let next = this.ranges[--index];
            pos -= range.from - next.to;
            range = next;
        }
        while(assoc < 0 ? pos > range.to : pos >= range.to){
            if (index == this.ranges.length - 1) return null;
            let next = this.ranges[++index];
            pos += next.from - range.to;
            range = next;
        }
        return pos;
    }
    /**
    @internal
    */ clipPos(pos) {
        if (pos >= this.range.from && pos < this.range.to) return pos;
        for (let range of this.ranges)if (range.to > pos) return Math.max(pos, range.from);
        return this.end;
    }
    /**
    Look at a code unit near the stream position. `.peek(0)` equals
    `.next`, `.peek(-1)` gives you the previous character, and so
    on.
    
    Note that looking around during tokenizing creates dependencies
    on potentially far-away content, which may reduce the
    effectiveness incremental parsing—when looking forward—or even
    cause invalid reparses when looking backward more than 25 code
    units, since the library does not track lookbehind.
    */ peek(offset) {
        let idx = this.chunkOff + offset, pos, result;
        if (idx >= 0 && idx < this.chunk.length) {
            pos = this.pos + offset;
            result = this.chunk.charCodeAt(idx);
        } else {
            let resolved = this.resolveOffset(offset, 1);
            if (resolved == null) return -1;
            pos = resolved;
            if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) result = this.chunk2.charCodeAt(pos - this.chunk2Pos);
            else {
                let i = this.rangeIndex, range = this.range;
                while(range.to <= pos)range = this.ranges[++i];
                this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
                if (pos + this.chunk2.length > range.to) this.chunk2 = this.chunk2.slice(0, range.to - pos);
                result = this.chunk2.charCodeAt(0);
            }
        }
        if (pos >= this.token.lookAhead) this.token.lookAhead = pos + 1;
        return result;
    }
    /**
    Accept a token. By default, the end of the token is set to the
    current stream position, but you can pass an offset (relative to
    the stream position) to change that.
    */ acceptToken(token, endOffset = 0) {
        let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
        if (end == null || end < this.token.start) throw new RangeError("Token end out of bounds");
        this.token.value = token;
        this.token.end = end;
    }
    /**
    Accept a token ending at a specific given position.
    */ acceptTokenTo(token, endPos) {
        this.token.value = token;
        this.token.end = endPos;
    }
    getChunk() {
        if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
            let { chunk: chunk, chunkPos: chunkPos } = this;
            this.chunk = this.chunk2;
            this.chunkPos = this.chunk2Pos;
            this.chunk2 = chunk;
            this.chunk2Pos = chunkPos;
            this.chunkOff = this.pos - this.chunkPos;
        } else {
            this.chunk2 = this.chunk;
            this.chunk2Pos = this.chunkPos;
            let nextChunk = this.input.chunk(this.pos);
            let end = this.pos + nextChunk.length;
            this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
            this.chunkPos = this.pos;
            this.chunkOff = 0;
        }
    }
    readNext() {
        if (this.chunkOff >= this.chunk.length) {
            this.getChunk();
            if (this.chunkOff == this.chunk.length) return this.next = -1;
        }
        return this.next = this.chunk.charCodeAt(this.chunkOff);
    }
    /**
    Move the stream forward N (defaults to 1) code units. Returns
    the new value of [`next`](#lr.InputStream.next).
    */ advance(n = 1) {
        this.chunkOff += n;
        while(this.pos + n >= this.range.to){
            if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
            n -= this.range.to - this.pos;
            this.range = this.ranges[++this.rangeIndex];
            this.pos = this.range.from;
        }
        this.pos += n;
        if (this.pos >= this.token.lookAhead) this.token.lookAhead = this.pos + 1;
        return this.readNext();
    }
    setDone() {
        this.pos = this.chunkPos = this.end;
        this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
        this.chunk = "";
        return this.next = -1;
    }
    /**
    @internal
    */ reset(pos, token) {
        if (token) {
            this.token = token;
            token.start = pos;
            token.lookAhead = pos + 1;
            token.value = token.extended = -1;
        } else this.token = $96e8fc72168067c5$var$nullToken;
        if (this.pos != pos) {
            this.pos = pos;
            if (pos == this.end) {
                this.setDone();
                return this;
            }
            while(pos < this.range.from)this.range = this.ranges[--this.rangeIndex];
            while(pos >= this.range.to)this.range = this.ranges[++this.rangeIndex];
            if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) this.chunkOff = pos - this.chunkPos;
            else {
                this.chunk = "";
                this.chunkOff = 0;
            }
            this.readNext();
        }
        return this;
    }
    /**
    @internal
    */ read(from, to) {
        if (from >= this.chunkPos && to <= this.chunkPos + this.chunk.length) return this.chunk.slice(from - this.chunkPos, to - this.chunkPos);
        if (from >= this.chunk2Pos && to <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(from - this.chunk2Pos, to - this.chunk2Pos);
        if (from >= this.range.from && to <= this.range.to) return this.input.read(from, to);
        let result = "";
        for (let r of this.ranges){
            if (r.from >= to) break;
            if (r.to > from) result += this.input.read(Math.max(r.from, from), Math.min(r.to, to));
        }
        return result;
    }
}
/**
@internal
*/ class $96e8fc72168067c5$var$TokenGroup {
    constructor(data, id){
        this.data = data;
        this.id = id;
    }
    token(input, stack) {
        let { parser: parser } = stack.p;
        $96e8fc72168067c5$var$readToken(this.data, input, stack, this.id, parser.data, parser.tokenPrecTable);
    }
}
$96e8fc72168067c5$var$TokenGroup.prototype.contextual = $96e8fc72168067c5$var$TokenGroup.prototype.fallback = $96e8fc72168067c5$var$TokenGroup.prototype.extend = false;
/**
@hide
*/ class $96e8fc72168067c5$export$dbe55ed82366d5e9 {
    constructor(data, precTable, elseToken){
        this.precTable = precTable;
        this.elseToken = elseToken;
        this.data = typeof data == "string" ? $96e8fc72168067c5$var$decodeArray(data) : data;
    }
    token(input, stack) {
        let start = input.pos, skipped = 0;
        for(;;){
            let atEof = input.next < 0, nextPos = input.resolveOffset(1, 1);
            $96e8fc72168067c5$var$readToken(this.data, input, stack, 0, this.data, this.precTable);
            if (input.token.value > -1) break;
            if (this.elseToken == null) return;
            if (!atEof) skipped++;
            if (nextPos == null) break;
            input.reset(nextPos, input.token);
        }
        if (skipped) {
            input.reset(start, input.token);
            input.acceptToken(this.elseToken, skipped);
        }
    }
}
$96e8fc72168067c5$export$dbe55ed82366d5e9.prototype.contextual = $96e8fc72168067c5$var$TokenGroup.prototype.fallback = $96e8fc72168067c5$var$TokenGroup.prototype.extend = false;
/**
`@external tokens` declarations in the grammar should resolve to
an instance of this class.
*/ class $96e8fc72168067c5$export$6e56a42e94c6b2cb {
    /**
    Create a tokenizer. The first argument is the function that,
    given an input stream, scans for the types of tokens it
    recognizes at the stream's position, and calls
    [`acceptToken`](#lr.InputStream.acceptToken) when it finds
    one.
    */ constructor(/**
    @internal
    */ token, options = {}){
        this.token = token;
        this.contextual = !!options.contextual;
        this.fallback = !!options.fallback;
        this.extend = !!options.extend;
    }
}
// Tokenizer data is stored a big uint16 array containing, for each
// state:
//
//  - A group bitmask, indicating what token groups are reachable from
//    this state, so that paths that can only lead to tokens not in
//    any of the current groups can be cut off early.
//
//  - The position of the end of the state's sequence of accepting
//    tokens
//
//  - The number of outgoing edges for the state
//
//  - The accepting tokens, as (token id, group mask) pairs
//
//  - The outgoing edges, as (start character, end character, state
//    index) triples, with end character being exclusive
//
// This function interprets that data, running through a stream as
// long as new states with the a matching group mask can be reached,
// and updating `input.token` when it matches a token.
function $96e8fc72168067c5$var$readToken(data, input, stack, group, precTable, precOffset) {
    let state = 0, groupMask = 1 << group, { dialect: dialect } = stack.p.parser;
    scan: for(;;){
        if ((groupMask & data[state]) == 0) break;
        let accEnd = data[state + 1];
        // Check whether this state can lead to a token in the current group
        // Accept tokens in this state, possibly overwriting
        // lower-precedence / shorter tokens
        for(let i = state + 3; i < accEnd; i += 2)if ((data[i + 1] & groupMask) > 0) {
            let term = data[i];
            if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || $96e8fc72168067c5$var$overrides(term, input.token.value, precTable, precOffset))) {
                input.acceptToken(term);
                break;
            }
        }
        let next = input.next, low = 0, high = data[state + 2];
        // Special case for EOF
        if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535 /* Seq.End */ ) {
            state = data[accEnd + high * 3 - 1];
            continue scan;
        }
        // Do a binary search on the state's edges
        for(; low < high;){
            let mid = low + high >> 1;
            let index = accEnd + mid + (mid << 1);
            let from = data[index], to = data[index + 1] || 0x10000;
            if (next < from) high = mid;
            else if (next >= to) low = mid + 1;
            else {
                state = data[index + 2];
                input.advance();
                continue scan;
            }
        }
        break;
    }
}
function $96e8fc72168067c5$var$findOffset(data, start, term) {
    for(let i = start, next; (next = data[i]) != 65535 /* Seq.End */ ; i++)if (next == term) return i - start;
    return -1;
}
function $96e8fc72168067c5$var$overrides(token, prev, tableData, tableOffset) {
    let iPrev = $96e8fc72168067c5$var$findOffset(tableData, tableOffset, prev);
    return iPrev < 0 || $96e8fc72168067c5$var$findOffset(tableData, tableOffset, token) < iPrev;
}
// Environment variable used to control console output
const $96e8fc72168067c5$var$verbose = false;
let $96e8fc72168067c5$var$stackIDs = null;
function $96e8fc72168067c5$var$cutAt(tree, pos, side) {
    let cursor = tree.cursor((0, $ed739beecf769914$export$b0e28367f55837aa).IncludeAnonymous);
    cursor.moveTo(pos);
    for(;;){
        if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos))) for(;;){
            if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError) return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25 /* Lookahead.Margin */ )) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25 /* Lookahead.Margin */ ));
            if (side < 0 ? cursor.prevSibling() : cursor.nextSibling()) break;
            if (!cursor.parent()) return side < 0 ? 0 : tree.length;
        }
    }
}
class $96e8fc72168067c5$var$FragmentCursor {
    constructor(fragments, nodeSet){
        this.fragments = fragments;
        this.nodeSet = nodeSet;
        this.i = 0;
        this.fragment = null;
        this.safeFrom = -1;
        this.safeTo = -1;
        this.trees = [];
        this.start = [];
        this.index = [];
        this.nextFragment();
    }
    nextFragment() {
        let fr = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
        if (fr) {
            this.safeFrom = fr.openStart ? $96e8fc72168067c5$var$cutAt(fr.tree, fr.from + fr.offset, 1) - fr.offset : fr.from;
            this.safeTo = fr.openEnd ? $96e8fc72168067c5$var$cutAt(fr.tree, fr.to + fr.offset, -1) - fr.offset : fr.to;
            while(this.trees.length){
                this.trees.pop();
                this.start.pop();
                this.index.pop();
            }
            this.trees.push(fr.tree);
            this.start.push(-fr.offset);
            this.index.push(0);
            this.nextStart = this.safeFrom;
        } else this.nextStart = 1e9;
    }
    // `pos` must be >= any previously given `pos` for this cursor
    nodeAt(pos) {
        if (pos < this.nextStart) return null;
        while(this.fragment && this.safeTo <= pos)this.nextFragment();
        if (!this.fragment) return null;
        for(;;){
            let last = this.trees.length - 1;
            if (last < 0) {
                this.nextFragment();
                return null;
            }
            let top = this.trees[last], index = this.index[last];
            if (index == top.children.length) {
                this.trees.pop();
                this.start.pop();
                this.index.pop();
                continue;
            }
            let next = top.children[index];
            let start = this.start[last] + top.positions[index];
            if (start > pos) {
                this.nextStart = start;
                return null;
            }
            if (next instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) {
                if (start == pos) {
                    if (start < this.safeFrom) return null;
                    let end = start + next.length;
                    if (end <= this.safeTo) {
                        let lookAhead = next.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).lookAhead);
                        if (!lookAhead || end + lookAhead < this.fragment.to) return next;
                    }
                }
                this.index[last]++;
                if (start + next.length >= Math.max(this.safeFrom, pos)) {
                    this.trees.push(next);
                    this.start.push(start);
                    this.index.push(0);
                }
            } else {
                this.index[last]++;
                this.nextStart = start + next.length;
            }
        }
    }
}
class $96e8fc72168067c5$var$TokenCache {
    constructor(parser, stream){
        this.stream = stream;
        this.tokens = [];
        this.mainToken = null;
        this.actions = [];
        this.tokens = parser.tokenizers.map((_)=>new $96e8fc72168067c5$var$CachedToken);
    }
    getActions(stack) {
        let actionIndex = 0;
        let main = null;
        let { parser: parser } = stack.p, { tokenizers: tokenizers } = parser;
        let mask = parser.stateSlot(stack.state, 3 /* ParseState.TokenizerMask */ );
        let context = stack.curContext ? stack.curContext.hash : 0;
        let lookAhead = 0;
        for(let i = 0; i < tokenizers.length; i++){
            if ((1 << i & mask) == 0) continue;
            let tokenizer = tokenizers[i], token = this.tokens[i];
            if (main && !tokenizer.fallback) continue;
            if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
                this.updateCachedToken(token, tokenizer, stack);
                token.mask = mask;
                token.context = context;
            }
            if (token.lookAhead > token.end + 25 /* Lookahead.Margin */ ) lookAhead = Math.max(token.lookAhead, lookAhead);
            if (token.value != 0 /* Term.Err */ ) {
                let startIndex = actionIndex;
                if (token.extended > -1) actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
                actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
                if (!tokenizer.extend) {
                    main = token;
                    if (actionIndex > startIndex) break;
                }
            }
        }
        while(this.actions.length > actionIndex)this.actions.pop();
        if (lookAhead) stack.setLookAhead(lookAhead);
        if (!main && stack.pos == this.stream.end) {
            main = new $96e8fc72168067c5$var$CachedToken;
            main.value = stack.p.parser.eofTerm;
            main.start = main.end = stack.pos;
            actionIndex = this.addActions(stack, main.value, main.end, actionIndex);
        }
        this.mainToken = main;
        return this.actions;
    }
    getMainToken(stack) {
        if (this.mainToken) return this.mainToken;
        let main = new $96e8fc72168067c5$var$CachedToken, { pos: pos, p: p } = stack;
        main.start = pos;
        main.end = Math.min(pos + 1, p.stream.end);
        main.value = pos == p.stream.end ? p.parser.eofTerm : 0 /* Term.Err */ ;
        return main;
    }
    updateCachedToken(token, tokenizer, stack) {
        let start = this.stream.clipPos(stack.pos);
        tokenizer.token(this.stream.reset(start, token), stack);
        if (token.value > -1) {
            let { parser: parser } = stack.p;
            for(let i = 0; i < parser.specialized.length; i++)if (parser.specialized[i] == token.value) {
                let result = parser.specializers[i](this.stream.read(token.start, token.end), stack);
                if (result >= 0 && stack.p.parser.dialect.allows(result >> 1)) {
                    if ((result & 1) == 0 /* Specialize.Specialize */ ) token.value = result >> 1;
                    else token.extended = result >> 1;
                    break;
                }
            }
        } else {
            token.value = 0 /* Term.Err */ ;
            token.end = this.stream.clipPos(start + 1);
        }
    }
    putAction(action, token, end, index) {
        // Don't add duplicate actions
        for(let i = 0; i < index; i += 3)if (this.actions[i] == action) return index;
        this.actions[index++] = action;
        this.actions[index++] = token;
        this.actions[index++] = end;
        return index;
    }
    addActions(stack, token, end, index) {
        let { state: state } = stack, { parser: parser } = stack.p, { data: data } = parser;
        for(let set = 0; set < 2; set++)for(let i = parser.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ );; i += 3){
            if (data[i] == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) i = $96e8fc72168067c5$var$pair(data, i + 2);
                else {
                    if (index == 0 && data[i + 1] == 2 /* Seq.Other */ ) index = this.putAction($96e8fc72168067c5$var$pair(data, i + 2), token, end, index);
                    break;
                }
            }
            if (data[i] == token) index = this.putAction($96e8fc72168067c5$var$pair(data, i + 1), token, end, index);
        }
        return index;
    }
}
class $96e8fc72168067c5$var$Parse {
    constructor(parser, input, fragments, ranges){
        this.parser = parser;
        this.input = input;
        this.ranges = ranges;
        this.recovering = 0;
        this.nextStackID = 0x2654; // ♔, ♕, ♖, ♗, ♘, ♙, ♠, ♡, ♢, ♣, ♤, ♥, ♦, ♧
        this.minStackPos = 0;
        this.reused = [];
        this.stoppedAt = null;
        this.lastBigReductionStart = -1;
        this.lastBigReductionSize = 0;
        this.bigReductionCount = 0;
        this.stream = new $96e8fc72168067c5$export$f22294a9362415e4(input, ranges);
        this.tokens = new $96e8fc72168067c5$var$TokenCache(parser, this.stream);
        this.topTerm = parser.top[1];
        let { from: from } = ranges[0];
        this.stacks = [
            $96e8fc72168067c5$export$694e0d28c7ffc90c.start(this, parser.top[0], from)
        ];
        this.fragments = fragments.length && this.stream.end - from > parser.bufferLength * 4 ? new $96e8fc72168067c5$var$FragmentCursor(fragments, parser.nodeSet) : null;
    }
    get parsedPos() {
        return this.minStackPos;
    }
    // Move the parser forward. This will process all parse stacks at
    // `this.pos` and try to advance them to a further position. If no
    // stack for such a position is found, it'll start error-recovery.
    //
    // When the parse is finished, this will return a syntax tree. When
    // not, it returns `null`.
    advance() {
        let stacks = this.stacks, pos = this.minStackPos;
        // This will hold stacks beyond `pos`.
        let newStacks = this.stacks = [];
        let stopped, stoppedTokens;
        // If a large amount of reductions happened with the same start
        // position, force the stack out of that production in order to
        // avoid creating a tree too deep to recurse through.
        // (This is an ugly kludge, because unfortunately there is no
        // straightforward, cheap way to check for this happening, due to
        // the history of reductions only being available in an
        // expensive-to-access format in the stack buffers.)
        if (this.bigReductionCount > 300 /* Rec.MaxLeftAssociativeReductionCount */  && stacks.length == 1) {
            let [s] = stacks;
            while(s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart);
            this.bigReductionCount = this.lastBigReductionSize = 0;
        }
        // Keep advancing any stacks at `pos` until they either move
        // forward or can't be advanced. Gather stacks that can't be
        // advanced further in `stopped`.
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i];
            for(;;){
                this.tokens.mainToken = null;
                if (stack.pos > pos) newStacks.push(stack);
                else if (this.advanceStack(stack, newStacks, stacks)) continue;
                else {
                    if (!stopped) {
                        stopped = [];
                        stoppedTokens = [];
                    }
                    stopped.push(stack);
                    let tok = this.tokens.getMainToken(stack);
                    stoppedTokens.push(tok.value, tok.end);
                }
                break;
            }
        }
        if (!newStacks.length) {
            let finished = stopped && $96e8fc72168067c5$var$findFinished(stopped);
            if (finished) {
                if ($96e8fc72168067c5$var$verbose) console.log("Finish with " + this.stackID(finished));
                return this.stackToTree(finished);
            }
            if (this.parser.strict) {
                if ($96e8fc72168067c5$var$verbose && stopped) console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
                throw new SyntaxError("No parse at " + pos);
            }
            if (!this.recovering) this.recovering = 5 /* Rec.Distance */ ;
        }
        if (this.recovering && stopped) {
            let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
            if (finished) {
                if ($96e8fc72168067c5$var$verbose) console.log("Force-finish " + this.stackID(finished));
                return this.stackToTree(finished.forceAll());
            }
        }
        if (this.recovering) {
            let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3 /* Rec.MaxRemainingPerStep */ ;
            if (newStacks.length > maxRemaining) {
                newStacks.sort((a, b)=>b.score - a.score);
                while(newStacks.length > maxRemaining)newStacks.pop();
            }
            if (newStacks.some((s)=>s.reducePos > pos)) this.recovering--;
        } else if (newStacks.length > 1) {
            // Prune stacks that are in the same state, or that have been
            // running without splitting for a while, to avoid getting stuck
            // with multiple successful stacks running endlessly on.
            outer: for(let i = 0; i < newStacks.length - 1; i++){
                let stack = newStacks[i];
                for(let j = i + 1; j < newStacks.length; j++){
                    let other = newStacks[j];
                    if (stack.sameState(other) || stack.buffer.length > 500 /* Rec.MinBufferLengthPrune */  && other.buffer.length > 500 /* Rec.MinBufferLengthPrune */ ) {
                        if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) newStacks.splice(j--, 1);
                        else {
                            newStacks.splice(i--, 1);
                            continue outer;
                        }
                    }
                }
            }
            if (newStacks.length > 12 /* Rec.MaxStackCount */ ) {
                newStacks.sort((a, b)=>b.score - a.score);
                newStacks.splice(12 /* Rec.MaxStackCount */ , newStacks.length - 12 /* Rec.MaxStackCount */ );
            }
        }
        this.minStackPos = newStacks[0].pos;
        for(let i = 1; i < newStacks.length; i++)if (newStacks[i].pos < this.minStackPos) this.minStackPos = newStacks[i].pos;
        return null;
    }
    stopAt(pos) {
        if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
        this.stoppedAt = pos;
    }
    // Returns an updated version of the given stack, or null if the
    // stack can't advance normally. When `split` and `stacks` are
    // given, stacks split off by ambiguous operations will be pushed to
    // `split`, or added to `stacks` if they move `pos` forward.
    advanceStack(stack, stacks, split) {
        let start = stack.pos, { parser: parser } = this;
        let base = $96e8fc72168067c5$var$verbose ? this.stackID(stack) + " -> " : "";
        if (this.stoppedAt != null && start > this.stoppedAt) return stack.forceReduce() ? stack : null;
        if (this.fragments) {
            let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
            for(let cached = this.fragments.nodeAt(start); cached;){
                let match = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser.getGoto(stack.state, cached.type.id) : -1;
                if (match > -1 && cached.length && (!strictCx || (cached.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).contextHash) || 0) == cxHash)) {
                    stack.useNode(cached, match);
                    if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + ` (via reuse of ${parser.getName(cached.type.id)})`);
                    return true;
                }
                if (!(cached instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) || cached.children.length == 0 || cached.positions[0] > 0) break;
                let inner = cached.children[0];
                if (inner instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e) && cached.positions[0] == 0) cached = inner;
                else break;
            }
        }
        let defaultReduce = parser.stateSlot(stack.state, 4 /* ParseState.DefaultReduce */ );
        if (defaultReduce > 0) {
            stack.reduce(defaultReduce);
            if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + ` (via always-reduce ${parser.getName(defaultReduce & 65535 /* Action.ValueMask */ )})`);
            return true;
        }
        if (stack.stack.length >= 8400 /* Rec.CutDepth */ ) {
            while(stack.stack.length > 6000 /* Rec.CutTo */  && stack.forceReduce());
        }
        let actions = this.tokens.getActions(stack);
        for(let i = 0; i < actions.length;){
            let action = actions[i++], term = actions[i++], end = actions[i++];
            let last = i == actions.length || !split;
            let localStack = last ? stack : stack.split();
            let main = this.tokens.mainToken;
            localStack.apply(action, term, main ? main.start : localStack.pos, end);
            if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(localStack) + ` (via ${(action & 65536 /* Action.ReduceFlag */ ) == 0 ? "shift" : `reduce of ${parser.getName(action & 65535 /* Action.ValueMask */ )}`} for ${parser.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
            if (last) return true;
            else if (localStack.pos > start) stacks.push(localStack);
            else split.push(localStack);
        }
        return false;
    }
    // Advance a given stack forward as far as it will go. Returns the
    // (possibly updated) stack if it got stuck, or null if it moved
    // forward and was given to `pushStackDedup`.
    advanceFully(stack, newStacks) {
        let pos = stack.pos;
        for(;;){
            if (!this.advanceStack(stack, null, null)) return false;
            if (stack.pos > pos) {
                $96e8fc72168067c5$var$pushStackDedup(stack, newStacks);
                return true;
            }
        }
    }
    runRecovery(stacks, tokens, newStacks) {
        let finished = null, restarted = false;
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i], token = tokens[i << 1], tokenEnd = tokens[(i << 1) + 1];
            let base = $96e8fc72168067c5$var$verbose ? this.stackID(stack) + " -> " : "";
            if (stack.deadEnd) {
                if (restarted) continue;
                restarted = true;
                stack.restart();
                if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + " (restarted)");
                let done = this.advanceFully(stack, newStacks);
                if (done) continue;
            }
            let force = stack.split(), forceBase = base;
            for(let j = 0; j < 10 /* Rec.ForceReduceLimit */  && force.forceReduce(); j++){
                if ($96e8fc72168067c5$var$verbose) console.log(forceBase + this.stackID(force) + " (via force-reduce)");
                let done = this.advanceFully(force, newStacks);
                if (done) break;
                if ($96e8fc72168067c5$var$verbose) forceBase = this.stackID(force) + " -> ";
            }
            for (let insert of stack.recoverByInsert(token)){
                if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(insert) + " (via recover-insert)");
                this.advanceFully(insert, newStacks);
            }
            if (this.stream.end > stack.pos) {
                if (tokenEnd == stack.pos) {
                    tokenEnd++;
                    token = 0 /* Term.Err */ ;
                }
                stack.recoverByDelete(token, tokenEnd);
                if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
                $96e8fc72168067c5$var$pushStackDedup(stack, newStacks);
            } else if (!finished || finished.score < stack.score) finished = stack;
        }
        return finished;
    }
    // Convert the stack's buffer to a syntax tree.
    stackToTree(stack) {
        stack.close();
        return (0, $ed739beecf769914$export$7fbedc92909ed28e).build({
            buffer: $96e8fc72168067c5$var$StackBufferCursor.create(stack),
            nodeSet: this.parser.nodeSet,
            topID: this.topTerm,
            maxBufferLength: this.parser.bufferLength,
            reused: this.reused,
            start: this.ranges[0].from,
            length: stack.pos - this.ranges[0].from,
            minRepeatType: this.parser.minRepeatTerm
        });
    }
    stackID(stack) {
        let id = ($96e8fc72168067c5$var$stackIDs || ($96e8fc72168067c5$var$stackIDs = new WeakMap)).get(stack);
        if (!id) $96e8fc72168067c5$var$stackIDs.set(stack, id = String.fromCodePoint(this.nextStackID++));
        return id + stack;
    }
}
function $96e8fc72168067c5$var$pushStackDedup(stack, newStacks) {
    for(let i = 0; i < newStacks.length; i++){
        let other = newStacks[i];
        if (other.pos == stack.pos && other.sameState(stack)) {
            if (newStacks[i].score < stack.score) newStacks[i] = stack;
            return;
        }
    }
    newStacks.push(stack);
}
class $96e8fc72168067c5$var$Dialect {
    constructor(source, flags, disabled){
        this.source = source;
        this.flags = flags;
        this.disabled = disabled;
    }
    allows(term) {
        return !this.disabled || this.disabled[term] == 0;
    }
}
const $96e8fc72168067c5$var$id = (x)=>x;
/**
Context trackers are used to track stateful context (such as
indentation in the Python grammar, or parent elements in the XML
grammar) needed by external tokenizers. You declare them in a
grammar file as `@context exportName from "module"`.

Context values should be immutable, and can be updated (replaced)
on shift or reduce actions.

The export used in a `@context` declaration should be of this
type.
*/ class $96e8fc72168067c5$export$88193367295cc46b {
    /**
    Define a context tracker.
    */ constructor(spec){
        this.start = spec.start;
        this.shift = spec.shift || $96e8fc72168067c5$var$id;
        this.reduce = spec.reduce || $96e8fc72168067c5$var$id;
        this.reuse = spec.reuse || $96e8fc72168067c5$var$id;
        this.hash = spec.hash || (()=>0);
        this.strict = spec.strict !== false;
    }
}
/**
Holds the parse tables for a given grammar, as generated by
`lezer-generator`, and provides [methods](#common.Parser) to parse
content with.
*/ class $96e8fc72168067c5$export$60c033f4cf02b410 extends (0, $ed739beecf769914$export$7acfa6ed01010e37) {
    /**
    @internal
    */ constructor(spec){
        super();
        /**
        @internal
        */ this.wrappers = [];
        if (spec.version != 14 /* File.Version */ ) throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14 /* File.Version */ })`);
        let nodeNames = spec.nodeNames.split(" ");
        this.minRepeatTerm = nodeNames.length;
        for(let i = 0; i < spec.repeatNodeCount; i++)nodeNames.push("");
        let topTerms = Object.keys(spec.topRules).map((r)=>spec.topRules[r][1]);
        let nodeProps = [];
        for(let i = 0; i < nodeNames.length; i++)nodeProps.push([]);
        function setProp(nodeID, prop, value) {
            nodeProps[nodeID].push([
                prop,
                prop.deserialize(String(value))
            ]);
        }
        if (spec.nodeProps) for (let propSpec of spec.nodeProps){
            let prop = propSpec[0];
            if (typeof prop == "string") prop = (0, $ed739beecf769914$export$b8034b9bc18acd90)[prop];
            for(let i = 1; i < propSpec.length;){
                let next = propSpec[i++];
                if (next >= 0) setProp(next, prop, propSpec[i++]);
                else {
                    let value = propSpec[i + -next];
                    for(let j = -next; j > 0; j--)setProp(propSpec[i++], prop, value);
                    i++;
                }
            }
        }
        this.nodeSet = new (0, $ed739beecf769914$export$7fad5fb00d8de02c)(nodeNames.map((name, i)=>(0, $ed739beecf769914$export$f06e977173f1857c).define({
                name: i >= this.minRepeatTerm ? undefined : name,
                id: i,
                props: nodeProps[i],
                top: topTerms.indexOf(i) > -1,
                error: i == 0,
                skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i) > -1
            })));
        if (spec.propSources) this.nodeSet = this.nodeSet.extend(...spec.propSources);
        this.strict = false;
        this.bufferLength = (0, $ed739beecf769914$export$de305a849879ffa);
        let tokenArray = $96e8fc72168067c5$var$decodeArray(spec.tokenData);
        this.context = spec.context;
        this.specializerSpecs = spec.specialized || [];
        this.specialized = new Uint16Array(this.specializerSpecs.length);
        for(let i = 0; i < this.specializerSpecs.length; i++)this.specialized[i] = this.specializerSpecs[i].term;
        this.specializers = this.specializerSpecs.map($96e8fc72168067c5$var$getSpecializer);
        this.states = $96e8fc72168067c5$var$decodeArray(spec.states, Uint32Array);
        this.data = $96e8fc72168067c5$var$decodeArray(spec.stateData);
        this.goto = $96e8fc72168067c5$var$decodeArray(spec.goto);
        this.maxTerm = spec.maxTerm;
        this.tokenizers = spec.tokenizers.map((value)=>typeof value == "number" ? new $96e8fc72168067c5$var$TokenGroup(tokenArray, value) : value);
        this.topRules = spec.topRules;
        this.dialects = spec.dialects || {};
        this.dynamicPrecedences = spec.dynamicPrecedences || null;
        this.tokenPrecTable = spec.tokenPrec;
        this.termNames = spec.termNames || null;
        this.maxNode = this.nodeSet.types.length - 1;
        this.dialect = this.parseDialect();
        this.top = this.topRules[Object.keys(this.topRules)[0]];
    }
    createParse(input, fragments, ranges) {
        let parse = new $96e8fc72168067c5$var$Parse(this, input, fragments, ranges);
        for (let w of this.wrappers)parse = w(parse, input, fragments, ranges);
        return parse;
    }
    /**
    Get a goto table entry @internal
    */ getGoto(state, term, loose = false) {
        let table = this.goto;
        if (term >= table[0]) return -1;
        for(let pos = table[term + 1];;){
            let groupTag = table[pos++], last = groupTag & 1;
            let target = table[pos++];
            if (last && loose) return target;
            for(let end = pos + (groupTag >> 1); pos < end; pos++)if (table[pos] == state) return target;
            if (last) return -1;
        }
    }
    /**
    Check if this state has an action for a given terminal @internal
    */ hasAction(state, terminal) {
        let data = this.data;
        for(let set = 0; set < 2; set++)for(let i = this.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ ), next;; i += 3){
            if ((next = data[i]) == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) next = data[i = $96e8fc72168067c5$var$pair(data, i + 2)];
                else if (data[i + 1] == 2 /* Seq.Other */ ) return $96e8fc72168067c5$var$pair(data, i + 2);
                else break;
            }
            if (next == terminal || next == 0 /* Term.Err */ ) return $96e8fc72168067c5$var$pair(data, i + 1);
        }
        return 0;
    }
    /**
    @internal
    */ stateSlot(state, slot) {
        return this.states[state * 6 /* ParseState.Size */  + slot];
    }
    /**
    @internal
    */ stateFlag(state, flag) {
        return (this.stateSlot(state, 0 /* ParseState.Flags */ ) & flag) > 0;
    }
    /**
    @internal
    */ validAction(state, action) {
        return !!this.allActions(state, (a)=>a == action ? true : null);
    }
    /**
    @internal
    */ allActions(state, action) {
        let deflt = this.stateSlot(state, 4 /* ParseState.DefaultReduce */ );
        let result = deflt ? action(deflt) : undefined;
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ ); result == null; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $96e8fc72168067c5$var$pair(this.data, i + 2);
                else break;
            }
            result = action($96e8fc72168067c5$var$pair(this.data, i + 1));
        }
        return result;
    }
    /**
    Get the states that can follow this one through shift actions or
    goto jumps. @internal
    */ nextStates(state) {
        let result = [];
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ );; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $96e8fc72168067c5$var$pair(this.data, i + 2);
                else break;
            }
            if ((this.data[i + 2] & 1) == 0) {
                let value = this.data[i + 1];
                if (!result.some((v, i)=>i & 1 && v == value)) result.push(this.data[i], value);
            }
        }
        return result;
    }
    /**
    Configure the parser. Returns a new parser instance that has the
    given settings modified. Settings not provided in `config` are
    kept from the original parser.
    */ configure(config) {
        // Hideous reflection-based kludge to make it easy to create a
        // slightly modified copy of a parser.
        let copy = Object.assign(Object.create($96e8fc72168067c5$export$60c033f4cf02b410.prototype), this);
        if (config.props) copy.nodeSet = this.nodeSet.extend(...config.props);
        if (config.top) {
            let info = this.topRules[config.top];
            if (!info) throw new RangeError(`Invalid top rule name ${config.top}`);
            copy.top = info;
        }
        if (config.tokenizers) copy.tokenizers = this.tokenizers.map((t)=>{
            let found = config.tokenizers.find((r)=>r.from == t);
            return found ? found.to : t;
        });
        if (config.specializers) {
            copy.specializers = this.specializers.slice();
            copy.specializerSpecs = this.specializerSpecs.map((s, i)=>{
                let found = config.specializers.find((r)=>r.from == s.external);
                if (!found) return s;
                let spec = Object.assign(Object.assign({}, s), {
                    external: found.to
                });
                copy.specializers[i] = $96e8fc72168067c5$var$getSpecializer(spec);
                return spec;
            });
        }
        if (config.contextTracker) copy.context = config.contextTracker;
        if (config.dialect) copy.dialect = this.parseDialect(config.dialect);
        if (config.strict != null) copy.strict = config.strict;
        if (config.wrap) copy.wrappers = copy.wrappers.concat(config.wrap);
        if (config.bufferLength != null) copy.bufferLength = config.bufferLength;
        return copy;
    }
    /**
    Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
    are registered for this parser.
    */ hasWrappers() {
        return this.wrappers.length > 0;
    }
    /**
    Returns the name associated with a given term. This will only
    work for all terms when the parser was generated with the
    `--names` option. By default, only the names of tagged terms are
    stored.
    */ getName(term) {
        return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
    }
    /**
    The eof term id is always allocated directly after the node
    types. @internal
    */ get eofTerm() {
        return this.maxNode + 1;
    }
    /**
    The type of top node produced by the parser.
    */ get topNode() {
        return this.nodeSet.types[this.top[1]];
    }
    /**
    @internal
    */ dynamicPrecedence(term) {
        let prec = this.dynamicPrecedences;
        return prec == null ? 0 : prec[term] || 0;
    }
    /**
    @internal
    */ parseDialect(dialect) {
        let values = Object.keys(this.dialects), flags = values.map(()=>false);
        if (dialect) for (let part of dialect.split(" ")){
            let id = values.indexOf(part);
            if (id >= 0) flags[id] = true;
        }
        let disabled = null;
        for(let i = 0; i < values.length; i++)if (!flags[i]) for(let j = this.dialects[values[i]], id; (id = this.data[j++]) != 65535 /* Seq.End */ ;)(disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id] = 1;
        return new $96e8fc72168067c5$var$Dialect(dialect, flags, disabled);
    }
    /**
    Used by the output of the parser generator. Not available to
    user code. @hide
    */ static deserialize(spec) {
        return new $96e8fc72168067c5$export$60c033f4cf02b410(spec);
    }
}
function $96e8fc72168067c5$var$pair(data, off) {
    return data[off] | data[off + 1] << 16;
}
function $96e8fc72168067c5$var$findFinished(stacks) {
    let best = null;
    for (let stack of stacks){
        let stopped = stack.p.stoppedAt;
        if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(stack.state, 2 /* StateFlag.Accepting */ ) && (!best || best.score < stack.score)) best = stack;
    }
    return best;
}
function $96e8fc72168067c5$var$getSpecializer(spec) {
    if (spec.external) {
        let mask = spec.extend ? 1 /* Specialize.Extend */  : 0 /* Specialize.Specialize */ ;
        return (value, stack)=>spec.external(value, stack) << 1 | mask;
    }
    return spec.get;
}




// This file was generated by lezer-generator. You probably shouldn't edit it.
const $07236028cbce11ab$var$scriptText = 55, $07236028cbce11ab$var$StartCloseScriptTag = 1, $07236028cbce11ab$var$styleText = 56, $07236028cbce11ab$var$StartCloseStyleTag = 2, $07236028cbce11ab$var$textareaText = 57, $07236028cbce11ab$var$StartCloseTextareaTag = 3, $07236028cbce11ab$var$EndTag = 4, $07236028cbce11ab$var$SelfClosingEndTag = 5, $07236028cbce11ab$var$StartTag = 6, $07236028cbce11ab$var$StartScriptTag = 7, $07236028cbce11ab$var$StartStyleTag = 8, $07236028cbce11ab$var$StartTextareaTag = 9, $07236028cbce11ab$var$StartSelfClosingTag = 10, $07236028cbce11ab$var$StartCloseTag = 11, $07236028cbce11ab$var$NoMatchStartCloseTag = 12, $07236028cbce11ab$var$MismatchedStartCloseTag = 13, $07236028cbce11ab$var$missingCloseTag = 58, $07236028cbce11ab$var$IncompleteTag = 14, $07236028cbce11ab$var$IncompleteCloseTag = 15, $07236028cbce11ab$var$commentContent$1 = 59, $07236028cbce11ab$var$Element = 21, $07236028cbce11ab$var$TagName = 23, $07236028cbce11ab$var$Attribute = 24, $07236028cbce11ab$var$AttributeName = 25, $07236028cbce11ab$var$AttributeValue = 27, $07236028cbce11ab$var$UnquotedAttributeValue = 28, $07236028cbce11ab$var$ScriptText = 29, $07236028cbce11ab$var$StyleText = 32, $07236028cbce11ab$var$TextareaText = 35, $07236028cbce11ab$var$OpenTag = 37, $07236028cbce11ab$var$CloseTag = 38, $07236028cbce11ab$var$Dialect_noMatch = 0, $07236028cbce11ab$var$Dialect_selfClosing = 1;
/* Hand-written tokenizers for HTML. */ const $07236028cbce11ab$var$selfClosers = {
    area: true,
    base: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    menuitem: true
};
const $07236028cbce11ab$var$implicitlyClosed = {
    dd: true,
    li: true,
    optgroup: true,
    option: true,
    p: true,
    rp: true,
    rt: true,
    tbody: true,
    td: true,
    tfoot: true,
    th: true,
    tr: true
};
const $07236028cbce11ab$var$closeOnOpen = {
    dd: {
        dd: true,
        dt: true
    },
    dt: {
        dd: true,
        dt: true
    },
    li: {
        li: true
    },
    option: {
        option: true,
        optgroup: true
    },
    optgroup: {
        optgroup: true
    },
    p: {
        address: true,
        article: true,
        aside: true,
        blockquote: true,
        dir: true,
        div: true,
        dl: true,
        fieldset: true,
        footer: true,
        form: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        header: true,
        hgroup: true,
        hr: true,
        menu: true,
        nav: true,
        ol: true,
        p: true,
        pre: true,
        section: true,
        table: true,
        ul: true
    },
    rp: {
        rp: true,
        rt: true
    },
    rt: {
        rp: true,
        rt: true
    },
    tbody: {
        tbody: true,
        tfoot: true
    },
    td: {
        td: true,
        th: true
    },
    tfoot: {
        tbody: true
    },
    th: {
        td: true,
        th: true
    },
    thead: {
        tbody: true,
        tfoot: true
    },
    tr: {
        tr: true
    }
};
function $07236028cbce11ab$var$nameChar(ch) {
    return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}
let $07236028cbce11ab$var$cachedName = null, $07236028cbce11ab$var$cachedInput = null, $07236028cbce11ab$var$cachedPos = 0;
function $07236028cbce11ab$var$tagNameAfter(input, offset) {
    let pos = input.pos + offset;
    if ($07236028cbce11ab$var$cachedPos == pos && $07236028cbce11ab$var$cachedInput == input) return $07236028cbce11ab$var$cachedName;
    let next = input.peek(offset), name = "";
    for(;;){
        if (!$07236028cbce11ab$var$nameChar(next)) break;
        name += String.fromCharCode(next);
        next = input.peek(++offset);
    }
    // Undefined to signal there's a <? or <!, null for just missing
    $07236028cbce11ab$var$cachedInput = input;
    $07236028cbce11ab$var$cachedPos = pos;
    return $07236028cbce11ab$var$cachedName = name ? name.toLowerCase() : next == $07236028cbce11ab$var$question || next == $07236028cbce11ab$var$bang ? undefined : null;
}
const $07236028cbce11ab$var$lessThan = 60, $07236028cbce11ab$var$greaterThan = 62, $07236028cbce11ab$var$slash = 47, $07236028cbce11ab$var$question = 63, $07236028cbce11ab$var$bang = 33, $07236028cbce11ab$var$dash = 45;
function $07236028cbce11ab$var$ElementContext(name, parent) {
    this.name = name;
    this.parent = parent;
}
const $07236028cbce11ab$var$startTagTerms = [
    $07236028cbce11ab$var$StartTag,
    $07236028cbce11ab$var$StartSelfClosingTag,
    $07236028cbce11ab$var$StartScriptTag,
    $07236028cbce11ab$var$StartStyleTag,
    $07236028cbce11ab$var$StartTextareaTag
];
const $07236028cbce11ab$var$elementContext = new (0, $96e8fc72168067c5$export$88193367295cc46b)({
    start: null,
    shift (context, term, stack, input) {
        return $07236028cbce11ab$var$startTagTerms.indexOf(term) > -1 ? new $07236028cbce11ab$var$ElementContext($07236028cbce11ab$var$tagNameAfter(input, 1) || "", context) : context;
    },
    reduce (context, term) {
        return term == $07236028cbce11ab$var$Element && context ? context.parent : context;
    },
    reuse (context, node, stack, input) {
        let type = node.type.id;
        return type == $07236028cbce11ab$var$StartTag || type == $07236028cbce11ab$var$OpenTag ? new $07236028cbce11ab$var$ElementContext($07236028cbce11ab$var$tagNameAfter(input, 1) || "", context) : context;
    },
    strict: false
});
const $07236028cbce11ab$var$tagStart = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next != $07236028cbce11ab$var$lessThan) {
        // End of file, close any open tags
        if (input.next < 0 && stack.context) input.acceptToken($07236028cbce11ab$var$missingCloseTag);
        return;
    }
    input.advance();
    let close = input.next == $07236028cbce11ab$var$slash;
    if (close) input.advance();
    let name = $07236028cbce11ab$var$tagNameAfter(input, 0);
    if (name === undefined) return;
    if (!name) return input.acceptToken(close ? $07236028cbce11ab$var$IncompleteCloseTag : $07236028cbce11ab$var$IncompleteTag);
    let parent = stack.context ? stack.context.name : null;
    if (close) {
        if (name == parent) return input.acceptToken($07236028cbce11ab$var$StartCloseTag);
        if (parent && $07236028cbce11ab$var$implicitlyClosed[parent]) return input.acceptToken($07236028cbce11ab$var$missingCloseTag, -2);
        if (stack.dialectEnabled($07236028cbce11ab$var$Dialect_noMatch)) return input.acceptToken($07236028cbce11ab$var$NoMatchStartCloseTag);
        for(let cx = stack.context; cx; cx = cx.parent)if (cx.name == name) return;
        input.acceptToken($07236028cbce11ab$var$MismatchedStartCloseTag);
    } else {
        if (name == "script") return input.acceptToken($07236028cbce11ab$var$StartScriptTag);
        if (name == "style") return input.acceptToken($07236028cbce11ab$var$StartStyleTag);
        if (name == "textarea") return input.acceptToken($07236028cbce11ab$var$StartTextareaTag);
        if ($07236028cbce11ab$var$selfClosers.hasOwnProperty(name)) return input.acceptToken($07236028cbce11ab$var$StartSelfClosingTag);
        if (parent && $07236028cbce11ab$var$closeOnOpen[parent] && $07236028cbce11ab$var$closeOnOpen[parent][name]) input.acceptToken($07236028cbce11ab$var$missingCloseTag, -1);
        else input.acceptToken($07236028cbce11ab$var$StartTag);
    }
}, {
    contextual: true
});
const $07236028cbce11ab$var$commentContent = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input)=>{
    for(let dashes = 0, i = 0;; i++){
        if (input.next < 0) {
            if (i) input.acceptToken($07236028cbce11ab$var$commentContent$1);
            break;
        }
        if (input.next == $07236028cbce11ab$var$dash) dashes++;
        else if (input.next == $07236028cbce11ab$var$greaterThan && dashes >= 2) {
            if (i >= 3) input.acceptToken($07236028cbce11ab$var$commentContent$1, -2);
            break;
        } else dashes = 0;
        input.advance();
    }
});
function $07236028cbce11ab$var$inForeignElement(context) {
    for(; context; context = context.parent)if (context.name == "svg" || context.name == "math") return true;
    return false;
}
const $07236028cbce11ab$var$endTag = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next == $07236028cbce11ab$var$slash && input.peek(1) == $07236028cbce11ab$var$greaterThan) {
        let selfClosing = stack.dialectEnabled($07236028cbce11ab$var$Dialect_selfClosing) || $07236028cbce11ab$var$inForeignElement(stack.context);
        input.acceptToken(selfClosing ? $07236028cbce11ab$var$SelfClosingEndTag : $07236028cbce11ab$var$EndTag, 2);
    } else if (input.next == $07236028cbce11ab$var$greaterThan) input.acceptToken($07236028cbce11ab$var$EndTag, 1);
});
function $07236028cbce11ab$var$contentTokenizer(tag, textToken, endToken) {
    let lastState = 2 + tag.length;
    return new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input)=>{
        // state means:
        // - 0 nothing matched
        // - 1 '<' matched
        // - 2 '</'
        // - 3-(1+tag.length) part of the tag matched
        // - lastState whole tag + possibly whitespace matched
        for(let state = 0, matchedLen = 0, i = 0;; i++){
            if (input.next < 0) {
                if (i) input.acceptToken(textToken);
                break;
            }
            if (state == 0 && input.next == $07236028cbce11ab$var$lessThan || state == 1 && input.next == $07236028cbce11ab$var$slash || state >= 2 && state < lastState && input.next == tag.charCodeAt(state - 2)) {
                state++;
                matchedLen++;
            } else if (state == lastState && input.next == $07236028cbce11ab$var$greaterThan) {
                if (i > matchedLen) input.acceptToken(textToken, -matchedLen);
                else input.acceptToken(endToken, -(matchedLen - 2));
                break;
            } else if ((input.next == 10 /* '\n' */  || input.next == 13 /* '\r' */ ) && i) {
                input.acceptToken(textToken, 1);
                break;
            } else state = matchedLen = 0;
            input.advance();
        }
    });
}
const $07236028cbce11ab$var$scriptTokens = $07236028cbce11ab$var$contentTokenizer("script", $07236028cbce11ab$var$scriptText, $07236028cbce11ab$var$StartCloseScriptTag);
const $07236028cbce11ab$var$styleTokens = $07236028cbce11ab$var$contentTokenizer("style", $07236028cbce11ab$var$styleText, $07236028cbce11ab$var$StartCloseStyleTag);
const $07236028cbce11ab$var$textareaTokens = $07236028cbce11ab$var$contentTokenizer("textarea", $07236028cbce11ab$var$textareaText, $07236028cbce11ab$var$StartCloseTextareaTag);
const $07236028cbce11ab$var$htmlHighlighting = (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
    "Text RawText IncompleteTag IncompleteCloseTag": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).content,
    "StartTag StartCloseTag SelfClosingEndTag EndTag": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).angleBracket,
    TagName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName,
    "MismatchedCloseTag/TagName": [
        (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName,
        (0, $a1ec9d683d365521$export$8b7a896ae75accbf).invalid
    ],
    AttributeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeName,
    "AttributeValue UnquotedAttributeValue": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeValue,
    Is: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionOperator,
    "EntityReference CharacterReference": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).character,
    Comment: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).blockComment,
    ProcessingInst: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).processingInstruction,
    DoctypeDecl: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).documentMeta
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $07236028cbce11ab$export$8f49e4af10703ce3 = (0, $96e8fc72168067c5$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: ",xOVO!rOOO!ZQ#tO'#CrO!`Q#tO'#C{O!eQ#tO'#DOO!jQ#tO'#DRO!oQ#tO'#DTO!tOaO'#CqO#PObO'#CqO#[OdO'#CqO$kO!rO'#CqOOO`'#Cq'#CqO$rO$fO'#DUO$zQ#tO'#DWO%PQ#tO'#DXOOO`'#Dl'#DlOOO`'#DZ'#DZQVO!rOOO%UQ&rO,59^O%aQ&rO,59gO%lQ&rO,59jO%wQ&rO,59mO&SQ&rO,59oOOOa'#D_'#D_O&_OaO'#CyO&jOaO,59]OOOb'#D`'#D`O&rObO'#C|O&}ObO,59]OOOd'#Da'#DaO'VOdO'#DPO'bOdO,59]OOO`'#Db'#DbO'jO!rO,59]O'qQ#tO'#DSOOO`,59],59]OOOp'#Dc'#DcO'vO$fO,59pOOO`,59p,59pO(OQ#|O,59rO(TQ#|O,59sOOO`-E7X-E7XO(YQ&rO'#CtOOQW'#D['#D[O(hQ&rO1G.xOOOa1G.x1G.xOOO`1G/Z1G/ZO(sQ&rO1G/ROOOb1G/R1G/RO)OQ&rO1G/UOOOd1G/U1G/UO)ZQ&rO1G/XOOO`1G/X1G/XO)fQ&rO1G/ZOOOa-E7]-E7]O)qQ#tO'#CzOOO`1G.w1G.wOOOb-E7^-E7^O)vQ#tO'#C}OOOd-E7_-E7_O){Q#tO'#DQOOO`-E7`-E7`O*QQ#|O,59nOOOp-E7a-E7aOOO`1G/[1G/[OOO`1G/^1G/^OOO`1G/_1G/_O*VQ,UO,59`OOQW-E7Y-E7YOOOa7+$d7+$dOOO`7+$u7+$uOOOb7+$m7+$mOOOd7+$p7+$pOOO`7+$s7+$sO*bQ#|O,59fO*gQ#|O,59iO*lQ#|O,59lOOO`1G/Y1G/YO*qO7[O'#CwO+SOMhO'#CwOOQW1G.z1G.zOOO`1G/Q1G/QOOO`1G/T1G/TOOO`1G/W1G/WOOOO'#D]'#D]O+eO7[O,59cOOQW,59c,59cOOOO'#D^'#D^O+vOMhO,59cOOOO-E7Z-E7ZOOQW1G.}1G.}OOOO-E7[-E7[",
    stateData: ",c~O!_OS~OUSOVPOWQOXROYTO[]O][O^^O_^Oa^Ob^Oc^Od^Oy^O|_O!eZO~OgaO~OgbO~OgcO~OgdO~OgeO~O!XfOPmP![mP~O!YiOQpP![pP~O!ZlORsP![sP~OUSOVPOWQOXROYTOZqO[]O][O^^O_^Oa^Ob^Oc^Od^Oy^O!eZO~O![rO~P#gO!]sO!fuO~OgvO~OgwO~OS|OT}OiyO~OS!POT}OiyO~OS!ROT}OiyO~OS!TOT}OiyO~OS}OT}OiyO~O!XfOPmX![mX~OP!WO![!XO~O!YiOQpX![pX~OQ!ZO![!XO~O!ZlORsX![sX~OR!]O![!XO~O![!XO~P#gOg!_O~O!]sO!f!aO~OS!bO~OS!cO~Oj!dOShXThXihX~OS!fOT!gOiyO~OS!hOT!gOiyO~OS!iOT!gOiyO~OS!jOT!gOiyO~OS!gOT!gOiyO~Og!kO~Og!lO~Og!mO~OS!nO~Ol!qO!a!oO!c!pO~OS!rO~OS!sO~OS!tO~Ob!uOc!uOd!uO!a!wO!b!uO~Ob!xOc!xOd!xO!c!wO!d!xO~Ob!uOc!uOd!uO!a!{O!b!uO~Ob!xOc!xOd!xO!c!{O!d!xO~OT~cbd!ey|!e~",
    goto: "%q!aPPPPPPPPPPPPPPPPPPPPP!b!hP!nPP!zP!}#Q#T#Z#^#a#g#j#m#s#y!bP!b!bP$P$V$m$s$y%P%V%]%cPPPPPPPP%iX^OX`pXUOX`pezabcde{!O!Q!S!UR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ!ObQ!QcQ!SdQ!UeZ!e{!O!Q!S!UQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
    nodeNames: "\u26A0 StartCloseTag StartCloseTag StartCloseTag EndTag SelfClosingEndTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
    maxTerm: 68,
    context: $07236028cbce11ab$var$elementContext,
    nodeProps: [
        [
            "closedBy",
            -10,
            1,
            2,
            3,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            "EndTag",
            6,
            "EndTag SelfClosingEndTag",
            -4,
            22,
            31,
            34,
            37,
            "CloseTag"
        ],
        [
            "openedBy",
            4,
            "StartTag StartCloseTag",
            5,
            "StartTag",
            -4,
            30,
            33,
            36,
            38,
            "OpenTag"
        ],
        [
            "group",
            -10,
            14,
            15,
            18,
            19,
            20,
            21,
            40,
            41,
            42,
            43,
            "Entity",
            17,
            "Entity TextContent",
            -3,
            29,
            32,
            35,
            "TextContent Entity"
        ],
        [
            "isolate",
            -11,
            22,
            30,
            31,
            33,
            34,
            36,
            37,
            38,
            39,
            42,
            43,
            "ltr",
            -3,
            27,
            28,
            40,
            ""
        ]
    ],
    propSources: [
        $07236028cbce11ab$var$htmlHighlighting
    ],
    skippedNodes: [
        0
    ],
    repeatNodeCount: 9,
    tokenData: "!<p!aR!YOX$qXY,QYZ,QZ[$q[]&X]^,Q^p$qpq,Qqr-_rs3_sv-_vw3}wxHYx}-_}!OH{!O!P-_!P!Q$q!Q![-_![!]Mz!]!^-_!^!_!$S!_!`!;x!`!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4U-_4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!Z$|caPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr$qrs&}sv$qvw+Pwx(tx!^$q!^!_*V!_!a&X!a#S$q#S#T&X#T;'S$q;'S;=`+z<%lO$q!R&bXaP!b`!dpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&Xq'UVaP!dpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}P'pTaPOv'kw!^'k!_;'S'k;'S;=`(P<%lO'kP(SP;=`<%l'kp([S!dpOv(Vx;'S(V;'S;=`(h<%lO(Vp(kP;=`<%l(Vq(qP;=`<%l&}a({WaP!b`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t`)jT!b`Or)esv)ew;'S)e;'S;=`)y<%lO)e`)|P;=`<%l)ea*SP;=`<%l(t!Q*^V!b`!dpOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!Q*vP;=`<%l*V!R*|P;=`<%l&XW+UYlWOX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+PW+wP;=`<%l+P!Z+}P;=`<%l$q!a,]`aP!b`!dp!_^OX&XXY,QYZ,QZ]&X]^,Q^p&Xpq,Qqr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!_-ljiSaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q[/ebiSlWOX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+PS0rXiSqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0mS1bP;=`<%l0m[1hP;=`<%l/^!V1vciSaP!b`!dpOq&Xqr1krs&}sv1kvw0mwx(tx!P1k!P!Q&X!Q!^1k!^!_*V!_!a&X!a#s1k#s$f&X$f;'S1k;'S;=`3R<%l?Ah1k?Ah?BY&X?BY?Mn1k?MnO&X!V3UP;=`<%l1k!_3[P;=`<%l-_!Z3hV!ahaP!dpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}!_4WiiSlWd!ROX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst>]tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^/^!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!Z5zblWOX5uXZ7SZ[5u[^7S^p5uqr5urs7Sst+Ptw5uwx7Sx!]5u!]!^7w!^!a7S!a#S5u#S#T7S#T;'S5u;'S;=`8n<%lO5u!R7VVOp7Sqs7St!]7S!]!^7l!^;'S7S;'S;=`7q<%lO7S!R7qOb!R!R7tP;=`<%l7S!Z8OYlWb!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!Z8qP;=`<%l5u!_8{iiSlWOX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst/^tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^:j!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!_:sbiSlWb!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!V<QciSOp7Sqr;{rs7Sst0mtw;{wx7Sx!P;{!P!Q7S!Q!];{!]!^=]!^!a7S!a#s;{#s$f7S$f;'S;{;'S;=`>P<%l?Ah;{?Ah?BY7S?BY?Mn;{?MnO7S!V=dXiSb!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!V>SP;=`<%l;{!_>YP;=`<%l8t!_>dhiSlWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^/^!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!Z@TalWOX@OXZAYZ[@O[^AY^p@Oqr@OrsAYsw@OwxAYx!]@O!]!^Az!^!aAY!a#S@O#S#TAY#T;'S@O;'S;=`Bq<%lO@O!RA]UOpAYq!]AY!]!^Ao!^;'SAY;'S;=`At<%lOAY!RAtOc!R!RAwP;=`<%lAY!ZBRYlWc!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!ZBtP;=`<%l@O!_COhiSlWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^Dj!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!_DsbiSlWc!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!VFQbiSOpAYqrE{rsAYswE{wxAYx!PE{!P!QAY!Q!]E{!]!^GY!^!aAY!a#sE{#s$fAY$f;'SE{;'S;=`G|<%l?AhE{?Ah?BYAY?BY?MnE{?MnOAY!VGaXiSc!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!VHPP;=`<%lE{!_HVP;=`<%lBw!ZHcW!cxaP!b`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t!aIYliSaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OKQ!O!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!aK_kiSaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!`&X!`!aMS!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!TM_XaP!b`!dp!fQOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!aNZ!ZiSgQaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OMz!O!PMz!P!Q$q!Q![Mz![!]Mz!]!^-_!^!_*V!_!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f$}-_$}%OMz%O%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4UMz4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Je-_$Je$JgMz$Jg$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!a!$PP;=`<%lMz!R!$ZY!b`!dpOq*Vqr!$yrs(Vsv*Vwx)ex!a*V!a!b!4t!b;'S*V;'S;=`*s<%lO*V!R!%Q]!b`!dpOr*Vrs(Vsv*Vwx)ex}*V}!O!%y!O!f*V!f!g!']!g#W*V#W#X!0`#X;'S*V;'S;=`*s<%lO*V!R!&QX!b`!dpOr*Vrs(Vsv*Vwx)ex}*V}!O!&m!O;'S*V;'S;=`*s<%lO*V!R!&vV!b`!dp!ePOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!'dX!b`!dpOr*Vrs(Vsv*Vwx)ex!q*V!q!r!(P!r;'S*V;'S;=`*s<%lO*V!R!(WX!b`!dpOr*Vrs(Vsv*Vwx)ex!e*V!e!f!(s!f;'S*V;'S;=`*s<%lO*V!R!(zX!b`!dpOr*Vrs(Vsv*Vwx)ex!v*V!v!w!)g!w;'S*V;'S;=`*s<%lO*V!R!)nX!b`!dpOr*Vrs(Vsv*Vwx)ex!{*V!{!|!*Z!|;'S*V;'S;=`*s<%lO*V!R!*bX!b`!dpOr*Vrs(Vsv*Vwx)ex!r*V!r!s!*}!s;'S*V;'S;=`*s<%lO*V!R!+UX!b`!dpOr*Vrs(Vsv*Vwx)ex!g*V!g!h!+q!h;'S*V;'S;=`*s<%lO*V!R!+xY!b`!dpOr!+qrs!,hsv!+qvw!-Swx!.[x!`!+q!`!a!/j!a;'S!+q;'S;=`!0Y<%lO!+qq!,mV!dpOv!,hvx!-Sx!`!,h!`!a!-q!a;'S!,h;'S;=`!.U<%lO!,hP!-VTO!`!-S!`!a!-f!a;'S!-S;'S;=`!-k<%lO!-SP!-kO|PP!-nP;=`<%l!-Sq!-xS!dp|POv(Vx;'S(V;'S;=`(h<%lO(Vq!.XP;=`<%l!,ha!.aX!b`Or!.[rs!-Ssv!.[vw!-Sw!`!.[!`!a!.|!a;'S!.[;'S;=`!/d<%lO!.[a!/TT!b`|POr)esv)ew;'S)e;'S;=`)y<%lO)ea!/gP;=`<%l!.[!R!/sV!b`!dp|POr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!0]P;=`<%l!+q!R!0gX!b`!dpOr*Vrs(Vsv*Vwx)ex#c*V#c#d!1S#d;'S*V;'S;=`*s<%lO*V!R!1ZX!b`!dpOr*Vrs(Vsv*Vwx)ex#V*V#V#W!1v#W;'S*V;'S;=`*s<%lO*V!R!1}X!b`!dpOr*Vrs(Vsv*Vwx)ex#h*V#h#i!2j#i;'S*V;'S;=`*s<%lO*V!R!2qX!b`!dpOr*Vrs(Vsv*Vwx)ex#m*V#m#n!3^#n;'S*V;'S;=`*s<%lO*V!R!3eX!b`!dpOr*Vrs(Vsv*Vwx)ex#d*V#d#e!4Q#e;'S*V;'S;=`*s<%lO*V!R!4XX!b`!dpOr*Vrs(Vsv*Vwx)ex#X*V#X#Y!+q#Y;'S*V;'S;=`*s<%lO*V!R!4{Y!b`!dpOr!4trs!5ksv!4tvw!6Vwx!8]x!a!4t!a!b!:]!b;'S!4t;'S;=`!;r<%lO!4tq!5pV!dpOv!5kvx!6Vx!a!5k!a!b!7W!b;'S!5k;'S;=`!8V<%lO!5kP!6YTO!a!6V!a!b!6i!b;'S!6V;'S;=`!7Q<%lO!6VP!6lTO!`!6V!`!a!6{!a;'S!6V;'S;=`!7Q<%lO!6VP!7QOyPP!7TP;=`<%l!6Vq!7]V!dpOv!5kvx!6Vx!`!5k!`!a!7r!a;'S!5k;'S;=`!8V<%lO!5kq!7yS!dpyPOv(Vx;'S(V;'S;=`(h<%lO(Vq!8YP;=`<%l!5ka!8bX!b`Or!8]rs!6Vsv!8]vw!6Vw!a!8]!a!b!8}!b;'S!8];'S;=`!:V<%lO!8]a!9SX!b`Or!8]rs!6Vsv!8]vw!6Vw!`!8]!`!a!9o!a;'S!8];'S;=`!:V<%lO!8]a!9vT!b`yPOr)esv)ew;'S)e;'S;=`)y<%lO)ea!:YP;=`<%l!8]!R!:dY!b`!dpOr!4trs!5ksv!4tvw!6Vwx!8]x!`!4t!`!a!;S!a;'S!4t;'S;=`!;r<%lO!4t!R!;]V!b`!dpyPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!;uP;=`<%l!4t!V!<TXjSaP!b`!dpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X",
    tokenizers: [
        $07236028cbce11ab$var$scriptTokens,
        $07236028cbce11ab$var$styleTokens,
        $07236028cbce11ab$var$textareaTokens,
        $07236028cbce11ab$var$endTag,
        $07236028cbce11ab$var$tagStart,
        $07236028cbce11ab$var$commentContent,
        0,
        1,
        2,
        3,
        4,
        5
    ],
    topRules: {
        "Document": [
            0,
            16
        ]
    },
    dialects: {
        noMatch: 0,
        selfClosing: 515
    },
    tokenPrec: 517
});
function $07236028cbce11ab$var$getAttrs(openTag, input) {
    let attrs = Object.create(null);
    for (let att of openTag.getChildren($07236028cbce11ab$var$Attribute)){
        let name = att.getChild($07236028cbce11ab$var$AttributeName), value = att.getChild($07236028cbce11ab$var$AttributeValue) || att.getChild($07236028cbce11ab$var$UnquotedAttributeValue);
        if (name) attrs[input.read(name.from, name.to)] = !value ? "" : value.type.id == $07236028cbce11ab$var$AttributeValue ? input.read(value.from + 1, value.to - 1) : input.read(value.from, value.to);
    }
    return attrs;
}
function $07236028cbce11ab$var$findTagName(openTag, input) {
    let tagNameNode = openTag.getChild($07236028cbce11ab$var$TagName);
    return tagNameNode ? input.read(tagNameNode.from, tagNameNode.to) : " ";
}
function $07236028cbce11ab$var$maybeNest(node, input, tags) {
    let attrs;
    for (let tag of tags){
        if (!tag.attrs || tag.attrs(attrs || (attrs = $07236028cbce11ab$var$getAttrs(node.node.parent.firstChild, input)))) return {
            parser: tag.parser
        };
    }
    return null;
}
// tags?: {
//   tag: string,
//   attrs?: ({[attr: string]: string}) => boolean,
//   parser: Parser
// }[]
// attributes?: {
//   name: string,
//   tagName?: string,
//   parser: Parser
// }[]
function $07236028cbce11ab$export$3a6217e5968adf01(tags = [], attributes = []) {
    let script = [], style = [], textarea = [], other = [];
    for (let tag of tags){
        let array = tag.tag == "script" ? script : tag.tag == "style" ? style : tag.tag == "textarea" ? textarea : other;
        array.push(tag);
    }
    let attrs = attributes.length ? Object.create(null) : null;
    for (let attr of attributes)(attrs[attr.name] || (attrs[attr.name] = [])).push(attr);
    return (0, $ed739beecf769914$export$5dcc455959c76221)((node, input)=>{
        let id = node.type.id;
        if (id == $07236028cbce11ab$var$ScriptText) return $07236028cbce11ab$var$maybeNest(node, input, script);
        if (id == $07236028cbce11ab$var$StyleText) return $07236028cbce11ab$var$maybeNest(node, input, style);
        if (id == $07236028cbce11ab$var$TextareaText) return $07236028cbce11ab$var$maybeNest(node, input, textarea);
        if (id == $07236028cbce11ab$var$Element && other.length) {
            let n = node.node, open = n.firstChild, tagName = open && $07236028cbce11ab$var$findTagName(open, input), attrs;
            if (tagName) {
                for (let tag of other)if (tag.tag == tagName && (!tag.attrs || tag.attrs(attrs || (attrs = $07236028cbce11ab$var$getAttrs(open, input))))) {
                    let close = n.lastChild;
                    let to = close.type.id == $07236028cbce11ab$var$CloseTag ? close.from : n.to;
                    if (to > open.to) return {
                        parser: tag.parser,
                        overlay: [
                            {
                                from: open.to,
                                to: to
                            }
                        ]
                    };
                }
            }
        }
        if (attrs && id == $07236028cbce11ab$var$Attribute) {
            let n = node.node, nameNode;
            if (nameNode = n.firstChild) {
                let matches = attrs[input.read(nameNode.from, nameNode.to)];
                if (matches) for (let attr of matches){
                    if (attr.tagName && attr.tagName != $07236028cbce11ab$var$findTagName(n.parent, input)) continue;
                    let value = n.lastChild;
                    if (value.type.id == $07236028cbce11ab$var$AttributeValue) {
                        let from = value.from + 1;
                        let last = value.lastChild, to = value.to - (last && last.isError ? 0 : 1);
                        if (to > from) return {
                            parser: attr.parser,
                            overlay: [
                                {
                                    from: from,
                                    to: to
                                }
                            ]
                        };
                    } else if (value.type.id == $07236028cbce11ab$var$UnquotedAttributeValue) return {
                        parser: attr.parser,
                        overlay: [
                            {
                                from: value.from,
                                to: value.to
                            }
                        ]
                    };
                }
            }
        }
        return null;
    });
}




// This file was generated by lezer-generator. You probably shouldn't edit it.
const $2479bc0bd5ea48bf$var$descendantOp = 122, $2479bc0bd5ea48bf$var$Unit = 1, $2479bc0bd5ea48bf$var$identifier = 123, $2479bc0bd5ea48bf$var$callee = 124, $2479bc0bd5ea48bf$var$VariableName = 2, $2479bc0bd5ea48bf$var$queryIdentifier = 125, $2479bc0bd5ea48bf$var$queryVariableName = 3, $2479bc0bd5ea48bf$var$QueryCallee = 4;
/* Hand-written tokenizers for CSS tokens that can't be
   expressed by Lezer's built-in tokenizer. */ const $2479bc0bd5ea48bf$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $2479bc0bd5ea48bf$var$colon = 58, $2479bc0bd5ea48bf$var$parenL = 40, $2479bc0bd5ea48bf$var$underscore = 95, $2479bc0bd5ea48bf$var$bracketL = 91, $2479bc0bd5ea48bf$var$dash = 45, $2479bc0bd5ea48bf$var$period = 46, $2479bc0bd5ea48bf$var$hash = 35, $2479bc0bd5ea48bf$var$percent = 37, $2479bc0bd5ea48bf$var$ampersand = 38, $2479bc0bd5ea48bf$var$backslash = 92, $2479bc0bd5ea48bf$var$newline = 10, $2479bc0bd5ea48bf$var$asterisk = 42;
function $2479bc0bd5ea48bf$var$isAlpha(ch) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch >= 161;
}
function $2479bc0bd5ea48bf$var$isDigit(ch) {
    return ch >= 48 && ch <= 57;
}
function $2479bc0bd5ea48bf$var$isHex(ch) {
    return $2479bc0bd5ea48bf$var$isDigit(ch) || ch >= 97 && ch <= 102 || ch >= 65 && ch <= 70;
}
const $2479bc0bd5ea48bf$var$identifierTokens = (id, varName, callee)=>(input, stack)=>{
        for(let inside = false, dashes = 0, i = 0;; i++){
            let { next: next } = input;
            if ($2479bc0bd5ea48bf$var$isAlpha(next) || next == $2479bc0bd5ea48bf$var$dash || next == $2479bc0bd5ea48bf$var$underscore || inside && $2479bc0bd5ea48bf$var$isDigit(next)) {
                if (!inside && (next != $2479bc0bd5ea48bf$var$dash || i > 0)) inside = true;
                if (dashes === i && next == $2479bc0bd5ea48bf$var$dash) dashes++;
                input.advance();
            } else if (next == $2479bc0bd5ea48bf$var$backslash && input.peek(1) != $2479bc0bd5ea48bf$var$newline) {
                input.advance();
                if ($2479bc0bd5ea48bf$var$isHex(input.next)) {
                    do input.advance();
                    while ($2479bc0bd5ea48bf$var$isHex(input.next));
                    if (input.next == 32) input.advance();
                } else if (input.next > -1) input.advance();
                inside = true;
            } else {
                if (inside) input.acceptToken(dashes == 2 && stack.canShift($2479bc0bd5ea48bf$var$VariableName) ? varName : next == $2479bc0bd5ea48bf$var$parenL ? callee : id);
                break;
            }
        }
    };
const $2479bc0bd5ea48bf$var$identifiers = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)($2479bc0bd5ea48bf$var$identifierTokens($2479bc0bd5ea48bf$var$identifier, $2479bc0bd5ea48bf$var$VariableName, $2479bc0bd5ea48bf$var$callee));
const $2479bc0bd5ea48bf$var$queryIdentifiers = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)($2479bc0bd5ea48bf$var$identifierTokens($2479bc0bd5ea48bf$var$queryIdentifier, $2479bc0bd5ea48bf$var$queryVariableName, $2479bc0bd5ea48bf$var$QueryCallee));
const $2479bc0bd5ea48bf$var$descendant = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input)=>{
    if ($2479bc0bd5ea48bf$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if ($2479bc0bd5ea48bf$var$isAlpha(next) || next == $2479bc0bd5ea48bf$var$underscore || next == $2479bc0bd5ea48bf$var$hash || next == $2479bc0bd5ea48bf$var$period || next == $2479bc0bd5ea48bf$var$asterisk || next == $2479bc0bd5ea48bf$var$bracketL || next == $2479bc0bd5ea48bf$var$colon && $2479bc0bd5ea48bf$var$isAlpha(input.peek(1)) || next == $2479bc0bd5ea48bf$var$dash || next == $2479bc0bd5ea48bf$var$ampersand) input.acceptToken($2479bc0bd5ea48bf$var$descendantOp);
    }
});
const $2479bc0bd5ea48bf$var$unitToken = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input)=>{
    if (!$2479bc0bd5ea48bf$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if (next == $2479bc0bd5ea48bf$var$percent) {
            input.advance();
            input.acceptToken($2479bc0bd5ea48bf$var$Unit);
        }
        if ($2479bc0bd5ea48bf$var$isAlpha(next)) {
            do input.advance();
            while ($2479bc0bd5ea48bf$var$isAlpha(input.next) || $2479bc0bd5ea48bf$var$isDigit(input.next));
            input.acceptToken($2479bc0bd5ea48bf$var$Unit);
        }
    }
});
const $2479bc0bd5ea48bf$var$cssHighlighting = (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
    "AtKeyword import charset namespace keyframes media supports": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionKeyword,
    "from to selector": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
    NamespaceName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).namespace,
    KeyframeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName,
    KeyframeRangeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    TagName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName,
    ClassName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className,
    PseudoClassName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).constant((0, $a1ec9d683d365521$export$8b7a896ae75accbf).className),
    IdName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName,
    "FeatureName PropertyName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName,
    AttributeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeName,
    NumberLiteral: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).number,
    KeywordQuery: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
    UnaryQueryOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    "CallTag ValueName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
    VariableName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName,
    Callee: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    Unit: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).unit,
    "UniversalSelector NestingSelector": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionOperator,
    "MatchOp CompareOp": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).compareOperator,
    "ChildOp SiblingOp, LogicOp": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).logicOperator,
    BinOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).arithmeticOperator,
    Important: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
    Comment: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).blockComment,
    ColorLiteral: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).color,
    "ParenthesizedContent StringLiteral": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
    ":": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).punctuation,
    "PseudoOp #": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).derefOperator,
    "; ,": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).separator,
    "( )": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).paren,
    "[ ]": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).squareBracket,
    "{ }": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).brace
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $2479bc0bd5ea48bf$var$spec_callee = {
    __proto__: null,
    lang: 38,
    "nth-child": 38,
    "nth-last-child": 38,
    "nth-of-type": 38,
    "nth-last-of-type": 38,
    dir: 38,
    "host-context": 38,
    if: 84,
    url: 124,
    "url-prefix": 124,
    domain: 124,
    regexp: 124
};
const $2479bc0bd5ea48bf$var$spec_queryIdentifier = {
    __proto__: null,
    or: 98,
    and: 98,
    not: 106,
    only: 106,
    layer: 170
};
const $2479bc0bd5ea48bf$var$spec_QueryCallee = {
    __proto__: null,
    selector: 112,
    layer: 166
};
const $2479bc0bd5ea48bf$var$spec_AtKeyword = {
    __proto__: null,
    "@import": 162,
    "@media": 174,
    "@charset": 178,
    "@namespace": 182,
    "@keyframes": 188,
    "@supports": 200,
    "@scope": 204
};
const $2479bc0bd5ea48bf$var$spec_identifier = {
    __proto__: null,
    to: 207
};
const $2479bc0bd5ea48bf$export$8f49e4af10703ce3 = (0, $96e8fc72168067c5$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: "EbQYQdOOO#qQdOOP#xO`OOOOQP'#Cf'#CfOOQP'#Ce'#CeO#}QdO'#ChO$nQaO'#CcO$xQdO'#CkO%TQdO'#DpO%YQdO'#DrO%_QdO'#DuO%_QdO'#DxOOQP'#FV'#FVO&eQhO'#EhOOQS'#FU'#FUOOQS'#Ek'#EkQYQdOOO&lQdO'#EOO&PQhO'#EUO&lQdO'#EWO'aQdO'#EYO'lQdO'#E]O'tQhO'#EcO(VQdO'#EeO(bQaO'#CfO)VQ`O'#D{O)[Q`O'#F`O)gQdO'#F`QOQ`OOP)qO&jO'#CaPOOO)C@t)C@tOOQP'#Cj'#CjOOQP,59S,59SO#}QdO,59SO)|QdO,59VO%TQdO,5:[O%YQdO,5:^O%_QdO,5:aO%_QdO,5:cO%_QdO,5:dO%_QdO'#ErO*XQ`O,58}O*aQdO'#DzOOQS,58},58}OOQP'#Cn'#CnOOQO'#Dn'#DnOOQP,59V,59VO*hQ`O,59VO*mQ`O,59VOOQP'#Dq'#DqOOQP,5:[,5:[OOQO'#Ds'#DsO*rQpO,5:^O+]QaO,5:aO+sQaO,5:dOOQW'#DZ'#DZO,ZQhO'#DdO,xQhO'#FaO'tQhO'#DbO-WQ`O'#DhOOQW'#F['#F[O-]Q`O,5;SO-eQ`O'#DeOOQS-E8i-E8iOOQ['#Cs'#CsO-jQdO'#CtO.QQdO'#CzO.hQdO'#C}O/OQ!pO'#DPO1RQ!jO,5:jOOQO'#DU'#DUO*mQ`O'#DTO1cQ!nO'#FXO3`Q`O'#DVO3eQ`O'#DkOOQ['#FX'#FXO-`Q`O,5:pO3jQ!bO,5:rOOQS'#E['#E[O3rQ`O,5:tO3wQdO,5:tOOQO'#E_'#E_O4PQ`O,5:wO4UQhO,5:}O%_QdO'#DgOOQS,5;P,5;PO-eQ`O,5;PO4^QdO,5;PO4fQdO,5:gO4vQdO'#EtO5TQ`O,5;zO5TQ`O,5;zPOOO'#Ej'#EjP5`O&jO,58{POOO,58{,58{OOQP1G.n1G.nOOQP1G.q1G.qO*hQ`O1G.qO*mQ`O1G.qOOQP1G/v1G/vO5kQpO1G/xO5sQaO1G/{O6ZQaO1G/}O6qQaO1G0OO7XQaO,5;^OOQO-E8p-E8pOOQS1G.i1G.iO7cQ`O,5:fO7hQdO'#DoO7oQdO'#CrOOQP1G/x1G/xO&lQdO1G/xO7vQ!jO'#DZO8UQ!bO,59vO8^QhO,5:OOOQO'#F]'#F]O8XQ!bO,59zO'tQhO,59xO8fQhO'#EvO8sQ`O,5;{O9OQhO,59|O9uQhO'#DiOOQW,5:S,5:SOOQS1G0n1G0nOOQW,5:P,5:PO9|Q!fO'#FYOOQS'#FY'#FYOOQS'#Em'#EmO;^QdO,59`OOQ[,59`,59`O;tQdO,59fOOQ[,59f,59fO<[QdO,59iOOQ[,59i,59iOOQ[,59k,59kO&lQdO,59mO<rQhO'#EQOOQW'#EQ'#EQO=WQ`O1G0UO1[QhO1G0UOOQ[,59o,59oO'tQhO'#DXOOQ[,59q,59qO=]Q#tO,5:VOOQS1G0[1G0[OOQS1G0^1G0^OOQS1G0`1G0`O=hQ`O1G0`O=mQdO'#E`OOQS1G0c1G0cOOQS1G0i1G0iO=xQaO,5:RO-`Q`O1G0kOOQS1G0k1G0kO-eQ`O1G0kO>PQ!fO1G0ROOQO1G0R1G0ROOQO,5;`,5;`O>gQdO,5;`OOQO-E8r-E8rO>tQ`O1G1fPOOO-E8h-E8hPOOO1G.g1G.gOOQP7+$]7+$]OOQP7+%d7+%dO&lQdO7+%dOOQS1G0Q1G0QO?PQaO'#F_O?ZQ`O,5:ZO?`Q!fO'#ElO@^QdO'#FWO@hQ`O,59^O@mQ!bO7+%dO&lQdO1G/bO@uQhO1G/fOOQW1G/j1G/jOOQW1G/d1G/dOAWQhO,5;bOOQO-E8t-E8tOAfQhO'#DZOAtQhO'#F^OBPQ`O'#F^OBUQ`O,5:TOOQS-E8k-E8kOOQ[1G.z1G.zOOQ[1G/Q1G/QOOQ[1G/T1G/TOOQ[1G/X1G/XOBZQdO,5:lOOQS7+%p7+%pOB`Q`O7+%pOBeQhO'#DYOBmQ`O,59sO'tQhO,59sOOQ[1G/q1G/qOBuQ`O1G/qOOQS7+%z7+%zOBzQbO'#DPOOQO'#Eb'#EbOCYQ`O'#EaOOQO'#Ea'#EaOCeQ`O'#EwOCmQdO,5:zOOQS,5:z,5:zOOQ[1G/m1G/mOOQS7+&V7+&VO-`Q`O7+&VOCxQ!fO'#EsO&lQdO'#EsOEPQdO7+%mOOQO7+%m7+%mOOQO1G0z1G0zOEdQ!bO<<IOOElQdO'#EqOEvQ`O,5;yOOQP1G/u1G/uOOQS-E8j-E8jOFOQdO'#EpOFYQ`O,5;rOOQ]1G.x1G.xOOQP<<IO<<IOOFbQdO7+$|OOQO'#D]'#D]OFiQ!bO7+%QOFqQhO'#EoOF{Q`O,5;xO&lQdO,5;xOOQW1G/o1G/oOOQO'#ES'#ESOGTQ`O1G0WOOQS<<I[<<I[O&lQdO,59tOGnQhO1G/_OOQ[1G/_1G/_OGuQ`O1G/_OOQW-E8l-E8lOOQ[7+%]7+%]OOQO,5:{,5:{O=pQdO'#ExOCeQ`O,5;cOOQS,5;c,5;cOOQS-E8u-E8uOOQS1G0f1G0fOOQS<<Iq<<IqOG}Q!fO,5;_OOQS-E8q-E8qOOQO<<IX<<IXOOQPAN>jAN>jOIUQaO,5;]OOQO-E8o-E8oOI`QdO,5;[OOQO-E8n-E8nOOQW<<Hh<<HhOOQW<<Hl<<HlOIjQhO<<HlOI{QhO,5;ZOJWQ`O,5;ZOOQO-E8m-E8mOJ]QdO1G1dOBZQdO'#EuOJgQ`O7+%rOOQW7+%r7+%rOJoQ!bO1G/`OOQ[7+$y7+$yOJzQhO7+$yPKRQ`O'#EnOOQO,5;d,5;dOOQO-E8v-E8vOOQS1G0}1G0}OKWQ`OAN>WO&lQdO1G0uOK]Q`O7+'OOOQO,5;a,5;aOOQO-E8s-E8sOOQW<<I^<<I^OOQ[<<He<<HePOQW,5;Y,5;YOOQWG23rG23rOKeQdO7+&a",
    stateData: "Kx~O#sOS#tQQ~OW[OZ[O]TO`VOaVOi]OjWOmXO!jYO!mZO!saO!ybO!{cO!}dO#QeO#WfO#YgO#oRO~OQiOW[OZ[O]TO`VOaVOi]OjWOmXO!jYO!mZO!saO!ybO!{cO!}dO#QeO#WfO#YgO#ohO~O#m$SP~P!dO#tmO~O#ooO~O]qO`rOarOjsOmtO!juO!mwO#nvO~OpzO!^xO~P$SOc!QO#o|O#p}O~O#o!RO~O#o!TO~OW[OZ[O]TO`VOaVOjWOmXO!jYO!mZO#oRO~OS!]Oe!YO!V![O!Y!`O#q!XOp$TP~Ok$TP~P&POQ!jOe!cOm!dOp!eOr!mOt!mOz!kO!`!lO#o!bO#p!hO#}!fO~Ot!qO!`!lO#o!pO~Ot!sO#o!sO~OS!]Oe!YO!V![O!Y!`O#q!XO~Oe!vOpzO#Z!xO~O]YX`YX`!pXaYXjYXmYXpYX!^YX!jYX!mYX#nYX~O`!zO~Ok!{O#m$SXo$SX~O#m$SXo$SX~P!dO#u#OO#v#OO#w#QO~Oc#UO#o|O#p}O~OpzO!^xO~Oo$SP~P!dOe#`O~Oe#aO~Ol#bO!h#cO~O]qO`rOarOjsOmtO~Op!ia!^!ia!j!ia!m!ia#n!iad!ia~P*zOp!la!^!la!j!la!m!la#n!lad!la~P*zOR#gOS!]Oe!YOr#gOt#gO!V![O!Y!`O#q#dO#}!fO~O!R#iO!^#jOk$TXp$TX~Oe#mO~Ok#oOpzO~Oe!vO~O]#rO`#rOd#uOi#rOj#rOk#rO~P&lO]#rO`#rOi#rOj#rOk#rOl#wO~P&lO]#rO`#rOi#rOj#rOk#rOo#yO~P&lOP#zOSsXesXksXvsX!VsX!YsX!usX!wsX#qsX!TsXQsX]sX`sXdsXisXjsXmsXpsXrsXtsXzsX!`sX#osX#psX#}sXlsXosX!^sX!qsX#msX~Ov#{O!u#|O!w#}Ok$TP~P'tOe#aOS#{Xk#{Xv#{X!V#{X!Y#{X!u#{X!w#{X#q#{XQ#{X]#{X`#{Xd#{Xi#{Xj#{Xm#{Xp#{Xr#{Xt#{Xz#{X!`#{X#o#{X#p#{X#}#{Xl#{Xo#{X!^#{X!q#{X#m#{X~Oe$RO~Oe$TO~Ok$VOv#{O~Ok$WO~Ot$XO!`!lO~Op$YO~OpzO!R#iO~OpzO#Z$`O~O!q$bOk!oa#m!oao!oa~P&lOk#hX#m#hXo#hX~P!dOk!{O#m$Sao$Sa~O#u#OO#v#OO#w$hO~Ol$jO!h$kO~Op!ii!^!ii!j!ii!m!ii#n!iid!ii~P*zOp!ki!^!ki!j!ki!m!ki#n!kid!ki~P*zOp!li!^!li!j!li!m!li#n!lid!li~P*zOp#fa!^#fa~P$SOo$lO~Od$RP~P%_Od#zP~P&lO`!PXd}X!R}X!T!PX~O`$sO!T$tO~Od$uO!R#iO~Ok#jXp#jX!^#jX~P'tO!^#jOk$Tap$Ta~O!R#iOk!Uap!Ua!^!Uad!Ua`!Ua~OS!]Oe!YO!V![O!Y!`O#q$yO~Od$QP~P9dOv#{OQ#|X]#|X`#|Xd#|Xe#|Xi#|Xj#|Xk#|Xm#|Xp#|Xr#|Xt#|Xz#|X!`#|X#o#|X#p#|X#}#|Xl#|Xo#|X~O]#rO`#rOd%OOi#rOj#rOk#rO~P&lO]#rO`#rOi#rOj#rOk#rOl%PO~P&lO]#rO`#rOi#rOj#rOk#rOo%QO~P&lOe%SOS!tXk!tX!V!tX!Y!tX#q!tX~Ok%TO~Od%YOt%ZO!a%ZO~Ok%[O~Oo%cO#o%^O#}%]O~Od%dO~P$SOv#{O!^%hO!q%jOk!oi#m!oio!oi~P&lOk#ha#m#hao#ha~P!dOk!{O#m$Sio$Si~O!^%mOd$RX~P$SOd%oO~Ov#{OQ#`Xd#`Xe#`Xm#`Xp#`Xr#`Xt#`Xz#`X!^#`X!`#`X#o#`X#p#`X#}#`X~O!^%qOd#zX~P&lOd%sO~Ol%tOv#{O~OR#gOr#gOt#gO#q%vO#}!fO~O!R#iOk#jap#ja!^#ja~O`!PXd}X!R}X!^}X~O!R#iO!^%xOd$QX~O`%zO~Od%{O~O#o%|O~Ok&OO~O`&PO!R#iO~Od&ROk&QO~Od&UO~OP#zOpsX!^sXdsX~O#}%]Op#TX!^#TX~OpzO!^&WO~Oo&[O#o%^O#}%]O~Ov#{OQ#gXe#gXk#gXm#gXp#gXr#gXt#gXz#gX!^#gX!`#gX!q#gX#m#gX#o#gX#p#gX#}#gXo#gX~O!^%hO!q&`Ok!oq#m!oqo!oq~P&lOl&aOv#{O~Od#eX!^#eX~P%_O!^%mOd$Ra~Od#dX!^#dX~P&lO!^%qOd#za~Od&fO~P&lOd&gO!T&hO~Od#cX!^#cX~P9dO!^%xOd$Qa~O]&mOd&oO~OS#bae#ba!V#ba!Y#ba#q#ba~Od&qO~PG]Od&qOk&rO~Ov#{OQ#gae#gak#gam#gap#gar#gat#gaz#ga!^#ga!`#ga!q#ga#m#ga#o#ga#p#ga#}#gao#ga~Od#ea!^#ea~P$SOd#da!^#da~P&lOR#gOr#gOt#gO#q%vO#}%]O~O!R#iOd#ca!^#ca~O`&xO~O!^%xOd$Qi~P&lO]&mOd&|O~Ov#{Od|ik|i~Od&}O~PG]Ok'OO~Od'PO~O!^%xOd$Qq~Od#cq!^#cq~P&lO#s!a#t#}]#}v!m~",
    goto: "2h$UPPPPP$VP$YP$c$uP$cP%X$cPP%_PPP%e%o%oPPPPP%oPP%oP&]P%oP%o'W%oP't'w'}'}(^'}P'}P'}P'}'}P(m'}(yP(|PP)p)v$c)|$c*SP$cP$c$cP*Y*{+YP$YP+aP+dP$YP$YP$YP+j$YP+m+p+s+z$YP$YPP$YP,P,V,f,|-[-b-l-r-x.O.U.`.f.l.rPPPPPPPPPPP.x/R/w/z0|P1U1u2O2R2U2[RnQ_^OP`kz!{$dq[OPYZ`kuvwxz!v!{#`$d%mqSOPYZ`kuvwxz!v!{#`$d%mQpTR#RqQ!OVR#SrQ#S!QS$Q!i!jR$i#U!V!mac!c!d!e!z#a#c#t#v#x#{$a$k$p$s%h%i%q%u%z&P&d&l&x'Q!U!mac!c!d!e!z#a#c#t#v#x#{$a$k$p$s%h%i%q%u%z&P&d&l&x'QU#g!Y$t&hU%`$Y%b&WR&V%_!V!iac!c!d!e!z#a#c#t#v#x#{$a$k$p$s%h%i%q%u%z&P&d&l&x'QR$S!kQ%W$RR&S%Xk!^]bf!Y![!g#i#j#m$P$R%X%xQ#e!YQ${#mQ%w$tQ&j%xR&w&hQ!ygQ#p!`Q$^!xR%f$`R#n!]!U!mac!c!d!e!z#a#c#t#v#x#{$a$k$p$s%h%i%q%u%z&P&d&l&x'QQ!qdR$X!rQ!PVR#TrQ#S!PR$i#TQ!SWR#VsQ!UXR#WtQ{UQ!wgQ#^yQ#o!_Q$U!nQ$[!uQ$_!yQ%e$^Q&Y%aQ&]%fR&v&XSjPzQ!}kQ$c!{R%k$dZiPkz!{$dR$P!gQ%}%SR&z&mR!rdR!teR$Z!tS%a$Y%bR&t&WV%_$Y%b&WQ#PmR$g#PQ`OSkPzU!a`k$dR$d!{Q$p#aY%p$p%u&d&l'QQ%u$sQ&d%qQ&l%zR'Q&xQ#t!cQ#v!dQ#x!eV$}#t#v#xQ%X$RR&T%XQ%y$zS&k%y&yR&y&lQ%r$pR&e%rQ%n$mR&c%nQyUR#]yQ%i$aR&_%iQ!|jS$e!|$fR$f!}Q&n%}R&{&nQ#k!ZR$x#kQ%b$YR&Z%bQ&X%aR&u&X__OP`kz!{$d^UOP`kz!{$dQ!VYQ!WZQ#XuQ#YvQ#ZwQ#[xQ$]!vQ$m#`R&b%mR$q#aQ!gaQ!oc[#q!c!d!e#t#v#xQ$a!zd$o#a$p$s%q%u%z&d&l&x'QQ$r#cQ%R#{S%g$a%iQ%l$kQ&^%hR&p&P]#s!c!d!e#t#v#xW!Z]b!g$PQ!ufQ#f!YQ#l![Q$v#iQ$w#jQ$z#mS%V$R%XR&i%xQ#h!YQ%w$tR&w&hR$|#mR$n#`QlPR#_zQ!_]Q!nbQ$O!gR%U$P",
    nodeNames: "\u26A0 Unit VariableName VariableName QueryCallee Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NestingSelector ClassSelector . ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue AtKeyword # ; ] [ BracketedValue } { BracedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee IfExpression if ArgList IfBranch KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp ComparisonQuery CompareOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector ParenthesizedSelector CallQuery ArgList , CallLiteral CallTag ParenthesizedContent PseudoClassName ArgList IdSelector IdName AttributeSelector AttributeName MatchOp ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp Block Declaration PropertyName Important ImportStatement import Layer layer LayerName layer MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports ScopeStatement scope to AtRule Styles",
    maxTerm: 143,
    nodeProps: [
        [
            "isolate",
            -2,
            5,
            36,
            ""
        ],
        [
            "openedBy",
            20,
            "(",
            28,
            "[",
            31,
            "{"
        ],
        [
            "closedBy",
            21,
            ")",
            29,
            "]",
            32,
            "}"
        ]
    ],
    propSources: [
        $2479bc0bd5ea48bf$var$cssHighlighting
    ],
    skippedNodes: [
        0,
        5,
        106
    ],
    repeatNodeCount: 15,
    tokenData: "JQ~R!YOX$qX^%i^p$qpq%iqr({rs-ust/itu6Wuv$qvw7Qwx7cxy9Qyz9cz{9h{|:R|}>t}!O?V!O!P?t!P!Q@]!Q![AU![!]BP!]!^B{!^!_C^!_!`DY!`!aDm!a!b$q!b!cEn!c!}$q!}#OG{#O#P$q#P#QH^#Q#R6W#R#o$q#o#pHo#p#q6W#q#rIQ#r#sIc#s#y$q#y#z%i#z$f$q$f$g%i$g#BY$q#BY#BZ%i#BZ$IS$q$IS$I_%i$I_$I|$q$I|$JO%i$JO$JT$q$JT$JU%i$JU$KV$q$KV$KW%i$KW&FU$q&FU&FV%i&FV;'S$q;'S;=`Iz<%lO$q`$tSOy%Qz;'S%Q;'S;=`%c<%lO%Q`%VS!a`Oy%Qz;'S%Q;'S;=`%c<%lO%Q`%fP;=`<%l%Q~%nh#s~OX%QX^'Y^p%Qpq'Yqy%Qz#y%Q#y#z'Y#z$f%Q$f$g'Y$g#BY%Q#BY#BZ'Y#BZ$IS%Q$IS$I_'Y$I_$I|%Q$I|$JO'Y$JO$JT%Q$JT$JU'Y$JU$KV%Q$KV$KW'Y$KW&FU%Q&FU&FV'Y&FV;'S%Q;'S;=`%c<%lO%Q~'ah#s~!a`OX%QX^'Y^p%Qpq'Yqy%Qz#y%Q#y#z'Y#z$f%Q$f$g'Y$g#BY%Q#BY#BZ'Y#BZ$IS%Q$IS$I_'Y$I_$I|%Q$I|$JO'Y$JO$JT%Q$JT$JU'Y$JU$KV%Q$KV$KW'Y$KW&FU%Q&FU&FV'Y&FV;'S%Q;'S;=`%c<%lO%Qj)OUOy%Qz#]%Q#]#^)b#^;'S%Q;'S;=`%c<%lO%Qj)gU!a`Oy%Qz#a%Q#a#b)y#b;'S%Q;'S;=`%c<%lO%Qj*OU!a`Oy%Qz#d%Q#d#e*b#e;'S%Q;'S;=`%c<%lO%Qj*gU!a`Oy%Qz#c%Q#c#d*y#d;'S%Q;'S;=`%c<%lO%Qj+OU!a`Oy%Qz#f%Q#f#g+b#g;'S%Q;'S;=`%c<%lO%Qj+gU!a`Oy%Qz#h%Q#h#i+y#i;'S%Q;'S;=`%c<%lO%Qj,OU!a`Oy%Qz#T%Q#T#U,b#U;'S%Q;'S;=`%c<%lO%Qj,gU!a`Oy%Qz#b%Q#b#c,y#c;'S%Q;'S;=`%c<%lO%Qj-OU!a`Oy%Qz#h%Q#h#i-b#i;'S%Q;'S;=`%c<%lO%Qj-iS!qY!a`Oy%Qz;'S%Q;'S;=`%c<%lO%Q~-xWOY-uZr-urs.bs#O-u#O#P.g#P;'S-u;'S;=`/c<%lO-u~.gOt~~.jRO;'S-u;'S;=`.s;=`O-u~.vXOY-uZr-urs.bs#O-u#O#P.g#P;'S-u;'S;=`/c;=`<%l-u<%lO-u~/fP;=`<%l-uj/nYjYOy%Qz!Q%Q!Q![0^![!c%Q!c!i0^!i#T%Q#T#Z0^#Z;'S%Q;'S;=`%c<%lO%Qj0cY!a`Oy%Qz!Q%Q!Q![1R![!c%Q!c!i1R!i#T%Q#T#Z1R#Z;'S%Q;'S;=`%c<%lO%Qj1WY!a`Oy%Qz!Q%Q!Q![1v![!c%Q!c!i1v!i#T%Q#T#Z1v#Z;'S%Q;'S;=`%c<%lO%Qj1}YrY!a`Oy%Qz!Q%Q!Q![2m![!c%Q!c!i2m!i#T%Q#T#Z2m#Z;'S%Q;'S;=`%c<%lO%Qj2tYrY!a`Oy%Qz!Q%Q!Q![3d![!c%Q!c!i3d!i#T%Q#T#Z3d#Z;'S%Q;'S;=`%c<%lO%Qj3iY!a`Oy%Qz!Q%Q!Q![4X![!c%Q!c!i4X!i#T%Q#T#Z4X#Z;'S%Q;'S;=`%c<%lO%Qj4`YrY!a`Oy%Qz!Q%Q!Q![5O![!c%Q!c!i5O!i#T%Q#T#Z5O#Z;'S%Q;'S;=`%c<%lO%Qj5TY!a`Oy%Qz!Q%Q!Q![5s![!c%Q!c!i5s!i#T%Q#T#Z5s#Z;'S%Q;'S;=`%c<%lO%Qj5zSrY!a`Oy%Qz;'S%Q;'S;=`%c<%lO%Qd6ZUOy%Qz!_%Q!_!`6m!`;'S%Q;'S;=`%c<%lO%Qd6tS!hS!a`Oy%Qz;'S%Q;'S;=`%c<%lO%Qb7VSZQOy%Qz;'S%Q;'S;=`%c<%lO%Q~7fWOY7cZw7cwx.bx#O7c#O#P8O#P;'S7c;'S;=`8z<%lO7c~8RRO;'S7c;'S;=`8[;=`O7c~8_XOY7cZw7cwx.bx#O7c#O#P8O#P;'S7c;'S;=`8z;=`<%l7c<%lO7c~8}P;=`<%l7cj9VSeYOy%Qz;'S%Q;'S;=`%c<%lO%Q~9hOd~n9oUWQvWOy%Qz!_%Q!_!`6m!`;'S%Q;'S;=`%c<%lO%Qj:YWvW!mQOy%Qz!O%Q!O!P:r!P!Q%Q!Q![=w![;'S%Q;'S;=`%c<%lO%Qj:wU!a`Oy%Qz!Q%Q!Q![;Z![;'S%Q;'S;=`%c<%lO%Qj;bY!a`#}YOy%Qz!Q%Q!Q![;Z![!g%Q!g!h<Q!h#X%Q#X#Y<Q#Y;'S%Q;'S;=`%c<%lO%Qj<VY!a`Oy%Qz{%Q{|<u|}%Q}!O<u!O!Q%Q!Q![=^![;'S%Q;'S;=`%c<%lO%Qj<zU!a`Oy%Qz!Q%Q!Q![=^![;'S%Q;'S;=`%c<%lO%Qj=eU!a`#}YOy%Qz!Q%Q!Q![=^![;'S%Q;'S;=`%c<%lO%Qj>O[!a`#}YOy%Qz!O%Q!O!P;Z!P!Q%Q!Q![=w![!g%Q!g!h<Q!h#X%Q#X#Y<Q#Y;'S%Q;'S;=`%c<%lO%Qj>yS!^YOy%Qz;'S%Q;'S;=`%c<%lO%Qj?[WvWOy%Qz!O%Q!O!P:r!P!Q%Q!Q![=w![;'S%Q;'S;=`%c<%lO%Qj?yU]YOy%Qz!Q%Q!Q![;Z![;'S%Q;'S;=`%c<%lO%Q~@bTvWOy%Qz{@q{;'S%Q;'S;=`%c<%lO%Q~@xS!a`#t~Oy%Qz;'S%Q;'S;=`%c<%lO%QjAZ[#}YOy%Qz!O%Q!O!P;Z!P!Q%Q!Q![=w![!g%Q!g!h<Q!h#X%Q#X#Y<Q#Y;'S%Q;'S;=`%c<%lO%QjBUU`YOy%Qz![%Q![!]Bh!];'S%Q;'S;=`%c<%lO%QbBoSaQ!a`Oy%Qz;'S%Q;'S;=`%c<%lO%QjCQSkYOy%Qz;'S%Q;'S;=`%c<%lO%QhCcU!TWOy%Qz!_%Q!_!`Cu!`;'S%Q;'S;=`%c<%lO%QhC|S!TW!a`Oy%Qz;'S%Q;'S;=`%c<%lO%QlDaS!TW!hSOy%Qz;'S%Q;'S;=`%c<%lO%QjDtV!jQ!TWOy%Qz!_%Q!_!`Cu!`!aEZ!a;'S%Q;'S;=`%c<%lO%QbEbS!jQ!a`Oy%Qz;'S%Q;'S;=`%c<%lO%QjEqYOy%Qz}%Q}!OFa!O!c%Q!c!}GO!}#T%Q#T#oGO#o;'S%Q;'S;=`%c<%lO%QjFfW!a`Oy%Qz!c%Q!c!}GO!}#T%Q#T#oGO#o;'S%Q;'S;=`%c<%lO%QjGV[iY!a`Oy%Qz}%Q}!OGO!O!Q%Q!Q![GO![!c%Q!c!}GO!}#T%Q#T#oGO#o;'S%Q;'S;=`%c<%lO%QjHQSmYOy%Qz;'S%Q;'S;=`%c<%lO%QnHcSl^Oy%Qz;'S%Q;'S;=`%c<%lO%QjHtSpYOy%Qz;'S%Q;'S;=`%c<%lO%QjIVSoYOy%Qz;'S%Q;'S;=`%c<%lO%QfIhU!mQOy%Qz!_%Q!_!`6m!`;'S%Q;'S;=`%c<%lO%Q`I}P;=`<%l$q",
    tokenizers: [
        $2479bc0bd5ea48bf$var$descendant,
        $2479bc0bd5ea48bf$var$unitToken,
        $2479bc0bd5ea48bf$var$identifiers,
        $2479bc0bd5ea48bf$var$queryIdentifiers,
        1,
        2,
        3,
        4,
        new (0, $96e8fc72168067c5$export$dbe55ed82366d5e9)("m~RRYZ[z{a~~g~aO#v~~dP!P!Qg~lO#w~~", 28, 129)
    ],
    topRules: {
        "StyleSheet": [
            0,
            6
        ],
        "Styles": [
            1,
            105
        ]
    },
    specialized: [
        {
            term: 124,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_callee[value] || -1
        },
        {
            term: 125,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_queryIdentifier[value] || -1
        },
        {
            term: 4,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_QueryCallee[value] || -1
        },
        {
            term: 25,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_AtKeyword[value] || -1
        },
        {
            term: 123,
            get: (value)=>$2479bc0bd5ea48bf$var$spec_identifier[value] || -1
        }
    ],
    tokenPrec: 1963
});




let $83e81cc0276b0738$var$_properties = null;
function $83e81cc0276b0738$var$properties() {
    if (!$83e81cc0276b0738$var$_properties && typeof document == "object" && document.body) {
        let { style: style } = document.body, names = [], seen = new Set;
        for(let prop in style)if (prop != "cssText" && prop != "cssFloat") {
            if (typeof style[prop] == "string") {
                if (/[A-Z]/.test(prop)) prop = prop.replace(/[A-Z]/g, (ch)=>"-" + ch.toLowerCase());
                if (!seen.has(prop)) {
                    names.push(prop);
                    seen.add(prop);
                }
            }
        }
        $83e81cc0276b0738$var$_properties = names.sort().map((name)=>({
                type: "property",
                label: name,
                apply: name + ": "
            }));
    }
    return $83e81cc0276b0738$var$_properties || [];
}
const $83e81cc0276b0738$var$pseudoClasses = /*@__PURE__*/ [
    "active",
    "after",
    "any-link",
    "autofill",
    "backdrop",
    "before",
    "checked",
    "cue",
    "default",
    "defined",
    "disabled",
    "empty",
    "enabled",
    "file-selector-button",
    "first",
    "first-child",
    "first-letter",
    "first-line",
    "first-of-type",
    "focus",
    "focus-visible",
    "focus-within",
    "fullscreen",
    "has",
    "host",
    "host-context",
    "hover",
    "in-range",
    "indeterminate",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "marker",
    "modal",
    "not",
    "nth-child",
    "nth-last-child",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "part",
    "placeholder",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "selection",
    "slotted",
    "target",
    "target-text",
    "valid",
    "visited",
    "where"
].map((name)=>({
        type: "class",
        label: name
    }));
const $83e81cc0276b0738$var$values = /*@__PURE__*/ [
    "above",
    "absolute",
    "activeborder",
    "additive",
    "activecaption",
    "after-white-space",
    "ahead",
    "alias",
    "all",
    "all-scroll",
    "alphabetic",
    "alternate",
    "always",
    "antialiased",
    "appworkspace",
    "asterisks",
    "attr",
    "auto",
    "auto-flow",
    "avoid",
    "avoid-column",
    "avoid-page",
    "avoid-region",
    "axis-pan",
    "background",
    "backwards",
    "baseline",
    "below",
    "bidi-override",
    "blink",
    "block",
    "block-axis",
    "bold",
    "bolder",
    "border",
    "border-box",
    "both",
    "bottom",
    "break",
    "break-all",
    "break-word",
    "bullets",
    "button",
    "button-bevel",
    "buttonface",
    "buttonhighlight",
    "buttonshadow",
    "buttontext",
    "calc",
    "capitalize",
    "caps-lock-indicator",
    "caption",
    "captiontext",
    "caret",
    "cell",
    "center",
    "checkbox",
    "circle",
    "cjk-decimal",
    "clear",
    "clip",
    "close-quote",
    "col-resize",
    "collapse",
    "color",
    "color-burn",
    "color-dodge",
    "column",
    "column-reverse",
    "compact",
    "condensed",
    "contain",
    "content",
    "contents",
    "content-box",
    "context-menu",
    "continuous",
    "copy",
    "counter",
    "counters",
    "cover",
    "crop",
    "cross",
    "crosshair",
    "currentcolor",
    "cursive",
    "cyclic",
    "darken",
    "dashed",
    "decimal",
    "decimal-leading-zero",
    "default",
    "default-button",
    "dense",
    "destination-atop",
    "destination-in",
    "destination-out",
    "destination-over",
    "difference",
    "disc",
    "discard",
    "disclosure-closed",
    "disclosure-open",
    "document",
    "dot-dash",
    "dot-dot-dash",
    "dotted",
    "double",
    "down",
    "e-resize",
    "ease",
    "ease-in",
    "ease-in-out",
    "ease-out",
    "element",
    "ellipse",
    "ellipsis",
    "embed",
    "end",
    "ethiopic-abegede-gez",
    "ethiopic-halehame-aa-er",
    "ethiopic-halehame-gez",
    "ew-resize",
    "exclusion",
    "expanded",
    "extends",
    "extra-condensed",
    "extra-expanded",
    "fantasy",
    "fast",
    "fill",
    "fill-box",
    "fixed",
    "flat",
    "flex",
    "flex-end",
    "flex-start",
    "footnotes",
    "forwards",
    "from",
    "geometricPrecision",
    "graytext",
    "grid",
    "groove",
    "hand",
    "hard-light",
    "help",
    "hidden",
    "hide",
    "higher",
    "highlight",
    "highlighttext",
    "horizontal",
    "hsl",
    "hsla",
    "hue",
    "icon",
    "ignore",
    "inactiveborder",
    "inactivecaption",
    "inactivecaptiontext",
    "infinite",
    "infobackground",
    "infotext",
    "inherit",
    "initial",
    "inline",
    "inline-axis",
    "inline-block",
    "inline-flex",
    "inline-grid",
    "inline-table",
    "inset",
    "inside",
    "intrinsic",
    "invert",
    "italic",
    "justify",
    "keep-all",
    "landscape",
    "large",
    "larger",
    "left",
    "level",
    "lighter",
    "lighten",
    "line-through",
    "linear",
    "linear-gradient",
    "lines",
    "list-item",
    "listbox",
    "listitem",
    "local",
    "logical",
    "loud",
    "lower",
    "lower-hexadecimal",
    "lower-latin",
    "lower-norwegian",
    "lowercase",
    "ltr",
    "luminosity",
    "manipulation",
    "match",
    "matrix",
    "matrix3d",
    "medium",
    "menu",
    "menutext",
    "message-box",
    "middle",
    "min-intrinsic",
    "mix",
    "monospace",
    "move",
    "multiple",
    "multiple_mask_images",
    "multiply",
    "n-resize",
    "narrower",
    "ne-resize",
    "nesw-resize",
    "no-close-quote",
    "no-drop",
    "no-open-quote",
    "no-repeat",
    "none",
    "normal",
    "not-allowed",
    "nowrap",
    "ns-resize",
    "numbers",
    "numeric",
    "nw-resize",
    "nwse-resize",
    "oblique",
    "opacity",
    "open-quote",
    "optimizeLegibility",
    "optimizeSpeed",
    "outset",
    "outside",
    "outside-shape",
    "overlay",
    "overline",
    "padding",
    "padding-box",
    "painted",
    "page",
    "paused",
    "perspective",
    "pinch-zoom",
    "plus-darker",
    "plus-lighter",
    "pointer",
    "polygon",
    "portrait",
    "pre",
    "pre-line",
    "pre-wrap",
    "preserve-3d",
    "progress",
    "push-button",
    "radial-gradient",
    "radio",
    "read-only",
    "read-write",
    "read-write-plaintext-only",
    "rectangle",
    "region",
    "relative",
    "repeat",
    "repeating-linear-gradient",
    "repeating-radial-gradient",
    "repeat-x",
    "repeat-y",
    "reset",
    "reverse",
    "rgb",
    "rgba",
    "ridge",
    "right",
    "rotate",
    "rotate3d",
    "rotateX",
    "rotateY",
    "rotateZ",
    "round",
    "row",
    "row-resize",
    "row-reverse",
    "rtl",
    "run-in",
    "running",
    "s-resize",
    "sans-serif",
    "saturation",
    "scale",
    "scale3d",
    "scaleX",
    "scaleY",
    "scaleZ",
    "screen",
    "scroll",
    "scrollbar",
    "scroll-position",
    "se-resize",
    "self-start",
    "self-end",
    "semi-condensed",
    "semi-expanded",
    "separate",
    "serif",
    "show",
    "single",
    "skew",
    "skewX",
    "skewY",
    "skip-white-space",
    "slide",
    "slider-horizontal",
    "slider-vertical",
    "sliderthumb-horizontal",
    "sliderthumb-vertical",
    "slow",
    "small",
    "small-caps",
    "small-caption",
    "smaller",
    "soft-light",
    "solid",
    "source-atop",
    "source-in",
    "source-out",
    "source-over",
    "space",
    "space-around",
    "space-between",
    "space-evenly",
    "spell-out",
    "square",
    "start",
    "static",
    "status-bar",
    "stretch",
    "stroke",
    "stroke-box",
    "sub",
    "subpixel-antialiased",
    "svg_masks",
    "super",
    "sw-resize",
    "symbolic",
    "symbols",
    "system-ui",
    "table",
    "table-caption",
    "table-cell",
    "table-column",
    "table-column-group",
    "table-footer-group",
    "table-header-group",
    "table-row",
    "table-row-group",
    "text",
    "text-bottom",
    "text-top",
    "textarea",
    "textfield",
    "thick",
    "thin",
    "threeddarkshadow",
    "threedface",
    "threedhighlight",
    "threedlightshadow",
    "threedshadow",
    "to",
    "top",
    "transform",
    "translate",
    "translate3d",
    "translateX",
    "translateY",
    "translateZ",
    "transparent",
    "ultra-condensed",
    "ultra-expanded",
    "underline",
    "unidirectional-pan",
    "unset",
    "up",
    "upper-latin",
    "uppercase",
    "url",
    "var",
    "vertical",
    "vertical-text",
    "view-box",
    "visible",
    "visibleFill",
    "visiblePainted",
    "visibleStroke",
    "visual",
    "w-resize",
    "wait",
    "wave",
    "wider",
    "window",
    "windowframe",
    "windowtext",
    "words",
    "wrap",
    "wrap-reverse",
    "x-large",
    "x-small",
    "xor",
    "xx-large",
    "xx-small"
].map((name)=>({
        type: "keyword",
        label: name
    })).concat(/*@__PURE__*/ [
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "grey",
    "green",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "rebeccapurple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
].map((name)=>({
        type: "constant",
        label: name
    })));
const $83e81cc0276b0738$var$tags = /*@__PURE__*/ [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "figcaption",
    "figure",
    "footer",
    "form",
    "header",
    "hgroup",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "meter",
    "nav",
    "ol",
    "output",
    "p",
    "pre",
    "ruby",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "tr",
    "u",
    "ul"
].map((name)=>({
        type: "type",
        label: name
    }));
const $83e81cc0276b0738$var$atRules = /*@__PURE__*/ [
    "@charset",
    "@color-profile",
    "@container",
    "@counter-style",
    "@font-face",
    "@font-feature-values",
    "@font-palette-values",
    "@import",
    "@keyframes",
    "@layer",
    "@media",
    "@namespace",
    "@page",
    "@position-try",
    "@property",
    "@scope",
    "@starting-style",
    "@supports",
    "@view-transition"
].map((label)=>({
        type: "keyword",
        label: label
    }));
const $83e81cc0276b0738$var$identifier = /^(\w[\w-]*|-\w[\w-]*|)$/, $83e81cc0276b0738$var$variable = /^-(-[\w-]*)?$/;
function $83e81cc0276b0738$var$isVarArg(node, doc) {
    var _a;
    if (node.name == "(" || node.type.isError) node = node.parent || node;
    if (node.name != "ArgList") return false;
    let callee = (_a = node.parent) === null || _a === void 0 ? void 0 : _a.firstChild;
    if ((callee === null || callee === void 0 ? void 0 : callee.name) != "Callee") return false;
    return doc.sliceString(callee.from, callee.to) == "var";
}
const $83e81cc0276b0738$var$VariablesByNode = /*@__PURE__*/ new (0, $ed739beecf769914$export$7f13b5dc44c541ae)();
const $83e81cc0276b0738$var$declSelector = [
    "Declaration"
];
function $83e81cc0276b0738$var$astTop(node) {
    for(let cur = node;;){
        if (cur.type.isTop) return cur;
        if (!(cur = cur.parent)) return node;
    }
}
function $83e81cc0276b0738$var$variableNames(doc, node, isVariable) {
    if (node.to - node.from > 4096) {
        let known = $83e81cc0276b0738$var$VariablesByNode.get(node);
        if (known) return known;
        let result = [], seen = new Set, cursor = node.cursor((0, $ed739beecf769914$export$b0e28367f55837aa).IncludeAnonymous);
        if (cursor.firstChild()) do {
            for (let option of $83e81cc0276b0738$var$variableNames(doc, cursor.node, isVariable))if (!seen.has(option.label)) {
                seen.add(option.label);
                result.push(option);
            }
        }while (cursor.nextSibling());
        $83e81cc0276b0738$var$VariablesByNode.set(node, result);
        return result;
    } else {
        let result = [], seen = new Set;
        node.cursor().iterate((node)=>{
            var _a;
            if (isVariable(node) && node.matchContext($83e81cc0276b0738$var$declSelector) && ((_a = node.node.nextSibling) === null || _a === void 0 ? void 0 : _a.name) == ":") {
                let name = doc.sliceString(node.from, node.to);
                if (!seen.has(name)) {
                    seen.add(name);
                    result.push({
                        label: name,
                        type: "variable"
                    });
                }
            }
        });
        return result;
    }
}
/**
Create a completion source for a CSS dialect, providing a
predicate for determining what kind of syntax node can act as a
completable variable. This is used by language modes like Sass and
Less to reuse this package's completion logic.
*/ const $83e81cc0276b0738$export$d81c1c660b46cb31 = (isVariable)=>(context)=>{
        let { state: state, pos: pos } = context, node = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1);
        let isDash = node.type.isError && node.from == node.to - 1 && state.doc.sliceString(node.from, node.to) == "-";
        if (node.name == "PropertyName" || (isDash || node.name == "TagName") && /^(Block|Styles)$/.test(node.resolve(node.to).name)) return {
            from: node.from,
            options: $83e81cc0276b0738$var$properties(),
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (node.name == "ValueName") return {
            from: node.from,
            options: $83e81cc0276b0738$var$values,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (node.name == "PseudoClassName") return {
            from: node.from,
            options: $83e81cc0276b0738$var$pseudoClasses,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (isVariable(node) || (context.explicit || isDash) && $83e81cc0276b0738$var$isVarArg(node, state.doc)) return {
            from: isVariable(node) || isDash ? node.from : pos,
            options: $83e81cc0276b0738$var$variableNames(state.doc, $83e81cc0276b0738$var$astTop(node), isVariable),
            validFor: $83e81cc0276b0738$var$variable
        };
        if (node.name == "TagName") {
            for(let { parent: parent } = node; parent; parent = parent.parent)if (parent.name == "Block") return {
                from: node.from,
                options: $83e81cc0276b0738$var$properties(),
                validFor: $83e81cc0276b0738$var$identifier
            };
            return {
                from: node.from,
                options: $83e81cc0276b0738$var$tags,
                validFor: $83e81cc0276b0738$var$identifier
            };
        }
        if (node.name == "AtKeyword") return {
            from: node.from,
            options: $83e81cc0276b0738$var$atRules,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (!context.explicit) return null;
        let above = node.resolve(pos), before = above.childBefore(pos);
        if (before && before.name == ":" && above.name == "PseudoClassSelector") return {
            from: pos,
            options: $83e81cc0276b0738$var$pseudoClasses,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (before && before.name == ":" && above.name == "Declaration" || above.name == "ArgList") return {
            from: pos,
            options: $83e81cc0276b0738$var$values,
            validFor: $83e81cc0276b0738$var$identifier
        };
        if (above.name == "Block" || above.name == "Styles") return {
            from: pos,
            options: $83e81cc0276b0738$var$properties(),
            validFor: $83e81cc0276b0738$var$identifier
        };
        return null;
    };
/**
CSS property, variable, and value keyword completion source.
*/ const $83e81cc0276b0738$export$62bc29ba0658e894 = /*@__PURE__*/ $83e81cc0276b0738$export$d81c1c660b46cb31((n)=>n.name == "VariableName");
/**
A language provider based on the [Lezer CSS
parser](https://github.com/lezer-parser/css), extended with
highlighting and indentation information.
*/ const $83e81cc0276b0738$export$93323d80d661fcda = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$b243968d9fb6db03).define({
    name: "css",
    parser: /*@__PURE__*/ (0, $2479bc0bd5ea48bf$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460).add({
                Declaration: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c)()
            }),
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$9b075a85eb4377d8).add({
                "Block KeyframeList": (0, $a97ccac5cf5f4f5d$export$48672beae16a681b)
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*\}$/,
        wordChars: "-"
    }
});
/**
Language support for CSS.
*/ function $83e81cc0276b0738$export$dbf350e5966cf602() {
    return new (0, $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b)($83e81cc0276b0738$export$93323d80d661fcda, $83e81cc0276b0738$export$93323d80d661fcda.data.of({
        autocomplete: $83e81cc0276b0738$export$62bc29ba0658e894
    }));
}




// This file was generated by lezer-generator. You probably shouldn't edit it.
const $44c7044f9afa5475$var$noSemi = 316, $44c7044f9afa5475$var$noSemiType = 317, $44c7044f9afa5475$var$incdec = 1, $44c7044f9afa5475$var$incdecPrefix = 2, $44c7044f9afa5475$var$questionDot = 3, $44c7044f9afa5475$var$JSXStartTag = 4, $44c7044f9afa5475$var$insertSemi = 318, $44c7044f9afa5475$var$spaces = 320, $44c7044f9afa5475$var$newline = 321, $44c7044f9afa5475$var$LineComment = 5, $44c7044f9afa5475$var$BlockComment = 6, $44c7044f9afa5475$var$Dialect_jsx = 0;
/* Hand-written tokenizers for JavaScript tokens that can't be
   expressed by lezer's built-in tokenizer. */ const $44c7044f9afa5475$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $44c7044f9afa5475$var$braceR = 125, $44c7044f9afa5475$var$semicolon = 59, $44c7044f9afa5475$var$slash = 47, $44c7044f9afa5475$var$star = 42, $44c7044f9afa5475$var$plus = 43, $44c7044f9afa5475$var$minus = 45, $44c7044f9afa5475$var$lt = 60, $44c7044f9afa5475$var$comma = 44, $44c7044f9afa5475$var$question = 63, $44c7044f9afa5475$var$dot = 46, $44c7044f9afa5475$var$bracketL = 91;
const $44c7044f9afa5475$var$trackNewline = new (0, $96e8fc72168067c5$export$88193367295cc46b)({
    start: false,
    shift (context, term) {
        return term == $44c7044f9afa5475$var$LineComment || term == $44c7044f9afa5475$var$BlockComment || term == $44c7044f9afa5475$var$spaces ? context : term == $44c7044f9afa5475$var$newline;
    },
    strict: false
});
const $44c7044f9afa5475$var$insertSemicolon = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { next: next } = input;
    if (next == $44c7044f9afa5475$var$braceR || next == -1 || stack.context) input.acceptToken($44c7044f9afa5475$var$insertSemi);
}, {
    contextual: true,
    fallback: true
});
const $44c7044f9afa5475$var$noSemicolon = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { next: next } = input, after;
    if ($44c7044f9afa5475$var$space.indexOf(next) > -1) return;
    if (next == $44c7044f9afa5475$var$slash && ((after = input.peek(1)) == $44c7044f9afa5475$var$slash || after == $44c7044f9afa5475$var$star)) return;
    if (next != $44c7044f9afa5475$var$braceR && next != $44c7044f9afa5475$var$semicolon && next != -1 && !stack.context) input.acceptToken($44c7044f9afa5475$var$noSemi);
}, {
    contextual: true
});
const $44c7044f9afa5475$var$noSemicolonType = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next == $44c7044f9afa5475$var$bracketL && !stack.context) input.acceptToken($44c7044f9afa5475$var$noSemiType);
}, {
    contextual: true
});
const $44c7044f9afa5475$var$operatorToken = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { next: next } = input;
    if (next == $44c7044f9afa5475$var$plus || next == $44c7044f9afa5475$var$minus) {
        input.advance();
        if (next == input.next) {
            input.advance();
            let mayPostfix = !stack.context && stack.canShift($44c7044f9afa5475$var$incdec);
            input.acceptToken(mayPostfix ? $44c7044f9afa5475$var$incdec : $44c7044f9afa5475$var$incdecPrefix);
        }
    } else if (next == $44c7044f9afa5475$var$question && input.peek(1) == $44c7044f9afa5475$var$dot) {
        input.advance();
        input.advance();
        if (input.next < 48 || input.next > 57) input.acceptToken($44c7044f9afa5475$var$questionDot);
    }
}, {
    contextual: true
});
function $44c7044f9afa5475$var$identifierChar(ch, start) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch == 95 || ch >= 192 || !start && ch >= 48 && ch <= 57;
}
const $44c7044f9afa5475$var$jsx = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next != $44c7044f9afa5475$var$lt || !stack.dialectEnabled($44c7044f9afa5475$var$Dialect_jsx)) return;
    input.advance();
    if (input.next == $44c7044f9afa5475$var$slash) return;
    // Scan for an identifier followed by a comma or 'extends', don't
    // treat this as a start tag if present.
    let back = 0;
    while($44c7044f9afa5475$var$space.indexOf(input.next) > -1){
        input.advance();
        back++;
    }
    if ($44c7044f9afa5475$var$identifierChar(input.next, true)) {
        input.advance();
        back++;
        while($44c7044f9afa5475$var$identifierChar(input.next, false)){
            input.advance();
            back++;
        }
        while($44c7044f9afa5475$var$space.indexOf(input.next) > -1){
            input.advance();
            back++;
        }
        if (input.next == $44c7044f9afa5475$var$comma) return;
        for(let i = 0;; i++){
            if (i == 7) {
                if (!$44c7044f9afa5475$var$identifierChar(input.next, true)) return;
                break;
            }
            if (input.next != "extends".charCodeAt(i)) break;
            input.advance();
            back++;
        }
    }
    input.acceptToken($44c7044f9afa5475$var$JSXStartTag, -back);
});
const $44c7044f9afa5475$var$jsHighlight = (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
    "get set async static": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
    "for while do if else switch try catch finally return throw break continue default case defer": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).controlKeyword,
    "in of await yield void typeof delete instanceof as satisfies": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    "let var const using function class extends": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionKeyword,
    "import export from": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).moduleKeyword,
    "with debugger new": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
    TemplateString: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string),
    super: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
    BooleanLiteral: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
    this: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).self,
    null: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).null,
    Star: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
    VariableName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName,
    "CallExpression/VariableName TaggedTemplateExpression/VariableName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
    VariableDefinition: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
    Label: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName,
    PropertyName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName,
    PrivatePropertyName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
    "CallExpression/MemberExpression/PropertyName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
    "FunctionDeclaration/VariableDefinition": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName)),
    "ClassDeclaration/VariableDefinition": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).className),
    "NewExpression/VariableName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className,
    PropertyDefinition: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
    PrivatePropertyDefinition: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName)),
    UpdateOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).updateOperator,
    "LineComment Hashbang": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).lineComment,
    BlockComment: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).blockComment,
    Number: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).number,
    String: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
    Escape: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
    ArithOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).arithmeticOperator,
    LogicOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).logicOperator,
    BitOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bitwiseOperator,
    CompareOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).compareOperator,
    RegExp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).regexp,
    Equals: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionOperator,
    Arrow: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).punctuation),
    ": Spread": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).punctuation,
    "( )": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).paren,
    "[ ]": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).squareBracket,
    "{ }": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).brace,
    "InterpolationStart InterpolationEnd": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).brace),
    ".": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).derefOperator,
    ", ;": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).separator,
    "@": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta,
    TypeName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName,
    TypeDefinition: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName),
    "type enum interface implements namespace module declare": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionKeyword,
    "abstract global Privacy readonly override": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
    "is keyof unique infer asserts": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    JSXAttributeValue: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeValue,
    JSXText: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).content,
    "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).angleBracket,
    "JSXIdentifier JSXNameSpacedName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName,
    "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeName,
    "JSXBuiltin/JSXIdentifier": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).standard((0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName)
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $44c7044f9afa5475$var$spec_identifier = {
    __proto__: null,
    export: 20,
    as: 25,
    from: 33,
    default: 36,
    async: 41,
    function: 42,
    in: 52,
    out: 55,
    const: 56,
    extends: 60,
    this: 64,
    true: 72,
    false: 72,
    null: 84,
    void: 88,
    typeof: 92,
    super: 108,
    new: 142,
    delete: 154,
    yield: 163,
    await: 167,
    class: 172,
    public: 235,
    private: 235,
    protected: 235,
    readonly: 237,
    instanceof: 256,
    satisfies: 259,
    import: 292,
    keyof: 349,
    unique: 353,
    infer: 359,
    asserts: 395,
    is: 397,
    abstract: 417,
    implements: 419,
    type: 421,
    let: 424,
    var: 426,
    using: 429,
    interface: 435,
    enum: 439,
    namespace: 445,
    module: 447,
    declare: 451,
    global: 455,
    defer: 471,
    for: 476,
    of: 485,
    while: 488,
    with: 492,
    do: 496,
    if: 500,
    else: 502,
    switch: 506,
    case: 512,
    try: 518,
    catch: 522,
    finally: 526,
    return: 530,
    throw: 534,
    break: 538,
    continue: 542,
    debugger: 546
};
const $44c7044f9afa5475$var$spec_word = {
    __proto__: null,
    async: 129,
    get: 131,
    set: 133,
    declare: 195,
    public: 197,
    private: 197,
    protected: 197,
    static: 199,
    abstract: 201,
    override: 203,
    readonly: 209,
    accessor: 211,
    new: 401
};
const $44c7044f9afa5475$var$spec_LessThan = {
    __proto__: null,
    "<": 193
};
const $44c7044f9afa5475$export$8f49e4af10703ce3 = (0, $96e8fc72168067c5$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: "$F|Q%TQlOOO%[QlOOO'_QpOOP(lO`OOO*zQ!0MxO'#CiO+RO#tO'#CjO+aO&jO'#CjO+oO#@ItO'#DaO.QQlO'#DgO.bQlO'#DrO%[QlO'#DzO0fQlO'#ESOOQ!0Lf'#E['#E[O1PQ`O'#EXOOQO'#Ep'#EpOOQO'#Il'#IlO1XQ`O'#GsO1dQ`O'#EoO1iQ`O'#EoO3hQ!0MxO'#JrO6[Q!0MxO'#JsO6uQ`O'#F]O6zQ,UO'#FtOOQ!0Lf'#Ff'#FfO7VO7dO'#FfO9XQMhO'#F|O9`Q`O'#F{OOQ!0Lf'#Js'#JsOOQ!0Lb'#Jr'#JrO9eQ`O'#GwOOQ['#K_'#K_O9pQ`O'#IYO9uQ!0LrO'#IZOOQ['#J`'#J`OOQ['#I_'#I_Q`QlOOQ`QlOOO9}Q!L^O'#DvO:UQlO'#EOO:]QlO'#EQO9kQ`O'#GsO:dQMhO'#CoO:rQ`O'#EnO:}Q`O'#EyO;hQMhO'#FeO;xQ`O'#GsOOQO'#K`'#K`O;}Q`O'#K`O<]Q`O'#G{O<]Q`O'#G|O<]Q`O'#HOO9kQ`O'#HRO=SQ`O'#HUO>kQ`O'#CeO>{Q`O'#HcO?TQ`O'#HiO?TQ`O'#HkO`QlO'#HmO?TQ`O'#HoO?TQ`O'#HrO?YQ`O'#HxO?_Q!0LsO'#IOO%[QlO'#IQO?jQ!0LsO'#ISO?uQ!0LsO'#IUO9uQ!0LrO'#IWO@QQ!0MxO'#CiOASQpO'#DlQOQ`OOO%[QlO'#EQOAjQ`O'#ETO:dQMhO'#EnOAuQ`O'#EnOBQQ!bO'#FeOOQ['#Cg'#CgOOQ!0Lb'#Dq'#DqOOQ!0Lb'#Jv'#JvO%[QlO'#JvOOQO'#Jy'#JyOOQO'#Ih'#IhOCQQpO'#EgOOQ!0Lb'#Ef'#EfOOQ!0Lb'#J}'#J}OC|Q!0MSO'#EgODWQpO'#EWOOQO'#Jx'#JxODlQpO'#JyOEyQpO'#EWODWQpO'#EgPFWO&2DjO'#CbPOOO)CD})CD}OOOO'#I`'#I`OFcO#tO,59UOOQ!0Lh,59U,59UOOOO'#Ia'#IaOFqO&jO,59UOGPQ!L^O'#DcOOOO'#Ic'#IcOGWO#@ItO,59{OOQ!0Lf,59{,59{OGfQlO'#IdOGyQ`O'#JtOIxQ!fO'#JtO+}QlO'#JtOJPQ`O,5:ROJgQ`O'#EpOJtQ`O'#KTOKPQ`O'#KSOKPQ`O'#KSOKXQ`O,5;^OK^Q`O'#KROOQ!0Ln,5:^,5:^OKeQlO,5:^OMcQ!0MxO,5:fONSQ`O,5:nONmQ!0LrO'#KQONtQ`O'#KPO9eQ`O'#KPO! YQ`O'#KPO! bQ`O,5;]O! gQ`O'#KPO!#lQ!fO'#JsOOQ!0Lh'#Ci'#CiO%[QlO'#ESO!$[Q!fO,5:sOOQS'#Jz'#JzOOQO-E<j-E<jO9kQ`O,5=_O!$rQ`O,5=_O!$wQlO,5;ZO!&zQMhO'#EkO!(eQ`O,5;ZO!(jQlO'#DyO!(tQpO,5;dO!(|QpO,5;dO%[QlO,5;dOOQ['#FT'#FTOOQ['#FV'#FVO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eOOQ['#FZ'#FZO!)[QlO,5;tOOQ!0Lf,5;y,5;yOOQ!0Lf,5;z,5;zOOQ!0Lf,5;|,5;|O%[QlO'#IpO!+_Q!0LrO,5<iO%[QlO,5;eO!&zQMhO,5;eO!+|QMhO,5;eO!-nQMhO'#E^O%[QlO,5;wOOQ!0Lf,5;{,5;{O!-uQ,UO'#FjO!.rQ,UO'#KXO!.^Q,UO'#KXO!.yQ,UO'#KXOOQO'#KX'#KXO!/_Q,UO,5<SOOOW,5<`,5<`O!/pQlO'#FvOOOW'#Io'#IoO7VO7dO,5<QO!/wQ,UO'#FxOOQ!0Lf,5<Q,5<QO!0hQ$IUO'#CyOOQ!0Lh'#C}'#C}O!0{O#@ItO'#DRO!1iQMjO,5<eO!1pQ`O,5<hO!3YQ(CWO'#GXO!3jQ`O'#GYO!3oQ`O'#GYO!5_Q(CWO'#G^O!6dQpO'#GbOOQO'#Gn'#GnO!,TQMhO'#GmOOQO'#Gp'#GpO!,TQMhO'#GoO!7VQ$IUO'#JlOOQ!0Lh'#Jl'#JlO!7aQ`O'#JkO!7oQ`O'#JjO!7wQ`O'#CuOOQ!0Lh'#C{'#C{O!8YQ`O'#C}OOQ!0Lh'#DV'#DVOOQ!0Lh'#DX'#DXO!8_Q`O,5<eO1SQ`O'#DZO!,TQMhO'#GPO!,TQMhO'#GRO!8gQ`O'#GTO!8lQ`O'#GUO!3oQ`O'#G[O!,TQMhO'#GaO<]Q`O'#JkO!8qQ`O'#EqO!9`Q`O,5<gOOQ!0Lb'#Cr'#CrO!9hQ`O'#ErO!:bQpO'#EsOOQ!0Lb'#KR'#KRO!:iQ!0LrO'#KaO9uQ!0LrO,5=cO`QlO,5>tOOQ['#Jh'#JhOOQ[,5>u,5>uOOQ[-E<]-E<]O!<hQ!0MxO,5:bO!:]QpO,5:`O!?RQ!0MxO,5:jO%[QlO,5:jO!AiQ!0MxO,5:lOOQO,5@z,5@zO!BYQMhO,5=_O!BhQ!0LrO'#JiO9`Q`O'#JiO!ByQ!0LrO,59ZO!CUQpO,59ZO!C^QMhO,59ZO:dQMhO,59ZO!CiQ`O,5;ZO!CqQ`O'#HbO!DVQ`O'#KdO%[QlO,5;}O!:]QpO,5<PO!D_Q`O,5=zO!DdQ`O,5=zO!DiQ`O,5=zO!DwQ`O,5=zO9uQ!0LrO,5=zO<]Q`O,5=jOOQO'#Cy'#CyO!EOQpO,5=gO!EWQMhO,5=hO!EcQ`O,5=jO!EhQ!bO,5=mO!EpQ`O'#K`O?YQ`O'#HWO9kQ`O'#HYO!EuQ`O'#HYO:dQMhO'#H[O!EzQ`O'#H[OOQ[,5=p,5=pO!FPQ`O'#H]O!FbQ`O'#CoO!FgQ`O,59PO!FqQ`O,59PO!HvQlO,59POOQ[,59P,59PO!IWQ!0LrO,59PO%[QlO,59PO!KcQlO'#HeOOQ['#Hf'#HfOOQ['#Hg'#HgO`QlO,5=}O!KyQ`O,5=}O`QlO,5>TO`QlO,5>VO!LOQ`O,5>XO`QlO,5>ZO!LTQ`O,5>^O!LYQlO,5>dOOQ[,5>j,5>jO%[QlO,5>jO9uQ!0LrO,5>lOOQ[,5>n,5>nO#!dQ`O,5>nOOQ[,5>p,5>pO#!dQ`O,5>pOOQ[,5>r,5>rO##QQpO'#D_O%[QlO'#JvO##sQpO'#JvO##}QpO'#DmO#$`QpO'#DmO#&qQlO'#DmO#&xQ`O'#JuO#'QQ`O,5:WO#'VQ`O'#EtO#'eQ`O'#KUO#'mQ`O,5;_O#'rQpO'#DmO#(PQpO'#EVOOQ!0Lf,5:o,5:oO%[QlO,5:oO#(WQ`O,5:oO?YQ`O,5;YO!CUQpO,5;YO!C^QMhO,5;YO:dQMhO,5;YO#(`Q`O,5@bO#(eQ07dO,5:sOOQO-E<f-E<fO#)kQ!0MSO,5;RODWQpO,5:rO#)uQpO,5:rODWQpO,5;RO!ByQ!0LrO,5:rOOQ!0Lb'#Ej'#EjOOQO,5;R,5;RO%[QlO,5;RO#*SQ!0LrO,5;RO#*_Q!0LrO,5;RO!CUQpO,5:rOOQO,5;X,5;XO#*mQ!0LrO,5;RPOOO'#I^'#I^P#+RO&2DjO,58|POOO,58|,58|OOOO-E<^-E<^OOQ!0Lh1G.p1G.pOOOO-E<_-E<_OOOO,59},59}O#+^Q!bO,59}OOOO-E<a-E<aOOQ!0Lf1G/g1G/gO#+cQ!fO,5?OO+}QlO,5?OOOQO,5?U,5?UO#+mQlO'#IdOOQO-E<b-E<bO#+zQ`O,5@`O#,SQ!fO,5@`O#,ZQ`O,5@nOOQ!0Lf1G/m1G/mO%[QlO,5@oO#,cQ`O'#IjOOQO-E<h-E<hO#,ZQ`O,5@nOOQ!0Lb1G0x1G0xOOQ!0Ln1G/x1G/xOOQ!0Ln1G0Y1G0YO%[QlO,5@lO#,wQ!0LrO,5@lO#-YQ!0LrO,5@lO#-aQ`O,5@kO9eQ`O,5@kO#-iQ`O,5@kO#-wQ`O'#ImO#-aQ`O,5@kOOQ!0Lb1G0w1G0wO!(tQpO,5:uO!)PQpO,5:uOOQS,5:w,5:wO#.iQdO,5:wO#.qQMhO1G2yO9kQ`O1G2yOOQ!0Lf1G0u1G0uO#/PQ!0MxO1G0uO#0UQ!0MvO,5;VOOQ!0Lh'#GW'#GWO#0rQ!0MzO'#JlO!$wQlO1G0uO#2}Q!fO'#JwO%[QlO'#JwO#3XQ`O,5:eOOQ!0Lh'#D_'#D_OOQ!0Lf1G1O1G1OO%[QlO1G1OOOQ!0Lf1G1f1G1fO#3^Q`O1G1OO#5rQ!0MxO1G1PO#5yQ!0MxO1G1PO#8aQ!0MxO1G1PO#8hQ!0MxO1G1PO#;OQ!0MxO1G1PO#=fQ!0MxO1G1PO#=mQ!0MxO1G1PO#=tQ!0MxO1G1PO#@[Q!0MxO1G1PO#@cQ!0MxO1G1PO#BpQ?MtO'#CiO#DkQ?MtO1G1`O#DrQ?MtO'#JsO#EVQ!0MxO,5?[OOQ!0Lb-E<n-E<nO#GdQ!0MxO1G1PO#HaQ!0MzO1G1POOQ!0Lf1G1P1G1PO#IdQMjO'#J|O#InQ`O,5:xO#IsQ!0MxO1G1cO#JgQ,UO,5<WO#JoQ,UO,5<XO#JwQ,UO'#FoO#K`Q`O'#FnOOQO'#KY'#KYOOQO'#In'#InO#KeQ,UO1G1nOOQ!0Lf1G1n1G1nOOOW1G1y1G1yO#KvQ?MtO'#JrO#LQQ`O,5<bO!)[QlO,5<bOOOW-E<m-E<mOOQ!0Lf1G1l1G1lO#LVQpO'#KXOOQ!0Lf,5<d,5<dO#L_QpO,5<dO#LdQMhO'#DTOOOO'#Ib'#IbO#LkO#@ItO,59mOOQ!0Lh,59m,59mO%[QlO1G2PO!8lQ`O'#IrO#LvQ`O,5<zOOQ!0Lh,5<w,5<wO!,TQMhO'#IuO#MdQMjO,5=XO!,TQMhO'#IwO#NVQMjO,5=ZO!&zQMhO,5=]OOQO1G2S1G2SO#NaQ!dO'#CrO#NtQ(CWO'#ErO$ |QpO'#GbO$!dQ!dO,5<sO$!kQ`O'#K[O9eQ`O'#K[O$!yQ`O,5<uO$#aQ!dO'#C{O!,TQMhO,5<tO$#kQ`O'#GZO$$PQ`O,5<tO$$UQ!dO'#GWO$$cQ!dO'#K]O$$mQ`O'#K]O!&zQMhO'#K]O$$rQ`O,5<xO$$wQlO'#JvO$%RQpO'#GcO#$`QpO'#GcO$%dQ`O'#GgO!3oQ`O'#GkO$%iQ!0LrO'#ItO$%tQpO,5<|OOQ!0Lp,5<|,5<|O$%{QpO'#GcO$&YQpO'#GdO$&kQpO'#GdO$&pQMjO,5=XO$'QQMjO,5=ZOOQ!0Lh,5=^,5=^O!,TQMhO,5@VO!,TQMhO,5@VO$'bQ`O'#IyO$'vQ`O,5@UO$(OQ`O,59aOOQ!0Lh,59i,59iO$(TQ`O,5@VO$)TQ$IYO,59uOOQ!0Lh'#Jp'#JpO$)vQMjO,5<kO$*iQMjO,5<mO@zQ`O,5<oOOQ!0Lh,5<p,5<pO$*sQ`O,5<vO$*xQMjO,5<{O$+YQ`O'#KPO!$wQlO1G2RO$+_Q`O1G2RO9eQ`O'#KSO9eQ`O'#EtO%[QlO'#EtO9eQ`O'#I{O$+dQ!0LrO,5@{OOQ[1G2}1G2}OOQ[1G4`1G4`OOQ!0Lf1G/|1G/|OOQ!0Lf1G/z1G/zO$-fQ!0MxO1G0UOOQ[1G2y1G2yO!&zQMhO1G2yO%[QlO1G2yO#.tQ`O1G2yO$/jQMhO'#EkOOQ!0Lb,5@T,5@TO$/wQ!0LrO,5@TOOQ[1G.u1G.uO!ByQ!0LrO1G.uO!CUQpO1G.uO!C^QMhO1G.uO$0YQ`O1G0uO$0_Q`O'#CiO$0jQ`O'#KeO$0rQ`O,5=|O$0wQ`O'#KeO$0|Q`O'#KeO$1[Q`O'#JRO$1jQ`O,5AOO$1rQ!fO1G1iOOQ!0Lf1G1k1G1kO9kQ`O1G3fO@zQ`O1G3fO$1yQ`O1G3fO$2OQ`O1G3fO!DiQ`O1G3fO9uQ!0LrO1G3fOOQ[1G3f1G3fO!EcQ`O1G3UO!&zQMhO1G3RO$2TQ`O1G3ROOQ[1G3S1G3SO!&zQMhO1G3SO$2YQ`O1G3SO$2bQpO'#HQOOQ[1G3U1G3UO!6_QpO'#I}O!EhQ!bO1G3XOOQ[1G3X1G3XOOQ[,5=r,5=rO$2jQMhO,5=tO9kQ`O,5=tO$%dQ`O,5=vO9`Q`O,5=vO!CUQpO,5=vO!C^QMhO,5=vO:dQMhO,5=vO$2xQ`O'#KcO$3TQ`O,5=wOOQ[1G.k1G.kO$3YQ!0LrO1G.kO@zQ`O1G.kO$3eQ`O1G.kO9uQ!0LrO1G.kO$5mQ!fO,5AQO$5zQ`O,5AQO9eQ`O,5AQO$6VQlO,5>PO$6^Q`O,5>POOQ[1G3i1G3iO`QlO1G3iOOQ[1G3o1G3oOOQ[1G3q1G3qO?TQ`O1G3sO$6cQlO1G3uO$:gQlO'#HtOOQ[1G3x1G3xO$:tQ`O'#HzO?YQ`O'#H|OOQ[1G4O1G4OO$:|QlO1G4OO9uQ!0LrO1G4UOOQ[1G4W1G4WOOQ!0Lb'#G_'#G_O9uQ!0LrO1G4YO9uQ!0LrO1G4[O$?TQ`O,5@bO!)[QlO,5;`O9eQ`O,5;`O?YQ`O,5:XO!)[QlO,5:XO!CUQpO,5:XO$?YQ?MtO,5:XOOQO,5;`,5;`O$?dQpO'#IeO$?zQ`O,5@aOOQ!0Lf1G/r1G/rO$@SQpO'#IkO$@^Q`O,5@pOOQ!0Lb1G0y1G0yO#$`QpO,5:XOOQO'#Ig'#IgO$@fQpO,5:qOOQ!0Ln,5:q,5:qO#(ZQ`O1G0ZOOQ!0Lf1G0Z1G0ZO%[QlO1G0ZOOQ!0Lf1G0t1G0tO?YQ`O1G0tO!CUQpO1G0tO!C^QMhO1G0tOOQ!0Lb1G5|1G5|O!ByQ!0LrO1G0^OOQO1G0m1G0mO%[QlO1G0mO$@mQ!0LrO1G0mO$@xQ!0LrO1G0mO!CUQpO1G0^ODWQpO1G0^O$AWQ!0LrO1G0mOOQO1G0^1G0^O$AlQ!0MxO1G0mPOOO-E<[-E<[POOO1G.h1G.hOOOO1G/i1G/iO$AvQ!bO,5<iO$BOQ!fO1G4jOOQO1G4p1G4pO%[QlO,5?OO$BYQ`O1G5zO$BbQ`O1G6YO$BjQ!fO1G6ZO9eQ`O,5?UO$BtQ!0MxO1G6WO%[QlO1G6WO$CUQ!0LrO1G6WO$CgQ`O1G6VO$CgQ`O1G6VO9eQ`O1G6VO$CoQ`O,5?XO9eQ`O,5?XOOQO,5?X,5?XO$DTQ`O,5?XO$+YQ`O,5?XOOQO-E<k-E<kOOQS1G0a1G0aOOQS1G0c1G0cO#.lQ`O1G0cOOQ[7+(e7+(eO!&zQMhO7+(eO%[QlO7+(eO$DcQ`O7+(eO$DnQMhO7+(eO$D|Q!0MzO,5=XO$GXQ!0MzO,5=ZO$IdQ!0MzO,5=XO$KuQ!0MzO,5=ZO$NWQ!0MzO,59uO%!]Q!0MzO,5<kO%$hQ!0MzO,5<mO%&sQ!0MzO,5<{OOQ!0Lf7+&a7+&aO%)UQ!0MxO7+&aO%)xQlO'#IfO%*VQ`O,5@cO%*_Q!fO,5@cOOQ!0Lf1G0P1G0PO%*iQ`O7+&jOOQ!0Lf7+&j7+&jO%*nQ?MtO,5:fO%[QlO7+&zO%*xQ?MtO,5:bO%+VQ?MtO,5:jO%+aQ?MtO,5:lO%+kQMhO'#IiO%+uQ`O,5@hOOQ!0Lh1G0d1G0dOOQO1G1r1G1rOOQO1G1s1G1sO%+}Q!jO,5<ZO!)[QlO,5<YOOQO-E<l-E<lOOQ!0Lf7+'Y7+'YOOOW7+'e7+'eOOOW1G1|1G1|O%,YQ`O1G1|OOQ!0Lf1G2O1G2OOOOO,59o,59oO%,_Q!dO,59oOOOO-E<`-E<`OOQ!0Lh1G/X1G/XO%,fQ!0MxO7+'kOOQ!0Lh,5?^,5?^O%-YQMhO1G2fP%-aQ`O'#IrPOQ!0Lh-E<p-E<pO%-}QMjO,5?aOOQ!0Lh-E<s-E<sO%.pQMjO,5?cOOQ!0Lh-E<u-E<uO%.zQ!dO1G2wO%/RQ!dO'#CrO%/iQMhO'#KSO$$wQlO'#JvOOQ!0Lh1G2_1G2_O%/sQ`O'#IqO%0[Q`O,5@vO%0[Q`O,5@vO%0dQ`O,5@vO%0oQ`O,5@vOOQO1G2a1G2aO%0}QMjO1G2`O$+YQ`O'#K[O!,TQMhO1G2`O%1_Q(CWO'#IsO%1lQ`O,5@wO!&zQMhO,5@wO%1tQ!dO,5@wOOQ!0Lh1G2d1G2dO%4UQ!fO'#CiO%4`Q`O,5=POOQ!0Lb,5<},5<}O%4hQpO,5<}OOQ!0Lb,5=O,5=OOCwQ`O,5<}O%4sQpO,5<}OOQ!0Lb,5=R,5=RO$+YQ`O,5=VOOQO,5?`,5?`OOQO-E<r-E<rOOQ!0Lp1G2h1G2hO#$`QpO,5<}O$$wQlO,5=PO%5RQ`O,5=OO%5^QpO,5=OO!,TQMhO'#IuO%6WQMjO1G2sO!,TQMhO'#IwO%6yQMjO1G2uO%7TQMjO1G5qO%7_QMjO1G5qOOQO,5?e,5?eOOQO-E<w-E<wOOQO1G.{1G.{O!,TQMhO1G5qO!,TQMhO1G5qO!:]QpO,59wO%[QlO,59wOOQ!0Lh,5<j,5<jO%7lQ`O1G2ZO!,TQMhO1G2bO%7qQ!0MxO7+'mOOQ!0Lf7+'m7+'mO!$wQlO7+'mO%8eQ`O,5;`OOQ!0Lb,5?g,5?gOOQ!0Lb-E<y-E<yO%8jQ!dO'#K^O#(ZQ`O7+(eO4UQ!fO7+(eO$DfQ`O7+(eO%8tQ!0MvO'#CiO%9XQ!0MvO,5=SO%9lQ`O,5=SO%9tQ`O,5=SOOQ!0Lb1G5o1G5oOOQ[7+$a7+$aO!ByQ!0LrO7+$aO!CUQpO7+$aO!$wQlO7+&aO%9yQ`O'#JQO%:bQ`O,5APOOQO1G3h1G3hO9kQ`O,5APO%:bQ`O,5APO%:jQ`O,5APOOQO,5?m,5?mOOQO-E=P-E=POOQ!0Lf7+'T7+'TO%:oQ`O7+)QO9uQ!0LrO7+)QO9kQ`O7+)QO@zQ`O7+)QO%:tQ`O7+)QOOQ[7+)Q7+)QOOQ[7+(p7+(pO%:yQ!0MvO7+(mO!&zQMhO7+(mO!E^Q`O7+(nOOQ[7+(n7+(nO!&zQMhO7+(nO%;TQ`O'#KbO%;`Q`O,5=lOOQO,5?i,5?iOOQO-E<{-E<{OOQ[7+(s7+(sO%<rQpO'#HZOOQ[1G3`1G3`O!&zQMhO1G3`O%[QlO1G3`O%<yQ`O1G3`O%=UQMhO1G3`O9uQ!0LrO1G3bO$%dQ`O1G3bO9`Q`O1G3bO!CUQpO1G3bO!C^QMhO1G3bO%=dQ`O'#JPO%=xQ`O,5@}O%>QQpO,5@}OOQ!0Lb1G3c1G3cOOQ[7+$V7+$VO@zQ`O7+$VO9uQ!0LrO7+$VO%>]Q`O7+$VO%[QlO1G6lO%[QlO1G6mO%>bQ!0LrO1G6lO%>lQlO1G3kO%>sQ`O1G3kO%>xQlO1G3kOOQ[7+)T7+)TO9uQ!0LrO7+)_O`QlO7+)aOOQ['#Kh'#KhOOQ['#JS'#JSO%?PQlO,5>`OOQ[,5>`,5>`O%[QlO'#HuO%?^Q`O'#HwOOQ[,5>f,5>fO9eQ`O,5>fOOQ[,5>h,5>hOOQ[7+)j7+)jOOQ[7+)p7+)pOOQ[7+)t7+)tOOQ[7+)v7+)vO%?cQpO1G5|O%?}Q?MtO1G0zO%@XQ`O1G0zOOQO1G/s1G/sO%@dQ?MtO1G/sO?YQ`O1G/sO!)[QlO'#DmOOQO,5?P,5?POOQO-E<c-E<cOOQO,5?V,5?VOOQO-E<i-E<iO!CUQpO1G/sOOQO-E<e-E<eOOQ!0Ln1G0]1G0]OOQ!0Lf7+%u7+%uO#(ZQ`O7+%uOOQ!0Lf7+&`7+&`O?YQ`O7+&`O!CUQpO7+&`OOQO7+%x7+%xO$AlQ!0MxO7+&XOOQO7+&X7+&XO%[QlO7+&XO%@nQ!0LrO7+&XO!ByQ!0LrO7+%xO!CUQpO7+%xO%@yQ!0LrO7+&XO%AXQ!0MxO7++rO%[QlO7++rO%AiQ`O7++qO%AiQ`O7++qOOQO1G4s1G4sO9eQ`O1G4sO%AqQ`O1G4sOOQS7+%}7+%}O#(ZQ`O<<LPO4UQ!fO<<LPO%BPQ`O<<LPOOQ[<<LP<<LPO!&zQMhO<<LPO%[QlO<<LPO%BXQ`O<<LPO%BdQ!0MzO,5?aO%DoQ!0MzO,5?cO%FzQ!0MzO1G2`O%I]Q!0MzO1G2sO%KhQ!0MzO1G2uO%MsQ!fO,5?QO%[QlO,5?QOOQO-E<d-E<dO%M}Q`O1G5}OOQ!0Lf<<JU<<JUO%NVQ?MtO1G0uO&!^Q?MtO1G1PO&!eQ?MtO1G1PO&$fQ?MtO1G1PO&$mQ?MtO1G1PO&&nQ?MtO1G1PO&(oQ?MtO1G1PO&(vQ?MtO1G1PO&(}Q?MtO1G1PO&+OQ?MtO1G1PO&+VQ?MtO1G1PO&+^Q!0MxO<<JfO&-UQ?MtO1G1PO&.RQ?MvO1G1PO&/UQ?MvO'#JlO&1[Q?MtO1G1cO&1iQ?MtO1G0UO&1sQMjO,5?TOOQO-E<g-E<gO!)[QlO'#FqOOQO'#KZ'#KZOOQO1G1u1G1uO&1}Q`O1G1tO&2SQ?MtO,5?[OOOW7+'h7+'hOOOO1G/Z1G/ZO&2^Q!dO1G4xOOQ!0Lh7+(Q7+(QP!&zQMhO,5?^O!,TQMhO7+(cO&2eQ`O,5?]O9eQ`O,5?]O$+YQ`O,5?]OOQO-E<o-E<oO&2sQ`O1G6bO&2sQ`O1G6bO&2{Q`O1G6bO&3WQMjO7+'zO&3hQ!dO,5?_O&3rQ`O,5?_O!&zQMhO,5?_OOQO-E<q-E<qO&3wQ!dO1G6cO&4RQ`O1G6cO&4ZQ`O1G2kO!&zQMhO1G2kOOQ!0Lb1G2i1G2iOOQ!0Lb1G2j1G2jO%4hQpO1G2iO!CUQpO1G2iOCwQ`O1G2iOOQ!0Lb1G2q1G2qO&4`QpO1G2iO&4nQ`O1G2kO$+YQ`O1G2jOCwQ`O1G2jO$$wQlO1G2kO&4vQ`O1G2jO&5jQMjO,5?aOOQ!0Lh-E<t-E<tO&6]QMjO,5?cOOQ!0Lh-E<v-E<vO!,TQMhO7++]O&6gQMjO7++]O&6qQMjO7++]OOQ!0Lh1G/c1G/cO&7OQ`O1G/cOOQ!0Lh7+'u7+'uO&7TQMjO7+'|O&7eQ!0MxO<<KXOOQ!0Lf<<KX<<KXO&8XQ`O1G0zO!&zQMhO'#IzO&8^Q`O,5@xO&:`Q!fO<<LPO!&zQMhO1G2nO&:gQ!0LrO1G2nOOQ[<<G{<<G{O!ByQ!0LrO<<G{O&:xQ!0MxO<<I{OOQ!0Lf<<I{<<I{OOQO,5?l,5?lO&;lQ`O,5?lO&;qQ`O,5?lOOQO-E=O-E=OO&<PQ`O1G6kO&<PQ`O1G6kO9kQ`O1G6kO@zQ`O<<LlOOQ[<<Ll<<LlO&<XQ`O<<LlO9uQ!0LrO<<LlO9kQ`O<<LlOOQ[<<LX<<LXO%:yQ!0MvO<<LXOOQ[<<LY<<LYO!E^Q`O<<LYO&<^QpO'#I|O&<iQ`O,5@|O!)[QlO,5@|OOQ[1G3W1G3WOOQO'#JO'#JOO9uQ!0LrO'#JOO&<qQpO,5=uOOQ[,5=u,5=uO&<xQpO'#EgO&=PQpO'#GeO&=UQ`O7+(zO&=ZQ`O7+(zOOQ[7+(z7+(zO!&zQMhO7+(zO%[QlO7+(zO&=cQ`O7+(zOOQ[7+(|7+(|O9uQ!0LrO7+(|O$%dQ`O7+(|O9`Q`O7+(|O!CUQpO7+(|O&=nQ`O,5?kOOQO-E<}-E<}OOQO'#H^'#H^O&=yQ`O1G6iO9uQ!0LrO<<GqOOQ[<<Gq<<GqO@zQ`O<<GqO&>RQ`O7+,WO&>WQ`O7+,XO%[QlO7+,WO%[QlO7+,XOOQ[7+)V7+)VO&>]Q`O7+)VO&>bQlO7+)VO&>iQ`O7+)VOOQ[<<Ly<<LyOOQ[<<L{<<L{OOQ[-E=Q-E=QOOQ[1G3z1G3zO&>nQ`O,5>aOOQ[,5>c,5>cO&>sQ`O1G4QO9eQ`O7+&fO!)[QlO7+&fOOQO7+%_7+%_O&>xQ?MtO1G6ZO?YQ`O7+%_OOQ!0Lf<<Ia<<IaOOQ!0Lf<<Iz<<IzO?YQ`O<<IzOOQO<<Is<<IsO$AlQ!0MxO<<IsO%[QlO<<IsOOQO<<Id<<IdO!ByQ!0LrO<<IdO&?SQ!0LrO<<IsO&?_Q!0MxO<= ^O&?oQ`O<= ]OOQO7+*_7+*_O9eQ`O7+*_OOQ[ANAkANAkO&?wQ!fOANAkO!&zQMhOANAkO#(ZQ`OANAkO4UQ!fOANAkO&@OQ`OANAkO%[QlOANAkO&@WQ!0MzO7+'zO&BiQ!0MzO,5?aO&DtQ!0MzO,5?cO&GPQ!0MzO7+'|O&IbQ!fO1G4lO&IlQ?MtO7+&aO&KpQ?MvO,5=XO&MwQ?MvO,5=ZO&NXQ?MvO,5=XO&NiQ?MvO,5=ZO&NyQ?MvO,59uO'#PQ?MvO,5<kO'%SQ?MvO,5<mO''hQ?MvO,5<{O')^Q?MtO7+'kO')kQ?MtO7+'mO')xQ`O,5<]OOQO7+'`7+'`OOQ!0Lh7+*d7+*dO')}QMjO<<K}OOQO1G4w1G4wO'*UQ`O1G4wO'*aQ`O1G4wO'*oQ`O7++|O'*oQ`O7++|O!&zQMhO1G4yO'*wQ!dO1G4yO'+RQ`O7++}O'+ZQ`O7+(VO'+fQ!dO7+(VOOQ!0Lb7+(T7+(TOOQ!0Lb7+(U7+(UO!CUQpO7+(TOCwQ`O7+(TO'+pQ`O7+(VO!&zQMhO7+(VO$+YQ`O7+(UO'+uQ`O7+(VOCwQ`O7+(UO'+}QMjO<<NwO!,TQMhO<<NwOOQ!0Lh7+$}7+$}O',XQ!dO,5?fOOQO-E<x-E<xO',cQ!0MvO7+(YO!&zQMhO7+(YOOQ[AN=gAN=gO9kQ`O1G5WOOQO1G5W1G5WO',sQ`O1G5WO',xQ`O7+,VO',xQ`O7+,VO9uQ!0LrOANBWO@zQ`OANBWOOQ[ANBWANBWO'-QQ`OANBWOOQ[ANAsANAsOOQ[ANAtANAtO'-VQ`O,5?hOOQO-E<z-E<zO'-bQ?MtO1G6hOOQO,5?j,5?jOOQO-E<|-E<|OOQ[1G3a1G3aO'-lQ`O,5=POOQ[<<Lf<<LfO!&zQMhO<<LfO&=UQ`O<<LfO'-qQ`O<<LfO%[QlO<<LfOOQ[<<Lh<<LhO9uQ!0LrO<<LhO$%dQ`O<<LhO9`Q`O<<LhO'-yQpO1G5VO'.UQ`O7+,TOOQ[AN=]AN=]O9uQ!0LrOAN=]OOQ[<= r<= rOOQ[<= s<= sO'.^Q`O<= rO'.cQ`O<= sOOQ[<<Lq<<LqO'.hQ`O<<LqO'.mQlO<<LqOOQ[1G3{1G3{O?YQ`O7+)lO'.tQ`O<<JQO'/PQ?MtO<<JQOOQO<<Hy<<HyOOQ!0LfAN?fAN?fOOQOAN?_AN?_O$AlQ!0MxOAN?_OOQOAN?OAN?OO%[QlOAN?_OOQO<<My<<MyOOQ[G27VG27VO!&zQMhOG27VO#(ZQ`OG27VO'/ZQ!fOG27VO4UQ!fOG27VO'/bQ`OG27VO'/jQ?MtO<<JfO'/wQ?MvO1G2`O'1mQ?MvO,5?aO'3pQ?MvO,5?cO'5sQ?MvO1G2sO'7vQ?MvO1G2uO'9yQ?MtO<<KXO':WQ?MtO<<I{OOQO1G1w1G1wO!,TQMhOANAiOOQO7+*c7+*cO':eQ`O7+*cO':pQ`O<= hO':xQ!dO7+*eOOQ!0Lb<<Kq<<KqO$+YQ`O<<KqOCwQ`O<<KqO';SQ`O<<KqO!&zQMhO<<KqOOQ!0Lb<<Ko<<KoO!CUQpO<<KoO';_Q!dO<<KqOOQ!0Lb<<Kp<<KpO';iQ`O<<KqO!&zQMhO<<KqO$+YQ`O<<KpO';nQMjOANDcO';xQ!0MvO<<KtOOQO7+*r7+*rO9kQ`O7+*rO'<YQ`O<= qOOQ[G27rG27rO9uQ!0LrOG27rO@zQ`OG27rO!)[QlO1G5SO'<bQ`O7+,SO'<jQ`O1G2kO&=UQ`OANBQOOQ[ANBQANBQO!&zQMhOANBQO'<oQ`OANBQOOQ[ANBSANBSO9uQ!0LrOANBSO$%dQ`OANBSOOQO'#H_'#H_OOQO7+*q7+*qOOQ[G22wG22wOOQ[ANE^ANE^OOQ[ANE_ANE_OOQ[ANB]ANB]O'<wQ`OANB]OOQ[<<MW<<MWO!)[QlOAN?lOOQOG24yG24yO$AlQ!0MxOG24yO#(ZQ`OLD,qOOQ[LD,qLD,qO!&zQMhOLD,qO'<|Q!fOLD,qO'=TQ?MvO7+'zO'>yQ?MvO,5?aO'@|Q?MvO,5?cO'CPQ?MvO7+'|O'DuQMjOG27TOOQO<<M}<<M}OOQ!0LbANA]ANA]O$+YQ`OANA]OCwQ`OANA]O'EVQ!dOANA]OOQ!0LbANAZANAZO'E^Q`OANA]O!&zQMhOANA]O'EiQ!dOANA]OOQ!0LbANA[ANA[OOQO<<N^<<N^OOQ[LD-^LD-^O9uQ!0LrOLD-^O'EsQ?MtO7+*nOOQO'#Gf'#GfOOQ[G27lG27lO&=UQ`OG27lO!&zQMhOG27lOOQ[G27nG27nO9uQ!0LrOG27nOOQ[G27wG27wO'E}Q?MtOG25WOOQOLD*eLD*eOOQ[!$(!]!$(!]O#(ZQ`O!$(!]O!&zQMhO!$(!]O'FXQ!0MzOG27TOOQ!0LbG26wG26wO$+YQ`OG26wO'HjQ`OG26wOCwQ`OG26wO'HuQ!dOG26wO!&zQMhOG26wOOQ[!$(!x!$(!xOOQ[LD-WLD-WO&=UQ`OLD-WOOQ[LD-YLD-YOOQ[!)9Ew!)9EwO#(ZQ`O!)9EwOOQ!0LbLD,cLD,cO$+YQ`OLD,cOCwQ`OLD,cO'H|Q`OLD,cO'IXQ!dOLD,cOOQ[!$(!r!$(!rOOQ[!.K;c!.K;cO'I`Q?MvOG27TOOQ!0Lb!$( }!$( }O$+YQ`O!$( }OCwQ`O!$( }O'KUQ`O!$( }OOQ!0Lb!)9Ei!)9EiO$+YQ`O!)9EiOCwQ`O!)9EiOOQ!0Lb!.K;T!.K;TO$+YQ`O!.K;TOOQ!0Lb!4/0o!4/0oO!)[QlO'#DzO1PQ`O'#EXO'KaQ!fO'#JrO'KhQ!L^O'#DvO'KoQlO'#EOO'KvQ!fO'#CiO'N^Q!fO'#CiO!)[QlO'#EQO'NnQlO,5;ZO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO'#IpO(!qQ`O,5<iO!)[QlO,5;eO(!yQMhO,5;eO($dQMhO,5;eO!)[QlO,5;wO!&zQMhO'#GmO(!yQMhO'#GmO!&zQMhO'#GoO(!yQMhO'#GoO1SQ`O'#DZO1SQ`O'#DZO!&zQMhO'#GPO(!yQMhO'#GPO!&zQMhO'#GRO(!yQMhO'#GRO!&zQMhO'#GaO(!yQMhO'#GaO!)[QlO,5:jO($kQpO'#D_O($uQpO'#JvO!)[QlO,5@oO'NnQlO1G0uO(%PQ?MtO'#CiO!)[QlO1G2PO!&zQMhO'#IuO(!yQMhO'#IuO!&zQMhO'#IwO(!yQMhO'#IwO(%ZQ!dO'#CrO!&zQMhO,5<tO(!yQMhO,5<tO'NnQlO1G2RO!)[QlO7+&zO!&zQMhO1G2`O(!yQMhO1G2`O!&zQMhO'#IuO(!yQMhO'#IuO!&zQMhO'#IwO(!yQMhO'#IwO!&zQMhO1G2bO(!yQMhO1G2bO'NnQlO7+'mO'NnQlO7+&aO!&zQMhOANAiO(!yQMhOANAiO(%nQ`O'#EoO(%sQ`O'#EoO(%{Q`O'#F]O(&QQ`O'#EyO(&VQ`O'#KTO(&bQ`O'#KRO(&mQ`O,5;ZO(&rQMjO,5<eO(&yQ`O'#GYO('OQ`O'#GYO('TQ`O,5<eO(']Q`O,5<gO('eQ`O,5;ZO('mQ?MtO1G1`O('tQ`O,5<tO('yQ`O,5<tO((OQ`O,5<vO((TQ`O,5<vO((YQ`O1G2RO((_Q`O1G0uO((dQMjO<<K}O((kQMjO<<K}O((rQMhO'#F|O9`Q`O'#F{OAuQ`O'#EnO!)[QlO,5;tO!3oQ`O'#GYO!3oQ`O'#GYO!3oQ`O'#G[O!3oQ`O'#G[O!,TQMhO7+(cO!,TQMhO7+(cO%.zQ!dO1G2wO%.zQ!dO1G2wO!&zQMhO,5=]O!&zQMhO,5=]",
    stateData: "()x~O'|OS'}OSTOS(ORQ~OPYOQYOSfOY!VOaqOdzOeyOl!POpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!uwO!xxO!|]O$W|O$niO%h}O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO&W!WO&^!XO&`!YO&b!ZO&d![O&g!]O&m!^O&s!_O&u!`O&w!aO&y!bO&{!cO(TSO(VTO(YUO(aVO(o[O~OWtO~P`OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oa!wOs!nO!S!oO!b!yO!c!vO!d!vO!|<VO#T!pO#U!pO#V!xO#W!pO#X!pO#[!zO#]!zO(U!lO(VTO(YUO(e!mO(o!sO~O(O!{O~OP]XR]X[]Xa]Xj]Xr]X!Q]X!S]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X'z]X(a]X(r]X(y]X(z]X~O!g%RX~P(qO_!}O(V#PO(W!}O(X#PO~O_#QO(X#PO(Y#PO(Z#QO~Ox#SO!U#TO(b#TO(c#VO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T<ZO(VTO(YUO(aVO(o[O~O![#ZO!]#WO!Y(hP!Y(vP~P+}O!^#cO~P`OPYOQYOSfOd!jOe!iOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(VTO(YUO(aVO(o[O~Op#mO![#iO!|]O#i#lO#j#iO(T<[O!k(sP~P.iO!l#oO(T#nO~O!x#sO!|]O%h#tO~O#k#uO~O!g#vO#k#uO~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!]$_O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~Oa(fX'z(fX'w(fX!k(fX!Y(fX!_(fX%i(fX!g(fX~P1qO#S$dO#`$eO$Q$eOP(gXR(gX[(gXj(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX!_(gX%i(gX~Oa(gX'z(gX'w(gX!Y(gX!k(gXv(gX!g(gX~P4UO#`$eO~O$]$hO$_$gO$f$mO~OSfO!_$nO$i$oO$k$qO~Oh%VOj%dOk%dOp%WOr%XOs$tOt$tOz%YO|%ZO!O%]O!S${O!_$|O!i%bO!l$xO#j%cO$W%`O$t%^O$v%_O$y%aO(T$sO(VTO(YUO(a$uO(y$}O(z%POg(^P~Ol%[O~P7eO!l%eO~O!S%hO!_%iO(T%gO~O!g%mO~Oa%nO'z%nO~O!Q%rO~P%[O(U!lO~P%[O%n%vO~P%[Oh%VO!l%eO(T%gO(U!lO~Oe%}O!l%eO(T%gO~Oj$RO~O!_&PO(T%gO(U!lO(VTO(YUO`)WP~O!Q&SO!l&RO%j&VO&T&WO~P;SO!x#sO~O%s&YO!S)SX!_)SX(T)SX~O(T&ZO~Ol!PO!u&`O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO~Od&eOe&dO!x&bO%h&cO%{&aO~P<bOd&hOeyOl!PO!_&gO!u&`O!xxO!|]O%h}O%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO~Ob&kO#`&nO%j&iO(U!lO~P=gO!l&oO!u&sO~O!l#oO~O!_XO~Oa%nO'x&{O'z%nO~Oa%nO'x'OO'z%nO~Oa%nO'x'QO'z%nO~O'w]X!Y]Xv]X!k]X&[]X!_]X%i]X!g]X~P(qO!b'_O!c'WO!d'WO(U!lO(VTO(YUO~Os'UO!S'TO!['XO(e'SO!^(iP!^(xP~P@nOn'bO!_'`O(T%gO~Oe'gO!l%eO(T%gO~O!Q&SO!l&RO~Os!nO!S!oO!|<VO#T!pO#U!pO#W!pO#X!pO(U!lO(VTO(YUO(e!mO(o!sO~O!b'mO!c'lO!d'lO#V!pO#['nO#]'nO~PBYOa%nOh%VO!g#vO!l%eO'z%nO(r'pO~O!p'tO#`'rO~PChOs!nO!S!oO(VTO(YUO(e!mO(o!sO~O!_XOs(mX!S(mX!b(mX!c(mX!d(mX!|(mX#T(mX#U(mX#V(mX#W(mX#X(mX#[(mX#](mX(U(mX(V(mX(Y(mX(e(mX(o(mX~O!c'lO!d'lO(U!lO~PDWO(P'xO(Q'xO(R'zO~O_!}O(V'|O(W!}O(X'|O~O_#QO(X'|O(Y'|O(Z#QO~Ov(OO~P%[Ox#SO!U#TO(b#TO(c(RO~O![(TO!Y'WX!Y'^X!]'WX!]'^X~P+}O!](VO!Y(hX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!](VO!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~O!Y(hX~PHRO!Y([O~O!Y(uX!](uX!g(uX!k(uX(r(uX~O#`(uX#k#dX!^(uX~PJUO#`(]O!Y(wX!](wX~O!](^O!Y(vX~O!Y(aO~O#`$eO~PJUO!^(bO~P`OR#zO!Q#yO!S#{O!l#xO(aVOP!na[!naj!nar!na!]!na!p!na#R!na#n!na#o!na#p!na#q!na#r!na#s!na#t!na#u!na#v!na#x!na#z!na#{!na(r!na(y!na(z!na~Oa!na'z!na'w!na!Y!na!k!nav!na!_!na%i!na!g!na~PKlO!k(cO~O!g#vO#`(dO(r'pO!](tXa(tX'z(tX~O!k(tX~PNXO!S%hO!_%iO!|]O#i(iO#j(hO(T%gO~O!](jO!k(sX~O!k(lO~O!S%hO!_%iO#j(hO(T%gO~OP(gXR(gX[(gXj(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX~O!g#vO!k(gX~P! uOR(nO!Q(mO!l#xO#S$dO!|!{a!S!{a~O!x!{a%h!{a!_!{a#i!{a#j!{a(T!{a~P!#vO!x(rO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~O#k(xO~O![(zO!k(kP~P%[O(e(|O(o[O~O!S)OO!l#xO(e(|O(o[O~OP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_!eO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(T)]O(VTO(YUO(aVO(o[O~O!]$_Oa$qa'z$qa'w$qa!k$qa!Y$qa!_$qa%i$qa!g$qa~Ol)dO~P!&zOh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O%]O!S${O!_$|O!i%bO!l$xO#j%cO$W%`O$t%^O$v%_O$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~Og(pP~P!,TO!Q)iO!g)hO!_$^X$Z$^X$]$^X$_$^X$f$^X~O!g)hO!_({X$Z({X$]({X$_({X$f({X~O!Q)iO~P!.^O!Q)iO!_({X$Z({X$]({X$_({X$f({X~O!_)kO$Z)oO$])jO$_)jO$f)pO~O![)sO~P!)[O$]$hO$_$gO$f)wO~On$zX!Q$zX#S$zX'y$zX(y$zX(z$zX~OgmXg$zXnmX!]mX#`mX~P!0SOx)yO(b)zO(c)|O~On*VO!Q*OO'y*PO(y$}O(z%PO~Og)}O~P!1WOg*WO~Oh%VOr%XOs$tOt$tOz%YO|%ZO!O<sO!S*YO!_*ZO!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(VTO(YUO(a$uO(y$}O(z%PO~Op*`O![*^O(T*XO!k)OP~P!1uO#k*aO~O!l*bO~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(T*dO(VTO(YUO(a$uO(y$}O(z%PO~O![*gO!Y)PP~P!3tOr*sOs!nO!S*iO!b*qO!c*kO!d*kO!l*bO#[*rO%`*mO(U!lO(VTO(YUO(e!mO~O!^*pO~P!5iO#S$dOn(`X!Q(`X'y(`X(y(`X(z(`X!](`X#`(`X~Og(`X$O(`X~P!6kOn*xO#`*wOg(_X!](_X~O!]*yOg(^X~Oj%dOk%dOl%dO(T&ZOg(^P~Os*|O~Og)}O(T&ZO~O!l+SO~O(T(vO~Op+WO!S%hO![#iO!_%iO!|]O#i#lO#j#iO(T%gO!k(sP~O!g#vO#k+XO~O!S%hO![+ZO!](^O!_%iO(T%gO!Y(vP~Os'[O!S+]O![+[O(VTO(YUO(e(|O~O!^(xP~P!9|O!]+^Oa)TX'z)TX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~Oa!ja!]!ja'z!ja'w!ja!Y!ja!k!jav!ja!_!ja%i!ja!g!ja~P!:tOR#zO!Q#yO!S#{O!l#xO(aVOP!ra[!raj!rar!ra!]!ra!p!ra#R!ra#n!ra#o!ra#p!ra#q!ra#r!ra#s!ra#t!ra#u!ra#v!ra#x!ra#z!ra#{!ra(r!ra(y!ra(z!ra~Oa!ra'z!ra'w!ra!Y!ra!k!rav!ra!_!ra%i!ra!g!ra~P!=[OR#zO!Q#yO!S#{O!l#xO(aVOP!ta[!taj!tar!ta!]!ta!p!ta#R!ta#n!ta#o!ta#p!ta#q!ta#r!ta#s!ta#t!ta#u!ta#v!ta#x!ta#z!ta#{!ta(r!ta(y!ta(z!ta~Oa!ta'z!ta'w!ta!Y!ta!k!tav!ta!_!ta%i!ta!g!ta~P!?rOh%VOn+gO!_'`O%i+fO~O!g+iOa(]X!_(]X'z(]X!](]X~Oa%nO!_XO'z%nO~Oh%VO!l%eO~Oh%VO!l%eO(T%gO~O!g#vO#k(xO~Ob+tO%j+uO(T+qO(VTO(YUO!^)XP~O!]+vO`)WX~O[+zO~O`+{O~O!_&PO(T%gO(U!lO`)WP~O%j,OO~P;SOh%VO#`,SO~Oh%VOn,VO!_$|O~O!_,XO~O!Q,ZO!_XO~O%n%vO~O!x,`O~Oe,eO~Ob,fO(T#nO(VTO(YUO!^)VP~Oe%}O~O%j!QO(T&ZO~P=gO[,kO`,jO~OPYOQYOSfOdzOeyOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!iuO!lZO!oYO!pYO!qYO!svO!xxO!|]O$niO%h}O(VTO(YUO(aVO(o[O~O!_!eO!u!gO$W!kO(T!dO~P!FyO`,jOa%nO'z%nO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oa,pOl!OO!uwO%l!OO%m!OO%n!OO~P!IcO!l&oO~O&^,vO~O!_,xO~O&o,zO&q,{OP&laQ&laS&laY&laa&lad&lae&lal&lap&lar&las&lat&laz&la|&la!O&la!S&la!W&la!X&la!_&la!i&la!l&la!o&la!p&la!q&la!s&la!u&la!x&la!|&la$W&la$n&la%h&la%j&la%l&la%m&la%n&la%q&la%s&la%v&la%w&la%y&la&W&la&^&la&`&la&b&la&d&la&g&la&m&la&s&la&u&la&w&la&y&la&{&la'w&la(T&la(V&la(Y&la(a&la(o&la!^&la&e&lab&la&j&la~O(T-QO~Oh!eX!]!RX!^!RX!g!RX!g!eX!l!eX#`!RX~O!]!eX!^!eX~P#!iO!g-VO#`-UOh(jX!]#hX!^#hX!g(jX!l(jX~O!](jX!^(jX~P##[Oh%VO!g-XO!l%eO!]!aX!^!aX~Os!nO!S!oO(VTO(YUO(e!mO~OP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_!eO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(VTO(YUO(aVO(o[O~O(T=QO~P#$qO!]-]O!^(iX~O!^-_O~O!g-VO#`-UO!]#hX!^#hX~O!]-`O!^(xX~O!^-bO~O!c-cO!d-cO(U!lO~P#$`O!^-fO~P'_On-iO!_'`O~O!Y-nO~Os!{a!b!{a!c!{a!d!{a#T!{a#U!{a#V!{a#W!{a#X!{a#[!{a#]!{a(U!{a(V!{a(Y!{a(e!{a(o!{a~P!#vO!p-sO#`-qO~PChO!c-uO!d-uO(U!lO~PDWOa%nO#`-qO'z%nO~Oa%nO!g#vO#`-qO'z%nO~Oa%nO!g#vO!p-sO#`-qO'z%nO(r'pO~O(P'xO(Q'xO(R-zO~Ov-{O~O!Y'Wa!]'Wa~P!:tO![.PO!Y'WX!]'WX~P%[O!](VO!Y(ha~O!Y(ha~PHRO!](^O!Y(va~O!S%hO![.TO!_%iO(T%gO!Y'^X!]'^X~O#`.VO!](ta!k(taa(ta'z(ta~O!g#vO~P#,wO!](jO!k(sa~O!S%hO!_%iO#j.ZO(T%gO~Op.`O!S%hO![.]O!_%iO!|]O#i._O#j.]O(T%gO!]'aX!k'aX~OR.dO!l#xO~Oh%VOn.gO!_'`O%i.fO~Oa#ci!]#ci'z#ci'w#ci!Y#ci!k#civ#ci!_#ci%i#ci!g#ci~P!:tOn>]O!Q*OO'y*PO(y$}O(z%PO~O#k#_aa#_a#`#_a'z#_a!]#_a!k#_a!_#_a!Y#_a~P#/sO#k(`XP(`XR(`X[(`Xa(`Xj(`Xr(`X!S(`X!l(`X!p(`X#R(`X#n(`X#o(`X#p(`X#q(`X#r(`X#s(`X#t(`X#u(`X#v(`X#x(`X#z(`X#{(`X'z(`X(a(`X(r(`X!k(`X!Y(`X'w(`Xv(`X!_(`X%i(`X!g(`X~P!6kO!].tO!k(kX~P!:tO!k.wO~O!Y.yO~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(aVO[#mia#mij#mir#mi!]#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#n#mi~P#3cO#n$OO~P#3cOP$[OR#zOr$aO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(aVO[#mia#mij#mi!]#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#r#mi~P#6QO#r$QO~P#6QOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO(aVOa#mi!]#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#v#mi~P#8oOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO(aVO(z#}Oa#mi!]#mi#z#mi#{#mi'z#mi(r#mi(y#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#x$UO~P#;VO#x#mi~P#;VO#v$SO~P#8oOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO(aVO(y#|O(z#}Oa#mi!]#mi#{#mi'z#mi(r#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#z#mi~P#={O#z$WO~P#={OP]XR]X[]Xj]Xr]X!Q]X!S]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X!]]X!^]X~O$O]X~P#@jOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO#x<eO#z<gO#{<hO(aVO(r$YO(y#|O(z#}O~O$O.{O~P#BwO#S$dO#`<nO$Q<nO$O(gX!^(gX~P! uOa'da!]'da'z'da'w'da!k'da!Y'dav'da!_'da%i'da!g'da~P!:tO[#mia#mij#mir#mi!]#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(aVO(y#mi(z#mi~P#EyOn>]O!Q*OO'y*PO(y$}O(z%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(a#mi~P#EyO!]/POg(pX~P!1WOg/RO~Oa$Pi!]$Pi'z$Pi'w$Pi!Y$Pi!k$Piv$Pi!_$Pi%i$Pi!g$Pi~P!:tO$]/SO$_/SO~O$]/TO$_/TO~O!g)hO#`/UO!_$cX$Z$cX$]$cX$_$cX$f$cX~O![/VO~O!_)kO$Z/XO$])jO$_)jO$f/YO~O!]<iO!^(fX~P#BwO!^/ZO~O!g)hO$f({X~O$f/]O~Ov/^O~P!&zOx)yO(b)zO(c/aO~O!S/dO~O(y$}On%aa!Q%aa'y%aa(z%aa!]%aa#`%aa~Og%aa$O%aa~P#L{O(z%POn%ca!Q%ca'y%ca(y%ca!]%ca#`%ca~Og%ca$O%ca~P#MnO!]fX!gfX!kfX!k$zX(rfX~P!0SOp%WO![/mO!](^O(T/lO!Y(vP!Y)PP~P!1uOr*sO!b*qO!c*kO!d*kO!l*bO#[*rO%`*mO(U!lO(VTO(YUO~Os<}O!S/nO![+[O!^*pO(e<|O!^(xP~P$ [O!k/oO~P#/sO!]/pO!g#vO(r'pO!k)OX~O!k/uO~OnoX!QoX'yoX(yoX(zoX~O!g#vO!koX~P$#OOp/wO!S%hO![*^O!_%iO(T%gO!k)OP~O#k/xO~O!Y$zX!]$zX!g%RX~P!0SO!]/yO!Y)PX~P#/sO!g/{O~O!Y/}O~OpkO(T0OO~P.iOh%VOr0TO!g#vO!l%eO(r'pO~O!g+iO~Oa%nO!]0XO'z%nO~O!^0ZO~P!5iO!c0[O!d0[O(U!lO~P#$`Os!nO!S0]O(VTO(YUO(e!mO~O#[0_O~Og%aa!]%aa#`%aa$O%aa~P!1WOg%ca!]%ca#`%ca$O%ca~P!1WOj%dOk%dOl%dO(T&ZOg'mX!]'mX~O!]*yOg(^a~Og0hO~On0jO#`0iOg(_a!](_a~OR0kO!Q0kO!S0lO#S$dOn}a'y}a(y}a(z}a!]}a#`}a~Og}a$O}a~P$(cO!Q*OO'y*POn$sa(y$sa(z$sa!]$sa#`$sa~Og$sa$O$sa~P$)_O!Q*OO'y*POn$ua(y$ua(z$ua!]$ua#`$ua~Og$ua$O$ua~P$*QO#k0oO~Og%Ta!]%Ta#`%Ta$O%Ta~P!1WO!g#vO~O#k0rO~O!]+^Oa)Ta'z)Ta~OR#zO!Q#yO!S#{O!l#xO(aVOP!ri[!rij!rir!ri!]!ri!p!ri#R!ri#n!ri#o!ri#p!ri#q!ri#r!ri#s!ri#t!ri#u!ri#v!ri#x!ri#z!ri#{!ri(r!ri(y!ri(z!ri~Oa!ri'z!ri'w!ri!Y!ri!k!riv!ri!_!ri%i!ri!g!ri~P$+oOh%VOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(VTO(YUO(a$uO(y$}O(z%PO~Op0{O%]0|O(T0zO~P$.VO!g+iOa(]a!_(]a'z(]a!](]a~O#k1SO~O[]X!]fX!^fX~O!]1TO!^)XX~O!^1VO~O[1WO~Ob1YO(T+qO(VTO(YUO~O!_&PO(T%gO`'uX!]'uX~O!]+vO`)Wa~O!k1]O~P!:tO[1`O~O`1aO~O#`1fO~On1iO!_$|O~O(e(|O!^)UP~Oh%VOn1rO!_1oO%i1qO~O[1|O!]1zO!^)VX~O!^1}O~O`2POa%nO'z%nO~O(T#nO(VTO(YUO~O#S$dO#`$eO$Q$eOP(gXR(gX[(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX~Oj2SO&[2TOa(gX~P$3pOj2SO#`$eO&[2TO~Oa2VO~P%[Oa2XO~O&e2[OP&ciQ&ciS&ciY&cia&cid&cie&cil&cip&cir&cis&cit&ciz&ci|&ci!O&ci!S&ci!W&ci!X&ci!_&ci!i&ci!l&ci!o&ci!p&ci!q&ci!s&ci!u&ci!x&ci!|&ci$W&ci$n&ci%h&ci%j&ci%l&ci%m&ci%n&ci%q&ci%s&ci%v&ci%w&ci%y&ci&W&ci&^&ci&`&ci&b&ci&d&ci&g&ci&m&ci&s&ci&u&ci&w&ci&y&ci&{&ci'w&ci(T&ci(V&ci(Y&ci(a&ci(o&ci!^&cib&ci&j&ci~Ob2bO!^2`O&j2aO~P`O!_XO!l2dO~O&q,{OP&liQ&liS&liY&lia&lid&lie&lil&lip&lir&lis&lit&liz&li|&li!O&li!S&li!W&li!X&li!_&li!i&li!l&li!o&li!p&li!q&li!s&li!u&li!x&li!|&li$W&li$n&li%h&li%j&li%l&li%m&li%n&li%q&li%s&li%v&li%w&li%y&li&W&li&^&li&`&li&b&li&d&li&g&li&m&li&s&li&u&li&w&li&y&li&{&li'w&li(T&li(V&li(Y&li(a&li(o&li!^&li&e&lib&li&j&li~O!Y2jO~O!]!aa!^!aa~P#BwOs!nO!S!oO![2pO(e!mO!]'XX!^'XX~P@nO!]-]O!^(ia~O!]'_X!^'_X~P!9|O!]-`O!^(xa~O!^2wO~P'_Oa%nO#`3QO'z%nO~Oa%nO!g#vO#`3QO'z%nO~Oa%nO!g#vO!p3UO#`3QO'z%nO(r'pO~Oa%nO'z%nO~P!:tO!]$_Ov$qa~O!Y'Wi!]'Wi~P!:tO!](VO!Y(hi~O!](^O!Y(vi~O!Y(wi!](wi~P!:tO!](ti!k(tia(ti'z(ti~P!:tO#`3WO!](ti!k(tia(ti'z(ti~O!](jO!k(si~O!S%hO!_%iO!|]O#i3]O#j3[O(T%gO~O!S%hO!_%iO#j3[O(T%gO~On3dO!_'`O%i3cO~Oh%VOn3dO!_'`O%i3cO~O#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'z%aa(a%aa(r%aa!k%aa!Y%aa'w%aav%aa!_%aa%i%aa!g%aa~P#L{O#k%caP%caR%ca[%caa%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'z%ca(a%ca(r%ca!k%ca!Y%ca'w%cav%ca!_%ca%i%ca!g%ca~P#MnO#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!]%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'z%aa(a%aa(r%aa!k%aa!Y%aa'w%aa#`%aav%aa!_%aa%i%aa!g%aa~P#/sO#k%caP%caR%ca[%caa%caj%car%ca!S%ca!]%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'z%ca(a%ca(r%ca!k%ca!Y%ca'w%ca#`%cav%ca!_%ca%i%ca!g%ca~P#/sO#k}aP}a[}aa}aj}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a'z}a(a}a(r}a!k}a!Y}a'w}av}a!_}a%i}a!g}a~P$(cO#k$saP$saR$sa[$saa$saj$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa'z$sa(a$sa(r$sa!k$sa!Y$sa'w$sav$sa!_$sa%i$sa!g$sa~P$)_O#k$uaP$uaR$ua[$uaa$uaj$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua'z$ua(a$ua(r$ua!k$ua!Y$ua'w$uav$ua!_$ua%i$ua!g$ua~P$*QO#k%TaP%TaR%Ta[%Taa%Taj%Tar%Ta!S%Ta!]%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta'z%Ta(a%Ta(r%Ta!k%Ta!Y%Ta'w%Ta#`%Tav%Ta!_%Ta%i%Ta!g%Ta~P#/sOa#cq!]#cq'z#cq'w#cq!Y#cq!k#cqv#cq!_#cq%i#cq!g#cq~P!:tO![3lO!]'YX!k'YX~P%[O!].tO!k(ka~O!].tO!k(ka~P!:tO!Y3oO~O$O!na!^!na~PKlO$O!ja!]!ja!^!ja~P#BwO$O!ra!^!ra~P!=[O$O!ta!^!ta~P!?rOg']X!]']X~P!,TO!]/POg(pa~OSfO!_4TO$d4UO~O!^4YO~Ov4ZO~P#/sOa$mq!]$mq'z$mq'w$mq!Y$mq!k$mqv$mq!_$mq%i$mq!g$mq~P!:tO!Y4]O~P!&zO!S4^O~O!Q*OO'y*PO(z%POn'ia(y'ia!]'ia#`'ia~Og'ia$O'ia~P%-fO!Q*OO'y*POn'ka(y'ka(z'ka!]'ka#`'ka~Og'ka$O'ka~P%.XO(r$YO~P#/sO!YfX!Y$zX!]fX!]$zX!g%RX#`fX~P!0SOp%WO(T=WO~P!1uOp4bO!S%hO![4aO!_%iO(T%gO!]'eX!k'eX~O!]/pO!k)Oa~O!]/pO!g#vO!k)Oa~O!]/pO!g#vO(r'pO!k)Oa~Og$|i!]$|i#`$|i$O$|i~P!1WO![4jO!Y'gX!]'gX~P!3tO!]/yO!Y)Pa~O!]/yO!Y)Pa~P#/sOP]XR]X[]Xj]Xr]X!Q]X!S]X!Y]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X~Oj%YX!g%YX~P%2OOj4oO!g#vO~Oh%VO!g#vO!l%eO~Oh%VOr4tO!l%eO(r'pO~Or4yO!g#vO(r'pO~Os!nO!S4zO(VTO(YUO(e!mO~O(y$}On%ai!Q%ai'y%ai(z%ai!]%ai#`%ai~Og%ai$O%ai~P%5oO(z%POn%ci!Q%ci'y%ci(y%ci!]%ci#`%ci~Og%ci$O%ci~P%6bOg(_i!](_i~P!1WO#`5QOg(_i!](_i~P!1WO!k5VO~Oa$oq!]$oq'z$oq'w$oq!Y$oq!k$oqv$oq!_$oq%i$oq!g$oq~P!:tO!Y5ZO~O!]5[O!_)QX~P#/sOa$zX!_$zX%^]X'z$zX!]$zX~P!0SO%^5_OaoX!_oX'zoX!]oX~P$#OOp5`O(T#nO~O%^5_O~Ob5fO%j5gO(T+qO(VTO(YUO!]'tX!^'tX~O!]1TO!^)Xa~O[5kO~O`5lO~O[5pO~Oa%nO'z%nO~P#/sO!]5uO#`5wO!^)UX~O!^5xO~Or6OOs!nO!S*iO!b!yO!c!vO!d!vO!|<VO#T!pO#U!pO#V!pO#W!pO#X!pO#[5}O#]!zO(U!lO(VTO(YUO(e!mO(o!sO~O!^5|O~P%;eOn6TO!_1oO%i6SO~Oh%VOn6TO!_1oO%i6SO~Ob6[O(T#nO(VTO(YUO!]'sX!^'sX~O!]1zO!^)Va~O(VTO(YUO(e6^O~O`6bO~Oj6eO&[6fO~PNXO!k6gO~P%[Oa6iO~Oa6iO~P%[Ob2bO!^6nO&j2aO~P`O!g6pO~O!g6rOh(ji!](ji!^(ji!g(ji!l(jir(ji(r(ji~O!]#hi!^#hi~P#BwO#`6sO!]#hi!^#hi~O!]!ai!^!ai~P#BwOa%nO#`6|O'z%nO~Oa%nO!g#vO#`6|O'z%nO~O!](tq!k(tqa(tq'z(tq~P!:tO!](jO!k(sq~O!S%hO!_%iO#j7TO(T%gO~O!_'`O%i7WO~On7[O!_'`O%i7WO~O#k'iaP'iaR'ia['iaa'iaj'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia'z'ia(a'ia(r'ia!k'ia!Y'ia'w'iav'ia!_'ia%i'ia!g'ia~P%-fO#k'kaP'kaR'ka['kaa'kaj'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka'z'ka(a'ka(r'ka!k'ka!Y'ka'w'kav'ka!_'ka%i'ka!g'ka~P%.XO#k$|iP$|iR$|i[$|ia$|ij$|ir$|i!S$|i!]$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i'z$|i(a$|i(r$|i!k$|i!Y$|i'w$|i#`$|iv$|i!_$|i%i$|i!g$|i~P#/sO#k%aiP%aiR%ai[%aia%aij%air%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai'z%ai(a%ai(r%ai!k%ai!Y%ai'w%aiv%ai!_%ai%i%ai!g%ai~P%5oO#k%ciP%ciR%ci[%cia%cij%cir%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci'z%ci(a%ci(r%ci!k%ci!Y%ci'w%civ%ci!_%ci%i%ci!g%ci~P%6bO!]'Ya!k'Ya~P!:tO!].tO!k(ki~O$O#ci!]#ci!^#ci~P#BwOP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(aVO[#mij#mir#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#n#mi~P%NdO#n<_O~P%NdOP$[OR#zOr<kO!Q#yO!S#{O!l#xO!p$[O#n<_O#o<`O#p<`O#q<`O(aVO[#mij#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#r#mi~P&!lO#r<aO~P&!lOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO(aVO#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#v#mi~P&$tOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO(aVO(z#}O#z#mi#{#mi$O#mi(r#mi(y#mi!]#mi!^#mi~O#x<eO~P&&uO#x#mi~P&&uO#v<cO~P&$tOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO#x<eO(aVO(y#|O(z#}O#{#mi$O#mi(r#mi!]#mi!^#mi~O#z#mi~P&)UO#z<gO~P&)UOa#|y!]#|y'z#|y'w#|y!Y#|y!k#|yv#|y!_#|y%i#|y!g#|y~P!:tO[#mij#mir#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi!]#mi!^#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n<_O#o<`O#p<`O#q<`O(aVO(y#mi(z#mi~P&,QOn>^O!Q*OO'y*PO(y$}O(z%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(a#mi~P&,QO#S$dOP(`XR(`X[(`Xj(`Xn(`Xr(`X!Q(`X!S(`X!l(`X!p(`X#R(`X#n(`X#o(`X#p(`X#q(`X#r(`X#s(`X#t(`X#u(`X#v(`X#x(`X#z(`X#{(`X$O(`X'y(`X(a(`X(r(`X(y(`X(z(`X!](`X!^(`X~O$O$Pi!]$Pi!^$Pi~P#BwO$O!ri!^!ri~P$+oOg']a!]']a~P!1WO!^7nO~O!]'da!^'da~P#BwO!Y7oO~P#/sO!g#vO(r'pO!]'ea!k'ea~O!]/pO!k)Oi~O!]/pO!g#vO!k)Oi~Og$|q!]$|q#`$|q$O$|q~P!1WO!Y'ga!]'ga~P#/sO!g7vO~O!]/yO!Y)Pi~P#/sO!]/yO!Y)Pi~O!Y7yO~Oh%VOr8OO!l%eO(r'pO~Oj8QO!g#vO~Or8TO!g#vO(r'pO~O!Q*OO'y*PO(z%POn'ja(y'ja!]'ja#`'ja~Og'ja$O'ja~P&5RO!Q*OO'y*POn'la(y'la(z'la!]'la#`'la~Og'la$O'la~P&5tOg(_q!](_q~P!1WO#`8VOg(_q!](_q~P!1WO!Y8WO~Og%Oq!]%Oq#`%Oq$O%Oq~P!1WOa$oy!]$oy'z$oy'w$oy!Y$oy!k$oyv$oy!_$oy%i$oy!g$oy~P!:tO!g6rO~O!]5[O!_)Qa~O!_'`OP$TaR$Ta[$Taj$Tar$Ta!Q$Ta!S$Ta!]$Ta!l$Ta!p$Ta#R$Ta#n$Ta#o$Ta#p$Ta#q$Ta#r$Ta#s$Ta#t$Ta#u$Ta#v$Ta#x$Ta#z$Ta#{$Ta(a$Ta(r$Ta(y$Ta(z$Ta~O%i7WO~P&8fO%^8[Oa%[i!_%[i'z%[i!]%[i~Oa#cy!]#cy'z#cy'w#cy!Y#cy!k#cyv#cy!_#cy%i#cy!g#cy~P!:tO[8^O~Ob8`O(T+qO(VTO(YUO~O!]1TO!^)Xi~O`8dO~O(e(|O!]'pX!^'pX~O!]5uO!^)Ua~O!^8nO~P%;eO(o!sO~P$&YO#[8oO~O!_1oO~O!_1oO%i8qO~On8tO!_1oO%i8qO~O[8yO!]'sa!^'sa~O!]1zO!^)Vi~O!k8}O~O!k9OO~O!k9RO~O!k9RO~P%[Oa9TO~O!g9UO~O!k9VO~O!](wi!^(wi~P#BwOa%nO#`9_O'z%nO~O!](ty!k(tya(ty'z(ty~P!:tO!](jO!k(sy~O%i9bO~P&8fO!_'`O%i9bO~O#k$|qP$|qR$|q[$|qa$|qj$|qr$|q!S$|q!]$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q'z$|q(a$|q(r$|q!k$|q!Y$|q'w$|q#`$|qv$|q!_$|q%i$|q!g$|q~P#/sO#k'jaP'jaR'ja['jaa'jaj'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja'z'ja(a'ja(r'ja!k'ja!Y'ja'w'jav'ja!_'ja%i'ja!g'ja~P&5RO#k'laP'laR'la['laa'laj'lar'la!S'la!l'la!p'la#R'la#n'la#o'la#p'la#q'la#r'la#s'la#t'la#u'la#v'la#x'la#z'la#{'la'z'la(a'la(r'la!k'la!Y'la'w'lav'la!_'la%i'la!g'la~P&5tO#k%OqP%OqR%Oq[%Oqa%Oqj%Oqr%Oq!S%Oq!]%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq'z%Oq(a%Oq(r%Oq!k%Oq!Y%Oq'w%Oq#`%Oqv%Oq!_%Oq%i%Oq!g%Oq~P#/sO!]'Yi!k'Yi~P!:tO$O#cq!]#cq!^#cq~P#BwO(y$}OP%aaR%aa[%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa$O%aa(a%aa(r%aa!]%aa!^%aa~On%aa!Q%aa'y%aa(z%aa~P&IyO(z%POP%caR%ca[%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca$O%ca(a%ca(r%ca!]%ca!^%ca~On%ca!Q%ca'y%ca(y%ca~P&LQOn>^O!Q*OO'y*PO(z%PO~P&IyOn>^O!Q*OO'y*PO(y$}O~P&LQOR0kO!Q0kO!S0lO#S$dOP}a[}aj}an}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a$O}a'y}a(a}a(r}a(y}a(z}a!]}a!^}a~O!Q*OO'y*POP$saR$sa[$saj$san$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa$O$sa(a$sa(r$sa(y$sa(z$sa!]$sa!^$sa~O!Q*OO'y*POP$uaR$ua[$uaj$uan$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua$O$ua(a$ua(r$ua(y$ua(z$ua!]$ua!^$ua~On>^O!Q*OO'y*PO(y$}O(z%PO~OP%TaR%Ta[%Taj%Tar%Ta!S%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta$O%Ta(a%Ta(r%Ta!]%Ta!^%Ta~P''VO$O$mq!]$mq!^$mq~P#BwO$O$oq!]$oq!^$oq~P#BwO!^9oO~O$O9pO~P!1WO!g#vO!]'ei!k'ei~O!g#vO(r'pO!]'ei!k'ei~O!]/pO!k)Oq~O!Y'gi!]'gi~P#/sO!]/yO!Y)Pq~Or9wO!g#vO(r'pO~O[9yO!Y9xO~P#/sO!Y9xO~Oj:PO!g#vO~Og(_y!](_y~P!1WO!]'na!_'na~P#/sOa%[q!_%[q'z%[q!]%[q~P#/sO[:UO~O!]1TO!^)Xq~O`:YO~O#`:ZO!]'pa!^'pa~O!]5uO!^)Ui~P#BwO!S:]O~O!_1oO%i:`O~O(VTO(YUO(e:eO~O!]1zO!^)Vq~O!k:hO~O!k:iO~O!k:jO~O!k:jO~P%[O#`:mO!]#hy!^#hy~O!]#hy!^#hy~P#BwO%i:rO~P&8fO!_'`O%i:rO~O$O#|y!]#|y!^#|y~P#BwOP$|iR$|i[$|ij$|ir$|i!S$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i$O$|i(a$|i(r$|i!]$|i!^$|i~P''VO!Q*OO'y*PO(z%POP'iaR'ia['iaj'ian'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia$O'ia(a'ia(r'ia(y'ia!]'ia!^'ia~O!Q*OO'y*POP'kaR'ka['kaj'kan'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka$O'ka(a'ka(r'ka(y'ka(z'ka!]'ka!^'ka~O(y$}OP%aiR%ai[%aij%ain%air%ai!Q%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai$O%ai'y%ai(a%ai(r%ai(z%ai!]%ai!^%ai~O(z%POP%ciR%ci[%cij%cin%cir%ci!Q%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci$O%ci'y%ci(a%ci(r%ci(y%ci!]%ci!^%ci~O$O$oy!]$oy!^$oy~P#BwO$O#cy!]#cy!^#cy~P#BwO!g#vO!]'eq!k'eq~O!]/pO!k)Oy~O!Y'gq!]'gq~P#/sOr:|O!g#vO(r'pO~O[;QO!Y;PO~P#/sO!Y;PO~Og(_!R!](_!R~P!1WOa%[y!_%[y'z%[y!]%[y~P#/sO!]1TO!^)Xy~O!]5uO!^)Uq~O(T;XO~O!_1oO%i;[O~O!k;_O~O%i;dO~P&8fOP$|qR$|q[$|qj$|qr$|q!S$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q$O$|q(a$|q(r$|q!]$|q!^$|q~P''VO!Q*OO'y*PO(z%POP'jaR'ja['jaj'jan'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja$O'ja(a'ja(r'ja(y'ja!]'ja!^'ja~O!Q*OO'y*POP'laR'la['laj'lan'lar'la!S'la!l'la!p'la#R'la#n'la#o'la#p'la#q'la#r'la#s'la#t'la#u'la#v'la#x'la#z'la#{'la$O'la(a'la(r'la(y'la(z'la!]'la!^'la~OP%OqR%Oq[%Oqj%Oqr%Oq!S%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq$O%Oq(a%Oq(r%Oq!]%Oq!^%Oq~P''VOg%e!Z!]%e!Z#`%e!Z$O%e!Z~P!1WO!Y;hO~P#/sOr;iO!g#vO(r'pO~O[;kO!Y;hO~P#/sO!]'pq!^'pq~P#BwO!]#h!Z!^#h!Z~P#BwO#k%e!ZP%e!ZR%e!Z[%e!Za%e!Zj%e!Zr%e!Z!S%e!Z!]%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z'z%e!Z(a%e!Z(r%e!Z!k%e!Z!Y%e!Z'w%e!Z#`%e!Zv%e!Z!_%e!Z%i%e!Z!g%e!Z~P#/sOr;tO!g#vO(r'pO~O!Y;uO~P#/sOr;|O!g#vO(r'pO~O!Y;}O~P#/sOP%e!ZR%e!Z[%e!Zj%e!Zr%e!Z!S%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z$O%e!Z(a%e!Z(r%e!Z!]%e!Z!^%e!Z~P''VOr<QO!g#vO(r'pO~Ov(fX~P1qO!Q%rO~P!)[O(U!lO~P!)[O!YfX!]fX#`fX~P%2OOP]XR]X[]Xj]Xr]X!Q]X!S]X!]]X!]fX!l]X!p]X#R]X#S]X#`]X#`fX#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X~O!gfX!k]X!kfX(rfX~P'LTOP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_XO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(T)]O(VTO(YUO(aVO(o[O~O!]<iO!^$qa~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<tO!S${O!_$|O!i>WO!l$xO#j<zO$W%`O$t<vO$v<xO$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~Ol)dO~P(!yOr!eX(r!eX~P#!iOr(jX(r(jX~P##[O!^]X!^fX~P'LTO!YfX!Y$zX!]fX!]$zX#`fX~P!0SO#k<^O~O!g#vO#k<^O~O#`<nO~Oj<bO~O#`=OO!](wX!^(wX~O#`<nO!](uX!^(uX~O#k=PO~Og=RO~P!1WO#k=XO~O#k=YO~Og=RO(T&ZO~O!g#vO#k=ZO~O!g#vO#k=PO~O$O=[O~P#BwO#k=]O~O#k=^O~O#k=cO~O#k=dO~O#k=eO~O#k=fO~O$O=gO~P!1WO$O=hO~P!1WOl=sO~P7eOk#S#T#U#W#X#[#i#j#u$n$t$v$y%]%^%h%i%j%q%s%v%w%y%{~(OT#o!X'|(U#ps#n#qr!Q'}$]'}(T$_(e~",
    goto: "$9Y)]PPPPPP)^PP)aP)rP+W/]PPPP6mPP7TPP=QPPP@tPA^PA^PPPA^PCfPA^PA^PA^PCjPCoPD^PIWPPPI[PPPPI[L_PPPLeMVPI[PI[PP! eI[PPPI[PI[P!#lI[P!'S!(X!(bP!)U!)Y!)U!,gPPPPPPP!-W!(XPP!-h!/YP!2iI[I[!2n!5z!:h!:h!>gPPP!>oI[PPPPPPPPP!BOP!C]PPI[!DnPI[PI[I[I[I[I[PI[!FQP!I[P!LbP!Lf!Lp!Lt!LtP!IXP!Lx!LxP#!OP#!SI[PI[#!Y#%_CjA^PA^PA^A^P#&lA^A^#)OA^#+vA^#.SA^A^#.r#1W#1W#1]#1f#1W#1qPP#1WPA^#2ZA^#6YA^A^6mPPP#:_PPP#:x#:xP#:xP#;`#:xPP#;fP#;]P#;]#;y#;]#<e#<k#<n)aP#<q)aP#<z#<z#<zP)aP)aP)aP)aPP)aP#=Q#=TP#=T)aP#=XP#=[P)aP)aP)aP)aP)aP)a)aPP#=b#=h#=s#=y#>P#>V#>]#>k#>q#>{#?R#?]#?c#?s#?y#@k#@}#AT#AZ#Ai#BO#Cs#DR#DY#Et#FS#Gt#HS#HY#H`#Hf#Hp#Hv#H|#IW#Ij#IpPPPPPPPPPPP#IvPPPPPPP#Jk#Mx$ b$ i$ qPPP$']P$'f$*_$0x$0{$1O$1}$2Q$2X$2aP$2g$2jP$3W$3[$4S$5b$5g$5}PP$6S$6Y$6^$6a$6e$6i$7e$7|$8e$8i$8l$8o$8y$8|$9Q$9UR!|RoqOXst!Z#d%m&r&t&u&w,s,x2[2_Y!vQ'`-e1o5{Q%tvQ%|yQ&T|Q&j!VS'W!e-]Q'f!iS'l!r!yU*k$|*Z*oQ+o%}S+|&V&WQ,d&dQ-c'_Q-m'gQ-u'mQ0[*qQ1b,OQ1y,eR<{<Y%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+],p,s,x-i-q.P.V.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3l4z6T6e6f6i6|8t9T9_S#q]<V!r)_$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SU+P%]<s<tQ+t&PQ,f&gQ,m&oQ0x+gQ0}+iQ1Y+uQ2R,kQ3`.gQ5`0|Q5f1TQ6[1zQ7Y3dQ8`5gR9e7['QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S!S!nQ!r!v!y!z$|'W'_'`'l'm'n*k*o*q*r-]-c-e-u0[0_1o5{5}%[$ti#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^Q&X|Q'U!eS'[%i-`Q+t&PQ,P&WQ,f&gQ0n+SQ1Y+uQ1_+{Q2Q,jQ2R,kQ5f1TQ5o1aQ6[1zQ6_1|Q6`2PQ8`5gQ8c5lQ8|6bQ:X8dQ:f8yQ;V:YR<}*ZrnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_R,h&k&z^OPXYstuvwz!Z!`!g!j!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'b'r(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>R>S[#]WZ#W#Z'X(T!b%jm#h#i#l$x%e%h(^(h(i(j*Y*^*b+Z+[+^,o-V.T.Z.[.]._/m/p2d3[3]4a6r7TQ%wxQ%{yW&Q|&V&W,OQ&_!TQ'c!hQ'e!iQ(q#sS+n%|%}Q+r&PQ,_&bQ,c&dS-l'f'gQ.i(rQ1R+oQ1X+uQ1Z+vQ1^+zQ1t,`S1x,d,eQ2|-mQ5e1TQ5i1WQ5n1`Q6Z1yQ8_5gQ8b5kQ8f5pQ:T8^R;T:U!U$zi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y!^%yy!i!u%{%|%}'V'e'f'g'k'u*j+n+o-Y-l-m-t0R0U1R2u2|3T4r4s4v7}9{Q+h%wQ,T&[Q,W&]Q,b&dQ.h(qQ1s,_U1w,c,d,eQ3e.iQ6U1tS6Y1x1yQ8x6Z#f>T#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^o>U<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hW%Ti%V*y>PS&[!Q&iQ&]!RQ&^!SU*}%[%d=sR,R&Y%]%Si#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^T)z$u){V+P%]<s<tW'[!e%i*Z-`S(}#y#zQ+c%rQ+y&SS.b(m(nQ1j,XQ5T0kR8i5u'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S$i$^c#Y#e%q%s%u(S(Y(t(y)R)S)T)U)V)W)X)Y)Z)[)^)`)b)g)q+d+x-Z-x-}.S.U.s.v.z.|.}/O/b0p2k2n3O3V3k3p3q3r3s3t3u3v3w3x3y3z3{3|4P4Q4X5X5c6u6{7Q7a7b7k7l8k9X9]9g9m9n:o;W;`<W=vT#TV#U'RkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ'Y!eR2q-]!W!nQ!e!r!v!y!z$|'W'_'`'l'm'n*Z*k*o*q*r-]-c-e-u0[0_1o5{5}R1l,ZnqOXst!Z#d%m&r&t&u&w,s,x2[2_Q&y!^Q'v!xS(s#u<^Q+l%zQ,]&_Q,^&aQ-j'dQ-w'oS.r(x=PS0q+X=ZQ1P+mQ1n,[Q2c,zQ2e,{Q2m-WQ2z-kQ2}-oS5Y0r=eQ5a1QS5d1S=fQ6t2oQ6x2{Q6}3SQ8]5bQ9Y6vQ9Z6yQ9^7OR:l9V$d$]c#Y#e%s%u(S(Y(t(y)R)S)T)U)V)W)X)Y)Z)[)^)`)b)g)q+d+x-Z-x-}.S.U.s.v.z.}/O/b0p2k2n3O3V3k3p3q3r3s3t3u3v3w3x3y3z3{3|4P4Q4X5X5c6u6{7Q7a7b7k7l8k9X9]9g9m9n:o;W;`<W=vS(o#p'iQ)P#zS+b%q.|S.c(n(pR3^.d'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SS#q]<VQ&t!XQ&u!YQ&w![Q&x!]R2Z,vQ'a!hQ+e%wQ-h'cS.e(q+hQ2x-gW3b.h.i0w0yQ6w2yW7U3_3a3e5^U9a7V7X7ZU:q9c9d9fS;b:p:sQ;p;cR;x;qU!wQ'`-eT5y1o5{!Q_OXZ`st!V!Z#d#h%e%m&i&k&r&t&u&w(j,s,x.[2[2_]!pQ!r'`-e1o5{T#q]<V%^{OPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_S(}#y#zS.b(m(n!s=l$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SU$fd)_,mS(p#p'iU*v%R(w4OU0m+O.n7gQ5^0xQ7V3`Q9d7YR:s9em!tQ!r!v!y!z'`'l'm'n-e-u1o5{5}Q't!uS(f#g2US-s'k'wQ/s*]Q0R*jQ3U-vQ4f/tQ4r0TQ4s0UQ4x0^Q7r4`S7}4t4vS8R4y4{Q9r7sQ9v7yQ9{8OQ:Q8TS:{9w9xS;g:|;PS;s;h;iS;{;t;uS<P;|;}R<S<QQ#wbQ's!uS(e#g2US(g#m+WQ+Y%fQ+j%xQ+p&OU-r'k't'wQ.W(fU/r*]*`/wQ0S*jQ0V*lQ1O+kQ1u,aS3R-s-vQ3Z.`S4e/s/tQ4n0PS4q0R0^Q4u0WQ6W1vQ7P3US7q4`4bQ7u4fU7|4r4x4{Q8P4wQ8v6XS9q7r7sQ9u7yQ9}8RQ:O8SQ:c8wQ:y9rS:z9v9xQ;S:QQ;^:dS;f:{;PS;r;g;hS;z;s;uS<O;{;}Q<R<PQ<T<SQ=o=jQ={=tR=|=uV!wQ'`-e%^aOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_S#wz!j!r=i$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SR=o>R%^bOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_Q%fj!^%xy!i!u%{%|%}'V'e'f'g'k'u*j+n+o-Y-l-m-t0R0U1R2u2|3T4r4s4v7}9{S&Oz!jQ+k%yQ,a&dW1v,b,c,d,eU6X1w1x1yS8w6Y6ZQ:d8x!r=j$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ=t>QR=u>R%QeOPXYstuvw!Z!`!g!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_Y#bWZ#W#Z(T!b%jm#h#i#l$x%e%h(^(h(i(j*Y*^*b+Z+[+^,o-V.T.Z.[.]._/m/p2d3[3]4a6r7TQ,n&o!p=k$Z$n)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SR=n'XU']!e%i*ZR2s-`%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+],p,s,x-i-q.P.V.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3l4z6T6e6f6i6|8t9T9_!r)_$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ,m&oQ0x+gQ3`.gQ7Y3dR9e7[!b$Tc#Y%q(S(Y(t(y)Z)[)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<W!P<d)^)q-Z.|2k2n3p3y3z4P4X6u7b7k7l8k9X9g9m9n;W;`=v!f$Vc#Y%q(S(Y(t(y)W)X)Z)[)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<W!T<f)^)q-Z.|2k2n3p3v3w3y3z4P4X6u7b7k7l8k9X9g9m9n;W;`=v!^$Zc#Y%q(S(Y(t(y)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<WQ4_/kz>S)^)q-Z.|2k2n3p4P4X6u7b7k7l8k9X9g9m9n;W;`=vQ>X>ZR>Y>['QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SS$oh$pR4U/U'XgOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/U/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>ST$kf$qQ$ifS)j$l)nR)v$qT$jf$qT)l$l)n'XhOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/U/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>ST$oh$pQ$rhR)u$p%^jOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_!s>Q$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S#glOPXZst!Z!`!o#S#d#o#{$n%m&k&n&o&r&t&u&w&{'T'b)O)s*i+]+g,p,s,x-i.g/V/n0]0l1r2S2T2V2X2[2_2a3d4T4z6T6e6f6i7[8t9T!U%Ri$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y#f(w#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^Q+T%aQ/c*Oo4O<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!U$yi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>YQ*c$zU*l$|*Z*oQ+U%bQ0W*m#f=q#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n=r<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hQ=w>TQ=x>UQ=y>VR=z>W!U%Ri$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y#f(w#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^o4O<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hnoOXst!Z#d%m&r&t&u&w,s,x2[2_S*f${*YQ-R'OQ-S'QR4i/y%[%Si#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^Q,U&]Q1h,WQ5s1gR8h5tV*n$|*Z*oU*n$|*Z*oT5z1o5{S0P*i/nQ4w0]T8S4z:]Q+j%xQ0V*lQ1O+kQ1u,aQ6W1vQ8v6XQ:c8wR;^:d!U%Oi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Yx*R$v)e*S*u+V/v0d0e4R4g5R5S5W7p8U:R:x=p=}>OS0`*t0a#f<o#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n<p<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!d=S(u)c*[*e.j.m.q/_/k/|0v1e3h4[4h4l5r7]7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[`=T3}7c7f7j9h:t:w;yS=_.l3iT=`7e9k!U%Qi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y|*T$v)e*U*t+V/g/v0d0e4R4g4|5R5S5W7p8U:R:x=p=}>OS0b*u0c#f<q#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n<r<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!h=U(u)c*[*e.k.l.q/_/k/|0v1e3f3h4[4h4l5r7]7^7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[d=V3}7d7e7j9h9i:t:u:w;yS=a.m3jT=b7f9lrnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_Q&f!UR,p&ornOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_R&f!UQ,Y&^R1d,RsnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_Q1p,_S6R1s1tU8p6P6Q6US:_8r8sS;Y:^:aQ;m;ZR;w;nQ&m!VR,i&iR6_1|R:f8yW&Q|&V&W,OR1Z+vQ&r!WR,s&sR,y&xT2],x2_R,}&yQ,|&yR2f,}Q'y!{R-y'ySsOtQ#dXT%ps#dQ#OTR'{#OQ#RUR'}#RQ){$uR/`){Q#UVR(Q#UQ#XWU(W#X(X.QQ(X#YR.Q(YQ-^'YR2r-^Q.u(yS3m.u3nR3n.vQ-e'`R2v-eY!rQ'`-e1o5{R'j!rQ/Q)eR4S/QU#_W%h*YU(_#_(`.RQ(`#`R.R(ZQ-a']R2t-at`OXst!V!Z#d%m&i&k&r&t&u&w,s,x2[2_S#hZ%eU#r`#h.[R.[(jQ(k#jQ.X(gW.a(k.X3X7RQ3X.YR7R3YQ)n$lR/W)nQ$phR)t$pQ$`cU)a$`-|<jQ-|<WR<j)qQ/q*]W4c/q4d7t9sU4d/r/s/tS7t4e4fR9s7u$e*Q$v(u)c)e*[*e*t*u+Q+R+V.l.m.o.p.q/_/g/i/k/v/|0d0e0v1e3f3g3h3}4R4[4g4h4l4|5O5R5S5W5r7]7^7_7`7e7f7h7i7j7p7w7z8U8X8Z9h9i9j9t9|:R:S:t:u:v:w:x:};R;e;j;v;y=p=}>O>Z>[Q/z*eU4k/z4m7xQ4m/|R7x4lS*o$|*ZR0Y*ox*S$v)e*t*u+V/v0d0e4R4g5R5S5W7p8U:R:x=p=}>O!d.j(u)c*[*e.l.m.q/_/k/|0v1e3h4[4h4l5r7]7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[U/h*S.j7ca7c3}7e7f7j9h:t:w;yQ0a*tQ3i.lU4}0a3i9kR9k7e|*U$v)e*t*u+V/g/v0d0e4R4g4|5R5S5W7p8U:R:x=p=}>O!h.k(u)c*[*e.l.m.q/_/k/|0v1e3f3h4[4h4l5r7]7^7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[U/j*U.k7de7d3}7e7f7j9h9i:t:u:w;yQ0c*uQ3j.mU5P0c3j9lR9l7fQ*z%UR0g*zQ5]0vR8Y5]Q+_%kR0u+_Q5v1jS8j5v:[R:[8kQ,[&_R1m,[Q5{1oR8m5{Q1{,fS6]1{8zR8z6_Q1U+rW5h1U5j8a:VQ5j1XQ8a5iR:V8bQ+w&QR1[+wQ2_,xR6m2_YrOXst#dQ&v!ZQ+a%mQ,r&rQ,t&tQ,u&uQ,w&wQ2Y,sS2],x2_R6l2[Q%opQ&z!_Q&}!aQ'P!bQ'R!cQ'q!uQ+`%lQ+l%zQ,Q&XQ,h&mQ-P&|W-p'k's't'wQ-w'oQ0X*nQ1P+mQ1c,PS2O,i,lQ2g-OQ2h-RQ2i-SQ2}-oW3P-r-s-v-xQ5a1QQ5m1_Q5q1eQ6V1uQ6a2QQ6k2ZU6z3O3R3UQ6}3SQ8]5bQ8e5oQ8g5rQ8l5zQ8u6WQ8{6`S9[6{7PQ9^7OQ:W8cQ:b8vQ:g8|Q:n9]Q;U:XQ;]:cQ;a:oQ;l;VR;o;^Q%zyQ'd!iQ'o!uU+m%{%|%}Q-W'VU-k'e'f'gS-o'k'uQ0Q*jS1Q+n+oQ2o-YS2{-l-mQ3S-tS4p0R0UQ5b1RQ6v2uQ6y2|Q7O3TU7{4r4s4vQ9z7}R;O9{S$wi>PR*{%VU%Ui%V>PR0f*yQ$viS(u#v+iS)c$b$cQ)e$dQ*[$xS*e${*YQ*t%OQ*u%QQ+Q%^Q+R%_Q+V%cQ.l<oQ.m<qQ.o<uQ.p<wQ.q<yQ/_)yQ/g*RQ/i*TQ/k*VQ/v*aS/|*g/mQ0d*wQ0e*xl0v+f,V.f1i1q3c6S7W8q9b:`:r;[;dQ1e,SQ3f=SQ3g=UQ3h=XS3}<l<mQ4R/PS4[/d4^Q4g/xQ4h/yQ4l/{Q4|0`Q5O0bQ5R0iQ5S0jQ5W0oQ5r1fQ7]=]Q7^=_Q7_=aQ7`=cQ7e<pQ7f<rQ7h<vQ7i<xQ7j<zQ7p4_Q7w4jQ7z4oQ8U5QQ8X5[Q8Z5_Q9h=YQ9i=TQ9j=VQ9t7vQ9|8QQ:R8VQ:S8[Q:t=^Q:u=`Q:v=bQ:w=dQ:x9pQ:}9yQ;R:PQ;e=gQ;j;QQ;v;kQ;y=hQ=p>PQ=}>XQ>O>YQ>Z>]R>[>^Q+O%]Q.n<sR7g<tnpOXst!Z#d%m&r&t&u&w,s,x2[2_Q!fPS#fZ#oQ&|!`W'h!o*i0]4zQ(P#SQ)Q#{Q)r$nS,l&k&nQ,q&oQ-O&{S-T'T/nQ-g'bQ.x)OQ/[)sQ0s+]Q0y+gQ2W,pQ2y-iQ3a.gQ4W/VQ5U0lQ6Q1rQ6c2SQ6d2TQ6h2VQ6j2XQ6o2aQ7Z3dQ7m4TQ8s6TQ9P6eQ9Q6fQ9S6iQ9f7[Q:a8tR:k9T#[cOPXZst!Z!`!o#d#o#{%m&k&n&o&r&t&u&w&{'T'b)O*i+]+g,p,s,x-i.g/n0]0l1r2S2T2V2X2[2_2a3d4z6T6e6f6i7[8t9TQ#YWQ#eYQ%quQ%svS%uw!gS(S#W(VQ(Y#ZQ(t#uQ(y#xQ)R$OQ)S$PQ)T$QQ)U$RQ)V$SQ)W$TQ)X$UQ)Y$VQ)Z$WQ)[$XQ)^$ZQ)`$_Q)b$aQ)g$eW)q$n)s/V4TQ+d%tQ+x&RS-Z'X2pQ-x'rS-}(T.PQ.S(]Q.U(dQ.s(xQ.v(zQ.z<UQ.|<XQ.}<YQ/O<]Q/b)}Q0p+XQ2k-UQ2n-XQ3O-qQ3V.VQ3k.tQ3p<^Q3q<_Q3r<`Q3s<aQ3t<bQ3u<cQ3v<dQ3w<eQ3x<fQ3y<gQ3z<hQ3{.{Q3|<kQ4P<nQ4Q<{Q4X<iQ5X0rQ5c1SQ6u=OQ6{3QQ7Q3WQ7a3lQ7b=PQ7k=RQ7l=ZQ8k5wQ9X6sQ9]6|Q9g=[Q9m=eQ9n=fQ:o9_Q;W:ZQ;`:mQ<W#SR=v>SR#[WR'Z!el!tQ!r!v!y!z'`'l'm'n-e-u1o5{5}S'V!e-]U*j$|*Z*oS-Y'W'_S0U*k*qQ0^*rQ2u-cQ4v0[R4{0_R({#xQ!fQT-d'`-e]!qQ!r'`-e1o5{Q#p]R'i<VR)f$dY!uQ'`-e1o5{Q'k!rS'u!v!yS'w!z5}S-t'l'mQ-v'nR3T-uT#kZ%eS#jZ%eS%km,oU(g#h#i#lS.Y(h(iQ.^(jQ0t+^Q3Y.ZU3Z.[.]._S7S3[3]R9`7Td#^W#W#Z%h(T(^*Y+Z.T/mr#gZm#h#i#l%e(h(i(j+^.Z.[.]._3[3]7TS*]$x*bQ/t*^Q2U,oQ2l-VQ4`/pQ6q2dQ7s4aQ9W6rT=m'X+[V#aW%h*YU#`W%h*YS(U#W(^U(Z#Z+Z/mS-['X+[T.O(T.TV'^!e%i*ZQ$lfR)x$qT)m$l)nR4V/UT*_$x*bT*h${*YQ0w+fQ1g,VQ3_.fQ5t1iQ6P1qQ7X3cQ8r6SQ9c7WQ:^8qQ:p9bQ;Z:`Q;c:rQ;n;[R;q;dnqOXst!Z#d%m&r&t&u&w,s,x2[2_Q&l!VR,h&itmOXst!U!V!Z#d%m&i&r&t&u&w,s,x2[2_R,o&oT%lm,oR1k,XR,g&gQ&U|S+}&V&WR1^,OR+s&PT&p!W&sT&q!W&sT2^,x2_",
    nodeNames: "\u26A0 ArithOp ArithOp ?. JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList in out const TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewTarget new NewExpression ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression TypeArgList CompareOp < declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression InstantiationExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast < ArrowFunction TypeParamList SequenceExpression InstantiationExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate asserts is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration defer ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
    maxTerm: 380,
    context: $44c7044f9afa5475$var$trackNewline,
    nodeProps: [
        [
            "isolate",
            -8,
            5,
            6,
            14,
            37,
            39,
            51,
            53,
            55,
            ""
        ],
        [
            "group",
            -26,
            9,
            17,
            19,
            68,
            207,
            211,
            215,
            216,
            218,
            221,
            224,
            234,
            237,
            243,
            245,
            247,
            249,
            252,
            258,
            264,
            266,
            268,
            270,
            272,
            274,
            275,
            "Statement",
            -34,
            13,
            14,
            32,
            35,
            36,
            42,
            51,
            54,
            55,
            57,
            62,
            70,
            72,
            76,
            80,
            82,
            84,
            85,
            110,
            111,
            120,
            121,
            136,
            139,
            141,
            142,
            143,
            144,
            145,
            147,
            148,
            167,
            169,
            171,
            "Expression",
            -23,
            31,
            33,
            37,
            41,
            43,
            45,
            173,
            175,
            177,
            178,
            180,
            181,
            182,
            184,
            185,
            186,
            188,
            189,
            190,
            201,
            203,
            205,
            206,
            "Type",
            -3,
            88,
            103,
            109,
            "ClassItem"
        ],
        [
            "openedBy",
            23,
            "<",
            38,
            "InterpolationStart",
            56,
            "[",
            60,
            "{",
            73,
            "(",
            160,
            "JSXStartCloseTag"
        ],
        [
            "closedBy",
            -2,
            24,
            168,
            ">",
            40,
            "InterpolationEnd",
            50,
            "]",
            61,
            "}",
            74,
            ")",
            165,
            "JSXEndTag"
        ]
    ],
    propSources: [
        $44c7044f9afa5475$var$jsHighlight
    ],
    skippedNodes: [
        0,
        5,
        6,
        278
    ],
    repeatNodeCount: 37,
    tokenData: "$Fq07[R!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#:O!R![#<_![!]#I_!]!^#Jk!^!_#Ku!_!`$![!`!a$$v!a!b$*T!b!c$,r!c!}Er!}#O$-|#O#P$/W#P#Q$4o#Q#R$5y#R#SEr#S#T$7W#T#o$8b#o#p$<r#p#q$=h#q#r$>x#r#s$@U#s$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$I|Er$I|$I}$Dk$I}$JO$Dk$JO$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr(n%d_$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$i&j(Z!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(Z!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$i&j(WpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(WpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z07[+rq$i&j(Wp(Z!b'|0/lOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z07[.ST(X#S$i&j'}0/lO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c07[.n_$i&j(Wp(Z!b'}0/lOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)3p/x`$i&j!p),Q(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW1V`#v(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW2d_#v(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At3l_(V':f$i&j(Z!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$i&j(Z!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$i&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$d`$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$d``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$d`$i&j(Z!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(Z!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$d`(Z!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k%9[:hh$i&j(Wp(Z!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__WS$i&j(Wp(Z!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]WS$i&j(Z!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXWS$i&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSWSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWWS(Z!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]WS$i&j(WpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWWS(WpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYWS(Wp(Z!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S%9[C}i$i&j(o%1l(Wp(Z!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr%9[EoP;=`<%lCr07[FRk$i&j(Wp(Z!b$]#t(T,2j(e$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$i&j(Wp(Z!b$]#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv07[JPP;=`<%lEr(KWJ_`$i&j(Wp(Z!b#p(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWKl_$i&j$Q(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,#xLva(z+JY$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWNW`$i&j#z(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At! c_(Y';W$i&j(WpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$i&j(WpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$i&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$d`$i&j(WpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(WpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$d`(WpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b/5|!'t_!l/.^$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&U!)O_!k!Lf$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z-!n!*[b$i&j(Wp(Z!b(U%&f#q(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW!+o`$i&j(Wp(Z!b#n(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;x!,|`$i&j(Wp(Z!br+4YOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,$U!.Z_!]+Jf$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!/ec$i&j(Wp(Z!b!Q.2^OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!0ya$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!2Z_![!L^$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!3eg$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!5Vg$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!6wc$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!8_c$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!9uf$i&j(Wp(Z!b#o(ChOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcxz!;Zz{#-}{!P!;Z!P!Q#/d!Q!^!;Z!^!_#(i!_!`#7S!`!a#8i!a!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z?O!;fb$i&j(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z>^!<w`$i&j(Z!b!X7`OY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eq!Q!^!<n!^!_!Gr!_!}!<n!}#O!KS#O#P!Dy#P#o!<n#o#p!Gr#p;'S!<n;'S;=`!L]<%lO!<n<z!>Q^$i&j!X7`OY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@c!_!}!=y!}#O!CW#O#P!Dy#P#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!?Td$i&j!X7`O!^&c!_#W&c#W#X!>|#X#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#k!>|#k#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&c7`!@hX!X7`OY!@cZ!P!@c!P!Q!AT!Q!}!@c!}#O!Ar#O#P!Bq#P;'S!@c;'S;=`!CQ<%lO!@c7`!AYW!X7`#W#X!AT#Z#[!AT#]#^!AT#a#b!AT#g#h!AT#i#j!AT#j#k!AT#m#n!AT7`!AuVOY!ArZ#O!Ar#O#P!B[#P#Q!@c#Q;'S!Ar;'S;=`!Bk<%lO!Ar7`!B_SOY!ArZ;'S!Ar;'S;=`!Bk<%lO!Ar7`!BnP;=`<%l!Ar7`!BtSOY!@cZ;'S!@c;'S;=`!CQ<%lO!@c7`!CTP;=`<%l!@c<z!C][$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#O!CW#O#P!DR#P#Q!=y#Q#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DWX$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DvP;=`<%l!CW<z!EOX$i&jOY!=yYZ&cZ!^!=y!^!_!@c!_#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!EnP;=`<%l!=y>^!Ezl$i&j(Z!b!X7`OY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#W&}#W#X!Eq#X#Z&}#Z#[!Eq#[#]&}#]#^!Eq#^#a&}#a#b!Eq#b#g&}#g#h!Eq#h#i&}#i#j!Eq#j#k!Eq#k#m&}#m#n!Eq#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}8r!GyZ(Z!b!X7`OY!GrZw!Grwx!@cx!P!Gr!P!Q!Hl!Q!}!Gr!}#O!JU#O#P!Bq#P;'S!Gr;'S;=`!J|<%lO!Gr8r!Hse(Z!b!X7`OY'}Zw'}x#O'}#P#W'}#W#X!Hl#X#Z'}#Z#[!Hl#[#]'}#]#^!Hl#^#a'}#a#b!Hl#b#g'}#g#h!Hl#h#i'}#i#j!Hl#j#k!Hl#k#m'}#m#n!Hl#n;'S'};'S;=`(f<%lO'}8r!JZX(Z!bOY!JUZw!JUwx!Arx#O!JU#O#P!B[#P#Q!Gr#Q;'S!JU;'S;=`!Jv<%lO!JU8r!JyP;=`<%l!JU8r!KPP;=`<%l!Gr>^!KZ^$i&j(Z!bOY!KSYZ&cZw!KSwx!CWx!^!KS!^!_!JU!_#O!KS#O#P!DR#P#Q!<n#Q#o!KS#o#p!JU#p;'S!KS;'S;=`!LV<%lO!KS>^!LYP;=`<%l!KS>^!L`P;=`<%l!<n=l!Ll`$i&j(Wp!X7`OY!LcYZ&cZr!Lcrs!=ys!P!Lc!P!Q!Mn!Q!^!Lc!^!_# o!_!}!Lc!}#O#%P#O#P!Dy#P#o!Lc#o#p# o#p;'S!Lc;'S;=`#&Y<%lO!Lc=l!Mwl$i&j(Wp!X7`OY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#W(r#W#X!Mn#X#Z(r#Z#[!Mn#[#](r#]#^!Mn#^#a(r#a#b!Mn#b#g(r#g#h!Mn#h#i(r#i#j!Mn#j#k!Mn#k#m(r#m#n!Mn#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r8Q# vZ(Wp!X7`OY# oZr# ors!@cs!P# o!P!Q#!i!Q!}# o!}#O#$R#O#P!Bq#P;'S# o;'S;=`#$y<%lO# o8Q#!pe(Wp!X7`OY)rZr)rs#O)r#P#W)r#W#X#!i#X#Z)r#Z#[#!i#[#])r#]#^#!i#^#a)r#a#b#!i#b#g)r#g#h#!i#h#i)r#i#j#!i#j#k#!i#k#m)r#m#n#!i#n;'S)r;'S;=`*Z<%lO)r8Q#$WX(WpOY#$RZr#$Rrs!Ars#O#$R#O#P!B[#P#Q# o#Q;'S#$R;'S;=`#$s<%lO#$R8Q#$vP;=`<%l#$R8Q#$|P;=`<%l# o=l#%W^$i&j(WpOY#%PYZ&cZr#%Prs!CWs!^#%P!^!_#$R!_#O#%P#O#P!DR#P#Q!Lc#Q#o#%P#o#p#$R#p;'S#%P;'S;=`#&S<%lO#%P=l#&VP;=`<%l#%P=l#&]P;=`<%l!Lc?O#&kn$i&j(Wp(Z!b!X7`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#W%Z#W#X#&`#X#Z%Z#Z#[#&`#[#]%Z#]#^#&`#^#a%Z#a#b#&`#b#g%Z#g#h#&`#h#i%Z#i#j#&`#j#k#&`#k#m%Z#m#n#&`#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z9d#(r](Wp(Z!b!X7`OY#(iZr#(irs!Grsw#(iwx# ox!P#(i!P!Q#)k!Q!}#(i!}#O#+`#O#P!Bq#P;'S#(i;'S;=`#,`<%lO#(i9d#)th(Wp(Z!b!X7`OY*gZr*grs'}sw*gwx)rx#O*g#P#W*g#W#X#)k#X#Z*g#Z#[#)k#[#]*g#]#^#)k#^#a*g#a#b#)k#b#g*g#g#h#)k#h#i*g#i#j#)k#j#k#)k#k#m*g#m#n#)k#n;'S*g;'S;=`+Z<%lO*g9d#+gZ(Wp(Z!bOY#+`Zr#+`rs!JUsw#+`wx#$Rx#O#+`#O#P!B[#P#Q#(i#Q;'S#+`;'S;=`#,Y<%lO#+`9d#,]P;=`<%l#+`9d#,cP;=`<%l#(i?O#,o`$i&j(Wp(Z!bOY#,fYZ&cZr#,frs!KSsw#,fwx#%Px!^#,f!^!_#+`!_#O#,f#O#P!DR#P#Q!;Z#Q#o#,f#o#p#+`#p;'S#,f;'S;=`#-q<%lO#,f?O#-tP;=`<%l#,f?O#-zP;=`<%l!;Z07[#.[b$i&j(Wp(Z!b(O0/l!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z07[#/o_$i&j(Wp(Z!bT0/lOY#/dYZ&cZr#/drs#0nsw#/dwx#4Ox!^#/d!^!_#5}!_#O#/d#O#P#1p#P#o#/d#o#p#5}#p;'S#/d;'S;=`#6|<%lO#/d06j#0w]$i&j(Z!bT0/lOY#0nYZ&cZw#0nwx#1px!^#0n!^!_#3R!_#O#0n#O#P#1p#P#o#0n#o#p#3R#p;'S#0n;'S;=`#3x<%lO#0n05W#1wX$i&jT0/lOY#1pYZ&cZ!^#1p!^!_#2d!_#o#1p#o#p#2d#p;'S#1p;'S;=`#2{<%lO#1p0/l#2iST0/lOY#2dZ;'S#2d;'S;=`#2u<%lO#2d0/l#2xP;=`<%l#2d05W#3OP;=`<%l#1p01O#3YW(Z!bT0/lOY#3RZw#3Rwx#2dx#O#3R#O#P#2d#P;'S#3R;'S;=`#3r<%lO#3R01O#3uP;=`<%l#3R06j#3{P;=`<%l#0n05x#4X]$i&j(WpT0/lOY#4OYZ&cZr#4Ors#1ps!^#4O!^!_#5Q!_#O#4O#O#P#1p#P#o#4O#o#p#5Q#p;'S#4O;'S;=`#5w<%lO#4O00^#5XW(WpT0/lOY#5QZr#5Qrs#2ds#O#5Q#O#P#2d#P;'S#5Q;'S;=`#5q<%lO#5Q00^#5tP;=`<%l#5Q05x#5zP;=`<%l#4O01p#6WY(Wp(Z!bT0/lOY#5}Zr#5}rs#3Rsw#5}wx#5Qx#O#5}#O#P#2d#P;'S#5};'S;=`#6v<%lO#5}01p#6yP;=`<%l#5}07[#7PP;=`<%l#/d)3h#7ab$i&j$Q(Ch(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;ZAt#8vb$Z#t$i&j(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z'Ad#:Zp$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#U%Z#U#V#?i#V#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#d#Bq#d#l%Z#l#m#Es#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#<jk$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#>j_$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#?rd$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#A]f$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Bzc$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Dbe$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#E|g$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Gpi$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x#Il_!g$b$i&j$O)Lv(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Jv_al$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f#LS^h#)`#R-<U(Wp(Z!b$n7`OY*gZr*grs'}sw*gwx)rx!P*g!P!Q#MO!Q!^*g!^!_#Mt!_!`$ f!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#MXX$k&j(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El#M}Z#r(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Np!`#O*g#P;'S*g;'S;=`+Z<%lO*g(El#NyX$Q(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El$ oX#s(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g*)x$!ga#`*!Y$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$#l!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(K[$#w_#k(Cl$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x$%Vag!*r#s(Ch$f#|$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$&[!`!a$'f!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$&g_#s(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$'qa#r(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$(v!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$)R`#r(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(Kd$*`a(r(Ct$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!a%Z!a!b$+e!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$+p`$i&j#{(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`$,}_!|$Ip$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f$.X_!S0,v$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/]Z$i&jO!^$0O!^!_$0f!_#i$0O#i#j$0k#j#l$0O#l#m$2^#m#o$0O#o#p$0f#p;'S$0O;'S;=`$4i<%lO$0O(n$0VT_#S$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0kO_#S(n$0p[$i&jO!Q&c!Q![$1f![!^&c!_!c&c!c!i$1f!i#T&c#T#Z$1f#Z#o&c#o#p$3|#p;'S&c;'S;=`&w<%lO&c(n$1kZ$i&jO!Q&c!Q![$2^![!^&c!_!c&c!c!i$2^!i#T&c#T#Z$2^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2cZ$i&jO!Q&c!Q![$3U![!^&c!_!c&c!c!i$3U!i#T&c#T#Z$3U#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3ZZ$i&jO!Q&c!Q![$0O![!^&c!_!c&c!c!i$0O!i#T&c#T#Z$0O#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$4PR!Q![$4Y!c!i$4Y#T#Z$4Y#S$4]S!Q![$4Y!c!i$4Y#T#Z$4Y#q#r$0f(n$4lP;=`<%l$0O#1[$4z_!Y#)l$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$6U`#x(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;p$7c_$i&j(Wp(Z!b(a+4QOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$8qk$i&j(Wp(Z!b(T,2j$_#t(e$I[OY%ZYZ&cZr%Zrs&}st%Ztu$8buw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$8b![!^%Z!^!_*g!_!c%Z!c!}$8b!}#O%Z#O#P&c#P#R%Z#R#S$8b#S#T%Z#T#o$8b#o#p*g#p$g%Z$g;'S$8b;'S;=`$<l<%lO$8b+d$:qk$i&j(Wp(Z!b$_#tOY%ZYZ&cZr%Zrs&}st%Ztu$:fuw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$:f![!^%Z!^!_*g!_!c%Z!c!}$:f!}#O%Z#O#P&c#P#R%Z#R#S$:f#S#T%Z#T#o$:f#o#p*g#p$g%Z$g;'S$:f;'S;=`$<f<%lO$:f+d$<iP;=`<%l$:f07[$<oP;=`<%l$8b#Jf$<{X!_#Hb(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g,#x$=sa(y+JY$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+e#q;'S%Z;'S;=`+a<%lO%Z)>v$?V_!^(CdvBr$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z?O$@a_!q7`$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$Aq|$i&j(Wp(Z!b'|0/l$]#t(T,2j(e$I[OX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr07[$D|k$i&j(Wp(Z!b'}0/l$]#t(T,2j(e$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
    tokenizers: [
        $44c7044f9afa5475$var$noSemicolon,
        $44c7044f9afa5475$var$noSemicolonType,
        $44c7044f9afa5475$var$operatorToken,
        $44c7044f9afa5475$var$jsx,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        $44c7044f9afa5475$var$insertSemicolon,
        new (0, $96e8fc72168067c5$export$dbe55ed82366d5e9)("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOx~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!U~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(c~~", 141, 340),
        new (0, $96e8fc72168067c5$export$dbe55ed82366d5e9)("j~RQYZXz{^~^O(Q~~aP!P!Qd~iO(R~~", 25, 323)
    ],
    topRules: {
        "Script": [
            0,
            7
        ],
        "SingleExpression": [
            1,
            276
        ],
        "SingleClassItem": [
            2,
            277
        ]
    },
    dialects: {
        jsx: 0,
        ts: 15175
    },
    dynamicPrecedences: {
        "80": 1,
        "82": 1,
        "94": 1,
        "169": 1,
        "199": 1
    },
    specialized: [
        {
            term: 327,
            get: (value)=>$44c7044f9afa5475$var$spec_identifier[value] || -1
        },
        {
            term: 343,
            get: (value)=>$44c7044f9afa5475$var$spec_word[value] || -1
        },
        {
            term: 95,
            get: (value)=>$44c7044f9afa5475$var$spec_LessThan[value] || -1
        }
    ],
    tokenPrec: 15201
});







/**
A collection of JavaScript-related
[snippets](https://codemirror.net/6/docs/ref/#autocomplete.snippet).
*/ const $03748e9436079709$export$c7c03ffcb9c131fc = [
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("function ${name}(${params}) {\n\t${}\n}", {
        label: "function",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n\t${}\n}", {
        label: "for",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("for (let ${name} of ${collection}) {\n\t${}\n}", {
        label: "for",
        detail: "of loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("do {\n\t${}\n} while (${})", {
        label: "do",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("while (${}) {\n\t${}\n}", {
        label: "while",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("try {\n\t${}\n} catch (${error}) {\n\t${}\n}", {
        label: "try",
        detail: "/ catch block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("if (${}) {\n\t${}\n}", {
        label: "if",
        detail: "block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("if (${}) {\n\t${}\n} else {\n\t${}\n}", {
        label: "if",
        detail: "/ else block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("class ${name} {\n\tconstructor(${params}) {\n\t\t${}\n\t}\n}", {
        label: "class",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("import {${names}} from \"${module}\"\n${}", {
        label: "import",
        detail: "named",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("import ${name} from \"${module}\"\n${}", {
        label: "import",
        detail: "default",
        type: "keyword"
    })
];
/**
A collection of snippet completions for TypeScript. Includes the
JavaScript [snippets](https://codemirror.net/6/docs/ref/#lang-javascript.snippets).
*/ const $03748e9436079709$export$4e97f270e7f6c0ba = /*@__PURE__*/ $03748e9436079709$export$c7c03ffcb9c131fc.concat([
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("interface ${name} {\n\t${}\n}", {
        label: "interface",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("type ${name} = ${type}", {
        label: "type",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("enum ${name} {\n\t${}\n}", {
        label: "enum",
        detail: "definition",
        type: "keyword"
    })
]);
const $03748e9436079709$var$cache = /*@__PURE__*/ new (0, $ed739beecf769914$export$7f13b5dc44c541ae)();
const $03748e9436079709$var$ScopeNodes = /*@__PURE__*/ new Set([
    "Script",
    "Block",
    "FunctionExpression",
    "FunctionDeclaration",
    "ArrowFunction",
    "MethodDeclaration",
    "ForStatement"
]);
function $03748e9436079709$var$defID(type) {
    return (node, def)=>{
        let id = node.node.getChild("VariableDefinition");
        if (id) def(id, type);
        return true;
    };
}
const $03748e9436079709$var$functionContext = [
    "FunctionDeclaration"
];
const $03748e9436079709$var$gatherCompletions = {
    FunctionDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("function"),
    ClassDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("class"),
    ClassExpression: ()=>true,
    EnumDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("constant"),
    TypeAliasDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("type"),
    NamespaceDeclaration: /*@__PURE__*/ $03748e9436079709$var$defID("namespace"),
    VariableDefinition (node, def) {
        if (!node.matchContext($03748e9436079709$var$functionContext)) def(node, "variable");
    },
    TypeDefinition (node, def) {
        def(node, "type");
    },
    __proto__: null
};
function $03748e9436079709$var$getScope(doc, node) {
    let cached = $03748e9436079709$var$cache.get(node);
    if (cached) return cached;
    let completions = [], top = true;
    function def(node, type) {
        let name = doc.sliceString(node.from, node.to);
        completions.push({
            label: name,
            type: type
        });
    }
    node.cursor((0, $ed739beecf769914$export$b0e28367f55837aa).IncludeAnonymous).iterate((node)=>{
        if (top) top = false;
        else if (node.name) {
            let gather = $03748e9436079709$var$gatherCompletions[node.name];
            if (gather && gather(node, def) || $03748e9436079709$var$ScopeNodes.has(node.name)) return false;
        } else if (node.to - node.from > 8192) {
            // Allow caching for bigger internal nodes
            for (let c of $03748e9436079709$var$getScope(doc, node.node))completions.push(c);
            return false;
        }
    });
    $03748e9436079709$var$cache.set(node, completions);
    return completions;
}
const $03748e9436079709$var$Identifier = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/;
const $03748e9436079709$var$dontComplete = [
    "TemplateString",
    "String",
    "RegExp",
    "LineComment",
    "BlockComment",
    "VariableDefinition",
    "TypeDefinition",
    "Label",
    "PropertyDefinition",
    "PropertyName",
    "PrivatePropertyDefinition",
    "PrivatePropertyName",
    "JSXText",
    "JSXAttributeValue",
    "JSXOpenTag",
    "JSXCloseTag",
    "JSXSelfClosingTag",
    ".",
    "?."
];
/**
Completion source that looks up locally defined names in
JavaScript code.
*/ function $03748e9436079709$export$a2e0a5b87b9b861c(context) {
    let inner = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1);
    if ($03748e9436079709$var$dontComplete.indexOf(inner.name) > -1) return null;
    let isWord = inner.name == "VariableName" || inner.to - inner.from < 20 && $03748e9436079709$var$Identifier.test(context.state.sliceDoc(inner.from, inner.to));
    if (!isWord && !context.explicit) return null;
    let options = [];
    for(let pos = inner; pos; pos = pos.parent)if ($03748e9436079709$var$ScopeNodes.has(pos.name)) options = options.concat($03748e9436079709$var$getScope(context.state.doc, pos));
    return {
        options: options,
        from: isWord ? inner.from : context.pos,
        validFor: $03748e9436079709$var$Identifier
    };
}
function $03748e9436079709$var$pathFor(read, member, name) {
    var _a;
    let path = [];
    for(;;){
        let obj = member.firstChild, prop;
        if ((obj === null || obj === void 0 ? void 0 : obj.name) == "VariableName") {
            path.push(read(obj));
            return {
                path: path.reverse(),
                name: name
            };
        } else if ((obj === null || obj === void 0 ? void 0 : obj.name) == "MemberExpression" && ((_a = prop = obj.lastChild) === null || _a === void 0 ? void 0 : _a.name) == "PropertyName") {
            path.push(read(prop));
            member = obj;
        } else return null;
    }
}
/**
Helper function for defining JavaScript completion sources. It
returns the completable name and object path for a completion
context, or null if no name/property completion should happen at
that position. For example, when completing after `a.b.c` it will
return `{path: ["a", "b"], name: "c"}`. When completing after `x`
it will return `{path: [], name: "x"}`. When not in a property or
name, it will return null if `context.explicit` is false, and
`{path: [], name: ""}` otherwise.
*/ function $03748e9436079709$export$744a796701708158(context) {
    let read = (node)=>context.state.doc.sliceString(node.from, node.to);
    let inner = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1);
    if (inner.name == "PropertyName") return $03748e9436079709$var$pathFor(read, inner.parent, read(inner));
    else if ((inner.name == "." || inner.name == "?.") && inner.parent.name == "MemberExpression") return $03748e9436079709$var$pathFor(read, inner.parent, "");
    else if ($03748e9436079709$var$dontComplete.indexOf(inner.name) > -1) return null;
    else if (inner.name == "VariableName" || inner.to - inner.from < 20 && $03748e9436079709$var$Identifier.test(read(inner))) return {
        path: [],
        name: read(inner)
    };
    else if (inner.name == "MemberExpression") return $03748e9436079709$var$pathFor(read, inner, "");
    else return context.explicit ? {
        path: [],
        name: ""
    } : null;
}
function $03748e9436079709$var$enumeratePropertyCompletions(obj, top) {
    let options = [], seen = new Set;
    for(let depth = 0;; depth++){
        for (let name of (Object.getOwnPropertyNames || Object.keys)(obj)){
            if (!/^[a-zA-Z_$\xaa-\uffdc][\w$\xaa-\uffdc]*$/.test(name) || seen.has(name)) continue;
            seen.add(name);
            let value;
            try {
                value = obj[name];
            } catch (_) {
                continue;
            }
            options.push({
                label: name,
                type: typeof value == "function" ? /^[A-Z]/.test(name) ? "class" : top ? "function" : "method" : top ? "variable" : "property",
                boost: -depth
            });
        }
        let next = Object.getPrototypeOf(obj);
        if (!next) return options;
        obj = next;
    }
}
/**
Defines a [completion source](https://codemirror.net/6/docs/ref/#autocomplete.CompletionSource) that
completes from the given scope object (for example `globalThis`).
Will enter properties of the object when completing properties on
a directly-named path.
*/ function $03748e9436079709$export$fc7787e70db1f2c3(scope) {
    let cache = new Map;
    return (context)=>{
        let path = $03748e9436079709$export$744a796701708158(context);
        if (!path) return null;
        let target = scope;
        for (let step of path.path){
            target = target[step];
            if (!target) return null;
        }
        let options = cache.get(target);
        if (!options) cache.set(target, options = $03748e9436079709$var$enumeratePropertyCompletions(target, !path.path.length));
        return {
            from: context.pos - path.name.length,
            options: options,
            validFor: $03748e9436079709$var$Identifier
        };
    };
}
/**
A language provider based on the [Lezer JavaScript
parser](https://github.com/lezer-parser/javascript), extended with
highlighting and indentation information.
*/ const $03748e9436079709$export$93859f94713968c6 = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$b243968d9fb6db03).define({
    name: "javascript",
    parser: /*@__PURE__*/ (0, $44c7044f9afa5475$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460).add({
                IfStatement: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c)({
                    except: /^\s*({|else\b)/
                }),
                TryStatement: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c)({
                    except: /^\s*({|catch\b|finally\b)/
                }),
                LabeledStatement: (0, $a97ccac5cf5f4f5d$export$4764c629086182f2),
                SwitchBody: (context)=>{
                    let after = context.textAfter, closed = /^\s*\}/.test(after), isCase = /^\s*(case|default)\b/.test(after);
                    return context.baseIndent + (closed ? 0 : isCase ? 1 : 2) * context.unit;
                },
                Block: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$60e82ea306899488)({
                    closing: "}"
                }),
                ArrowFunction: (cx)=>cx.baseIndent + cx.unit,
                "TemplateString BlockComment": ()=>null,
                "Statement Property": /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c)({
                    except: /^\s*{/
                }),
                JSXElement (context) {
                    let closed = /^\s*<\//.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                JSXEscape (context) {
                    let closed = /\s*\}/.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                "JSXOpenTag JSXSelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                }
            }),
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$9b075a85eb4377d8).add({
                "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": (0, $a97ccac5cf5f4f5d$export$48672beae16a681b),
                BlockComment (tree) {
                    return {
                        from: tree.from + 2,
                        to: tree.to - 2
                    };
                }
            })
        ]
    }),
    languageData: {
        closeBrackets: {
            brackets: [
                "(",
                "[",
                "{",
                "'",
                '"',
                "`"
            ]
        },
        commentTokens: {
            line: "//",
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
        wordChars: "$"
    }
});
const $03748e9436079709$var$jsxSublanguage = {
    test: (node)=>/^JSX/.test(node.name),
    facet: /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$b57f683f43553b99)({
        commentTokens: {
            block: {
                open: "{/*",
                close: "*/}"
            }
        }
    })
};
/**
A language provider for TypeScript.
*/ const $03748e9436079709$export$5a3c1a94be83ebb = /*@__PURE__*/ $03748e9436079709$export$93859f94713968c6.configure({
    dialect: "ts"
}, "typescript");
/**
Language provider for JSX.
*/ const $03748e9436079709$export$cf3118f4eee6176c = /*@__PURE__*/ $03748e9436079709$export$93859f94713968c6.configure({
    dialect: "jsx",
    props: [
        /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$4afc6f37514bbb67).add((n)=>n.isTop ? [
                $03748e9436079709$var$jsxSublanguage
            ] : undefined)
    ]
});
/**
Language provider for JSX + TypeScript.
*/ const $03748e9436079709$export$5e6bf9a8e977a24e = /*@__PURE__*/ $03748e9436079709$export$93859f94713968c6.configure({
    dialect: "jsx ts",
    props: [
        /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$4afc6f37514bbb67).add((n)=>n.isTop ? [
                $03748e9436079709$var$jsxSublanguage
            ] : undefined)
    ]
}, "typescript");
let $03748e9436079709$var$kwCompletion = (name)=>({
        label: name,
        type: "keyword"
    });
const $03748e9436079709$var$keywords = /*@__PURE__*/ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map($03748e9436079709$var$kwCompletion);
const $03748e9436079709$var$typescriptKeywords = /*@__PURE__*/ $03748e9436079709$var$keywords.concat(/*@__PURE__*/ [
    "declare",
    "implements",
    "private",
    "protected",
    "public"
].map($03748e9436079709$var$kwCompletion));
/**
JavaScript support. Includes [snippet](https://codemirror.net/6/docs/ref/#lang-javascript.snippets)
and local variable completion.
*/ function $03748e9436079709$export$755219397dca4f08(config = {}) {
    let lang = config.jsx ? config.typescript ? $03748e9436079709$export$5e6bf9a8e977a24e : $03748e9436079709$export$cf3118f4eee6176c : config.typescript ? $03748e9436079709$export$5a3c1a94be83ebb : $03748e9436079709$export$93859f94713968c6;
    let completions = config.typescript ? $03748e9436079709$export$4e97f270e7f6c0ba.concat($03748e9436079709$var$typescriptKeywords) : $03748e9436079709$export$c7c03ffcb9c131fc.concat($03748e9436079709$var$keywords);
    return new (0, $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b)(lang, [
        $03748e9436079709$export$93859f94713968c6.data.of({
            autocomplete: (0, $7570a9a1a9679713$export$1dfdaeb1e91714c0)($03748e9436079709$var$dontComplete, (0, $7570a9a1a9679713$export$db0ee7d2648a0c4b)(completions))
        }),
        $03748e9436079709$export$93859f94713968c6.data.of({
            autocomplete: $03748e9436079709$export$a2e0a5b87b9b861c
        }),
        config.jsx ? $03748e9436079709$export$f1d931274ca0e1f1 : []
    ]);
}
function $03748e9436079709$var$findOpenTag(node) {
    for(;;){
        if (node.name == "JSXOpenTag" || node.name == "JSXSelfClosingTag" || node.name == "JSXFragmentTag") return node;
        if (node.name == "JSXEscape" || !node.parent) return null;
        node = node.parent;
    }
}
function $03748e9436079709$var$elementName(doc, tree, max = doc.length) {
    for(let ch = tree === null || tree === void 0 ? void 0 : tree.firstChild; ch; ch = ch.nextSibling){
        if (ch.name == "JSXIdentifier" || ch.name == "JSXBuiltin" || ch.name == "JSXNamespacedName" || ch.name == "JSXMemberExpression") return doc.sliceString(ch.from, Math.min(ch.to, max));
    }
    return "";
}
const $03748e9436079709$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
/**
Extension that will automatically insert JSX close tags when a `>` or
`/` is typed.
*/ const $03748e9436079709$export$f1d931274ca0e1f1 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).inputHandler.of((view, from, to, text, defaultInsert)=>{
    if (($03748e9436079709$var$android ? view.composing : view.compositionStarted) || view.state.readOnly || from != to || text != ">" && text != "/" || !$03748e9436079709$export$93859f94713968c6.isActiveAt(view.state, from, -1)) return false;
    let base = defaultInsert(), { state: state } = base;
    let closeTags = state.changeByRange((range)=>{
        var _a;
        let { head: head } = range, around = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(head - 1, -1), name;
        if (around.name == "JSXStartTag") around = around.parent;
        if (state.doc.sliceString(head - 1, head) != text || around.name == "JSXAttributeValue" && around.to > head) ;
        else if (text == ">" && around.name == "JSXFragmentTag") return {
            range: range,
            changes: {
                from: head,
                insert: `</>`
            }
        };
        else if (text == "/" && around.name == "JSXStartCloseTag") {
            let empty = around.parent, base = empty.parent;
            if (base && empty.from == head - 2 && ((name = $03748e9436079709$var$elementName(state.doc, base.firstChild, head)) || ((_a = base.firstChild) === null || _a === void 0 ? void 0 : _a.name) == "JSXFragmentTag")) {
                let insert = `${name}>`;
                return {
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(head + insert.length, -1),
                    changes: {
                        from: head,
                        insert: insert
                    }
                };
            }
        } else if (text == ">") {
            let openTag = $03748e9436079709$var$findOpenTag(around);
            if (openTag && openTag.name == "JSXOpenTag" && !/^\/?>|^<\//.test(state.doc.sliceString(head, head + 2)) && (name = $03748e9436079709$var$elementName(state.doc, openTag, head))) return {
                range: range,
                changes: {
                    from: head,
                    insert: `</${name}>`
                }
            };
        }
        return {
            range: range
        };
    });
    if (closeTags.changes.empty) return false;
    view.dispatch([
        base,
        state.update(closeTags, {
            userEvent: "input.complete",
            scrollIntoView: true
        })
    ]);
    return true;
});
/**
Connects an [ESLint](https://eslint.org/) linter to CodeMirror's
[lint](https://codemirror.net/6/docs/ref/#lint) integration. `eslint` should be an instance of the
[`Linter`](https://eslint.org/docs/developer-guide/nodejs-api#linter)
class, and `config` an optional ESLint configuration. The return
value of this function can be passed to [`linter`](https://codemirror.net/6/docs/ref/#lint.linter)
to create a JavaScript linting extension.

Note that ESLint targets node, and is tricky to run in the
browser. The
[eslint-linter-browserify](https://github.com/UziTech/eslint-linter-browserify)
package may help with that (see
[example](https://github.com/UziTech/eslint-linter-browserify/blob/master/example/script.js)).
*/ function $03748e9436079709$export$5f7cd04a95ec53e6(eslint, config) {
    if (!config) {
        config = {
            parserOptions: {
                ecmaVersion: 2019,
                sourceType: "module"
            },
            env: {
                browser: true,
                node: true,
                es6: true,
                es2015: true,
                es2017: true,
                es2020: true
            },
            rules: {}
        };
        eslint.getRules().forEach((desc, name)=>{
            var _a;
            if ((_a = desc.meta.docs) === null || _a === void 0 ? void 0 : _a.recommended) config.rules[name] = 2;
        });
    }
    return (view)=>{
        let { state: state } = view, found = [];
        for (let { from: from, to: to } of $03748e9436079709$export$93859f94713968c6.findRegions(state)){
            let fromLine = state.doc.lineAt(from), offset = {
                line: fromLine.number - 1,
                col: from - fromLine.from,
                pos: from
            };
            for (let d of eslint.verify(state.sliceDoc(from, to), config))found.push($03748e9436079709$var$translateDiagnostic(d, state.doc, offset));
        }
        return found;
    };
}
function $03748e9436079709$var$mapPos(line, col, doc, offset) {
    return doc.line(line + offset.line).from + col + (line == 1 ? offset.col - 1 : -1);
}
function $03748e9436079709$var$translateDiagnostic(input, doc, offset) {
    let start = $03748e9436079709$var$mapPos(input.line, input.column, doc, offset);
    let result = {
        from: start,
        to: input.endLine != null && input.endColumn != 1 ? $03748e9436079709$var$mapPos(input.endLine, input.endColumn, doc, offset) : start,
        message: input.message,
        source: input.ruleId ? "eslint:" + input.ruleId : "eslint",
        severity: input.severity == 1 ? "warning" : "error"
    };
    if (input.fix) {
        let { range: range, text: text } = input.fix, from = range[0] + offset.pos - start, to = range[1] + offset.pos - start;
        result.actions = [
            {
                name: "fix",
                apply (view, start) {
                    view.dispatch({
                        changes: {
                            from: start + from,
                            to: start + to,
                            insert: text
                        },
                        scrollIntoView: true
                    });
                }
            }
        ];
    }
    return result;
}





const $b89c3ee08b45bae9$var$Targets = [
    "_blank",
    "_self",
    "_top",
    "_parent"
];
const $b89c3ee08b45bae9$var$Charsets = [
    "ascii",
    "utf-8",
    "utf-16",
    "latin1",
    "latin1"
];
const $b89c3ee08b45bae9$var$Methods = [
    "get",
    "post",
    "put",
    "delete"
];
const $b89c3ee08b45bae9$var$Encs = [
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
];
const $b89c3ee08b45bae9$var$Bool = [
    "true",
    "false"
];
const $b89c3ee08b45bae9$var$S = {}; // Empty tag spec
const $b89c3ee08b45bae9$var$Tags = {
    a: {
        attrs: {
            href: null,
            ping: null,
            type: null,
            media: null,
            target: $b89c3ee08b45bae9$var$Targets,
            hreflang: null
        }
    },
    abbr: $b89c3ee08b45bae9$var$S,
    address: $b89c3ee08b45bae9$var$S,
    area: {
        attrs: {
            alt: null,
            coords: null,
            href: null,
            target: null,
            ping: null,
            media: null,
            hreflang: null,
            type: null,
            shape: [
                "default",
                "rect",
                "circle",
                "poly"
            ]
        }
    },
    article: $b89c3ee08b45bae9$var$S,
    aside: $b89c3ee08b45bae9$var$S,
    audio: {
        attrs: {
            src: null,
            mediagroup: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "none",
                "metadata",
                "auto"
            ],
            autoplay: [
                "autoplay"
            ],
            loop: [
                "loop"
            ],
            controls: [
                "controls"
            ]
        }
    },
    b: $b89c3ee08b45bae9$var$S,
    base: {
        attrs: {
            href: null,
            target: $b89c3ee08b45bae9$var$Targets
        }
    },
    bdi: $b89c3ee08b45bae9$var$S,
    bdo: $b89c3ee08b45bae9$var$S,
    blockquote: {
        attrs: {
            cite: null
        }
    },
    body: $b89c3ee08b45bae9$var$S,
    br: $b89c3ee08b45bae9$var$S,
    button: {
        attrs: {
            form: null,
            formaction: null,
            name: null,
            value: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "autofocus"
            ],
            formenctype: $b89c3ee08b45bae9$var$Encs,
            formmethod: $b89c3ee08b45bae9$var$Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: $b89c3ee08b45bae9$var$Targets,
            type: [
                "submit",
                "reset",
                "button"
            ]
        }
    },
    canvas: {
        attrs: {
            width: null,
            height: null
        }
    },
    caption: $b89c3ee08b45bae9$var$S,
    center: $b89c3ee08b45bae9$var$S,
    cite: $b89c3ee08b45bae9$var$S,
    code: $b89c3ee08b45bae9$var$S,
    col: {
        attrs: {
            span: null
        }
    },
    colgroup: {
        attrs: {
            span: null
        }
    },
    command: {
        attrs: {
            type: [
                "command",
                "checkbox",
                "radio"
            ],
            label: null,
            icon: null,
            radiogroup: null,
            command: null,
            title: null,
            disabled: [
                "disabled"
            ],
            checked: [
                "checked"
            ]
        }
    },
    data: {
        attrs: {
            value: null
        }
    },
    datagrid: {
        attrs: {
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    datalist: {
        attrs: {
            data: null
        }
    },
    dd: $b89c3ee08b45bae9$var$S,
    del: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    details: {
        attrs: {
            open: [
                "open"
            ]
        }
    },
    dfn: $b89c3ee08b45bae9$var$S,
    div: $b89c3ee08b45bae9$var$S,
    dl: $b89c3ee08b45bae9$var$S,
    dt: $b89c3ee08b45bae9$var$S,
    em: $b89c3ee08b45bae9$var$S,
    embed: {
        attrs: {
            src: null,
            type: null,
            width: null,
            height: null
        }
    },
    eventsource: {
        attrs: {
            src: null
        }
    },
    fieldset: {
        attrs: {
            disabled: [
                "disabled"
            ],
            form: null,
            name: null
        }
    },
    figcaption: $b89c3ee08b45bae9$var$S,
    figure: $b89c3ee08b45bae9$var$S,
    footer: $b89c3ee08b45bae9$var$S,
    form: {
        attrs: {
            action: null,
            name: null,
            "accept-charset": $b89c3ee08b45bae9$var$Charsets,
            autocomplete: [
                "on",
                "off"
            ],
            enctype: $b89c3ee08b45bae9$var$Encs,
            method: $b89c3ee08b45bae9$var$Methods,
            novalidate: [
                "novalidate"
            ],
            target: $b89c3ee08b45bae9$var$Targets
        }
    },
    h1: $b89c3ee08b45bae9$var$S,
    h2: $b89c3ee08b45bae9$var$S,
    h3: $b89c3ee08b45bae9$var$S,
    h4: $b89c3ee08b45bae9$var$S,
    h5: $b89c3ee08b45bae9$var$S,
    h6: $b89c3ee08b45bae9$var$S,
    head: {
        children: [
            "title",
            "base",
            "link",
            "style",
            "meta",
            "script",
            "noscript",
            "command"
        ]
    },
    header: $b89c3ee08b45bae9$var$S,
    hgroup: $b89c3ee08b45bae9$var$S,
    hr: $b89c3ee08b45bae9$var$S,
    html: {
        attrs: {
            manifest: null
        }
    },
    i: $b89c3ee08b45bae9$var$S,
    iframe: {
        attrs: {
            src: null,
            srcdoc: null,
            name: null,
            width: null,
            height: null,
            sandbox: [
                "allow-top-navigation",
                "allow-same-origin",
                "allow-forms",
                "allow-scripts"
            ],
            seamless: [
                "seamless"
            ]
        }
    },
    img: {
        attrs: {
            alt: null,
            src: null,
            ismap: null,
            usemap: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ]
        }
    },
    input: {
        attrs: {
            alt: null,
            dirname: null,
            form: null,
            formaction: null,
            height: null,
            list: null,
            max: null,
            maxlength: null,
            min: null,
            name: null,
            pattern: null,
            placeholder: null,
            size: null,
            src: null,
            step: null,
            value: null,
            width: null,
            accept: [
                "audio/*",
                "video/*",
                "image/*"
            ],
            autocomplete: [
                "on",
                "off"
            ],
            autofocus: [
                "autofocus"
            ],
            checked: [
                "checked"
            ],
            disabled: [
                "disabled"
            ],
            formenctype: $b89c3ee08b45bae9$var$Encs,
            formmethod: $b89c3ee08b45bae9$var$Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: $b89c3ee08b45bae9$var$Targets,
            multiple: [
                "multiple"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            type: [
                "hidden",
                "text",
                "search",
                "tel",
                "url",
                "email",
                "password",
                "datetime",
                "date",
                "month",
                "week",
                "time",
                "datetime-local",
                "number",
                "range",
                "color",
                "checkbox",
                "radio",
                "file",
                "submit",
                "image",
                "reset",
                "button"
            ]
        }
    },
    ins: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    kbd: $b89c3ee08b45bae9$var$S,
    keygen: {
        attrs: {
            challenge: null,
            form: null,
            name: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            keytype: [
                "RSA"
            ]
        }
    },
    label: {
        attrs: {
            for: null,
            form: null
        }
    },
    legend: $b89c3ee08b45bae9$var$S,
    li: {
        attrs: {
            value: null
        }
    },
    link: {
        attrs: {
            href: null,
            type: null,
            hreflang: null,
            media: null,
            sizes: [
                "all",
                "16x16",
                "16x16 32x32",
                "16x16 32x32 64x64"
            ]
        }
    },
    map: {
        attrs: {
            name: null
        }
    },
    mark: $b89c3ee08b45bae9$var$S,
    menu: {
        attrs: {
            label: null,
            type: [
                "list",
                "context",
                "toolbar"
            ]
        }
    },
    meta: {
        attrs: {
            content: null,
            charset: $b89c3ee08b45bae9$var$Charsets,
            name: [
                "viewport",
                "application-name",
                "author",
                "description",
                "generator",
                "keywords"
            ],
            "http-equiv": [
                "content-language",
                "content-type",
                "default-style",
                "refresh"
            ]
        }
    },
    meter: {
        attrs: {
            value: null,
            min: null,
            low: null,
            high: null,
            max: null,
            optimum: null
        }
    },
    nav: $b89c3ee08b45bae9$var$S,
    noscript: $b89c3ee08b45bae9$var$S,
    object: {
        attrs: {
            data: null,
            type: null,
            name: null,
            usemap: null,
            form: null,
            width: null,
            height: null,
            typemustmatch: [
                "typemustmatch"
            ]
        }
    },
    ol: {
        attrs: {
            reversed: [
                "reversed"
            ],
            start: null,
            type: [
                "1",
                "a",
                "A",
                "i",
                "I"
            ]
        },
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    optgroup: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null
        }
    },
    option: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null,
            selected: [
                "selected"
            ],
            value: null
        }
    },
    output: {
        attrs: {
            for: null,
            form: null,
            name: null
        }
    },
    p: $b89c3ee08b45bae9$var$S,
    param: {
        attrs: {
            name: null,
            value: null
        }
    },
    pre: $b89c3ee08b45bae9$var$S,
    progress: {
        attrs: {
            value: null,
            max: null
        }
    },
    q: {
        attrs: {
            cite: null
        }
    },
    rp: $b89c3ee08b45bae9$var$S,
    rt: $b89c3ee08b45bae9$var$S,
    ruby: $b89c3ee08b45bae9$var$S,
    samp: $b89c3ee08b45bae9$var$S,
    script: {
        attrs: {
            type: [
                "text/javascript"
            ],
            src: null,
            async: [
                "async"
            ],
            defer: [
                "defer"
            ],
            charset: $b89c3ee08b45bae9$var$Charsets
        }
    },
    section: $b89c3ee08b45bae9$var$S,
    select: {
        attrs: {
            form: null,
            name: null,
            size: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    slot: {
        attrs: {
            name: null
        }
    },
    small: $b89c3ee08b45bae9$var$S,
    source: {
        attrs: {
            src: null,
            type: null,
            media: null
        }
    },
    span: $b89c3ee08b45bae9$var$S,
    strong: $b89c3ee08b45bae9$var$S,
    style: {
        attrs: {
            type: [
                "text/css"
            ],
            media: null,
            scoped: null
        }
    },
    sub: $b89c3ee08b45bae9$var$S,
    summary: $b89c3ee08b45bae9$var$S,
    sup: $b89c3ee08b45bae9$var$S,
    table: $b89c3ee08b45bae9$var$S,
    tbody: $b89c3ee08b45bae9$var$S,
    td: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null
        }
    },
    template: $b89c3ee08b45bae9$var$S,
    textarea: {
        attrs: {
            dirname: null,
            form: null,
            maxlength: null,
            name: null,
            placeholder: null,
            rows: null,
            cols: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            wrap: [
                "soft",
                "hard"
            ]
        }
    },
    tfoot: $b89c3ee08b45bae9$var$S,
    th: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null,
            scope: [
                "row",
                "col",
                "rowgroup",
                "colgroup"
            ]
        }
    },
    thead: $b89c3ee08b45bae9$var$S,
    time: {
        attrs: {
            datetime: null
        }
    },
    title: $b89c3ee08b45bae9$var$S,
    tr: $b89c3ee08b45bae9$var$S,
    track: {
        attrs: {
            src: null,
            label: null,
            default: null,
            kind: [
                "subtitles",
                "captions",
                "descriptions",
                "chapters",
                "metadata"
            ],
            srclang: null
        }
    },
    ul: {
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    var: $b89c3ee08b45bae9$var$S,
    video: {
        attrs: {
            src: null,
            poster: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "auto",
                "metadata",
                "none"
            ],
            autoplay: [
                "autoplay"
            ],
            mediagroup: [
                "movie"
            ],
            muted: [
                "muted"
            ],
            controls: [
                "controls"
            ]
        }
    },
    wbr: $b89c3ee08b45bae9$var$S
};
const $b89c3ee08b45bae9$var$GlobalAttrs = {
    accesskey: null,
    class: null,
    contenteditable: $b89c3ee08b45bae9$var$Bool,
    contextmenu: null,
    dir: [
        "ltr",
        "rtl",
        "auto"
    ],
    draggable: [
        "true",
        "false",
        "auto"
    ],
    dropzone: [
        "copy",
        "move",
        "link",
        "string:",
        "file:"
    ],
    hidden: [
        "hidden"
    ],
    id: null,
    inert: [
        "inert"
    ],
    itemid: null,
    itemprop: null,
    itemref: null,
    itemscope: [
        "itemscope"
    ],
    itemtype: null,
    lang: [
        "ar",
        "bn",
        "de",
        "en-GB",
        "en-US",
        "es",
        "fr",
        "hi",
        "id",
        "ja",
        "pa",
        "pt",
        "ru",
        "tr",
        "zh"
    ],
    spellcheck: $b89c3ee08b45bae9$var$Bool,
    autocorrect: $b89c3ee08b45bae9$var$Bool,
    autocapitalize: $b89c3ee08b45bae9$var$Bool,
    style: null,
    tabindex: null,
    title: null,
    translate: [
        "yes",
        "no"
    ],
    rel: [
        "stylesheet",
        "alternate",
        "author",
        "bookmark",
        "help",
        "license",
        "next",
        "nofollow",
        "noreferrer",
        "prefetch",
        "prev",
        "search",
        "tag"
    ],
    role: /*@__PURE__*/ "alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
    "aria-activedescendant": null,
    "aria-atomic": $b89c3ee08b45bae9$var$Bool,
    "aria-autocomplete": [
        "inline",
        "list",
        "both",
        "none"
    ],
    "aria-busy": $b89c3ee08b45bae9$var$Bool,
    "aria-checked": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-controls": null,
    "aria-describedby": null,
    "aria-disabled": $b89c3ee08b45bae9$var$Bool,
    "aria-dropeffect": null,
    "aria-expanded": [
        "true",
        "false",
        "undefined"
    ],
    "aria-flowto": null,
    "aria-grabbed": [
        "true",
        "false",
        "undefined"
    ],
    "aria-haspopup": $b89c3ee08b45bae9$var$Bool,
    "aria-hidden": $b89c3ee08b45bae9$var$Bool,
    "aria-invalid": [
        "true",
        "false",
        "grammar",
        "spelling"
    ],
    "aria-label": null,
    "aria-labelledby": null,
    "aria-level": null,
    "aria-live": [
        "off",
        "polite",
        "assertive"
    ],
    "aria-multiline": $b89c3ee08b45bae9$var$Bool,
    "aria-multiselectable": $b89c3ee08b45bae9$var$Bool,
    "aria-owns": null,
    "aria-posinset": null,
    "aria-pressed": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-readonly": $b89c3ee08b45bae9$var$Bool,
    "aria-relevant": null,
    "aria-required": $b89c3ee08b45bae9$var$Bool,
    "aria-selected": [
        "true",
        "false",
        "undefined"
    ],
    "aria-setsize": null,
    "aria-sort": [
        "ascending",
        "descending",
        "none",
        "other"
    ],
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null
};
const $b89c3ee08b45bae9$var$eventAttributes = /*@__PURE__*/ "beforeunload copy cut dragstart dragover dragleave dragenter dragend drag paste focus blur change click load mousedown mouseenter mouseleave mouseup keydown keyup resize scroll unload".split(" ").map((n)=>"on" + n);
for (let a of $b89c3ee08b45bae9$var$eventAttributes)$b89c3ee08b45bae9$var$GlobalAttrs[a] = null;
class $b89c3ee08b45bae9$var$Schema {
    constructor(extraTags, extraAttrs){
        this.tags = {
            ...$b89c3ee08b45bae9$var$Tags,
            ...extraTags
        };
        this.globalAttrs = {
            ...$b89c3ee08b45bae9$var$GlobalAttrs,
            ...extraAttrs
        };
        this.allTags = Object.keys(this.tags);
        this.globalAttrNames = Object.keys(this.globalAttrs);
    }
}
$b89c3ee08b45bae9$var$Schema.default = /*@__PURE__*/ new $b89c3ee08b45bae9$var$Schema;
function $b89c3ee08b45bae9$var$elementName(doc, tree, max = doc.length) {
    if (!tree) return "";
    let tag = tree.firstChild;
    let name = tag && tag.getChild("TagName");
    return name ? doc.sliceString(name.from, Math.min(name.to, max)) : "";
}
function $b89c3ee08b45bae9$var$findParentElement(tree, skip = false) {
    for(; tree; tree = tree.parent)if (tree.name == "Element") {
        if (skip) skip = false;
        else return tree;
    }
    return null;
}
function $b89c3ee08b45bae9$var$allowedChildren(doc, tree, schema) {
    let parentInfo = schema.tags[$b89c3ee08b45bae9$var$elementName(doc, $b89c3ee08b45bae9$var$findParentElement(tree))];
    return (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.children) || schema.allTags;
}
function $b89c3ee08b45bae9$var$openTags(doc, tree) {
    let open = [];
    for(let parent = $b89c3ee08b45bae9$var$findParentElement(tree); parent && !parent.type.isTop; parent = $b89c3ee08b45bae9$var$findParentElement(parent.parent)){
        let tagName = $b89c3ee08b45bae9$var$elementName(doc, parent);
        if (tagName && parent.lastChild.name == "CloseTag") break;
        if (tagName && open.indexOf(tagName) < 0 && (tree.name == "EndTag" || tree.from >= parent.firstChild.to)) open.push(tagName);
    }
    return open;
}
const $b89c3ee08b45bae9$var$identifier = /^[:\-\.\w\u00b7-\uffff]*$/;
function $b89c3ee08b45bae9$var$completeTag(state, schema, tree, from, to) {
    let end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    let parent = $b89c3ee08b45bae9$var$findParentElement(tree, tree.name == "StartTag" || tree.name == "TagName");
    return {
        from: from,
        to: to,
        options: $b89c3ee08b45bae9$var$allowedChildren(state.doc, parent, schema).map((tagName)=>({
                label: tagName,
                type: "type"
            })).concat($b89c3ee08b45bae9$var$openTags(state.doc, tree).map((tag, i)=>({
                label: "/" + tag,
                apply: "/" + tag + end,
                type: "type",
                boost: 99 - i
            }))),
        validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function $b89c3ee08b45bae9$var$completeCloseTag(state, tree, from, to) {
    let end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    return {
        from: from,
        to: to,
        options: $b89c3ee08b45bae9$var$openTags(state.doc, tree).map((tag, i)=>({
                label: tag,
                apply: tag + end,
                type: "type",
                boost: 99 - i
            })),
        validFor: $b89c3ee08b45bae9$var$identifier
    };
}
function $b89c3ee08b45bae9$var$completeStartTag(state, schema, tree, pos) {
    let options = [], level = 0;
    for (let tagName of $b89c3ee08b45bae9$var$allowedChildren(state.doc, tree, schema))options.push({
        label: "<" + tagName,
        type: "type"
    });
    for (let open of $b89c3ee08b45bae9$var$openTags(state.doc, tree))options.push({
        label: "</" + open + ">",
        type: "type",
        boost: 99 - level++
    });
    return {
        from: pos,
        to: pos,
        options: options,
        validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function $b89c3ee08b45bae9$var$completeAttrName(state, schema, tree, from, to) {
    let elt = $b89c3ee08b45bae9$var$findParentElement(tree), info = elt ? schema.tags[$b89c3ee08b45bae9$var$elementName(state.doc, elt)] : null;
    let localAttrs = info && info.attrs ? Object.keys(info.attrs) : [];
    let names = info && info.globalAttrs === false ? localAttrs : localAttrs.length ? localAttrs.concat(schema.globalAttrNames) : schema.globalAttrNames;
    return {
        from: from,
        to: to,
        options: names.map((attrName)=>({
                label: attrName,
                type: "property"
            })),
        validFor: $b89c3ee08b45bae9$var$identifier
    };
}
function $b89c3ee08b45bae9$var$completeAttrValue(state, schema, tree, from, to) {
    var _a;
    let nameNode = (_a = tree.parent) === null || _a === void 0 ? void 0 : _a.getChild("AttributeName");
    let options = [], token = undefined;
    if (nameNode) {
        let attrName = state.sliceDoc(nameNode.from, nameNode.to);
        let attrs = schema.globalAttrs[attrName];
        if (!attrs) {
            let elt = $b89c3ee08b45bae9$var$findParentElement(tree), info = elt ? schema.tags[$b89c3ee08b45bae9$var$elementName(state.doc, elt)] : null;
            attrs = (info === null || info === void 0 ? void 0 : info.attrs) && info.attrs[attrName];
        }
        if (attrs) {
            let base = state.sliceDoc(from, to).toLowerCase(), quoteStart = '"', quoteEnd = '"';
            if (/^['"]/.test(base)) {
                token = base[0] == '"' ? /^[^"]*$/ : /^[^']*$/;
                quoteStart = "";
                quoteEnd = state.sliceDoc(to, to + 1) == base[0] ? "" : base[0];
                base = base.slice(1);
                from++;
            } else token = /^[^\s<>='"]*$/;
            for (let value of attrs)options.push({
                label: value,
                apply: quoteStart + value + quoteEnd,
                type: "constant"
            });
        }
    }
    return {
        from: from,
        to: to,
        options: options,
        validFor: token
    };
}
function $b89c3ee08b45bae9$var$htmlCompletionFor(schema, context) {
    let { state: state, pos: pos } = context, tree = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1), around = tree.resolve(pos);
    for(let scan = pos, before; around == tree && (before = tree.childBefore(scan));){
        let last = before.lastChild;
        if (!last || !last.type.isError || last.from < last.to) break;
        around = tree = before;
        scan = last.from;
    }
    if (tree.name == "TagName") return tree.parent && /CloseTag$/.test(tree.parent.name) ? $b89c3ee08b45bae9$var$completeCloseTag(state, tree, tree.from, pos) : $b89c3ee08b45bae9$var$completeTag(state, schema, tree, tree.from, pos);
    else if (tree.name == "StartTag" || tree.name == "IncompleteTag") return $b89c3ee08b45bae9$var$completeTag(state, schema, tree, pos, pos);
    else if (tree.name == "StartCloseTag" || tree.name == "IncompleteCloseTag") return $b89c3ee08b45bae9$var$completeCloseTag(state, tree, pos, pos);
    else if (tree.name == "OpenTag" || tree.name == "SelfClosingTag" || tree.name == "AttributeName") return $b89c3ee08b45bae9$var$completeAttrName(state, schema, tree, tree.name == "AttributeName" ? tree.from : pos, pos);
    else if (tree.name == "Is" || tree.name == "AttributeValue" || tree.name == "UnquotedAttributeValue") return $b89c3ee08b45bae9$var$completeAttrValue(state, schema, tree, tree.name == "Is" ? pos : tree.from, pos);
    else if (context.explicit && (around.name == "Element" || around.name == "Text" || around.name == "Document")) return $b89c3ee08b45bae9$var$completeStartTag(state, schema, tree, pos);
    else return null;
}
/**
HTML tag completion. Opens and closes tags and attributes in a
context-aware way.
*/ function $b89c3ee08b45bae9$export$25345412b4ded248(context) {
    return $b89c3ee08b45bae9$var$htmlCompletionFor($b89c3ee08b45bae9$var$Schema.default, context);
}
/**
Create a completion source for HTML extended with additional tags
or attributes.
*/ function $b89c3ee08b45bae9$export$2bf1c75d01fadf84(config) {
    let { extraTags: extraTags, extraGlobalAttributes: extraAttrs } = config;
    let schema = extraAttrs || extraTags ? new $b89c3ee08b45bae9$var$Schema(extraTags, extraAttrs) : $b89c3ee08b45bae9$var$Schema.default;
    return (context)=>$b89c3ee08b45bae9$var$htmlCompletionFor(schema, context);
}
const $b89c3ee08b45bae9$var$jsonParser = /*@__PURE__*/ (0, $03748e9436079709$export$93859f94713968c6).parser.configure({
    top: "SingleExpression"
});
const $b89c3ee08b45bae9$var$defaultNesting = [
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/typescript" || attrs.lang == "ts",
        parser: (0, $03748e9436079709$export$5a3c1a94be83ebb).parser
    },
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/babel" || attrs.type == "text/jsx",
        parser: (0, $03748e9436079709$export$cf3118f4eee6176c).parser
    },
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/typescript-jsx",
        parser: (0, $03748e9436079709$export$5e6bf9a8e977a24e).parser
    },
    {
        tag: "script",
        attrs (attrs) {
            return /^(importmap|speculationrules|application\/(.+\+)?json)$/i.test(attrs.type);
        },
        parser: $b89c3ee08b45bae9$var$jsonParser
    },
    {
        tag: "script",
        attrs (attrs) {
            return !attrs.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(attrs.type);
        },
        parser: (0, $03748e9436079709$export$93859f94713968c6).parser
    },
    {
        tag: "style",
        attrs (attrs) {
            return (!attrs.lang || attrs.lang == "css") && (!attrs.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(attrs.type));
        },
        parser: (0, $83e81cc0276b0738$export$93323d80d661fcda).parser
    }
];
const $b89c3ee08b45bae9$var$defaultAttrs = /*@__PURE__*/ [
    {
        name: "style",
        parser: /*@__PURE__*/ (0, $83e81cc0276b0738$export$93323d80d661fcda).parser.configure({
            top: "Styles"
        })
    }
].concat(/*@__PURE__*/ $b89c3ee08b45bae9$var$eventAttributes.map((name)=>({
        name: name,
        parser: (0, $03748e9436079709$export$93859f94713968c6).parser
    })));
const $b89c3ee08b45bae9$var$htmlPlain = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$b243968d9fb6db03).define({
    name: "html",
    parser: /*@__PURE__*/ (0, $07236028cbce11ab$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460).add({
                Element (context) {
                    let after = /^(\s*)(<\/)?/.exec(context.textAfter);
                    if (context.node.to <= context.pos + after[0].length) return context.continue();
                    return context.lineIndent(context.node.from) + (after[2] ? 0 : context.unit);
                },
                "OpenTag CloseTag SelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                },
                Document (context) {
                    if (context.pos + /\s*/.exec(context.textAfter)[0].length < context.node.to) return context.continue();
                    let endElt = null, close;
                    for(let cur = context.node;;){
                        let last = cur.lastChild;
                        if (!last || last.name != "Element" || last.to != cur.to) break;
                        endElt = cur = last;
                    }
                    if (endElt && !((close = endElt.lastChild) && (close.name == "CloseTag" || close.name == "SelfClosingTag"))) return context.lineIndent(endElt.from) + context.unit;
                    return null;
                }
            }),
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$9b075a85eb4377d8).add({
                Element (node) {
                    let first = node.firstChild, last = node.lastChild;
                    if (!first || first.name != "OpenTag") return null;
                    return {
                        from: first.to,
                        to: last.name == "CloseTag" ? last.from : node.to
                    };
                }
            }),
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$ca7d74cd5b9f1011).add({
                "OpenTag CloseTag": (node)=>node.getChild("TagName")
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "<!--",
                close: "-->"
            }
        },
        indentOnInput: /^\s*<\/\w+\W$/,
        wordChars: "-_"
    }
});
/**
A language provider based on the [Lezer HTML
parser](https://github.com/lezer-parser/html), extended with the
JavaScript and CSS parsers to parse the content of `<script>` and
`<style>` tags.
*/ const $b89c3ee08b45bae9$export$76e66adcf103f9a2 = /*@__PURE__*/ $b89c3ee08b45bae9$var$htmlPlain.configure({
    wrap: /*@__PURE__*/ (0, $07236028cbce11ab$export$3a6217e5968adf01)($b89c3ee08b45bae9$var$defaultNesting, $b89c3ee08b45bae9$var$defaultAttrs)
});
/**
Language support for HTML, including
[`htmlCompletion`](https://codemirror.net/6/docs/ref/#lang-html.htmlCompletion) and JavaScript and
CSS support extensions.
*/ function $b89c3ee08b45bae9$export$c0bb0b647f701bb5(config = {}) {
    let dialect = "", wrap;
    if (config.matchClosingTags === false) dialect = "noMatch";
    if (config.selfClosingTags === true) dialect = (dialect ? dialect + " " : "") + "selfClosing";
    if (config.nestedLanguages && config.nestedLanguages.length || config.nestedAttributes && config.nestedAttributes.length) wrap = (0, $07236028cbce11ab$export$3a6217e5968adf01)((config.nestedLanguages || []).concat($b89c3ee08b45bae9$var$defaultNesting), (config.nestedAttributes || []).concat($b89c3ee08b45bae9$var$defaultAttrs));
    let lang = wrap ? $b89c3ee08b45bae9$var$htmlPlain.configure({
        wrap: wrap,
        dialect: dialect
    }) : dialect ? $b89c3ee08b45bae9$export$76e66adcf103f9a2.configure({
        dialect: dialect
    }) : $b89c3ee08b45bae9$export$76e66adcf103f9a2;
    return new (0, $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b)(lang, [
        $b89c3ee08b45bae9$export$76e66adcf103f9a2.data.of({
            autocomplete: $b89c3ee08b45bae9$export$2bf1c75d01fadf84(config)
        }),
        config.autoCloseTags !== false ? $b89c3ee08b45bae9$export$f1d931274ca0e1f1 : [],
        (0, $03748e9436079709$export$755219397dca4f08)().support,
        (0, $83e81cc0276b0738$export$dbf350e5966cf602)().support
    ]);
}
const $b89c3ee08b45bae9$var$selfClosers = /*@__PURE__*/ new Set(/*@__PURE__*/ "area base br col command embed frame hr img input keygen link meta param source track wbr menuitem".split(" "));
/**
Extension that will automatically insert close tags when a `>` or
`/` is typed.
*/ const $b89c3ee08b45bae9$export$f1d931274ca0e1f1 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).inputHandler.of((view, from, to, text, insertTransaction)=>{
    if (view.composing || view.state.readOnly || from != to || text != ">" && text != "/" || !$b89c3ee08b45bae9$export$76e66adcf103f9a2.isActiveAt(view.state, from, -1)) return false;
    let base = insertTransaction(), { state: state } = base;
    let closeTags = state.changeByRange((range)=>{
        var _a, _b, _c;
        let didType = state.doc.sliceString(range.from - 1, range.to) == text;
        let { head: head } = range, after = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(head, -1), name;
        if (didType && text == ">" && after.name == "EndTag") {
            let tag = after.parent;
            if (((_b = (_a = tag.parent) === null || _a === void 0 ? void 0 : _a.lastChild) === null || _b === void 0 ? void 0 : _b.name) != "CloseTag" && (name = $b89c3ee08b45bae9$var$elementName(state.doc, tag.parent, head)) && !$b89c3ee08b45bae9$var$selfClosers.has(name)) {
                let to = head + (state.doc.sliceString(head, head + 1) === ">" ? 1 : 0);
                let insert = `</${name}>`;
                return {
                    range: range,
                    changes: {
                        from: head,
                        to: to,
                        insert: insert
                    }
                };
            }
        } else if (didType && text == "/" && after.name == "IncompleteCloseTag") {
            let tag = after.parent;
            if (after.from == head - 2 && ((_c = tag.lastChild) === null || _c === void 0 ? void 0 : _c.name) != "CloseTag" && (name = $b89c3ee08b45bae9$var$elementName(state.doc, tag, head)) && !$b89c3ee08b45bae9$var$selfClosers.has(name)) {
                let to = head + (state.doc.sliceString(head, head + 1) === ">" ? 1 : 0);
                let insert = `${name}>`;
                return {
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(head + insert.length, -1),
                    changes: {
                        from: head,
                        to: to,
                        insert: insert
                    }
                };
            }
        }
        return {
            range: range
        };
    });
    if (closeTags.changes.empty) return false;
    view.dispatch([
        base,
        state.update(closeTags, {
            userEvent: "input.complete",
            scrollIntoView: true
        })
    ]);
    return true;
});






class $1e126942d86629f6$var$SelectedDiagnostic {
    constructor(from, to, diagnostic){
        this.from = from;
        this.to = to;
        this.diagnostic = diagnostic;
    }
}
class $1e126942d86629f6$var$LintState {
    constructor(diagnostics, panel, selected){
        this.diagnostics = diagnostics;
        this.panel = panel;
        this.selected = selected;
    }
    static init(diagnostics, panel, state) {
        // Filter the list of diagnostics for which to create markers
        let diagnosticFilter = state.facet($1e126942d86629f6$var$lintConfig).markerFilter;
        if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics, state);
        let sorted = diagnostics.slice().sort((a, b)=>a.from - b.from || a.to - b.to);
        let deco = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)(), active = [], pos = 0;
        let scan = state.doc.iter(), scanPos = 0, docLen = state.doc.length;
        for(let i = 0;;){
            let next = i == sorted.length ? null : sorted[i];
            if (!next && !active.length) break;
            let from, to;
            if (active.length) {
                from = pos;
                to = active.reduce((p, d)=>Math.min(p, d.to), next && next.from > from ? next.from : 1e8);
            } else {
                from = next.from;
                if (from > docLen) break;
                to = next.to;
                active.push(next);
                i++;
            }
            while(i < sorted.length){
                let next = sorted[i];
                if (next.from == from && (next.to > next.from || next.to == from)) {
                    active.push(next);
                    i++;
                    to = Math.min(next.to, to);
                } else {
                    to = Math.min(next.from, to);
                    break;
                }
            }
            to = Math.min(to, docLen);
            let widget = false;
            if (active.some((d)=>d.from == from && (d.to == to || to == docLen))) {
                widget = from == to;
                if (!widget && to - from < 10) {
                    let behind = from - (scanPos + scan.value.length);
                    if (behind > 0) {
                        scan.next(behind);
                        scanPos = from;
                    }
                    for(let check = from;;){
                        if (check >= to) {
                            widget = true;
                            break;
                        }
                        if (!scan.lineBreak && scanPos + scan.value.length > check) break;
                        check = scanPos + scan.value.length;
                        scanPos += scan.value.length;
                        scan.next();
                    }
                }
            }
            let sev = $1e126942d86629f6$var$maxSeverity(active);
            if (widget) deco.add(from, from, (0, $7beee9608540d2c3$export$10e30b733df217ea).widget({
                widget: new $1e126942d86629f6$var$DiagnosticWidget(sev),
                diagnostics: active.slice()
            }));
            else {
                let markClass = active.reduce((c, d)=>d.markClass ? c + " " + d.markClass : c, "");
                deco.add(from, to, (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
                    class: "cm-lintRange cm-lintRange-" + sev + markClass,
                    diagnostics: active.slice(),
                    inclusiveEnd: active.some((a)=>a.to > to)
                }));
            }
            pos = to;
            if (pos == docLen) break;
            for(let i = 0; i < active.length; i++)if (active[i].to <= pos) active.splice(i--, 1);
        }
        let set = deco.finish();
        return new $1e126942d86629f6$var$LintState(set, panel, $1e126942d86629f6$var$findDiagnostic(set));
    }
}
function $1e126942d86629f6$var$findDiagnostic(diagnostics, diagnostic = null, after = 0) {
    let found = null;
    diagnostics.between(after, 1e9, (from, to, { spec: spec })=>{
        if (diagnostic && spec.diagnostics.indexOf(diagnostic) < 0) return;
        if (!found) found = new $1e126942d86629f6$var$SelectedDiagnostic(from, to, diagnostic || spec.diagnostics[0]);
        else if (spec.diagnostics.indexOf(found.diagnostic) < 0) return false;
        else found = new $1e126942d86629f6$var$SelectedDiagnostic(found.from, to, found.diagnostic);
    });
    return found;
}
function $1e126942d86629f6$var$hideTooltip(tr, tooltip) {
    let from = tooltip.pos, to = tooltip.end || from;
    let result = tr.state.facet($1e126942d86629f6$var$lintConfig).hideOn(tr, from, to);
    if (result != null) return result;
    let line = tr.startState.doc.lineAt(tooltip.pos);
    return !!(tr.effects.some((e)=>e.is($1e126942d86629f6$export$9c7976977981c7bf)) || tr.changes.touchesRange(line.from, Math.max(line.to, to)));
}
function $1e126942d86629f6$var$maybeEnableLint(state, effects) {
    return state.field($1e126942d86629f6$var$lintState, false) ? effects : effects.concat((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($1e126942d86629f6$var$lintExtensions));
}
/**
Returns a transaction spec which updates the current set of
diagnostics, and enables the lint extension if if wasn't already
active.
*/ function $1e126942d86629f6$export$188c3c6ceeec4bb3(state, diagnostics) {
    return {
        effects: $1e126942d86629f6$var$maybeEnableLint(state, [
            $1e126942d86629f6$export$9c7976977981c7bf.of(diagnostics)
        ])
    };
}
/**
The state effect that updates the set of active diagnostics. Can
be useful when writing an extension that needs to track these.
*/ const $1e126942d86629f6$export$9c7976977981c7bf = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$togglePanel = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$movePanelSelection = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$lintState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return new $1e126942d86629f6$var$LintState((0, $7beee9608540d2c3$export$10e30b733df217ea).none, null, null);
    },
    update (value, tr) {
        if (tr.docChanged && value.diagnostics.size) {
            let mapped = value.diagnostics.map(tr.changes), selected = null, panel = value.panel;
            if (value.selected) {
                let selPos = tr.changes.mapPos(value.selected.from, 1);
                selected = $1e126942d86629f6$var$findDiagnostic(mapped, value.selected.diagnostic, selPos) || $1e126942d86629f6$var$findDiagnostic(mapped, null, selPos);
            }
            if (!mapped.size && panel && tr.state.facet($1e126942d86629f6$var$lintConfig).autoPanel) panel = null;
            value = new $1e126942d86629f6$var$LintState(mapped, panel, selected);
        }
        for (let effect of tr.effects){
            if (effect.is($1e126942d86629f6$export$9c7976977981c7bf)) {
                let panel = !tr.state.facet($1e126942d86629f6$var$lintConfig).autoPanel ? value.panel : effect.value.length ? $1e126942d86629f6$var$LintPanel.open : null;
                value = $1e126942d86629f6$var$LintState.init(effect.value, panel, tr.state);
            } else if (effect.is($1e126942d86629f6$var$togglePanel)) value = new $1e126942d86629f6$var$LintState(value.diagnostics, effect.value ? $1e126942d86629f6$var$LintPanel.open : null, value.selected);
            else if (effect.is($1e126942d86629f6$var$movePanelSelection)) value = new $1e126942d86629f6$var$LintState(value.diagnostics, value.panel, effect.value);
        }
        return value;
    },
    provide: (f)=>[
            (0, $7beee9608540d2c3$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel),
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f, (s)=>s.diagnostics)
        ]
});
/**
Returns the number of active lint diagnostics in the given state.
*/ function $1e126942d86629f6$export$31ce51ade4a789ff(state) {
    let lint = state.field($1e126942d86629f6$var$lintState, false);
    return lint ? lint.diagnostics.size : 0;
}
const $1e126942d86629f6$var$activeMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-lintRange cm-lintRange-active"
});
function $1e126942d86629f6$var$lintTooltip(view, pos, side) {
    let { diagnostics: diagnostics } = view.state.field($1e126942d86629f6$var$lintState);
    let found, start = -1, end = -1;
    diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to, { spec: spec })=>{
        if (pos >= from && pos <= to && (from == to || (pos > from || side > 0) && (pos < to || side < 0))) {
            found = spec.diagnostics;
            start = from;
            end = to;
            return false;
        }
    });
    let diagnosticFilter = view.state.facet($1e126942d86629f6$var$lintConfig).tooltipFilter;
    if (found && diagnosticFilter) found = diagnosticFilter(found, view.state);
    if (!found) return null;
    return {
        pos: start,
        end: end,
        above: view.state.doc.lineAt(start).to < end,
        create () {
            return {
                dom: $1e126942d86629f6$var$diagnosticsTooltip(view, found)
            };
        }
    };
}
function $1e126942d86629f6$var$diagnosticsTooltip(view, diagnostics) {
    return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("ul", {
        class: "cm-tooltip-lint"
    }, diagnostics.map((d)=>$1e126942d86629f6$var$renderDiagnostic(view, d, false)));
}
/**
Command to open and focus the lint panel.
*/ const $1e126942d86629f6$export$5c4e65c70e8c34a7 = (view)=>{
    let field = view.state.field($1e126942d86629f6$var$lintState, false);
    if (!field || !field.panel) view.dispatch({
        effects: $1e126942d86629f6$var$maybeEnableLint(view.state, [
            $1e126942d86629f6$var$togglePanel.of(true)
        ])
    });
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $1e126942d86629f6$var$LintPanel.open);
    if (panel) panel.dom.querySelector(".cm-panel-lint ul").focus();
    return true;
};
/**
Command to close the lint panel, when open.
*/ const $1e126942d86629f6$export$2ee372c3e690e3c3 = (view)=>{
    let field = view.state.field($1e126942d86629f6$var$lintState, false);
    if (!field || !field.panel) return false;
    view.dispatch({
        effects: $1e126942d86629f6$var$togglePanel.of(false)
    });
    return true;
};
/**
Move the selection to the next diagnostic.
*/ const $1e126942d86629f6$export$79abb131646e1359 = (view)=>{
    let field = view.state.field($1e126942d86629f6$var$lintState, false);
    if (!field) return false;
    let sel = view.state.selection.main, next = field.diagnostics.iter(sel.to + 1);
    if (!next.value) {
        next = field.diagnostics.iter(0);
        if (!next.value || next.from == sel.from && next.to == sel.to) return false;
    }
    view.dispatch({
        selection: {
            anchor: next.from,
            head: next.to
        },
        scrollIntoView: true
    });
    return true;
};
/**
Move the selection to the previous diagnostic.
*/ const $1e126942d86629f6$export$f71c1dd1430b5cc1 = (view)=>{
    let { state: state } = view, field = state.field($1e126942d86629f6$var$lintState, false);
    if (!field) return false;
    let sel = state.selection.main;
    let prevFrom, prevTo, lastFrom, lastTo;
    field.diagnostics.between(0, state.doc.length, (from, to)=>{
        if (to < sel.to && (prevFrom == null || prevFrom < from)) {
            prevFrom = from;
            prevTo = to;
        }
        if (lastFrom == null || from > lastFrom) {
            lastFrom = from;
            lastTo = to;
        }
    });
    if (lastFrom == null || prevFrom == null && lastFrom == sel.from) return false;
    view.dispatch({
        selection: {
            anchor: prevFrom !== null && prevFrom !== void 0 ? prevFrom : lastFrom,
            head: prevTo !== null && prevTo !== void 0 ? prevTo : lastTo
        },
        scrollIntoView: true
    });
    return true;
};
/**
A set of default key bindings for the lint functionality.

- Ctrl-Shift-m (Cmd-Shift-m on macOS): [`openLintPanel`](https://codemirror.net/6/docs/ref/#lint.openLintPanel)
- F8: [`nextDiagnostic`](https://codemirror.net/6/docs/ref/#lint.nextDiagnostic)
*/ const $1e126942d86629f6$export$a21d7a0cde3cbb60 = [
    {
        key: "Mod-Shift-m",
        run: $1e126942d86629f6$export$5c4e65c70e8c34a7,
        preventDefault: true
    },
    {
        key: "F8",
        run: $1e126942d86629f6$export$79abb131646e1359
    }
];
const $1e126942d86629f6$var$lintPlugin = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.timeout = -1;
        this.set = true;
        let { delay: delay } = view.state.facet($1e126942d86629f6$var$lintConfig);
        this.lintTime = Date.now() + delay;
        this.run = this.run.bind(this);
        this.timeout = setTimeout(this.run, delay);
    }
    run() {
        clearTimeout(this.timeout);
        let now = Date.now();
        if (now < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - now);
        else {
            this.set = false;
            let { state: state } = this.view, { sources: sources } = state.facet($1e126942d86629f6$var$lintConfig);
            if (sources.length) $1e126942d86629f6$var$batchResults(sources.map((s)=>Promise.resolve(s(this.view))), (annotations)=>{
                if (this.view.state.doc == state.doc) this.view.dispatch($1e126942d86629f6$export$188c3c6ceeec4bb3(this.view.state, annotations.reduce((a, b)=>a.concat(b))));
            }, (error)=>{
                (0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, error);
            });
        }
    }
    update(update) {
        let config = update.state.facet($1e126942d86629f6$var$lintConfig);
        if (update.docChanged || config != update.startState.facet($1e126942d86629f6$var$lintConfig) || config.needsRefresh && config.needsRefresh(update)) {
            this.lintTime = Date.now() + config.delay;
            if (!this.set) {
                this.set = true;
                this.timeout = setTimeout(this.run, config.delay);
            }
        }
    }
    force() {
        if (this.set) {
            this.lintTime = Date.now();
            this.run();
        }
    }
    destroy() {
        clearTimeout(this.timeout);
    }
});
function $1e126942d86629f6$var$batchResults(promises, sink, error) {
    let collected = [], timeout = -1;
    for (let p of promises)p.then((value)=>{
        collected.push(value);
        clearTimeout(timeout);
        if (collected.length == promises.length) sink(collected);
        else timeout = setTimeout(()=>sink(collected), 200);
    }, error);
}
const $1e126942d86629f6$var$lintConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (input) {
        return {
            sources: input.map((i)=>i.source).filter((x)=>x != null),
            ...(0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(input.map((i)=>i.config), {
                delay: 750,
                markerFilter: null,
                tooltipFilter: null,
                needsRefresh: null,
                hideOn: ()=>null
            }, {
                delay: Math.max,
                markerFilter: $1e126942d86629f6$var$combineFilter,
                tooltipFilter: $1e126942d86629f6$var$combineFilter,
                needsRefresh: (a, b)=>!a ? b : !b ? a : (u)=>a(u) || b(u),
                hideOn: (a, b)=>!a ? b : !b ? a : (t, x, y)=>a(t, x, y) || b(t, x, y),
                autoPanel: (a, b)=>a || b
            })
        };
    }
});
function $1e126942d86629f6$var$combineFilter(a, b) {
    return !a ? b : !b ? a : (d, s)=>b(a(d, s), s);
}
/**
Given a diagnostic source, this function returns an extension that
enables linting with that source. It will be called whenever the
editor is idle (after its content changed).

Note that settings given here will apply to all linters active in
the editor. If `null` is given as source, this only configures the
lint extension.
*/ function $1e126942d86629f6$export$8bb7ef7a8be4cb1c(source, config = {}) {
    return [
        $1e126942d86629f6$var$lintConfig.of({
            source: source,
            config: config
        }),
        $1e126942d86629f6$var$lintPlugin,
        $1e126942d86629f6$var$lintExtensions
    ];
}
/**
Forces any linters [configured](https://codemirror.net/6/docs/ref/#lint.linter) to run when the
editor is idle to run right away.
*/ function $1e126942d86629f6$export$e917f1893924e285(view) {
    let plugin = view.plugin($1e126942d86629f6$var$lintPlugin);
    if (plugin) plugin.force();
}
function $1e126942d86629f6$var$assignKeys(actions) {
    let assigned = [];
    if (actions) actions: for (let { name: name } of actions){
        for(let i = 0; i < name.length; i++){
            let ch = name[i];
            if (/[a-zA-Z]/.test(ch) && !assigned.some((c)=>c.toLowerCase() == ch.toLowerCase())) {
                assigned.push(ch);
                continue actions;
            }
        }
        assigned.push("");
    }
    return assigned;
}
function $1e126942d86629f6$var$renderDiagnostic(view, diagnostic, inPanel) {
    var _a;
    let keys = inPanel ? $1e126942d86629f6$var$assignKeys(diagnostic.actions) : [];
    return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("li", {
        class: "cm-diagnostic cm-diagnostic-" + diagnostic.severity
    }, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("span", {
        class: "cm-diagnosticText"
    }, diagnostic.renderMessage ? diagnostic.renderMessage(view) : diagnostic.message), (_a = diagnostic.actions) === null || _a === void 0 ? void 0 : _a.map((action, i)=>{
        let fired = false, click = (e)=>{
            e.preventDefault();
            if (fired) return;
            fired = true;
            let found = $1e126942d86629f6$var$findDiagnostic(view.state.field($1e126942d86629f6$var$lintState).diagnostics, diagnostic);
            if (found) action.apply(view, found.from, found.to);
        };
        let { name: name } = action, keyIndex = keys[i] ? name.indexOf(keys[i]) : -1;
        let nameElt = keyIndex < 0 ? name : [
            name.slice(0, keyIndex),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("u", name.slice(keyIndex, keyIndex + 1)),
            name.slice(keyIndex + 1)
        ];
        let markClass = action.markClass ? " " + action.markClass : "";
        return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
            type: "button",
            class: "cm-diagnosticAction" + markClass,
            onclick: click,
            onmousedown: click,
            "aria-label": ` Action: ${name}${keyIndex < 0 ? "" : ` (access key "${keys[i]})"`}.`
        }, nameElt);
    }), diagnostic.source && (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", {
        class: "cm-diagnosticSource"
    }, diagnostic.source));
}
class $1e126942d86629f6$var$DiagnosticWidget extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
    constructor(sev){
        super();
        this.sev = sev;
    }
    eq(other) {
        return other.sev == this.sev;
    }
    toDOM() {
        return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("span", {
            class: "cm-lintPoint cm-lintPoint-" + this.sev
        });
    }
}
class $1e126942d86629f6$var$PanelItem {
    constructor(view, diagnostic){
        this.diagnostic = diagnostic;
        this.id = "item_" + Math.floor(Math.random() * 0xffffffff).toString(16);
        this.dom = $1e126942d86629f6$var$renderDiagnostic(view, diagnostic, true);
        this.dom.id = this.id;
        this.dom.setAttribute("role", "option");
    }
}
class $1e126942d86629f6$var$LintPanel {
    constructor(view){
        this.view = view;
        this.items = [];
        let onkeydown = (event)=>{
            if (event.keyCode == 27) {
                $1e126942d86629f6$export$2ee372c3e690e3c3(this.view);
                this.view.focus();
            } else if (event.keyCode == 38 || event.keyCode == 33) this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
            else if (event.keyCode == 40 || event.keyCode == 34) this.moveSelection((this.selectedIndex + 1) % this.items.length);
            else if (event.keyCode == 36) this.moveSelection(0);
            else if (event.keyCode == 35) this.moveSelection(this.items.length - 1);
            else if (event.keyCode == 13) this.view.focus();
            else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
                let { diagnostic: diagnostic } = this.items[this.selectedIndex], keys = $1e126942d86629f6$var$assignKeys(diagnostic.actions);
                for(let i = 0; i < keys.length; i++)if (keys[i].toUpperCase().charCodeAt(0) == event.keyCode) {
                    let found = $1e126942d86629f6$var$findDiagnostic(this.view.state.field($1e126942d86629f6$var$lintState).diagnostics, diagnostic);
                    if (found) diagnostic.actions[i].apply(view, found.from, found.to);
                }
            } else return;
            event.preventDefault();
        };
        let onclick = (event)=>{
            for(let i = 0; i < this.items.length; i++)if (this.items[i].dom.contains(event.target)) this.moveSelection(i);
        };
        this.list = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("ul", {
            tabIndex: 0,
            role: "listbox",
            "aria-label": this.view.state.phrase("Diagnostics"),
            onkeydown: onkeydown,
            onclick: onclick
        });
        this.dom = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", {
            class: "cm-panel-lint"
        }, this.list, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
            type: "button",
            name: "close",
            "aria-label": this.view.state.phrase("close"),
            onclick: ()=>$1e126942d86629f6$export$2ee372c3e690e3c3(this.view)
        }, "\xd7"));
        this.update();
    }
    get selectedIndex() {
        let selected = this.view.state.field($1e126942d86629f6$var$lintState).selected;
        if (!selected) return -1;
        for(let i = 0; i < this.items.length; i++)if (this.items[i].diagnostic == selected.diagnostic) return i;
        return -1;
    }
    update() {
        let { diagnostics: diagnostics, selected: selected } = this.view.state.field($1e126942d86629f6$var$lintState);
        let i = 0, needsSync = false, newSelectedItem = null;
        let seen = new Set();
        diagnostics.between(0, this.view.state.doc.length, (_start, _end, { spec: spec })=>{
            for (let diagnostic of spec.diagnostics){
                if (seen.has(diagnostic)) continue;
                seen.add(diagnostic);
                let found = -1, item;
                for(let j = i; j < this.items.length; j++)if (this.items[j].diagnostic == diagnostic) {
                    found = j;
                    break;
                }
                if (found < 0) {
                    item = new $1e126942d86629f6$var$PanelItem(this.view, diagnostic);
                    this.items.splice(i, 0, item);
                    needsSync = true;
                } else {
                    item = this.items[found];
                    if (found > i) {
                        this.items.splice(i, found - i);
                        needsSync = true;
                    }
                }
                if (selected && item.diagnostic == selected.diagnostic) {
                    if (!item.dom.hasAttribute("aria-selected")) {
                        item.dom.setAttribute("aria-selected", "true");
                        newSelectedItem = item;
                    }
                } else if (item.dom.hasAttribute("aria-selected")) item.dom.removeAttribute("aria-selected");
                i++;
            }
        });
        while(i < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)){
            needsSync = true;
            this.items.pop();
        }
        if (this.items.length == 0) {
            this.items.push(new $1e126942d86629f6$var$PanelItem(this.view, {
                from: -1,
                to: -1,
                severity: "info",
                message: this.view.state.phrase("No diagnostics")
            }));
            needsSync = true;
        }
        if (newSelectedItem) {
            this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
            this.view.requestMeasure({
                key: this,
                read: ()=>({
                        sel: newSelectedItem.dom.getBoundingClientRect(),
                        panel: this.list.getBoundingClientRect()
                    }),
                write: ({ sel: sel, panel: panel })=>{
                    let scaleY = panel.height / this.list.offsetHeight;
                    if (sel.top < panel.top) this.list.scrollTop -= (panel.top - sel.top) / scaleY;
                    else if (sel.bottom > panel.bottom) this.list.scrollTop += (sel.bottom - panel.bottom) / scaleY;
                }
            });
        } else if (this.selectedIndex < 0) this.list.removeAttribute("aria-activedescendant");
        if (needsSync) this.sync();
    }
    sync() {
        let domPos = this.list.firstChild;
        function rm() {
            let prev = domPos;
            domPos = prev.nextSibling;
            prev.remove();
        }
        for (let item of this.items)if (item.dom.parentNode == this.list) {
            while(domPos != item.dom)rm();
            domPos = item.dom.nextSibling;
        } else this.list.insertBefore(item.dom, domPos);
        while(domPos)rm();
    }
    moveSelection(selectedIndex) {
        if (this.selectedIndex < 0) return;
        let field = this.view.state.field($1e126942d86629f6$var$lintState);
        let selection = $1e126942d86629f6$var$findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
        if (!selection) return;
        this.view.dispatch({
            selection: {
                anchor: selection.from,
                head: selection.to
            },
            scrollIntoView: true,
            effects: $1e126942d86629f6$var$movePanelSelection.of(selection)
        });
    }
    static open(view) {
        return new $1e126942d86629f6$var$LintPanel(view);
    }
}
function $1e126942d86629f6$var$svg(content, attrs = `viewBox="0 0 40 40"`) {
    return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content)}</svg>')`;
}
function $1e126942d86629f6$var$underline(color) {
    return $1e126942d86629f6$var$svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
const $1e126942d86629f6$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-diagnostic": {
        padding: "3px 6px 3px 8px",
        marginLeft: "-1px",
        display: "block",
        whiteSpace: "pre-wrap"
    },
    ".cm-diagnostic-error": {
        borderLeft: "5px solid #d11"
    },
    ".cm-diagnostic-warning": {
        borderLeft: "5px solid orange"
    },
    ".cm-diagnostic-info": {
        borderLeft: "5px solid #999"
    },
    ".cm-diagnostic-hint": {
        borderLeft: "5px solid #66d"
    },
    ".cm-diagnosticAction": {
        font: "inherit",
        border: "none",
        padding: "2px 4px",
        backgroundColor: "#444",
        color: "white",
        borderRadius: "3px",
        marginLeft: "8px",
        cursor: "pointer"
    },
    ".cm-diagnosticSource": {
        fontSize: "70%",
        opacity: .7
    },
    ".cm-lintRange": {
        backgroundPosition: "left bottom",
        backgroundRepeat: "repeat-x",
        paddingBottom: "0.7px"
    },
    ".cm-lintRange-error": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("#d11")
    },
    ".cm-lintRange-warning": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("orange")
    },
    ".cm-lintRange-info": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("#999")
    },
    ".cm-lintRange-hint": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("#66d")
    },
    ".cm-lintRange-active": {
        backgroundColor: "#ffdd9980"
    },
    ".cm-tooltip-lint": {
        padding: 0,
        margin: 0
    },
    ".cm-lintPoint": {
        position: "relative",
        "&:after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "-2px",
            borderLeft: "3px solid transparent",
            borderRight: "3px solid transparent",
            borderBottom: "4px solid #d11"
        }
    },
    ".cm-lintPoint-warning": {
        "&:after": {
            borderBottomColor: "orange"
        }
    },
    ".cm-lintPoint-info": {
        "&:after": {
            borderBottomColor: "#999"
        }
    },
    ".cm-lintPoint-hint": {
        "&:after": {
            borderBottomColor: "#66d"
        }
    },
    ".cm-panel.cm-panel-lint": {
        position: "relative",
        "& ul": {
            maxHeight: "100px",
            overflowY: "auto",
            "& [aria-selected]": {
                backgroundColor: "#ddd",
                "& u": {
                    textDecoration: "underline"
                }
            },
            "&:focus [aria-selected]": {
                background_fallback: "#bdf",
                backgroundColor: "Highlight",
                color_fallback: "white",
                color: "HighlightText"
            },
            "& u": {
                textDecoration: "none"
            },
            padding: 0,
            margin: 0
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "2px",
            background: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        }
    }
});
function $1e126942d86629f6$var$severityWeight(sev) {
    return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
function $1e126942d86629f6$var$maxSeverity(diagnostics) {
    let sev = "hint", weight = 1;
    for (let d of diagnostics){
        let w = $1e126942d86629f6$var$severityWeight(d.severity);
        if (w > weight) {
            weight = w;
            sev = d.severity;
        }
    }
    return sev;
}
class $1e126942d86629f6$var$LintGutterMarker extends (0, $7beee9608540d2c3$export$591ab4c909549043) {
    constructor(diagnostics){
        super();
        this.diagnostics = diagnostics;
        this.severity = $1e126942d86629f6$var$maxSeverity(diagnostics);
    }
    toDOM(view) {
        let elt = document.createElement("div");
        elt.className = "cm-lint-marker cm-lint-marker-" + this.severity;
        let diagnostics = this.diagnostics;
        let diagnosticsFilter = view.state.facet($1e126942d86629f6$var$lintGutterConfig).tooltipFilter;
        if (diagnosticsFilter) diagnostics = diagnosticsFilter(diagnostics, view.state);
        if (diagnostics.length) elt.onmouseover = ()=>$1e126942d86629f6$var$gutterMarkerMouseOver(view, elt, diagnostics);
        return elt;
    }
}
function $1e126942d86629f6$var$trackHoverOn(view, marker) {
    let mousemove = (event)=>{
        let rect = marker.getBoundingClientRect();
        if (event.clientX > rect.left - 10 /* Hover.Margin */  && event.clientX < rect.right + 10 /* Hover.Margin */  && event.clientY > rect.top - 10 /* Hover.Margin */  && event.clientY < rect.bottom + 10 /* Hover.Margin */ ) return;
        for(let target = event.target; target; target = target.parentNode){
            if (target.nodeType == 1 && target.classList.contains("cm-tooltip-lint")) return;
        }
        window.removeEventListener("mousemove", mousemove);
        if (view.state.field($1e126942d86629f6$var$lintGutterTooltip)) view.dispatch({
            effects: $1e126942d86629f6$var$setLintGutterTooltip.of(null)
        });
    };
    window.addEventListener("mousemove", mousemove);
}
function $1e126942d86629f6$var$gutterMarkerMouseOver(view, marker, diagnostics) {
    function hovered() {
        let line = view.elementAtHeight(marker.getBoundingClientRect().top + 5 - view.documentTop);
        const linePos = view.coordsAtPos(line.from);
        if (linePos) view.dispatch({
            effects: $1e126942d86629f6$var$setLintGutterTooltip.of({
                pos: line.from,
                above: false,
                clip: false,
                create () {
                    return {
                        dom: $1e126942d86629f6$var$diagnosticsTooltip(view, diagnostics),
                        getCoords: ()=>marker.getBoundingClientRect()
                    };
                }
            })
        });
        marker.onmouseout = marker.onmousemove = null;
        $1e126942d86629f6$var$trackHoverOn(view, marker);
    }
    let { hoverTime: hoverTime } = view.state.facet($1e126942d86629f6$var$lintGutterConfig);
    let hoverTimeout = setTimeout(hovered, hoverTime);
    marker.onmouseout = ()=>{
        clearTimeout(hoverTimeout);
        marker.onmouseout = marker.onmousemove = null;
    };
    marker.onmousemove = ()=>{
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(hovered, hoverTime);
    };
}
function $1e126942d86629f6$var$markersForDiagnostics(doc, diagnostics) {
    let byLine = Object.create(null);
    for (let diagnostic of diagnostics){
        let line = doc.lineAt(diagnostic.from);
        (byLine[line.from] || (byLine[line.from] = [])).push(diagnostic);
    }
    let markers = [];
    for(let line in byLine)markers.push(new $1e126942d86629f6$var$LintGutterMarker(byLine[line]).range(+line));
    return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(markers, true);
}
const $1e126942d86629f6$var$lintGutterExtension = /*@__PURE__*/ (0, $7beee9608540d2c3$export$f2b922cb4a245974)({
    class: "cm-gutter-lint",
    markers: (view)=>view.state.field($1e126942d86629f6$var$lintGutterMarkers),
    widgetMarker: (view, widget, block)=>{
        let diagnostics = [];
        view.state.field($1e126942d86629f6$var$lintGutterMarkers).between(block.from, block.to, (from, to, value)=>{
            if (from > block.from && from < block.to) diagnostics.push(...value.diagnostics);
        });
        return diagnostics.length ? new $1e126942d86629f6$var$LintGutterMarker(diagnostics) : null;
    }
});
const $1e126942d86629f6$var$lintGutterMarkers = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
    },
    update (markers, tr) {
        markers = markers.map(tr.changes);
        let diagnosticFilter = tr.state.facet($1e126942d86629f6$var$lintGutterConfig).markerFilter;
        for (let effect of tr.effects)if (effect.is($1e126942d86629f6$export$9c7976977981c7bf)) {
            let diagnostics = effect.value;
            if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics || [], tr.state);
            markers = $1e126942d86629f6$var$markersForDiagnostics(tr.state.doc, diagnostics.slice(0));
        }
        return markers;
    }
});
const $1e126942d86629f6$var$setLintGutterTooltip = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$lintGutterTooltip = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (tooltip, tr) {
        if (tooltip && tr.docChanged) tooltip = $1e126942d86629f6$var$hideTooltip(tr, tooltip) ? null : {
            ...tooltip,
            pos: tr.changes.mapPos(tooltip.pos)
        };
        return tr.effects.reduce((t, e)=>e.is($1e126942d86629f6$var$setLintGutterTooltip) ? e.value : t, tooltip);
    },
    provide: (field)=>(0, $7beee9608540d2c3$export$dba11b50e1aa3c12).from(field)
});
const $1e126942d86629f6$var$lintGutterTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-gutter-lint": {
        width: "1.4em",
        "& .cm-gutterElement": {
            padding: ".2em"
        }
    },
    ".cm-lint-marker": {
        width: "1em",
        height: "1em"
    },
    ".cm-lint-marker-info": {
        content: /*@__PURE__*/ $1e126942d86629f6$var$svg(`<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>`)
    },
    ".cm-lint-marker-warning": {
        content: /*@__PURE__*/ $1e126942d86629f6$var$svg(`<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>`)
    },
    ".cm-lint-marker-error": {
        content: /*@__PURE__*/ $1e126942d86629f6$var$svg(`<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>`)
    }
});
const $1e126942d86629f6$var$lintExtensions = [
    $1e126942d86629f6$var$lintState,
    /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.compute([
        $1e126942d86629f6$var$lintState
    ], (state)=>{
        let { selected: selected, panel: panel } = state.field($1e126942d86629f6$var$lintState);
        return !selected || !panel || selected.from == selected.to ? (0, $7beee9608540d2c3$export$10e30b733df217ea).none : (0, $7beee9608540d2c3$export$10e30b733df217ea).set([
            $1e126942d86629f6$var$activeMark.range(selected.from, selected.to)
        ]);
    }),
    /*@__PURE__*/ (0, $7beee9608540d2c3$export$69f8d9e63c4aa884)($1e126942d86629f6$var$lintTooltip, {
        hideOn: $1e126942d86629f6$var$hideTooltip
    }),
    $1e126942d86629f6$var$baseTheme
];
const $1e126942d86629f6$var$lintGutterConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            hoverTime: 300 /* Hover.Time */ ,
            markerFilter: null,
            tooltipFilter: null
        });
    }
});
/**
Returns an extension that installs a gutter showing markers for
each line that has diagnostics, which can be hovered over to see
the diagnostics.
*/ function $1e126942d86629f6$export$3a68dabf7c007d32(config = {}) {
    return [
        $1e126942d86629f6$var$lintGutterConfig.of(config),
        $1e126942d86629f6$var$lintGutterMarkers,
        $1e126942d86629f6$var$lintGutterExtension,
        $1e126942d86629f6$var$lintGutterTheme,
        $1e126942d86629f6$var$lintGutterTooltip
    ];
}
/**
Iterate over the marked diagnostics for the given editor state,
calling `f` for each of them. Note that, if the document changed
since the diagnostics were created, the `Diagnostic` object will
hold the original outdated position, whereas the `to` and `from`
arguments hold the diagnostic's current position.
*/ function $1e126942d86629f6$export$7991d57589868fb2(state, f) {
    let lState = state.field($1e126942d86629f6$var$lintState, false);
    if (lState && lState.diagnostics.size) {
        let pending = [], pendingStart = [], lastEnd = -1;
        for(let iter = (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter([
            lState.diagnostics
        ]);; iter.next()){
            for(let i = 0; i < pending.length; i++)if (!iter.value || iter.value.spec.diagnostics.indexOf(pending[i]) < 0) {
                f(pending[i], pendingStart[i], lastEnd);
                pending.splice(i, 1);
                pendingStart.splice(i--, 1);
            }
            if (!iter.value) break;
            for (let d of iter.value.spec.diagnostics)if (pending.indexOf(d) < 0) {
                pending.push(d);
                pendingStart.push(iter.from);
            }
            lastEnd = iter.to;
        }
    }
}





const $976a3faeb93466fd$var$basicNormalize = typeof String.prototype.normalize == "function" ? (x)=>x.normalize("NFKD") : (x)=>x;
/**
A search cursor provides an iterator over text matches in a
document.
*/ class $976a3faeb93466fd$export$4989b254f32490be {
    /**
    Create a text cursor. The query is the search string, `from` to
    `to` provides the region to search.
    
    When `normalize` is given, it will be called, on both the query
    string and the content it is matched against, before comparing.
    You can, for example, create a case-insensitive search by
    passing `s => s.toLowerCase()`.
    
    Text is always normalized with
    [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
    (when supported).
    */ constructor(text, query, from = 0, to = text.length, normalize, test){
        this.test = test;
        /**
        The current match (only holds a meaningful value after
        [`next`](https://codemirror.net/6/docs/ref/#search.SearchCursor.next) has been called and when
        `done` is false).
        */ this.value = {
            from: 0,
            to: 0
        };
        /**
        Whether the end of the iterated region has been reached.
        */ this.done = false;
        this.matches = [];
        this.buffer = "";
        this.bufferPos = 0;
        this.iter = text.iterRange(from, to);
        this.bufferStart = from;
        this.normalize = normalize ? (x)=>normalize($976a3faeb93466fd$var$basicNormalize(x)) : $976a3faeb93466fd$var$basicNormalize;
        this.query = this.normalize(query);
    }
    peek() {
        if (this.bufferPos == this.buffer.length) {
            this.bufferStart += this.buffer.length;
            this.iter.next();
            if (this.iter.done) return -1;
            this.bufferPos = 0;
            this.buffer = this.iter.value;
        }
        return (0, $6295c6875f57e3ee$export$42977f40461e1360)(this.buffer, this.bufferPos);
    }
    /**
    Look for the next match. Updates the iterator's
    [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
    [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
    at least once before using the cursor.
    */ next() {
        while(this.matches.length)this.matches.pop();
        return this.nextOverlapping();
    }
    /**
    The `next` method will ignore matches that partially overlap a
    previous match. This method behaves like `next`, but includes
    such matches.
    */ nextOverlapping() {
        for(;;){
            let next = this.peek();
            if (next < 0) {
                this.done = true;
                return this;
            }
            let str = (0, $6295c6875f57e3ee$export$73bfc63873071f74)(next), start = this.bufferStart + this.bufferPos;
            this.bufferPos += (0, $6295c6875f57e3ee$export$a870abf234f6353c)(next);
            let norm = this.normalize(str);
            if (norm.length) for(let i = 0, pos = start;; i++){
                let code = norm.charCodeAt(i);
                let match = this.match(code, pos, this.bufferPos + this.bufferStart);
                if (i == norm.length - 1) {
                    if (match) {
                        this.value = match;
                        return this;
                    }
                    break;
                }
                if (pos == start && i < str.length && str.charCodeAt(i) == code) pos++;
            }
        }
    }
    match(code, pos, end) {
        let match = null;
        for(let i = 0; i < this.matches.length; i += 2){
            let index = this.matches[i], keep = false;
            if (this.query.charCodeAt(index) == code) {
                if (index == this.query.length - 1) match = {
                    from: this.matches[i + 1],
                    to: end
                };
                else {
                    this.matches[i]++;
                    keep = true;
                }
            }
            if (!keep) {
                this.matches.splice(i, 2);
                i -= 2;
            }
        }
        if (this.query.charCodeAt(0) == code) {
            if (this.query.length == 1) match = {
                from: pos,
                to: end
            };
            else this.matches.push(1, pos);
        }
        if (match && this.test && !this.test(match.from, match.to, this.buffer, this.bufferStart)) match = null;
        return match;
    }
}
if (typeof Symbol != "undefined") $976a3faeb93466fd$export$4989b254f32490be.prototype[Symbol.iterator] = function() {
    return this;
};
const $976a3faeb93466fd$var$empty = {
    from: -1,
    to: -1,
    match: /*@__PURE__*/ /.*/.exec("")
};
const $976a3faeb93466fd$var$baseFlags = "gm" + (/x/.unicode == null ? "" : "u");
/**
This class is similar to [`SearchCursor`](https://codemirror.net/6/docs/ref/#search.SearchCursor)
but searches for a regular expression pattern instead of a plain
string.
*/ class $976a3faeb93466fd$export$234e2283eb9dcd35 {
    /**
    Create a cursor that will search the given range in the given
    document. `query` should be the raw pattern (as you'd pass it to
    `new RegExp`).
    */ constructor(text, query, options, from = 0, to = text.length){
        this.text = text;
        this.to = to;
        this.curLine = "";
        /**
        Set to `true` when the cursor has reached the end of the search
        range.
        */ this.done = false;
        /**
        Will contain an object with the extent of the match and the
        match object when [`next`](https://codemirror.net/6/docs/ref/#search.RegExpCursor.next)
        sucessfully finds a match.
        */ this.value = $976a3faeb93466fd$var$empty;
        if (/\\[sWDnr]|\n|\r|\[\^/.test(query)) return new $976a3faeb93466fd$var$MultilineRegExpCursor(text, query, options, from, to);
        this.re = new RegExp(query, $976a3faeb93466fd$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.iter = text.iter();
        let startLine = text.lineAt(from);
        this.curLineStart = startLine.from;
        this.matchPos = $976a3faeb93466fd$var$toCharEnd(text, from);
        this.getLine(this.curLineStart);
    }
    getLine(skip) {
        this.iter.next(skip);
        if (this.iter.lineBreak) this.curLine = "";
        else {
            this.curLine = this.iter.value;
            if (this.curLineStart + this.curLine.length > this.to) this.curLine = this.curLine.slice(0, this.to - this.curLineStart);
            this.iter.next();
        }
    }
    nextLine() {
        this.curLineStart = this.curLineStart + this.curLine.length + 1;
        if (this.curLineStart > this.to) this.curLine = "";
        else this.getLine(0);
    }
    /**
    Move to the next match, if there is one.
    */ next() {
        for(let off = this.matchPos - this.curLineStart;;){
            this.re.lastIndex = off;
            let match = this.matchPos <= this.to && this.re.exec(this.curLine);
            if (match) {
                let from = this.curLineStart + match.index, to = from + match[0].length;
                this.matchPos = $976a3faeb93466fd$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                if (from == this.curLineStart + this.curLine.length) this.nextLine();
                if ((from < to || from > this.value.to) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        match: match
                    };
                    return this;
                }
                off = this.matchPos - this.curLineStart;
            } else if (this.curLineStart + this.curLine.length < this.to) {
                this.nextLine();
                off = 0;
            } else {
                this.done = true;
                return this;
            }
        }
    }
}
const $976a3faeb93466fd$var$flattened = /*@__PURE__*/ new WeakMap();
// Reusable (partially) flattened document strings
class $976a3faeb93466fd$var$FlattenedDoc {
    constructor(from, text){
        this.from = from;
        this.text = text;
    }
    get to() {
        return this.from + this.text.length;
    }
    static get(doc, from, to) {
        let cached = $976a3faeb93466fd$var$flattened.get(doc);
        if (!cached || cached.from >= to || cached.to <= from) {
            let flat = new $976a3faeb93466fd$var$FlattenedDoc(from, doc.sliceString(from, to));
            $976a3faeb93466fd$var$flattened.set(doc, flat);
            return flat;
        }
        if (cached.from == from && cached.to == to) return cached;
        let { text: text, from: cachedFrom } = cached;
        if (cachedFrom > from) {
            text = doc.sliceString(from, cachedFrom) + text;
            cachedFrom = from;
        }
        if (cached.to < to) text += doc.sliceString(cached.to, to);
        $976a3faeb93466fd$var$flattened.set(doc, new $976a3faeb93466fd$var$FlattenedDoc(cachedFrom, text));
        return new $976a3faeb93466fd$var$FlattenedDoc(from, text.slice(from - cachedFrom, to - cachedFrom));
    }
}
class $976a3faeb93466fd$var$MultilineRegExpCursor {
    constructor(text, query, options, from, to){
        this.text = text;
        this.to = to;
        this.done = false;
        this.value = $976a3faeb93466fd$var$empty;
        this.matchPos = $976a3faeb93466fd$var$toCharEnd(text, from);
        this.re = new RegExp(query, $976a3faeb93466fd$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.flat = $976a3faeb93466fd$var$FlattenedDoc.get(text, from, this.chunkEnd(from + 5000 /* Chunk.Base */ ));
    }
    chunkEnd(pos) {
        return pos >= this.to ? this.to : this.text.lineAt(pos).to;
    }
    next() {
        for(;;){
            let off = this.re.lastIndex = this.matchPos - this.flat.from;
            let match = this.re.exec(this.flat.text);
            // Skip empty matches directly after the last match
            if (match && !match[0] && match.index == off) {
                this.re.lastIndex = off + 1;
                match = this.re.exec(this.flat.text);
            }
            if (match) {
                let from = this.flat.from + match.index, to = from + match[0].length;
                // If a match goes almost to the end of a noncomplete chunk, try
                // again, since it'll likely be able to match more
                if ((this.flat.to >= this.to || match.index + match[0].length <= this.flat.text.length - 10) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        match: match
                    };
                    this.matchPos = $976a3faeb93466fd$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                    return this;
                }
            }
            if (this.flat.to == this.to) {
                this.done = true;
                return this;
            }
            // Grow the flattened doc
            this.flat = $976a3faeb93466fd$var$FlattenedDoc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
        }
    }
}
if (typeof Symbol != "undefined") $976a3faeb93466fd$export$234e2283eb9dcd35.prototype[Symbol.iterator] = $976a3faeb93466fd$var$MultilineRegExpCursor.prototype[Symbol.iterator] = function() {
    return this;
};
function $976a3faeb93466fd$var$validRegExp(source) {
    try {
        new RegExp(source, $976a3faeb93466fd$var$baseFlags);
        return true;
    } catch (_a) {
        return false;
    }
}
function $976a3faeb93466fd$var$toCharEnd(text, pos) {
    if (pos >= text.length) return pos;
    let line = text.lineAt(pos), next;
    while(pos < line.to && (next = line.text.charCodeAt(pos - line.from)) >= 0xDC00 && next < 0xE000)pos++;
    return pos;
}
function $976a3faeb93466fd$var$createLineDialog(view) {
    let line = String(view.state.doc.lineAt(view.state.selection.main.head).number);
    let input = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
        class: "cm-textfield",
        name: "line",
        value: line
    });
    let dom = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("form", {
        class: "cm-gotoLine",
        onkeydown: (event)=>{
            if (event.keyCode == 27) {
                event.preventDefault();
                view.dispatch({
                    effects: $976a3faeb93466fd$var$dialogEffect.of(false)
                });
                view.focus();
            } else if (event.keyCode == 13) {
                event.preventDefault();
                go();
            }
        },
        onsubmit: (event)=>{
            event.preventDefault();
            go();
        }
    }, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", view.state.phrase("Go to line"), ": ", input), " ", (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
        class: "cm-button",
        type: "submit"
    }, view.state.phrase("go")), (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
        name: "close",
        onclick: ()=>{
            view.dispatch({
                effects: $976a3faeb93466fd$var$dialogEffect.of(false)
            });
            view.focus();
        },
        "aria-label": view.state.phrase("close"),
        type: "button"
    }, [
        "\xd7"
    ]));
    function go() {
        let match = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(input.value);
        if (!match) return;
        let { state: state } = view, startLine = state.doc.lineAt(state.selection.main.head);
        let [, sign, ln, cl, percent] = match;
        let col = cl ? +cl.slice(1) : 0;
        let line = ln ? +ln : startLine.number;
        if (ln && percent) {
            let pc = line / 100;
            if (sign) pc = pc * (sign == "-" ? -1 : 1) + startLine.number / state.doc.lines;
            line = Math.round(state.doc.lines * pc);
        } else if (ln && sign) line = line * (sign == "-" ? -1 : 1) + startLine.number;
        let docLine = state.doc.line(Math.max(1, Math.min(state.doc.lines, line)));
        let selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(docLine.from + Math.max(0, Math.min(col, docLine.length)));
        view.dispatch({
            effects: [
                $976a3faeb93466fd$var$dialogEffect.of(false),
                (0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(selection.from, {
                    y: 'center'
                })
            ],
            selection: selection
        });
        view.focus();
    }
    return {
        dom: dom
    };
}
const $976a3faeb93466fd$var$dialogEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $976a3faeb93466fd$var$dialogField = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return true;
    },
    update (value, tr) {
        for (let e of tr.effects)if (e.is($976a3faeb93466fd$var$dialogEffect)) value = e.value;
        return value;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$e89c3c9af31c1e3b).from(f, (val)=>val ? $976a3faeb93466fd$var$createLineDialog : null)
});
/**
Command that shows a dialog asking the user for a line number, and
when a valid position is provided, moves the cursor to that line.

Supports line numbers, relative line offsets prefixed with `+` or
`-`, document percentages suffixed with `%`, and an optional
column position by adding `:` and a second number after the line
number.
*/ const $976a3faeb93466fd$export$5d5b784f9a618ec3 = (view)=>{
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createLineDialog);
    if (!panel) {
        let effects = [
            $976a3faeb93466fd$var$dialogEffect.of(true)
        ];
        if (view.state.field($976a3faeb93466fd$var$dialogField, false) == null) effects.push((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of([
            $976a3faeb93466fd$var$dialogField,
            $976a3faeb93466fd$var$baseTheme$1
        ]));
        view.dispatch({
            effects: effects
        });
        panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createLineDialog);
    }
    if (panel) panel.dom.querySelector("input").select();
    return true;
};
const $976a3faeb93466fd$var$baseTheme$1 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-panel.cm-gotoLine": {
        padding: "2px 6px 4px",
        position: "relative",
        "& label": {
            fontSize: "80%"
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            bottom: "0",
            right: "4px",
            backgroundColor: "inherit",
            border: "none",
            font: "inherit",
            padding: "0"
        }
    }
});
const $976a3faeb93466fd$var$defaultHighlightOptions = {
    highlightWordAroundCursor: false,
    minSelectionLength: 1,
    maxMatches: 100,
    wholeWords: false
};
const $976a3faeb93466fd$var$highlightConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (options) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(options, $976a3faeb93466fd$var$defaultHighlightOptions, {
            highlightWordAroundCursor: (a, b)=>a || b,
            minSelectionLength: Math.min,
            maxMatches: Math.min
        });
    }
});
/**
This extension highlights text that matches the selection. It uses
the `"cm-selectionMatch"` class for the highlighting. When
`highlightWordAroundCursor` is enabled, the word at the cursor
itself will be highlighted with `"cm-selectionMatch-main"`.
*/ function $976a3faeb93466fd$export$f14efe56171a2e02(options) {
    let ext = [
        $976a3faeb93466fd$var$defaultTheme,
        $976a3faeb93466fd$var$matchHighlighter
    ];
    if (options) ext.push($976a3faeb93466fd$var$highlightConfig.of(options));
    return ext;
}
const $976a3faeb93466fd$var$matchDeco = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch"
});
const $976a3faeb93466fd$var$mainMatchDeco = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch cm-selectionMatch-main"
});
// Whether the characters directly outside the given positions are non-word characters
function $976a3faeb93466fd$var$insideWordBoundaries(check, state, from, to) {
    return (from == 0 || check(state.sliceDoc(from - 1, from)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) && (to == state.doc.length || check(state.sliceDoc(to, to + 1)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word);
}
// Whether the characters directly at the given positions are word characters
function $976a3faeb93466fd$var$insideWord(check, state, from, to) {
    return check(state.sliceDoc(from, from + 1)) == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && check(state.sliceDoc(to - 1, to)) == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word;
}
const $976a3faeb93466fd$var$matchHighlighter = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.selectionSet || update.docChanged || update.viewportChanged) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let conf = view.state.facet($976a3faeb93466fd$var$highlightConfig);
        let { state: state } = view, sel = state.selection;
        if (sel.ranges.length > 1) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        let range = sel.main, query, check = null;
        if (range.empty) {
            if (!conf.highlightWordAroundCursor) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            let word = state.wordAt(range.head);
            if (!word) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            check = state.charCategorizer(range.head);
            query = state.sliceDoc(word.from, word.to);
        } else {
            let len = range.to - range.from;
            if (len < conf.minSelectionLength || len > 200) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            if (conf.wholeWords) {
                query = state.sliceDoc(range.from, range.to); // TODO: allow and include leading/trailing space?
                check = state.charCategorizer(range.head);
                if (!($976a3faeb93466fd$var$insideWordBoundaries(check, state, range.from, range.to) && $976a3faeb93466fd$var$insideWord(check, state, range.from, range.to))) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            } else {
                query = state.sliceDoc(range.from, range.to);
                if (!query) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            }
        }
        let deco = [];
        for (let part of view.visibleRanges){
            let cursor = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, query, part.from, part.to);
            while(!cursor.next().done){
                let { from: from, to: to } = cursor.value;
                if (!check || $976a3faeb93466fd$var$insideWordBoundaries(check, state, from, to)) {
                    if (range.empty && from <= range.from && to >= range.to) deco.push($976a3faeb93466fd$var$mainMatchDeco.range(from, to));
                    else if (from >= range.to || to <= range.from) deco.push($976a3faeb93466fd$var$matchDeco.range(from, to));
                    if (deco.length > conf.maxMatches) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
                }
            }
        }
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
const $976a3faeb93466fd$var$defaultTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-selectionMatch": {
        backgroundColor: "#99ff7780"
    },
    ".cm-searchMatch .cm-selectionMatch": {
        backgroundColor: "transparent"
    }
});
// Select the words around the cursors.
const $976a3faeb93466fd$var$selectWord = ({ state: state, dispatch: dispatch })=>{
    let { selection: selection } = state;
    let newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(selection.ranges.map((range)=>state.wordAt(range.head) || (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head)), selection.mainIndex);
    if (newSel.eq(selection)) return false;
    dispatch(state.update({
        selection: newSel
    }));
    return true;
};
// Find next occurrence of query relative to last cursor. Wrap around
// the document if there are no more matches.
function $976a3faeb93466fd$var$findNextOccurrence(state, query) {
    let { main: main, ranges: ranges } = state.selection;
    let word = state.wordAt(main.head), fullWord = word && word.from == main.from && word.to == main.to;
    for(let cycled = false, cursor = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, query, ranges[ranges.length - 1].to);;){
        cursor.next();
        if (cursor.done) {
            if (cycled) return null;
            cursor = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, query, 0, Math.max(0, ranges[ranges.length - 1].from - 1));
            cycled = true;
        } else {
            if (cycled && ranges.some((r)=>r.from == cursor.value.from)) continue;
            if (fullWord) {
                let word = state.wordAt(cursor.value.from);
                if (!word || word.from != cursor.value.from || word.to != cursor.value.to) continue;
            }
            return cursor.value;
        }
    }
}
/**
Select next occurrence of the current selection. Expand selection
to the surrounding word when the selection is empty.
*/ const $976a3faeb93466fd$export$dd0e64cebe05ee17 = ({ state: state, dispatch: dispatch })=>{
    let { ranges: ranges } = state.selection;
    if (ranges.some((sel)=>sel.from === sel.to)) return $976a3faeb93466fd$var$selectWord({
        state: state,
        dispatch: dispatch
    });
    let searchedText = state.sliceDoc(ranges[0].from, ranges[0].to);
    if (state.selection.ranges.some((r)=>state.sliceDoc(r.from, r.to) != searchedText)) return false;
    let range = $976a3faeb93466fd$var$findNextOccurrence(state, searchedText);
    if (!range) return false;
    dispatch(state.update({
        selection: state.selection.addRange((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.from, range.to), false),
        effects: (0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(range.to)
    }));
    return true;
};
const $976a3faeb93466fd$var$searchConfigFacet = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            top: false,
            caseSensitive: false,
            literal: false,
            regexp: false,
            wholeWord: false,
            createPanel: (view)=>new $976a3faeb93466fd$var$SearchPanel(view),
            scrollToMatch: (range)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(range)
        });
    }
});
/**
Add search state to the editor configuration, and optionally
configure the search extension.
([`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) will automatically
enable this if it isn't already on).
*/ function $976a3faeb93466fd$export$d76128d007d19019(config) {
    return config ? [
        $976a3faeb93466fd$var$searchConfigFacet.of(config),
        $976a3faeb93466fd$var$searchExtensions
    ] : $976a3faeb93466fd$var$searchExtensions;
}
/**
A search query. Part of the editor's search state.
*/ class $976a3faeb93466fd$export$4bc63ef50ec3954e {
    /**
    Create a query object.
    */ constructor(config){
        this.search = config.search;
        this.caseSensitive = !!config.caseSensitive;
        this.literal = !!config.literal;
        this.regexp = !!config.regexp;
        this.replace = config.replace || "";
        this.valid = !!this.search && (!this.regexp || $976a3faeb93466fd$var$validRegExp(this.search));
        this.unquoted = this.unquote(this.search);
        this.wholeWord = !!config.wholeWord;
    }
    /**
    @internal
    */ unquote(text) {
        return this.literal ? text : text.replace(/\\([nrt\\])/g, (_, ch)=>ch == "n" ? "\n" : ch == "r" ? "\r" : ch == "t" ? "\t" : "\\");
    }
    /**
    Compare this query to another query.
    */ eq(other) {
        return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord;
    }
    /**
    @internal
    */ create() {
        return this.regexp ? new $976a3faeb93466fd$var$RegExpQuery(this) : new $976a3faeb93466fd$var$StringQuery(this);
    }
    /**
    Get a search cursor for this query, searching through the given
    range in the given state.
    */ getCursor(state, from = 0, to) {
        let st = state.doc ? state : (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).create({
            doc: state
        });
        if (to == null) to = st.doc.length;
        return this.regexp ? $976a3faeb93466fd$var$regexpCursor(this, st, from, to) : $976a3faeb93466fd$var$stringCursor(this, st, from, to);
    }
}
class $976a3faeb93466fd$var$QueryType {
    constructor(spec){
        this.spec = spec;
    }
}
function $976a3faeb93466fd$var$stringCursor(spec, state, from, to) {
    return new $976a3faeb93466fd$export$4989b254f32490be(state.doc, spec.unquoted, from, to, spec.caseSensitive ? undefined : (x)=>x.toLowerCase(), spec.wholeWord ? $976a3faeb93466fd$var$stringWordTest(state.doc, state.charCategorizer(state.selection.main.head)) : undefined);
}
function $976a3faeb93466fd$var$stringWordTest(doc, categorizer) {
    return (from, to, buf, bufPos)=>{
        if (bufPos > from || bufPos + buf.length < to) {
            bufPos = Math.max(0, from - 2);
            buf = doc.sliceString(bufPos, Math.min(doc.length, to + 2));
        }
        return (categorizer($976a3faeb93466fd$var$charBefore(buf, from - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charAfter(buf, from - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) && (categorizer($976a3faeb93466fd$var$charAfter(buf, to - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charBefore(buf, to - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word);
    };
}
class $976a3faeb93466fd$var$StringQuery extends $976a3faeb93466fd$var$QueryType {
    constructor(spec){
        super(spec);
    }
    nextMatch(state, curFrom, curTo) {
        let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, curTo, state.doc.length).nextOverlapping();
        if (cursor.done) {
            let end = Math.min(state.doc.length, curFrom + this.spec.unquoted.length);
            cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, 0, end).nextOverlapping();
        }
        return cursor.done || cursor.value.from == curFrom && cursor.value.to == curTo ? null : cursor.value;
    }
    // Searching in reverse is, rather than implementing an inverted search
    // cursor, done by scanning chunk after chunk forward.
    prevMatchInRange(state, from, to) {
        for(let pos = to;;){
            let start = Math.max(from, pos - 10000 /* FindPrev.ChunkSize */  - this.spec.unquoted.length);
            let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, start, pos), range = null;
            while(!cursor.nextOverlapping().done)range = cursor.value;
            if (range) return range;
            if (start == from) return null;
            pos -= 10000 /* FindPrev.ChunkSize */ ;
        }
    }
    prevMatch(state, curFrom, curTo) {
        let found = this.prevMatchInRange(state, 0, curFrom);
        if (!found) found = this.prevMatchInRange(state, Math.max(0, curTo - this.spec.unquoted.length), state.doc.length);
        return found && (found.from != curFrom || found.to != curTo) ? found : null;
    }
    getReplacement(_result) {
        return this.spec.unquote(this.spec.replace);
    }
    matchAll(state, limit) {
        let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, Math.max(0, from - this.spec.unquoted.length), Math.min(to + this.spec.unquoted.length, state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
function $976a3faeb93466fd$var$regexpCursor(spec, state, from, to) {
    return new $976a3faeb93466fd$export$234e2283eb9dcd35(state.doc, spec.search, {
        ignoreCase: !spec.caseSensitive,
        test: spec.wholeWord ? $976a3faeb93466fd$var$regexpWordTest(state.charCategorizer(state.selection.main.head)) : undefined
    }, from, to);
}
function $976a3faeb93466fd$var$charBefore(str, index) {
    return str.slice((0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(str, index, false), index);
}
function $976a3faeb93466fd$var$charAfter(str, index) {
    return str.slice(index, (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(str, index));
}
function $976a3faeb93466fd$var$regexpWordTest(categorizer) {
    return (_from, _to, match)=>!match[0].length || (categorizer($976a3faeb93466fd$var$charBefore(match.input, match.index)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charAfter(match.input, match.index)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) && (categorizer($976a3faeb93466fd$var$charAfter(match.input, match.index + match[0].length)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charBefore(match.input, match.index + match[0].length)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word);
}
class $976a3faeb93466fd$var$RegExpQuery extends $976a3faeb93466fd$var$QueryType {
    nextMatch(state, curFrom, curTo) {
        let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, curTo, state.doc.length).next();
        if (cursor.done) cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, 0, curFrom).next();
        return cursor.done ? null : cursor.value;
    }
    prevMatchInRange(state, from, to) {
        for(let size = 1;; size++){
            let start = Math.max(from, to - size * 10000 /* FindPrev.ChunkSize */ );
            let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, start, to), range = null;
            while(!cursor.next().done)range = cursor.value;
            if (range && (start == from || range.from > start + 10)) return range;
            if (start == from) return null;
        }
    }
    prevMatch(state, curFrom, curTo) {
        return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
    }
    getReplacement(result) {
        return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (m, i)=>{
            if (i == "&") return result.match[0];
            if (i == "$") return "$";
            for(let l = i.length; l > 0; l--){
                let n = +i.slice(0, l);
                if (n > 0 && n < result.match.length) return result.match[n] + i.slice(l);
            }
            return m;
        });
    }
    matchAll(state, limit) {
        let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, Math.max(0, from - 250 /* RegExp.HighlightMargin */ ), Math.min(to + 250 /* RegExp.HighlightMargin */ , state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
/**
A state effect that updates the current search query. Note that
this only has an effect if the search state has been initialized
(by including [`search`](https://codemirror.net/6/docs/ref/#search.search) in your configuration or
by running [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) at least
once).
*/ const $976a3faeb93466fd$export$2cd1e14773f5e71b = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $976a3faeb93466fd$var$togglePanel = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $976a3faeb93466fd$var$searchState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create (state) {
        return new $976a3faeb93466fd$var$SearchState($976a3faeb93466fd$var$defaultQuery(state).create(), null);
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($976a3faeb93466fd$export$2cd1e14773f5e71b)) value = new $976a3faeb93466fd$var$SearchState(effect.value.create(), value.panel);
            else if (effect.is($976a3faeb93466fd$var$togglePanel)) value = new $976a3faeb93466fd$var$SearchState(value.query, effect.value ? $976a3faeb93466fd$var$createSearchPanel : null);
        }
        return value;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel)
});
/**
Get the current search query from an editor state.
*/ function $976a3faeb93466fd$export$1664b92369554829(state) {
    let curState = state.field($976a3faeb93466fd$var$searchState, false);
    return curState ? curState.query.spec : $976a3faeb93466fd$var$defaultQuery(state);
}
/**
Query whether the search panel is open in the given editor state.
*/ function $976a3faeb93466fd$export$453cecf1765eeb62(state) {
    var _a;
    return ((_a = state.field($976a3faeb93466fd$var$searchState, false)) === null || _a === void 0 ? void 0 : _a.panel) != null;
}
class $976a3faeb93466fd$var$SearchState {
    constructor(query, panel){
        this.query = query;
        this.panel = panel;
    }
}
const $976a3faeb93466fd$var$matchMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-searchMatch"
}), $976a3faeb93466fd$var$selectedMatchMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-searchMatch cm-searchMatch-selected"
});
const $976a3faeb93466fd$var$searchHighlighter = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.decorations = this.highlight(view.state.field($976a3faeb93466fd$var$searchState));
    }
    update(update) {
        let state = update.state.field($976a3faeb93466fd$var$searchState);
        if (state != update.startState.field($976a3faeb93466fd$var$searchState) || update.docChanged || update.selectionSet || update.viewportChanged) this.decorations = this.highlight(state);
    }
    highlight({ query: query, panel: panel }) {
        if (!panel || !query.spec.valid) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        let { view: view } = this;
        let builder = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
        for(let i = 0, ranges = view.visibleRanges, l = ranges.length; i < l; i++){
            let { from: from, to: to } = ranges[i];
            while(i < l - 1 && to > ranges[i + 1].from - 500 /* RegExp.HighlightMargin */ )to = ranges[++i].to;
            query.highlight(view.state, from, to, (from, to)=>{
                let selected = view.state.selection.ranges.some((r)=>r.from == from && r.to == to);
                builder.add(from, to, selected ? $976a3faeb93466fd$var$selectedMatchMark : $976a3faeb93466fd$var$matchMark);
            });
        }
        return builder.finish();
    }
}, {
    decorations: (v)=>v.decorations
});
function $976a3faeb93466fd$var$searchCommand(f) {
    return (view)=>{
        let state = view.state.field($976a3faeb93466fd$var$searchState, false);
        return state && state.query.spec.valid ? f(view, state) : $976a3faeb93466fd$export$8894af164d40b422(view);
    };
}
/**
Open the search panel if it isn't already open, and move the
selection to the first match after the current main selection.
Will wrap around to the start of the document when it reaches the
end.
*/ const $976a3faeb93466fd$export$ebdf538520f8717 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let { to: to } = view.state.selection.main;
    let next = query.nextMatch(view.state, to, to);
    if (!next) return false;
    let selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(next.from, next.to);
    let config = view.state.facet($976a3faeb93466fd$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $976a3faeb93466fd$var$announceMatch(view, next),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $976a3faeb93466fd$var$selectSearchInput(view);
    return true;
});
/**
Move the selection to the previous instance of the search query,
before the current main selection. Will wrap past the start
of the document to start searching at the end again.
*/ const $976a3faeb93466fd$export$eef4841c27f82c55 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from } = state.selection.main;
    let prev = query.prevMatch(state, from, from);
    if (!prev) return false;
    let selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(prev.from, prev.to);
    let config = view.state.facet($976a3faeb93466fd$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $976a3faeb93466fd$var$announceMatch(view, prev),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $976a3faeb93466fd$var$selectSearchInput(view);
    return true;
});
/**
Select all instances of the search query.
*/ const $976a3faeb93466fd$export$5d21cfc86ff1ce1d = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let ranges = query.matchAll(view.state, 1000);
    if (!ranges || !ranges.length) return false;
    view.dispatch({
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges.map((r)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(r.from, r.to))),
        userEvent: "select.search.matches"
    });
    return true;
});
/**
Select all instances of the currently selected text.
*/ const $976a3faeb93466fd$export$6f1c98d8556667b5 = ({ state: state, dispatch: dispatch })=>{
    let sel = state.selection;
    if (sel.ranges.length > 1 || sel.main.empty) return false;
    let { from: from, to: to } = sel.main;
    let ranges = [], main = 0;
    for(let cur = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, state.sliceDoc(from, to)); !cur.next().done;){
        if (ranges.length > 1000) return false;
        if (cur.value.from == from) main = ranges.length;
        ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(cur.value.from, cur.value.to));
    }
    dispatch(state.update({
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, main),
        userEvent: "select.search.matches"
    }));
    return true;
};
/**
Replace the current match of the search query.
*/ const $976a3faeb93466fd$export$f9afe47535eaf3d2 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from, to: to } = state.selection.main;
    if (state.readOnly) return false;
    let match = query.nextMatch(state, from, from);
    if (!match) return false;
    let next = match;
    let changes = [], selection, replacement;
    let effects = [];
    if (next.from == from && next.to == to) {
        replacement = state.toText(query.getReplacement(next));
        changes.push({
            from: next.from,
            to: next.to,
            insert: replacement
        });
        next = query.nextMatch(state, next.from, next.to);
        effects.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(state.phrase("replaced match on line $", state.doc.lineAt(from).number) + "."));
    }
    let changeSet = view.state.changes(changes);
    if (next) {
        selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(next.from, next.to).map(changeSet);
        effects.push($976a3faeb93466fd$var$announceMatch(view, next));
        effects.push(state.facet($976a3faeb93466fd$var$searchConfigFacet).scrollToMatch(selection.main, view));
    }
    view.dispatch({
        changes: changeSet,
        selection: selection,
        effects: effects,
        userEvent: "input.replace"
    });
    return true;
});
/**
Replace all instances of the search query with the given
replacement.
*/ const $976a3faeb93466fd$export$b8b3234b4edfc4c2 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    if (view.state.readOnly) return false;
    let changes = query.matchAll(view.state, 1e9).map((match)=>{
        let { from: from, to: to } = match;
        return {
            from: from,
            to: to,
            insert: query.getReplacement(match)
        };
    });
    if (!changes.length) return false;
    let announceText = view.state.phrase("replaced $ matches", changes.length) + ".";
    view.dispatch({
        changes: changes,
        effects: (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(announceText),
        userEvent: "input.replace.all"
    });
    return true;
});
function $976a3faeb93466fd$var$createSearchPanel(view) {
    return view.state.facet($976a3faeb93466fd$var$searchConfigFacet).createPanel(view);
}
function $976a3faeb93466fd$var$defaultQuery(state, fallback) {
    var _a, _b, _c, _d, _e;
    let sel = state.selection.main;
    let selText = sel.empty || sel.to > sel.from + 100 ? "" : state.sliceDoc(sel.from, sel.to);
    if (fallback && !selText) return fallback;
    let config = state.facet($976a3faeb93466fd$var$searchConfigFacet);
    return new $976a3faeb93466fd$export$4bc63ef50ec3954e({
        search: ((_a = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _a !== void 0 ? _a : config.literal) ? selText : selText.replace(/\n/g, "\\n"),
        caseSensitive: (_b = fallback === null || fallback === void 0 ? void 0 : fallback.caseSensitive) !== null && _b !== void 0 ? _b : config.caseSensitive,
        literal: (_c = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _c !== void 0 ? _c : config.literal,
        regexp: (_d = fallback === null || fallback === void 0 ? void 0 : fallback.regexp) !== null && _d !== void 0 ? _d : config.regexp,
        wholeWord: (_e = fallback === null || fallback === void 0 ? void 0 : fallback.wholeWord) !== null && _e !== void 0 ? _e : config.wholeWord
    });
}
function $976a3faeb93466fd$var$getSearchInput(view) {
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createSearchPanel);
    return panel && panel.dom.querySelector("[main-field]");
}
function $976a3faeb93466fd$var$selectSearchInput(view) {
    let input = $976a3faeb93466fd$var$getSearchInput(view);
    if (input && input == view.root.activeElement) input.select();
}
/**
Make sure the search panel is open and focused.
*/ const $976a3faeb93466fd$export$8894af164d40b422 = (view)=>{
    let state = view.state.field($976a3faeb93466fd$var$searchState, false);
    if (state && state.panel) {
        let searchInput = $976a3faeb93466fd$var$getSearchInput(view);
        if (searchInput && searchInput != view.root.activeElement) {
            let query = $976a3faeb93466fd$var$defaultQuery(view.state, state.query.spec);
            if (query.valid) view.dispatch({
                effects: $976a3faeb93466fd$export$2cd1e14773f5e71b.of(query)
            });
            searchInput.focus();
            searchInput.select();
        }
    } else view.dispatch({
        effects: [
            $976a3faeb93466fd$var$togglePanel.of(true),
            state ? $976a3faeb93466fd$export$2cd1e14773f5e71b.of($976a3faeb93466fd$var$defaultQuery(view.state, state.query.spec)) : (0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($976a3faeb93466fd$var$searchExtensions)
        ]
    });
    return true;
};
/**
Close the search panel.
*/ const $976a3faeb93466fd$export$4c389f3929badbb8 = (view)=>{
    let state = view.state.field($976a3faeb93466fd$var$searchState, false);
    if (!state || !state.panel) return false;
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createSearchPanel);
    if (panel && panel.dom.contains(view.root.activeElement)) view.focus();
    view.dispatch({
        effects: $976a3faeb93466fd$var$togglePanel.of(false)
    });
    return true;
};
/**
Default search-related key bindings.

 - Mod-f: [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel)
 - F3, Mod-g: [`findNext`](https://codemirror.net/6/docs/ref/#search.findNext)
 - Shift-F3, Shift-Mod-g: [`findPrevious`](https://codemirror.net/6/docs/ref/#search.findPrevious)
 - Mod-Alt-g: [`gotoLine`](https://codemirror.net/6/docs/ref/#search.gotoLine)
 - Mod-d: [`selectNextOccurrence`](https://codemirror.net/6/docs/ref/#search.selectNextOccurrence)
*/ const $976a3faeb93466fd$export$2dba96787cbe0a4a = [
    {
        key: "Mod-f",
        run: $976a3faeb93466fd$export$8894af164d40b422,
        scope: "editor search-panel"
    },
    {
        key: "F3",
        run: $976a3faeb93466fd$export$ebdf538520f8717,
        shift: $976a3faeb93466fd$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Mod-g",
        run: $976a3faeb93466fd$export$ebdf538520f8717,
        shift: $976a3faeb93466fd$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Escape",
        run: $976a3faeb93466fd$export$4c389f3929badbb8,
        scope: "editor search-panel"
    },
    {
        key: "Mod-Shift-l",
        run: $976a3faeb93466fd$export$6f1c98d8556667b5
    },
    {
        key: "Mod-Alt-g",
        run: $976a3faeb93466fd$export$5d5b784f9a618ec3
    },
    {
        key: "Mod-d",
        run: $976a3faeb93466fd$export$dd0e64cebe05ee17,
        preventDefault: true
    }
];
class $976a3faeb93466fd$var$SearchPanel {
    constructor(view){
        this.view = view;
        let query = this.query = view.state.field($976a3faeb93466fd$var$searchState).query.spec;
        this.commit = this.commit.bind(this);
        this.searchField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            value: query.search,
            placeholder: $976a3faeb93466fd$var$phrase(view, "Find"),
            "aria-label": $976a3faeb93466fd$var$phrase(view, "Find"),
            class: "cm-textfield",
            name: "search",
            form: "",
            "main-field": "true",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.replaceField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            value: query.replace,
            placeholder: $976a3faeb93466fd$var$phrase(view, "Replace"),
            "aria-label": $976a3faeb93466fd$var$phrase(view, "Replace"),
            class: "cm-textfield",
            name: "replace",
            form: "",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.caseField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "case",
            form: "",
            checked: query.caseSensitive,
            onchange: this.commit
        });
        this.reField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "re",
            form: "",
            checked: query.regexp,
            onchange: this.commit
        });
        this.wordField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "word",
            form: "",
            checked: query.wholeWord,
            onchange: this.commit
        });
        function button(name, onclick, content) {
            return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
                class: "cm-button",
                name: name,
                onclick: onclick,
                type: "button"
            }, content);
        }
        this.dom = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", {
            onkeydown: (e)=>this.keydown(e),
            class: "cm-search"
        }, [
            this.searchField,
            button("next", ()=>$976a3faeb93466fd$export$ebdf538520f8717(view), [
                $976a3faeb93466fd$var$phrase(view, "next")
            ]),
            button("prev", ()=>$976a3faeb93466fd$export$eef4841c27f82c55(view), [
                $976a3faeb93466fd$var$phrase(view, "previous")
            ]),
            button("select", ()=>$976a3faeb93466fd$export$5d21cfc86ff1ce1d(view), [
                $976a3faeb93466fd$var$phrase(view, "all")
            ]),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", null, [
                this.caseField,
                $976a3faeb93466fd$var$phrase(view, "match case")
            ]),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", null, [
                this.reField,
                $976a3faeb93466fd$var$phrase(view, "regexp")
            ]),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", null, [
                this.wordField,
                $976a3faeb93466fd$var$phrase(view, "by word")
            ]),
            ...view.state.readOnly ? [] : [
                (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("br"),
                this.replaceField,
                button("replace", ()=>$976a3faeb93466fd$export$f9afe47535eaf3d2(view), [
                    $976a3faeb93466fd$var$phrase(view, "replace")
                ]),
                button("replaceAll", ()=>$976a3faeb93466fd$export$b8b3234b4edfc4c2(view), [
                    $976a3faeb93466fd$var$phrase(view, "replace all")
                ])
            ],
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
                name: "close",
                onclick: ()=>$976a3faeb93466fd$export$4c389f3929badbb8(view),
                "aria-label": $976a3faeb93466fd$var$phrase(view, "close"),
                type: "button"
            }, [
                "\xd7"
            ])
        ]);
    }
    commit() {
        let query = new $976a3faeb93466fd$export$4bc63ef50ec3954e({
            search: this.searchField.value,
            caseSensitive: this.caseField.checked,
            regexp: this.reField.checked,
            wholeWord: this.wordField.checked,
            replace: this.replaceField.value
        });
        if (!query.eq(this.query)) {
            this.query = query;
            this.view.dispatch({
                effects: $976a3faeb93466fd$export$2cd1e14773f5e71b.of(query)
            });
        }
    }
    keydown(e) {
        if ((0, $7beee9608540d2c3$export$bce154f45536286e)(this.view, e, "search-panel")) e.preventDefault();
        else if (e.keyCode == 13 && e.target == this.searchField) {
            e.preventDefault();
            (e.shiftKey ? $976a3faeb93466fd$export$eef4841c27f82c55 : $976a3faeb93466fd$export$ebdf538520f8717)(this.view);
        } else if (e.keyCode == 13 && e.target == this.replaceField) {
            e.preventDefault();
            $976a3faeb93466fd$export$f9afe47535eaf3d2(this.view);
        }
    }
    update(update) {
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($976a3faeb93466fd$export$2cd1e14773f5e71b) && !effect.value.eq(this.query)) this.setQuery(effect.value);
    }
    setQuery(query) {
        this.query = query;
        this.searchField.value = query.search;
        this.replaceField.value = query.replace;
        this.caseField.checked = query.caseSensitive;
        this.reField.checked = query.regexp;
        this.wordField.checked = query.wholeWord;
    }
    mount() {
        this.searchField.select();
    }
    get pos() {
        return 80;
    }
    get top() {
        return this.view.state.facet($976a3faeb93466fd$var$searchConfigFacet).top;
    }
}
function $976a3faeb93466fd$var$phrase(view, phrase) {
    return view.state.phrase(phrase);
}
const $976a3faeb93466fd$var$AnnounceMargin = 30;
const $976a3faeb93466fd$var$Break = /[\s\.,:;?!]/;
function $976a3faeb93466fd$var$announceMatch(view, { from: from, to: to }) {
    let line = view.state.doc.lineAt(from), lineEnd = view.state.doc.lineAt(to).to;
    let start = Math.max(line.from, from - $976a3faeb93466fd$var$AnnounceMargin), end = Math.min(lineEnd, to + $976a3faeb93466fd$var$AnnounceMargin);
    let text = view.state.sliceDoc(start, end);
    if (start != line.from) {
        for(let i = 0; i < $976a3faeb93466fd$var$AnnounceMargin; i++)if (!$976a3faeb93466fd$var$Break.test(text[i + 1]) && $976a3faeb93466fd$var$Break.test(text[i])) {
            text = text.slice(i);
            break;
        }
    }
    if (end != lineEnd) {
        for(let i = text.length - 1; i > text.length - $976a3faeb93466fd$var$AnnounceMargin; i--)if (!$976a3faeb93466fd$var$Break.test(text[i - 1]) && $976a3faeb93466fd$var$Break.test(text[i])) {
            text = text.slice(0, i);
            break;
        }
    }
    return (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(`${view.state.phrase("current match")}. ${text} ${view.state.phrase("on line")} ${line.number}.`);
}
const $976a3faeb93466fd$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-panel.cm-search": {
        padding: "2px 6px 4px",
        position: "relative",
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "4px",
            backgroundColor: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        },
        "& input, & button, & label": {
            margin: ".2em .6em .2em 0"
        },
        "& input[type=checkbox]": {
            marginRight: ".2em"
        },
        "& label": {
            fontSize: "80%",
            whiteSpace: "pre"
        }
    },
    "&light .cm-searchMatch": {
        backgroundColor: "#ffff0054"
    },
    "&dark .cm-searchMatch": {
        backgroundColor: "#00ffff8a"
    },
    "&light .cm-searchMatch-selected": {
        backgroundColor: "#ff6a0054"
    },
    "&dark .cm-searchMatch-selected": {
        backgroundColor: "#ff00ff8a"
    }
});
const $976a3faeb93466fd$var$searchExtensions = [
    $976a3faeb93466fd$var$searchState,
    /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).low($976a3faeb93466fd$var$searchHighlighter),
    $976a3faeb93466fd$var$baseTheme
];







const $b936e6b9e1d87287$var$dark0 = '#282828', $b936e6b9e1d87287$var$dark1 = '#3c3836', $b936e6b9e1d87287$var$dark3 = '#665c54', $b936e6b9e1d87287$var$gray_245 = '#928374', $b936e6b9e1d87287$var$light1 = '#ebdbb2', $b936e6b9e1d87287$var$light2 = '#d5c4a1', $b936e6b9e1d87287$var$light3 = '#bdae93', $b936e6b9e1d87287$var$light4 = '#a89984', $b936e6b9e1d87287$var$bright_red = '#fb4934', $b936e6b9e1d87287$var$bright_green = '#b8bb26', $b936e6b9e1d87287$var$bright_yellow = '#fabd2f', $b936e6b9e1d87287$var$bright_blue = '#83a598', $b936e6b9e1d87287$var$bright_purple = '#d3869b', $b936e6b9e1d87287$var$bright_aqua = '#8ec07c', $b936e6b9e1d87287$var$bright_orange = '#fe8019';
const $b936e6b9e1d87287$var$bg0 = $b936e6b9e1d87287$var$dark0, $b936e6b9e1d87287$var$bg1 = $b936e6b9e1d87287$var$dark1, $b936e6b9e1d87287$var$bg3 = $b936e6b9e1d87287$var$dark3, $b936e6b9e1d87287$var$gray = $b936e6b9e1d87287$var$gray_245, $b936e6b9e1d87287$var$fg1 = $b936e6b9e1d87287$var$light1, $b936e6b9e1d87287$var$fg2 = $b936e6b9e1d87287$var$light2, $b936e6b9e1d87287$var$fg3 = $b936e6b9e1d87287$var$light3, $b936e6b9e1d87287$var$fg4 = $b936e6b9e1d87287$var$light4, $b936e6b9e1d87287$var$red = $b936e6b9e1d87287$var$bright_red, $b936e6b9e1d87287$var$green = $b936e6b9e1d87287$var$bright_green, $b936e6b9e1d87287$var$yellow = $b936e6b9e1d87287$var$bright_yellow, $b936e6b9e1d87287$var$blue = $b936e6b9e1d87287$var$bright_blue, $b936e6b9e1d87287$var$purple = $b936e6b9e1d87287$var$bright_purple, $b936e6b9e1d87287$var$aqua = $b936e6b9e1d87287$var$bright_aqua, $b936e6b9e1d87287$var$orange = $b936e6b9e1d87287$var$bright_orange;
const $b936e6b9e1d87287$var$invalid = $b936e6b9e1d87287$var$red, $b936e6b9e1d87287$var$darkBackground = $b936e6b9e1d87287$var$bg1, $b936e6b9e1d87287$var$highlightBackground = $b936e6b9e1d87287$var$darkBackground, $b936e6b9e1d87287$var$background = $b936e6b9e1d87287$var$bg0, $b936e6b9e1d87287$var$tooltipBackground = $b936e6b9e1d87287$var$bg1, $b936e6b9e1d87287$var$selection = $b936e6b9e1d87287$var$darkBackground, $b936e6b9e1d87287$var$cursor = $b936e6b9e1d87287$var$orange;
/**
The editor theme styles for Gruvbox Dark.
*/ const $b936e6b9e1d87287$export$8512db6a7edec164 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).theme({
    '&': {
        color: $b936e6b9e1d87287$var$fg1,
        backgroundColor: $b936e6b9e1d87287$var$background
    },
    '.cm-content': {
        caretColor: $b936e6b9e1d87287$var$cursor
    },
    '.cm-cursor, .cm-dropCursor': {
        borderLeftColor: $b936e6b9e1d87287$var$cursor
    },
    '&.cm-focused .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection': {
        backgroundColor: $b936e6b9e1d87287$var$selection
    },
    '.cm-panels': {
        backgroundColor: $b936e6b9e1d87287$var$darkBackground,
        color: $b936e6b9e1d87287$var$fg1
    },
    '.cm-panels.cm-panels-top': {
        borderBottom: '2px solid black'
    },
    '.cm-panels.cm-panels-bottom': {
        borderTop: '2px solid black'
    },
    '.cm-searchMatch': {
        backgroundColor: $b936e6b9e1d87287$var$bg0,
        color: $b936e6b9e1d87287$var$yellow,
        outline: `1px solid ${$b936e6b9e1d87287$var$bg3}`
    },
    '.cm-searchMatch.cm-searchMatch-selected': {
        backgroundColor: $b936e6b9e1d87287$var$bg3
    },
    '.cm-activeLine': {
        backgroundColor: $b936e6b9e1d87287$var$highlightBackground
    },
    '.cm-selectionMatch': {
        backgroundColor: $b936e6b9e1d87287$var$bg3
    },
    '&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket': {
        outline: `1px solid ${$b936e6b9e1d87287$var$bg3}`,
        fontStyle: 'bold'
    },
    '&.cm-focused .cm-matchingBracket': {
        backgroundColor: $b936e6b9e1d87287$var$bg3
    },
    '.cm-gutters': {
        backgroundColor: $b936e6b9e1d87287$var$bg1,
        color: $b936e6b9e1d87287$var$fg3,
        border: 'none'
    },
    '.cm-activeLineGutter': {
        backgroundColor: $b936e6b9e1d87287$var$highlightBackground
    },
    '.cm-foldPlaceholder': {
        backgroundColor: 'transparent',
        border: 'none',
        color: '#ddd'
    },
    '.cm-tooltip': {
        border: 'none',
        backgroundColor: $b936e6b9e1d87287$var$tooltipBackground
    },
    '.cm-tooltip .cm-tooltip-arrow:before': {
        borderTopColor: 'transparent',
        borderBottomColor: 'transparent'
    },
    '.cm-tooltip .cm-tooltip-arrow:after': {
        borderTopColor: $b936e6b9e1d87287$var$tooltipBackground,
        borderBottomColor: $b936e6b9e1d87287$var$tooltipBackground
    },
    '.cm-tooltip-autocomplete': {
        '& > ul > li[aria-selected]': {
            backgroundColor: $b936e6b9e1d87287$var$highlightBackground,
            color: $b936e6b9e1d87287$var$fg2
        }
    }
}, {
    dark: true
});
/**
The highlighting style for code in the Gruvbox Dark theme.
*/ const $b936e6b9e1d87287$export$6ac92358cefff2ef = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$4819f093bdd5b4a).define([
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
        color: $b936e6b9e1d87287$var$red
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).name,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).deleted,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).character,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).macroName
        ],
        color: $b936e6b9e1d87287$var$aqua
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName
        ],
        color: $b936e6b9e1d87287$var$blue
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName)
        ],
        color: $b936e6b9e1d87287$var$green,
        fontStyle: 'bold'
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName
        ],
        color: $b936e6b9e1d87287$var$fg1
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).color,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).constant((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name),
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).standard((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name)
        ],
        color: $b936e6b9e1d87287$var$purple
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name),
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).separator
        ],
        color: $b936e6b9e1d87287$var$fg1
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).brace
        ],
        color: $b936e6b9e1d87287$var$fg1
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).annotation
        ],
        color: $b936e6b9e1d87287$var$invalid
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).number,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).changed,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).annotation,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).self,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).namespace
        ],
        color: $b936e6b9e1d87287$var$purple
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className
        ],
        color: $b936e6b9e1d87287$var$yellow
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operator,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword
        ],
        color: $b936e6b9e1d87287$var$red
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName
        ],
        color: $b936e6b9e1d87287$var$aqua,
        fontStyle: 'bold'
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).squareBracket
        ],
        color: $b936e6b9e1d87287$var$orange
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).angleBracket
        ],
        color: $b936e6b9e1d87287$var$blue
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeName
        ],
        color: $b936e6b9e1d87287$var$aqua
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).regexp
        ],
        color: $b936e6b9e1d87287$var$aqua
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).quote
        ],
        color: $b936e6b9e1d87287$var$gray
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string
        ],
        color: $b936e6b9e1d87287$var$fg1
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).link,
        color: $b936e6b9e1d87287$var$fg4,
        textDecoration: 'underline',
        textUnderlinePosition: 'under'
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).url,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string)
        ],
        color: $b936e6b9e1d87287$var$purple
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta
        ],
        color: $b936e6b9e1d87287$var$yellow
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).comment
        ],
        color: $b936e6b9e1d87287$var$gray,
        fontStyle: 'italic'
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strong,
        fontWeight: 'bold',
        color: $b936e6b9e1d87287$var$orange
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).emphasis,
        fontStyle: 'italic',
        color: $b936e6b9e1d87287$var$green
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strikethrough,
        textDecoration: 'line-through'
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading,
        fontWeight: 'bold',
        color: $b936e6b9e1d87287$var$green
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading1,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading2
        ],
        fontWeight: 'bold',
        color: $b936e6b9e1d87287$var$green
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading3,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading4
        ],
        fontWeight: 'bold',
        color: $b936e6b9e1d87287$var$yellow
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading5,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading6
        ],
        color: $b936e6b9e1d87287$var$yellow
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName)
        ],
        color: $b936e6b9e1d87287$var$purple
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).processingInstruction,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).inserted
        ],
        color: $b936e6b9e1d87287$var$bright_blue
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).contentSeparator
        ],
        color: $b936e6b9e1d87287$var$red
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).invalid,
        color: $b936e6b9e1d87287$var$orange,
        borderBottom: `1px dotted ${$b936e6b9e1d87287$var$invalid}`
    }
]);
/**
Extension to enable the Gruvbox Dark theme (both the editor theme and
the highlight style).
*/ const $b936e6b9e1d87287$export$528b3505117fc12e = [
    $b936e6b9e1d87287$export$8512db6a7edec164,
    /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$ec1b956ff3a16361)($b936e6b9e1d87287$export$6ac92358cefff2ef)
];





const $9383af9c509aa5cf$var$dark1 = '#3c3836', $9383af9c509aa5cf$var$dark2 = '#504945', $9383af9c509aa5cf$var$dark3 = '#665c54', $9383af9c509aa5cf$var$dark4 = '#7c6f64', $9383af9c509aa5cf$var$gray_244 = '#928374', $9383af9c509aa5cf$var$light0 = '#fbf1c7', $9383af9c509aa5cf$var$light1 = '#ebdbb2', $9383af9c509aa5cf$var$light3 = '#bdae93', $9383af9c509aa5cf$var$faded_red = '#9d0006', $9383af9c509aa5cf$var$faded_green = '#79740e', $9383af9c509aa5cf$var$faded_yellow = '#b57614', $9383af9c509aa5cf$var$faded_blue = '#076678', $9383af9c509aa5cf$var$faded_purple = '#8f3f71', $9383af9c509aa5cf$var$faded_aqua = '#427b58', $9383af9c509aa5cf$var$faded_orange = '#af3a03';
const $9383af9c509aa5cf$var$bg0 = $9383af9c509aa5cf$var$light0, $9383af9c509aa5cf$var$bg1 = $9383af9c509aa5cf$var$light1, $9383af9c509aa5cf$var$bg3 = $9383af9c509aa5cf$var$light3, $9383af9c509aa5cf$var$gray = $9383af9c509aa5cf$var$gray_244, $9383af9c509aa5cf$var$fg1 = $9383af9c509aa5cf$var$dark1, $9383af9c509aa5cf$var$fg2 = $9383af9c509aa5cf$var$dark2, $9383af9c509aa5cf$var$fg3 = $9383af9c509aa5cf$var$dark3, $9383af9c509aa5cf$var$fg4 = $9383af9c509aa5cf$var$dark4, $9383af9c509aa5cf$var$red = $9383af9c509aa5cf$var$faded_red, $9383af9c509aa5cf$var$green = $9383af9c509aa5cf$var$faded_green, $9383af9c509aa5cf$var$yellow = $9383af9c509aa5cf$var$faded_yellow, $9383af9c509aa5cf$var$blue = $9383af9c509aa5cf$var$faded_blue, $9383af9c509aa5cf$var$purple = $9383af9c509aa5cf$var$faded_purple, $9383af9c509aa5cf$var$aqua = $9383af9c509aa5cf$var$faded_aqua, $9383af9c509aa5cf$var$orange = $9383af9c509aa5cf$var$faded_orange;
const $9383af9c509aa5cf$var$invalid = $9383af9c509aa5cf$var$red, $9383af9c509aa5cf$var$darkBackground = $9383af9c509aa5cf$var$bg1, $9383af9c509aa5cf$var$highlightBackground = $9383af9c509aa5cf$var$darkBackground, $9383af9c509aa5cf$var$background = $9383af9c509aa5cf$var$bg0, $9383af9c509aa5cf$var$tooltipBackground = $9383af9c509aa5cf$var$bg1, $9383af9c509aa5cf$var$selection = $9383af9c509aa5cf$var$darkBackground, $9383af9c509aa5cf$var$cursor = $9383af9c509aa5cf$var$orange;
/**
The editor theme styles for Gruvbox Light.
*/ const $9383af9c509aa5cf$export$a612293909849134 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).theme({
    '&': {
        color: $9383af9c509aa5cf$var$fg1,
        backgroundColor: $9383af9c509aa5cf$var$background
    },
    '.cm-content': {
        caretColor: $9383af9c509aa5cf$var$cursor
    },
    '.cm-cursor, .cm-dropCursor': {
        borderLeftColor: $9383af9c509aa5cf$var$cursor
    },
    '&.cm-focused .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection': {
        backgroundColor: $9383af9c509aa5cf$var$selection
    },
    '.cm-panels': {
        backgroundColor: $9383af9c509aa5cf$var$darkBackground,
        color: $9383af9c509aa5cf$var$fg1
    },
    '.cm-panels.cm-panels-top': {
        borderBottom: '2px solid black'
    },
    '.cm-panels.cm-panels-bottom': {
        borderTop: '2px solid black'
    },
    '.cm-searchMatch': {
        backgroundColor: $9383af9c509aa5cf$var$bg0,
        color: $9383af9c509aa5cf$var$yellow,
        outline: `1px solid ${$9383af9c509aa5cf$var$bg3}`
    },
    '.cm-searchMatch.cm-searchMatch-selected': {
        backgroundColor: $9383af9c509aa5cf$var$bg3
    },
    '.cm-activeLine': {
        backgroundColor: $9383af9c509aa5cf$var$highlightBackground
    },
    '.cm-selectionMatch': {
        backgroundColor: $9383af9c509aa5cf$var$bg3
    },
    '&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket': {
        outline: `1px solid ${$9383af9c509aa5cf$var$bg3}`,
        fontStyle: 'bold'
    },
    '&.cm-focused .cm-matchingBracket': {
        backgroundColor: $9383af9c509aa5cf$var$bg3
    },
    '.cm-gutters': {
        backgroundColor: $9383af9c509aa5cf$var$bg1,
        color: $9383af9c509aa5cf$var$fg3,
        border: 'none'
    },
    '.cm-activeLineGutter': {
        backgroundColor: $9383af9c509aa5cf$var$highlightBackground
    },
    '.cm-foldPlaceholder': {
        backgroundColor: 'transparent',
        border: 'none',
        color: '#ddd'
    },
    '.cm-tooltip': {
        border: 'none',
        backgroundColor: $9383af9c509aa5cf$var$tooltipBackground
    },
    '.cm-tooltip .cm-tooltip-arrow:before': {
        borderTopColor: 'transparent',
        borderBottomColor: 'transparent'
    },
    '.cm-tooltip .cm-tooltip-arrow:after': {
        borderTopColor: $9383af9c509aa5cf$var$tooltipBackground,
        borderBottomColor: $9383af9c509aa5cf$var$tooltipBackground
    },
    '.cm-tooltip-autocomplete': {
        '& > ul > li[aria-selected]': {
            backgroundColor: $9383af9c509aa5cf$var$highlightBackground,
            color: $9383af9c509aa5cf$var$fg2
        }
    }
}, {
    dark: false
});
/**
The highlighting style for code in the Gruvbox Light theme.
*/ const $9383af9c509aa5cf$export$31e8e92da508ca9a = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$4819f093bdd5b4a).define([
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
        color: $9383af9c509aa5cf$var$red
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).name,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).deleted,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).character,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).macroName
        ],
        color: $9383af9c509aa5cf$var$aqua
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName
        ],
        color: $9383af9c509aa5cf$var$blue
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName)
        ],
        color: $9383af9c509aa5cf$var$green,
        fontStyle: 'bold'
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName
        ],
        color: $9383af9c509aa5cf$var$fg1
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).color,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).constant((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name),
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).standard((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name)
        ],
        color: $9383af9c509aa5cf$var$purple
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name),
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).separator
        ],
        color: $9383af9c509aa5cf$var$fg1
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).brace
        ],
        color: $9383af9c509aa5cf$var$fg1
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).annotation
        ],
        color: $9383af9c509aa5cf$var$invalid
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).number,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).changed,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).annotation,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).self,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).namespace
        ],
        color: $9383af9c509aa5cf$var$purple
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className
        ],
        color: $9383af9c509aa5cf$var$yellow
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operator,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword
        ],
        color: $9383af9c509aa5cf$var$red
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).tagName
        ],
        color: $9383af9c509aa5cf$var$aqua,
        fontStyle: 'bold'
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).squareBracket
        ],
        color: $9383af9c509aa5cf$var$orange
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).angleBracket
        ],
        color: $9383af9c509aa5cf$var$blue
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).attributeName
        ],
        color: $9383af9c509aa5cf$var$aqua
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).regexp
        ],
        color: $9383af9c509aa5cf$var$aqua
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).quote
        ],
        color: $9383af9c509aa5cf$var$gray
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string
        ],
        color: $9383af9c509aa5cf$var$fg1
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).link,
        color: $9383af9c509aa5cf$var$fg4,
        textDecoration: 'underline',
        textUnderlinePosition: 'under'
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).url,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string)
        ],
        color: $9383af9c509aa5cf$var$purple
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta
        ],
        color: $9383af9c509aa5cf$var$yellow
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).comment
        ],
        color: $9383af9c509aa5cf$var$gray,
        fontStyle: 'italic'
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strong,
        fontWeight: 'bold',
        color: $9383af9c509aa5cf$var$orange
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).emphasis,
        fontStyle: 'italic',
        color: $9383af9c509aa5cf$var$green
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strikethrough,
        textDecoration: 'line-through'
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading,
        fontWeight: 'bold',
        color: $9383af9c509aa5cf$var$green
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading1,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading2
        ],
        fontWeight: 'bold',
        color: $9383af9c509aa5cf$var$green
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading3,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading4
        ],
        fontWeight: 'bold',
        color: $9383af9c509aa5cf$var$yellow
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading5,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading6
        ],
        color: $9383af9c509aa5cf$var$yellow
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName)
        ],
        color: $9383af9c509aa5cf$var$purple
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).processingInstruction,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).inserted
        ],
        color: $9383af9c509aa5cf$var$blue
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).contentSeparator
        ],
        color: $9383af9c509aa5cf$var$red
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).invalid,
        color: $9383af9c509aa5cf$var$orange,
        borderBottom: `1px dotted ${$9383af9c509aa5cf$var$invalid}`
    }
]);
/**
Extension to enable the Gruvbox Light theme (both the editor theme and
the highlight style).
*/ const $9383af9c509aa5cf$export$f068983d69663e7f = [
    $9383af9c509aa5cf$export$a612293909849134,
    /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$ec1b956ff3a16361)($9383af9c509aa5cf$export$31e8e92da508ca9a)
];


var $1ab59825f922472c$exports = {};
$1ab59825f922472c$exports = "{let e=window.top;if(e){let n=new Map,l=new Map,t=console.clear,r=console.log,i=console.info,c=console.warn,s=console.error,d=console.debug,w=console.assert,f=console.count,u=console.countReset,a=console.time,g=console.timeLog,m=console.timeEnd,p=console.group,$=console.groupCollapsed,b=console.groupEnd,E=console.table,v=console.dir,x=console.dirxml,h=console.trace,y=console.profile,C=console.profileEnd,L=console.timeStamp;window.console.clear=function(){t(),o(\"clear\")},window.console.log=function(...e){r(...e),o(\"log\",e,\"log\")},window.console.info=function(...e){i(...e),o(\"info\",e,\"info\")},window.console.warn=function(...e){c(...e),o(\"warn\",e,\"warn\")},window.console.error=function(...e){s(...e),o(\"error\",e,\"error\")},window.console.debug=function(...e){d(...e),o(\"debug\",e,\"debug\")},window.console.assert=function(e,...n){w(e,...n),e||o(\"log\",[`Assertion failed: ${n.join(\" \")}`],\"error\")},window.console.count=function(e=\"default\"){f(e),n.set(e,(n.get(e)||0)+1),o(\"log\",[`${e}: ${n.get(e)}`],\"log\")},window.console.countReset=function(e=\"default\"){u(e),n.get(e)?(n.set(e,0),o(\"log\",[`${e}: ${n.get(e)}`],\"log\")):o(\"warn\",`Count for '${e}' does not exist`,\"warn\")},window.console.time=function(o=\"default\"){a(o),l.set(o,performance.now())},window.console.timeLog=function(e=\"default\",...n){g(e);let t=l.get(e);if(t){let l=performance.now()-t.toFixed(3);o(\"log\",`${e}: ${l}ms`,...n)}},window.console.timeEnd=function(e=\"default\"){m(e);let n=l.get(e);if(n){let t=(performance.now()-n).toFixed(3);o(\"log\",[`${e}: ${t}ms`],\"log\"),l.delete(e)}else o(\"warn\",`Timer '${e}' does not exist`,\"warn\")},window.console.group=function(e){p(e),o(\"group\",[e])},window.console.groupCollapsed=function(e){$(e),o(\"groupCollapsed\",[e])},window.console.groupEnd=function(){b(),o(\"groupEnd\")},window.console.table=function(e,n){E(e,n),Array.isArray(e)&&o(\"--- Table View ---\",\"info\"),o(\"log\",e,\"log\")},window.console.dir=function(e,n){v(e,n),o(\"log\",[\"[Object Directory]:\",e],\"log\")},window.console.dirxml=function(...e){x(...e),o(\"log\",e,\"log\")},window.console.trace=function(...e){h(...e);let n=Error();n.name=\"Trace\",o(\"log\",[...e,n.stack],\"log\")},window.console.profile=function(e){y(e),o(\"info\",`Profile '${e}' started (Check browser devtools)`,\"info\")},window.console.profileEnd=function(e){C(e),o(\"info\",`Profile '${e}' finished`,\"info\")},window.console.timeStamp=function(e){L(e),o(\"info\",`Timestamp: ${e}`,\"info\")};let M=document.querySelector(\"title\");function o(n,l,t=\"log\"){e&&e.postMessage({source:\"v-console-msg\",method:n,args:l,type:t},\"*\")}M&&(o(\"title\",[document.title],\"\"),new MutationObserver(()=>o(\"title\",[document.title],\"\")).observe(M,{childList:!0})),window.onerror=(e,n,l,t,r)=>(s(r),o(\"error\",[e],\"error\"),!0),window.addEventListener(\"unhandledrejection\",e=>{let n=e.reason;n?(s(n),n.message?o(\"error\",[n.message],\"error\"):o(\"error\",[n],\"error\")):(s(e),o(\"error\",[e],\"error\")),e.preventDefault()})}}";


function $61f6272e57fff786$export$f1a76e4a6085c675() {
    return "Error";
}


/**
 * @type {import("./ErrorProcessorFunction.js").ErrorProcessorFunction}
 */ let $7bb78ffd14ca2050$var$_errorProcessor = $7bb78ffd14ca2050$export$1d4ffcbcad9ae209;
function $7bb78ffd14ca2050$export$8ee69c7d6d2e321c(errorProcessorFunction) {
    $7bb78ffd14ca2050$var$_errorProcessor = errorProcessorFunction;
}
function $7bb78ffd14ca2050$export$f6eaab8b15dfca2c(error) {
    return $7bb78ffd14ca2050$var$_errorProcessor(error);
}
function $7bb78ffd14ca2050$export$1d4ffcbcad9ae209(error) {
    if (error === null) console.error((0, $61f6272e57fff786$export$f1a76e4a6085c675)());
    else console.error(error);
}


/**
 * @type {import("./AsyncErrorProcessorFunction.js")
 *                                                .AsyncErrorProcessorFunction}
 */ let $e5d55a266c49f4e8$var$_asyncErrorProcessor = $e5d55a266c49f4e8$export$9ed822df79c6c7e9;
function $e5d55a266c49f4e8$export$db084ab3f554bf3a(asyncErrorProcessorFunction) {
    $e5d55a266c49f4e8$var$_asyncErrorProcessor = asyncErrorProcessorFunction;
}
async function $e5d55a266c49f4e8$export$75fc0628f0a56eec(error) {
    return $e5d55a266c49f4e8$var$_asyncErrorProcessor(error);
}
async function $e5d55a266c49f4e8$export$9ed822df79c6c7e9(error) {
    (0, $7bb78ffd14ca2050$export$1d4ffcbcad9ae209)(error);
}



async function $c29c91925b067813$export$f37f21d82e56bbd5(callbackOrPromise, errorValue) {
    try {
        if (typeof callbackOrPromise === "function") return await callbackOrPromise();
        else return await callbackOrPromise;
    } catch (error) {
        await (0, $e5d55a266c49f4e8$export$75fc0628f0a56eec)(error);
        return errorValue;
    }
}


/**
 * @type {import("./MessageDisplayFunction.js").MessageDisplayFunction}
 */ let $f14fda0cfe4dac4e$var$_errorDisplay = $f14fda0cfe4dac4e$export$475e96c69015c30b;
function $f14fda0cfe4dac4e$export$3a0f0e9af695b29d(errorDisplayFunction) {
    $f14fda0cfe4dac4e$var$_errorDisplay = errorDisplayFunction;
}
function $f14fda0cfe4dac4e$export$e0ab1b53c704b99(message) {
    $f14fda0cfe4dac4e$var$_errorDisplay(message);
}
function $f14fda0cfe4dac4e$export$475e96c69015c30b(message) {
    console.error(message);
}




function $577d4b7f70bd60d4$export$d234c058d1d4e435(callback, errorValue) {
    try {
        return callback();
    } catch (error) {
        (0, $7bb78ffd14ca2050$export$f6eaab8b15dfca2c)(error);
        return errorValue;
    }
}



/**
 * @type {import("./AsyncMessageDisplayFunction.js").
 *                                                 AsyncMessageDisplayFunction}
 */ let $59db19bfce0015f0$var$_asyncErrorDisplay = $59db19bfce0015f0$export$bc39acb236d75712;
function $59db19bfce0015f0$export$8e12deac7b1a6138(asyncErrorDisplayFunction) {
    $59db19bfce0015f0$var$_asyncErrorDisplay = asyncErrorDisplayFunction;
}
async function $59db19bfce0015f0$export$724720d9c2149522(message) {
    return $59db19bfce0015f0$var$_asyncErrorDisplay(message);
}
async function $59db19bfce0015f0$export$bc39acb236d75712(message) {
    (0, $f14fda0cfe4dac4e$export$475e96c69015c30b)(message);
}



async function $9569083d8800e90e$export$76dc3bddaf4950be(error) {
    if (error === null) {
        const errorMessage = (0, $61f6272e57fff786$export$f1a76e4a6085c675)();
        console.error(errorMessage);
        await (0, $59db19bfce0015f0$export$724720d9c2149522)(errorMessage);
    } else {
        console.error(error);
        if (Object.getOwnPropertyNames(error).includes("message")) await (0, $59db19bfce0015f0$export$724720d9c2149522)(error.message);
    }
}




function $3d55f8e7bfdf81d3$export$cfe80289ecc3ced2(error) {
    if (error === null) {
        const errorMessage = (0, $61f6272e57fff786$export$f1a76e4a6085c675)();
        console.error(errorMessage);
        (0, $f14fda0cfe4dac4e$export$e0ab1b53c704b99)(errorMessage);
    } else {
        console.error(error);
        if (Object.getOwnPropertyNames(error).includes("message")) (0, $f14fda0cfe4dac4e$export$e0ab1b53c704b99)(error.message);
    }
}


/**
 * @param {string} selector
 */ function $6752761a74d96c53$export$6f525e6e037c81b3(selector) {
    return `Selector ${selector} no encontrado.`;
}


function $a01ce2be121a58f9$export$78fb49a702cc1f2(parent, selector) {
    /**
  * @type {T | null}
  */ const element = parent.querySelector(selector);
    if (element === null) throw new Error((0, $6752761a74d96c53$export$6f525e6e037c81b3)(selector));
    return element;
}


let $5e17f8394fdeb93e$var$_promiseNewFunction = $5e17f8394fdeb93e$export$3fdac89a98cadfa1;
function $5e17f8394fdeb93e$export$873de1c7d75cac89(promiseNewFunction) {
    $5e17f8394fdeb93e$var$_promiseNewFunction = promiseNewFunction;
}
function $5e17f8394fdeb93e$export$4d4a522f2506fc24(executor) {
    return $5e17f8394fdeb93e$var$_promiseNewFunction(executor);
}
function $5e17f8394fdeb93e$export$3fdac89a98cadfa1(executor) {
    return new Promise(executor);
}


/**
 * @param {File} file
 */ function $596ef8ea5ccee719$export$fc5e2568348ccf7a(file) {
    return `No se recuper\xf3 texto al leer el archivo ${file.name}.`;
}


function $8f1ec47bd999c277$export$7dc2912951b09f(file) {
    return (0, $5e17f8394fdeb93e$export$4d4a522f2506fc24)((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            if (typeof reader.result === "string") resolve(reader.result);
            else reject((0, $596ef8ea5ccee719$export$fc5e2568348ccf7a)(file));
        };
        reader.onerror = ()=>reject(reader.error);
        reader.readAsText(file);
    });
}


function $e95c91700c771383$export$9bfd58cf57635a1() {
    return "Obtener archivos seleccionados de un input con type distinto de file.";
}


function $e34f5e3266e8ca53$export$c7569ebd33acdbfd(input) {
    if (input.type !== "file") throw new Error((0, $e95c91700c771383$export$9bfd58cf57635a1)());
    const files = input.files;
    if (files === null) throw new Error((0, $e95c91700c771383$export$9bfd58cf57635a1)());
    return files;
}


function $f92ff3834d047fff$export$a9d57d1c3a801ea0() {
    return "Service worker registrado..";
}


function $a267a1e0dcc82fcd$export$b69665eaa91f816c(registrationPromise) {
    registrationPromise.then((registration)=>{
        console.log((0, $f92ff3834d047fff$export$a9d57d1c3a801ea0)(), registration);
    }).catch((error)=>console.error(error));
}


var $c7daaa09e59138b8$exports = {};
$c7daaa09e59138b8$exports = import.meta.resolve("5VnLw");


(0, $577d4b7f70bd60d4$export$d234c058d1d4e435)(()=>{
    (0, $f14fda0cfe4dac4e$export$3a0f0e9af695b29d)(alert);
    (0, $7bb78ffd14ca2050$export$8ee69c7d6d2e321c)((0, $3d55f8e7bfdf81d3$export$cfe80289ecc3ced2));
    (0, $e5d55a266c49f4e8$export$db084ab3f554bf3a)((0, $9569083d8800e90e$export$76dc3bddaf4950be));
    (0, $a267a1e0dcc82fcd$export$b69665eaa91f816c)(navigator.serviceWorker.register($c7daaa09e59138b8$exports, {
        scope: '/'
    }));
    /**
   * @type {HTMLInputElement}
   */ const openElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#abrir");
    /**
   * @type {HTMLAnchorElement}
   */ const saveElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#guardar");
    const executeElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#ejecutar");
    const codeElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#code");
    /**
   * @type {HTMLInputElement}
   */ const codeShowElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#codeShow");
    /**
   * @type {HTMLIFrameElement}
   */ const iframeElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "iframe");
    /**
   * @type {HTMLOutputElement}
   */ const windowTitleElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#windowTitle");
    /**
   * @type {HTMLInputElement}
   */ const windowShowElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#windowShow");
    /** @type {HTMLInputElement} */ const consoleShowElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#consoleShow");
    const consoleSecElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#consoleSec");
    const consoleDivElement = (0, $a01ce2be121a58f9$export$78fb49a702cc1f2)(document, "#consoleDiv");
    const darkModePreference = matchMedia('(prefers-color-scheme: dark)');
    darkModePreference.addEventListener("change", ()=>location.reload());
    let text = decodeURIComponent(location.hash.replace(/^\#/, ""));
    if (text.includes("&")) {
        const parts = text.split("&");
        codeShowElement.checked = parts[0] === "1";
        windowShowElement.checked = parts[1] === "1";
        consoleShowElement.checked = parts[2] === "1";
        text = parts[3] || "";
    }
    var editor = new (0, $7beee9608540d2c3$export$eece2fccabbb77c5)({
        doc: text,
        parent: codeElement,
        extensions: [
            darkModePreference.matches ? (0, $b936e6b9e1d87287$export$528b3505117fc12e) : (0, $9383af9c509aa5cf$export$f068983d69663e7f),
            // A line number gutter
            (0, $7beee9608540d2c3$export$1a8cf111682eaa7d)(),
            // A gutter with code folding markers
            (0, $a97ccac5cf5f4f5d$export$c4dcf64f741b6228)(),
            (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).tabSize.of(1),
            // Sets the string used for indentation to 2 spaces
            (0, $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5).of(" "),
            // Replace non-printable characters with placeholders
            (0, $7beee9608540d2c3$export$76dc0899547f659c)(),
            // The undo history
            (0, $032754016b6293d7$export$55abd4691b317664)(),
            // Show a drop cursor when dragging over the editor
            (0, $7beee9608540d2c3$export$b8e3092a3bfa2062)(),
            // Allow multiple cursors/selections
            (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).allowMultipleSelections.of(true),
            // Re-indent lines when typing specific input
            (0, $a97ccac5cf5f4f5d$export$9bcaf6e2125ee117)(),
            // Highlight syntax with a default style
            (0, $a97ccac5cf5f4f5d$export$ec1b956ff3a16361)((0, $a97ccac5cf5f4f5d$export$bb02a6818dd48320)),
            // Highlight matching brackets near cursor
            (0, $a97ccac5cf5f4f5d$export$cef7edfd214be605)(),
            // Automatically close brackets
            (0, $7570a9a1a9679713$export$69e4e9d3300ff824)(),
            // Load the autocompletion system
            (0, $7570a9a1a9679713$export$f95786d390465556)(),
            // Allow alt-drag to select rectangular regions
            (0, $7beee9608540d2c3$export$dd482925db1aabd3)(),
            // Change the cursor to a crosshair when holding alt
            (0, $7beee9608540d2c3$export$9b6525222ac3b7fb)(),
            // Style the current line specially
            (0, $7beee9608540d2c3$export$1a7e096bee9035c)(),
            // Style the gutter for current line specially
            (0, $7beee9608540d2c3$export$93b52f08bb2c759c)(),
            // Highlight text that matches the selected text
            (0, $976a3faeb93466fd$export$f14efe56171a2e02)(),
            (0, $7beee9608540d2c3$export$5043418e2ef368d5).of([
                (0, $032754016b6293d7$export$893b77570f8af4da),
                // Closed-brackets aware backspace
                ...(0, $7570a9a1a9679713$export$9477e95792b48f4a),
                // A large set of basic bindings
                ...(0, $032754016b6293d7$export$ab2e8d0ac5d2b69e),
                // Search-related keys
                ...(0, $976a3faeb93466fd$export$2dba96787cbe0a4a),
                // Redo/undo keys
                ...(0, $032754016b6293d7$export$ab4a28cb63e8a670),
                // Code folding bindings
                ...(0, $a97ccac5cf5f4f5d$export$39c52376a8936d67),
                // Autocompletion keys
                ...(0, $7570a9a1a9679713$export$2a3d759d156afab4),
                // Keys related to the linter system
                ...(0, $1e126942d86629f6$export$a21d7a0cde3cbb60)
            ]),
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).updateListener.of((update)=>{
                (0, $577d4b7f70bd60d4$export$d234c058d1d4e435)(()=>{
                    if (update.docChanged) stateChanges();
                }, undefined);
            }),
            (0, $b89c3ee08b45bae9$export$c0bb0b647f701bb5)()
        ]
    });
    openElement.addEventListener("change", fileOpen);
    executeElement.addEventListener("click", ejecute);
    codeShowUpdate();
    codeShowElement.addEventListener("click", codeShowUpdate);
    windowShowUpdate();
    windowShowElement.addEventListener("click", windowShowUpdate);
    consoleShowUpdate();
    consoleShowElement.addEventListener("click", consoleShowUpdate);
    codeDisplay();
    windowDisplay();
    consoleDisplay();
    stateChanges();
    if (!codeShowElement.checked && windowShowElement.checked && !consoleShowElement.checked) ejecute();
    function fileOpen() {
        (0, $c29c91925b067813$export$f37f21d82e56bbd5)(async ()=>{
            const files = (0, $e34f5e3266e8ca53$export$c7569ebd33acdbfd)(openElement);
            if (files.length > 0) {
                const file = files[0];
                const text = await (0, $8f1ec47bd999c277$export$7dc2912951b09f)(file);
                saveElement.download = file.name;
                setEditorContent(text);
                saveHrefUpdate(text);
            }
        }, undefined);
    }
    function ejecute() {
        (0, $577d4b7f70bd60d4$export$d234c058d1d4e435)(()=>{
            const src = editor.state.doc.toString().replace(/* html */ `</title>`, /* html */ `</title><script>${(0, (/*@__PURE__*/$parcel$interopDefault($1ab59825f922472c$exports)))}</script>`);
            iframeElement.srcdoc = src;
        }, undefined);
    }
    function codeShowUpdate() {
        (0, $577d4b7f70bd60d4$export$d234c058d1d4e435)(()=>{
            codeDisplay();
            stateChanges();
        }, undefined);
    }
    function codeDisplay() {
        codeElement.hidden = !codeShowElement.checked;
    }
    function windowShowUpdate() {
        (0, $577d4b7f70bd60d4$export$d234c058d1d4e435)(()=>{
            windowDisplay();
            stateChanges();
        }, undefined);
    }
    function windowDisplay() {
        iframeElement.hidden = !windowShowElement.checked;
    }
    function consoleShowUpdate() {
        (0, $577d4b7f70bd60d4$export$d234c058d1d4e435)(()=>{
            consoleDisplay();
            stateChanges();
        }, undefined);
    }
    function consoleDisplay() {
        consoleSecElement.hidden = !consoleShowElement.checked;
    }
    /**
   * @param {string} newContent
   */ function setEditorContent(newContent) {
        editor.dispatch({
            changes: {
                from: 0,
                to: editor.state.doc.length,
                insert: newContent // Inserta el nuevo contenido
            }
        });
    }
    function stateChanges() {
        const text = encodeURIComponent(editor.state.doc.toString());
        const s = codeShowElement.checked ? "1" : "0";
        const w = windowShowElement.checked ? "1" : "0";
        const c = consoleShowElement.checked ? "1" : "0";
        location.hash = `${s}&${w}&${c}&${text}`;
        saveHrefUpdate(text);
    }
    /**
   * @param {string} text
   */ function saveHrefUpdate(text) {
        saveElement.href = URL.createObjectURL(new Blob([
            text
        ], {
            type: "text/html"
        }));
    }
    const SOURCE_ID = 'v-console-msg';
    let groupLevel = 0;
    window.onmessage = (/** @type {MessageEvent<{
     source: string,
     method:string,
     args: any[],
     type:string,
    }>} */ event)=>{
        if (event.data?.source === SOURCE_ID) {
            const { method: method, args: args, type: type } = event.data;
            processMessage(method, args, type);
        }
    };
    /**
   * @param {string} method
   * @param {any[]} args
   * @param {string} type
   */ function processMessage(method, args, type) {
        switch(method){
            case 'clear':
                consoleDivElement.textContent = '';
                groupLevel = 0;
                break;
            case 'group':
                render(`\u{25BC} ${args[0] || 'Grupo'}`, 'log');
                groupLevel++;
                break;
            case 'groupEnd':
                if (groupLevel > 0) groupLevel--;
                break;
            case "title":
                {
                    const title = (args || [])[0];
                    document.title = title + " | GilPG Edit";
                    windowTitleElement.value = title;
                }
                break;
            default:
                args.forEach((arg)=>render(arg, type || 'log'));
        }
    }
    function render(message, type) {
        const lineContainer = document.createElement('div');
        lineContainer.className = "log-line type-" + type;
        // const time = new Date().toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })
        // const indent = "  ".repeat(groupLevel)
        let content = message instanceof Error ? `${message.stack}` : typeof message === 'object' ? JSON.stringify(message, null, 2) : message;
        // lineContainer.innerHTML = `<span class="timestamp">${time}</span>${indent}${content}`
        lineContainer.textContent = content;
        consoleDivElement.appendChild(lineContainer);
        consoleDivElement.scrollTop = consoleDivElement.scrollHeight;
    }
    window.onerror = function(/** @type {string} */ message, /** @type {string} */ _url, /** @type {number} */ _line, /** @type {number} */ _column, /** @type {Error} */ errorObject) {
        console.error(errorObject);
        alert(message);
        return true;
    };
    window.addEventListener('unhandledrejection', (event)=>{
        const reason = event.reason;
        if (reason) {
            console.error(reason);
            if (reason.message) alert(reason.message);
            else alert(reason);
        } else {
            console.error(event);
            alert(event);
        }
        event.preventDefault();
    });
}, undefined);


//# sourceMappingURL=gilpgedit.github.io.9e4b0517.js.map
